webpackJsonp([1],{

/***/ "+3lO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("abPz");
var global = __webpack_require__("YjQv");
var hide = __webpack_require__("aLzV");
var Iterators = __webpack_require__("yYxz");
var TO_STRING_TAG = __webpack_require__("hgbu")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+66z":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "+MZ2":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "+Oa1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+SdG":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("a/OS")('keys');
var uid = __webpack_require__("GmwO");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "+TD/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.writePreviewsCache = exports.readPreviewsCache = exports.defaultVariables = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactApollo = __webpack_require__("3zLD");

var _graphql = __webpack_require__("qm98");

var defaultVariables = exports.defaultVariables = {
    pageSize: 200,
    listingPageSize: 4
};

var readPreviewsCache = exports.readPreviewsCache = function readPreviewsCache(proxy, hav, pageSize, listingPageSize) {
    return proxy.readQuery({ query: _graphql.fetchPreviewsQuery, variables: { hav: hav, pageSize: pageSize, listingPageSize: listingPageSize } });
};

var writePreviewsCache = exports.writePreviewsCache = function writePreviewsCache(proxy, hav, pageSize, listingPageSize, cache) {
    return proxy.writeQuery({ query: _graphql.fetchPreviewsQuery, variables: { hav: hav, pageSize: pageSize, listingPageSize: listingPageSize }, data: cache });
};

var withFetchPreviewsQuery = (0, _reactApollo.graphql)(_graphql.fetchPreviewsQuery, {
    options: function options(_ref) {
        var hav = _ref.hav,
            _ref$pageSize = _ref.pageSize,
            pageSize = _ref$pageSize === undefined ? defaultVariables.pageSize : _ref$pageSize,
            _ref$listingPageSize = _ref.listingPageSize,
            listingPageSize = _ref$listingPageSize === undefined ? defaultVariables.listingPageSize : _ref$listingPageSize,
            fetchTripboardsQueryConfig = _ref.fetchTripboardsQueryConfig;
        return _extends({}, fetchTripboardsQueryConfig, {
            variables: { hav: hav, pageSize: pageSize, listingPageSize: listingPageSize }
        });
    },
    name: 'tripboardData',
    alias: 'withFetchPreviewsQuery',
    skip: function skip(_ref2) {
        var hav = _ref2.hav;
        return !hav;
    }
});

exports.default = withFetchPreviewsQuery;
//# sourceMappingURL=with-fetch-previews.js.map

/***/ }),

/***/ "+VX5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "+gg+":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "+iDZ":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("YjQv").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "+oMz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeToastById = exports.createToast = undefined;

var _constants = __webpack_require__("cHop");

var createToast = exports.createToast = function createToast() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        type: _constants.CREATE_TOAST,
        props: props
    };
};

var removeToastById = exports.removeToastById = function removeToastById(id) {
    return {
        type: _constants.REMOVE_TOAST_BY_ID,
        payload: { id: id }
    };
};

exports.default = {
    createToast: createToast, removeToastById: removeToastById
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "+urU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TooltipPositioner = function () {
    function TooltipPositioner(props, container, tooltip) {
        _classCallCheck(this, TooltipPositioner);

        this.VISUAL_OFFSET = 28;
        this.VISUAL_OFFSET_MIN = 8;
        this.ARROW_WIDTH = 16;
        this.BODY_MARGIN = 16; // @spacing-2x

        this.props = props;
        this.containerBounds = container.getBoundingClientRect();
        this.tooltipBounds = this._getCorrectTooltipBounds(tooltip);

        var safePlacement = this.getSafePlacement();

        this.tooltipPosition = this._getTooltipPosition(safePlacement);
        this.arrowPosition = this._getTooltipArrowPosition(safePlacement);
    }

    /**
     * Get the adjusted positions for the arrow and the tooltip
     * @return {object} { tooltipPosition, arrowPosition }
     */


    _createClass(TooltipPositioner, [{
        key: 'getPositions',
        value: function getPositions() {
            return {
                tooltipPosition: this.tooltipPosition,
                arrowPosition: this.arrowPosition
            };
        }

        /**
         * Find out if the tooltip would overflow in the passed placement property.
         * It would find the best placement for the tooltip.
         * @return {string} Safe placement
         */

    }, {
        key: 'getSafePlacement',
        value: function getSafePlacement() {
            var containerBounds = this.containerBounds,
                tooltipBounds = this.tooltipBounds;
            var _props = this.props,
                tooltipType = _props.tooltipType,
                placement = _props.placement;

            var bodyBounds = document.body.getBoundingClientRect();

            // Using window.innerHeight instead of clientHeight would introduce a bug
            // because if the tooltip overflows, it changes window.innerHeight and we
            // are therefore not able to calculate the overflow.
            // https://github.homeawaycorp.com/ui-toolkit/react-tooltip/pull/47#discussion_r239171
            var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var windowHeight = tooltipType === 'tooltip' || tooltipType === 'tooltip--lg' ? clientHeight : bodyBounds.height;

            if (placement === 'bottom' && containerBounds.bottom + tooltipBounds.height > windowHeight) {
                return 'top';
            } else if (placement === 'top' && containerBounds.top - tooltipBounds.height < bodyBounds.top + window.pageYOffset) {
                return 'bottom';
            } else if (placement === 'right' && containerBounds.right + tooltipBounds.width > bodyBounds.width) {
                return 'left';
            } else if (placement === 'left' && containerBounds.left - tooltipBounds.width < bodyBounds.left) {
                return 'right';
            }

            return placement;
        }

        /**
         * Temporarily add fixed positioning to the tooltip to get correct bounds
         * (Absolute positioning affect the width and height of tooltip if triggering element is small)
         * @return {object} { left, top, right, bottom, x, y, width, height }
         */

    }, {
        key: '_getCorrectTooltipBounds',
        value: function _getCorrectTooltipBounds(tooltip) {
            tooltip.style.position = 'fixed';

            var relativeBounds = tooltip.getBoundingClientRect();

            tooltip.style.position = '';

            return relativeBounds;
        }

        /**
         * Calculate the position of the tooltip, taking into account the potential
         * overflows to the right and left. This will ensure that the tooltip is
         * always visible
         * @return {object} Styles for the tooltip ({left, top, width})
         */

    }, {
        key: '_getTooltipPosition',
        value: function _getTooltipPosition(placement) {
            var containerBounds = this.containerBounds,
                tooltipBounds = this.tooltipBounds;

            var leftOffset = this.props.parentNode ? containerBounds.left + window.pageXOffset : 0;
            var topOffset = this.props.parentNode ? containerBounds.top + window.pageYOffset : 0;
            var buttonHeightOffset = tooltipBounds.height < containerBounds.height ? tooltipBounds.height / 4 : 0;
            var centeredHeightOffset = this.props.centered ? -(tooltipBounds.height / 4 - 12) : 0;
            var position = {
                left: '',
                top: '',
                width: this.tooltipBounds.width
            };
            if (placement === 'left') {
                position.left = leftOffset - this.tooltipBounds.width;
                position.top = topOffset - tooltipBounds.height / 4 + centeredHeightOffset + buttonHeightOffset;
            } else if (placement === 'top') {
                var tooltipLeft = this._getHorizontalTooltipLeft();
                position.left = leftOffset + tooltipLeft;
                position.top = topOffset - tooltipBounds.height;
                position.arrowLeft = this._getHorizontalTooltipArrowLeft(-tooltipLeft);
            } else if (placement === 'bottom') {
                var _tooltipLeft = this._getHorizontalTooltipLeft();
                position.left = leftOffset + _tooltipLeft;
                position.top = topOffset + containerBounds.height;
                position.arrowLeft = this._getHorizontalTooltipArrowLeft(-_tooltipLeft);
            } else {
                // safePlacement === Right
                position.left = leftOffset + containerBounds.width;
                position.top = topOffset - tooltipBounds.height / 4 + centeredHeightOffset + buttonHeightOffset;
            }

            return position;
        }

        /**
         * Calculate the styles for the arrow, so it would always look visually nice.
         * @return {object} Arrow styles ({left, top})
         */

    }, {
        key: '_getTooltipArrowPosition',
        value: function _getTooltipArrowPosition(safePlacement) {
            var tooltipType = this.props.tooltipType;

            var position = {};

            var isLargeTooltip = tooltipType === 'tooltip--lg' || tooltipType === 'popover';
            var isHorizontalTooltip = /left|right/.test(safePlacement);

            if (isHorizontalTooltip && isLargeTooltip) {
                var arrowTopOffset = this.tooltipBounds.height / 4 + this.containerBounds.height / 2;
                position.top = arrowTopOffset + 'px';
            }

            if (!isHorizontalTooltip) {
                position.left = this.tooltipPosition.arrowLeft;
            }

            if (this.props.centered && isHorizontalTooltip) {
                position.top = '50%';
            }

            return position;
        }

        /**
         * Calculates the tooltip left style, taking into account that if it
         * would overflow on the left or right
         * @return {number} Left position of the horizontal tooltip
         */

    }, {
        key: '_getHorizontalTooltipLeft',
        value: function _getHorizontalTooltipLeft() {
            var containerBounds = this.containerBounds,
                tooltipBounds = this.tooltipBounds;


            if (this.props.centered && !this._willCenteredTooltipOverflow()) {
                return containerBounds.width / 2 - tooltipBounds.width / 2;
            }

            var initialLeftPosition = containerBounds.width / 2 - this.ARROW_WIDTH / 2 - this.VISUAL_OFFSET;

            var left = containerBounds.left + initialLeftPosition;
            var overflowLeft = this.BODY_MARGIN - left;

            var right = left + tooltipBounds.width;
            // Using window.innerWidth instead of clientWidth would introduce a bug
            // because if the tooltip overflows, it changes window.innerWidth and we
            // are therefore not able to calculate the overflow.
            // https://github.homeawaycorp.com/ui-toolkit/react-tooltip/pull/47#discussion_r239171
            var clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
            var overflowRight = right - (clientWidth - this.BODY_MARGIN);

            if (overflowRight < 0 && overflowLeft < 0) {
                return initialLeftPosition;
            } else if (overflowRight > 0) {
                return initialLeftPosition - overflowRight;
            }
            return initialLeftPosition + overflowLeft;
        }

        /**
         * Calculate left style for the arrow, if the tooltip is horizontal.
         * @param  {number} offset pixels to offset the arrow
         * @return {string} left style string. Ex: "20px"
         */

    }, {
        key: '_getHorizontalTooltipArrowLeft',
        value: function _getHorizontalTooltipArrowLeft(offset) {
            var containerBounds = this.containerBounds,
                tooltipBounds = this.tooltipBounds;

            if (this.props.centered && !this._willCenteredTooltipOverflow()) {
                return '50%';
            }

            var arrowLeftContainerCenter = offset + containerBounds.width / 2;

            // Set lower and upper limit for the arrow position not to
            // overflow the tooltip width
            var pixels = Math.min(tooltipBounds.width - this.ARROW_WIDTH / 2 - this.VISUAL_OFFSET_MIN, Math.max(this.ARROW_WIDTH / 2 + this.VISUAL_OFFSET_MIN, arrowLeftContainerCenter));
            return pixels + 'px';
        }

        /**
         * Helper function that will check if the "centered" tooltip would overflow
         * on the right and left
         * @return {boolean} Would centered tooltip overflow?
         */

    }, {
        key: '_willCenteredTooltipOverflow',
        value: function _willCenteredTooltipOverflow() {
            var containerBounds = this.containerBounds,
                tooltipBounds = this.tooltipBounds;

            var centeredTooltipRight = containerBounds.left + containerBounds.width / 2 + tooltipBounds.width / 2;

            // Using window.innerWidth instead of clientWidth would introduce a bug
            // because if the tooltip overflows, it changes window.innerWidth and we
            // are therefore not able to calculate the overflow.
            // https://github.homeawaycorp.com/ui-toolkit/react-tooltip/pull/47#discussion_r239171
            var clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
            var overflowsRight = clientWidth - this.BODY_MARGIN - centeredTooltipRight < 0;

            var centeredTooltipLeft = containerBounds.left + containerBounds.width / 2 - tooltipBounds.width / 2;
            var overflowsLeft = centeredTooltipLeft - (0 + this.BODY_MARGIN) < 0;

            return overflowsRight || overflowsLeft;
        }
    }]);

    return TooltipPositioner;
}();

exports.default = TooltipPositioner;
//# sourceMappingURL=TooltipPositioner.js.map

/***/ }),

/***/ "+zJ9":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("GmwO")('meta');
var isObject = __webpack_require__("8ANE");
var has = __webpack_require__("x//u");
var setDesc = __webpack_require__("GCs6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("zyKz")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "+zi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/storeUtils.js
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.");
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = JSON.stringify(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject && idObject.type === 'id';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return __assign({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw new Error("Variable nodes are not supported by valueFromNode");
}
/**
 * Evaluate a ValueNode and yield its value in its natural JS form.
 */
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}
//# sourceMappingURL=storeUtils.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/directives.js

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        // TODO should move this validation to GraphQL validation once that's implemented.
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            // Just don't worry about directives we don't understand
            return;
        }
        //evaluate the "if" argument and skip (i.e. return undefined) if it evaluates to true.
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
        if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
        }
        var ifArgument = directiveArguments[0];
        if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
        }
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
            // means it has to be a variable value if this is a valid @skip or @include directive
            if (ifValue.kind !== 'Variable') {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            }
            else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === undefined) {
                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
            }
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function flattenSelections(selection) {
    if (!selection.selectionSet ||
        !(selection.selectionSet.selections.length > 0))
        return [selection];
    return [selection].concat(selection.selectionSet.selections
        .map(function (selectionNode) {
        return [selectionNode].concat(flattenSelections(selectionNode));
    })
        .reduce(function (selections, selected) { return selections.concat(selected); }, []));
}
var added = new Map();
function getDirectiveNames(doc) {
    var cached = added.get(doc);
    if (cached)
        return cached;
    // operation => [names of directives];
    var directives = doc.definitions
        .filter(function (definition) {
        return definition.selectionSet && definition.selectionSet.selections;
    })
        .map(function (x) { return flattenSelections(x); })
        .reduce(function (selections, selected) { return selections.concat(selected); }, [])
        .filter(function (selection) {
        return selection.directives && selection.directives.length > 0;
    })
        .map(function (selection) { return selection.directives; })
        .reduce(function (directives, directive) { return directives.concat(directive); }, [])
        .map(function (directive) { return directive.name.value; });
    added.set(doc, directives);
    return directives;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
//# sourceMappingURL=directives.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/fragments.js
var fragments___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/**
 * Returns a query document which adds a single query operation that only
 * spreads the target fragment inside of it.
 *
 * So for example a document of:
 *
 * ```graphql
 * fragment foo on Foo { a b c }
 * ```
 *
 * Turns into:
 *
 * ```graphql
 * { ...foo }
 *
 * fragment foo on Foo { a b c }
 * ```
 *
 * The target fragment will either be the only fragment in the document, or a
 * fragment specified by the provided `fragmentName`. If there is more then one
 * fragment, but a `fragmentName` was not defined then an error will be thrown.
 */
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function (definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === 'undefined') {
        if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        }
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = fragments___assign({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}
//# sourceMappingURL=fragments.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/util/assign.js
function assign_assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
//# sourceMappingURL=assign.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/getFromAST.js


function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
    if (!mutationDef) {
        throw new Error('Must contain a mutation definition.');
    }
    return mutationDef;
}
// Checks the document for errors and throws an exception if there is an error.
function checkDocument(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    if (operations.length > 1) {
        throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    if (!def) {
        throw new Error("GraphQL document is missing an operation");
    }
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
// Returns the FragmentDefinitions from a particular document as an array
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== 'query') {
        throw new Error('Must contain a query definition.');
    }
    return queryDef;
}
function getFragmentDefinition(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    if (doc.definitions.length > 1) {
        throw new Error('Fragment must have exactly one definition.');
    }
    var fragmentDef = doc.definitions[0];
    if (fragmentDef.kind !== 'FragmentDefinition') {
        throw new Error('Must be a fragment definition.');
    }
    return fragmentDef;
}
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            // we do this because we want to allow multiple fragment definitions
            // to precede an operation definition.
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
// Utility function that takes a list of fragment definitions and makes a hash out of them
// that maps the name of the fragment to the fragment definition.
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign_assign.apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
/**
 * Returns the names of all variables declared by the operation.
 */
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}
//# sourceMappingURL=getFromAST.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/util/cloneDeep.js
/**
 * Deeply clones a value to create a new instance.
 */
function cloneDeep(value) {
    // If the value is an array, create a new array where every item has been cloned.
    if (Array.isArray(value)) {
        return value.map(function (item) { return cloneDeep(item); });
    }
    // If the value is an object, go through all of the object’s properties and add them to a new
    // object.
    if (value !== null && typeof value === 'object') {
        var nextValue = {};
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                nextValue[key] = cloneDeep(value[key]);
            }
        }
        return nextValue;
    }
    // Otherwise this is some primitive value and it is therefore immutable so we can just return it
    // directly.
    return value;
}
//# sourceMappingURL=cloneDeep.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/transform.js


var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isNotEmpty(op, fragments) {
    // keep selections that are still valid
    return (op.selectionSet.selections.filter(function (selectionSet) {
        // anything that doesn't match the compound filter is okay
        return !(selectionSet &&
            // look into fragments to verify they should stay
            selectionSet.kind === 'FragmentSpread' &&
            // see if the fragment in the map is valid (recursively)
            !isNotEmpty(fragments[selectionSet.name.value], fragments));
    }).length > 0);
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            if (dir.name && dir.name === directive.name.value)
                return true;
            if (dir.test && dir.test(directive))
                return true;
            return false;
        });
    };
}
function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    if (selectionSet.selections) {
        if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
                return (selection.kind === 'Field' &&
                    selection.name.value === '__typename');
            });
            if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD);
            }
        }
        selectionSet.selections.forEach(function (selection) {
            // Must not add __typename if we're inside an introspection query
            if (selection.kind === 'Field') {
                if (selection.name.value.lastIndexOf('__', 0) !== 0 &&
                    selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
            else if (selection.kind === 'InlineFragment') {
                if (selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
        });
    }
}
function removeDirectivesFromSelectionSet(directives, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    // if any of the directives are set to remove this selectionSet, remove it
    var agressiveRemove = directives.some(function (dir) { return dir.remove; });
    selectionSet.selections = selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.directives)
            return selection;
        var directiveMatcher = getDirectiveMatcher(directives);
        var remove;
        selection.directives = selection.directives.filter(function (directive) {
            var shouldKeep = !directiveMatcher(directive);
            if (!remove && !shouldKeep && agressiveRemove)
                remove = true;
            return shouldKeep;
        });
        return remove ? null : selection;
    })
        .filter(function (x) { return !!x; });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
    });
    return selectionSet;
}
function removeDirectivesFromDocument(directives, doc) {
    var docClone = cloneDeep(doc);
    docClone.definitions.forEach(function (definition) {
        removeDirectivesFromSelectionSet(directives, definition.selectionSet);
    });
    var operation = getOperationDefinitionOrDie(docClone);
    var fragments = createFragmentMap(getFragmentDefinitions(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
var transform_added = new Map();
function addTypenameToDocument(doc) {
    checkDocument(doc);
    var cached = transform_added.get(doc);
    if (cached)
        return cached;
    var docClone = cloneDeep(doc);
    docClone.definitions.forEach(function (definition) {
        var isRoot = definition.kind === 'OperationDefinition';
        addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    transform_added.set(doc, docClone);
    return docClone;
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
var removed = new Map();
function removeConnectionDirectiveFromDocument(doc) {
    checkDocument(doc);
    var cached = removed.get(doc);
    if (cached)
        return cached;
    var docClone = removeDirectivesFromDocument([connectionRemoveConfig], doc);
    removed.set(doc, docClone);
    return docClone;
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!(selectionSet && selectionSet.selections)) {
        return false;
    }
    var matchedSelections = selectionSet.selections.filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, nestedCheck);
    });
    return matchedSelections.length > 0;
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (selection.kind !== 'Field' || !selection) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var matchedDirectives = selection.directives.filter(directiveMatcher);
    return (matchedDirectives.length > 0 ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromSelectionSet(directives, selectionSet) {
    selectionSet.selections = selectionSet.selections
        .filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, true);
    })
        .map(function (selection) {
        if (hasDirectivesInSelection(directives, selection, false)) {
            return selection;
        }
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            selection.selectionSet = getDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
        return selection;
    });
    return selectionSet;
}
function getDirectivesFromDocument(directives, doc, includeAllFragments) {
    if (includeAllFragments === void 0) { includeAllFragments = false; }
    checkDocument(doc);
    var docClone = cloneDeep(doc);
    docClone.definitions = docClone.definitions.map(function (definition) {
        if ((definition.kind === 'OperationDefinition' ||
            (definition.kind === 'FragmentDefinition' && !includeAllFragments)) &&
            definition.selectionSet) {
            definition.selectionSet = getDirectivesFromSelectionSet(directives, definition.selectionSet);
        }
        return definition;
    });
    var operation = getOperationDefinitionOrDie(docClone);
    var fragments = createFragmentMap(getFragmentDefinitions(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
//# sourceMappingURL=transform.js.map
// EXTERNAL MODULE: ./node_modules/apollo-utilities/lib/util/environment.js
var environment = __webpack_require__("mSTb");

// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/util/errorHandling.js
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/util/isEqual.js
/**
 * Performs a deep equality check on two JavaScript values.
 */
function isEqual(a, b) {
    // If the two values are strictly equal, we are good.
    if (a === b) {
        return true;
    }
    // Dates are equivalent if their time values are equal.
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    // If a and b are both objects, we will compare their properties. This will compare arrays as
    // well.
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        // Compare all of the keys in `a`. If one of the keys has a different value, or that key does
        // not exist in `b` return false immediately.
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        // Look through all the keys in `b`. If `b` has a key that `a` does not, return false.
        for (var key in b) {
            if (!Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        // If we made it this far the objects are equal!
        return true;
    }
    // Otherwise the values are not equal.
    return false;
}
//# sourceMappingURL=isEqual.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/util/maybeDeepFreeze.js

// taken straight from https://github.com/substack/deep-freeze to avoid import hassles with rollup
function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (Object(environment["a" /* isDevelopment */])() || Object(environment["c" /* isTest */])()) {
        // Polyfilled Symbols potentially cause infinite / very deep recursion while deep freezing
        // which is known to crash IE11 (https://github.com/apollographql/apollo-client/issues/3043).
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/util/warnOnce.js

var haveWarned = Object.create({});
/**
 * Print a warning only once in development.
 * In production no warnings are printed.
 * In test all warnings are printed.
 *
 * @param msg The warning message
 * @param type warn or error (will call console.warn or console.error)
 */
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (Object(environment["b" /* isProduction */])()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!Object(environment["c" /* isTest */])()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}
//# sourceMappingURL=warnOnce.js.map
// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getDirectiveInfoFromField; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "A", function() { return shouldInclude; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flattenSelections; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDirectiveNames; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return hasDirectives; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getFragmentQueryDocument; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return getMutationDefinition; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return checkDocument; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getOperationDefinition; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getOperationDefinitionOrDie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getOperationName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return getFragmentDefinitions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return getQueryDefinition; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getFragmentDefinition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return getMainDefinition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return createFragmentMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return getDefaultValues; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return variablesInOperation; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return removeDirectivesFromDocument; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return addTypenameToDocument; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return removeConnectionDirectiveFromDocument; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDirectivesFromDocument; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isScalarValue; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isNumberValue; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return valueToObjectRepresentation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "B", function() { return storeKeyNameFromField; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return getStoreKeyName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return argumentsObjectFromField; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return resultKeyNameFromField; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return isField; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return isInlineFragment; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return isIdValue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "C", function() { return toIdValue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return isJsonValue; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return valueFromNode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return assign_assign; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return cloneDeep; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return environment["b" /* isProduction */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return environment["a" /* isDevelopment */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return environment["c" /* isTest */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "D", function() { return tryFunctionOrLogError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return graphQLResultHasError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return isEqual; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return maybeDeepFreeze; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "E", function() { return warnOnceInDevelopment; });












//# sourceMappingURL=index.js.map

/***/ }),

/***/ "/HXb":
/***/ (function(module, exports) {

module.exports = {"001":1,"AD":1,"AE":6,"AF":6,"AG":0,"AI":1,"AL":1,"AM":1,"AN":1,"AR":0,"AS":0,"AT":1,"AU":1,"AX":1,"AZ":1,"BA":1,"BD":5,"BE":1,"BG":1,"BH":6,"BM":1,"BN":1,"BR":0,"BS":0,"BT":0,"BW":0,"BY":1,"BZ":0,"CA":0,"CH":1,"CL":1,"CM":1,"CN":0,"CO":0,"CR":1,"CY":1,"CZ":1,"DE":1,"DJ":6,"DK":1,"DM":0,"DO":0,"DZ":6,"EC":1,"EE":1,"EG":6,"ES":1,"ET":0,"FI":1,"FJ":1,"FO":1,"FR":1,"GB":1,"GB-alt-variant":0,"GE":1,"GF":1,"GP":1,"GR":1,"GT":0,"GU":0,"HK":0,"HN":0,"HR":1,"HU":1,"ID":0,"IE":0,"IL":0,"IN":0,"IQ":6,"IR":6,"IS":1,"IT":1,"JM":0,"JO":6,"JP":0,"KE":0,"KG":1,"KH":0,"KR":0,"KW":6,"KZ":1,"LA":0,"LB":1,"LI":1,"LK":1,"LT":1,"LU":1,"LV":1,"LY":6,"MA":6,"MC":1,"MD":1,"ME":1,"MH":0,"MK":1,"MM":0,"MN":1,"MO":0,"MQ":1,"MT":0,"MV":5,"MX":0,"MY":1,"MZ":0,"NI":0,"NL":1,"NO":1,"NP":0,"NZ":0,"OM":6,"PA":0,"PE":0,"PH":0,"PK":0,"PL":1,"PR":0,"PT":1,"PY":0,"QA":6,"RE":1,"RO":1,"RS":1,"RU":1,"SA":0,"SD":6,"SE":1,"SG":0,"SI":1,"SK":1,"SM":1,"SV":0,"SY":6,"TH":0,"TJ":1,"TM":1,"TN":0,"TR":1,"TT":0,"TW":0,"UA":1,"UM":0,"US":0,"UY":1,"UZ":1,"VA":1,"VE":0,"VI":0,"VN":1,"WS":0,"XK":1,"YE":0,"ZA":0,"ZW":0}

/***/ }),

/***/ "/c3J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/* istanbul ignore next */
function safeWindowListenerAdd(eventName, callback) {
    if (true) {
        window.addEventListener(eventName, callback);
    }
}

/* istanbul ignore next */
function safeWindowListenerRemove(eventName, callback) {
    if (true) {
        window.removeEventListener(eventName, callback);
    }
}

exports.safeWindowListenerAdd = safeWindowListenerAdd;
exports.safeWindowListenerRemove = safeWindowListenerRemove;
//# sourceMappingURL=safeWindowListeners.js.map

/***/ }),

/***/ "/xbn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactButtons = __webpack_require__("HfJ9");

var _svgDefs = __webpack_require__("QnUD");

__webpack_require__("tyeG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Third Party Imports
var CarouselButtons = function CarouselButtons(_ref) {
    var handlePrev = _ref.handlePrev,
        handleNext = _ref.handleNext,
        _ref$reduceButtonHitT = _ref.reduceButtonHitTarget,
        reduceButtonHitTarget = _ref$reduceButtonHitT === undefined ? false : _ref$reduceButtonHitT;

    var navPrevArrowWrapperClasses = (0, _classnames2.default)('carousel__nav-wrapper carousel__nav-wrapper--prev', {
        'carousel__nav-wrapper--reduced': reduceButtonHitTarget
    });

    var navPrevButtonClasses = (0, _classnames2.default)('carousel__nav carousel__nav--prev', {
        'carousel__nav--reduced': reduceButtonHitTarget
    });

    var navNextArrowWrapperClasses = (0, _classnames2.default)('carousel__nav-wrapper carousel__nav-wrapper--next', {
        'carousel__nav-wrapper--reduced': reduceButtonHitTarget
    });

    var navNextButtonClasses = (0, _classnames2.default)('carousel__nav carousel__nav--next', {
        'carousel__nav--reduced': reduceButtonHitTarget
    });

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            {
                className: navPrevArrowWrapperClasses,
                key: 'carousel__nav-wrapper-0'
            },
            _react2.default.createElement(_reactButtons.ButtonIcon, {
                className: navPrevButtonClasses,
                onClick: handlePrev,
                circle: true,
                label: 'Previous',
                svgMarkup: _svgDefs.CHEVRON_LEFT__24
            })
        ),
        _react2.default.createElement(
            'div',
            {
                className: navNextArrowWrapperClasses,
                key: 'carousel__nav-wrapper-1'
            },
            _react2.default.createElement(_reactButtons.ButtonIcon, {
                className: navNextButtonClasses,
                onClick: handleNext,
                circle: true,
                label: 'Next',
                svgMarkup: _svgDefs.CHEVRON_RIGHT__24
            })
        )
    );
};

// Style


// Artifactory Imports


CarouselButtons.propTypes = {
    handlePrev: _propTypes2.default.func.isRequired,
    handleNext: _propTypes2.default.func.isRequired
};

exports.default = CarouselButtons;
//# sourceMappingURL=CarouselButtons.js.map

/***/ }),

/***/ "/yk9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _today = __webpack_require__("WAVn");

var _today2 = _interopRequireDefault(_today);

var _MonthNames = __webpack_require__("EgLL");

var _DaySelection = __webpack_require__("mgkl");

var _DaySelection2 = _interopRequireDefault(_DaySelection);

var _dateUtils = __webpack_require__("SCsJ");

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _LanguageTag = __webpack_require__("r94d");

var _LanguageTag2 = _interopRequireDefault(_LanguageTag);

__webpack_require__("eNOg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Day = function (_Component) {
    _inherits(Day, _Component);

    function Day(props) {
        _classCallCheck(this, Day);

        var _this = _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).call(this, props));

        _this.handleDayClick = function () {
            var _this$props = _this.props,
                dayTemplateComponent = _this$props.dayTemplateComponent,
                dayData = _this$props.dayData,
                day = _this$props.day;

            var today = _today2.default.getToday();
            var isToday = _today2.default.isToday(day, today);
            var isPast = _today2.default.isPast(day, today);
            var canClick = dayTemplateComponent && dayTemplateComponent.canClick ? dayTemplateComponent.canClick({ dayData: dayData, day: day, isPast: isPast, isToday: isToday }) : true;

            if (canClick) {
                _this.props.onDayClick(_this.props.day.dateString);
                _this.props.setActiveMonth();
            } else {
                _this.props.onDisabledDayClick(_this.props.day.dateString);
            }
        };

        _this.handleDayKeyboardEvents = function (e) {
            _this.handleDayHover();

            if (e.which === 13 || e.which === 32) {
                // Enter key or spacebar
                _this.handleDayClick();
            }
        };

        _this.handleDayHover = function () {
            var _this$props2 = _this.props,
                dayTemplateComponent = _this$props2.dayTemplateComponent,
                dayData = _this$props2.dayData,
                day = _this$props2.day;

            var today = _today2.default.getToday();
            var isToday = _today2.default.isToday(day, today);
            var isPast = _today2.default.isPast(day, today);
            var canSpan = dayTemplateComponent && dayTemplateComponent.canSpan ? dayTemplateComponent.canSpan({ dayData: dayData, day: day, isPast: isPast, isToday: isToday }) : true;

            if (canSpan) {
                _this.props.onDayHover(_this.props.day.dateString);
                _this.props.setActiveMonth();
            }
        };

        _this.mapMonthToAriaLabel = function (dayObj) {
            var monthNames = _this.props.monthNames || (0, _MonthNames.getMonthNamesInstance)(_this.props.locale).monthNames;

            return monthNames[dayObj.month];
        };

        return _this;
    }

    _createClass(Day, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            // Always update if any of these change
            if (nextProps.day !== this.props.day || nextProps.dayIndex !== this.props.dayIndex || nextProps.weekIndex !== this.props.weekIndex || nextProps.selectionStart !== this.props.selectionStart || nextProps.selectionEnd !== this.props.selectionEnd || nextProps.dayData !== this.props.dayData || nextProps.hoverDate !== this.props.hoverDate || nextProps.focusDate !== this.props.focusDate) {
                return true;
            }

            return false;
        }
    }, {
        key: 'buildDayTemplate',
        value: function buildDayTemplate(isToday, isPast, ariaLabelDate) {
            var _props = this.props,
                dayTemplateComponent = _props.dayTemplateComponent,
                dayData = _props.dayData,
                day = _props.day;

            var dateClasses = (0, _classnames2.default)({
                'date': dayTemplateComponent ? false : true,
                'today': isToday,
                'past': isPast
            });

            if (dayTemplateComponent) {
                var DayTemplateComponent = dayTemplateComponent;
                return _react2.default.createElement(DayTemplateComponent, {
                    dateString: day.dateString,
                    day: day.day,
                    dayData: dayData,
                    dayClasses: dateClasses,
                    isPast: isPast,
                    isToday: isToday
                });
            }

            return _react2.default.createElement(
                'div',
                { className: dateClasses, 'aria-hidden': 'true' },
                day.day,
                _react2.default.createElement(
                    'p',
                    { className: 'hidden' },
                    ariaLabelDate
                )
            );
        }
    }, {
        key: 'getAriaLabel',
        value: function getAriaLabel(day, date) {
            var compare = _dateUtils2.default.compareDateStrings;
            var start = this.props.selectedDate || this.props.selectionStart;
            var end = this.props.selectionEnd;
            if (!day.day) {
                return '';
            } else if (start !== null && compare(start, day.dateString) === 0) {
                // Selected start date
                return this.props.i18n.ariaLabelCheckinSelected.replace('{0}', date);
            } else if (end !== null && compare(end, day.dateString) === 0) {
                // Selected end date
                return this.props.i18n.ariaLabelCheckoutSelected.replace('{0}', date);
            }
            return date;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                day = _props2.day,
                selectionStart = _props2.selectionStart,
                selectionEnd = _props2.selectionEnd,
                selectedDate = _props2.selectedDate,
                hoverDate = _props2.hoverDate,
                dayIndex = _props2.dayIndex,
                weekIndex = _props2.weekIndex,
                simple = _props2.simple,
                dayTemplateComponent = _props2.dayTemplateComponent,
                dayData = _props2.dayData,
                setRef = _props2.setRef,
                i18n = _props2.i18n,
                isFocusable = _props2.isFocusable,
                locale = _props2.locale;

            var today = _today2.default.getToday();
            var isToday = _today2.default.isToday(day, today);
            var isPast = _today2.default.isPast(day, today);
            var lastDayOfWeek = (dayIndex + 1) % 7 === 0;
            var canSpan = dayTemplateComponent && dayTemplateComponent.canSpan ? dayTemplateComponent.canSpan({ dayData: dayData, day: day, isPast: isPast, isToday: isToday }) : true;
            var canClick = dayTemplateComponent && dayTemplateComponent.canClick ? dayTemplateComponent.canClick({ dayData: dayData, day: day, isPast: isPast, isToday: isToday }) : true;
            var event = new Date(Date.UTC(day.year, day.month, day.day));
            var options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
            var languageTag = locale ? new _LanguageTag2.default(locale) : {};
            var code = languageTag.code || 'default';
            var ariaLabelDate = event.toLocaleDateString(code, options);
            var dayTemplate = this.buildDayTemplate(isToday, isPast, ariaLabelDate);
            var isHidden = !day.day ? true : false;
            var isTouch = false;
            var tabIndex = -1;
            var ariaLabel = this.getAriaLabel(day, ariaLabelDate);

            /* istanbul ignore next */
            if (true) {
                isTouch = 'ontouchstart' in window;
            }

            var dayClasses = (0, _classnames2.default)({
                'day': true,
                'last': lastDayOfWeek,
                'top': weekIndex === 0,
                'empty': !day.day,
                'last-day': _dateUtils2.default.isLastDayInMonth(day),
                'first-day': _dateUtils2.default.isFirstDayInMonth(day),
                'no-gridlines': !this.props.showGridlines,
                'past': isPast,
                'selectable': this.props.selectable && canSpan,
                'clickable': this.props.selectable && canClick
            });

            if (canSpan && !canClick && !!this.props.selectionStart && !this.props.selectionEnd) {
                ariaLabel = i18n.ariaLabelNotValidCheckout.replace('{0}', ariaLabelDate);
            } else if (canSpan && !canClick) {
                ariaLabel = i18n.ariaLabelNotValidCheckin.replace('{0}', ariaLabelDate);
            } else if (isPast || !canSpan || !canClick) {
                ariaLabel = i18n.ariaLabelUnavailable.replace('{0}', ariaLabelDate);
            }

            // Update the tabIndex of the cell depending on whether it is either
            // the selected start date, current day of the month, or the first day of the first visible month.
            if (day.dateString === selectionStart || day.dateString === selectedDate) {
                tabIndex = 0;
            } else if (isFocusable) {
                tabIndex = 0;
            } else if (!day.day || isPast) {
                tabIndex = -2; // A tabIndex of -2 is used to prevent navigation to empty cells and days in the past
            }

            return _react2.default.createElement(
                'td',
                { className: dayClasses, ref: setRef, 'data-column': dayIndex, 'data-row': weekIndex, tabIndex: tabIndex, 'aria-label': ariaLabel, 'aria-hidden': isHidden, onClick: this.handleDayClick, onFocus: isTouch ? null : this.handleDayKeyboardEvents, onKeyDown: this.handleDayKeyboardEvents, onMouseEnter: isTouch ? null : this.handleDayHover },
                _react2.default.createElement(_DaySelection2.default, {
                    day: day,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd,
                    selectedDate: selectedDate,
                    hoverDate: hoverDate,
                    simple: simple,
                    dayTemplate: dayTemplate,
                    ariaLabelDate: ariaLabelDate
                })
            );
        }
    }]);

    return Day;
}(_react.Component);

Day.propTypes = {
    day: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
    weekIndex: _propTypes2.default.number,
    dayIndex: _propTypes2.default.number,
    simple: _propTypes2.default.bool,
    locale: _propTypes2.default.string,
    monthNames: _propTypes2.default.array,
    selectionStart: _propTypes2.default.string,
    selectionEnd: _propTypes2.default.string,
    hoverDate: _propTypes2.default.string,
    onDayClick: _propTypes2.default.func,
    onDayHover: _propTypes2.default.func,
    onDisabledDayClick: _propTypes2.default.func,
    dayData: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]), // eslint-disable-line react/forbid-prop-types
    dayTemplateComponent: _propTypes2.default.func
};
exports.default = Day;
//# sourceMappingURL=Day.js.map

/***/ }),

/***/ "0/jl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("YjQv");
var has = __webpack_require__("x//u");
var DESCRIPTORS = __webpack_require__("qs+f");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var META = __webpack_require__("+zJ9").KEY;
var $fails = __webpack_require__("zyKz");
var shared = __webpack_require__("a/OS");
var setToStringTag = __webpack_require__("LhDF");
var uid = __webpack_require__("GmwO");
var wks = __webpack_require__("hgbu");
var wksExt = __webpack_require__("4DQ7");
var wksDefine = __webpack_require__("Ntt2");
var enumKeys = __webpack_require__("6rdy");
var isArray = __webpack_require__("NU0k");
var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var createDesc = __webpack_require__("YTz9");
var _create = __webpack_require__("NZ8V");
var gOPNExt = __webpack_require__("6tLb");
var $GOPD = __webpack_require__("rjjF");
var $DP = __webpack_require__("GCs6");
var $keys = __webpack_require__("pEGt");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("2m2c").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("bSeU").f = $propertyIsEnumerable;
  __webpack_require__("THEY").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("c8Kh")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("aLzV")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "037f":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("1oyr"),
    defineProperty = __webpack_require__("p0bc"),
    identity = __webpack_require__("wSKX");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "0H+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("2Zwn"));

var _addClass = _interopRequireDefault(__webpack_require__("8+5l"));

var _removeClass = _interopRequireDefault(__webpack_require__("A4of"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _Transition = _interopRequireDefault(__webpack_require__("AUPe"));

var _PropTypes = __webpack_require__("nb0Q");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "0Lvz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var defined = __webpack_require__("+MZ2");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0lN5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = emitDatePickerEvent;

var _debug = __webpack_require__("LYGc");

function emitDatePickerEvent(eventaction) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Debug message
    if ((0, _debug.isLocal)()) {
        console.log('raise edap event - ', eventaction, options); //eslint-disable-line
    }

    // If edap does not exist, define array so overloaded push() method can raise event
    window.edap = window.edap || [];
    window.edap.push(function (edap) {
        edap.trigger(eventaction, options);
    });
}
//# sourceMappingURL=edap.js.map

/***/ }),

/***/ "0nPK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__("HW6M");

var _classnames3 = _interopRequireDefault(_classnames2);

var _svgDefs = __webpack_require__("QnUD");

var _reactSvg = __webpack_require__("Ye17");

__webpack_require__("gFo6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Third Party Imports

// Style


/* Percentage of the picture to swipe in order to allow swipe */
var THRESHOLD = 0.05;
var VERTICAL_THRESHOLD = 10;

var SimpleImageCarousel = function (_Component) {
    _inherits(SimpleImageCarousel, _Component);

    function SimpleImageCarousel(props) {
        _classCallCheck(this, SimpleImageCarousel);

        var _this = _possibleConstructorReturn(this, (SimpleImageCarousel.__proto__ || Object.getPrototypeOf(SimpleImageCarousel)).call(this, props));

        _this.onKeyDown = function (e) {
            var key = e.key,
                target = e.target;
            var onClick = _this.props.onClick;

            if (_this.keyUp && target === _this.main && (key === 'Enter' || key === ' ')) {
                _this.keyUp = false;
                if (key === ' ') {
                    e.preventDefault();
                }
                onClick();
            }
        };

        _this.onKeyUp = function (e) {
            var key = e.key,
                target = e.target;

            if (!_this.keyUp && target === _this.main && (key === 'Enter' || key === ' ')) {
                _this.keyUp = true;
            }
        };

        _this.handleTouchEnd = function () {
            _this.x = null;
            _this.y = null;
            _this.hasImageTransitioned = false;
        };

        _this.handleTouchMove = function (e) {
            var clientX = e.touches[0].clientX;
            var clientY = e.touches[0].clientY;

            if (_this.x && _this.y && !_this.hasImageTransitioned) {
                /* Get the start position and direction */
                var xDiff = _this.x - clientX;
                var yDiffAbs = Math.abs(_this.y - clientY);
                var width = e.target.clientWidth;
                /* Calculate percentage of image dragged */
                var force = Math.abs(xDiff / width);

                /* If we are swiping left or right
                Else we are scrolling */
                if (Math.abs(xDiff) > yDiffAbs && yDiffAbs < VERTICAL_THRESHOLD) {
                    /* Prevent vertical scrolling while are are swiping on the image */
                    e.preventDefault();

                    if (force > THRESHOLD) {
                        if (xDiff > 0) {
                            _this.onNext(e);
                        } else {
                            _this.onPrev(e);
                        }
                        _this.hasImageTransitioned = true;
                    }
                }
            } else {
                _this.x = clientX;
                _this.y = clientY;
            }
        };

        _this.appendBackgroundStyle = function (style, imageUrl) {
            if (imageUrl) {
                style.backgroundImage = 'url(' + imageUrl + ')';
            }

            return style;
        };

        var backgroundSrc = props.images[0] && props.images[0].src || null;
        _this.setMainRef = _this.setRef.bind(_this, 'main');
        _this.setPrevRef = _this.setRef.bind(_this, 'prev');
        _this.setNextRef = _this.setRef.bind(_this, 'next');
        _this.onPrev = _this.onChangeIndex.bind(_this, 'prev');
        _this.onNext = _this.onChangeIndex.bind(_this, 'next');
        _this.state = {
            backgroundSrc: backgroundSrc,
            preloadSrc: '',
            transitionDirection: '',
            index: 0,
            altText: ''
        };
        _this.keyUp = true;
        _this.timeouts = {};
        _this.x = null;
        _this.y = null;
        _this.hasImageTransitioned = false;
        return _this;
    }

    _createClass(SimpleImageCarousel, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var onClick = this.props.onClick;
            /* istanbul ignore else */

            if (this.main) {
                this.main.removeEventListener('click', onClick);
                this.main.removeEventListener('keydown', this.onKeyDown);
                this.main.removeEventListener('keyup', this.onKeyUp);
                this.main.removeEventListener('touchmove', this.handleTouchMove);
                this.main.removeEventListener('touchend', this.handleTouchEnd);
            }
            /* istanbul ignore else */
            if (this.prev) {
                this.prev.removeEventListener('click', this.onPrev);
            }
            /* istanbul ignore else */
            if (this.next) {
                this.next.removeEventListener('click', this.onNext);
            }
        }
    }, {
        key: 'transition',
        value: function transition(dir) {
            var _this2 = this;

            var _props = this.props,
                transitionDuration = _props.transitionDuration,
                images = _props.images,
                index = _props.index;

            var updatedIndex = this.getUpdatedIndex(dir, index);
            var preloadIndex = this.getPreloadIndex(dir, index);
            this.setState({
                transitionDirection: dir,
                backgroundSrc: images[updatedIndex].src,
                preloadSrc: images[preloadIndex].src,
                altText: images[updatedIndex].altText
            });
            clearTimeout(this.timeouts.slide);
            this.timeouts.slide = setTimeout(function () {
                // this.updateIndex(dir);
                clearTimeout(_this2.timeouts.slide);
                _this2.setState({ transitionDirection: '' });
                if (dir === 'next') {
                    _this2.props.onNextClick(updatedIndex);
                } else {
                    _this2.props.onPrevClick(updatedIndex);
                }
            }, transitionDuration);
        }
    }, {
        key: 'onChangeIndex',
        value: function onChangeIndex(dir, e) {
            e.stopPropagation();
            this.transition(dir);
        }
    }, {
        key: 'getNextIndex',
        value: function getNextIndex(index) {
            var images = this.props.images;

            return index > images.length - 2 ? 0 : index + 1;
        }
    }, {
        key: 'getPrevIndex',
        value: function getPrevIndex(index) {
            var images = this.props.images;

            return index > 0 ? index - 1 : images.length - 1;
        }
    }, {
        key: 'getUpdatedIndex',
        value: function getUpdatedIndex(dir, index) {
            return dir === 'next' ? this.getNextIndex(index) : this.getPrevIndex(index);
        }
    }, {
        key: 'getPreloadIndex',
        value: function getPreloadIndex(dir, index) {
            var val = this.getUpdatedIndex(dir, this.getUpdatedIndex(dir, index));
            return val;
        }
    }, {
        key: 'getTransitionDuration',
        value: function getTransitionDuration(dir, image) {
            var transitionDuration = this.props.transitionDuration;

            if (dir === image || dir !== '' && image === 'either') {
                return transitionDuration + 'ms';
            }
            return '';
        }
    }, {
        key: 'setRef',
        value: function setRef(name, ref) {
            var onClick = this.props.onClick;

            var methodsMap = {
                prev: this.onPrev,
                next: this.onNext,
                main: onClick
            };
            this[name] = ref;
            if (ref && methodsMap[name]) {
                ref.addEventListener('click', methodsMap[name]);
                if (name === 'main') {
                    ref.addEventListener('keydown', this.onKeyDown);
                    ref.addEventListener('keyup', this.onKeyUp);
                    ref.addEventListener('touchmove', this.handleTouchMove);
                    ref.addEventListener('touchend', this.handleTouchEnd);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                transitionDirection = _state.transitionDirection,
                preloadSrc = _state.preloadSrc,
                backgroundSrc = _state.backgroundSrc;
            var _props2 = this.props,
                index = _props2.index,
                images = _props2.images,
                transitionStyle = _props2.transitionStyle,
                renderButtons = _props2.renderButtons,
                className = _props2.className,
                href = _props2.href,
                target = _props2.target;

            var backgroundImageSrc = images[index] && images[index].src || null;
            var nextBackgroundImage = images[this.getNextIndex(index)];
            var nextBackgroundImageSrc = nextBackgroundImage && nextBackgroundImage.src || null;
            var prevBackgroundImage = images[this.getPrevIndex(index)];
            var prevBackgroundImageSrc = prevBackgroundImage && prevBackgroundImage.src || null;
            var rootClass = (0, _classnames3.default)('SimpleImageCarousel', _defineProperty({
                'SimpleImageCarousel--transitioning': !!transitionDirection
            }, className, !!className));
            var curClass = (0, _classnames3.default)('SimpleImageCarousel__image SimpleImageCarousel__image--cur', {
                'SimpleImageCarousel__image--transitioning-prev-slide': transitionDirection === 'prev' && transitionStyle === 'slide',
                'SimpleImageCarousel__image--transitioning-next-slide': transitionDirection === 'next' && transitionStyle === 'slide'
            });

            var curStyle = this.appendBackgroundStyle({
                transitionDuration: this.getTransitionDuration(transitionDirection, 'either')
            }, backgroundImageSrc);

            var rootStyle = this.appendBackgroundStyle({}, backgroundSrc);

            var nextClass = (0, _classnames3.default)('SimpleImageCarousel__image', {
                'SimpleImageCarousel__image--next-slide': transitionStyle === 'slide' || transitionStyle === 'slideOver',
                'SimpleImageCarousel__image--next-fade': transitionStyle === 'fade',
                'SimpleImageCarousel__image--transitioning-slide': transitionDirection === 'next' && (transitionStyle === 'slide' || transitionStyle === 'slideOver'),
                'SimpleImageCarousel__image--transitioning-fade': transitionDirection === 'next' && transitionStyle === 'fade'
            });
            var nextStyle = this.appendBackgroundStyle({
                transitionDuration: this.getTransitionDuration(transitionDirection, 'next')
            }, nextBackgroundImageSrc);
            var prevClass = (0, _classnames3.default)('SimpleImageCarousel__image', {
                'SimpleImageCarousel__image--prev-slide': transitionStyle === 'slide' || transitionStyle === 'slideOver',
                'SimpleImageCarousel__image--prev-fade': transitionStyle === 'fade',
                'SimpleImageCarousel__image--transitioning-slide': transitionDirection === 'prev' && (transitionStyle === 'slide' || transitionStyle === 'slideOver'),
                'SimpleImageCarousel__image--transitioning-fade': transitionDirection === 'prev' && transitionStyle === 'fade'
            });
            var prevStyle = this.appendBackgroundStyle({
                transitionDuration: this.getTransitionDuration(transitionDirection, 'prev')
            }, prevBackgroundImageSrc);
            var preloadStyle = this.appendBackgroundStyle({}, preloadSrc);

            return _react2.default.createElement(
                'a',
                {
                    'aria-label': 'View property',
                    className: rootClass,
                    'data-imgsrcurl': backgroundSrc,
                    'data-index': index,
                    'data-wdio': 'SimpleImageCarousel--main',
                    ref: this.setMainRef,
                    role: 'button',
                    style: rootStyle,
                    tabIndex: '0',
                    target: target,
                    href: href
                },
                _react2.default.createElement('div', { className: curClass, style: curStyle, role: 'img', 'aria-label': this.state.altText }),
                _react2.default.createElement('div', { className: nextClass, style: nextStyle }),
                _react2.default.createElement('div', { className: prevClass, style: prevStyle }),
                _react2.default.createElement('div', { className: 'SimpleImageCarousel__preloader', style: preloadStyle }),
                images.length > 0 && renderButtons({ setPrevRef: this.setPrevRef, setNextRef: this.setNextRef })
            );
        }
    }]);

    return SimpleImageCarousel;
}(_react.Component);

SimpleImageCarousel.propTypes = {
    /** index */
    index: _propTypes2.default.number.isRequired,
    /** images array */
    images: _propTypes2.default.instanceOf(Array).isRequired,
    /** images array */
    className: _propTypes2.default.string,
    /** transition duration in milliseconds */
    transitionDuration: _propTypes2.default.number,
    /** transition style */
    transitionStyle: _propTypes2.default.oneOf(['slide', 'slideOver', 'fade']),
    /** main image click handler */
    onClick: _propTypes2.default.func,
    /** previous image button click handler callback */
    onPrevClick: _propTypes2.default.func,
    /** next image button click handler callback */
    onNextClick: _propTypes2.default.func,
    /** renders previous and next buttons. Takes {setPrevRef, setNextRef} as argument */
    renderButtons: _propTypes2.default.func
};
SimpleImageCarousel.defaultProps = {
    index: 0,
    images: [],
    transitionDuration: 250,
    transitionStyle: 'slide',
    onClick: function onClick() {},
    onPrevClick: function onPrevClick() {},
    onNextClick: function onNextClick() {},
    renderButtons: function renderButtons(_ref) {
        var setPrevRef = _ref.setPrevRef,
            setNextRef = _ref.setNextRef;

        return [_react2.default.createElement(
            'button',
            {
                key: '0',
                className: 'SimpleImageCarousel__button SimpleImageCarousel__button--left',
                'data-wdio': 'SimpleImageCarousel__button--prev',
                ref: setPrevRef
            },
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                'Previous Image'
            ),
            _react2.default.createElement(_reactSvg.SVGIcon, { className: 'SimpleImageCarousel__svg SimpleImageCarousel__svg--left', markup: _svgDefs.CHEVRON_LEFT__24 })
        ), _react2.default.createElement(
            'button',
            {
                key: '1',
                className: 'SimpleImageCarousel__button SimpleImageCarousel__button--right',
                'data-wdio': 'SimpleImageCarousel__button--next',
                ref: setNextRef
            },
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                'Next Image'
            ),
            _react2.default.createElement(_reactSvg.SVGIcon, { className: 'SimpleImageCarousel__svg SimpleImageCarousel__svg--right', markup: _svgDefs.CHEVRON_RIGHT__24 })
        )];
    }
};
exports.default = SimpleImageCarousel;
//# sourceMappingURL=SimpleImageCarousel.js.map

/***/ }),

/***/ "0yQ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("ieDx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WeekdayNames(_ref) {
    var dayNames = _ref.dayNames,
        shortDayNames = _ref.shortDayNames,
        longDayNames = _ref.longDayNames,
        simple = _ref.simple,
        _ref$startOfWeek = _ref.startOfWeek,
        startOfWeek = _ref$startOfWeek === undefined ? 0 : _ref$startOfWeek,
        showGridlines = _ref.showGridlines;

    var weekDayNameClasses = (0, _classnames2.default)('weekday-names', {
        'weekday-names--no-gridlines': !showGridlines
    });

    return _react2.default.createElement(
        'tr',
        { className: weekDayNameClasses },
        [0, 1, 2, 3, 4, 5, 6].map(function (x, i) {
            var weekend = startOfWeek === 0 && (i === 0 || i === 6) || startOfWeek === 1 && (i === 5 || i === 6);

            var weekDayClasses = (0, _classnames2.default)({
                'weekday-title': true,
                weekend: weekend,
                simple: simple
            });

            return _react2.default.createElement(
                'th',
                { scope: 'col', className: weekDayClasses, key: 'weekday-' + i },
                _react2.default.createElement(
                    'span',
                    { 'aria-hidden': 'true' },
                    simple ? shortDayNames[i] : dayNames[i]
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    longDayNames[i]
                )
            );
        })
    );
}

exports.default = WeekdayNames;
//# sourceMappingURL=WeekdayNames.js.map

/***/ }),

/***/ "1C79":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("uIr7"),
    isFlattenable = __webpack_require__("Qp3N");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "1RnF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("aLzV");


/***/ }),

/***/ "1Yb9":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("mgnk"),
    isObjectLike = __webpack_require__("UnEC");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "1fcP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1oyr":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "1sG0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecentActivity = __webpack_require__("Aq9S");

var _RecentActivity2 = _interopRequireDefault(_RecentActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecentActivityContainer = function (_Component) {
    _inherits(RecentActivityContainer, _Component);

    function RecentActivityContainer() {
        _classCallCheck(this, RecentActivityContainer);

        var _this = _possibleConstructorReturn(this, (RecentActivityContainer.__proto__ || Object.getPrototypeOf(RecentActivityContainer)).call(this));

        _this.handleNextAndPreviousClick = function (e, newIndex) {
            _this.setState({ cardIndex: newIndex });

            if (_this.props.onArrowClick) {
                _this.props.onArrowClick(e, newIndex);
            }
        };

        _this.state = { cardIndex: 0 };
        return _this;
    }

    _createClass(RecentActivityContainer, [{
        key: 'render',
        value: function render() {
            var cardIndex = this.state.cardIndex;


            return _react2.default.createElement(_RecentActivity2.default, _extends({
                cardIndex: cardIndex,
                onArrowClick: this.handleNextAndPreviousClick
            }, this.props));
        }
    }]);

    return RecentActivityContainer;
}(_react.Component);

RecentActivityContainer.propTypes = {
    breakpoints: _propTypes2.default.objectOf(_propTypes2.default.number),
    env: _propTypes2.default.oneOf(['dev', 'test', 'stage', 'production', 'prod']),
    hav: _propTypes2.default.string,
    onArrowClick: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    puuid: _propTypes2.default.string,
    site: _propTypes2.default.string,
    title: _propTypes2.default.string
};
RecentActivityContainer.defaultProps = {
    site: 'homeaway_us'
};
exports.default = RecentActivityContainer;
//# sourceMappingURL=RecentActivityContainer.js.map

/***/ }),

/***/ "2+dq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2KeS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("YSwN"))(6);

/***/ }),

/***/ "2N6f":
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__("rCVp"),
    overRest = __webpack_require__("Q2wK"),
    setToString = __webpack_require__("WHce");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ "2VmA":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("VORN"),
    baseLodash = __webpack_require__("KMSM");

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),

/***/ "2Zwn":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("F1sa")();
}


/***/ }),

/***/ "2m2c":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("DvwR");
var hiddenKeys = __webpack_require__("B5V0").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "3BH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ARROW_RIGHT__24 = void 0;
var ARROW_RIGHT__24 = '<svg data-id="SVG_ARROW_RIGHT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M15.7 7l5 5-5 5M20.8 12H3.2"/></g></svg>';
exports.ARROW_RIGHT__24 = ARROW_RIGHT__24;

/***/ }),

/***/ "3Y6g":
/***/ (function(module, exports) {

exports.version = "2.3.1"

/***/ }),

/***/ "3ZWP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactButtons = __webpack_require__("HfJ9");

var _reactFormComponents = __webpack_require__("QyGt");

var _reactSvg = __webpack_require__("Ye17");

var _HEART_SELECTED__ = __webpack_require__("OFFT");

var _constants = __webpack_require__("hXMO");

__webpack_require__("FJL/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CreateTripBoard(props) {
    var handleClickCancel = props.handleClickCancel,
        handleClickCreate = props.handleClickCreate,
        newBoardName = props.newBoardName,
        onNameChange = props.onNameChange,
        showCancel = props.showCancel,
        translations = props.translations,
        isMobile = props.isMobile,
        createIsDisabled = props.createIsDisabled;


    var emptyState = translations['tripboards.main.empty.state'];
    var heartMessages = emptyState && emptyState.split('{heart}');

    return _react2.default.createElement(
        'div',
        { className: 'create-trip-board' },
        heartMessages && _react2.default.createElement(
            'div',
            { className: 'create-trip-board__cta' },
            heartMessages[0],
            ' ',
            _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _HEART_SELECTED__.HEART_SELECTED__16, className: 'create-trip-board__cta_heart' }),
            ' ',
            heartMessages[1]
        ),
        _react2.default.createElement(
            'form',
            { onSubmit: handleClickCreate },
            _react2.default.createElement(_reactFormComponents.FormInput, {
                autoFocus: !isMobile,
                className: 'create-trip-board__input',
                id: 'boardInput',
                inputClassName: 'trip-board-text-input',
                label: translations['tripboards.modal.create.name'],
                maxLength: _constants.MAX_TRIPBOARD_NAME_LENGTH,
                value: newBoardName,
                onChange: onNameChange
            }),
            _react2.default.createElement(
                'div',
                { className: 'create-trip-board__buttons' },
                showCancel && _react2.default.createElement(_reactButtons.Button, {
                    id: 'cancelButton',
                    className: 'create-trip-board__buttons_cancel',
                    label: translations['tripboards.cancel'],
                    onClick: handleClickCancel,
                    size: 'sm'
                }),
                _react2.default.createElement(_reactButtons.ButtonPrimary, {
                    id: 'createButton',
                    label: translations['tripboards.modal.create'],
                    disabled: createIsDisabled,
                    onClick: handleClickCreate,
                    size: 'sm'
                })
            )
        )
    );
}

CreateTripBoard.propTypes = {
    handleClickCancel: _propTypes2.default.func.isRequired,
    handleClickCreate: _propTypes2.default.func.isRequired,
    newBoardName: _propTypes2.default.string.isRequired,
    onNameChange: _propTypes2.default.func.isRequired,
    showCancel: _propTypes2.default.bool.isRequired
};

exports.default = CreateTripBoard;
//# sourceMappingURL=CreateTripBoard.js.map

/***/ }),

/***/ "3fMt":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("SWGL");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "3ggi":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('asyncIterator');


/***/ }),

/***/ "3zLD":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__("GiK3"), __webpack_require__("KSGD"), __webpack_require__("u1/p")) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'apollo-client'], factory) :
    (factory((global['react-apollo'] = {}),global.React,global.PropTypes,global.apolloClient));
}(this, (function (exports,React,PropTypes,apolloClient) { 'use strict';

    function getProps(element) {
        return element.props || element.attributes;
    }
    function isReactElement(element) {
        return !!element.type;
    }
    function isComponentClass(Comp) {
        return Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent);
    }
    function providesChildContext(instance) {
        return !!instance.getChildContext;
    }
    function walkTree(element, context, visitor) {
        if (Array.isArray(element)) {
            element.forEach(function (item) { return walkTree(item, context, visitor); });
            return;
        }
        if (!element) {
            return;
        }
        if (isReactElement(element)) {
            if (typeof element.type === 'function') {
                var Comp = element.type;
                var props = Object.assign({}, Comp.defaultProps, getProps(element));
                var childContext_1 = context;
                var child = void 0;
                if (isComponentClass(Comp)) {
                    var instance_1 = new Comp(props, context);
                    instance_1.props = instance_1.props || props;
                    instance_1.context = instance_1.context || context;
                    instance_1.state = instance_1.state || null;
                    instance_1.setState = function (newState) {
                        if (typeof newState === 'function') {
                            newState = newState(instance_1.state, instance_1.props, instance_1.context);
                        }
                        instance_1.state = Object.assign({}, instance_1.state, newState);
                    };
                    if (instance_1.componentWillMount) {
                        instance_1.componentWillMount();
                    }
                    if (providesChildContext(instance_1)) {
                        childContext_1 = Object.assign({}, context, instance_1.getChildContext());
                    }
                    if (visitor(element, instance_1, context, childContext_1) === false) {
                        return;
                    }
                    child = instance_1.render();
                }
                else {
                    if (visitor(element, null, context) === false) {
                        return;
                    }
                    child = Comp(props, context);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, childContext_1, visitor); });
                    }
                    else {
                        walkTree(child, childContext_1, visitor);
                    }
                }
            }
            else {
                if (visitor(element, null, context) === false) {
                    return;
                }
                if (element.props && element.props.children) {
                    React.Children.forEach(element.props.children, function (child) {
                        if (child) {
                            walkTree(child, context, visitor);
                        }
                    });
                }
            }
        }
        else if (typeof element === 'string' || typeof element === 'number') {
            visitor(element, null, context);
        }
    }
    function hasFetchDataFunction(instance) {
        return typeof instance.fetchData === 'function';
    }
    function isPromise(promise) {
        return typeof promise.then === 'function';
    }
    function getPromisesFromTree(_a) {
        var rootElement = _a.rootElement, _b = _a.rootContext, rootContext = _b === void 0 ? {} : _b;
        var promises = [];
        walkTree(rootElement, rootContext, function (_, instance, context, childContext) {
            if (instance && hasFetchDataFunction(instance)) {
                var promise = instance.fetchData();
                if (isPromise(promise)) {
                    promises.push({ promise: promise, context: childContext || context, instance: instance });
                    return false;
                }
            }
        });
        return promises;
    }
    function getDataFromTree(rootElement, rootContext) {
        if (rootContext === void 0) { rootContext = {}; }
        var promises = getPromisesFromTree({ rootElement: rootElement, rootContext: rootContext });
        if (!promises.length) {
            return Promise.resolve();
        }
        var errors = [];
        var mappedPromises = promises.map(function (_a) {
            var promise = _a.promise, context = _a.context, instance = _a.instance;
            return promise
                .then(function (_) { return getDataFromTree(instance.render(), context); })
                .catch(function (e) { return errors.push(e); });
        });
        return Promise.all(mappedPromises).then(function (_) {
            if (errors.length > 0) {
                var error = errors.length === 1
                    ? errors[0]
                    : new Error(errors.length + " errors were thrown when executing your fetchData functions.");
                error.queryErrors = errors;
                throw error;
            }
        });
    }

    var invariant = __webpack_require__("crWv");
    var ApolloConsumer = function (props, context) {
        invariant(!!context.client, "Could not find \"client\" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>");
        return props.children(context.client);
    };
    ApolloConsumer.contextTypes = {
        client: PropTypes.object.isRequired,
    };
    ApolloConsumer.propTypes = {
        children: PropTypes.func.isRequired,
    };

    var __extends = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$1 = __webpack_require__("crWv");
    var ApolloProvider = (function (_super) {
        __extends(ApolloProvider, _super);
        function ApolloProvider(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.operations = new Map();
            invariant$1(props.client, 'ApolloClient was not passed a client instance. Make ' +
                'sure you pass in your client via the "client" prop.');
            if (!props.client.__operations_cache__) {
                props.client.__operations_cache__ = _this.operations;
            }
            return _this;
        }
        ApolloProvider.prototype.getChildContext = function () {
            return {
                client: this.props.client,
                operations: this.props.client.__operations_cache__,
            };
        };
        ApolloProvider.prototype.render = function () {
            return this.props.children;
        };
        ApolloProvider.propTypes = {
            client: PropTypes.object.isRequired,
            children: PropTypes.element.isRequired,
        };
        ApolloProvider.childContextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        return ApolloProvider;
    }(React.Component));

    var invariant$2 = __webpack_require__("crWv");
    var DocumentType;
    (function (DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })(DocumentType || (DocumentType = {}));
    var cache = new Map();
    function parser(document) {
        var cached = cache.get(document);
        if (cached)
            return cached;
        var variables, type, name;
        invariant$2(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " +
            "DocumentNode. You may need to use 'graphql-tag' or another method " +
            "to convert your operation into a document");
        var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
        var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
        var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
        var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
        invariant$2(!fragments.length || (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
            "You must include a query, subscription or mutation as well");
        invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
            (document + " had " + queries.length + " queries, " + subscriptions.length + " ") +
            ("subscriptions and " + mutations.length + " mutations. ") +
            "You can use 'compose' to join multiple operation types to a component");
        type = queries.length ? DocumentType.Query : DocumentType.Mutation;
        if (!queries.length && !mutations.length)
            type = DocumentType.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        invariant$2(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " +
            (definitions.length + " definitions. ") +
            "You can use 'compose' to join multiple operation types to a component");
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') {
            name = definition.name.value;
        }
        else {
            name = 'data';
        }
        var payload = { name: name, type: type, variables: variables };
        cache.set(document, payload);
        return payload;
    }

    var __extends$1 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var shallowEqual = __webpack_require__("sgb3");
    var invariant$3 = __webpack_require__("crWv");
    function compact(obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            if (obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    function observableQueryFields(observable) {
        var fields = {
            variables: observable.variables,
            refetch: observable.refetch.bind(observable),
            fetchMore: observable.fetchMore.bind(observable),
            updateQuery: observable.updateQuery.bind(observable),
            startPolling: observable.startPolling.bind(observable),
            stopPolling: observable.stopPolling.bind(observable),
            subscribeToMore: observable.subscribeToMore.bind(observable),
        };
        return fields;
    }
    var Query = (function (_super) {
        __extends$1(Query, _super);
        function Query(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.previousData = {};
            _this.startQuerySubscription = function () {
                if (_this.querySubscription)
                    return;
                var current = _this.getQueryResult();
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: function () {
                        if (current && current.networkStatus === 7) {
                            current = undefined;
                            return;
                        }
                        _this.updateCurrentData();
                    },
                    error: function (error) {
                        _this.resubscribeToQuery();
                        if (!error.hasOwnProperty('graphQLErrors'))
                            throw error;
                        _this.updateCurrentData();
                    },
                });
            };
            _this.removeQuerySubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            _this.updateCurrentData = function () {
                if (_this.hasMounted)
                    _this.forceUpdate();
            };
            _this.getQueryResult = function () {
                var data = { data: Object.create(null) };
                Object.assign(data, observableQueryFields(_this.queryObservable));
                var currentResult = _this.queryObservable.currentResult();
                var loading = currentResult.loading, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) {
                    error = new apolloClient.ApolloError({ graphQLErrors: errors });
                }
                Object.assign(data, { loading: loading, networkStatus: networkStatus, error: error });
                if (loading) {
                    Object.assign(data.data, _this.previousData, currentResult.data);
                }
                else if (error) {
                    Object.assign(data, {
                        data: (_this.queryObservable.getLastResult() || {}).data,
                    });
                }
                else {
                    Object.assign(data.data, currentResult.data);
                    _this.previousData = currentResult.data;
                }
                if (!_this.querySubscription) {
                    var oldRefetch_1 = data.refetch;
                    data.refetch = function (args) {
                        if (_this.querySubscription) {
                            return oldRefetch_1(args);
                        }
                        else {
                            return new Promise(function (r, f) {
                                _this.refetcherQueue = { resolve: r, reject: f, args: args };
                            });
                        }
                    };
                }
                data.client = _this.client;
                return data;
            };
            _this.client = props.client || context.client;
            invariant$3(!!_this.client, "Could not find \"client\" in the context of Query or as passed props. Wrap the root component in an <ApolloProvider>");
            _this.initializeQueryObservable(props);
            return _this;
        }
        Query.prototype.fetchData = function () {
            if (this.props.skip)
                return false;
            var _a = this.props, children = _a.children, ssr = _a.ssr, displayName = _a.displayName, skip = _a.skip, client = _a.client, opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client"]);
            var fetchPolicy = opts.fetchPolicy;
            if (ssr === false)
                return false;
            if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
                fetchPolicy = 'cache-first';
            }
            var observable = this.client.watchQuery(__assign({}, opts, { fetchPolicy: fetchPolicy }));
            var result = this.queryObservable.currentResult();
            return result.loading ? observable.result() : false;
        };
        Query.prototype.componentDidMount = function () {
            this.hasMounted = true;
            if (this.props.skip)
                return;
            this.startQuerySubscription();
            if (this.refetcherQueue) {
                var _a = this.refetcherQueue, args = _a.args, resolve = _a.resolve, reject = _a.reject;
                this.queryObservable.refetch(args)
                    .then(resolve)
                    .catch(reject);
            }
        };
        Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (nextProps.skip && !this.props.skip) {
                this.removeQuerySubscription();
                return;
            }
            var client = nextProps.client;
            if (shallowEqual(this.props, nextProps) &&
                (this.client === client || this.client === nextContext.client)) {
                return;
            }
            if (this.client !== client && this.client !== nextContext.client) {
                if (client) {
                    this.client = client;
                }
                else {
                    this.client = nextContext.client;
                }
                this.removeQuerySubscription();
                this.queryObservable = null;
                this.previousData = {};
                this.updateQuery(nextProps);
            }
            if (this.props.query !== nextProps.query) {
                this.removeQuerySubscription();
            }
            this.updateQuery(nextProps);
            if (nextProps.skip)
                return;
            this.startQuerySubscription();
        };
        Query.prototype.componentWillUnmount = function () {
            this.removeQuerySubscription();
            this.hasMounted = false;
        };
        Query.prototype.render = function () {
            var children = this.props.children;
            var queryResult = this.getQueryResult();
            return children(queryResult);
        };
        Query.prototype.extractOptsFromProps = function (props) {
            var variables = props.variables, pollInterval = props.pollInterval, fetchPolicy = props.fetchPolicy, errorPolicy = props.errorPolicy, notifyOnNetworkStatusChange = props.notifyOnNetworkStatusChange, query = props.query, _a = props.displayName, displayName = _a === void 0 ? 'Query' : _a, _b = props.context, context = _b === void 0 ? {} : _b;
            this.operation = parser(query);
            invariant$3(this.operation.type === DocumentType.Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === DocumentType.Mutation ? 'mutation' : 'subscription') + ".");
            return compact({
                variables: variables,
                pollInterval: pollInterval,
                query: query,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
                notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
                metadata: { reactComponent: { displayName: displayName } },
                context: context,
            });
        };
        Query.prototype.initializeQueryObservable = function (props) {
            var opts = this.extractOptsFromProps(props);
            if (this.context.operations) {
                this.context.operations.set(this.operation.name, {
                    query: opts.query,
                    variables: opts.variables,
                });
            }
            this.queryObservable = this.client.watchQuery(opts);
        };
        Query.prototype.updateQuery = function (props) {
            if (!this.queryObservable)
                this.initializeQueryObservable(props);
            this.queryObservable.setOptions(this.extractOptsFromProps(props))
                .catch(function () { return null; });
        };
        Query.prototype.resubscribeToQuery = function () {
            this.removeQuerySubscription();
            var lastError = this.queryObservable.getLastError();
            var lastResult = this.queryObservable.getLastResult();
            this.queryObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.queryObservable, { lastError: lastError, lastResult: lastResult });
        };
        Query.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Query.propTypes = {
            children: PropTypes.func.isRequired,
            fetchPolicy: PropTypes.string,
            notifyOnNetworkStatusChange: PropTypes.bool,
            pollInterval: PropTypes.number,
            query: PropTypes.object.isRequired,
            variables: PropTypes.object,
            ssr: PropTypes.bool,
        };
        return Query;
    }(React.Component));

    var __extends$2 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$4 = __webpack_require__("crWv");
    var shallowEqual$1 = __webpack_require__("sgb3");
    var initialState = {
        loading: false,
        called: false,
        error: undefined,
        data: undefined,
    };
    var Mutation = (function (_super) {
        __extends$2(Mutation, _super);
        function Mutation(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.runMutation = function (options) {
                if (options === void 0) { options = {}; }
                _this.onStartMutation();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(options)
                    .then(function (response) {
                    _this.onCompletedMutation(response, mutationId);
                    return response;
                })
                    .catch(function (e) {
                    _this.onMutationError(e, mutationId);
                    if (!_this.props.onError)
                        throw e;
                });
            };
            _this.mutate = function (options) {
                var _a = _this.props, mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, context = _b === void 0 ? {} : _b;
                var refetchQueries = options.refetchQueries || _this.props.refetchQueries;
                if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
                    refetchQueries = refetchQueries.map(function (x) {
                        if (typeof x === 'string' && _this.context.operations)
                            return _this.context.operations.get(x) || x;
                        return x;
                    });
                    delete options.refetchQueries;
                }
                return _this.client.mutate(__assign$1({ mutation: mutation,
                    variables: variables,
                    optimisticResponse: optimisticResponse,
                    refetchQueries: refetchQueries,
                    update: update,
                    context: context }, options));
            };
            _this.onStartMutation = function () {
                if (!_this.state.loading && !_this.props.ignoreResults) {
                    _this.setState({
                        loading: true,
                        error: undefined,
                        data: undefined,
                        called: true,
                    });
                }
            };
            _this.onCompletedMutation = function (response, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var _a = _this.props, onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
                var data = response.data;
                var callOncomplete = function () { return (onCompleted ? onCompleted(data) : null); };
                if (_this.isMostRecentMutation(mutationId) && !ignoreResults) {
                    _this.setState({ loading: false, data: data }, callOncomplete);
                }
                else {
                    callOncomplete();
                }
            };
            _this.onMutationError = function (error, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var onError = _this.props.onError;
                var callOnError = function () { return (onError ? onError(error) : null); };
                if (_this.isMostRecentMutation(mutationId)) {
                    _this.setState({ loading: false, error: error }, callOnError);
                }
                else {
                    callOnError();
                }
            };
            _this.generateNewMutationId = function () {
                _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
                return _this.mostRecentMutationId;
            };
            _this.isMostRecentMutation = function (mutationId) {
                return _this.mostRecentMutationId === mutationId;
            };
            _this.verifyDocumentIsMutation = function (mutation) {
                var operation = parser(mutation);
                invariant$4(operation.type === DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === DocumentType.Query ? 'query' : 'subscription') + ".");
            };
            _this.verifyContext = function (context) {
                invariant$4(!!context.client, "Could not find \"client\" in the context of Mutation. Wrap the root component in an <ApolloProvider>");
            };
            _this.verifyContext(context);
            _this.client = context.client;
            _this.verifyDocumentIsMutation(props.mutation);
            _this.mostRecentMutationId = 0;
            _this.state = initialState;
            return _this;
        }
        Mutation.prototype.componentDidMount = function () {
            this.hasMounted = true;
        };
        Mutation.prototype.componentWillUnmount = function () {
            this.hasMounted = false;
        };
        Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (shallowEqual$1(this.props, nextProps) && this.client === nextContext.client) {
                return;
            }
            if (this.props.mutation !== nextProps.mutation) {
                this.verifyDocumentIsMutation(nextProps.mutation);
            }
            if (this.client !== nextContext.client) {
                this.client = nextContext.client;
                this.setState(initialState);
            }
        };
        Mutation.prototype.render = function () {
            var children = this.props.children;
            var _a = this.state, loading = _a.loading, data = _a.data, error = _a.error, called = _a.called;
            var result = {
                called: called,
                loading: loading,
                data: data,
                error: error,
            };
            return children(this.runMutation, result);
        };
        Mutation.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Mutation.propTypes = {
            mutation: PropTypes.object.isRequired,
            variables: PropTypes.object,
            optimisticResponse: PropTypes.object,
            refetchQueries: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.string),
                PropTypes.arrayOf(PropTypes.object),
                PropTypes.func,
            ]),
            update: PropTypes.func,
            children: PropTypes.func.isRequired,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
        };
        return Mutation;
    }(React.Component));

    var __extends$3 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var shallowEqual$2 = __webpack_require__("sgb3");
    var invariant$5 = __webpack_require__("crWv");
    var Subscription = (function (_super) {
        __extends$3(Subscription, _super);
        function Subscription(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.initialize = function (props) {
                if (_this.queryObservable)
                    return;
                _this.queryObservable = _this.client.subscribe({
                    query: props.subscription,
                    variables: props.variables,
                });
            };
            _this.startSubscription = function () {
                if (_this.querySubscription)
                    return;
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: _this.updateCurrentData,
                    error: _this.updateError,
                });
            };
            _this.getInitialState = function () { return ({
                loading: true,
                error: undefined,
                data: undefined,
            }); };
            _this.updateCurrentData = function (result) {
                _this.setState({
                    data: result.data,
                    loading: false,
                    error: undefined,
                });
            };
            _this.updateError = function (error) {
                _this.setState({
                    error: error,
                    loading: false,
                });
            };
            _this.endSubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            invariant$5(!!context.client, "Could not find \"client\" in the context of Subscription. Wrap the root component in an <ApolloProvider>");
            _this.client = context.client;
            _this.initialize(props);
            _this.state = _this.getInitialState();
            return _this;
        }
        Subscription.prototype.componentDidMount = function () {
            this.startSubscription();
        };
        Subscription.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (shallowEqual$2(this.props.variables, nextProps.variables) &&
                this.client === nextContext.client &&
                this.props.subscription === nextProps.subscription) {
                return;
            }
            var shouldResubscribe = nextProps.shouldResubscribe;
            if (typeof shouldResubscribe === 'function') {
                shouldResubscribe = !!shouldResubscribe(this.props, nextProps);
            }
            var shouldNotResubscribe = shouldResubscribe === false;
            if (this.client !== nextContext.client) {
                this.client = nextContext.client;
            }
            if (!shouldNotResubscribe) {
                this.endSubscription();
                delete this.queryObservable;
                this.initialize(nextProps);
                this.startSubscription();
                this.setState(this.getInitialState());
                return;
            }
            this.initialize(nextProps);
            this.startSubscription();
        };
        Subscription.prototype.componentWillUnmount = function () {
            this.endSubscription();
        };
        Subscription.prototype.render = function () {
            var result = Object.assign({}, this.state, {
                variables: this.props.variables,
            });
            return this.props.children(result);
        };
        Subscription.contextTypes = {
            client: PropTypes.object.isRequired,
        };
        Subscription.propTypes = {
            subscription: PropTypes.object.isRequired,
            variables: PropTypes.object,
            children: PropTypes.func.isRequired,
            shouldResubscribe: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        };
        return Subscription;
    }(React.Component));

    var __extends$4 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$6 = __webpack_require__("crWv");
    var defaultMapPropsToOptions = function () { return ({}); };
    var defaultMapPropsToSkip = function () { return false; };
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function calculateVariablesFromProps(operation, props, graphQLDisplayName, wrapperName) {
        var variables = {};
        for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
            var _b = _a[_i], variable = _b.variable, type = _b.type;
            if (!variable.name || !variable.name.value)
                continue;
            var variableName = variable.name.value;
            var variableProp = props[variableName];
            if (typeof variableProp !== 'undefined') {
                variables[variableName] = variableProp;
                continue;
            }
            if (type.kind !== 'NonNullType') {
                variables[variableName] = null;
                continue;
            }
            if (operation.type === DocumentType.Mutation)
                return;
            invariant$6(typeof variableProp !== 'undefined', "The operation '" + operation.name + "' wrapping '" + wrapperName + "' " +
                ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") +
                ("passed to '" + graphQLDisplayName + "'"));
        }
        return variables;
    }
    var GraphQLBase = (function (_super) {
        __extends$4(GraphQLBase, _super);
        function GraphQLBase(props) {
            var _this = _super.call(this, props) || this;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        GraphQLBase.prototype.getWrappedInstance = function () {
            invariant$6(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
            return this.wrappedInstance;
        };
        GraphQLBase.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        return GraphQLBase;
    }(React.Component));

    var __extends$5 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$2 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics = __webpack_require__("NMIb");
    function query(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$5(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Query, __assign$2({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document, warnUnhandledError: true }), function (_a) {
                        var _ = _a.client, data = _a.data, r = __rest$1(_a, ["client", "data"]);
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$2({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$2({}, props, childProps));
                        var _b, _c;
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$6 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$3 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var hoistNonReactStatics$1 = __webpack_require__("NMIb");
    function mutation(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$6(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var props = this.props;
                    var opts = mapPropsToOptions(props);
                    if (operationOptions.withRef) {
                        this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: this.setWrappedInstance,
                        });
                    }
                    if (!opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Mutation, __assign$3({}, opts, { mutation: document, ignoreResults: true }), function (mutate, _result) {
                        var name = operationOptions.name || 'mutate';
                        var childProps = (_a = {}, _a[name] = mutate, _a);
                        if (operationOptions.props) {
                            var newResult = (_b = {}, _b[name] = mutate, _b.ownProps = props, _b);
                            childProps = operationOptions.props(newResult);
                        }
                        return React.createElement(WrappedComponent, __assign$3({}, props, childProps));
                        var _a, _b;
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$1(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$7 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$4 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics$2 = __webpack_require__("NMIb");
    function subscribe(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$7(GraphQL, _super);
                function GraphQL(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = { resubscribe: false };
                    return _this;
                }
                GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
                    if (!shouldResubscribe)
                        return;
                    this.setState({
                        resubscribe: shouldResubscribe(this.props, nextProps),
                    });
                };
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Subscription, __assign$4({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                        var data = _a.data, r = __rest$2(_a, ["data"]);
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$4({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$4({}, props, childProps));
                        var _b, _c;
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$2(GraphQL, WrappedComponent, {});
        };
    }

    function graphql(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        switch (parser(document).type) {
            case DocumentType.Mutation:
                return mutation(document, operationOptions);
            case DocumentType.Subscription:
                return subscribe(document, operationOptions);
            case DocumentType.Query:
            default:
                return query(document, operationOptions);
        }
    }

    var __extends$8 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$5 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$7 = __webpack_require__("crWv");
    var hoistNonReactStatics$3 = __webpack_require__("NMIb");
    function getDisplayName$1(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function withApollo(WrappedComponent, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
        var WithApollo = (function (_super) {
            __extends$8(WithApollo, _super);
            function WithApollo(props) {
                var _this = _super.call(this, props) || this;
                _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
                return _this;
            }
            WithApollo.prototype.getWrappedInstance = function () {
                invariant$7(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
                return this.wrappedInstance;
            };
            WithApollo.prototype.setWrappedInstance = function (ref) {
                this.wrappedInstance = ref;
            };
            WithApollo.prototype.render = function () {
                var _this = this;
                return (React.createElement(ApolloConsumer, null, function (client) {
                    var props = Object.assign({}, _this.props, {
                        client: client,
                        ref: operationOptions.withRef ? _this.setWrappedInstance : undefined,
                    });
                    return React.createElement(WrappedComponent, __assign$5({}, props));
                }));
            };
            WithApollo.displayName = withDisplayName;
            WithApollo.WrappedComponent = WrappedComponent;
            return WithApollo;
        }(React.Component));
        return hoistNonReactStatics$3(WithApollo, WrappedComponent, {});
    }

    var compose = __webpack_require__("qojq");

    exports.compose = compose;
    exports.getDataFromTree = getDataFromTree;
    exports.ApolloConsumer = ApolloConsumer;
    exports.ApolloProvider = ApolloProvider;
    exports.Query = Query;
    exports.Mutation = Mutation;
    exports.Subscription = Subscription;
    exports.graphql = graphql;
    exports.withApollo = withApollo;
    exports.walkTree = walkTree;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-apollo.browser.umd.js.map


/***/ }),

/***/ "463A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__("0H+Z"));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__("kbQE"));

var _TransitionGroup = _interopRequireDefault(__webpack_require__("dUsL"));

var _Transition = _interopRequireDefault(__webpack_require__("AUPe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),

/***/ "4DQ7":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("hgbu");


/***/ }),

/***/ "4Xz7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("4fG1");

var _reactButtons = __webpack_require__("HfJ9");

var _MINUS__ = __webpack_require__("qyqb");

var _PLUS__ = __webpack_require__("nF8R");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuantitySelector = function (_Component) {
    _inherits(QuantitySelector, _Component);

    function QuantitySelector(props) {
        _classCallCheck(this, QuantitySelector);

        var _this = _possibleConstructorReturn(this, (QuantitySelector.__proto__ || Object.getPrototypeOf(QuantitySelector)).call(this, props));

        _this.handleA11y = _this.handleA11y.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.stepUp = _this.stepUp.bind(_this);
        _this.stepDown = _this.stepDown.bind(_this);
        return _this;
    }

    _createClass(QuantitySelector, [{
        key: 'stepUp',
        value: function stepUp() {
            var newValue = Number(this.props.value) + Number(this.props.step);

            if (newValue <= this.props.max) {
                this.handleChange(newValue);
            }
        }
    }, {
        key: 'stepDown',
        value: function stepDown() {
            var newValue = Number(this.props.value) - Number(this.props.step);

            if (newValue >= this.props.min) {
                this.handleChange(newValue);
            }
        }

        // handle a11y users editing the text using AT

    }, {
        key: 'handleA11y',
        value: function handleA11y() {
            var newValue = this.input.value;

            if (newValue >= this.props.min && newValue <= this.props.max) {
                this.handleChange(newValue);
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(newValue) {
            if (newValue > this.props.value) {
                this.props.onIncrement(newValue);
            } else {
                this.props.onDecrement(newValue);
            }
        }
    }, {
        key: 'renderLabelComponent',
        value: function renderLabelComponent() {
            var _props = this.props,
                label = _props.label,
                labelData = _props.labelData;

            var LabelComponent = label;

            return _react2.default.createElement(
                'span',
                { className: 'quantity-selector__custom-label' },
                _react2.default.createElement(LabelComponent, { data: labelData })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                id = _props2.id,
                label = _props2.label,
                labelData = _props2.labelData,
                min = _props2.min,
                max = _props2.max,
                value = _props2.value,
                decreaseLabel = _props2.decreaseLabel,
                increaseLabel = _props2.increaseLabel,
                className = _props2.className,
                onIncrement = _props2.onIncrement,
                onDecrement = _props2.onDecrement,
                disableInput = _props2.disableInput,
                rest = _objectWithoutProperties(_props2, ['id', 'label', 'labelData', 'min', 'max', 'value', 'decreaseLabel', 'increaseLabel', 'className', 'onIncrement', 'onDecrement', 'disableInput']); // eslint-disable-line no-unused-vars


            var selectorClasses = (0, _classnames2.default)('quantity-selector', className);
            var isLabelComponent = typeof label === 'function';

            return _react2.default.createElement(
                'div',
                _extends({ className: selectorClasses }, rest),
                _react2.default.createElement(
                    'label',
                    { 'aria-live': 'polite', className: 'quantity-selector__label', htmlFor: id },
                    isLabelComponent ? this.renderLabelComponent() : label,
                    _react2.default.createElement('input', { disabled: disableInput, type: 'number', min: min, max: max, ref: function ref(_ref) {
                            return _this2.input = _ref;
                        }, className: 'quantity-selector__input', id: id, value: value, onChange: this.handleA11y }),
                    _react2.default.createElement('div', { className: 'quantity-selector__focus-indicator bg-brand' })
                ),
                _react2.default.createElement(_reactButtons.ButtonIcon, { disabled: value === min, label: decreaseLabel, onClick: this.stepDown, className: 'quantity-selector__btn quantity-selector__btn--decrease', svgMarkup: _MINUS__.MINUS__16, circle: true }),
                _react2.default.createElement(_reactButtons.ButtonIcon, { disabled: value === max, label: increaseLabel, onClick: this.stepUp, className: 'quantity-selector__btn quantity-selector__btn--increase', svgMarkup: _PLUS__.PLUS__16, circle: true })
            );
        }
    }]);

    return QuantitySelector;
}(_react.Component);

QuantitySelector.propTypes = {
    /** id attribute for QuantitySelector, required for a11y */
    id: _propTypes2.default.string.isRequired,
    /** Label for the Quantity Selector (ex: 0 Children); This can be a string, element, or component. Required for a11y. */
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]).isRequired,
    /** Optional data required by custom label component */
    labelData: _propTypes2.default.shape({
        value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        label: _propTypes2.default.string
    }),
    /** value for the number input */
    value: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
    /** min attribute for the number input */
    min: _propTypes2.default.number,
    /** max attribute for the number input */
    max: _propTypes2.default.number,
    /** how much to increment/decrement per button click*/
    step: _propTypes2.default.number,
    /** Label for the Decrement Button, required for a11y */
    decreaseLabel: _propTypes2.default.string.isRequired,
    /** Label for the Increment Button, required for a11y */
    increaseLabel: _propTypes2.default.string.isRequired,
    /** event handler to fire when the number increases */
    onIncrement: _propTypes2.default.func.isRequired,
    /** event handler to fire when the number decreases */
    onDecrement: _propTypes2.default.func.isRequired,
    /** Boolean to disable the focus/underline/keyboard input functionality of the input field */
    disableInput: _propTypes2.default.bool
};
QuantitySelector.defaultProps = {
    value: 0,
    min: 0,
    max: 20,
    step: 1,
    disableInput: false
};
exports.default = QuantitySelector;
//# sourceMappingURL=QuantitySelector.js.map

/***/ }),

/***/ "4ZAL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ajQ":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("qs+f"), 'Object', { defineProperty: __webpack_require__("GCs6").f });


/***/ }),

/***/ "4dmN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c8Kh");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var hide = __webpack_require__("aLzV");
var has = __webpack_require__("x//u");
var Iterators = __webpack_require__("yYxz");
var $iterCreate = __webpack_require__("I7B8");
var setToStringTag = __webpack_require__("LhDF");
var getPrototypeOf = __webpack_require__("VD8v");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "4fG1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4pRd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AspectRatioCardTitle = exports.AspectRatioCardText = exports.AspectRatioCardImage = exports.AspectRatioCard = undefined;

var _AspectRatioCard = __webpack_require__("fPr/");

var _AspectRatioCard2 = _interopRequireDefault(_AspectRatioCard);

var _AspectRatioCardImage = __webpack_require__("BxE1");

var _AspectRatioCardImage2 = _interopRequireDefault(_AspectRatioCardImage);

var _AspectRatioCardText = __webpack_require__("Hqt+");

var _AspectRatioCardText2 = _interopRequireDefault(_AspectRatioCardText);

var _AspectRatioCardTitle = __webpack_require__("X0fC");

var _AspectRatioCardTitle2 = _interopRequireDefault(_AspectRatioCardTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AspectRatioCard = _AspectRatioCard2.default;
exports.AspectRatioCardImage = _AspectRatioCardImage2.default;
exports.AspectRatioCardText = _AspectRatioCardText2.default;
exports.AspectRatioCardTitle = _AspectRatioCardTitle2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "5183":
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__("bIbi");

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),

/***/ "5CEY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCalendarDataInstance = undefined;

var _calendarBase = __webpack_require__("lpBX");

var _instances = {};

/**
 * Utility to cache the calendar data instance so
 * that we can include it in multiple files and not
 * have to re-instantiate it.
**/

function CalendarData(siblingMonths) {
    this.calendarData = new _calendarBase.Calendar({ siblingMonths: siblingMonths });
}

CalendarData.prototype.setProperty = function (name, value) {
    this.calendarData[name] = value;
};

CalendarData.prototype.getMonth = function (year, month) {
    return this.calendarData.getCalendar(year, month);
};

function getCalendarDataInstance(siblingMonths) {
    var hash = siblingMonths ? 'siblingMonths' : 'noSiblingMonths';
    if (!_instances[hash]) {
        _instances[hash] = new CalendarData(siblingMonths);
    }
    return _instances[hash];
}

exports.getCalendarDataInstance = getCalendarDataInstance;
//# sourceMappingURL=CalendarData.js.map

/***/ }),

/***/ "5DDM":
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__("2VmA"),
    getData = __webpack_require__("wKps"),
    getFuncName = __webpack_require__("K96V"),
    lodash = __webpack_require__("6xqu");

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),

/***/ "5Du6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5HME":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = emitGuestPickerEvent;

var _debug = __webpack_require__("HgRV");

function emitGuestPickerEvent() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Debug message
    /* istanbul ignore next */
    if ((0, _debug.isLocal)()) {
        console.log('raise generic edap event - ', options); //eslint-disable-line
    }

    // If edap does not exist, define array so overloaded push() method can raise event
    window.edap = window.edap || [];
    window.edap.push(function (edap) {
        edap.trigger('generic.event', options);
    });
}
//# sourceMappingURL=edap.js.map

/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("tYO1"), __esModule: true };

/***/ }),

/***/ "5WWy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _TooltipPositioner = __webpack_require__("+urU");

var _TooltipPositioner2 = _interopRequireDefault(_TooltipPositioner);

var _utils = __webpack_require__("TINw");

var _rafOptimized = __webpack_require__("pick");

__webpack_require__("9fOB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
    _inherits(Tooltip, _Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.addEventListeners = function () {
            // @homeaway/raf-optimized resize returns a callback to remove the event listener
            // https://github.homeawaycorp.com/traveler/raf-optimized/blob/8f607c662b99f6da33724b3c563e97eba86ef740/src/index.js#L163
            _this.removeResizeEventListener = (0, _rafOptimized.resize)(_this.adjustPositioning);

            if (_this.props.closeOnOutsideClick) {
                window.document.addEventListener('mouseup', _this.handleOutsideMouseClick);
                window.document.addEventListener('touchstart', _this.handleOutsideMouseClick);
            }
        };

        _this.detachEventListeners = function () {
            _this.removeResizeEventListener();

            if (_this.props.closeOnOutsideClick) {
                window.document.removeEventListener('mouseup', _this.handleOutsideMouseClick);
                window.document.removeEventListener('touchstart', _this.handleOutsideMouseClick);
            }

            if (_this.removeNodeScrollListener) {
                _this.removeNodeScrollListener();
                _this.removeNodeScrollListener = null;
            }

            if (_this.removeWindowScrollListener) {
                _this.removeWindowScrollListener();
                _this.removeWindowScrollListener = null;
            }
        };

        _this.adjustPositioning = function () {
            if (_this.tooltip && _this.state.displayTooltip) {
                _this.tooltipPositioner = _this.initTooltipPositioner();
                var tooltipDOM = (0, _reactDom.findDOMNode)(_this.tooltip);

                var _this$tooltipPosition = _this.tooltipPositioner.getPositions(),
                    tooltipPosition = _this$tooltipPosition.tooltipPosition,
                    arrowPosition = _this$tooltipPosition.arrowPosition;

                // Change className without triggering rerender
                // TODO: refactor this so the render function is the only
                // method setting the className


                tooltipDOM.className = _this.getTooltipClassName();

                // Tooltip changes widths after it's repositioned.
                // Force it to stay the same so positioning is correct
                tooltipDOM.style.width = tooltipPosition.width + 'px';
                tooltipDOM.style.left = tooltipPosition.left + 'px';
                tooltipDOM.style.top = tooltipPosition.top + 'px';

                _this.tooltipArrow.style.top = arrowPosition.top;
                _this.tooltipArrow.style.left = arrowPosition.left;
            }
        };

        _this.clearTimeouts = function () {
            if (_this.closeTimeoutId !== null) {
                clearTimeout(_this.closeTimeoutId);
                _this.closeTimeoutId = null;
            }

            if (_this.delayHideTimeoutId !== null) {
                clearTimeout(_this.delayHideTimeoutId);
                _this.delayHideTimeoutId = null;
            }

            if (_this.delayShowTimeoutId !== null) {
                clearTimeout(_this.delayShowTimeoutId);
                _this.delayShowTimeoutId = null;
            }
        };

        _this.handleFocus = function (e) {
            _this.props.onFocus(e);
            _this.handleOpen(e);
        };

        _this.handleOpen = function (e) {
            if (_this.props.trigger === 'none') {
                return;
            }

            var eventType = e.type === 'mouseover' ? 'hover' : e.type;

            // only trigger openPortal for specified triggers
            if (_this.props.trigger.indexOf(eventType) !== -1) {
                var targetContainer = _this.props.parentNode ? _this.tooltip : _this.container;
                // close on second click
                if (eventType === 'click' && _this.state.displayTooltip && targetContainer && !targetContainer.contains(e.target)) {
                    _this.handleClose(e);
                    return;
                }

                // set up a persist state so only a click can close tooltip
                if (eventType === 'click') {
                    _this.setState({
                        persist: true
                    });
                }

                _this.clearTimeouts();

                _this.delayShowTimeoutId = setTimeout(function () {
                    _this.displayTooltip();
                }, _this.props.delayShow);
            }
        };

        _this.handleClose = function (e) {
            if (_this.props.trigger === 'none') {
                return;
            }

            if (!_this.state.persist) {
                _this.clearTimeouts();
                _this.delayHideTimeoutId = setTimeout(function () {
                    _this.fadeAndClose();
                }, _this.props.delayHide);
            } else if (e.type === 'click') {
                _this.fadeAndClose();
            }
        };

        _this.handleOutsideMouseClick = function (e) {
            var targetContainer = _this.props.parentNode ? _this.tooltip : _this.container;
            if (_this.state.displayTooltip && _this.props.closeOnOutsideClick && targetContainer && !targetContainer.contains(e.target)) {
                _this.fadeAndClose();
            }
        };

        _this.handleKeydown = function (e) {
            if (e.keyCode === _this.KEYCODES.ESCAPE && _this.state.displayTooltip) {
                _this.fadeAndClose();
            }
        };

        _this.displayTooltip = function () {
            _this.setState({
                displayTooltip: true
            });

            _this.props.onOpen();
        };

        _this.closeTooltip = function () {
            _this.setState({
                displayTooltip: false
            });

            _this.props.onClose();
        };

        _this.closeTimeoutId = null;
        _this.delayHideTimeoutId = null;
        _this.delayShowTimeoutId = null;
        _this.removeResizeEventListener = Function.prototype; // Noop
        _this.contentId = null;

        _this.state = {
            persist: false,
            displayTooltip: false
        };

        _this.KEYCODES = {
            ESCAPE: 27
        };
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.contentId = Math.floor(Math.random() * 1000);

            if (this.props.isOpen) {
                this.displayTooltip();
            }

            this.addEventListeners();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isOpen !== this.props.isOpen) {
                if (nextProps.isOpen) {
                    this.displayTooltip();
                } else {
                    this.fadeAndClose();
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var displayChanged = prevState.displayTooltip !== this.state.displayTooltip;
            this.adjustPositioning();

            // If the tooltip needs to scroll independent of the browser window,
            // listen to scroll events on the specified scrollNode and the browser
            // window to adjust positioning appropriately.
            if (displayChanged && "object" !== 'undefined' && this.state.displayTooltip && this.props.parentNode && this.props.scrollNode) {
                // Setup listeners when tooltip is displayed.
                this.removeNodeScrollListener = (0, _rafOptimized.addThrottleHandler)('scroll', this.adjustPositioning, this.props.scrollNode);
                this.removeWindowScrollListener = (0, _rafOptimized.scroll)(this.adjustPositioning);
            }

            if (displayChanged && !this.state.displayTooltip) {
                // Remove listeners when tooltip is hidden.
                if (this.removeNodeScrollListener) {
                    this.removeNodeScrollListener();
                    this.removeNodeScrollListener = null;
                }
                if (this.removeWindowScrollListener) {
                    this.removeWindowScrollListener();
                    this.removeWindowScrollListener = null;
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
            this.detachEventListeners();
        }
    }, {
        key: 'initTooltipPositioner',
        value: function initTooltipPositioner() {
            return new _TooltipPositioner2.default(this.props, this.container, this.tooltip);
        }
    }, {
        key: 'getTooltipClassName',
        value: function getTooltipClassName() {
            var tooltipType = this.props.tooltipType;
            var placement = this.tooltipPositioner ? this.tooltipPositioner.getSafePlacement() : this.props.placement;

            return (0, _classnames2.default)(this.props.portalClassName, 'Tooltip Tooltip--' + placement, {
                // Checks for tooltip and tooltip-lg
                'Tooltip--popover': tooltipType === 'popover',
                'Tooltip--lg': tooltipType === 'tooltip--lg' || tooltipType === 'popover',
                'in': this.state.displayTooltip
            }, 'fade');
        }
    }, {
        key: 'fadeAndClose',


        /* wait for fade out animation to occur, then remove from DOM */
        value: function fadeAndClose() {
            var _this2 = this;

            var tooltipDOM = (0, _reactDom.findDOMNode)(this.tooltip);

            if (tooltipDOM) {
                tooltipDOM.className = tooltipDOM.className.replace('in ', '');
            }

            this.clearTimeouts();

            this.closeTimeoutId = setTimeout(function () {
                _this2.closeTooltip();
            }, this.props.fadeOutDuration);
        }
    }, {
        key: 'renderTooltipContent',


        // Helper method to render the tooltip content. Separated from the main
        // render method since it can be rendered inside and outside of a portal.
        value: function renderTooltipContent(content, title, tooltipType, interactiveContent, rest) {
            var _this3 = this;

            var isPopover = tooltipType === 'popover';
            var role = 'status';

            if (interactiveContent || isPopover) {
                role = 'dialog';
            }

            var props = _extends({
                ref: /* istanbul ignore next */function ref(c) {
                    return _this3.tooltip = c;
                }
            }, rest, {
                style: {
                    display: 'block'
                },
                className: this.getTooltipClassName(),
                role: role
            });

            if (this.state.displayTooltip && this.contentId !== null) {
                props.id = 'tipContent-' + this.contentId;
                props['aria-live'] = interactiveContent ? 'off' : 'polite';
            }

            return _react2.default.createElement(
                'span',
                props,
                _react2.default.createElement('span', {
                    className: 'Tooltip__arrow',
                    ref:
                    /* istanbul ignore next */
                    function ref(c) {
                        return _this3.tooltipArrow = c;
                    }
                }),
                isPopover && title && _react2.default.createElement(
                    'span',
                    { className: 'Tooltip__title' },
                    title
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'Tooltip__inner' },
                    content
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                fadeOutDuration = _props.fadeOutDuration,
                tooltipType = _props.tooltipType,
                title = _props.title,
                placement = _props.placement,
                content = _props.content,
                delayHide = _props.delayHide,
                delayShow = _props.delayShow,
                openByClickOn = _props.openByClickOn,
                isOpen = _props.isOpen,
                wrappingMethod = _props.wrappingMethod,
                wrapperClassName = _props.wrapperClassName,
                wrapperStyle = _props.wrapperStyle,
                portalClassName = _props.portalClassName,
                parentNode = _props.parentNode,
                trigger = _props.trigger,
                onOpen = _props.onOpen,
                onClose = _props.onClose,
                centered = _props.centered,
                closeOnOutsideClick = _props.closeOnOutsideClick,
                scrollNode = _props.scrollNode,
                interactiveContent = _props.interactiveContent,
                interactiveContainer = _props.interactiveContainer,
                rest = _objectWithoutProperties(_props, ['fadeOutDuration', 'tooltipType', 'title', 'placement', 'content', 'delayHide', 'delayShow', 'openByClickOn', 'isOpen', 'wrappingMethod', 'wrapperClassName', 'wrapperStyle', 'portalClassName', 'parentNode', 'trigger', 'onOpen', 'onClose', 'centered', 'closeOnOutsideClick', 'scrollNode', 'interactiveContent', 'interactiveContainer']); // eslint-disable-line no-unused-vars

            // This helps preserve the bounds of the this.props.children


            var wrapStyle = _extends({ display: wrappingMethod, outline: 0, position: 'relative' }, wrapperStyle);
            var usePortal = parentNode && "object" !== 'undefined';
            var props = {
                ref: /* istanbul ignore next */function ref(c) {
                    return _this4.container = c;
                },
                className: wrapperClassName,
                style: wrapStyle,
                onMouseOver: this.handleOpen,
                onMouseLeave: this.handleClose,
                onFocus: this.handleFocus,
                onBlur: this.handleClose,
                onClick: this.handleOpen,
                onKeyDown: this.handleKeydown,
                role: interactiveContainer ? 'presentation' : 'button',
                tabIndex: interactiveContainer ? null : '0'
            };

            if (this.state.displayTooltip && this.contentId !== null) {
                props['aria-controls'] = 'tipContent-' + this.contentId;
            }

            return _react2.default.createElement(
                'span',
                props,
                this.props.children,
                this.state.displayTooltip && !usePortal && this.renderTooltipContent(content, title, tooltipType, interactiveContent, rest),
                this.state.displayTooltip && usePortal && _reactDom2.default.createPortal(this.renderTooltipContent(content, title, tooltipType, interactiveContent, rest), parentNode)
            );
        }
    }]);

    return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
    /** Delay closing the tooltip in milliseconds */
    delayHide: _propTypes2.default.number,
    /** Delay opening the tooltip in milliseconds */
    delayShow: _propTypes2.default.number,
    /** Duration of the fade transition when the tooltip closes in milliseconds */
    fadeOutDuration: _propTypes2.default.number,
    /** Content of the Tooltip */
    content: _propTypes2.default.node.isRequired,
    /** If using your own state to control the visibility of the Tooltip, rather than providing an
        openByClickOn element or children, you will set the isOpen property. Also set the trigger to "none".  */
    isOpen: _propTypes2.default.bool,
    /** The function to call when the tooltip closes */
    onClose: _propTypes2.default.func,
    /** Callback for when the tooltip gains focus */
    onFocus: _propTypes2.default.func,
    /** The function to call when the tooltip opens */
    onOpen: _propTypes2.default.func,
    /** The element to attach an event listener that opens the Tooltip */
    openByClickOn: _propTypes2.default.element,
    /** How to position the tooltip */
    placement: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right']),
    /** Whether to center the tooltip to its content or allow for the default offset */
    centered: _propTypes2.default.bool,
    /** The DOM element to use as the parent for the tooltip when visible. This is useful in scenarios where the tooltip needs to break out of its current container due to overflow or z-index issues. */
    parentNode: _utils.checkElementType,
    /** Allows you to add a classname to the popover/tooltip for custom styling */
    portalClassName: _propTypes2.default.string,
    /** The DOM element that the tooltip needs to scroll with. Only specify this if parentNode was specified and the tooltip is displayed in a container that is scrollable independent of the browser window. */
    scrollNode: _utils.checkElementType,
    /** Tooltip Title, used only in tooltipType === 'popover' */
    title: _propTypes2.default.node,
    /** Type of Tooltip (Tooltip, Popover, Large Tooltip) to display */
    tooltipType: _propTypes2.default.oneOf(['tooltip', 'popover', 'tooltip--lg']),
    /** How tooltip is triggered: click | hover | focus | none. You may pass multiple triggers; separate them with a space. Set this to "none" if you are controlling the tooltip/popover visibility externally using the "isOpen" property. */
    trigger: _propTypes2.default.string,
    /** className prop to pass to the wrapper div. Defaults to an empty string. */
    wrapperClassName: _propTypes2.default.string,
    /** style prop to pass to the wrapper div. Defaults to an empty object. */
    wrapperStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** If the element that you are applying the tooltip to is a block element, switch the wrappingMethod from its default to 'block'.
      * This prop is left for compatibility with older versions and the display value may be overridden with `wrapperStyle` instead. */
    wrappingMethod: _propTypes2.default.oneOf(['inline-block', 'block']),
    /** Boolean to determine whether the tooltip will close if the user clicks outside of the tooltip. */
    closeOnOutsideClick: _propTypes2.default.bool,
    /** Flag to use when Tooltip content contains elements that are interactive. This will remove the default `aria-live` attribute and `tabindex`. As a result, it will prevent aria-live from causing a screen reader to read out all elements within a Tooltip (ex: a calendar) when it opens. Defaults to false.*/
    interactiveContent: _propTypes2.default.bool,
    /** Flag to use when a Tooltip is used on an element that can receive its own focus. This will remove the `role="button"` attribute and `tabindex` from the span wrapper. Ie: When using a Button, FormInput, etc. */
    interactiveContainer: _propTypes2.default.bool
};
Tooltip.defaultProps = {
    content: '',
    delayHide: 0,
    delayShow: 0,
    // The current fade out transition time
    // in Baseline is 350ms so am setting this
    // slightly earlier to prevent being able
    // to mouse over tooltip after it's faded to 0 opacity
    // but still exists in DOM, which causes a flicker.
    fadeOutDuration: 340,
    isOpen: false,
    onClose: function onClose() {},
    onFocus: function onFocus() {},
    onOpen: function onOpen() {},
    placement: 'top',
    centered: false,
    tooltipType: 'tooltip',
    trigger: 'hover focus',
    wrapperClassName: '',
    wrapperStyle: {},
    wrappingMethod: 'inline-block',
    closeOnOutsideClick: true,
    interactiveContent: false,
    interactiveContainer: false
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map

/***/ }),

/***/ "5Xbz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blockStringValue;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = null;

  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);

    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;

      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }

  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  } // Return a string of the lines joined with U+000A.


  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;

  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }

  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),

/***/ "6RRl":
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__("2VmA"),
    LodashWrapper = __webpack_require__("6o+p"),
    copyArray = __webpack_require__("hrPF");

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),

/***/ "6aXM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6fpj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syntaxError = syntaxError;

var _GraphQLError = __webpack_require__("QmgZ");

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
function syntaxError(source, position, description) {
  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

/***/ }),

/***/ "6nsg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6o+p":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("VORN"),
    baseLodash = __webpack_require__("KMSM");

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),

/***/ "6rdy":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "6tLb":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("ksFB");
var gOPN = __webpack_require__("2m2c").f;
var toString = {}.toString;

var windowNames = "object" == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "6u75":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;
exports.parseConstValue = parseConstValue;
exports.parseTypeReference = parseTypeReference;
exports.parseNamedType = parseNamedType;

var _inspect = _interopRequireDefault(__webpack_require__("ieo+"));

var _source = __webpack_require__("gyRD");

var _error = __webpack_require__("Qhe+");

var _lexer = __webpack_require__("AxoS");

var _kinds = __webpack_require__("Jko5");

var _directiveLocation = __webpack_require__("nC2W");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;

  if (!(sourceObj instanceof _source.Source)) {
    throw new TypeError("Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
  }

  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  return parseDocument(lexer);
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */


function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  expect(lexer, _lexer.TokenKind.SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, _lexer.TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */


function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  expect(lexer, _lexer.TokenKind.SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, _lexer.TokenKind.EOF);
  return type;
}
/**
 * Converts a name lex token into a name parse node.
 */


function parseName(lexer) {
  var token = expect(lexer, _lexer.TokenKind.NAME);
  return {
    kind: _kinds.Kind.NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
} // Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */


function parseDocument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.DOCUMENT,
    definitions: many(lexer, _lexer.TokenKind.SOF, parseDefinition, _lexer.TokenKind.EOF),
    loc: loc(lexer, start)
  };
}
/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 *   - TypeSystemExtension
 */


function parseDefinition(lexer) {
  if (peek(lexer, _lexer.TokenKind.NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);

      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'directive':
        return parseTypeSystemDefinition(lexer);

      case 'extend':
        return parseTypeSystemExtension(lexer);
    }
  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}
/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */


function parseExecutableDefinition(lexer) {
  if (peek(lexer, _lexer.TokenKind.NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
} // Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */


function parseOperationDefinition(lexer) {
  var start = lexer.token;

  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return {
      kind: _kinds.Kind.OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }

  var operation = parseOperationType(lexer);
  var name;

  if (peek(lexer, _lexer.TokenKind.NAME)) {
    name = parseName(lexer);
  }

  return {
    kind: _kinds.Kind.OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * OperationType : one of query mutation subscription
 */


function parseOperationType(lexer) {
  var operationToken = expect(lexer, _lexer.TokenKind.NAME);

  switch (operationToken.value) {
    case 'query':
      return 'query';

    case 'mutation':
      return 'mutation';

    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}
/**
 * VariableDefinitions : ( VariableDefinition+ )
 */


function parseVariableDefinitions(lexer) {
  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
 */


function parseVariableDefinition(lexer) {
  var start = lexer.token;

  if (lexer.options.experimentalVariableDefinitionDirectives) {
    return {
      kind: _kinds.Kind.VARIABLE_DEFINITION,
      variable: parseVariable(lexer),
      type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
      defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
      directives: parseDirectives(lexer, true),
      loc: loc(lexer, start)
    };
  }

  return {
    kind: _kinds.Kind.VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    loc: loc(lexer, start)
  };
}
/**
 * Variable : $ Name
 */


function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.DOLLAR);
  return {
    kind: _kinds.Kind.VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * SelectionSet : { Selection+ }
 */


function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.SELECTION_SET,
    selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
    loc: loc(lexer, start)
  };
}
/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */


function parseSelection(lexer) {
  return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
}
/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */


function parseField(lexer) {
  var start = lexer.token;
  var nameOrAlias = parseName(lexer);
  var alias;
  var name;

  if (skip(lexer, _lexer.TokenKind.COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: _kinds.Kind.FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}
/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */


function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, item, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * Argument[Const] : Name : Value[?Const]
 */


function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */


function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.SPREAD);

  if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== 'on') {
    return {
      kind: _kinds.Kind.FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }

  var typeCondition;

  if (lexer.token.value === 'on') {
    lexer.advance();
    typeCondition = parseNamedType(lexer);
  }

  return {
    kind: _kinds.Kind.INLINE_FRAGMENT,
    typeCondition: typeCondition,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */


function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment'); // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: _kinds.Kind.FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }

  return {
    kind: _kinds.Kind.FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * FragmentName : Name but not `on`
 */


function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }

  return parseName(lexer);
} // Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */


function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;

  switch (token.kind) {
    case _lexer.TokenKind.BRACKET_L:
      return parseList(lexer, isConst);

    case _lexer.TokenKind.BRACE_L:
      return parseObject(lexer, isConst);

    case _lexer.TokenKind.INT:
      lexer.advance();
      return {
        kind: _kinds.Kind.INT,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.FLOAT:
      lexer.advance();
      return {
        kind: _kinds.Kind.FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.STRING:
    case _lexer.TokenKind.BLOCK_STRING:
      return parseStringLiteral(lexer);

    case _lexer.TokenKind.NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: _kinds.Kind.BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: _kinds.Kind.NULL,
          loc: loc(lexer, token)
        };
      }

      lexer.advance();
      return {
        kind: _kinds.Kind.ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }

      break;
  }

  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: _kinds.Kind.STRING,
    value: token.value,
    block: token.kind === _lexer.TokenKind.BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}
/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */


function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: _kinds.Kind.LIST,
    values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
    loc: loc(lexer, start)
  };
}
/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */


function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.BRACE_L);
  var fields = [];

  while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }

  return {
    kind: _kinds.Kind.OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectField[Const] : Name : Value[?Const]
 */


function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */


function parseDirectives(lexer, isConst) {
  var directives = [];

  while (peek(lexer, _lexer.TokenKind.AT)) {
    directives.push(parseDirective(lexer, isConst));
  }

  return directives;
}
/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */


function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.AT);
  return {
    kind: _kinds.Kind.DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */


function parseTypeReference(lexer) {
  var start = lexer.token;
  var type;

  if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, _lexer.TokenKind.BRACKET_R);
    type = {
      kind: _kinds.Kind.LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }

  if (skip(lexer, _lexer.TokenKind.BANG)) {
    return {
      kind: _kinds.Kind.NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }

  return type;
}
/**
 * NamedType : Name
 */


function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */


function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === _lexer.TokenKind.NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);

      case 'scalar':
        return parseScalarTypeDefinition(lexer);

      case 'type':
        return parseObjectTypeDefinition(lexer);

      case 'interface':
        return parseInterfaceTypeDefinition(lexer);

      case 'union':
        return parseUnionTypeDefinition(lexer);

      case 'enum':
        return parseEnumTypeDefinition(lexer);

      case 'input':
        return parseInputObjectTypeDefinition(lexer);

      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, _lexer.TokenKind.STRING) || peek(lexer, _lexer.TokenKind.BLOCK_STRING);
}
/**
 * Description : StringValue
 */


function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}
/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */


function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
  return {
    kind: _kinds.Kind.SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}
/**
 * OperationTypeDefinition : OperationType : NamedType
 */


function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseNamedType(lexer);
  return {
    kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}
/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */


function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */


function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */


function parseImplementsInterfaces(lexer) {
  var types = [];

  if (lexer.token.value === 'implements') {
    lexer.advance(); // Optional leading ampersand

    skip(lexer, _lexer.TokenKind.AMP);

    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, _lexer.TokenKind.AMP) || // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, _lexer.TokenKind.NAME));
  }

  return types;
}
/**
 * FieldsDefinition : { FieldDefinition+ }
 */


function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, _lexer.TokenKind.BRACE_L) && lexer.lookahead().kind === _lexer.TokenKind.BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }

  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */


function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */


function parseArgumentDefs(lexer) {
  if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
    return [];
  }

  return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
}
/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */


function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseTypeReference(lexer);
  var defaultValue;

  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }

  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */


function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */


function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: _kinds.Kind.UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}
/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */


function parseUnionMemberTypes(lexer) {
  var types = [];

  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
    // Optional leading pipe
    skip(lexer, _lexer.TokenKind.PIPE);

    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, _lexer.TokenKind.PIPE));
  }

  return types;
}
/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */


function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}
/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */


function parseEnumValuesDefinition(lexer) {
  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */


function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */


function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */


function parseInputFieldsDefinition(lexer) {
  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * TypeSystemExtension :
 *   - SchemaExtension
 *   - TypeExtension
 *
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */


function parseTypeSystemExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === _lexer.TokenKind.NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaExtension(lexer);

      case 'scalar':
        return parseScalarTypeExtension(lexer);

      case 'type':
        return parseObjectTypeExtension(lexer);

      case 'interface':
        return parseInterfaceTypeExtension(lexer);

      case 'union':
        return parseUnionTypeExtension(lexer);

      case 'enum':
        return parseEnumTypeExtension(lexer);

      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}
/**
 * SchemaExtension :
 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
 *  - extend schema Directives[Const]
 */


function parseSchemaExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R) : [];

  if (directives.length === 0 && operationTypes.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.SCHEMA_EXTENSION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}
/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */


function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);

  if (directives.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */


function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);

  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */


function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);

  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */


function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);

  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}
/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */


function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);

  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}
/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */


function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);

  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */


function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, _lexer.TokenKind.AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: _kinds.Kind.DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}
/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */


function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, _lexer.TokenKind.PIPE);
  var locations = [];

  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, _lexer.TokenKind.PIPE));

  return locations;
}
/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */


function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);

  if (_directiveLocation.DirectiveLocation.hasOwnProperty(name.value)) {
    return name;
  }

  throw unexpected(lexer, start);
} // Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */


function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
  return {
    start: this.start,
    end: this.end
  };
};
/**
 * Determines if the next token is of a given kind
 */


function peek(lexer, kind) {
  return lexer.token.kind === kind;
}
/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */


function skip(lexer, kind) {
  var match = lexer.token.kind === kind;

  if (match) {
    lexer.advance();
  }

  return match;
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */


function expect(lexer, kind) {
  var token = lexer.token;

  if (token.kind === kind) {
    lexer.advance();
    return token;
  }

  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */


function expectKeyword(lexer, value) {
  var token = lexer.token;

  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
    lexer.advance();
    return token;
  }

  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */


function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return (0, _error.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */


function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];

  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }

  return nodes;
}
/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */


function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];

  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }

  return nodes;
}

/***/ }),

/***/ "6xqu":
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__("2VmA"),
    LodashWrapper = __webpack_require__("6o+p"),
    baseLodash = __webpack_require__("KMSM"),
    isArray = __webpack_require__("NGEn"),
    isObjectLike = __webpack_require__("UnEC"),
    wrapperClone = __webpack_require__("6RRl");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),

/***/ "72mj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_d3276433b58c8a2853f4
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_d3276433b58c8a2853f4
var prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/classnames/index.js from dll-reference vendor_d3276433b58c8a2853f4
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("HW6M");
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-unveil/lib/transpiled/index.js
var transpiled = __webpack_require__("kSlA");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitThumbnails/HitThumbnail/HitThumbnail.js






function HitThumbnail(_ref) {
    var galleryUrl = _ref.galleryUrl,
        url = _ref.url,
        className = _ref.className;

    var classname = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('card__figure scratchpad-hit-wrapper', className);
    var imageUrl = url || galleryUrl;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        transpiled["Unveil"],
        {
            className: classname,
            offset: 500
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
            className: 'scratchpad-hit-thumbnail component--translucent',
            style: { backgroundImage: 'url(' + imageUrl + ')' }
        })
    );
}

HitThumbnail.propTypes = {
    className: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    galleryUrl: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    url: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitThumbnail_HitThumbnail = (HitThumbnail);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitThumbnails/HitAddedTag/HitAddedTag.js



function HitAddedTag(_ref) {
    var addedTime = _ref.addedTime;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        {
            className: 'scratchpad-hit-added-tag label label-default'
        },
        addedTime
    );
}

HitAddedTag.propTypes = {
    addedTime: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitAddedTag_HitAddedTag = (HitAddedTag);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitThumbnails/HitThumbnails.js






function HitThumbnails(_ref) {
    var addedTime = _ref.addedTime,
        gallery = _ref.gallery,
        galleryUrl = _ref.galleryUrl,
        miniHit = _ref.miniHit,
        spu = _ref.spu,
        thumbnailUrl1 = _ref.thumbnailUrl1,
        thumbnailUrl2 = _ref.thumbnailUrl2,
        thumbnailUrl3 = _ref.thumbnailUrl3;

    var addedTag = null;

    if (miniHit) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: 'card__imgs scratchpad-thumbnails'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitThumbnail_HitThumbnail, {
                galleryUrl: galleryUrl,
                spu: spu,
                url: thumbnailUrl1
            })
        );
    }

    if (gallery && addedTime) {
        addedTag = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitAddedTag_HitAddedTag, {
            addedTime: addedTime
        });
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        {
            className: 'card__imgs scratchpad-thumbnails'
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitThumbnail_HitThumbnail, {
            galleryUrl: galleryUrl,
            spu: spu,
            url: thumbnailUrl1
        }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitThumbnail_HitThumbnail, {
            galleryUrl: galleryUrl,
            spu: spu,
            url: thumbnailUrl2,
            className: 'hidden-xs hidden-gallery hidden-mini'
        }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitThumbnail_HitThumbnail, {
            galleryUrl: galleryUrl,
            spu: spu,
            url: thumbnailUrl3,
            className: 'hidden-xs hidden-gallery hidden-mini'
        }),
        addedTag
    );
}

HitThumbnails.propTypes = {
    addedTime: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    gallery: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    galleryUrl: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    miniHit: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool.isRequired,
    spu: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    thumbnailUrl1: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    thumbnailUrl2: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    thumbnailUrl3: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitThumbnails_HitThumbnails = __webpack_exports__["default"] = (HitThumbnails);

/***/ }),

/***/ "7610":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("GiK3");
var PropTypes = __webpack_require__("KSGD");
var DetectPassiveEvents = __webpack_require__("qngo").default;

function getInitialState() {
  return {
    x: null,
    y: null,
    swiping: false,
    start: 0
  };
}

function getMovingPosition(e) {
  return 'changedTouches' in e ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY } : { x: e.clientX, y: e.clientY };
}
function getPosition(e) {
  return 'touches' in e ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
}

function calculatePos(e, state) {
  var _getMovingPosition = getMovingPosition(e),
      x = _getMovingPosition.x,
      y = _getMovingPosition.y;

  var deltaX = state.x - x;
  var deltaY = state.y - y;

  var absX = Math.abs(deltaX);
  var absY = Math.abs(deltaY);

  var time = Date.now() - state.start;
  var velocity = Math.sqrt(absX * absX + absY * absY) / time;

  return { deltaX: deltaX, deltaY: deltaY, absX: absX, absY: absY, velocity: velocity };
}

var Swipeable = function (_React$Component) {
  _inherits(Swipeable, _React$Component);

  function Swipeable(props, context) {
    _classCallCheck(this, Swipeable);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.eventStart = _this.eventStart.bind(_this);
    _this.eventMove = _this.eventMove.bind(_this);
    _this.eventEnd = _this.eventEnd.bind(_this);
    _this.mouseDown = _this.mouseDown.bind(_this);
    _this.mouseMove = _this.mouseMove.bind(_this);
    _this.mouseUp = _this.mouseUp.bind(_this);
    _this.cleanupMouseListeners = _this.cleanupMouseListeners.bind(_this);
    _this.setupMouseListeners = _this.setupMouseListeners.bind(_this);
    _this.elementRef = _this.elementRef.bind(_this);
    _this.setupTouchmoveEvent = _this.setupTouchmoveEvent.bind(_this);
    _this.cleanupTouchmoveEvent = _this.cleanupTouchmoveEvent.bind(_this);
    _this.hasPassiveSupport = DetectPassiveEvents.hasSupport;
    return _this;
  }

  Swipeable.prototype.componentWillMount = function componentWillMount() {
    this.swipeable = getInitialState();
  };

  Swipeable.prototype.componentDidMount = function componentDidMount() {
    if (this.props.preventDefaultTouchmoveEvent) {
      this.setupTouchmoveEvent();
    }
  };

  Swipeable.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled !== this.props.disabled) {
      this.cleanupMouseListeners();

      this.swipeable = getInitialState();
    }

    if (prevProps.preventDefaultTouchmoveEvent && !this.props.preventDefaultTouchmoveEvent) {
      this.cleanupTouchmoveEvent();
    } else if (!prevProps.preventDefaultTouchmoveEvent && this.props.preventDefaultTouchmoveEvent) {
      this.setupTouchmoveEvent();
    }
  };

  Swipeable.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cleanupMouseListeners();
  };

  Swipeable.prototype.setupTouchmoveEvent = function setupTouchmoveEvent() {
    if (this.element && this.hasPassiveSupport) {
      this.element.addEventListener('touchmove', this.eventMove, { passive: false });
    }
  };

  Swipeable.prototype.setupMouseListeners = function setupMouseListeners() {
    document.addEventListener('mousemove', this.mouseMove);
    document.addEventListener('mouseup', this.mouseUp);
  };

  Swipeable.prototype.cleanupTouchmoveEvent = function cleanupTouchmoveEvent() {
    if (this.element && this.hasPassiveSupport) {
      this.element.removeEventListener('touchmove', this.eventMove, { passive: false });
    }
  };

  Swipeable.prototype.cleanupMouseListeners = function cleanupMouseListeners() {
    document.removeEventListener('mousemove', this.mouseMove);
    document.removeEventListener('mouseup', this.mouseUp);
  };

  Swipeable.prototype.mouseDown = function mouseDown(e) {
    if (!this.props.trackMouse || e.type !== 'mousedown') {
      return;
    }

    if (typeof this.props.onMouseDown === 'function') this.props.onMouseDown(e);

    this.setupMouseListeners();

    this.eventStart(e);
  };

  Swipeable.prototype.mouseMove = function mouseMove(e) {
    this.eventMove(e);
  };

  Swipeable.prototype.mouseUp = function mouseUp(e) {
    this.cleanupMouseListeners();
    this.eventEnd(e);
  };

  Swipeable.prototype.eventStart = function eventStart(e) {
    if (e.touches && e.touches.length > 1) return;

    var _getPosition = getPosition(e),
        x = _getPosition.x,
        y = _getPosition.y;

    if (this.props.stopPropagation) e.stopPropagation();

    this.swipeable = { start: Date.now(), x: x, y: y, swiping: false };
  };

  Swipeable.prototype.eventMove = function eventMove(e) {
    var _props = this.props,
        stopPropagation = _props.stopPropagation,
        delta = _props.delta,
        onSwiping = _props.onSwiping,
        onSwipingLeft = _props.onSwipingLeft,
        onSwipedLeft = _props.onSwipedLeft,
        onSwipingRight = _props.onSwipingRight,
        onSwipedRight = _props.onSwipedRight,
        onSwipingUp = _props.onSwipingUp,
        onSwipedUp = _props.onSwipedUp,
        onSwipingDown = _props.onSwipingDown,
        onSwipedDown = _props.onSwipedDown,
        preventDefaultTouchmoveEvent = _props.preventDefaultTouchmoveEvent;


    if (!this.swipeable.x || !this.swipeable.y || e.touches && e.touches.length > 1) {
      return;
    }

    var pos = calculatePos(e, this.swipeable);

    if (pos.absX < delta && pos.absY < delta && !this.swipeable.swiping) return;

    if (stopPropagation) e.stopPropagation();

    if (onSwiping) {
      onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
    }

    var cancelablePageSwipe = false;
    if (pos.absX > pos.absY) {
      if (pos.deltaX > 0) {
        if (onSwipingLeft || onSwipedLeft) {
          onSwipingLeft && onSwipingLeft(e, pos.absX);
          cancelablePageSwipe = true;
        }
      } else if (onSwipingRight || onSwipedRight) {
        onSwipingRight && onSwipingRight(e, pos.absX);
        cancelablePageSwipe = true;
      }
    } else if (pos.deltaY > 0) {
      if (onSwipingUp || onSwipedUp) {
        onSwipingUp && onSwipingUp(e, pos.absY);
        cancelablePageSwipe = true;
      }
    } else if (onSwipingDown || onSwipedDown) {
      onSwipingDown && onSwipingDown(e, pos.absY);
      cancelablePageSwipe = true;
    }

    this.swipeable.swiping = true;

    if (cancelablePageSwipe && preventDefaultTouchmoveEvent) e.preventDefault();
  };

  Swipeable.prototype.eventEnd = function eventEnd(e) {
    var _props2 = this.props,
        stopPropagation = _props2.stopPropagation,
        flickThreshold = _props2.flickThreshold,
        onSwiped = _props2.onSwiped,
        onSwipedLeft = _props2.onSwipedLeft,
        onSwipedRight = _props2.onSwipedRight,
        onSwipedUp = _props2.onSwipedUp,
        onSwipedDown = _props2.onSwipedDown,
        onTap = _props2.onTap;


    if (this.swipeable.swiping) {
      var pos = calculatePos(e, this.swipeable);

      if (stopPropagation) e.stopPropagation();

      var isFlick = pos.velocity > flickThreshold;

      onSwiped && onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);

      if (pos.absX > pos.absY) {
        if (pos.deltaX > 0) {
          onSwipedLeft && onSwipedLeft(e, pos.deltaX, isFlick);
        } else {
          onSwipedRight && onSwipedRight(e, pos.deltaX, isFlick);
        }
      } else if (pos.deltaY > 0) {
        onSwipedUp && onSwipedUp(e, pos.deltaY, isFlick);
      } else {
        onSwipedDown && onSwipedDown(e, pos.deltaY, isFlick);
      }
    } else {
      onTap && onTap(e);
    }

    this.swipeable = getInitialState();
  };

  Swipeable.prototype.elementRef = function elementRef(element) {
    this.element = element;
    this.props.innerRef && this.props.innerRef(element);
  };

  Swipeable.prototype.render = function render() {
    var newProps = _extends({}, this.props);
    if (!this.props.disabled) {
      newProps.onTouchStart = this.eventStart;

      if (!this.props.preventDefaultTouchmoveEvent || !this.hasPassiveSupport) {
        newProps.onTouchMove = this.eventMove;
      }

      newProps.onTouchEnd = this.eventEnd;
      newProps.onMouseDown = this.mouseDown;
    }

    newProps.ref = this.elementRef;

    delete newProps.onSwiped;
    delete newProps.onSwiping;
    delete newProps.onSwipingUp;
    delete newProps.onSwipingRight;
    delete newProps.onSwipingDown;
    delete newProps.onSwipingLeft;
    delete newProps.onSwipedUp;
    delete newProps.onSwipedRight;
    delete newProps.onSwipedDown;
    delete newProps.onSwipedLeft;
    delete newProps.onTap;
    delete newProps.flickThreshold;
    delete newProps.delta;
    delete newProps.preventDefaultTouchmoveEvent;
    delete newProps.stopPropagation;
    delete newProps.nodeName;
    delete newProps.children;
    delete newProps.trackMouse;
    delete newProps.disabled;
    delete newProps.innerRef;

    return React.createElement(this.props.nodeName, newProps, this.props.children);
  };

  return Swipeable;
}(React.Component);

Swipeable.propTypes = {
  onSwiped: PropTypes.func,
  onSwiping: PropTypes.func,
  onSwipingUp: PropTypes.func,
  onSwipingRight: PropTypes.func,
  onSwipingDown: PropTypes.func,
  onSwipingLeft: PropTypes.func,
  onSwipedUp: PropTypes.func,
  onSwipedRight: PropTypes.func,
  onSwipedDown: PropTypes.func,
  onSwipedLeft: PropTypes.func,
  onTap: PropTypes.func,
  flickThreshold: PropTypes.number,
  delta: PropTypes.number,
  preventDefaultTouchmoveEvent: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  nodeName: PropTypes.string,
  trackMouse: PropTypes.bool,
  disabled: PropTypes.bool,
  innerRef: PropTypes.func,
  children: PropTypes.node
};

Swipeable.defaultProps = {
  flickThreshold: 0.6,
  delta: 10,
  preventDefaultTouchmoveEvent: false,
  stopPropagation: false,
  nodeName: 'div',
  disabled: false
};

module.exports = Swipeable;

/***/ }),

/***/ "7LCA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ANE":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8AZL":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "8Wdq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8fRV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
    var timeout = void 0;
    return function () {
        var context = this;
        var args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
//# sourceMappingURL=debounce.js.map

/***/ }),

/***/ "9MbE":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("8ANE");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "9TIe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

module.exports = __webpack_require__("4Xz7").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "9Zlg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9fOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9hiw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9uIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export simpleMerge */
/* unused harmony export Config */
/* unused harmony export TypeaheadProps */
/* unused harmony export withConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homeaway_react_determine_if_mobile__ = __webpack_require__("akZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homeaway_react_determine_if_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__homeaway_react_determine_if_mobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__homeaway_react_svg__ = __webpack_require__("Ye17");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__homeaway_react_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__homeaway_react_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__homeaway_svg_defs__ = __webpack_require__("QnUD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container__ = __webpack_require__("eXOF");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * CONFIG.JS
 *
 * ReactJS Run-time Configuration Service
 *
 * Contains a configuration class that can be accessed via
 * `window.typeaheadConfig.service`:
 *
 * window.typeaheadConfig.service = window.typeaheadConfig.service || [];
 * window.typeaheadConfig.service.push((service) => {
 *    // access service API methods on `Config` clas
 * });
 *
 * HOC provides standard ReactJS configuration + global
 * overrides that can be set from `window.typeaheadConfig.service`
 *
 **/






/**
 * Merge results from a and b without causing any side effects to a or b
 * @param {*} a
 * @param {*} b
 */

function simpleMerge(a, b) {
  var result = _extends({}, a, b);

  if (a.messages && b.messages) {
    result.messages = _extends({}, a.messages, b.messages);
  }

  return result;
} // Singleton Configuration Class.  Implemented by <withConfig> HOC.
// This is an internal class.  Only one instance of it is exported

var _Config =
/*#__PURE__*/
function () {
  // Contains state from run-time configuration and static configuration.
  function _Config() {
    var _this = this;

    this.mergedState = {};
    this.accessMap = {};
    this.reactInstances = [];
    this.reactInstanceId = 0;

    this.__reset = function () {
      _this.mergedState = {};
      _this.accessMap = {};
      _this.reactInstances = [];
      _this.reactInstanceId = 0;
    };

    this.isSSR = function () {
      return typeof global !== 'undefined' && typeof global.typeaheadConfig === 'object';
    };

    this.isClient = function () {
      return "object" !== 'undefined';
    };

    this.getNamespace = function () {
      if (_this.isSSR()) {
        return global.typeaheadConfig; // SSR
      } else if (_this.isClient()) {
        window.typeaheadConfig = window.typeaheadConfig || {};
        return window.typeaheadConfig; // Client
      } // Unable to reconcile environment


      return {};
    };

    this.setNamespace = function (value) {
      if (_this.isSSR()) {
        global.typeaheadConfig = value;
        return value;
      } else if (_this.isClient()) {
        window.typeaheadConfig = value;
        return value;
      } // Unable to reconcile environment


      return {};
    };

    this.isObject = function (obj) {
      return typeof obj === 'object' && obj !== null;
    };

    this.onFirstAccess = function (key, fn) {
      if (_this.accessMap[key]) {
        console.error("accessMap already contains " + key); //eslint-disable-line

        return false;
      }

      _this.accessMap[key] = function () {
        delete _this.accessMap[key];
        fn();
      };

      return true;
    };

    this.checkFirstAccess = function (key) {
      if (typeof _this.accessMap[key] !== 'undefined') {
        _this.accessMap[key]();

        return true;
      }

      return false;
    };

    this.getPublicApi = function () {
      return {
        sync: _this.sync,
        getConfig: _this.getConfig,
        setConfig: _this.setConfig,
        getMergedState: _this.getMergedState,
        onFirstAccess: _this.onFirstAccess
      };
    };

    this.sync = function () {
      _this.reactInstances.forEach(function (entry) {
        entry.inst.setWithConfig();
      });
    };

    this.getConfig = function (path) {
      if (typeof path === 'undefined') {
        return simpleMerge({}, _this.getNamespace());
      }

      return _this.access(path);
    };

    this.setConfig = function (path, value) {
      if (typeof value === 'undefined') {
        return _this.setNamespace(simpleMerge(_this.getNamespace(), path));
      }

      var properties = path.split('.');

      var currentObject = _this.getNamespace();

      var property;

      while (properties.length) {
        property = properties.shift();

        if (!_this.isObject(currentObject[property])) {
          currentObject[property] = {};
        }

        if (!properties.length) {
          currentObject[property] = value;
        }

        currentObject = currentObject[property];
      }

      return currentObject;
    };

    this.getMergedState = function (path) {
      if (typeof path === 'undefined') {
        return simpleMerge({}, _this.mergedState);
      }

      return _this.access(path, _this.mergedState);
    };

    this.setMergedState = function (state) {
      _this.mergedState = simpleMerge(_this.mergedState, state);
    };

    this.initialize();
    return this;
  }

  var _proto = _Config.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    // Create namespace access
    var namespace = this.getNamespace(); // Create globally accessible service

    namespace.service = namespace.service || []; // Process service access requests

    if (typeof namespace.service.forEach === 'function') {
      namespace.service.forEach(function (serviceCall) {
        serviceCall(_this2.getPublicApi());
      });
    }

    namespace.service = {
      push: function push(fn) {
        fn.call(_this2, _this2.getPublicApi());
      }
    };
  }
  /**
   * registerReactInstance()
   * Registers a react instance to faciliate syncing from global API
   * @param {*} inst
   */
  ;

  _proto.registerReactInstance = function registerReactInstance(inst) {
    var _this3 = this;

    // Save reference to instance of ReactJS class that we are wrapping.
    this.reactInstances.push({
      id: ++this.reactInstanceId,
      inst: inst
    });
    return function (id) {
      // Return function to remove instance
      return function () {
        _this3.reactInstances.forEach(function (reactInstance, index) {
          if (reactInstance.id === id) {
            _this3.reactInstances.splice(index, 1);

            return true;
          }

          return false;
        });
      };
    }(this.reactInstanceId);
  }
  /**
   * Helper method to determine if we are in a SSR context
   */
  ;

  /**
   * access()
   * Helper method for safe access
   * @param {*} path
   * @param {*} namespace
   */
  _proto.access = function access(path, namespace) {
    if (namespace === void 0) {
      namespace = this.getNamespace();
    }

    var properties = path.split('.');
    var currentObject = namespace;
    var property;

    while (properties.length) {
      property = properties.shift();

      if (!currentObject || typeof currentObject[property] === 'undefined') {
        break;
      }

      if (!properties.length) {
        this.checkFirstAccess(path); // Check our access map

        return currentObject[property];
      }

      currentObject = currentObject[property];
    }

    console.error("Could not access \"" + path + "\" in configuration"); //eslint-disable-line

    return null;
  }
  /**
   * sync()
   * Invokes .setState() on wrapped reactJS instance with
   * merged state from this class.
   */
  ;

  return _Config;
}(); // Singleton instance


var Config = new _Config();
var TypeaheadProps =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TypeaheadProps, _React$Component);

  function TypeaheadProps() {
    return _React$Component.apply(this, arguments) || this;
  }

  return TypeaheadProps;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
TypeaheadProps.propTypes = {
  /** App prefix for running application */
  appPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** Base URL for the brand */
  baseUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** Instance of configuration class */
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  //eslint-disable-line

  /**
   * Filter separator style.
   * NOTE: requires V2 remotePath
   * 1: Mark
   * 2: Inline Mark
   * 3: Arrow
   */
  filterType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([0, 1, 2, 3]),

  /** Hide selected filter inside Typeahead input */
  hideSelectedFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Google place API key to be used when Google fallback is enabled */
  googlePlaceApiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** Google place API Url to use when using Google fallback */
  googlePlaceApiUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** When set to false, do not render icon.  Supports custom element.  Defaults to magnifying glass (<SVGIcon markup={SEARCH__24}). */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /** Provided by determineIfMobile HOC.  Used to determine number of suggestion results */
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Option to set input focus.  Requires you to implement `onBlur` prop to update to false. */
  isTypeaheadInputFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Which locale to use (SERVER SIDE ENABLED) */
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** Translated message strings (SERVER SIDE ENABLED) */
  messages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    resultsfound: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    noresultsfound: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    destinationplaceholdermsg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    destinationselected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    recentsearches: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    where: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    recentlyviewed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    clearsearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /** Minimum number of characters to type before results are grabbed */
  minLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /** Handler to be called when input has lost focus.  */
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /** Handler to be called when list of suggestions is closed */
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /** Handler to be called when input receives focus.  */
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /** Handle to be called when typeahead config wrapper has been mounted on the DOM */
  onMount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /** Handler to be called when user selects a destination */
  onSelectDestination: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /** Handler to be called when search updated or destinaton selected.  */
  onUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /** Option to set popover max-width on desktop. Will get reduced to fit within viewport if necessary  */
  popoverDesktopMaxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** Option to set min margin between right edge of popover and right edge of viewport. Defaults to baseline container outer gutter  */
  popoverDesktopMinMarginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** Option to set popover width on desktop. Will get reduced to fit within viewport if necessary  */
  popoverDesktopWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** Option to set popover min-width on desktop. Will get reduced to fit within viewport if necessary  */
  popoverDesktopMinWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** When greater than 0, caps maximum numbers of results displayed.   */
  popoverMaxDisplayCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** When greater than 0, caps maximum numbers of results displayed when isMobile.   */
  popoverMaxDisplayCountMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** Limit amount of recent searches */
  recentSearchesDisplayMax: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /** The XHR path to be used when querying typeahead suggestions. */
  remotePath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** When set to false, user input (IE "Aus") will be preserved when selecting a destination (IE like "Austin, TX, USA") when element is focused */
  retainUserInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Prepopulated Query */
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** When set to false, it won't suggest a destination within the destination field. Defaults to true. */
  showInlineSuggestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Option to control whether or not user sees recent searches in typeahead list */
  showRecentSearches: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** When set to true the suggestion will have type icon on the left side */
  showResultIcons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** When set to true the suggestion will have type label on the right side */
  showResultLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** When set to true the spinner won't appear when loading destinations */
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Moniker brand: homeaway_us, vrbo, abritel, etc (SERVER SIDE ENABLED) */
  site: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /** Flag to ellipsis term to fit within single-line result row. Will not affect icon, inline filter text, recently viewed, or type label */
  truncateResultTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Use animation for results popover*/
  usePopoverAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Use animation for input type-ahead results
   * NOTE: requires V2 remotePath
   */
  useResultsAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
TypeaheadProps.defaultProps = {
  appPrefix: '/',
  baseUrl: null,
  filterType: 0,
  hideSelectedFilter: false,
  googlePlaceApiKey: 'AIzaSyAYkFHPo1vhSXLRTZS3Z7E75XwNhaNVDEQ',
  icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__homeaway_react_svg__["SVGIcon"], {
    markup: __WEBPACK_IMPORTED_MODULE_4__homeaway_svg_defs__["SEARCH__24"]
  }),
  isMobile: false,
  isTypeaheadInputFocus: false,
  locale: null,
  messages: {},
  minLength: 2,
  onBlur: function onBlur() {},
  onClose: function onClose() {},
  onFocus: function onFocus() {},
  onMount: function onMount() {},
  onSelectDestination: function onSelectDestination() {},
  onUpdate: function onUpdate() {},
  popoverDesktopMaxWidth: 'none',
  popoverDesktopMinMarginRight: 30,
  popoverDesktopMinWidth: 'auto',
  popoverDesktopWidth: 'auto',
  popoverMaxDisplayCount: 8,
  popoverMaxDisplayCountMobile: 8,
  recentSearchesDisplayMax: 2,
  remotePath: '/geo/v1/typeahead/suggest',
  retainUserInput: true,
  search: '',
  showInlineSuggestion: true,
  showRecentSearches: true,
  showResultIcons: false,
  showResultLabels: false,
  showSpinner: false,
  site: null,
  truncateResultTerms: true,
  usePopoverAnimation: false,
  useResultsAnimation: false
};
function withConfig(Wrapped) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_TypeaheadProps) {
    _inheritsLoose(WrappedWithConfig, _TypeaheadProps);

    // Holds local state

    /* istanbul ignore next */
    function WrappedWithConfig(props) {
      var _this4;

      _this4 = _TypeaheadProps.call(this, props) || this;
      _this4.state = {};

      _this4.setWithConfig = function (nextProps) {
        if (nextProps === void 0) {
          nextProps = {};
        }

        var nextState = null;

        if (_this4.props.usePropsOnly !== true) {
          nextState = simpleMerge(nextProps, _this4.config.getConfig());
        } else {
          nextState = nextProps;
        } // Kicks off life cycle to re-render this component and
        // pass data into <Wrapped> via {...this.state}


        _this4.setState(nextState); // Update merged state in configuration service


        _this4.config.setMergedState(nextState);
      };

      _this4.config = Config;

      if (props.usePropsOnly !== true) {
        _this4.state = simpleMerge(props, _this4.config.getConfig());
      } else {
        _this4.state = simpleMerge({}, props);
      }

      _this4.config.setMergedState(_this4.state);

      return _this4;
    }

    var _proto2 = WrappedWithConfig.prototype;

    _proto2.componentDidMount = function componentDidMount() {
      this.unregisterGlobalConfig = Config.registerReactInstance(this);
      this.props.onMount();
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      this.unregisterGlobalConfig();
      this.config = null; // dereference global `Config` to allow GC
    }
    /**
     * componentWillReceiveProps()
     * @param {*} nextProps
     */
    ;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      this.setWithConfig(nextProps);
    }
    /**
     * setWithConfig()
     * @param {*} nextProps
     * Merges incoming props and global state into local `this.state`
     */
    ;

    _proto2.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, this.state, {
        config: this.config
      }));
    };

    return WrappedWithConfig;
  }(TypeaheadProps), _temp;
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__homeaway_react_determine_if_mobile___default()(withConfig(__WEBPACK_IMPORTED_MODULE_5__container__["a" /* TypeaheadContainer */]), 767));
//# sourceMappingURL=config.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "AFOY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("CZee");
var $Object = __webpack_require__("iANj").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "AUPe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("2Zwn"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _reactLifecyclesCompat = __webpack_require__("R8mX");

var _PropTypes = __webpack_require__("nb0Q");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),

/***/ "AgU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ahf/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.store = factory();
  }
}(this, function () {
	
	// Store.js
	var store = {},
		win = ( true ? window : global),
		doc = win.document,
		localStorageName = 'localStorage',
		scriptTag = 'script',
		storage

	store.disabled = false
	store.version = '1.3.20'
	store.set = function(key, value) {}
	store.get = function(key, defaultVal) {}
	store.has = function(key) { return store.get(key) !== undefined }
	store.remove = function(key) {}
	store.clear = function() {}
	store.transact = function(key, defaultVal, transactionFn) {
		if (transactionFn == null) {
			transactionFn = defaultVal
			defaultVal = null
		}
		if (defaultVal == null) {
			defaultVal = {}
		}
		var val = store.get(key, defaultVal)
		transactionFn(val)
		store.set(key, val)
	}
	store.getAll = function() {}
	store.forEach = function() {}

	store.serialize = function(value) {
		return JSON.stringify(value)
	}
	store.deserialize = function(value) {
		if (typeof value != 'string') { return undefined }
		try { return JSON.parse(value) }
		catch(e) { return value || undefined }
	}

	// Functions to encapsulate questionable FireFox 3.6.13 behavior
	// when about.config::dom.storage.enabled === false
	// See https://github.com/marcuswestin/store.js/issues#issue/13
	function isLocalStorageNameSupported() {
		try { return (localStorageName in win && win[localStorageName]) }
		catch(err) { return false }
	}

	if (isLocalStorageNameSupported()) {
		storage = win[localStorageName]
		store.set = function(key, val) {
			if (val === undefined) { return store.remove(key) }
			storage.setItem(key, store.serialize(val))
			return val
		}
		store.get = function(key, defaultVal) {
			var val = store.deserialize(storage.getItem(key))
			return (val === undefined ? defaultVal : val)
		}
		store.remove = function(key) { storage.removeItem(key) }
		store.clear = function() { storage.clear() }
		store.getAll = function() {
			var ret = {}
			store.forEach(function(key, val) {
				ret[key] = val
			})
			return ret
		}
		store.forEach = function(callback) {
			for (var i=0; i<storage.length; i++) {
				var key = storage.key(i)
				callback(key, store.get(key))
			}
		}
	} else if (doc && doc.documentElement.addBehavior) {
		var storageOwner,
			storageContainer
		// Since #userData storage applies only to specific paths, we need to
		// somehow link our data to a specific path.  We choose /favicon.ico
		// as a pretty safe option, since all browsers already make a request to
		// this URL anyway and being a 404 will not hurt us here.  We wrap an
		// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
		// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
		// since the iframe access rules appear to allow direct access and
		// manipulation of the document element, even for a 404 page.  This
		// document can be used instead of the current document (which would
		// have been limited to the current path) to perform #userData storage.
		try {
			storageContainer = new ActiveXObject('htmlfile')
			storageContainer.open()
			storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
			storageContainer.close()
			storageOwner = storageContainer.w.frames[0].document
			storage = storageOwner.createElement('div')
		} catch(e) {
			// somehow ActiveXObject instantiation failed (perhaps some special
			// security settings or otherwse), fall back to per-path storage
			storage = doc.createElement('div')
			storageOwner = doc.body
		}
		var withIEStorage = function(storeFunction) {
			return function() {
				var args = Array.prototype.slice.call(arguments, 0)
				args.unshift(storage)
				// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
				// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
				storageOwner.appendChild(storage)
				storage.addBehavior('#default#userData')
				storage.load(localStorageName)
				var result = storeFunction.apply(store, args)
				storageOwner.removeChild(storage)
				return result
			}
		}

		// In IE7, keys cannot start with a digit or contain certain chars.
		// See https://github.com/marcuswestin/store.js/issues/40
		// See https://github.com/marcuswestin/store.js/issues/83
		var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
		var ieKeyFix = function(key) {
			return key.replace(/^d/, '___$&').replace(forbiddenCharsRegex, '___')
		}
		store.set = withIEStorage(function(storage, key, val) {
			key = ieKeyFix(key)
			if (val === undefined) { return store.remove(key) }
			storage.setAttribute(key, store.serialize(val))
			storage.save(localStorageName)
			return val
		})
		store.get = withIEStorage(function(storage, key, defaultVal) {
			key = ieKeyFix(key)
			var val = store.deserialize(storage.getAttribute(key))
			return (val === undefined ? defaultVal : val)
		})
		store.remove = withIEStorage(function(storage, key) {
			key = ieKeyFix(key)
			storage.removeAttribute(key)
			storage.save(localStorageName)
		})
		store.clear = withIEStorage(function(storage) {
			var attributes = storage.XMLDocument.documentElement.attributes
			storage.load(localStorageName)
			for (var i=attributes.length-1; i>=0; i--) {
				storage.removeAttribute(attributes[i].name)
			}
			storage.save(localStorageName)
		})
		store.getAll = function(storage) {
			var ret = {}
			store.forEach(function(key, val) {
				ret[key] = val
			})
			return ret
		}
		store.forEach = withIEStorage(function(storage, callback) {
			var attributes = storage.XMLDocument.documentElement.attributes
			for (var i=0, attr; attr=attributes[i]; ++i) {
				callback(attr.name, store.deserialize(storage.getAttribute(attr.name)))
			}
		})
	}

	try {
		var testKey = '__storejs__'
		store.set(testKey, testKey)
		if (store.get(testKey) != testKey) { store.disabled = true }
		store.remove(testKey)
	} catch(e) {
		store.disabled = true
	}
	store.enabled = !store.disabled
	
	return store
}));


/***/ }),

/***/ "Ai/T":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "Aq0r":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "Aq9S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scratchpad = __webpack_require__("w5xw");

var _reactDetermineIfMobile = __webpack_require__("54yA");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _RecentActivityStateless = __webpack_require__("ZmSW");

var _RecentActivityStateless2 = _interopRequireDefault(_RecentActivityStateless);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecentActivity = function (_Component) {
    _inherits(RecentActivity, _Component);

    function RecentActivity(props) {
        _classCallCheck(this, RecentActivity);

        var _this = _possibleConstructorReturn(this, (RecentActivity.__proto__ || Object.getPrototypeOf(RecentActivity)).call(this, props));

        _this.state = {
            summaries: []
        };
        return _this;
    }

    _createClass(RecentActivity, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                env = _props.env,
                hav = _props.hav,
                puuid = _props.puuid,
                site = _props.site;
            // console.log('props', this.props);

            this.fetchSummaries(env, hav, puuid, site);
        }
    }, {
        key: 'fetchSummaries',
        value: function fetchSummaries(env, hav, puuid, site) {
            var _this2 = this;

            (0, _scratchpad.fullV1)({ env: env, hav: hav, puuid: puuid, site: site }).then(function (json) {
                var summaries = json.summaries && json.summaries.map(function (summary) {
                    var arrivalDate = summary.arrivalDate,
                        departureDate = summary.departureDate,
                        lbsGroupName = summary.lbsGroupName,
                        _summary$propertiesSu = summary.propertiesSummary,
                        propertiesSummary = _summary$propertiesSu === undefined ? {} : _summary$propertiesSu,
                        scratchpadId = summary.scratchpadId,
                        imageUrl = summary.imageUrl;
                    var _propertiesSummary$pr = propertiesSummary.properties,
                        properties = _propertiesSummary$pr === undefined ? [] : _propertiesSummary$pr;

                    var firstImageUrl = properties[0] && properties[0].hit && properties[0].hit.thumbnailUrl1;
                    var count = properties.length;
                    return {
                        startDate: arrivalDate,
                        count: count,
                        endDate: departureDate,
                        title: lbsGroupName,
                        key: scratchpadId,
                        id: scratchpadId,
                        imageUri: imageUrl || firstImageUrl
                    };
                });
                if (summaries) {
                    _this2.setState({ summaries: summaries });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var summaries = this.state.summaries;
            var _props2 = this.props,
                cardIndex = _props2.cardIndex,
                breakpoints = _props2.breakpoints,
                isMobile = _props2.isMobile,
                title = _props2.title,
                onEnter = _props2.onEnter,
                onClick = _props2.onClick,
                onArrowClick = _props2.onArrowClick;


            return _react2.default.createElement(_RecentActivityStateless2.default, {
                breakpoints: breakpoints,
                cardIndex: cardIndex,
                isMobile: isMobile,
                onArrowClick: onArrowClick,
                onClick: onClick,
                onEnter: onEnter,
                summaries: summaries,
                title: title
            });
        }
    }]);

    return RecentActivity;
}(_react.Component);

RecentActivity.propTypes = {
    breakpoints: _propTypes2.default.objectOf(_propTypes2.default.number),
    cardIndex: _propTypes2.default.number,
    env: _propTypes2.default.oneOf(['dev', 'test', 'stage', 'production', 'prod']),
    hav: _propTypes2.default.string,
    isMobile: _propTypes2.default.bool,
    onArrowClick: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    puuid: _propTypes2.default.string,
    site: _propTypes2.default.string,
    title: _propTypes2.default.string
};
RecentActivity.defaultProps = {
    env: 'production',
    site: 'homeaway_us'
};
exports.default = (0, _reactDetermineIfMobile2.default)(RecentActivity, 767);
//# sourceMappingURL=RecentActivity.js.map

/***/ }),

/***/ "AxoS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLexer = createLexer;
exports.getTokenDesc = getTokenDesc;
exports.TokenKind = void 0;

var _error = __webpack_require__("Qhe+");

var _blockStringValue = _interopRequireDefault(__webpack_require__("5Xbz"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

exports.TokenKind = TokenKind;

/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;
/**
 * Helper function for constructing the Token object.
 */

function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
};

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev);
      }

      return readString(source, pos, line, col, prev);
  }

  throw (0, _error.syntaxError)(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = charCodeAt.call(body, position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);

    if (code >= 48 && code <= 57) {
      throw (0, _error.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = charCodeAt.call(body, ++position);

    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }

    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw (0, _error.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));

          if (charCode < 0) {
            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + "\\u".concat(body.slice(position + 1, position + 5), "."));
          }

          value += String.fromCharCode(charCode);
          position += 4;
          break;

        default:
          throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringValue.default)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    } // Escape Triple-Quote (\""")


    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),

/***/ "B/BN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Arrow = __webpack_require__("qWiE");

var _Arrow2 = _interopRequireDefault(_Arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ArrowNext(props) {
    var _props$arrowBackgroun = props.arrowBackgroundColor,
        red = _props$arrowBackgroun.red,
        green = _props$arrowBackgroun.green,
        blue = _props$arrowBackgroun.blue;


    var style = {
        background: 'linear-gradient(to right, rgba(' + red + ', ' + green + ', ' + blue + ', 0) 0%, rgba(' + red + ', ' + green + ', ' + blue + ', 1) 50%, rgba(' + red + ', ' + green + ', ' + blue + ', 1) 100%)'
    };

    return _react2.default.createElement(
        _Arrow2.default,
        _extends({}, props, {
            className: 'horizontal-scroll-button-right',
            style: style,
            tabIndex: 0,
            viewBox: '0 0 48 48'
        }),
        _react2.default.createElement('polygon', { points: '17.41 8 16 9.41 29.17 24 16 38.59 17.41 40 32 24 17.41 8' })
    );
}

ArrowNext.propTypes = {
    arrowBackgroundColor: _propTypes2.default.shape({
        red: _propTypes2.default.number,
        green: _propTypes2.default.number,
        blue: _propTypes2.default.number
    })
};

exports.default = ArrowNext;
//# sourceMappingURL=ArrowNext.js.map

/***/ }),

/***/ "B/qS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactTooltip = __webpack_require__("j6PF");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactModal = __webpack_require__("XSjK");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactGuestFields = __webpack_require__("r6wq");

var _reactGuestFields2 = _interopRequireDefault(_reactGuestFields);

var _reactButtons = __webpack_require__("HfJ9");

__webpack_require__("Hq0H");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base
 */
var Base = function (_Component) {
    _inherits(Base, _Component);

    function Base() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Base);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.renderModalTitle = function () {
            var _this$props = _this.props,
                clearButtonLabel = _this$props.clearButtonLabel,
                onClear = _this$props.onClear,
                modalTitle = _this$props.modalTitle,
                showClearButton = _this$props.showClearButton;

            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'guest-picker__title' },
                    modalTitle
                ),
                showClearButton && _react2.default.createElement(
                    'a',
                    { className: 'guest-picker__clear-link', onClick: onClear },
                    clearButtonLabel
                )
            );
        }, _this.renderPrefixElement = function () {
            var formPrefixElement = _this.props.formPrefixElement;

            var Element = formPrefixElement;

            return formPrefixElement ? _react2.default.createElement(Element, null) : null;
        }, _this.renderSuffixElement = function () {
            var formSuffixElement = _this.props.formSuffixElement;

            var Element = formSuffixElement;

            return formSuffixElement ? _react2.default.createElement(Element, null) : null;
        }, _this.renderGuestFields = function () {
            var _this$props2 = _this.props,
                adultsCount = _this$props2.adultsCount,
                adultsLabel = _this$props2.adultsLabel,
                applyButtonLabel = _this$props2.applyButtonLabel,
                childrenCount = _this$props2.childrenCount,
                childrenLabel = _this$props2.childrenLabel,
                clearButtonLabel = _this$props2.clearButtonLabel,
                compRefFun = _this$props2.compRefFun,
                continueButtonLabel = _this$props2.continueButtonLabel,
                disableButton = _this$props2.disableButton,
                isMobile = _this$props2.isMobile,
                onApply = _this$props2.onApply,
                onChange = _this$props2.onChange,
                onClear = _this$props2.onClear,
                petIncluded = _this$props2.petIncluded,
                showClearButton = _this$props2.showClearButton,
                showContinue = _this$props2.showContinue,
                showPetOption = _this$props2.showPetOption,
                formPrefixElement = _this$props2.formPrefixElement,
                formSuffixElement = _this$props2.formSuffixElement;


            var formPrefix = typeof formPrefixElement === 'function' ? _this.renderPrefixElement() : formPrefixElement;
            var formSuffix = typeof formSuffixElement === 'function' ? _this.renderSuffixElement() : formSuffixElement;

            return _react2.default.createElement(
                'div',
                { ref: compRefFun },
                formPrefix && _react2.default.createElement(
                    'div',
                    { className: 'guest-picker__prefix' },
                    formPrefix
                ),
                _react2.default.createElement(_reactGuestFields2.default, _extends({}, _this.props, {
                    adultsLabel: adultsLabel,
                    adultsCount: adultsCount,
                    childrenLabel: childrenLabel,
                    childrenCount: childrenCount,
                    petIncluded: petIncluded,
                    showpetOption: showPetOption,
                    onChange: onChange
                })),
                formSuffix && _react2.default.createElement(
                    'div',
                    { className: 'guest-picker__suffix' },
                    formSuffix
                ),
                !isMobile && _react2.default.createElement(
                    'div',
                    { className: 'row popover-actions' },
                    _react2.default.createElement(
                        'div',
                        { className: 'text-right' },
                        showClearButton && _react2.default.createElement(_reactButtons.ButtonLink, { label: clearButtonLabel, size: 'sm', onClick: onClear }),
                        _react2.default.createElement(_reactButtons.ButtonPrimary, { label: applyButtonLabel, size: 'sm', onClick: onApply, disabled: disableButton })
                    )
                ),
                showContinue && isMobile && _react2.default.createElement(
                    'a',
                    { className: 'btn btn-primary btn-rounded guest-picker__continue', onClick: onApply, disabled: disableButton },
                    continueButtonLabel
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Base, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                centered = _props.centered,
                className = _props.className,
                inputs = _props.inputs,
                isMobile = _props.isMobile,
                isOpen = _props.isOpen,
                onModalClose = _props.onModalClose,
                onClose = _props.onClose,
                placement = _props.placement,
                fadeOutDuration = _props.fadeOutDuration;

            // Mobile (component in modal)

            if (isMobile) {
                return _react2.default.createElement(
                    'div',
                    { className: className },
                    inputs,
                    _react2.default.createElement(
                        _reactModal2.default,
                        {
                            id: 'picker-modal',
                            className: 'guest-picker__modal',
                            title: this.renderModalTitle(),
                            isOpen: isOpen,
                            onClose: onModalClose,
                            isWorkflow: true
                        },
                        this.renderGuestFields()
                    )
                );
            }

            // Desktop (component in popover)
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    _reactTooltip2.default,
                    {
                        fadeOutDuration: fadeOutDuration,
                        tooltipType: 'popover',
                        trigger: 'none',
                        wrappingMethod: 'block',
                        placement: placement,
                        isOpen: isOpen,
                        onClose: onClose,
                        portalClassName: 'guest-picker__popover',
                        content: this.renderGuestFields(),
                        centered: centered
                    },
                    inputs
                )
            );
        }
    }]);

    return Base;
}(_react.Component);

Base.defaultProps = {
    onChange: function onChange() {},
    showClearButton: true
};
exports.default = Base;
//# sourceMappingURL=Base.js.map

/***/ }),

/***/ "B5V0":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "BDlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("YSwN"))(3);

/***/ }),

/***/ "BQO6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tz60");
__webpack_require__("+3lO");
module.exports = __webpack_require__("4DQ7").f('iterator');


/***/ }),

/***/ "BRq8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRASHCAN__16 = void 0;
var TRASHCAN__16 = '<svg data-id="SVG_TRASHCAN__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M2.3 4.7h11.6m-3.7-1.4c0-.6-.5-1-1-1H7a1 1 0 0 0-1 1v1.4h4.2V3.3zM6.8 11V7.3M9.3 11V7.3m3.4-2.6l-.8 8.3c0 .5-.5 1-1 1H5.2a1 1 0 0 1-1-1l-.5-5.8" fill="none" stroke-linecap="round" stroke-linejoin="round" /></svg>';
exports.TRASHCAN__16 = TRASHCAN__16;

/***/ }),

/***/ "BxE1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _AspectRatioCardUtil = __webpack_require__("RiTF");

var _AspectRatioCardUtil2 = _interopRequireDefault(_AspectRatioCardUtil);

__webpack_require__("UjZZ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AspectRatioCardImage = function (_Component) {
    _inherits(AspectRatioCardImage, _Component);

    function AspectRatioCardImage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AspectRatioCardImage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AspectRatioCardImage.__proto__ || Object.getPrototypeOf(AspectRatioCardImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            boundSide: 'width',
            aspectRatioData: _AspectRatioCardUtil2.default.getAspectRatioData(_this.props.aspectRatio),
            imageAspectRatioData: { ratio: 0 }
        }, _this.handleImageOnLoad = function (e) {
            var _this$state = _this.state,
                imageAspectRatioData = _this$state.imageAspectRatioData,
                aspectRatioData = _this$state.aspectRatioData,
                boundSide = _this$state.boundSide;

            if (imageAspectRatioData && imageAspectRatioData.ratio === 0) {
                var img = e.target;
                var newImageAspectRatioData = _AspectRatioCardUtil2.default.getAspectRatioData(img.naturalWidth + 'x' + img.naturalHeight);
                var newBoundSide = _AspectRatioCardUtil2.default.getImageBoundSide(newImageAspectRatioData.ratio, aspectRatioData.ratio);
                if (newImageAspectRatioData.ratio !== imageAspectRatioData.ratio || newBoundSide !== boundSide) {
                    _this.setState({
                        imageAspectRatioData: newImageAspectRatioData,
                        boundSide: newBoundSide
                    });
                }
                _this.props.onLoad(newImageAspectRatioData);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AspectRatioCardImage, [{
        key: 'componentDidMount',


        // if image is server-side rendered, call image loaded callback when component mounts because image onload may never be dispatched
        value: function componentDidMount() {
            if (this.image && this.image.complete) {
                this.handleImageOnLoad({ target: this.image });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var imageUri = this.props.imageUri;
            var _state = this.state,
                boundSide = _state.boundSide,
                imageAspectRatioData = _state.imageAspectRatioData;

            var imageClasses = (0, _classnames2.default)('AspectRatioCardImage__image', {
                'AspectRatioCardImage__image--width-100': boundSide === 'width',
                'AspectRatioCardImage__image--height-100': boundSide === 'height',
                'AspectRatioCardImage__image--not-loaded': !imageAspectRatioData || !imageAspectRatioData.ratio
            });

            return _react2.default.createElement(
                'div',
                { className: 'AspectRatioCardImage' },
                _react2.default.createElement('img', {
                    alt: '',
                    className: imageClasses,
                    src: imageUri,
                    onLoad: this.handleImageOnLoad,
                    ref: function ref(c) {
                        _this2.image = c;
                    }
                })
            );
        }
    }]);

    return AspectRatioCardImage;
}(_react.Component);

AspectRatioCardImage.propTypes = {
    /** The card aspect ratio, which determines the maintained aspect ratio of the image block. This does NOT need to be specified if this component is used as a child of AspectRatioCard. */
    aspectRatio: _propTypes2.default.oneOf(['4x3', '3x4']),
    /** The URI of the image to be rendered. */
    imageUri: _propTypes2.default.string,
    /** Callback to invoke when the image has been loaded. */
    onLoad: _propTypes2.default.func
};
AspectRatioCardImage.defaultProps = {
    imageUri: '',
    onLoad: function onLoad() {}
};
exports.default = AspectRatioCardImage;
//# sourceMappingURL=AspectRatioCardImage.js.map

/***/ }),

/***/ "BzqH":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("nclR");
module.exports = __webpack_require__("iANj").Object.setPrototypeOf;


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("rKx+"), __esModule: true };

/***/ }),

/***/ "CBH9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CWsh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optimisticAddToTripBoardResponse = exports.handleOnMutationError = exports.handleOnMutationComplete = exports.addListingToCache = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactApollo = __webpack_require__("3zLD");

var _graphql = __webpack_require__("qm98");

var _edap = __webpack_require__("H/Ty");

var _edap2 = _interopRequireDefault(_edap);

var _TripBoard = __webpack_require__("Dtfn");

var _TripBoard2 = _interopRequireDefault(_TripBoard);

var _withFetchPreviews = __webpack_require__("+TD/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var addListingToCache = exports.addListingToCache = function addListingToCache(hav, pageSize, listingPageSize, listingId, boardId, thumbnailUrl) {
    return function (proxy) {
        var cache = (0, _withFetchPreviews.readPreviewsCache)(proxy, hav, pageSize, listingPageSize);
        if (!cache || !cache.paginatedTripBoards) {
            return; // why bother, we aren't getting fed tripboard previews
        }

        var boards = cache.paginatedTripBoards.tripBoards || [];
        var thisTripBoardIndex = boards.findIndex(function (_ref) {
            var uuid = _ref.uuid;
            return uuid === boardId;
        });
        if (thisTripBoardIndex >= 0) {
            var thisTripBoard = boards[thisTripBoardIndex];
            thisTripBoard.listingRefs = [listingId].concat(_toConsumableArray(thisTripBoard.listingRefs));
            thisTripBoard.listings = [{
                __typename: 'Listing',
                listingId: listingId,
                images: [{ __typename: 'Image', c6_uri: thumbnailUrl, width: 800, height: 600 }]
            }].concat(_toConsumableArray(thisTripBoard.listings));
            (0, _withFetchPreviews.writePreviewsCache)(proxy, hav, pageSize, listingPageSize, cache);
        }
    };
};

var handleOnMutationComplete = exports.handleOnMutationComplete = function handleOnMutationComplete(listingId) {
    return function (data) {
        var createTripBoard = data && data.createTripBoard || {};
        var uuid = createTripBoard.uuid,
            stay = createTripBoard.stay;

        var _ref2 = stay || {},
            adultCount = _ref2.adultCount,
            childrenCount = _ref2.childrenCount,
            petsIncluded = _ref2.petsIncluded;

        var _ref3 = stay && stay.dateRange || {},
            arrival = _ref3.arrival,
            departure = _ref3.departure;

        _edap2.default.boardSaved(false, adultCount, childrenCount, petsIncluded, arrival, departure, listingId, uuid);
    };
};

var handleOnMutationError = exports.handleOnMutationError = function handleOnMutationError(listingId, boardId) {
    return function () {
        _TripBoard2.default.showCreateError(listingId);
        _edap2.default.boardCreateError(listingId, boardId);
    };
};

var optimisticAddToTripBoardResponse = exports.optimisticAddToTripBoardResponse = {
    addUnitToTripBoard: true
};

var withAddToTripBoard = (0, _reactApollo.graphql)(_graphql.addToTripboardMutation, {
    options: function options(_ref4) {
        var mutationConfig = _ref4.mutationConfig,
            listingId = _ref4.listingId;
        return _extends({}, mutationConfig, {
            onCompleted: handleOnMutationComplete(listingId),
            optimisticResponse: optimisticAddToTripBoardResponse
        });
    },
    name: 'addToTripBoard',
    alias: 'withAddToTripBoardMutation'
});

exports.default = withAddToTripBoard;
//# sourceMappingURL=with-add-to-trip-board.js.map

/***/ }),

/***/ "CZee":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("NZ8V") });


/***/ }),

/***/ "Dtfn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TripBoardModalContainer = __webpack_require__("sNwG");

var _TripBoardModalContainer2 = _interopRequireDefault(_TripBoardModalContainer);

var _edap = __webpack_require__("H/Ty");

var _edap2 = _interopRequireDefault(_edap);

var _testExposureOnce = __webpack_require__("FCbp");

var _testExposureOnce2 = _interopRequireDefault(_testExposureOnce);

var _constants = __webpack_require__("hXMO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TripBoard = {
    id: 'trip-board-modal-container',

    modal: {
        close: function close() {},
        open: function open() {}
    },

    siteName: null,

    getTripboards: null,

    createToast: null,

    tripBoardButton: null,

    translations: null,

    testExposure: {
        loadingAnimation: new _testExposureOnce2.default(_constants.LOADING_ANIMATION),
        newModal: new _testExposureOnce2.default(_constants.NEW_MODAL)
    },

    close: function close() {
        this.tripBoardButton = null;
        this.modal.close();
        return this;
    },
    setVisibilityListener: function setVisibilityListener() {
        var visibilityChange = null;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
            }

            document.addEventListener(visibilityChange, this.handleVisibilityChange.bind(this), false);
        }
    },
    handleVisibilityChange: function handleVisibilityChange() {
        if (!document.hidden) {
            // the handler fires twice for hidden = false and hidden = true.  We only need one.
            this.getTripboards(this.siteName);
        }
    },
    setSitename: function setSitename(siteName) {
        this.siteName = siteName;
    },
    setGetTripboards: function setGetTripboards(getTripboards) {
        this.getTripboards = getTripboards;
    },
    setCreateToast: function setCreateToast(createToast) {
        this.createToast = createToast;
    },
    create: function create(createBoard, newBoardName) {
        var tripBoardRef = this.tripBoardButton;
        var _tripBoardRef$props = tripBoardRef.props,
            adultsCount = _tripBoardRef$props.adultsCount,
            childrenCount = _tripBoardRef$props.childrenCount,
            listingId = _tripBoardRef$props.listingId,
            thumbnailUrl = _tripBoardRef$props.thumbnailUrl,
            petIncluded = _tripBoardRef$props.petIncluded,
            startDate = _tripBoardRef$props.startDate,
            endDate = _tripBoardRef$props.endDate;
        // guard against empty strings

        if (!startDate || !endDate) {
            startDate = null;
            endDate = null;
        }

        createBoard({
            listings: [{
                listingId: listingId,
                startDate: startDate,
                endDate: endDate
            }],
            adultsCount: adultsCount,
            childrenCount: childrenCount,
            petIncluded: petIncluded,
            startDate: startDate,
            endDate: endDate,
            name: newBoardName,
            thumbnailUrl: thumbnailUrl
        });

        this.close();
    },
    add: function add(addToBoard, boardId) {
        var _tripBoardButton$prop = this.tripBoardButton.props,
            adultsCount = _tripBoardButton$prop.adultsCount,
            childrenCount = _tripBoardButton$prop.childrenCount,
            listingId = _tripBoardButton$prop.listingId,
            petIncluded = _tripBoardButton$prop.petIncluded,
            thumbnailUrl = _tripBoardButton$prop.thumbnailUrl,
            tripboards = _tripBoardButton$prop.tripboards,
            startDate = _tripBoardButton$prop.startDate,
            endDate = _tripBoardButton$prop.endDate;

        addToBoard({
            adultsCount: adultsCount,
            boardId: boardId,
            childrenCount: childrenCount,
            listingId: listingId,
            petIncluded: petIncluded,
            startDate: startDate,
            endDate: endDate,
            thumbnailUrl: thumbnailUrl
        });

        var boardsPosition = tripboards.boards.findIndex(function (tripboard) {
            return tripboard.boardId === boardId;
        });
        var boardsLength = tripboards.boards.length;
        var tripboard = tripboards.boards[boardsPosition];

        // update UI
        this.confirm(tripboard.name, thumbnailUrl, listingId, boardId);
        this.close();

        // triger EDAP events
        _edap2.default.boardAdd(boardsPosition, boardsLength, listingId, boardId);
    },
    confirm: function confirm(name, thumbnail, listingId, boardId) {
        var _this = this;

        var toastMessage = function toastMessage() {
            return _react2.default.createElement(
                'span',
                null,
                _this.translations['tripboards.toaster.added.to'],
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'a',
                    { href: '/tripboard/' + boardId, className: 'toaster__toast-link' },
                    name
                )
            );
        };

        var onAutoClose = function onAutoClose() {
            _edap2.default.toasterAutoClose(listingId, boardId);
        };

        var onClose = function onClose() {
            _edap2.default.toasterClose(listingId, boardId);
        };

        var onContentClick = function onContentClick() {
            _edap2.default.toasterClick(listingId, boardId);
        };

        var onCloseClick = function onCloseClick() {
            _edap2.default.toasterDismiss(listingId, boardId);
        };

        this.createToast({
            onAutoClose: onAutoClose,
            onClose: onClose,
            onCloseClick: onCloseClick,
            onContentClick: onContentClick,
            renderContent: toastMessage,
            thumbnail: thumbnail,
            type: 'inverse'
        });

        _edap2.default.toasterView(listingId, boardId);
    },
    showCreateError: function showCreateError(listingId) {
        var _this2 = this;

        var toastMessage = function toastMessage() {
            return _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                _react2.default.createElement('i', { className: 'icon-alert icon-error icon-lg', 'aria-hidden': 'true' }),
                _react2.default.createElement(
                    'div',
                    { style: { paddingLeft: '15px' } },
                    _this2.translations['tripboards.error']
                )
            );
        };

        this.createToast({
            renderContent: toastMessage,
            type: 'inverse'
        });

        _edap2.default.toasterError(listingId);
    },
    getPropsFromTripboardButton: function getPropsFromTripboardButton(tripBoardButton) {
        var tripBoards = tripBoardButton.props.tripboards && tripBoardButton.props.tripboards.boards || [];
        var props = {
            listingId: tripBoardButton.props.listingId,
            position: tripBoardButton.props.position || 'right',
            refButton: tripBoardButton.refButton,
            thumbnailUrl: tripBoardButton.props.thumbnailUrl,
            createBoard: tripBoardButton.props.createBoard,
            addToBoard: tripBoardButton.props.addToBoard,
            translations: this.translations,
            tripBoards: tripBoards,
            rating: tripBoardButton.props.rating,
            headline: tripBoardButton.props.headline,
            reviewCount: tripBoardButton.props.reviewCount
        };
        return props;
    },
    remove: function remove(removeFromBoard, listingId) {
        removeFromBoard({ listingId: listingId });
        _edap2.default.heartClickOff(listingId);
    },
    open: function open(tripBoardButton) {
        this.tripBoardButton = tripBoardButton;
        this.translations = tripBoardButton.props.translations;

        var props = this.getPropsFromTripboardButton(tripBoardButton);

        // Position left on PDP instead of bottom.
        // TODO: We need to fix this in GT!!!!
        props.position = props.position === 'bottom' ? 'left' : props.position;

        // decorate
        props.onCreate = this.create.bind(this);
        props.onAdd = this.add.bind(this);

        if (!this.isRendered()) {
            this.render();
        }

        this.modal.open(props);

        _edap2.default.heartClickOn(props.listingId);

        if ("object" !== 'undefined' && typeof window.__ABACUS__ !== 'undefined') {
            this.testExposure.newModal.trigger();
        }

        return this;
    },
    render: function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var modalContainer = this.getContainerElement();
        this.modal = _reactDom2.default.render(_react2.default.createElement(_TripBoardModalContainer2.default, props), modalContainer);
    },
    getContainerElement: function getContainerElement() {
        var container = document.getElementById(this.id);

        if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', this.id);
            document.body.appendChild(container);
        }

        return container;
    },
    isRendered: function isRendered() {
        return this.modal instanceof _react2.default.Component;
    }
};

exports.default = TripBoard;
//# sourceMappingURL=TripBoard.js.map

/***/ }),

/***/ "DvwR":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("x//u");
var toIObject = __webpack_require__("ksFB");
var arrayIndexOf = __webpack_require__("PbQV")(false);
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "EJZz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Base = __webpack_require__("B/qS");

var _Base2 = _interopRequireDefault(_Base);

var _reactFormComponents = __webpack_require__("QyGt");

var _reactDetermineIfMobile = __webpack_require__("54yA");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _edap = __webpack_require__("5HME");

var _edap2 = _interopRequireDefault(_edap);

var _debounce = __webpack_require__("8fRV");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Guest Picker
 * wraps guest fields
*/

var keyChangeMap = {
    adultsCount: 'adults',
    childrenCount: 'children'
};

var GuestPicker = function (_Component) {
    _inherits(GuestPicker, _Component);

    function GuestPicker(props) {
        _classCallCheck(this, GuestPicker);

        var _this = _possibleConstructorReturn(this, (GuestPicker.__proto__ || Object.getPrototypeOf(GuestPicker)).call(this, props));

        _this.handleFocus = function () {
            if (_this.props.isMobile) {
                // Open, but set isDelayed to true so the component waits a moment to render
                _this.setState({
                    isOpen: true,
                    isDelayed: true,
                    undoState: {
                        adultsCount: _this.props.adultsCount,
                        childrenCount: _this.props.childrenCount,
                        petIncluded: _this.props.petIncluded
                    }
                }, function () {
                    _this.props.onOpen();
                });

                (0, _edap2.default)({
                    eventaction: 'popover shown',
                    eventcategory: 'guest selector'
                });
            } else {
                if (!_this.state.isOpen) {
                    _this.handleDebounceFocus();
                }

                var guestInput = (0, _reactDom.findDOMNode)(_this).querySelector('input');

                // prevent double setState when guestInput receives focus;
                if (document && document.activeElement !== guestInput) {
                    // as we may be clicking on the overlay, rather than tabbing to the input
                    // force focus of the input for text entry (text entry is TODO)
                    if (!_this.props.disableTextInput) {
                        guestInput.focus();
                    }

                    _this.setState({
                        isOpen: true,
                        undoState: {
                            adultsCount: _this.props.adultsCount,
                            childrenCount: _this.props.childrenCount,
                            petIncluded: _this.props.petIncluded
                        }
                    }, function () {
                        _this.props.onOpen();
                    });

                    // Listen for clicks outside of the popup and the input
                    window.setTimeout(function () {
                        window.addEventListener('click', _this.handleWindowClick);
                        document.documentElement.addEventListener('mouseup', _this.handleWindowClick);
                        document.documentElement.addEventListener('touchstart', _this.handleWindowClick);
                    }, 0);
                }
            }
        };

        _this.handleChange = function (key, value) {
            if (keyChangeMap[key]) {
                (0, _edap2.default)({
                    eventaction: 'counter button click',
                    eventcategory: 'guest selector',
                    eventlabel: keyChangeMap[key]
                });
            }
            _this.props.onChange(key, value);
        };

        _this.handleClear = function (event) {
            (0, _edap2.default)({
                eventaction: 'popover clear',
                eventcategory: 'guest selector'
            });
            event.preventDefault();
            _this.props.onClear();
        };

        _this.handleClose = function () {
            if (_this.state.isOpen) {
                (0, _edap2.default)({
                    eventaction: 'popover hidden',
                    eventcategory: 'guest selector'
                });
                /* We need to make sure the state is updated before calling onClose. If it is not,
                before componentWillReceiveProps will then call onExit if it is controlled by the parent since
                the parent re-updates the state */
                _this.setState({ isOpen: false }, function () {
                    _this.props.onClose();
                });
            }
        };

        _this.handleExit = function () {
            if (_this.state.isOpen) {
                (0, _edap2.default)({
                    eventaction: 'popover hidden',
                    eventcategory: 'guest selector'
                });

                _this.setState({ isOpen: false }, function () {
                    _this.props.onExit(_this.state.undoState);
                });
            }
        };

        _this.handleWindowClick = function (event) {
            // We want to close the tooltip when the user clicks anything on the screen,
            // outside of the tooltip. This is for non-mobile.
            var isWithin = _this.contains(_this.input, event.target) || _this.contains(_this.guestSelector, event.target) || _this.contains(_this.overlay, event.target);

            if (isWithin) {
                event.stopImmediatePropagation();
            } else {
                // Stop listening for clicks outside of the tooltip's parent element
                window.setTimeout(function () {
                    window.removeEventListener('click', _this.handleWindowClick);
                    document.documentElement.removeEventListener('mouseup', _this.handleWindowClick);
                    document.documentElement.removeEventListener('touchstart', _this.handleWindowClick);
                }, 0);
            }
        };

        _this.compRefFun = function (c) {
            _this.guestSelector = c;
        };

        _this.state = {
            isOpen: props.isOpen,
            undoState: {}
        };

        // debounce for desktop (see TODO on line 146)
        _this.handleDebounceFocus = (0, _debounce2.default)(function () {
            (0, _edap2.default)({
                eventaction: 'popover shown',
                eventcategory: 'guest selector'
            });
        }, 0).bind(_this);

        _this.handleWindowClick = (0, _debounce2.default)(_this.handleWindowClick.bind(_this), 0, true);
        return _this;
    }

    _createClass(GuestPicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isOpen !== nextProps.isOpen && this.state.isOpen !== nextProps.isOpen) {
                if (nextProps.isOpen) {
                    this.handleFocus();
                } else {
                    // call handleExit not handleClose since we don't want to confirm the changes
                    this.handleExit();
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            // TODO: jank check
            if (this.props.isMobile && this.state.isDelayed) {
                window.setTimeout(function () {
                    _this2.setState({ isDelayed: false });
                }, 50);
            }
        }
    }, {
        key: 'contains',
        value: function contains(elem, target) {
            return elem && (0, _reactDom.findDOMNode)(elem).contains(target);
        }

        /**
         * compRefFun
         * Used to compare against window for onClose
         */

    }, {
        key: 'renderInput',


        // eslint-disable-next-line complexity
        value: function renderInput() {
            var _this3 = this;

            var _props = this.props,
                label = _props.label,
                name = _props.name,
                guestLabel = _props.guestLabel,
                errorMsg = _props.errorMsg,
                className = _props.className,
                readOnly = _props.readOnly,
                wdioPrefix = _props.wdioPrefix,
                inputIcon = _props.inputIcon,
                positionIconRight = _props.positionIconRight;


            var inputClasses = (0, _classnames2.default)(className, {
                'not-empty': this.state.isOpen,
                'focus': this.state.isOpen
            });

            var overlayClasses = (0, _classnames2.default)('picker__overlay', {
                'picker__overlay--selectable': !readOnly
            });

            return _react2.default.createElement(
                'div',
                { className: 'position-relative' },
                _react2.default.createElement(_reactFormComponents.FormInput, {
                    className: inputClasses,
                    name: name,
                    label: label,
                    value: guestLabel,
                    onChange: this.handleChangeInput,
                    onFocus: readOnly ? null : this.handleFocus,
                    errorMsg: errorMsg,
                    ref: function ref(c) {
                        return _this3.input = c;
                    } //eslint-disable-line
                    , readOnly: readOnly ? 'readOnly' : '',
                    'data-wdio': wdioPrefix ? wdioPrefix + '-guest-picker-input' : 'guest-picker-input',
                    leftContent: !positionIconRight ? inputIcon : null,
                    rightContent: positionIconRight ? inputIcon : null
                }),
                _react2.default.createElement('div', {
                    className: overlayClasses,
                    ref: function ref(c) {
                        return _this3.overlay = c;
                    } //eslint-disable-line
                    , onClick: readOnly ? null : this.handleFocus
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = (0, _classnames2.default)(this.props.className, 'guest-picker');
            return _react2.default.createElement(_Base2.default, _extends({}, this.props, {
                className: classes,
                inputs: this.renderInput(),
                fadeOutDuration: this.props.fadeOutDuration,
                isMobile: this.props.isMobile,
                isOpen: this.state.isOpen,
                onModalClose: this.handleExit,
                compRefFun: this.compRefFun,
                onChange: this.handleChange,
                onClear: this.handleClear,
                onApply: this.handleClose,
                onClose: this.handleExit,
                formPrefixElement: this.props.formPrefixElement,
                formSuffixElement: this.props.formSuffixElement
            }));
        }
    }]);

    return GuestPicker;
}(_react.Component);

GuestPicker.propTypes = {
    /** Add content to the left of the input. This can be a string, element, or component */
    inputIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
    /** Left/right alignment of icon in input field */
    positionIconRight: _propTypes2.default.bool,
    /** Guest Label */
    guestLabel: _propTypes2.default.string,
    /** Form input's label */
    label: _propTypes2.default.string.isRequired,
    /** Form input's name property */
    name: _propTypes2.default.string.isRequired,
    /** Form input's error message */
    errorMsg: _propTypes2.default.node,
    /** Form input Display-only mode */
    readOnly: _propTypes2.default.bool,
    /** By default, the input element is given a data-wdio attribute of "guest-picker-input".
    If you have more than one on a page you can add a prefix by using this property. */
    wdioPrefix: _propTypes2.default.bool,

    /** Number of Adults */
    adultsCount: _propTypes2.default.number,
    /** Label for Adults */
    adultsLabel: _propTypes2.default.string,
    /** Max Number of Adults */
    adultsMax: _propTypes2.default.number,
    /** Min Number of Adults */
    adultsMin: _propTypes2.default.number,
    /** Number of Children */
    childrenCount: _propTypes2.default.number,
    /** Label for Children */
    childrenLabel: _propTypes2.default.string,
    /** Max Number of Children */
    childrenMax: _propTypes2.default.number,
    /** Min Number of Children */
    childrenMin: _propTypes2.default.number,
    /** pet Checked false by default */
    petIncluded: _propTypes2.default.bool,
    /** Label for pet Yes */
    petLabel: _propTypes2.default.string,
    /** Label for pet Yes */
    petYesLabel: _propTypes2.default.string,
    /** Label for pet No */
    petNoLabel: _propTypes2.default.string,
    /** Show pet Radio Group false by default */
    showPetOption: _propTypes2.default.bool,

    /** Show continue button on mobile */
    showContinue: _propTypes2.default.bool,
    /** Disable apply/continue button on desktop/mobile (if shown) */
    disableButton: _propTypes2.default.bool,

    /** Continue Button Label */
    continueButtonLabel: _propTypes2.default.string,
    /** Clear Button Label */
    clearButtonLabel: _propTypes2.default.string,
    /** Show Clear Button */
    showClearButton: _propTypes2.default.bool,
    /** Apply Button Label */
    applyButtonLabel: _propTypes2.default.string,

    /** Function to call when a guest picker is closed */
    onClose: _propTypes2.default.func,
    /** Function to call when a guest picker changes */
    onChange: _propTypes2.default.func,
    /** Function to call when a guest picker is cleared */
    onClear: _propTypes2.default.func,

    /** Prevents keyboard input. Useful on iPad to prevent software keyboard from popping up. */
    disableTextInput: _propTypes2.default.bool,

    /** State of of the modal (defaults to false) */
    isOpen: _propTypes2.default.bool,
    /** Callback for when the guest picker opens */
    onOpen: _propTypes2.default.func,

    /** Where should the tooltip be displayed (defaults to "top").
    Supports "top", "bottom", "right", "left". Checkout the react-tooltip
    documentation for more information */
    placement: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right']),
    /** Centers tooltip position (defaults to true) */
    centered: _propTypes2.default.bool,

    /** Duration of the fade transition when the tooltip closes in milliseconds */
    fadeOutDuration: _propTypes2.default.number,

    /* Element to render above +/- buttons; can be string, element, or component */
    formPrefixElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
    /* Element to render below +/- buttons; can be string, element, or component */
    formSuffixElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func])
};
GuestPicker.defaultProps = {
    inputIcon: null,
    positionIconRight: false,
    guestLabel: 'Guest(s)',
    clearButtonLabel: 'Clear',
    showClearButton: true,
    continueButtonLabel: 'Continue',
    applyButtonLabel: 'Apply',
    modalTitle: 'Select guests',
    petLabel: 'pets',
    onClose: function onClose() {},
    onChange: function onChange() {},
    onClear: function onClear() {},
    onExit: function onExit() {},
    onOpen: function onOpen() {},
    showContinue: true,
    disableButton: false,
    readOnly: false,
    disableTextInput: false,
    isOpen: false,
    placement: 'top',
    centered: true,
    fadeOutDuration: 400,
    formPrefixElement: null,
    formSuffixElement: null
};
exports.default = (0, _reactDetermineIfMobile2.default)(GuestPicker);
//# sourceMappingURL=GuestPicker.js.map

/***/ }),

/***/ "EXV4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactApollo = __webpack_require__("3zLD");

var _graphql = __webpack_require__("qm98");

var withUpdateStayOnTripBoard = (0, _reactApollo.graphql)(_graphql.updateStayMutation, {
    options: function options(props) {
        return _extends({}, props.mutationConfig);
    },
    name: 'updateStayOnTripBoard',
    alias: 'withUpdateStayMutation'
});

exports.default = withUpdateStayOnTripBoard;
//# sourceMappingURL=with-update-stay-on-trip-board.js.map

/***/ }),

/***/ "EarI":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "EgLL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMonthNamesInstance = undefined;

var _LanguageTag = __webpack_require__("r94d");

var _LanguageTag2 = _interopRequireDefault(_LanguageTag);

var _Objects = __webpack_require__("q4WY");

var _Labels = __webpack_require__("wc36");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _instances = {};

function MonthNames(locale, labels) {
    this.monthNames = (0, _Objects.getObjectKeyOfLength)(labels, 'monthNames', 12) || (0, _Labels.getLocaleDateStrings)(locale, { month: 'long' }, true) || (0, _Labels.getDefaultLabels)('monthNames') || [];
    this.shortMonthNames = (0, _Objects.getObjectKeyOfLength)(labels, 'shortMonthNames', 12) || (0, _Labels.getLocaleDateStrings)(locale, { month: 'short' }, true) || (0, _Labels.getDefaultLabels)('shortMonthNames') || [];
}

MonthNames.prototype.getMonthNames = function () {
    return this.monthNames;
};

MonthNames.prototype.getShortMonthNames = function () {
    return this.shortMonthNames;
};

function getMonthNamesInstance(locale, labels) {
    var languageTag = locale ? new _LanguageTag2.default(locale) : {};
    var code = languageTag.code || 'default';

    labels = labels || {};

    if (!(0, _Objects.isEmptyObject)(labels)) {
        return new MonthNames(languageTag.code, labels);
    }

    if (!_instances[code]) {
        _instances[code] = new MonthNames(languageTag.code, labels);
    }

    return _instances[code];
}

exports.getMonthNamesInstance = getMonthNamesInstance;
//# sourceMappingURL=MonthNames.js.map

/***/ }),

/***/ "Ey83":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F1sa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("K6Pp");

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "F5GY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("gYGY");

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "F6Hy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__("PirY");

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),

/***/ "F6ea":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F8cY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardCarousel = undefined;

var _CardCarousel = __webpack_require__("fdqI");

var _CardCarousel2 = _interopRequireDefault(_CardCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CardCarousel = _CardCarousel2.default;
exports.default = _CardCarousel2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "FCbp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _abacusClientUtils = __webpack_require__("k4AA");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Ensures the test exposure is fired only once.
 * @example
 * const testExposure = new TestExposureOnce('ha_pulse_test_name');
 * testExposure.trigger();
 */

var TestExposureOnce = function () {
    function TestExposureOnce(experimentName) {
        _classCallCheck(this, TestExposureOnce);

        this.isLogged = false;
        this.name = experimentName;
    }

    _createClass(TestExposureOnce, [{
        key: 'trigger',
        value: function trigger() {
            // only log test exposure once
            if (!this.isLogged) {
                (0, _abacusClientUtils.evaluateExperimentAndLog)(this.name);
                this.isLogged = true;
            }
        }
    }]);

    return TestExposureOnce;
}();

exports.default = TestExposureOnce;
//# sourceMappingURL=testExposureOnce.js.map

/***/ }),

/***/ "FJL/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FKWp":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "FXRR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FYws":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fy0/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("vmzn");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if ("object" !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    ("object" !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "GAvn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setTag = setTag;
exports.passProps = passProps;
/**
 * @file style constants and static functions
 */

var block = exports.block = { display: 'block' };

var sizerWrapperStyles = exports.sizerWrapperStyles = _extends({}, block, {
  position: 'absolute',
  left: '-20000px',
  width: '100%'
});

var spreaderStyles = exports.spreaderStyles = _extends({}, block, {
  overflow: 'hidden',
  height: '0px',
  width: '100%'
});

var wrapperStyles = exports.wrapperStyles = _extends({}, block, {
  position: 'relative',
  overflow: 'hidden'
});

var childrenStyles = exports.childrenStyles = _extends({}, block, {
  width: '100%'
});

var tagWhitelist = ['div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'];

function setTag(tagName) {
  if (!tagName) {
    return 'div';
  }

  var foundTag = tagWhitelist.find(function (tag) {
    return tagName === tag;
  });
  return foundTag || 'div';
}

var eventWhitelist = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp'];

function passProps(props) {
  return (Object.keys(props) || {}).reduce(function (passed, key) {
    var hasEvent = eventWhitelist.find(function (event) {
      return event === key;
    });
    var passedCopy = _extends({}, passed);

    if (hasEvent) {
      passedCopy[key] = props[key];
    }

    return passedCopy;
  }, {});
}

// Polyfill
if (!Array.prototype.find) {
  /* eslint no-extend-native: [0], prefer-rest-params: [0] */
  Array.prototype.find = function find(predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0; // eslint-disable-line
    var thisArg = arguments[1];
    var value = void 0;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

/***/ }),

/***/ "GCs6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var toPrimitive = __webpack_require__("9MbE");
var dP = Object.defineProperty;

exports.f = __webpack_require__("qs+f") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "GhAV":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("W6Rd");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "GmwO":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "Gq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GvH4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = LRUCache

// This will be a proper iterable 'Map' in engines that support it,
// or a fakey-fake PseudoMap in older versions.
var Map = __webpack_require__("H8mJ")
var util = __webpack_require__("OMJi")

// A linked list to keep track of recently-used-ness
var Yallist = __webpack_require__("ukpD")

// use symbols if possible, otherwise just _props
var hasSymbol = typeof Symbol === 'function'
var makeSymbol
if (hasSymbol) {
  makeSymbol = function (key) {
    return Symbol.for(key)
  }
} else {
  makeSymbol = function (key) {
    return '_' + key
  }
}

var MAX = makeSymbol('max')
var LENGTH = makeSymbol('length')
var LENGTH_CALCULATOR = makeSymbol('lengthCalculator')
var ALLOW_STALE = makeSymbol('allowStale')
var MAX_AGE = makeSymbol('maxAge')
var DISPOSE = makeSymbol('dispose')
var NO_DISPOSE_ON_SET = makeSymbol('noDisposeOnSet')
var LRU_LIST = makeSymbol('lruList')
var CACHE = makeSymbol('cache')

function naiveLength () { return 1 }

// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
function LRUCache (options) {
  if (!(this instanceof LRUCache)) {
    return new LRUCache(options)
  }

  if (typeof options === 'number') {
    options = { max: options }
  }

  if (!options) {
    options = {}
  }

  var max = this[MAX] = options.max
  // Kind of weird to have a default max of Infinity, but oh well.
  if (!max ||
      !(typeof max === 'number') ||
      max <= 0) {
    this[MAX] = Infinity
  }

  var lc = options.length || naiveLength
  if (typeof lc !== 'function') {
    lc = naiveLength
  }
  this[LENGTH_CALCULATOR] = lc

  this[ALLOW_STALE] = options.stale || false
  this[MAX_AGE] = options.maxAge || 0
  this[DISPOSE] = options.dispose
  this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false
  this.reset()
}

// resize the cache when the max changes.
Object.defineProperty(LRUCache.prototype, 'max', {
  set: function (mL) {
    if (!mL || !(typeof mL === 'number') || mL <= 0) {
      mL = Infinity
    }
    this[MAX] = mL
    trim(this)
  },
  get: function () {
    return this[MAX]
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'allowStale', {
  set: function (allowStale) {
    this[ALLOW_STALE] = !!allowStale
  },
  get: function () {
    return this[ALLOW_STALE]
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'maxAge', {
  set: function (mA) {
    if (!mA || !(typeof mA === 'number') || mA < 0) {
      mA = 0
    }
    this[MAX_AGE] = mA
    trim(this)
  },
  get: function () {
    return this[MAX_AGE]
  },
  enumerable: true
})

// resize the cache when the lengthCalculator changes.
Object.defineProperty(LRUCache.prototype, 'lengthCalculator', {
  set: function (lC) {
    if (typeof lC !== 'function') {
      lC = naiveLength
    }
    if (lC !== this[LENGTH_CALCULATOR]) {
      this[LENGTH_CALCULATOR] = lC
      this[LENGTH] = 0
      this[LRU_LIST].forEach(function (hit) {
        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key)
        this[LENGTH] += hit.length
      }, this)
    }
    trim(this)
  },
  get: function () { return this[LENGTH_CALCULATOR] },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'length', {
  get: function () { return this[LENGTH] },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'itemCount', {
  get: function () { return this[LRU_LIST].length },
  enumerable: true
})

LRUCache.prototype.rforEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this[LRU_LIST].tail; walker !== null;) {
    var prev = walker.prev
    forEachStep(this, fn, walker, thisp)
    walker = prev
  }
}

function forEachStep (self, fn, node, thisp) {
  var hit = node.value
  if (isStale(self, hit)) {
    del(self, node)
    if (!self[ALLOW_STALE]) {
      hit = undefined
    }
  }
  if (hit) {
    fn.call(thisp, hit.value, hit.key, self)
  }
}

LRUCache.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this[LRU_LIST].head; walker !== null;) {
    var next = walker.next
    forEachStep(this, fn, walker, thisp)
    walker = next
  }
}

LRUCache.prototype.keys = function () {
  return this[LRU_LIST].toArray().map(function (k) {
    return k.key
  }, this)
}

LRUCache.prototype.values = function () {
  return this[LRU_LIST].toArray().map(function (k) {
    return k.value
  }, this)
}

LRUCache.prototype.reset = function () {
  if (this[DISPOSE] &&
      this[LRU_LIST] &&
      this[LRU_LIST].length) {
    this[LRU_LIST].forEach(function (hit) {
      this[DISPOSE](hit.key, hit.value)
    }, this)
  }

  this[CACHE] = new Map() // hash of items by key
  this[LRU_LIST] = new Yallist() // list of items in order of use recency
  this[LENGTH] = 0 // length of items in the list
}

LRUCache.prototype.dump = function () {
  return this[LRU_LIST].map(function (hit) {
    if (!isStale(this, hit)) {
      return {
        k: hit.key,
        v: hit.value,
        e: hit.now + (hit.maxAge || 0)
      }
    }
  }, this).toArray().filter(function (h) {
    return h
  })
}

LRUCache.prototype.dumpLru = function () {
  return this[LRU_LIST]
}

LRUCache.prototype.inspect = function (n, opts) {
  var str = 'LRUCache {'
  var extras = false

  var as = this[ALLOW_STALE]
  if (as) {
    str += '\n  allowStale: true'
    extras = true
  }

  var max = this[MAX]
  if (max && max !== Infinity) {
    if (extras) {
      str += ','
    }
    str += '\n  max: ' + util.inspect(max, opts)
    extras = true
  }

  var maxAge = this[MAX_AGE]
  if (maxAge) {
    if (extras) {
      str += ','
    }
    str += '\n  maxAge: ' + util.inspect(maxAge, opts)
    extras = true
  }

  var lc = this[LENGTH_CALCULATOR]
  if (lc && lc !== naiveLength) {
    if (extras) {
      str += ','
    }
    str += '\n  length: ' + util.inspect(this[LENGTH], opts)
    extras = true
  }

  var didFirst = false
  this[LRU_LIST].forEach(function (item) {
    if (didFirst) {
      str += ',\n  '
    } else {
      if (extras) {
        str += ',\n'
      }
      didFirst = true
      str += '\n  '
    }
    var key = util.inspect(item.key).split('\n').join('\n  ')
    var val = { value: item.value }
    if (item.maxAge !== maxAge) {
      val.maxAge = item.maxAge
    }
    if (lc !== naiveLength) {
      val.length = item.length
    }
    if (isStale(this, item)) {
      val.stale = true
    }

    val = util.inspect(val, opts).split('\n').join('\n  ')
    str += key + ' => ' + val
  })

  if (didFirst || extras) {
    str += '\n'
  }
  str += '}'

  return str
}

LRUCache.prototype.set = function (key, value, maxAge) {
  maxAge = maxAge || this[MAX_AGE]

  var now = maxAge ? Date.now() : 0
  var len = this[LENGTH_CALCULATOR](value, key)

  if (this[CACHE].has(key)) {
    if (len > this[MAX]) {
      del(this, this[CACHE].get(key))
      return false
    }

    var node = this[CACHE].get(key)
    var item = node.value

    // dispose of the old one before overwriting
    // split out into 2 ifs for better coverage tracking
    if (this[DISPOSE]) {
      if (!this[NO_DISPOSE_ON_SET]) {
        this[DISPOSE](key, item.value)
      }
    }

    item.now = now
    item.maxAge = maxAge
    item.value = value
    this[LENGTH] += len - item.length
    item.length = len
    this.get(key)
    trim(this)
    return true
  }

  var hit = new Entry(key, value, len, now, maxAge)

  // oversized objects fall out of cache automatically.
  if (hit.length > this[MAX]) {
    if (this[DISPOSE]) {
      this[DISPOSE](key, value)
    }
    return false
  }

  this[LENGTH] += hit.length
  this[LRU_LIST].unshift(hit)
  this[CACHE].set(key, this[LRU_LIST].head)
  trim(this)
  return true
}

LRUCache.prototype.has = function (key) {
  if (!this[CACHE].has(key)) return false
  var hit = this[CACHE].get(key).value
  if (isStale(this, hit)) {
    return false
  }
  return true
}

LRUCache.prototype.get = function (key) {
  return get(this, key, true)
}

LRUCache.prototype.peek = function (key) {
  return get(this, key, false)
}

LRUCache.prototype.pop = function () {
  var node = this[LRU_LIST].tail
  if (!node) return null
  del(this, node)
  return node.value
}

LRUCache.prototype.del = function (key) {
  del(this, this[CACHE].get(key))
}

LRUCache.prototype.load = function (arr) {
  // reset the cache
  this.reset()

  var now = Date.now()
  // A previous serialized cache has the most recent items first
  for (var l = arr.length - 1; l >= 0; l--) {
    var hit = arr[l]
    var expiresAt = hit.e || 0
    if (expiresAt === 0) {
      // the item was created without expiration in a non aged cache
      this.set(hit.k, hit.v)
    } else {
      var maxAge = expiresAt - now
      // dont add already expired items
      if (maxAge > 0) {
        this.set(hit.k, hit.v, maxAge)
      }
    }
  }
}

LRUCache.prototype.prune = function () {
  var self = this
  this[CACHE].forEach(function (value, key) {
    get(self, key, false)
  })
}

function get (self, key, doUse) {
  var node = self[CACHE].get(key)
  if (node) {
    var hit = node.value
    if (isStale(self, hit)) {
      del(self, node)
      if (!self[ALLOW_STALE]) hit = undefined
    } else {
      if (doUse) {
        self[LRU_LIST].unshiftNode(node)
      }
    }
    if (hit) hit = hit.value
  }
  return hit
}

function isStale (self, hit) {
  if (!hit || (!hit.maxAge && !self[MAX_AGE])) {
    return false
  }
  var stale = false
  var diff = Date.now() - hit.now
  if (hit.maxAge) {
    stale = diff > hit.maxAge
  } else {
    stale = self[MAX_AGE] && (diff > self[MAX_AGE])
  }
  return stale
}

function trim (self) {
  if (self[LENGTH] > self[MAX]) {
    for (var walker = self[LRU_LIST].tail;
         self[LENGTH] > self[MAX] && walker !== null;) {
      // We know that we're about to delete this one, and also
      // what the next least recently used key will be, so just
      // go ahead and set it now.
      var prev = walker.prev
      del(self, walker)
      walker = prev
    }
  }
}

function del (self, node) {
  if (node) {
    var hit = node.value
    if (self[DISPOSE]) {
      self[DISPOSE](hit.key, hit.value)
    }
    self[LENGTH] -= hit.length
    self[CACHE].delete(hit.key)
    self[LRU_LIST].removeNode(node)
  }
}

// classy, since V8 prefers predictable objects.
function Entry (key, value, length, now, maxAge) {
  this.key = key
  this.value = value
  this.length = length
  this.now = now
  this.maxAge = maxAge || 0
}


/***/ }),

/***/ "H/Ty":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isValidEntityType = isValidEntityType;
exports.isValidEntityArgs = isValidEntityArgs;
exports.trigger = trigger;
exports.tripboardEntityAction = tripboardEntityAction;
var getEventLabel = exports.getEventLabel = function getEventLabel(listingId, boardId) {
    return 'lid=' + listingId + (boardId ? ';bid=' + boardId : '');
};

var generic = exports.generic = {
    CATEGORY: 'tripboards',
    // triggered on add, whether a new or existing board
    // only triggered if API call was successful
    BOARD_SAVED: {
        eventaction: 'board.saved',
        getLabel: function getLabel() {
            var isNewBoard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var adultsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var childrenCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var petIncluded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var startDate = arguments[4];
            var endDate = arguments[5];

            var label = 'isnewboard=' + (isNewBoard ? 1 : 0) + ';';

            if (startDate && endDate) {
                label = label + 'start=' + startDate + ';end=' + endDate + ';';
            }
            if (childrenCount !== null) {
                label += 'childrenCount=' + childrenCount + ';';
            }
            if (petIncluded !== null) {
                label += 'petIncluded=' + petIncluded + ';';
            }
            if (adultsCount !== null) {
                label += 'adultsCount=' + adultsCount + ';';
            }

            return label;
        }
    },
    // triggered when adding to an existing board
    // triggered before API call is made
    BOARD_ADD: {
        eventaction: 'board.existing.attempt',
        getLabel: function getLabel(position, total) {
            // start position index at 1 instead of 0
            return 'position=' + (position + 1) + ';total=' + total + ';';
        }
    },
    // triggered when modal `X` is pressed for existing boards flow
    BOARD_ADD_DISMISS: {
        eventaction: 'board.existing.dismiss.pressed'
    },
    // triggered if ADD API call fails
    BOARD_ADD_ERROR: {
        eventaction: 'board.existing.error'
    },
    // triggered when adding to a new board
    // triggered before API call is made
    BOARD_CREATE: {
        eventaction: 'board.create.attempt'
        // eventlabel: ${boardName}
    },
    // triggered when `Create new list` is clicked
    BOARD_CREATE_CLICK: {
        eventaction: 'board.create.click'
    },
    // triggered when `Cancel` is pressed
    BOARD_CREATE_CANCEL: {
        eventaction: 'board.create.cancel.pressed'
        // eventlabel: ${boardName}
    },
    // triggered when modal `X` is pressed for create board flow
    BOARD_CREATE_DISMISS: {
        eventaction: 'board.create.dismiss.pressed'
        // eventlabel: ${boardName}
    },
    // triggered if create API call fails
    BOARD_CREATE_ERROR: {
        eventaction: 'board.create.error'
    },
    // triggered when heart is "hearted"
    // triggered before any API calls are made
    HEART_CLICK_ON: {
        eventaction: 'heart.click.on'
    },
    // triggered when heart is "unhearted"
    // triggered before API call is made
    HEART_CLICK_OFF: {
        eventaction: 'heart.click.off'
    },

    TOASTER_AUTOCLOSE: 'toaster.autoclose',

    TOASTER_CLICK: 'toaster.click',

    TOASTER_CLOSE: 'toaster.close',

    TOASTER_DISMISS: 'toaster.dismiss',

    TOASTER_ERROR: 'toaster.error',

    TOASTER_VIEW: 'toaster.view',

    // simple wrapper to always pass `Tripboards` as the EDAP category
    // and listingId and boardId (if we have it) with every event
    trigger: function trigger() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var listingId = arguments[1];
        var boardId = arguments[2];

        var eventcategory = generic.CATEGORY;
        var eventaction = event.eventaction,
            eventlabel = event.eventlabel;

        var label = getEventLabel(listingId, boardId);

        eventlabel = eventlabel ? '' + eventlabel + label : label;

        if (window && window.edap && window.edap.trigger) {
            window.edap.trigger('generic.event', {
                eventaction: eventaction,
                eventcategory: eventcategory,
                eventlabel: eventlabel
            });
        }
        return {
            eventaction: eventaction,
            eventcategory: eventcategory,
            eventlabel: eventlabel
        };
    }
};

generic.boardSaved = function boardSaved(isNewBoard, adultsCount, childrenCount, petIncluded, startDate, endDate, listingId, boardId) {
    generic.trigger({
        eventaction: generic.BOARD_SAVED.eventaction,
        eventlabel: generic.BOARD_SAVED.getLabel(isNewBoard, adultsCount, childrenCount, petIncluded, startDate, endDate)
    }, listingId, boardId);
};

generic.boardError = function boardError(listingId, boardId) {
    generic.trigger(generic.BOARD_ADD_ERROR, listingId, boardId);
};

generic.boardAdd = function boardAdd(boardsPosition, boardsLength, listingId, boardId) {
    generic.trigger({
        eventaction: generic.BOARD_ADD.eventaction,
        eventlabel: generic.BOARD_ADD.getLabel(boardsPosition, boardsLength)
    }, listingId, boardId);
};

generic.heartClickOff = function heartClickOff(listingId) {
    generic.trigger(generic.HEART_CLICK_OFF, listingId);
};

generic.heartClickOn = function heartClickOn(listingId) {
    generic.trigger(generic.HEART_CLICK_ON, listingId);
};

generic.boardCreateClick = function boardCreateClick(listingId) {
    generic.trigger(generic.BOARD_CREATE_CLICK, listingId);
};

generic.boardCreateCancel = function boardCreateCancel(listingId, newBoardName) {
    generic.trigger({
        eventaction: generic.BOARD_CREATE_CANCEL.eventaction,
        eventlabel: 'name=' + newBoardName + ';'
    }, listingId);
};

generic.boardCreateDismiss = function boardCreateDismiss(listingId, newBoardName) {
    generic.trigger({
        eventaction: generic.BOARD_CREATE_DISMISS.eventaction,
        eventlabel: 'name=' + newBoardName + ';'
    }, listingId);
};

generic.boardAddDismiss = function boardAddDismiss(listingId) {
    generic.trigger(generic.BOARD_ADD_DISMISS, listingId);
};

generic.boardCreate = function boardCreate(listingId, newBoardName) {
    generic.trigger({
        eventaction: generic.BOARD_CREATE.eventaction,
        eventlabel: 'name=' + newBoardName + ';'
    }, listingId);
};

generic.boardCreateError = function boardCreateError(listingId) {
    generic.trigger(generic.BOARD_CREATE_ERROR, listingId);
};

generic.boardError = function boardError(listingId, boardId) {
    generic.trigger(generic.BOARD_ADD_ERROR, listingId, boardId);
};

generic.toasterAutoClose = function (listingId, boardId) {
    generic.trigger({ eventaction: generic.TOASTER_AUTOCLOSE }, listingId, boardId);
};

generic.toasterClick = function (listingId, boardId) {
    generic.trigger({ eventaction: generic.TOASTER_CLICK }, listingId, boardId);
};

generic.toasterClose = function (listingId, boardId) {
    generic.trigger({ eventaction: generic.TOASTER_CLOSE }, listingId, boardId);
};

generic.toasterDismiss = function (listingId, boardId) {
    generic.trigger({ eventaction: generic.TOASTER_DISMISS }, listingId, boardId);
};

generic.toasterError = function (listingId) {
    generic.trigger({ eventaction: generic.TOASTER_ERROR }, listingId);
};

generic.toasterView = function (listingId, boardId) {
    generic.trigger({ eventaction: generic.TOASTER_VIEW }, listingId, boardId);
};

/** @name actionstate edap enum */
var ACTION_STATE = exports.ACTION_STATE = {
    OFF: 'off',
    ON: 'on'
};

/** @name entitytype edap enum (edap-integrations@8.6.0) */
var ENTITY_TYPE = exports.ENTITY_TYPE = {
    BOARD: 'trip board', // @entityvalue: '<trip board uuid>' '3635e571-a3f9-4af6-a252-6019b78e2992'
    LISTING: 'unit', // @entityvlaue: '<listingid>' '321.21011.21011'
    DATE: 'date', // @entityvlaue: '<date>' '2014-04-20'
    GUESTS: 'guests', // @entityvalue: '<guest count>' '2'
    CHILDREN: 'children', // @entityvalue: '<child count>' '0'
    PETS: 'pets', // @entityvalue: '<pets count>' '0' Not a boolean??????????????
    ROLE: 'role' // @entityvalue: '<role>' 'collaborator'
};

// named events (edap-integrations@8.6.0)
var named = exports.named = {
    TRIP_BOARD_REMOVE: 'tripboards.remove',
    TRIP_BOARD_ADD: 'tripboards.add',
    TRIP_BOARD_CREATE: 'tripboards.create',
    HEARTING_CLICK: 'hearting.click'
};

// named event utility methods
function isValidEntityType(type) {
    var types = Object.values(ENTITY_TYPE);
    return types.indexOf(type) !== -1;
}

function isValidEntityArgs(boardid, entitytype) {
    return boardid && isValidEntityType(entitytype);
}

function trigger(name, data) {
    if (window && window.edap && window.edap.trigger) {
        window.edap.trigger(name, data);
    }
}

function tripboardEntityAction(namedEvent) {
    return function (boardid, entitytype, entityvalue) {
        if (!isValidEntityArgs(boardid, entitytype)) {
            return;
        }
        trigger(namedEvent, {
            boardid: boardid,
            entitytype: entitytype,
            entityvalue: entityvalue
        });
    };
}

// named event methods
named.remove = function (entitytype, entityvalue) {
    trigger(named.TRIP_BOARD_REMOVE, {
        entitytype: entitytype,
        entityvalue: entityvalue
    });
};

named.add = function (boardid, entitytype, entityvalue) {
    if (!isValidEntityArgs(boardid, entitytype)) {
        return;
    }
    trigger(named.TRIP_BOARD_ADD, {
        boardid: boardid,
        entitytype: entitytype,
        entityvalue: entityvalue
    });
};

named.create = function tripboardCreate(boardid) {
    if (!boardid) {
        return;
    }
    trigger(named.TRIP_BOARD_CREATE, { boardid: boardid });
};

named.heartClickOff = function tripboardHeartClickOff(listingId) {
    if (!listingId) {
        return;
    }

    trigger(named.HEARTING_CLICK, {
        actionstate: ACTION_STATE.OFF,
        eventlistingids: listingId
    });
};

named.heartClickOn = function heartClickOn(listingId) {
    if (!listingId) {
        return;
    }

    trigger(named.HEARTING_CLICK, {
        actionstate: ACTION_STATE.ON,
        eventlistingids: listingId
    });
};

var methods = {
    boardAdd: function boardAdd(boardsPosition, boardsLength, listingId, boardId) {
        generic.boardAdd(boardsPosition, boardsLength, listingId, boardId);
        named.add(boardId, ENTITY_TYPE.LISTING, listingId);
    },


    boardAddDismiss: generic.boardAddDismiss,

    boardCreate: generic.boardCreate,

    boardCreateCancel: generic.boardCreateCancel,

    boardCreateClick: generic.boardCreateClick,

    boardCreateDismiss: generic.boardCreateDismiss,

    boardCreateError: generic.boardCreateError,

    boardError: generic.boardError,

    boardSaved: generic.boardSaved,

    create: function create(boardId, listingId) {
        named.create(boardId);
        named.add(boardId, ENTITY_TYPE.LISTING, listingId);
    },
    heartClickOff: function heartClickOff(listingId) {
        generic.heartClickOff(listingId);
        named.heartClickOff(listingId, ACTION_STATE.OFF);
        named.remove(ENTITY_TYPE.LISTING, listingId);
    },
    heartClickOn: function heartClickOn(listingId) {
        generic.heartClickOn(listingId);
        named.heartClickOn(listingId);
    },


    toasterAutoClose: generic.toasterAutoClose,

    toasterClick: generic.toasterClick,

    toasterClose: generic.toasterClose,

    toasterDismiss: generic.toasterDismiss,

    toasterError: generic.toasterError,

    toasterView: generic.toasterView
};

exports.default = _extends({
    generic: generic,
    named: named,
    getEventLabel: getEventLabel
}, methods);
//# sourceMappingURL=edap.js.map

/***/ }),

/***/ "H8mJ":
/***/ (function(module, exports, __webpack_require__) {

if (Object({"NODE_ENV":"production"}).npm_package_name === 'pseudomap' &&
    Object({"NODE_ENV":"production"}).npm_lifecycle_script === 'test')
  Object({"NODE_ENV":"production"}).TEST_PSEUDOMAP = 'true'

if (typeof Map === 'function' && !Object({"NODE_ENV":"production"}).TEST_PSEUDOMAP) {
  module.exports = Map
} else {
  module.exports = __webpack_require__("shmE")
}


/***/ }),

/***/ "HK2/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MonthNames = __webpack_require__("EgLL");

var _DayNames = __webpack_require__("uL9r");

var _CalendarData = __webpack_require__("5CEY");

var _WeekdayNames = __webpack_require__("0yQ2");

var _WeekdayNames2 = _interopRequireDefault(_WeekdayNames);

var _Day = __webpack_require__("/yk9");

var _Day2 = _interopRequireDefault(_Day);

var _dateUtils = __webpack_require__("SCsJ");

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _today = __webpack_require__("WAVn");

var _today2 = _interopRequireDefault(_today);

var _propTypeDateString = __webpack_require__("IohZ");

var _propTypeDateString2 = _interopRequireDefault(_propTypeDateString);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("RXFs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
    _inherits(Month, _Component);

    function Month(props) {
        _classCallCheck(this, Month);

        // Initialize locale based calendar data.
        var _this = _possibleConstructorReturn(this, (Month.__proto__ || Object.getPrototypeOf(Month)).call(this, props));

        _this.handleMonthNameClicked = function () {
            if (_this.props.onMonthNameClicked) {
                _this.props.onMonthNameClicked(_this.props.month, _this.props.year);
            }
        };

        _this.handleDayKeyboardEvents = function (e) {
            var row = _this.getRow();
            var col = _this.getCol();
            var numOfRows = _this.reference.length - 1;
            var keyCode = e.which;

            if (keyCode === 39) {
                // Right Arrow
                _this.props.handleRightArrow(row, col, numOfRows);
            } else if (keyCode === 37) {
                // Left Arrow
                _this.props.handleLeftArrow(row, col);
            } else if (keyCode === 40) {
                // Down Arrow
                _this.props.handleDownArrow(row, col, numOfRows);
            } else if (keyCode === 38) {
                // Up Arrow
                _this.props.handleUpArrow(row, col);
            }
        };

        _this.pushDayRef = function (day, rowIndex) {
            if (day) {
                _this.reference[rowIndex].push(day);
            }
        };

        _this.setActiveMonth = function () {
            _this.props.setActiveMonth(_this.props.index);
        };

        _this.firstFocusableDay = function (day, i, tableRow) {
            // eslint-disable-line complexity
            var today = _today2.default.getToday();
            var isToday = _today2.default.isToday(day, today);
            var isPast = _today2.default.isPast(day, today);
            var numMonths = _this.props.numMonthsToDisplay;
            var dateString = _this.props.selectedDate || _this.props.selectionStart;
            var startDate = dateString ? _dateUtils2.default.getDateFromString(dateString) : null;
            var outOfRange = true;
            var monthDiff = void 0;
            var yearDiff = void 0;

            if (startDate !== null && startDate !== '') {
                yearDiff = day.year - startDate.getFullYear();
                monthDiff = Math.abs(day.month + yearDiff * 12 - startDate.getMonth());
                outOfRange = monthDiff >= numMonths;

                if (startDate.getMonth() < day.month && startDate.getFullYear() <= day.year) {
                    outOfRange = true;
                }
            }

            if (_this.props.selectionStart === null || _this.props.selectionStart === '' || outOfRange) {
                if (i === 0 && !isPast) {
                    // focusable day must be within the first month displayed (props.index === 0)
                    if (isToday) {
                        return true;
                    } else if (_dateUtils2.default.isFirstDayInMonth(day) && tableRow === 0) {
                        // Verifying the table row is 0 prevents potential sibling months from also receiving focus on their first day
                        return true;
                    }
                }
            }

            return false;
        };

        _this.dayNames = (0, _DayNames.getDayNamesInstance)(props.locale, props.labels);
        _this.monthNames = (0, _MonthNames.getMonthNamesInstance)(props.locale, props.labels);
        _this.calendarData = (0, _CalendarData.getCalendarDataInstance)(props.showSiblingMonths);
        _this.calendarData.setProperty('weekStart', _this.dayNames.getStartOfWeek());
        _this.reference = [];

        _this.state = {
            calendarDays: _this.getCalendarDays(props)
        };
        return _this;
    }

    /* istanbul ignore next */


    _createClass(Month, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var date = new Date();
            var isCurrentMonth = date.getMonth() === this.props.month && date.getFullYear() === this.props.year;
            // If this is the current month or the month contains the selected dates then scroll into view
            if (this.props.scrollToMonth && (!this.props.selectionStart && isCurrentMonth || this.isSelectedMonth())) {
                this.elem.scrollIntoView();
            }
        }

        // eslint-disable-next-line complexity

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var year = nextProps.year,
                month = nextProps.month,
                locale = nextProps.locale,
                showSiblingMonths = nextProps.showSiblingMonths,
                labels = nextProps.labels;

            var localeChange = locale !== this.props.locale;
            var labelsChange = labels !== this.props.labels;
            var siblingChange = showSiblingMonths !== this.props.showSiblingMonths;

            if (localeChange || labelsChange) {
                this.dayNames = (0, _DayNames.getDayNamesInstance)(locale, labels);
                this.monthNames = (0, _MonthNames.getMonthNamesInstance)(locale, labels);
            }

            if (siblingChange) {
                this.calendarData = (0, _CalendarData.getCalendarDataInstance)(showSiblingMonths);
            }

            if (localeChange || siblingChange) {
                this.calendarData.setProperty('weekStart', this.dayNames.getStartOfWeek());
            }

            // If these guys change, get the new calendar day data
            if (year !== this.props.year || month !== this.props.month || localeChange || siblingChange) {
                this.setState({
                    calendarDays: this.getCalendarDays(nextProps)
                });
            }
        }

        // The optimizations in shouldComponentUpdate are for improving the responsiveness
        // when making selections, particularly when many months are rendered.

    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var _this2 = this;

            var propChange = ['month', 'year', 'width', 'simple', 'showMonthLabels', 'monthLabelAlignment', 'showGridLines', 'padWeeks', 'showSiblingMonths', 'selectable', 'dayData', 'selectionType', 'locale', 'labels', 'index'].some(function (prop) {
                return nextProps[prop] !== _this2.props[prop];
            });

            // Always update if any of the above properties change
            if (propChange) {
                return true;
            }

            if (nextProps.selectionType === 'single') {
                return this.shouldComponentUpdateSingle(nextProps);
            }
            return this.shouldComponentUpdateRange(nextProps);
        }
    }, {
        key: 'zeroFill',
        value: function zeroFill(value) {
            var oneBasedValue = value + 1;
            return oneBasedValue < 10 ? '0' + oneBasedValue : '' + oneBasedValue;
        }
    }, {
        key: 'getRenderingMonth',
        value: function getRenderingMonth(year, month) {
            var zeroFilledMonth = this.zeroFill(month);
            return +('' + year + zeroFilledMonth);
        }
    }, {
        key: 'shouldComponentUpdateSingle',
        value: function shouldComponentUpdateSingle(nextProps) {
            var _props = this.props,
                month = _props.month,
                year = _props.year,
                selectedDate = _props.selectedDate;


            var renderingMonth = this.getRenderingMonth(year, month);
            var selectedMonth = this.getMonth(nextProps.selectedDate);
            var prevSelectedMonth = this.getMonth(selectedDate);
            var buffer = nextProps.showSiblingMonths ? 1 : 0;

            // Clear any selections (i.e. render any month with a previous selection)
            if (renderingMonth === prevSelectedMonth) {
                return true;
            }

            // Skip any months outside of the new selection, plus a buffer (if applicable)
            // Using an extra buffer because the early dates from the next month may show in
            // the previous month. Same for next month dates (showSiblingMonths prop)
            if (renderingMonth < selectedMonth - buffer || renderingMonth > selectedMonth + buffer) {
                return false;
            }

            return true;
        }
    }, {
        key: 'shouldComponentUpdateRange',
        value: function shouldComponentUpdateRange(nextProps) {
            var _props2 = this.props,
                month = _props2.month,
                year = _props2.year,
                selectionStart = _props2.selectionStart,
                selectionEnd = _props2.selectionEnd,
                hoverDate = _props2.hoverDate;


            var renderingMonth = this.getRenderingMonth(year, month);
            var selectionStartMonth = this.getMonth(nextProps.selectionStart);
            var selectionEndMonth = this.getMonth(nextProps.selectionEnd);
            var hoverMonth = this.getMonth(nextProps.hoverDate);
            var outMonth = selectionEndMonth || hoverMonth || selectionStartMonth;
            var buffer = nextProps.showSiblingMonths ? 1 : 0;

            // If the new selection, or partial selection contains the month in question, render.
            // Using an extra buffer because the early dates from the next month may show in
            // the previous month. Same for next month dates (showSiblingMonths prop)
            if (renderingMonth >= selectionStartMonth - buffer && renderingMonth <= outMonth + buffer) {
                return true;
            }

            var prevSelectionStartMonth = this.getMonth(selectionStart);
            var prevSelectionEndMonth = this.getMonth(selectionEnd);
            var prevHoverMonth = this.getMonth(hoverDate);
            var outMonth2 = prevSelectionEndMonth || Math.max(prevHoverMonth, prevSelectionStartMonth);

            // If an old selection was drawn on this month, rerender to clear
            if (renderingMonth >= prevSelectionStartMonth && renderingMonth <= outMonth2) {
                return true;
            }

            return false;
        }
    }, {
        key: 'getMonth',
        value: function getMonth(dateString) {
            // concatenating the year and month 201611, for comparisons
            if (dateString) {
                var parts = dateString.split('-');
                return +('' + parts[0] + parts[1]);
            }
            return null;
        }

        // Determines if this month contains the start date of the current selection

    }, {
        key: 'isSelectedMonth',
        value: function isSelectedMonth() {
            var dateString = this.props.selectedDate || this.props.selectionStart;

            if (!dateString) {
                return false;
            }

            var date = _dateUtils2.default.getDateFromString(dateString);

            return date.getMonth() === this.props.month && date.getFullYear() === this.props.year;
        }
    }, {
        key: 'newFilledArray',
        value: function newFilledArray(len, val) {
            var a = [];
            while (len--) {
                a.push(val);
            }
            return a;
        }
    }, {
        key: 'getCalendarDays',
        value: function getCalendarDays(_ref) {
            var month = _ref.month,
                year = _ref.year,
                width = _ref.width;

            var days = this.calendarData.getMonth(year, month);
            days = days.map(function (day) {
                if (!day) {
                    return day;
                }

                day.dateString = _dateUtils2.default.getDayToString(day);
                return day;
            });

            // Pad the days array so that all months have a height of
            // 6 weeks, this is only when multiple months are showing.
            if (width !== '100%' || this.props.padWeeks) {
                var paddingArray = this.newFilledArray(42 - days.length, false);
                days = days.concat(paddingArray);
            }

            return days;
        }
    }, {
        key: 'getRow',
        value: function getRow() {
            var focusedElement = document.activeElement; // Find the element that currently has focus
            return parseInt(focusedElement.dataset.row, 10);
        }
    }, {
        key: 'getCol',
        value: function getCol() {
            var focusedElement = document.activeElement; // Find the element that currently has focus
            return parseInt(focusedElement.dataset.column, 10);
        }

        // Used to fill a 2 dimension array to keep a reference for each day: reference[week][day]


        /**
        * Determines whether a day should be focusable. If there is not a day selected then a focusable day is either
        * the current day of the present month or the first day of the month as long as it is not in the past
        * @param day {object} The custom day object to check
        * @param i {number} index of month
        * @returns {boolean} true if day is the focusable day of the given month, false otherwise
        */

    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _props3 = this.props,
                month = _props3.month,
                year = _props3.year,
                simple = _props3.simple,
                locale = _props3.locale,
                width = _props3.width,
                showGridlines = _props3.showGridlines,
                showMonthLabels = _props3.showMonthLabels,
                monthLabelAlignment = _props3.monthLabelAlignment,
                hoverDate = _props3.hoverDate,
                selectable = _props3.selectable,
                selectionStart = _props3.selectionStart,
                selectionEnd = _props3.selectionEnd,
                selectedDate = _props3.selectedDate,
                onMonthNameClicked = _props3.onMonthNameClicked,
                onDayClick = _props3.onDayClick,
                onDayHover = _props3.onDayHover,
                dayData = _props3.dayData,
                dayTemplateComponent = _props3.dayTemplateComponent,
                onDisabledDayClick = _props3.onDisabledDayClick,
                i18n = _props3.i18n,
                index = _props3.index;

            var calendarDays = this.state.calendarDays;
            var multi = width !== '100%';
            this.reference = [];

            var monthClasses = (0, _classnames2.default)({
                'month': true,
                multi: multi,
                simple: simple
            });

            var labelClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, 'align-' + monthLabelAlignment, true), _defineProperty(_classNames, 'hoverable', onMonthNameClicked), _defineProperty(_classNames, 'h3', !multi), _classNames));

            return _react2.default.createElement(
                'div',
                { className: monthClasses, style: { width: width }, ref: function ref(_ref2) {
                        return _this3.elem = _ref2;
                    } },
                showMonthLabels && _react2.default.createElement(
                    'h4',
                    { className: labelClasses, onClick: this.handleMonthNameClicked },
                    _react2.default.createElement(
                        'span',
                        null,
                        this.monthNames.getMonthNames()[month]
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'year-label' },
                        ' ',
                        year
                    )
                ),
                _react2.default.createElement(
                    'table',
                    { className: 'month-table', 'aria-label': this.monthNames.getMonthNames()[month] + ' ' + year },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(_WeekdayNames2.default, {
                            simple: simple,
                            startOfWeek: this.dayNames.getStartOfWeek(),
                            dayNames: this.dayNames.getDayNames(),
                            shortDayNames: this.dayNames.getShortDayNames(),
                            longDayNames: this.dayNames.getLongDayNames(),
                            showGridlines: showGridlines
                        })
                    ),
                    _react2.default.createElement(
                        'tbody',
                        { className: 'day-wrap', onKeyDown: this.handleDayKeyboardEvents },
                        calendarDays.reduce(function (m, day, i) {
                            if (i % 7 === 0) {
                                m.push([day]);
                            } else {
                                m[m.length - 1].push(day);
                            }
                            return m;
                        }, []).map(function (grouped, j) {
                            _this3.reference.push([]);
                            return _react2.default.createElement(
                                'tr',
                                { key: j },
                                grouped.map(function (day, k) {
                                    return _react2.default.createElement(_Day2.default, {
                                        key: 'day-' + k,
                                        day: day,
                                        weekIndex: j,
                                        dayIndex: k,
                                        monthIndex: index,
                                        locale: locale,
                                        simple: simple,
                                        showGridlines: showGridlines,
                                        selectable: selectable,
                                        selectionStart: selectionStart,
                                        selectionEnd: selectionEnd,
                                        selectedDate: selectedDate,
                                        hoverDate: hoverDate,
                                        onDayClick: onDayClick,
                                        onDayHover: onDayHover,
                                        dayData: dayData[day.dateString] || dayData.defaults || {},
                                        dayTemplateComponent: dayTemplateComponent,
                                        onDisabledDayClick: onDisabledDayClick,
                                        setActiveMonth: _this3.setActiveMonth,
                                        isFocusable: _this3.firstFocusableDay(day, index, j),
                                        i18n: i18n,
                                        setRef: function setRef(c) {
                                            return _this3.pushDayRef(c, j);
                                        } // eslint-disable-line
                                    });
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Month;
}(_react.Component);

Month.propTypes = {
    year: _propTypes2.default.number,
    month: _propTypes2.default.number,
    width: _propTypes2.default.string,
    simple: _propTypes2.default.bool,
    showMonthLabels: _propTypes2.default.bool,
    showGridlines: _propTypes2.default.bool,
    monthLabelAlignment: _propTypes2.default.string,
    padWeeks: _propTypes2.default.bool,
    scrollToMonth: _propTypes2.default.bool,
    hoverDate: _propTypes2.default.string,
    showSiblingMonths: _propTypes2.default.bool,
    selectable: _propTypes2.default.bool,
    selectionType: _propTypes2.default.oneOf(['range', 'single']),
    selectionStart: _propTypeDateString2.default,
    selectionEnd: _propTypeDateString2.default,
    selectedDate: _propTypeDateString2.default,
    onMonthNameClicked: _propTypes2.default.func,
    onDayClick: _propTypes2.default.func,
    onDayHover: _propTypes2.default.func,
    dayData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    dayTemplateComponent: _propTypes2.default.func,
    /** A moniker or BCP-47 style language tag string. */
    locale: _propTypes2.default.string,
    /** Optional labels object to override default locale-driven labels */
    labels: _propTypes2.default.shape({
        monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortMonthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        dayNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortDayNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    index: _propTypes2.default.number
};
Month.defaultProps = {
    dayData: {},
    padWeeks: false,
    scrollToMonth: false,
    simple: false,
    labels: {}
};
exports.default = Month;
//# sourceMappingURL=Month.js.map

/***/ }),

/***/ "HgRV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLocal = isLocal;
function isLocal() {
    return !!("object" !== 'undefined' && window.location && window.location.host && window.location.host.match(/((localhost|0.0.0.0):(11000|8000|12000))|github.homeawaycorp.com/));
}
//# sourceMappingURL=debug.js.map

/***/ }),

/***/ "Ho0a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactButtons = __webpack_require__("HfJ9");

var _reactDetermineIfMobile = __webpack_require__("54yA");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _reactFormComponents = __webpack_require__("QyGt");

var _constants = __webpack_require__("hXMO");

__webpack_require__("frhy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CreateTripBoardNewModal(props) {
    var handleClickCancel = props.handleClickCancel,
        handleClickCreate = props.handleClickCreate,
        newBoardName = props.newBoardName,
        onNameChange = props.onNameChange,
        showCancel = props.showCancel,
        translations = props.translations,
        isMobile = props.isMobile,
        createIsDisabled = props.createIsDisabled;


    return _react2.default.createElement(
        'div',
        { className: 'create-trip-board-new-modal' },
        _react2.default.createElement(
            'form',
            { onSubmit: handleClickCreate },
            _react2.default.createElement(_reactFormComponents.FormInput, {
                autoFocus: !isMobile,
                className: 'create-trip-board-new-modal__input',
                id: 'boardInput',
                inputClassName: 'trip-board-text-input',
                label: translations['tripboards.modal.create.name'],
                maxLength: _constants.MAX_TRIPBOARD_NAME_LENGTH,
                value: newBoardName,
                onChange: onNameChange
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'create-trip-board-new-modal__buttons' },
            showCancel && _react2.default.createElement(_reactButtons.Button, {
                id: 'cancelButton',
                className: 'create-trip-board-new-modal__buttons_cancel',
                label: translations['tripboards.cancel'],
                onClick: handleClickCancel,
                size: 'sm'
            }),
            _react2.default.createElement(_reactButtons.ButtonPrimary, {
                id: 'createButton',
                className: 'create-trip-board-new-modal__buttons_create',
                label: translations['tripboards.modal.create'],
                disabled: createIsDisabled,
                onClick: handleClickCreate,
                size: 'sm'
            })
        )
    );
}

CreateTripBoardNewModal.propTypes = {
    handleClickCancel: _propTypes2.default.func.isRequired,
    handleClickCreate: _propTypes2.default.func.isRequired,
    newBoardName: _propTypes2.default.string.isRequired,
    onNameChange: _propTypes2.default.func.isRequired,
    showCancel: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactDetermineIfMobile2.default)(CreateTripBoardNewModal);
//# sourceMappingURL=CreateTripBoardNewModal.js.map

/***/ }),

/***/ "Hq0H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hqt+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _shiitake = __webpack_require__("YW+/");

var _shiitake2 = _interopRequireDefault(_shiitake);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AspectRatioCardText = function AspectRatioCardText(_ref) {
    var text = _ref.text;
    return _react2.default.createElement(
        _shiitake2.default,
        { lines: 2, throttleRate: 200, className: 'small', tagName: 'span' },
        text
    );
};

AspectRatioCardText.propTypes = {
    /** The text to display. Text will be truncated as necessary. */
    text: _propTypes2.default.string.isRequired
};

exports.default = AspectRatioCardText;
//# sourceMappingURL=AspectRatioCardText.js.map

/***/ }),

/***/ "Hw4J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.visitWithTypeInfo = visitWithTypeInfo;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;

var _inspect = _interopRequireDefault(__webpack_require__("ieo+"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = {};
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

exports.BREAK = BREAK;

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var k in node) {
            if (node.hasOwnProperty(k)) {
              clone[k] = node[k];
            }
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + (0, _inspect.default)(node));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */


function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */


function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),

/***/ "I7B8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("NZ8V");
var descriptor = __webpack_require__("YTz9");
var setToStringTag = __webpack_require__("LhDF");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("aLzV")(IteratorPrototype, __webpack_require__("hgbu")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "IAED":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleImageCarousel = undefined;

var _SimpleImageCarousel = __webpack_require__("0nPK");

var _SimpleImageCarousel2 = _interopRequireDefault(_SimpleImageCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SimpleImageCarousel = _SimpleImageCarousel2.default;
exports.default = _SimpleImageCarousel2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "ICSD":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("ITwD"),
    getValue = __webpack_require__("mTAn");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "ITwD":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("gGqR"),
    isMasked = __webpack_require__("eFps"),
    isObject = __webpack_require__("yCNF"),
    toSource = __webpack_require__("Ai/T");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "IVRI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),

/***/ "IVYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ib78":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TripBoardHitNewModal = __webpack_require__("LIrC");

var _TripBoardHitNewModal2 = _interopRequireDefault(_TripBoardHitNewModal);

var _reactButtons = __webpack_require__("HfJ9");

__webpack_require__("m1bQ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddToTripBoardNewModal(props) {
    var onTripBoardClicked = props.onTripBoardClicked,
        onCreateBoardClicked = props.onCreateBoardClicked,
        tripBoards = props.tripBoards,
        translations = props.translations;


    var tripBoardHits = tripBoards.map(function (tripBoard, index) {
        var boardId = tripBoard.boardId,
            name = tripBoard.name,
            _tripBoard$listings = tripBoard.listings,
            listings = _tripBoard$listings === undefined ? [] : _tripBoard$listings;

        var thumbnails = listings.filter(function (listing) {
            return listing && listing.images;
        }).reduce(function (currentThumbnails, listing) {
            return currentThumbnails.concat([listing.images[0].c6_uri]);
        }, []);

        var onClick = function onClick(event) {
            onTripBoardClicked(event, boardId);
        };

        return _react2.default.createElement(_TripBoardHitNewModal2.default, {
            key: 'trip-board-hit-' + index,
            onClick: onClick,
            tripBoardTitle: name,
            thumbnails: thumbnails
        });
    });

    var createButtonText = translations['tripboards.modal.create.new.list'];

    var handleAddNewTripBoard = function handleAddNewTripBoard() {
        onCreateBoardClicked();
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: 'add-to-tripboard__scrollable-tripboards' },
            tripBoardHits
        ),
        _react2.default.createElement(
            'div',
            { className: 'add-to-tripboard__create-button-container', onClick: handleAddNewTripBoard, role: 'button' },
            _react2.default.createElement(
                'div',
                { className: 'add-to-tripboard__shadow' },
                _react2.default.createElement(
                    'div',
                    { className: 'add-to-tripboard__create-button' },
                    _react2.default.createElement(
                        _reactButtons.ButtonIcon,
                        { className: 'add-to-tripboard__create-button-icon', circle: true, label: createButtonText },
                        _react2.default.createElement(
                            'svg',
                            { className: 'add-to-tripboard__create-svg-plus', viewBox: '0 0 50 50' },
                            _react2.default.createElement('path', { d: 'M50 22H28V0h-6v22H0v6h22v22h6V28h22' })
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'add-to-tripboard__create-label' },
                        createButtonText
                    )
                )
            )
        )
    );
}

AddToTripBoardNewModal.propTypes = {
    onTripBoardClicked: _propTypes2.default.func,
    tripBoards: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

AddToTripBoardNewModal.defaultProps = {
    onTripBoardClicked: function onTripBoardClicked() {},
    onCreateBoardClicked: function onCreateBoardClicked() {},
    tripBoards: []
};

exports.default = AddToTripBoardNewModal;
//# sourceMappingURL=AddToTripBoardNewModal.js.map

/***/ }),

/***/ "Ighh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rafOptimized = __webpack_require__("pick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DetermineIfMobile(WrappedComponent) {
    var _class, _temp;

    var mobileBreakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 767;

    var HAS_WINDOW = "object" !== 'undefined';

    return _temp = _class = function (_Component) {
        _inherits(_class, _Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.resizeCallback = function (sizeObj) {
                var isMobile = _this.isMobileByWindow(sizeObj.width);
                if (isMobile !== _this.state.isMobile) {
                    _this.setState({ isMobile: isMobile });
                }
            };

            _this.state = {
                isMobile: _this.isMobile(props)
            };
            return _this;
        }

        _createClass(_class, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (HAS_WINDOW) {
                    this.clearResize = (0, _rafOptimized.resize)(this.resizeCallback);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (HAS_WINDOW) {
                    this.clearResize();
                }
            }

            /**
             * resizeCallback()
             * Callback function implemented by @homeaway/raf-optimized resize() registration
             * @param {obj} sizeObj - contains "width" and "height" properties
             */

        }, {
            key: 'isMobile',


            /**
             * isMobile()
             * Determine if component is mobile when we are not sure if we are in browser or node environment
             * @param {obj} props
             */
            value: function isMobile(props) {
                if (HAS_WINDOW) {
                    return this.isMobileByWindow(false);
                }
                return this.isMobileByProps(props);
            }

            /**
             * isMobileByProps()
             * Determine if component is mobile when are not in a browser environment
             * @param {obj} props
             */

        }, {
            key: 'isMobileByProps',
            value: function isMobileByProps(props) {
                return props.isMobile || false;
            }

            /**
             * isMobileByWindow()
             * Determine if component is mobile when are in a browser environment
             * @param {false|int} width - provided on optimized resize() events from @homeaway/raf-optimized
             */

        }, {
            key: 'isMobileByWindow',
            value: function isMobileByWindow() {
                var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                if (!width) {
                    width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                }
                return width <= this.props.mobileBreakpoint;
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { isMobile: this.state.isMobile }));
            }
        }]);

        return _class;
    }(_react.Component), _class.propTypes = {
        /** Point at which mobile vs desktop views are switched. Anything below or equal to this number will result in mobile view. */
        mobileBreakpoint: _propTypes2.default.number,
        /** Force value. This is useful for server-side rendering when you know if it is mobile. It helps prevent react's server/client mismatch warnings. */
        isMobile: _propTypes2.default.bool
    }, _class.defaultProps = {
        mobileBreakpoint: mobileBreakpoint
    }, _temp;
}

exports.default = DetermineIfMobile;
//# sourceMappingURL=DetermineIfMobile.js.map

/***/ }),

/***/ "Io3e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),

/***/ "IohZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint consistent-return: 0 */

/**
 * Date string propType
 * ensures that property fits the form: YYYY-MM-DD
 */
function propTypeDateString(props, propName, componentName) {
    if (props[propName] && !/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/.test(props[propName])) {
        return new Error("Invalid value for \"" + propName + "\" supplied to " + componentName + ". \"" + propName + "\" should be in the format: \"YYYY-MM-DD\". Validation failed.");
    }
}

exports.default = propTypeDateString;
//# sourceMappingURL=propTypeDateString.js.map

/***/ }),

/***/ "Iqx9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printError = printError;

var _location = __webpack_require__("Nvbj");

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];

  if (error.nodes) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var node = _step.value;

        if (node.loc) {
          printedLocations.push(highlightSourceAtLocation(node.loc.source, (0, _location.getLocation)(node.loc.source, node.loc.start)));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else if (error.source && error.locations) {
    var source = error.source;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var location = _step2.value;
        printedLocations.push(highlightSourceAtLocation(source, location));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */


function highlightSourceAtLocation(source, location) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = location.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = location.line + lineOffset;
  var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = location.column + columnOffset;
  var lines = body.split(/\r\n|[\n\r]/g);
  return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1, ": "), lines[lineIndex - 1]], ["".concat(lineNum, ": "), lines[lineIndex]], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1, ": "), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _ref4 = _step3.value;
      var prefix = _ref4[0];
      padLen = Math.max(padLen, prefix.length);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + line;
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),

/***/ "JRXi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jbb1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JgUz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),

/***/ "JiIc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invariant;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),

/***/ "Jko5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Kind = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

exports.Kind = Kind;

/***/ }),

/***/ "Jq3D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHEVRON_RIGHT__16 = void 0;
var CHEVRON_RIGHT__16 = '<svg data-id="SVG_CHEVRON_RIGHT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M6 13l4.6-5L6 3"/></svg>';
exports.CHEVRON_RIGHT__16 = CHEVRON_RIGHT__16;

/***/ }),

/***/ "K6Pp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "K96V":
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__("d6Sb");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),

/***/ "K9ox":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KMSM":
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),

/***/ "KTwR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYm/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactStarRating = __webpack_require__("W2iw");

var _reactStarRating2 = _interopRequireDefault(_reactStarRating);

__webpack_require__("dqtQ");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TripBoardNewModal = function (_Component) {
    _inherits(TripBoardNewModal, _Component);

    function TripBoardNewModal(props) {
        _classCallCheck(this, TripBoardNewModal);

        return _possibleConstructorReturn(this, (TripBoardNewModal.__proto__ || Object.getPrototypeOf(TripBoardNewModal)).call(this, props));
    }

    _createClass(TripBoardNewModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                rating = _props.rating,
                headline = _props.headline,
                _props$reviewCount = _props.reviewCount,
                reviewCount = _props$reviewCount === undefined ? 0 : _props$reviewCount,
                thumbnailUrl = _props.thumbnailUrl;


            var reviewsClass = (0, _classnames2.default)({
                'reviews-hidden': reviewCount === 0,
                'rating-review': reviewCount > 0
            });

            return _react2.default.createElement(
                'div',
                { className: 'trip-board-new-modal' },
                _react2.default.createElement(
                    'div',
                    { className: 'trip-board-new-modal__left-column' },
                    _react2.default.createElement(
                        'div',
                        { className: 'trip-board-new-modal__left-column-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'trip-board-new-modal__image-container' },
                            _react2.default.createElement('div', { className: 'trip-board-new-modal__listing-image', style: { backgroundImage: thumbnailUrl ? 'url(' + thumbnailUrl + ')' : 'none' } })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'trip-board-new-modal__info-container' },
                            _react2.default.createElement(
                                'div',
                                { className: 'headline' },
                                headline
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: reviewsClass },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'rating-review__rating' },
                                    _react2.default.createElement(_reactStarRating2.default, { rating: rating })
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'rating-review__review-count' },
                                    reviewCount
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'trip-board-new-modal__right-column' },
                    _react2.default.createElement(
                        'div',
                        { className: 'scroll-container' },
                        this.props.children
                    )
                )
            );
        }
    }]);

    return TripBoardNewModal;
}(_react.Component);

exports.default = TripBoardNewModal;
//# sourceMappingURL=TripBoardNewModal.js.map

/***/ }),

/***/ "Kxgp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global google */

var Overlay = function (_PureComponent) {
    _inherits(Overlay, _PureComponent);

    function Overlay(props) {
        _classCallCheck(this, Overlay);

        var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));

        var closeBoxURL = props.closeBoxURL,
            pixelOffset = props.pixelOffset,
            map = props.map;

        var _require = __webpack_require__("YUK5"),
            InfoBox = _require.InfoBox;

        var infobox = new InfoBox({
            closeBoxURL: closeBoxURL,
            pixelOffset: new google.maps.Size(pixelOffset.width, pixelOffset.height)
        });
        infobox.setMap(map);
        _this.infobox = infobox;
        _this.markerContent = document.createElement('div');
        _this.infobox.setContent(_this.markerContent);
        return _this;
    }

    _createClass(Overlay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                map = _props.map,
                marker = _props.marker;

            this.infobox.setContent(this.markerContent);
            this.infobox.open(map, marker);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.infobox && this.infobox.getContent()) {
                this.infobox.setMap(null);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _reactDom2.default.createPortal(_react.Children.only(this.props.children), this.markerContent);
        }
    }]);

    return Overlay;
}(_react.PureComponent);

Overlay.propTypes = {
    /** Single child to be rendered under overlay */
    children: _propTypes2.default.node.isRequired,
    /** URL to an image for the close button of the overlay */
    closeBoxURL: _propTypes2.default.string,
    /** google.maps.Size() */
    pixelOffset: _propTypes2.default.shape({
        width: _propTypes2.default.number.isRequired,
        height: _propTypes2.default.number.isRequired
    }),
    /** marker reference (automatically passed down if wrapped by Marker) */
    marker: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** map reference (automatically passed down if wrapped by GoogleMap) */
    map: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};
Overlay.defaultProps = {
    closeBoxURL: '',
    pixelOffset: {
        height: 0,
        width: 0
    }
};
exports.default = Overlay;
//# sourceMappingURL=Overlay.js.map

/***/ }),

/***/ "L1Sl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _actions = __webpack_require__("xGNz");

var _havCookie = __webpack_require__("bG61");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var mapDispatchToProps = {
    setHavInState: _actions.setHav
};

var mapStateToProps = function mapStateToProps(_ref) {
    var tripboardButton = _ref.tripboardButton;
    return { hav: tripboardButton.auth && tripboardButton.auth.hav };
};

var withHav = function withHav(WrappedComponent) {
    return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(function (_Component) {
        _inherits(withHavWrapper, _Component);

        function withHavWrapper(props) {
            _classCallCheck(this, withHavWrapper);

            var _this = _possibleConstructorReturn(this, (withHavWrapper.__proto__ || Object.getPrototypeOf(withHavWrapper)).call(this, props));

            _this.displayName = 'withHav(' + getDisplayName(WrappedComponent) + ')';

            _this.getHavFromConfig();
            return _this;
        }

        _createClass(withHavWrapper, [{
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.getHavFromConfig();
            }
        }, {
            key: 'getHavFromConfig',
            value: function getHavFromConfig() {
                var _props = this.props,
                    hav = _props.hav,
                    setHavInState = _props.setHavInState;

                if (!hav) {
                    var havFromConfigOrCookie = (0, _havCookie.getHav)();
                    setHavInState({ hav: havFromConfigOrCookie });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(WrappedComponent, this.props);
            }
        }]);

        return withHavWrapper;
    }(_react.Component));
};

exports.default = withHav;
//# sourceMappingURL=with-hav.js.map

/***/ }),

/***/ "L337":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LIrC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("fq9n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TripBoardHitNewModal(_ref) {
    var thumbnails = _ref.thumbnails,
        tripBoardTitle = _ref.tripBoardTitle,
        rest = _objectWithoutProperties(_ref, ['thumbnails', 'tripBoardTitle']);

    return _react2.default.createElement(
        'div',
        _extends({}, rest, { className: 'trip-board-hit-new-modal' }),
        _react2.default.createElement(
            'div',
            { className: 'trip-board-hit-new-modal__image-container' },
            _react2.default.createElement('div', { className: 'trip-board-hit-new-modal__image', style: { backgroundImage: thumbnails[0] ? 'url(' + thumbnails[0] + ')' : 'none' } })
        ),
        _react2.default.createElement(
            'div',
            { className: 'trip-board-hit-new-modal__title' },
            tripBoardTitle
        )
    );
}

TripBoardHitNewModal.propTypes = {
    thumbnails: _propTypes2.default.arrayOf(_propTypes2.default.string),
    tripBoardTitle: _propTypes2.default.string
};

TripBoardHitNewModal.defaultProps = {
    thumbnails: [],
    tripBoardTitle: ''
};

exports.default = TripBoardHitNewModal;
//# sourceMappingURL=TripBoardHitNewModal.js.map

/***/ }),

/***/ "LPd1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataIdFromObjectForTripboard = exports.tripboardButtonReducer = exports.TripBoard = exports.renderTripBoardButton = undefined;

var _tripBoardDataProvider = __webpack_require__("UqVM");

var _tripBoardDataProvider2 = _interopRequireDefault(_tripBoardDataProvider);

var _graphql = __webpack_require__("qm98");

var _RenderTripBoardButton = __webpack_require__("nTj+");

var _RenderTripBoardButton2 = _interopRequireDefault(_RenderTripBoardButton);

var _TripBoard = __webpack_require__("Dtfn");

var _TripBoard2 = _interopRequireDefault(_TripBoard);

var _reducers = __webpack_require__("So98");

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _tripBoardDataProvider2.default; /**
                                                    * This index.js file is the entry point for your component and
                                                    * is referenced from package.json. It's best to keep it lightweight
                                                    * and do all of your work in component and subcomponent files.
                                                   **/

exports.renderTripBoardButton = _RenderTripBoardButton2.default;
exports.TripBoard = _TripBoard2.default;
exports.tripboardButtonReducer = _reducers2.default;
exports.dataIdFromObjectForTripboard = _graphql.dataIdFromObjectForTripboard;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "LYGc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLocal = isLocal;
function isLocal() {
    return !!("object" !== 'undefined' && window.location && window.location.host && window.location.host.match(/((localhost|0.0.0.0):(11000|8000|12000))|github.homeawaycorp.com|wvrgroup.internal|hahosting.local|sea.corp.expecn.com|corp.expecn.com/));
}
//# sourceMappingURL=debug.js.map

/***/ }),

/***/ "Lgum":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LhDF":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("GCs6").f;
var has = __webpack_require__("x//u");
var TAG = __webpack_require__("hgbu")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "Libf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LocR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("qs+f") && !__webpack_require__("zyKz")(function () {
  return Object.defineProperty(__webpack_require__("PY1i")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "LtA8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MBgi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Carousel = __webpack_require__("zaqd");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _CarouselPageNumber = __webpack_require__("wq4h");

var _CarouselPageNumber2 = _interopRequireDefault(_CarouselPageNumber);

var _CarouselUtil = __webpack_require__("ZTHW");

__webpack_require__("Ey83");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Third Party Imports


// Primary Imports


var InlineCarouselContainer = function (_Component) {
    _inherits(InlineCarouselContainer, _Component);

    function InlineCarouselContainer(props) {
        _classCallCheck(this, InlineCarouselContainer);

        var _this = _possibleConstructorReturn(this, (InlineCarouselContainer.__proto__ || Object.getPrototypeOf(InlineCarouselContainer)).call(this, props));

        _this.currentImageLoadedCallback = function () {
            if (_this.state.showPreviewImage && _this.props.renderInteractive) {
                _this.setState({ showPreviewImage: false });
            }
        };

        _this.setElemRef = function (ref) {
            _this.elem = ref;
        };

        _this.onImageCountClick = function () {
            _this.props.onImageClick();
        };

        _this.timeouts = {};

        _this.state = {
            showPreviewImage: true
        };
        return _this;
    }

    /* eslint-disable complexity */


    _createClass(InlineCarouselContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            // For large, outside, container components like this, it is better to hand in
            // a single, or a few, objects.  The smaller, composed, componenents have
            // the more granular props.
            // Moving to a few larger objects will simplyfy this.
            var shouldUpdate = nextState.showPreviewImage !== this.state.showPreviewImage || nextProps.galleryTitle !== this.props.galleryTitle || nextProps.renderInteractive !== this.props.renderInteractive || nextProps.thumbnailUrl !== this.props.thumbnailUrl || nextProps.index !== this.props.index || nextProps.showArrows !== this.props.showArrows || nextProps.prevIndex !== this.props.prevIndex || nextProps.showPageNumber !== this.props.showPageNumber || nextProps.renderedIndices.join(',') !== this.props.renderedIndices.join(',') || nextProps.multiImage !== this.props.multiImage || nextProps.handlesKeyboardNavigation !== this.props.handlesKeyboardNavigation || !!nextProps.width || !!nextProps.height || _CarouselUtil.utils.imagesDidChange(this.props.images, nextProps.images);

            return shouldUpdate;
        }
        /* eslint-enable complexity */

    }, {
        key: 'getPreviewImageSrc',
        value: function getPreviewImageSrc() {
            var _props = this.props,
                thumbnailUrl = _props.thumbnailUrl,
                images = _props.images,
                index = _props.index;

            if (thumbnailUrl) {
                return thumbnailUrl;
            }
            if (images && !isNaN(index) && images.length > index) {
                return images[index].src || '';
            }
            return '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                backgroundColor = _props2.backgroundColor,
                className = _props2.className,
                renderPageNumber = _props2.renderPageNumber,
                showPageNumber = _props2.showPageNumber,
                slideSize = _props2.slideSize,
                rest = _objectWithoutProperties(_props2, ['backgroundColor', 'className', 'renderPageNumber', 'showPageNumber', 'slideSize']);

            var classes = (0, _classnames2.default)('inline-carousel-container', className);
            var previewClass = 'inline-carousel-container__preview-image inline-carousel-container__preview-image--' + slideSize;

            return _react2.default.createElement(
                'div',
                {
                    className: classes,
                    ref: this.setElemRef
                },
                _react2.default.createElement(_Carousel2.default, _extends({
                    panDirection: 'horizontal',
                    onCurrentImageLoaded: this.currentImageLoadedCallback,
                    setPrevNextFuncs: this.setPrevNextFuncs,
                    slideSize: slideSize,
                    carouselType: _CarouselUtil.CAROUSEL_TYPE.INLINE
                }, rest)),
                this.state.showPreviewImage && _react2.default.createElement(
                    'div',
                    {
                        className: 'inline-carousel-container__preview-image-container',
                        style: { backgroundColor: backgroundColor }
                    },
                    slideSize === 'height' && _react2.default.createElement('img', { className: previewClass, src: this.getPreviewImageSrc() }),
                    slideSize !== 'height' && _react2.default.createElement('div', {
                        className: previewClass,
                        style: {
                            backgroundImage: 'url(' + this.getPreviewImageSrc() + ')',
                            backgroundSize: slideSize
                        }
                    })
                ),
                showPageNumber && _react2.default.createElement(
                    'div',
                    {
                        className: 'inline-carousel-container__image-count',
                        onClick: this.onImageCountClick
                    },
                    renderPageNumber(this.props)
                )
            );
        }
    }]);

    return InlineCarouselContainer;
}(_react.Component);

InlineCarouselContainer.propTypes = {
    /** Color of the background before the image loads. Defaults to black */
    backgroundColor: _propTypes2.default.string,
    /** Current image index. */
    index: _propTypes2.default.number.isRequired,
    /** Image data objects. Contains properties: src, lowResSrc, and altText. */
    images: _propTypes2.default.instanceOf(Array).isRequired,
    /** Indices from images array to render. */
    renderedIndices: _propTypes2.default.instanceOf(Array).isRequired,
    /** Updates image index to next image. Takes current index and images length as params. */
    onNextImage: _propTypes2.default.func.isRequired,
    /** Updates image index to previous image. Takes current index and images length as params. */
    onPrevImage: _propTypes2.default.func.isRequired,
    /** Action to take when an image is clicked.*/
    onImageClick: _propTypes2.default.func,
    /** Client-side render (true) or server-side render (false). */
    renderInteractive: _propTypes2.default.bool,
    /** Flag to show prev/next buttons.*/
    showArrows: _propTypes2.default.bool,
    /** url for preview image shown from SSR before carousel javascript loads */
    thumbnailUrl: _propTypes2.default.string,
    /** Flag to show page numbers.*/
    showPageNumber: _propTypes2.default.bool,
    /** How images size to slide and how slides flow within carousel. 'height' - images size to set height and flow horizantally,
    'width' - images size to set width and flow horizontally, 'contain' - images size to be contained in full height/width slide and flow horizontally, 'cover' - images size to cover full height/width slide and flow horizontally. */
    slideSize: _propTypes2.default.oneOf(['height', 'cover', 'contain']),
    /** Distance between slides */
    slideMargin: _propTypes2.default.number,
    /** Maximum opacity of overlay for non-current slides. */
    maxOverlayOpacity: _propTypes2.default.number,
    /** How many images at the front and tail of the renderedIndices should be rendered as low res.*/
    renderedLowResCountPerSide: _propTypes2.default.number,
    /** renders previous and next buttons. Takes {handlePrev, handleNext} as argument */
    renderButtons: _propTypes2.default.func,
    /** renders page number. Takes {index, images} as argument */
    renderPageNumber: _propTypes2.default.func,
    /** renders placeholder card for card without image src, takes {index, length} as argument */
    renderPlaceholder: _propTypes2.default.func,
    /** additional className string to add*/
    className: _propTypes2.default.string,
    /** Translated labels*/
    labels: _propTypes2.default.objectOf(_propTypes2.default.string),
    /** flag to prohibit touch*/
    touchProhibited: _propTypes2.default.bool,
    /** does not set a color style for the carousel background */
    hideBackground: _propTypes2.default.bool,
    /** id for debugging */
    id: _propTypes2.default.string,
    /** width to set the carousel */
    width: _propTypes2.default.number,
    /** height to set the carousel */
    height: _propTypes2.default.number,
    /** Indicates if captions should be shown. */
    displayCaptions: _propTypes2.default.bool,
    /** Indicates if captions should be truncated to one line. */
    truncateCaptions: _propTypes2.default.bool,
    /** Indicates if carousel handles keyboard events, i.e. do arrow keys navigate images */
    handlesKeyboardNavigation: _propTypes2.default.bool
};
InlineCarouselContainer.defaultProps = {
    backgroundColor: '#fff',
    index: 0,
    images: [],
    renderedIndices: [],
    onNextImage: function onNextImage() {},
    onPrevImage: function onPrevImage() {},
    onImageClick: function onImageClick() {},
    renderInteractive: false,
    showArrows: false,
    thumbnailUrl: '',
    showPageNumber: false,
    slideSize: 'height',
    slideMargin: 1,
    maxOverlayOpacity: 0.8,
    renderedLowResCountPerSide: 0,
    renderPageNumber: _CarouselPageNumber2.default,
    className: '',
    labels: {},
    touchProhibited: false,
    hideBackground: false,
    id: '',
    displayCaptions: false,
    truncateCaptions: false,
    handlesKeyboardNavigation: false
};
exports.default = InlineCarouselContainer;
//# sourceMappingURL=InlineCarouselContainer.js.map

/***/ }),

/***/ "MHlU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("O+4a").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "MpCr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MwfY":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("F5GY")();
}


/***/ }),

/***/ "N1tr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALENDAR__16 = void 0;
var CALENDAR__16 = '<svg data-id="SVG_CALENDAR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M1.4 2.7H13c.9 0 1.5.7 1.5 1.5v10.6H3c-.9 0-1.5-.7-1.5-1.5v-8H12"/><path fill="currentColor" stroke="none" d="M7.1 9.2h1.8V7.4H7.1zM7.1 12.8h1.8v-1.9H7.1zM3.7 9.2h1.9V7.4H3.7zM3.7 12.8h1.9v-1.9H3.7zM10.4 9.2h1.9V7.4h-1.9zM10.4 12.8h1.9v-1.9h-1.9z"/><path stroke-linecap="round" stroke-linejoin="round" d="M4.6 1.2v1.5m6.8-1.5v1.5"/></g></svg>';
exports.CALENDAR__16 = CALENDAR__16;

/***/ }),

/***/ "NGEn":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "NMIb":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),

/***/ "NMac":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("8ANE");
var anObject = __webpack_require__("FKWp");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("3fMt")(Function.call, __webpack_require__("rjjF").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "NTt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint consistent-return: 0 */

/**
 * Date string propType
 * ensures that property fits the form: YYYY-MM-DD
 */
function propTypeDateString(props, propName, componentName) {
    if (props[propName] && !/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/.test(props[propName])) {
        return new Error("Invalid value for \"" + propName + "\" supplied to " + componentName + ". \"" + propName + "\" should be in the format: \"YYYY-MM-DD\". Validation failed.");
    }
}

exports.default = propTypeDateString;
//# sourceMappingURL=propTypeDateString.js.map

/***/ }),

/***/ "NU0k":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("NZra");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "NZ8V":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("FKWp");
var dPs = __webpack_require__("r3+g");
var enumBugKeys = __webpack_require__("B5V0");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("PY1i")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("+iDZ").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "NZra":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "NjwZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__("GiK3");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),

/***/ "NkRn":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "Ntt2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var LIBRARY = __webpack_require__("c8Kh");
var wksExt = __webpack_require__("4DQ7");
var defineProperty = __webpack_require__("GCs6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "Nvbj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

/***/ }),

/***/ "O+4a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Month = __webpack_require__("HK2/");

var _Month2 = _interopRequireDefault(_Month);

var _dateUtils = __webpack_require__("SCsJ");

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _propTypeDateString = __webpack_require__("IohZ");

var _propTypeDateString2 = _interopRequireDefault(_propTypeDateString);

var _safeWindowListeners = __webpack_require__("/c3J");

var _LanguageTag = __webpack_require__("r94d");

var _LanguageTag2 = _interopRequireDefault(_LanguageTag);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("y1vT");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarBase = function (_Component) {
    _inherits(CalendarBase, _Component);

    function CalendarBase(props) {
        _classCallCheck(this, CalendarBase);

        var _this = _possibleConstructorReturn(this, (CalendarBase.__proto__ || Object.getPrototypeOf(CalendarBase)).call(this, props));

        _this.updateFocus = function () {
            var _this$props = _this.props,
                direction = _this$props.direction,
                column = _this$props.column,
                activeMonth = _this$props.activeMonth;

            _this.setActiveMonth(activeMonth);

            if (direction === 'next' || direction === 'prev') {
                _this.setMonthFocus(direction);
            } else if (direction === 'up' || direction === 'down') {
                _this.setMonthFocus(direction, column);
            }
        };

        _this.setActiveMonth = function (i) {
            _this.activeMonth = i;
        };

        _this.setMonthFocus = function (direction, i) {
            // eslint-disable-line
            var numOfRows = void 0;
            var currentIndex = _this.activeMonth;

            // Increment the active month index and set the focus on the first day of the next month.
            if (direction === 'next') {
                if (currentIndex < _this.monthRef.length - 1) {
                    _this.activeMonth = currentIndex + 1;
                    numOfRows = _this.monthRef[_this.activeMonth].reference.length - 1;
                    _this.handleRightArrow(0, -1, numOfRows);
                } else {
                    // If we've reached the last visible month, notify the parent component so we can continue navigation.
                    _this.props.onArrowNavigation(direction);
                }
                // Decrement the active month index and set the focus on the last day of the previous month.
            } else if (direction === 'prev') {
                if (currentIndex > 0) {
                    _this.activeMonth = currentIndex - 1;
                    numOfRows = _this.monthRef[_this.activeMonth].reference.length - 1;
                    _this.handleLeftArrow(numOfRows, 7);
                } else {
                    // If we've reached the first visible month, notify the parent component.
                    _this.props.onArrowNavigation(direction);
                }
                // Increment the active month index and set the focus on the same day of the first week in the next month.
            } else if (direction === 'down') {
                if (currentIndex < _this.monthRef.length - 1) {
                    _this.activeMonth = currentIndex + 1;
                    numOfRows = _this.monthRef[_this.activeMonth].reference.length - 1;
                    _this.handleDownArrow(-1, i, numOfRows);
                } else {
                    // If we've reached the last visible month, notify the parent component.
                    _this.props.onArrowNavigation(direction, i);
                }
                // Decrement the active month index and set the focus on the same day of the last week of the previous month.
            } else if (direction === 'up') {
                if (currentIndex > 0) {
                    _this.activeMonth = currentIndex - 1;
                    numOfRows = _this.monthRef[_this.activeMonth].reference.length;
                    _this.handleUpArrow(numOfRows, i);
                } else {
                    // If we've reached the first visible month, notify the parent component.
                    _this.props.onArrowNavigation(direction, i);
                }
            }
        };

        _this.handleRightArrow = function (row, col, numOfRows) {
            var i = _this.activeMonth;
            // If focus is on the last day of a week and the right arrow key is pressed,
            // move focus to the first day of the next week
            if (col === 6 && row < numOfRows) {
                row++;
                col = 0;
                // If focus is on the last day of the month and the right arrow key is pressed,
                // move the focus to first day of the next month
            } else if (col === 6 && row === numOfRows) {
                _this.setMonthFocus('next');
                return;
                // If neither of the above are true, then just move focus to the next day
            } else {
                col++;
            }

            if (_this.monthRef[i].reference[row][col].tabIndex !== -2) {
                _this.monthRef[i].reference[row][col].focus();
            } else {
                // Couldn't set the focus on the new day, so try again with the next cell to the right.
                _this.handleRightArrow(row, col, numOfRows);
            }
        };

        _this.handleLeftArrow = function (row, col) {
            var i = _this.activeMonth;
            // If focus is on the first day of the month and the left arrow key is pressed,
            // move the focus to last day of the previous month
            if (col === 0 && row === 0) {
                _this.setMonthFocus('prev');
                return;
                // If focus is on the first day of a week and the left arrow key is pressed,
                // move focus to the last day of the previous week
            } else if (col === 0 && row !== 0) {
                row--;
                col = 6;
                // If neither of the above are true, then just move focus to the previous day
            } else if (col !== 0) {
                col--;
            }

            if (_this.monthRef[i].reference[row][col].tabIndex !== -2) {
                _this.monthRef[i].reference[row][col].focus();
            } else {
                // Couldn't set the focus on the new day, so try again with the next cell to the left.
                _this.handleLeftArrow(row, col);
            }
        };

        _this.handleDownArrow = function (row, col, numOfRows) {
            var i = _this.activeMonth;
            // If we aren't on the last week of the month,
            // then move focus to same day of the next week.
            if (row < numOfRows) {
                row++;
                if (_this.monthRef[i].reference[row][col].tabIndex !== -2) {
                    _this.monthRef[i].reference[row][col].focus();
                } else {
                    _this.handleDownArrow(row, col, numOfRows); // Couldn't set the focus on the new day, so try again with the next cell below.
                }
                // If the down arrow key is pressed while on the last week of a month,
                // move focus to the next month as long as we aren't already in the last month of the array
            } else if (i <= _this.monthRef.length - 1) {
                _this.setMonthFocus('down', col);
            }
        };

        _this.handleUpArrow = function (row, col) {
            var i = _this.activeMonth;
            // If we aren't on the first week of the month,
            // then move focus to same day of the previous week.
            if (row !== 0) {
                row--;
                if (_this.monthRef[i].reference[row][col].tabIndex !== -2) {
                    _this.monthRef[i].reference[row][col].focus();
                } else {
                    _this.handleUpArrow(row, col); // Couldn't set the focus on the new day, so try again with the next cell above.
                }
                // If the up arrow key is pressed while on the first week of a month,
                // move focus to the previous month as long as we aren't already in the first month of the array
            } else if (i >= 0) {
                _this.setMonthFocus('up', col);
            }
        };

        _this.state = {
            hoverDate: null, // Will be a date string
            ariaLiveLabel: ''
        };

        // Binds
        _this.handleDayClick = _this.handleDayClick.bind(_this);
        _this.handleDayHover = _this.handleDayHover.bind(_this);
        _this.onFirstTouch = _this.onFirstTouch.bind(_this);

        _this.initialMount = true;
        _this.activeMonth = 0;
        _this.monthRef = [];
        return _this;
    }

    _createClass(CalendarBase, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.sizeChanged();
            this.sizeChanged = (0, _lodash2.default)(this.sizeChanged.bind(this), 100);
            (0, _safeWindowListeners.safeWindowListenerAdd)('resize', this.sizeChanged);
            (0, _safeWindowListeners.safeWindowListenerAdd)('touchstart', this.onFirstTouch);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.selectionEnd !== this.props.selectionEnd) {
                this.setState({ hoverDate: nextProps.selectionEnd });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // The refresh prop is toggled every time the onArrowNavigation() callback function is used.
            // We use this as a way for nav-calendar-month to notify calendar-base that it is
            // ready to reset its focus after the new calendar months have been rendered.
            if (prevProps.refresh !== this.props.refresh) {
                this.updateFocus();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _safeWindowListeners.safeWindowListenerRemove)('resize', this.sizeChanged);
            (0, _safeWindowListeners.safeWindowListenerRemove)('touchstart', this.onFirstTouch);
        }
    }, {
        key: 'onFirstTouch',
        value: function onFirstTouch() {
            // storing isTouch on the class as opposed to state since state was
            // causing a scrolling lag on iOS. This is fine for now since isTouch
            // is only used in this file, during a selection, not passed down the
            // component hierarchy.
            this.isTouch = true;
            (0, _safeWindowListeners.safeWindowListenerRemove)('touchstart', this.onFirstTouch);
        }
    }, {
        key: 'sizeChanged',
        value: function sizeChanged() {
            var small = this.firstMonth && this.firstMonth.elem ? this.firstMonth.elem.clientWidth <= 480 : false;
            if (small !== this.state.simple) {
                this.setState({ simple: small });
            }
        }
    }, {
        key: 'handleDayClick',
        value: function handleDayClick(dateString) {
            if (!dateString || !this.props.selectable) {
                return;
            }

            if (this.props.selectionType === 'range') {
                this.rangeSelection(dateString);
            } else {
                this.singleDateSelection(dateString);
            }
        }
    }, {
        key: 'updateAriaLive',
        value: function updateAriaLive(dateString, position) {
            if (dateString !== null) {
                var _props = this.props,
                    i18n = _props.i18n,
                    locale = _props.locale;

                var event = _dateUtils2.default.getDateFromString(dateString);
                var options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
                var languageTag = locale ? new _LanguageTag2.default(locale) : {};
                var code = languageTag.code || 'default';
                var date = event.toLocaleDateString(code, options);

                if (position === 'start') {
                    this.setState({ ariaLiveLabel: i18n.ariaLabelCheckinSelected.replace('{0}', date) });
                } else if (position === 'end') {
                    this.setState({ ariaLiveLabel: i18n.ariaLabelCheckoutSelected.replace('{0}', date) });
                }
            } else {
                this.setState({ ariaLiveLabel: '' });
            }
        }
    }, {
        key: 'rangeSelection',
        value: function rangeSelection(dateString) {
            var _props2 = this.props,
                selectionStart = _props2.selectionStart,
                selectionEnd = _props2.selectionEnd,
                selectionChangeMode = _props2.selectionChangeMode,
                enableSameDayDateRange = _props2.enableSameDayDateRange;
            var hoverDate = this.state.hoverDate;

            // If there is already a start of selection, but no end

            if (selectionStart && !selectionEnd || selectionStart && selectionChangeMode === 'end') {
                var dateCompare = _dateUtils2.default.compareDateStrings(selectionStart, dateString);
                // Is the incoming date greater than the selectionStart or
                // is the same day selected and same day selection allowed?
                if (dateCompare > 0 || dateCompare === 0 && enableSameDayDateRange) {
                    selectionEnd = dateString;
                    this.updateAriaLive(selectionEnd, 'end');
                } else if (dateCompare === 0) {
                    // if incoming date equals selectionStart cancel out the selection
                    selectionStart = null;
                    hoverDate = null;
                    this.updateAriaLive(null, null);
                } else {
                    selectionStart = dateString;
                    selectionEnd = null;
                    this.updateAriaLive(selectionStart, 'start');
                }
            } else {
                selectionStart = dateString;
                selectionEnd = null;
                hoverDate = null;
                this.updateAriaLive(selectionStart, 'start');
            }

            if (!this.isTouch) {
                this.setState({ hoverDate: hoverDate });
            }

            // Notify the outside world
            this.props.onSelectionChanged(selectionStart, selectionEnd);
        }
    }, {
        key: 'singleDateSelection',
        value: function singleDateSelection(dateString) {
            // Notify the outside world
            this.props.onSelectionChanged(dateString);
        }
    }, {
        key: 'handleDayHover',
        value: function handleDayHover(dateString) {
            if (this.props.selectionStart && !this.props.selectionEnd && this.props.selectable) {
                this.setState({ hoverDate: dateString });
            }
        }

        // Used to reset focus on the correct date after nav-calendar-month updates the months that are displayed


        // Used to reset the month and day focus when arrow nagivation moves outside the current month.

    }, {
        key: 'renderMonths',
        value: function renderMonths() {
            var _this2 = this;

            var months = [];
            this.monthRef = [];
            var i18n = this.props.i18n;

            // We determine the "small" styling by rendering an empty div and evaluating its width.
            // Then a second render is triggered that renders all requested months.

            if (this.initialMount) {
                this.initialMount = false;
                return _react2.default.createElement('div', {
                    style: { width: 100 / this.props.numColumns + '%' },
                    ref:
                    /* istanbul ignore next */
                    function ref(c) {
                        return _this2.firstMonth = { elem: c };
                    }
                });
            }

            var numMonths = this.props.numMonthsToDisplay;

            var _loop = function _loop(i) {
                var _dateUtils$addMonthsT = _dateUtils2.default.addMonthsToMonth(_this2.props.year, _this2.props.month, i),
                    month = _dateUtils$addMonthsT.month,
                    year = _dateUtils$addMonthsT.year;

                months.push(_react2.default.createElement(_Month2.default, {
                    key: 'month-' + year + '-' + month,
                    month: month,
                    year: year,
                    width: 100 / _this2.props.numColumns + '%',
                    simple: _this2.state.simple,
                    showMonthLabels: _this2.props.showMonthLabels,
                    monthLabelAlignment: _this2.props.monthLabelAlignment,
                    showGridlines: _this2.props.showGridlines,
                    padWeeks: _this2.props.padWeeks,
                    showSiblingMonths: _this2.props.showSiblingMonths,
                    selectable: _this2.props.selectable,
                    selectionType: _this2.props.selectionType,
                    selectionStart: _this2.props.selectionStart,
                    selectionEnd: _this2.props.selectionEnd,
                    selectedDate: _this2.props.selectedDate,
                    scrollToMonth: _this2.props.scrollToMonth,
                    hoverDate: _this2.state.hoverDate,
                    onDayClick: _this2.handleDayClick,
                    onDayHover: _this2.handleDayHover,
                    onMonthNameClicked: _this2.props.onMonthNameClicked,
                    dayData: _this2.props.dayData,
                    dayTemplateComponent: _this2.props.dayTemplateComponent,
                    onDisabledDayClick: _this2.props.onDisabledDayClick,
                    locale: _this2.props.locale,
                    labels: _this2.props.labels,
                    index: i,
                    setActiveMonth: _this2.setActiveMonth,
                    numMonthsToDisplay: _this2.props.numMonthsToDisplay,
                    handleRightArrow: _this2.handleRightArrow,
                    handleLeftArrow: _this2.handleLeftArrow,
                    handleDownArrow: _this2.handleDownArrow,
                    handleUpArrow: _this2.handleUpArrow,
                    i18n: i18n,
                    ref: function ref(_ref) {
                        /* istanbul ignore next */
                        if (i === 0) {
                            _this2.firstMonth = _ref;
                        }
                        _this2.monthRef[i] = _ref;
                    }
                }));
            };

            for (var i = 0; i <= numMonths - 1; i++) {
                _loop(i);
            }

            return months;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                className = _props3.className,
                wdioPrefix = _props3.wdioPrefix;

            var calendarClasses = (0, _classnames2.default)(className, 'calendar', 'clearfix');
            var dataWdio = wdioPrefix ? wdioPrefix + '-calendar' : 'calendar';

            return _react2.default.createElement(
                'div',
                { className: calendarClasses, 'data-wdio': dataWdio },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only', 'aria-live': 'polite' },
                    this.state.ariaLiveLabel
                ),
                this.renderMonths()
            );
        }
    }]);

    return CalendarBase;
}(_react.Component);

CalendarBase.propTypes = {
    /** Zero-based index representing the month. The calendar stores nothing for month or year, it is up to the host app to provide those values. */
    month: _propTypes2.default.number.isRequired,
    /** e.g. 2016, number representing the year. The calendar stores nothing for month or year, it is up to the host app to provide those values. */
    year: _propTypes2.default.number.isRequired,
    /** The number of months to draw. Use this property in conjunction with the numColumns property to achieve your use-case */
    numMonthsToDisplay: _propTypes2.default.number,
    /** The number of columns to break the months into. Used in conjunction with "numMonthsToDisplay" to achieve multiple use-cases */
    numColumns: _propTypes2.default.number,
    /** Show/Hide the days of the previous and next months to fill out start and end weeks. Showing them can be desireable for single months, but not with multiple month displays. */
    showSiblingMonths: _propTypes2.default.bool,
    /** Force all months to have 6 weeks rather than a varying number. This is automatically done in multi-column mode so that the rows align. */
    padWeeks: _propTypes2.default.bool,
    /** Show/Hide the label above each month "September 2016" */
    showMonthLabels: _propTypes2.default.bool,
    /** Horizontal alignment of label above each month */
    monthLabelAlignment: _propTypes2.default.oneOf(['left', 'right', 'center']),
    /** Show/Hide gridlines around days */
    showGridlines: _propTypes2.default.bool,
    /** Turns on date range selection */
    selectable: _propTypes2.default.bool,
    /** Type of selection 1) date range (default) 2) single date */
    selectionType: _propTypes2.default.oneOf(['range', 'single']),
    /** Enable date range being the same date. By default, if the end date is selected to be the same as the start date, the entire selection is canceled */
    enableSameDayDateRange: _propTypes2.default.bool,
    /** Format: "YYYY-MM-DD". For date range selections, this is the start date. */
    selectionStart: _propTypeDateString2.default,
    /** Format: "YYYY-MM-DD". For date range selections, this is the end date. */
    selectionEnd: _propTypeDateString2.default,
    /** Format: "YYYY-MM-DD". For 'single' selectionType, this is the selected date */
    selectedDate: _propTypeDateString2.default,
    /** onSelectionChanged(selectionStart, selectionEnd) Called when a date range selection changes. In some cases the selectionEnd will be null, such as when a selection is first initiated. */
    onSelectionChanged: _propTypes2.default.func,
    /** Once a selection is made, by default any clicking down will start a new selection. If you need to change the start or end date rather than replace the full selection, choose 'start' or 'end' here. We do this for the date range picker (for example) */
    selectionChangeMode: _propTypes2.default.oneOf(['all', 'start', 'end']),
    /** When using the calendar in a scrolling scenario, scroll to the selected month on render */
    scrollToMonth: _propTypes2.default.bool,
    /** onDisabledDayClick Called when clicked on a disabled date an alert with arrival and departure date triggers. */
    onDisabledDayClick: _propTypes2.default.func,
    /** onMonthNameClicked(month, year) Called when the user clicks the month name label */
    onMonthNameClicked: _propTypes2.default.func,
    /** If you need custom data displayed on each day, such as nightly rate, you can provide a template component and a set of data. Use this property for the component  */
    dayTemplateComponent: _propTypes2.default.func,
    /** If you provide a dayTemplateComponent, you can also specify the data needed.  See the "Day Data" section above. */
    dayData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** By default, the calender element is given a data-wdio attribute of "calendar".
    If you have more than one on a page you can add a prefix to those two strings by using this property. */
    wdioPrefix: _propTypes2.default.string,
    /** onArrowNavigation(direction, column) Called when the beginning or end of the visible calendar range is navigated to via arrow keys. Used in conjunction with nav-calendar-month to navigate to prev/next month. */
    onArrowNavigation: _propTypes2.default.func,
    /** Last arrow key direction that was pressed while using keyboard navigation for a11y. ie: 'up', 'down', 'prev', 'next' */
    direction: _propTypes2.default.string,
    /** The 0-6 index of the last table cell column that received focus. Used to update the focus to the correct date when updateFocus() is called. */
    column: _propTypes2.default.number,
    /** The 0-11 index of the current month that has a date in focus. Used to update the focus to the correct month when updateFocus() is called.  */
    activeMonth: _propTypes2.default.number,
    /** Flag to determine if focus date needs to be updated. */
    refresh: _propTypes2.default.bool,
    /** A moniker or BCP-47 style language tag string. */
    locale: _propTypes2.default.string,
    /** Optional labels object to override default locale-driven labels */
    labels: _propTypes2.default.shape({
        monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortMonthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        dayNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortDayNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    /** Object containing lingua translations for the current locale. It is assumed that the parent app will prepare and provide the i18n object matching the shape seen here. */
    i18n: _propTypes2.default.shape({
        ariaLabelCheckinSelected: _propTypes2.default.string,
        ariaLabelCheckoutSelected: _propTypes2.default.string,
        ariaLabelNotValidCheckin: _propTypes2.default.string,
        ariaLabelNotValidCheckout: _propTypes2.default.string,
        ariaLabelUnavailable: _propTypes2.default.string
    })
};
CalendarBase.defaultProps = {
    numMonthsToDisplay: 1,
    numColumns: 1,
    showSiblingMonths: false,
    showMonthLabels: true,
    monthLabelAlignment: 'center',
    showGridlines: false,
    selectable: false,
    enableSameDayDateRange: false,
    selectionType: 'range',
    selectedDate: null, // Will be a date string
    selectionStart: null, // Will be a date string
    selectionEnd: null, // Will be a date string
    selectionChangeMode: 'all',
    onSelectionChanged: function onSelectionChanged() {},
    onDisabledDayClick: function onDisabledDayClick() {},
    dayData: {},
    dayTemplateComponent: null,
    onArrowNavigation: function onArrowNavigation() {},
    direction: null,
    column: null,
    activeMonth: null,
    refresh: false,
    labels: {},
    i18n: {
        ariaLabelCheckinSelected: '{0} is selected as your check-in date.',
        ariaLabelCheckoutSelected: '{0} is selected as your checkout date.',
        ariaLabelNotValidCheckin: '{0} is not a valid check in date.',
        ariaLabelNotValidCheckout: '{0} is not a valid checkout date.',
        ariaLabelUnavailable: '{0} is unavailable.'
    }
};
exports.default = CalendarBase;
//# sourceMappingURL=CalendarBase.js.map

/***/ }),

/***/ "O+Vf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global google */

var Marker = function (_PureComponent) {
    _inherits(Marker, _PureComponent);

    function Marker(props) {
        _classCallCheck(this, Marker);

        var _this = _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).call(this, props));

        var icon = props.icon,
            id = props.id,
            onClick = props.onClick,
            map = props.map,
            position = props.position;

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(position),
            map: map,
            icon: icon,
            zIndex: 1
        });

        google.maps.event.addListener(marker, 'click', function () {
            onClick(id);
        });

        _this.marker = marker;
        return _this;
    }

    _createClass(Marker, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var currentIcon = this.props.icon;
            var currentPosition = this.props.position;

            if (typeof currentIcon !== 'undefined' && currentIcon !== prevProps.icon) {
                this.marker.setIcon(currentIcon);
            }

            if (currentPosition.lat !== prevProps.position.lat || currentPosition.lng !== prevProps.position.lng) {
                this.marker.setPosition(new google.maps.LatLng(currentPosition));
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            /* Remove all marker listeners */
            google.maps.event.clearInstanceListeners(this.marker);

            /* Remove marker */
            this.marker.setMap(null);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                map = _props.map;


            if (children) {
                return (0, _react.cloneElement)(children, {
                    map: map,
                    marker: this.marker
                });
            }
            return null;
        }
    }]);

    return Marker;
}(_react.PureComponent);

Marker.propTypes = {
    /** Single child to be rendered under marker */
    children: _propTypes2.default.node,
    /** Icon object to be rendered by google maps */
    icon: _propTypes2.default.shape({
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number,
        path: _propTypes2.default.string,
        scale: _propTypes2.default.number,
        strokeColor: _propTypes2.default.string
    }),
    /** Unique marker identifier */
    id: _propTypes2.default.string.isRequired,
    /** Callback for clicking on the maker */
    onClick: _propTypes2.default.func,
    /** map reference (automatically passed down if wrapped by GoogleMaps) */
    map: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** lat and lng object describing the origin of the marker*/
    position: _propTypes2.default.shape({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }).isRequired
};
Marker.defaultProps = {
    onClick: /* istanbul ignore next */function onClick() {},
    icon: {
        anchor: { x: 12, y: 15 },
        fillColor: '#0067db', // @ha-core-blue
        fillOpacity: 1,
        path: 'M8.3 1C5.3 1 3 3.4 3 6.3c0 4 4.5 8.7 5.3 8.7.8 0 5.3-4.8 5.3-8.7 0-3-2.4-5.3-5.3-5.3zm0 7.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8z', // LOCATION__24
        scale: 2,
        strokeColor: '#0067db' // @ha-core-blue
    }
};
exports.default = Marker;
//# sourceMappingURL=Marker.js.map

/***/ }),

/***/ "OAwv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__("rprB");
var objectAssign = __webpack_require__("BEQ0");
var decodeComponent = __webpack_require__("i4Cv");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: this.parse(this.extract(str), opts)
	};
};


/***/ }),

/***/ "OEBp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselUtil = exports.ModalCarouselContainer = exports.InlineCarouselContainer = exports.CarouselSlide = exports.Carousel = undefined;

var _Carousel = __webpack_require__("zaqd");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _CarouselSlide = __webpack_require__("x08l");

var _CarouselSlide2 = _interopRequireDefault(_CarouselSlide);

var _InlineCarouselContainer = __webpack_require__("MBgi");

var _InlineCarouselContainer2 = _interopRequireDefault(_InlineCarouselContainer);

var _ModalCarouselContainer = __webpack_require__("w7pv");

var _ModalCarouselContainer2 = _interopRequireDefault(_ModalCarouselContainer);

var _CarouselUtil = __webpack_require__("ZTHW");

var _CarouselUtil2 = _interopRequireDefault(_CarouselUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Carousel = _Carousel2.default;
exports.CarouselSlide = _CarouselSlide2.default;
exports.InlineCarouselContainer = _InlineCarouselContainer2.default;
exports.ModalCarouselContainer = _ModalCarouselContainer2.default;
exports.CarouselUtil = _CarouselUtil2.default;
exports.default = _Carousel2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "OFFT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEART_SELECTED__16 = void 0;
var HEART_SELECTED__16 = '<svg data-id="SVG_HEART_SELECTED__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M8 4c.7-1 1.8-2 3.5-2 2 0 3.5 1.7 3.5 3.6 0 2.9-3.1 4.7-7 8.4-3.9-3.7-7-5.5-7-8.4C1 3.6 2.4 2 4.5 2a4 4 0 0 1 3.4 2"/><path stroke-linecap="round" stroke-linejoin="round" d="M8 4c.7-1 1.8-2 3.5-2 2 0 3.5 1.7 3.5 3.6 0 2.9-3.1 4.7-7 8.4-3.9-3.7-7-5.5-7-8.4C1 3.6 2.4 2 4.5 2a4 4 0 0 1 3.4 2z"/></g></svg>';
exports.HEART_SELECTED__16 = HEART_SELECTED__16;

/***/ }),

/***/ "OMJi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("fC4T");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("ONRY");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "ONRY":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "OdER":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeUnitFromTripBoardsMutation = exports.updateStayMutation = exports.createNewTripboardMutation = exports.addToTripboardMutation = exports.fetchPreviewsQuery = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    query paginatedTripBoards($hav: String!, $pageSize: Int!, $listingPageSize: Int) {\n        paginatedTripBoards(hav: $hav, pageSize: $pageSize) {\n            tripBoards {\n                uuid\n                name\n                stay {\n                    adultCount\n                    childrenCount\n                    petsIncluded\n                    dateRange {\n                        arrival\n                        departure\n                    }\n                }\n                listingRefs\n                listings(pageSize: $listingPageSize) {\n                    listingId\n                    images {\n                        c6_uri\n                        height\n                        width\n                    }\n                }\n            }\n        }\n    }\n'], ['\n    query paginatedTripBoards($hav: String!, $pageSize: Int!, $listingPageSize: Int) {\n        paginatedTripBoards(hav: $hav, pageSize: $pageSize) {\n            tripBoards {\n                uuid\n                name\n                stay {\n                    adultCount\n                    childrenCount\n                    petsIncluded\n                    dateRange {\n                        arrival\n                        departure\n                    }\n                }\n                listingRefs\n                listings(pageSize: $listingPageSize) {\n                    listingId\n                    images {\n                        c6_uri\n                        height\n                        width\n                    }\n                }\n            }\n        }\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    mutation addUnitToTripBoard($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n        addUnitToTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad)\n    }\n'], ['\n    mutation addUnitToTripBoard($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n        addUnitToTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad)\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    mutation createTripBoard($hav: String!, $tripBoard: TripBoardInput!, $listingPageSize: Int) {\n        createTripBoard(hav: $hav, tripBoard: $tripBoard) {\n            uuid\n            name\n            listingRefs\n            stay {\n                adultCount\n                childrenCount\n                petsIncluded\n                dateRange {\n                    arrival\n                    departure\n                }\n            }\n            listings(pageSize: $listingPageSize) {\n                listingId\n                images {\n                    c6_uri\n                    height\n                    width\n                }\n            }\n        }\n    }\n'], ['\n    mutation createTripBoard($hav: String!, $tripBoard: TripBoardInput!, $listingPageSize: Int) {\n        createTripBoard(hav: $hav, tripBoard: $tripBoard) {\n            uuid\n            name\n            listingRefs\n            stay {\n                adultCount\n                childrenCount\n                petsIncluded\n                dateRange {\n                    arrival\n                    departure\n                }\n            }\n            listings(pageSize: $listingPageSize) {\n                listingId\n                images {\n                    c6_uri\n                    height\n                    width\n                }\n            }\n        }\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    mutation updateStayOnTripBoard($hav: String!, $tripBoardUuid: String!, $stay: StayInput!) {\n        updateStayOnTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, stay: $stay)\n    }\n'], ['\n    mutation updateStayOnTripBoard($hav: String!, $tripBoardUuid: String!, $stay: StayInput!) {\n        updateStayOnTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, stay: $stay)\n    }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    mutation removeUnitFromTripBoards($hav: String!, $unitTriad: String!) {\n        removeUnitFromTripBoards(hav: $hav, unitTriad: $unitTriad)\n    }\n'], ['\n    mutation removeUnitFromTripBoards($hav: String!, $unitTriad: String!) {\n        removeUnitFromTripBoards(hav: $hav, unitTriad: $unitTriad)\n    }\n']);

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// # Query to fetch a paginated list of trip boards
//     paginatedTripBoards(
//         # The hav ID associated with this trip board
//         hav: String!
//         # The page being requested
//         page: Int
//         # The number of results requested from each page
//         pageSize: Int
//     ): PaginatedTripBoards
var fetchPreviewsQuery = exports.fetchPreviewsQuery = (0, _graphqlTag2.default)(_templateObject);

// # Add a Unit to the trip board document.
// addUnitToTripBoard(
//     # The hav ID of the user adding the unit
//     hav: String!
//     # The uuid of the trip board.
//     tripBoardUuid: String!
//     # The unitTriad for the listing.
//     unitTriad: String!
// ): Boolean sucess or failure

var addToTripboardMutation = exports.addToTripboardMutation = (0, _graphqlTag2.default)(_templateObject2);

// # Creates a new trip board document.
// createTripBoard(
//     # The hav ID of the user creating the trip board.
//     hav: String!
//     # The trip board being created.
//     tripBoard: TripBoardInput!
// ): TripBoard

// input TripBoardInput {
//     boardId: String
//     createTime: String
//     dated: Boolean
//     endDate: String
//     listings: [TripBoardListingInput]
//     name: String!
//     shared: Boolean
//     sourceFavorite: Boolean
//     startDate: String
//     updateTime: String
// }

// input TripBoardListingInput {
//     endDate: String
//     listingId: String!
//     startDate: String
// }
var createNewTripboardMutation = exports.createNewTripboardMutation = (0, _graphqlTag2.default)(_templateObject3);

// # Updates the stay (guest context with dates) on the trip board document unit.
// updateStayOnTripBoard(
//     # The hav ID of the user updating the stay.
//     hav: String!
//     # The uuid of the trip board.
//     tripBoardUuid: String!
//     # The guest context with dates.
//     stay: StayInput!
// ): Boolean
var updateStayMutation = exports.updateStayMutation = (0, _graphqlTag2.default)(_templateObject4);

// # Removes a Unit from multiple trip board documents.
// removeUnitFromTripBoards(
//     # The hav ID of the user removing the unit.
//     hav: String!
//     # The unitTriad for the listing.
//     unitTriad: String!
// ): Boolean

var removeUnitFromTripBoardsMutation = exports.removeUnitFromTripBoardsMutation = (0, _graphqlTag2.default)(_templateObject5);
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ "Oelt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OoWg":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('observable');


/***/ }),

/***/ "OvRC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("AFOY"), __esModule: true };

/***/ }),

/***/ "PKY1":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),

/***/ "PY1i":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
var document = __webpack_require__("YjQv").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "PbQV":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("ksFB");
var toLength = __webpack_require__("GhAV");
var toAbsoluteIndex = __webpack_require__("+VX5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "Pf15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "PirY":
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ "Pvdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q2wK":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("8AZL");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "Qhe+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GraphQLError", {
  enumerable: true,
  get: function get() {
    return _GraphQLError.GraphQLError;
  }
});
Object.defineProperty(exports, "syntaxError", {
  enumerable: true,
  get: function get() {
    return _syntaxError.syntaxError;
  }
});
Object.defineProperty(exports, "locatedError", {
  enumerable: true,
  get: function get() {
    return _locatedError.locatedError;
  }
});
Object.defineProperty(exports, "printError", {
  enumerable: true,
  get: function get() {
    return _printError.printError;
  }
});
Object.defineProperty(exports, "formatError", {
  enumerable: true,
  get: function get() {
    return _formatError.formatError;
  }
});

var _GraphQLError = __webpack_require__("QmgZ");

var _syntaxError = __webpack_require__("6fpj");

var _locatedError = __webpack_require__("t/I/");

var _printError = __webpack_require__("Iqx9");

var _formatError = __webpack_require__("zZmH");

/***/ }),

/***/ "QmgZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphQLError = GraphQLError;

var _printError = __webpack_require__("Iqx9");

var _location = __webpack_require__("Nvbj");

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return (0, _location.getLocation)(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions || originalError && originalError.extensions;

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return (0, _printError.printError)(this);
    }
  }
});

/***/ }),

/***/ "Qp3N":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    isArguments = __webpack_require__("1Yb9"),
    isArray = __webpack_require__("NGEn");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "RCJj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "REiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RH2O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("YSwN"))(18);

/***/ }),

/***/ "RXFs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RgpV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RiTF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ASPECT_DELIMITER = 'x';
var util = {
    getAspectRatioData: function getAspectRatioData() {
        var aspectRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '4x3';

        var arParts = aspectRatio.split(ASPECT_DELIMITER).map(function (val) {
            return parseInt(val, 10);
        });
        var ratio = arParts[0] / arParts[1];
        return {
            ratio: ratio,
            ratioString: aspectRatio,
            heightDimension: arParts[1],
            widthDimension: arParts[0],
            heightMultiplier: arParts[1] / arParts[0],
            widthMultiplier: ratio
        };
    },
    getImageBoundSide: function getImageBoundSide(imageAspectRatio, carouselAspectRatio) {
        return imageAspectRatio < carouselAspectRatio ? 'width' : 'height';
    }
};

exports.default = util;
//# sourceMappingURL=AspectRatioCardUtil.js.map

/***/ }),

/***/ "Rw6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SCsJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Returns a date object when given a string, "YYYY-MM-DD".
 *
 * @param {string} dateString - date string in the format "YYYY-MM-DD"
 * @return {Date}  New Date object from provided string.
 */
function getDateFromString(dateString) {
    var dateElems = dateString.split('-');
    return new Date(+dateElems[0], +dateElems[1] - 1, +dateElems[2]);
}

/**
 * Returns string representation of a date when given a date object.
 * The result is in the format "YYYY-MM-DD".
 *
 * @param {Date} date - date object
 * @return {string}  string representation of date.
 */
function getDateToString(date) {
    var month = date.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = date.getDate();
    day = day < 10 ? '0' + day : day;
    return date.getFullYear() + '-' + month + '-' + day;
}

/**
 * Returns string representation of a date when given a custom
 * object with year, month, day. That custom object is provided
 * by the calendar-base data.
 * The result is in the format "YYYY-MM-DD".
 *
 * @param {object} obj - custom date object
 * @return {string}  string representation of date.
 */
function getDayToString(obj) {
    var year = obj.year,
        month = obj.month,
        day = obj.day;

    month = month + 1;
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    return year + '-' + month + '-' + day;
}

/**
 * Returns a javascript Date object given a custom Day object provided
 * by the calendar-base data.
 * @param {object} obj - custom date object
 * @return {Date} javascript Date object
 */
function getDayToDate(obj) {
    var year = obj.year,
        month = obj.month,
        day = obj.day;

    return new Date(year, month, day);
}

/**
 * Returns an array of date objects given a start date and a number
 * of nights.
 *
 * @param {string} start - start date in format, "YYYY-MM-DD"
 * @param {number} num - number of nights
 * @return {array}  Array of date objects
 */
function getDateRange(start, num) {
    var startDate = getDateFromString(start);
    var dates = [getDateToString(new Date(startDate))];

    for (var i = 0; i < num; i++) {
        dates.push(getDateToString(new Date(startDate.setDate(startDate.getDate() + 1))));
    }
    return dates;
}

/**
 * Returns the number of days between two date strings.
 *
 * @param {string} startString - start date string in format, "YYYY-MM-DD"
 * @param {string} endString - end date string in format, "YYYY-MM-DD"
 * @return {number}  number of days
 */
function getNumDaysBetweenDateStrings(startString, endString) {
    var numDays = 0;
    var startDate = getDateFromString(startString);
    var endDate = getDateFromString(endString);
    while (endDate > startDate) {
        numDays++;
        startDate.setDate(startDate.getDate() + 1);
    }
    return numDays;
}

/**
 * Compares 2 date strings and returns an integer that indicates whether the
 * second date is earlier (-1), later (1), or equal to (0) the first.
 *
 * @param {string} startString - start date string in format, "YYYY-MM-DD"
 * @param {string} endString - end date string in format, "YYYY-MM-DD"
 * @return {int}  indication or comparison
 */
function compareDateStrings(startString, endString) {
    var _startString$split = startString.split('-'),
        _startString$split2 = _slicedToArray(_startString$split, 3),
        year1 = _startString$split2[0],
        month1 = _startString$split2[1],
        day1 = _startString$split2[2];

    var _endString$split = endString.split('-'),
        _endString$split2 = _slicedToArray(_endString$split, 3),
        year2 = _endString$split2[0],
        month2 = _endString$split2[1],
        day2 = _endString$split2[2];

    if (+year2 > +year1) {
        return 1;
    }
    if (+year2 < +year1) {
        return -1;
    }
    // Same year
    if (+month2 > +month1) {
        return 1;
    }
    if (+month2 < +month1) {
        return -1;
    }
    // Same month
    if (+day2 > +day1) {
        return 1;
    }
    if (+day2 < +day1) {
        return -1;
    }

    return 0;
}

/**
 * Returns whether the date represented by the given custom date object is the last day of the given month.
 * @param day {object} The custom day object to check
 * @returns {boolean} true if it is the last day of the given month, otherwise false
 */
function isLastDayInMonth(day) {
    var test = getDayToDate(day);
    if (test.getDate() < 28) {
        return false;
    }
    test.setDate(test.getDate() + 1);
    return test.getDate() === 1;
}

/**
 * Returns whether the date represented by the given custom date object is the first day of the given month.
 * @param day {object} The custom day object to check
 * @returns {boolean} true if it is the first day of the given month, otherwise false
 */
function isFirstDayInMonth(day) {
    var test = getDayToDate(day);
    if (test.getDate() !== 1) {
        return false;
    }

    return true;
}

/**
 * Given a month, add a number of months to it and return the new month.
 * @param year {object} Year of the month
 * @param month {object} month number (zero-based)
 * @param num {object} Number of months to add
 * @returns {object} object with the year and month of the new month
 */
function addMonthsToMonth(year, month, num) {
    var date = getDayToDate({ year: year, month: month, day: '01' });
    date.setMonth(date.getMonth() + num);
    return { year: date.getFullYear(), month: date.getMonth() };
}

exports.default = { getDateFromString: getDateFromString, getDateToString: getDateToString, getDayToString: getDayToString, getDayToDate: getDayToDate, getDateRange: getDateRange, getNumDaysBetweenDateStrings: getNumDaysBetweenDateStrings, compareDateStrings: compareDateStrings, isFirstDayInMonth: isFirstDayInMonth, isLastDayInMonth: isLastDayInMonth, addMonthsToMonth: addMonthsToMonth };
//# sourceMappingURL=dateUtils.js.map

/***/ }),

/***/ "SIAm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),

/***/ "SMcY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUP__16 = void 0;
var GROUP__16 = '<svg data-id="SVG_GROUP__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.9A4 4 0 0 0 6.7 9a4 4 0 0 0-3.8.4A4 4 0 0 0 1 13"/><path d="M6.9 7c0 1-.8 1.8-1.9 1.8C4 8.8 3.2 8 3.2 7v-.5c0-1 .8-1.9 1.8-1.9S7 5.5 7 6.5V7z"/><path stroke-linecap="round" stroke-linejoin="round" d="M6.9 7c0 1-.8 1.8-1.9 1.8C4 8.8 3.2 8 3.2 7v-.5c0-1 .8-1.9 1.8-1.9S7 5.5 7 6.5V7zm2.3.7a4 4 0 0 1 5.8 3.4"/><path d="M9.3 5.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-.5c0-1-.8-1.8-1.8-1.8S9.3 4 9.3 5v.5z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.3 5.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-.5c0-1-.8-1.8-1.8-1.8S9.3 4 9.3 5v.5z"/></g></svg>';
exports.GROUP__16 = GROUP__16;

/***/ }),

/***/ "SSMt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SWGL":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "So98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__("2KeS");

var _translations = __webpack_require__("XAeO");

var _translations2 = _interopRequireDefault(_translations);

var _auth = __webpack_require__("lmMP");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    translations: _translations2.default,
    auth: _auth2.default
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "StqW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SuiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5L2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "THEY":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "TINw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Custom PropTypes validator to check if the value is an instance of window.Element
// but also falling back to Object if window is undefined (SSR).
var checkElementType = function checkElementType(props, propName, componentName) {
    var instance = "object" !== 'undefined' && window.Element ? window.Element : Object;
    if (props[propName] && !(props[propName] instanceof instance)) {
        return new Error('Invalid prop \'' + propName + '\' supplied to \'' + componentName + '\'. Validation failed.');
    }
    return null;
};

exports.checkElementType = checkElementType;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "TQ3y":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("blYT");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "TkRw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TkuE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U7UD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GuestPicker = undefined;

var _GuestPicker = __webpack_require__("EJZz");

var _GuestPicker2 = _interopRequireDefault(_GuestPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GuestPicker2.default; /**
                                          * This index.js file is the entry point for your component and
                                          * is referenced from package.json. It's best to keep it lightweight
                                          * and do all of your work in component and subcomponent files.
                                         **/

exports.GuestPicker = _GuestPicker2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "UNM8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * See README.md for full description
 *
 * @module redux-middleware-adapter
 */

var _registeredMiddleware;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stage = {
    before: 'before',
    after: 'after'
};

var registeredMiddleware = (_registeredMiddleware = {}, _defineProperty(_registeredMiddleware, stage.before, {}), _defineProperty(_registeredMiddleware, stage.after, {}), _registeredMiddleware);

/**
 * middlewareAdapter is applied to the redux store. It is a standard redux middleware.
 * It is invoked after each dispatched action, prior to any reducer being called.
 * middlewareAdapter maintains a map of action types and callbacks. In response
 * to an action, it will invoke each of the callback functions that are
 * associated with that action's type.
 */
var middlewareAdapter = function middlewareAdapter(store) {
    return function (next) {
        return function (action) {
            if (registeredMiddleware[stage.before][action.type]) {
                registeredMiddleware[stage.before][action.type].forEach(function (middleware) {
                    return middleware(store, action);
                });
            }

            var result = next(action);

            if (registeredMiddleware[stage.after][action.type]) {
                registeredMiddleware[stage.after][action.type].reduce(function (_result, middleware) {
                    return middleware(store, action);
                }, result);
            }

            // return the state to follow Redux convention
            return result;
        };
    };
};

/**
 * registerMiddleware takes an actionType and a callback function.
 * When an action of the provided type is dispatched, the callback function will
 * be invoked by the middlewareAdapter.
 * The provided callback function takes 3 parameters, the store and the action.
 * These parameters may be omitted if they are not needed.
 * @param {String} actionType action type string of the action that is dispatched that the function is concerned with
 * @param {func} func middleware function that is listening to the action provided
 * @param {String} callTiming This can be either "before" or "after" and tells middleware adapter to call the middleware function
 * before or after the redux state is updated by the reducers handling the same action type. Default: "before"
 */
var registerMiddleware = function registerMiddleware(actionType, func) {
    var callTiming = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stage.before;

    /* istanbul ignore else */
    if (!registeredMiddleware[callTiming][actionType]) {
        registeredMiddleware[callTiming][actionType] = [];
    }

    if (!registeredMiddleware[callTiming][actionType].includes(func)) {
        registeredMiddleware[callTiming][actionType].push(func);
    }
};

module.exports = { registerMiddleware: registerMiddleware, middlewareAdapter: middlewareAdapter, registeredMiddleware: registeredMiddleware };
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "UVMF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UgnD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _actions = __webpack_require__("+oMz");

var ToasterActionCreators = _interopRequireWildcard(_actions);

var _redux = __webpack_require__("2KeS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToasterSvgs = __webpack_require__("mZVS");

var _ToasterSvgs2 = _interopRequireDefault(_ToasterSvgs);

var _Toast = __webpack_require__("haWr");

var _Toast2 = _interopRequireDefault(_Toast);

__webpack_require__("RCJj");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function Toaster(_ref) {
    var autoClose = _ref.autoClose,
        autoCloseAfter = _ref.autoCloseAfter,
        onAutoClose = _ref.onAutoClose,
        onClose = _ref.onClose,
        onCloseClick = _ref.onCloseClick,
        onContentClick = _ref.onContentClick,
        position = _ref.position,
        removeToastById = _ref.removeToastById,
        toasts = _ref.toasts,
        type = _ref.type;

    var containerClasses = (0, _classnames2.default)({
        'toaster': true,
        'is-bottom': position === 'bottom',
        'is-top': position === 'top'
    });

    return _react2.default.createElement(
        'div',
        { className: containerClasses },
        _react2.default.createElement(_ToasterSvgs2.default, null),
        toasts.map(function (toast) {
            // eslint-disable-line
            var props = toast.props;

            var shouldAutoClose = props.autoClose || autoClose;
            var handleAutoClose = props.onAutoClose || onAutoClose;
            var handleCloseClick = props.onCloseClick || onCloseClick;
            var handleContentClick = props.onContentClick || onContentClick;
            var handleClose = props.onClose || onClose;
            var autoCloseTime = props.autoCloseAfter || autoCloseAfter;
            var toastType = props.type || type;

            return _react2.default.createElement(_Toast2.default, _extends({
                key: 'toast-' + props.id
            }, toast.props, {
                autoClose: shouldAutoClose,
                autoCloseAfter: autoCloseTime,
                onClose: handleClose,
                onRemove: removeToastById,
                onContentClick: handleContentClick,
                onAutoClose: handleAutoClose,
                onCloseClick: handleCloseClick,
                type: toastType
            }));
        })
    );
}

Toaster.propTypes = {
    autoClose: _propTypes2.default.bool,
    autoCloseAfter: _propTypes2.default.number,
    position: _propTypes2.default.oneOf(['top', 'bottom']),
    onAutoClose: _propTypes2.default.func,
    onContentClick: _propTypes2.default.func,
    onCloseClick: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    type: _propTypes2.default.string,
    id: _propTypes2.default.number
};

Toaster.defaultProps = {
    autoClose: true,
    autoCloseAfter: 5000, // 5 seconds
    position: 'bottom',
    onAutoClose: noop,
    onContentClick: noop,
    onCloseClick: noop,
    onClose: noop,
    type: 'default'
};

function mapStateToProps(state) {
    return {
        toasts: state.toasts
    };
}

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        removeToastById: ToasterActionCreators.removeToastById,
        createToast: ToasterActionCreators.createToast
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Toaster);
//# sourceMappingURL=Toaster.js.map

/***/ }),

/***/ "UjR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// === Symbol Support ===

var hasSymbols = function () {
  return typeof Symbol === 'function';
};
var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

// === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];

  if (value == null) return undefined;

  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');

  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;
  if (ctor !== undefined) {
    ctor = ctor[getSymbol('species')];
    if (ctor === null) {
      ctor = undefined;
    }
  }
  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;

  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');
      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;
  if (!queue) {
    return;
  }
  subscription._queue = undefined;
  subscription._state = 'ready';
  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';

  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);
    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;
      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;
      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({ type: type, value: value });
    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{ type: type, value: value }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable

    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';

    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: 'closed',
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: 'next',
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: 'error',
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: 'complete',
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: 'closed',
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = exports.Observable = function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');

    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');

    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: 'subscribe',
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }
      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: 'forEach',
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },

          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: 'map',
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'reduce',
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;

      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));

            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'concat',
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscription = void 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (sources.length === 0) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources.shift()));
              }
            }
          });
        }

        startNext(_this5);

        return function () {
          if (subscription) {
            subscription = undefined;
            subscription.unsubscribe();
          }
        };
      });
    }
  }, {
    key: 'flatMap',
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });

            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: getSymbol('observable'),
    value: function () {
      return this;
    }
  }], [{
    key: 'from',
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;

      if (x == null) throw new TypeError(x + ' is not an object');

      var method = getMethod(x, getSymbol('observable'));
      if (method) {
        var observable = method.call(x);

        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');

        if (isObservable(observable) && observable.constructor === C) return observable;

        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, getSymbol('iterator'));
        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var item = _step.value;

                  observer.next(item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;
            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }
            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: 'of',
    value: function of() {
      for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;

      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;
          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }
          observer.complete();
        });
      });
    }
  }, {
    key: getSymbol('species'),
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: getSymbol('observable'),
      hostReportError: hostReportError
    },
    configurabe: true
  });
}

/***/ }),

/***/ "UjZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UnEC":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "UqVM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TripBoardButtonDataProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("2KeS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withFetchPreviews = __webpack_require__("+TD/");

var _withFetchPreviews2 = _interopRequireDefault(_withFetchPreviews);

var _withCreateNewTripBoard = __webpack_require__("m+HC");

var _withCreateNewTripBoard2 = _interopRequireDefault(_withCreateNewTripBoard);

var _withAddToTripBoard = __webpack_require__("CWsh");

var _withAddToTripBoard2 = _interopRequireDefault(_withAddToTripBoard);

var _withUpdateStayOnTripBoard = __webpack_require__("EXV4");

var _withUpdateStayOnTripBoard2 = _interopRequireDefault(_withUpdateStayOnTripBoard);

var _withHav = __webpack_require__("L1Sl");

var _withHav2 = _interopRequireDefault(_withHav);

var _withRemoveFromTripBoards = __webpack_require__("anwW");

var _withRemoveFromTripBoards2 = _interopRequireDefault(_withRemoveFromTripBoards);

var _graphql = __webpack_require__("qm98");

var _TripBoardButton = __webpack_require__("zq7B");

var _TripBoardButton2 = _interopRequireDefault(_TripBoardButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TripBoardButtonDataProvider = exports.TripBoardButtonDataProvider = function (_Component) {
    _inherits(TripBoardButtonDataProvider, _Component);

    function TripBoardButtonDataProvider(props) {
        _classCallCheck(this, TripBoardButtonDataProvider);

        var _this = _possibleConstructorReturn(this, (TripBoardButtonDataProvider.__proto__ || Object.getPrototypeOf(TripBoardButtonDataProvider)).call(this, props));

        _this.handleCreateTripBoard = _this.handleCreateTripBoard.bind(_this);
        _this.handleAddToTripBoard = _this.handleAddToTripBoard.bind(_this);
        _this.handleGetTripBoards = _this.handleGetTripBoards.bind(_this);
        _this.handleRemoveFromTripBoard = _this.handleRemoveFromTripBoard.bind(_this);
        return _this;
    }

    _createClass(TripBoardButtonDataProvider, [{
        key: 'getStay',
        value: function getStay() {
            var adultCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
            var childrenCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var petsIncluded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var startDate = arguments[3];
            var endDate = arguments[4];

            var stay = { adultCount: adultCount, childrenCount: childrenCount, petsIncluded: petsIncluded };

            if (startDate && endDate) {
                stay = stay ? stay : {};
                stay.dateRange = { arrival: startDate, departure: endDate };
            }
            return stay;
        }
    }, {
        key: 'handleCreateTripBoard',
        value: function handleCreateTripBoard(_ref) {
            var listings = _ref.listings,
                name = _ref.name,
                startDate = _ref.startDate,
                endDate = _ref.endDate,
                adultsCount = _ref.adultsCount,
                petIncluded = _ref.petIncluded,
                childrenCount = _ref.childrenCount,
                thumbnailUrl = _ref.thumbnailUrl;
            var _props = this.props,
                createTripBoard = _props.createTripBoard,
                hav = _props.hav,
                pageSize = _props.pageSize,
                listingPageSize = _props.listingPageSize;

            var listingRefs = listings.reduce(function (listingIds, _ref2) {
                var listingId = _ref2.listingId;
                return [].concat(_toConsumableArray(listingIds), [listingId]);
            }, []);

            var stay = this.getStay(adultsCount, childrenCount, petIncluded, startDate, endDate);
            var tripBoard = { name: name, listings: listings };

            var _ref3 = stay || {},
                dateRange = _ref3.dateRange,
                guestContext = _objectWithoutProperties(_ref3, ['dateRange']);

            if (dateRange) {
                tripBoard = _extends({}, tripBoard, { startDate: startDate, endDate: endDate });
            }
            tripBoard = _extends({}, tripBoard, guestContext);

            var mutationVariables = {
                hav: hav,
                tripBoard: tripBoard
            };
            createTripBoard({
                variables: mutationVariables,
                update: (0, _withCreateNewTripBoard.addTripBoardToCache)(hav, pageSize, listingPageSize),
                optimisticResponse: (0, _withCreateNewTripBoard.optimisticNewTripBoardResponse)(name, listingRefs, stay, thumbnailUrl)
            });
        }
    }, {
        key: 'handleAddToTripBoard',
        value: function handleAddToTripBoard(_ref4) {
            var listingId = _ref4.listingId,
                boardId = _ref4.boardId,
                adultsCount = _ref4.adultsCount,
                childrenCount = _ref4.childrenCount,
                petIncluded = _ref4.petIncluded,
                startDate = _ref4.startDate,
                endDate = _ref4.endDate,
                thumbnailUrl = _ref4.thumbnailUrl;
            var _props2 = this.props,
                addToTripBoard = _props2.addToTripBoard,
                updateStayOnTripBoard = _props2.updateStayOnTripBoard,
                hav = _props2.hav,
                pageSize = _props2.pageSize,
                listingPageSize = _props2.listingPageSize;

            addToTripBoard({
                variables: {
                    hav: hav,
                    tripBoardUuid: boardId,
                    unitTriad: listingId
                },
                onError: (0, _withAddToTripBoard.handleOnMutationError)(listingId, boardId),
                update: (0, _withAddToTripBoard.addListingToCache)(hav, pageSize, listingPageSize, listingId, boardId, thumbnailUrl)
            });

            var stay = this.getStay(adultsCount, childrenCount, petIncluded, startDate, endDate);

            if (stay) {
                updateStayOnTripBoard({
                    variables: {
                        hav: hav,
                        tripBoardUuid: boardId,
                        stay: stay
                    }
                });
            }
        }
    }, {
        key: 'handleGetTripBoards',
        value: function handleGetTripBoards() {
            var tripboardData = this.props.tripboardData;

            var refetch = tripboardData && tripboardData.refetch;
            if (refetch) {
                refetch();
            }
        }
    }, {
        key: 'handleRemoveFromTripBoard',
        value: function handleRemoveFromTripBoard(_ref5) {
            var listingId = _ref5.listingId;
            var _props3 = this.props,
                hav = _props3.hav,
                removeFromTripBoards = _props3.removeFromTripBoards,
                pageSize = _props3.pageSize,
                listingPageSize = _props3.listingPageSize;

            removeFromTripBoards({
                variables: {
                    hav: hav,
                    unitTriad: listingId
                },
                update: (0, _withRemoveFromTripBoards.removeListingFromCache)(listingId, hav, pageSize, listingPageSize)
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                tripboardData = _props4.tripboardData,
                createTripBoard = _props4.createTripBoard,
                addToTripBoard = _props4.addToTripBoard,
                updateStayOnTripBoard = _props4.updateStayOnTripBoard,
                removeFromTripBoards = _props4.removeFromTripBoards,
                pageSize = _props4.pageSize,
                listingPageSize = _props4.listingPageSize,
                childProps = _objectWithoutProperties(_props4, ['tripboardData', 'createTripBoard', 'addToTripBoard', 'updateStayOnTripBoard', 'removeFromTripBoards', 'pageSize', 'listingPageSize']);

            var _ref6 = tripboardData || {},
                paginatedTripBoards = _ref6.paginatedTripBoards,
                loading = _ref6.loading;

            var transformedData = (0, _graphql.transformTripboardData)(paginatedTripBoards);
            return _react2.default.createElement(_TripBoardButton2.default, _extends({
                loading: loading,
                addToBoard: this.handleAddToTripBoard,
                createBoard: this.handleCreateTripBoard,
                removeFromBoard: this.handleRemoveFromTripBoard,
                getTripboards: this.handleGetTripBoards,
                tripboards: transformedData
            }, childProps));
        }
    }]);

    return TripBoardButtonDataProvider;
}(_react.Component);

TripBoardButtonDataProvider.propTypes = {
    hav: _propTypes2.default.string.isRequired,
    pageSize: _propTypes2.default.number,
    listingPageSize: _propTypes2.default.number,
    fetchTripboardsQueryConfig: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};
TripBoardButtonDataProvider.defaultProps = {
    pageSize: _withFetchPreviews.defaultVariables.pageSize,
    listingPageSize: _withFetchPreviews.defaultVariables.listingPageSize
};
exports.default = (0, _redux.compose)(_withHav2.default, _withFetchPreviews2.default, _withCreateNewTripBoard2.default, _withAddToTripBoard2.default, _withUpdateStayOnTripBoard2.default, _withRemoveFromTripBoards2.default)(TripBoardButtonDataProvider);
//# sourceMappingURL=trip-board-data-provider.js.map

/***/ }),

/***/ "UzhU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Arrow = __webpack_require__("qWiE");

var _Arrow2 = _interopRequireDefault(_Arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ArrowPrevious(props) {
    var _props$arrowBackgroun = props.arrowBackgroundColor,
        red = _props$arrowBackgroun.red,
        green = _props$arrowBackgroun.green,
        blue = _props$arrowBackgroun.blue;


    var style = {
        background: 'linear-gradient(to right, rgba(' + red + ', ' + green + ', ' + blue + ', 1) 0%, rgba(' + red + ', ' + green + ', ' + blue + ', 1) 50%, rgba(' + red + ', ' + green + ', ' + blue + ', 0) 100%)'
    };

    return _react2.default.createElement(
        _Arrow2.default,
        _extends({}, props, {
            className: 'horizontal-scroll-button-left',
            style: style,
            tabIndex: 0,
            viewBox: '0 0 48 48'
        }),
        _react2.default.createElement('polygon', { points: '30.59 8 32 9.41 18.83 24 32 38.59 30.59 40 16 24 30.59 8' })
    );
}

ArrowPrevious.propTypes = {
    arrowBackgroundColor: _propTypes2.default.shape({
        red: _propTypes2.default.number,
        green: _propTypes2.default.number,
        blue: _propTypes2.default.number
    })
};

exports.default = ArrowPrevious;
//# sourceMappingURL=ArrowPrevious.js.map

/***/ }),

/***/ "VD8v":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("x//u");
var toObject = __webpack_require__("wXdB");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "VORN":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "Vs5E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2iw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StarRating = __webpack_require__("XWbl");

var _StarRating2 = _interopRequireDefault(_StarRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all your work in component and subcomponent files.
**/

exports.default = _StarRating2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "W6Rd":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "WAVn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateUtils = __webpack_require__("SCsJ");

var _dateUtils2 = _interopRequireDefault(_dateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var date = new Date();

var todayObj = {
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear()
};

function getToday() {
    return todayObj;
}

function getTodaysMonthString() {
    return todayObj.year + ' ' + (todayObj.month + 1);
}

function isToday(day, today) {
    if (!today) {
        today = getToday();
    }

    if (day) {
        return day.year === today.year && day.month === today.month && day.day === today.day;
    }

    return false;
}

function isPast(day, today) {
    if (!today) {
        today = getToday();
    }

    if (day) {
        return _dateUtils2.default.compareDateStrings(_dateUtils2.default.getDayToString(day), _dateUtils2.default.getDayToString(today)) > 0;
    }

    return false;
}

exports.default = { getToday: getToday, getTodaysMonthString: getTodaysMonthString, isToday: isToday, isPast: isPast };
//# sourceMappingURL=today.js.map

/***/ }),

/***/ "WB1p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WHce":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("037f"),
    shortOut = __webpack_require__("Zk5a");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "WUh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wdy1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var ctx = __webpack_require__("3fMt");
var hide = __webpack_require__("aLzV");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "WhHO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__("Fy0/");

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__("zFiE");

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__("Io3e");

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__("w1c7");

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),

/***/ "WpB1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X/Bi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTooltip = __webpack_require__("j6PF");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactModal = __webpack_require__("XSjK");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactButtons = __webpack_require__("HfJ9");

var _reactNavCalendarMonth = __webpack_require__("oA90");

var _reactNavCalendarMonth2 = _interopRequireDefault(_reactNavCalendarMonth);

var _propTypeDateString = __webpack_require__("NTt2");

var _propTypeDateString2 = _interopRequireDefault(_propTypeDateString);

__webpack_require__("Libf");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var checkElementType = function checkElementType(props, propName, componentName) {
    var instance = "object" !== 'undefined' && window.Element ? window.Element : Object;
    if (props[propName] && !(props[propName] instanceof instance)) {
        return new Error('Invalid prop \'' + propName + '\' supplied to \'' + componentName + '\'. Validation failed.');
    }
    return null;
};

var Base = function (_Component) {
    _inherits(Base, _Component);

    function Base() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Base);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function () {
            _this.props.onClose();
            _this.props.onCancel();
        }, _this.handleOnContinue = function () {
            _this.props.onClose();
            _this.props.onSubmit();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Base, [{
        key: 'disableClearButton',
        value: function disableClearButton(startDate, endDate, date) {
            return !startDate && !endDate && !date;
        }
    }, {
        key: 'renderClearButton',
        value: function renderClearButton(buttonClasses, disabled, onClick, label) {
            return _react2.default.createElement(_reactButtons.ButtonLink, { type: 'button', className: buttonClasses, disabled: disabled, onClick: onClick, label: label });
        }
    }, {
        key: 'renderAlertTemplateComponent',
        value: function renderAlertTemplateComponent() {
            var _props = this.props,
                alertTemplateComponent = _props.alertTemplateComponent,
                alertTemplateData = _props.alertTemplateData;

            var AlertTemplateComponent = alertTemplateComponent;

            if (alertTemplateComponent) {
                return _react2.default.createElement(
                    'div',
                    { className: 'picker__alert' },
                    _react2.default.createElement(AlertTemplateComponent, { data: alertTemplateData })
                );
            }

            return null;
        }
    }, {
        key: 'renderCalendar',
        value: function renderCalendar(props) {
            if (props.isDelayed) {
                return false;
            }

            var selectionType = props.selectionType,
                month = props.month,
                year = props.year,
                minDate = props.minDate,
                maxDate = props.maxDate,
                numMonthsToDisplay = props.numMonthsToDisplay,
                date = props.date,
                startDate = props.startDate,
                endDate = props.endDate,
                selectionChangeMode = props.selectionChangeMode,
                onSelectionChanged = props.onSelectionChanged,
                isMobile = props.isMobile,
                className = props.className,
                clearButtonLabel = props.clearButtonLabel,
                continueButtonLabel = props.continueButtonLabel,
                locale = props.locale,
                alertTemplateComponent = props.alertTemplateComponent,
                alertTemplateData = props.alertTemplateData,
                calendarLabels = props.calendarLabels,
                showContinueButton = props.showContinueButton,
                rest = _objectWithoutProperties(props, ['selectionType', 'month', 'year', 'minDate', 'maxDate', 'numMonthsToDisplay', 'date', 'startDate', 'endDate', 'selectionChangeMode', 'onSelectionChanged', 'isMobile', 'className', 'clearButtonLabel', 'continueButtonLabel', 'locale', 'alertTemplateComponent', 'alertTemplateData', 'calendarLabels', 'showContinueButton']); // eslint-disable-line

            var showContinue = showContinueButton && isMobile;
            var clearButtonClasses = (0, _classnames2.default)('picker__clear', { mobile: isMobile });
            var showAlert = alertTemplateComponent ? true : false;
            var disableClearButton = this.disableClearButton(startDate, endDate, date);

            return _react2.default.createElement(
                'div',
                { ref: props.calendarRefFunc },
                _react2.default.createElement(_reactNavCalendarMonth2.default, _extends({
                    className: 'picker__calendar ' + selectionType,
                    month: month,
                    year: year,
                    minDate: minDate,
                    maxDate: maxDate,
                    numMonthsToDisplay: numMonthsToDisplay,
                    selectable: true,
                    selectionType: selectionType,
                    selectedDate: date,
                    selectionStart: startDate,
                    selectionEnd: endDate,
                    selectionChangeMode: selectionChangeMode,
                    onSelectionChanged: onSelectionChanged,
                    mobileBehavior: 'scrolling',
                    scrollToMonth: isMobile,
                    locale: locale,
                    labels: calendarLabels
                }, rest)),
                showContinue && _react2.default.createElement(
                    'a',
                    { className: 'btn btn-primary btn-rounded picker__continue', onClick: this.handleOnContinue },
                    continueButtonLabel
                ),
                !isMobile && this.renderClearButton(clearButtonClasses, disableClearButton, props.onDatesCleared, clearButtonLabel),
                showAlert && this.renderAlertTemplateComponent()
            );
        }
    }, {
        key: 'renderModalTitle',
        value: function renderModalTitle() {
            var _props2 = this.props,
                clearButtonLabel = _props2.clearButtonLabel,
                onDatesCleared = _props2.onDatesCleared,
                date = _props2.date,
                endDate = _props2.endDate,
                startDate = _props2.startDate,
                isMobile = _props2.isMobile,
                modalTitle = _props2.modalTitle;

            var buttonClasses = (0, _classnames2.default)('btn', 'btn-link', 'picker__clear', { mobile: isMobile });
            var disableClearButton = this.disableClearButton(startDate, endDate, date);
            var containerClasses = (0, _classnames2.default)({ 'picker-modal-title-container': modalTitle });

            return _react2.default.createElement(
                'div',
                { className: containerClasses },
                this.renderClearButton(buttonClasses, disableClearButton, onDatesCleared, clearButtonLabel),
                modalTitle && _react2.default.createElement(
                    'div',
                    { className: 'picker-modal-title' },
                    modalTitle
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                centered = _props3.centered,
                className = _props3.className,
                closeOnOutsideClick = _props3.closeOnOutsideClick,
                inputs = _props3.inputs,
                isMobile = _props3.isMobile,
                isOpen = _props3.isOpen,
                onFocus = _props3.onFocus,
                onOpen = _props3.onOpen,
                parentNode = _props3.parentNode,
                placement = _props3.placement,
                scrollNode = _props3.scrollNode,
                fadeOutDuration = _props3.fadeOutDuration;

            // Mobile (calendar in modal)

            if (isMobile) {
                return _react2.default.createElement(
                    'div',
                    { className: className },
                    inputs,
                    _react2.default.createElement(
                        _reactModal2.default,
                        {
                            id: 'picker-modal',
                            className: 'picker__modal',
                            title: this.renderModalTitle(),
                            isOpen: isOpen,
                            onClose: this.handleOnClose,
                            onModalClose: this.props.onClose,
                            onModalOpen: onOpen,
                            isWorkflow: true
                        },
                        this.renderCalendar(this.props)
                    )
                );
            }

            // Desktop (calendar in popover)
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    _reactTooltip2.default,
                    {
                        fadeOutDuration: fadeOutDuration,
                        content: this.renderCalendar(this.props),
                        isOpen: isOpen,
                        onFocus: onFocus,
                        onClose: this.handleOnContinue,
                        onOpen: onOpen,
                        parentNode: parentNode,
                        placement: placement,
                        portalClassName: 'picker__popover',
                        scrollNode: scrollNode,
                        tooltipType: 'popover',
                        trigger: 'none',
                        wrappingMethod: 'block',
                        closeOnOutsideClick: closeOnOutsideClick,
                        centered: centered
                    },
                    inputs
                )
            );
        }
    }]);

    return Base;
}(_react.Component);

Base.propTypes = {
    alertTemplateComponent: _propTypes2.default.func,
    alertTemplateData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** Optional labels object to override default locale-driven labels on calendar */
    calendarLabels: _propTypes2.default.shape({
        monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortMonthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        dayNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortDayNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    calendarRefFunc: _propTypes2.default.func,
    centered: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    clearButtonLabel: _propTypes2.default.string,
    closeOnOutsideClick: _propTypes2.default.bool,
    continueButtonLabel: _propTypes2.default.string,
    dayData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    dayTemplateComponent: _propTypes2.default.func,
    endDate: _propTypeDateString2.default,
    inputs: _propTypes2.default.element,
    isDelayed: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    isOpen: _propTypes2.default.bool,
    /** A moniker or BCP-47 style language tag string. */
    locale: _propTypes2.default.string,
    minDate: _propTypes2.default.instanceOf(Date),
    maxDate: _propTypes2.default.instanceOf(Date),
    modalTitle: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    numMonthsToDisplay: _propTypes2.default.number,
    onDatesCleared: _propTypes2.default.func,
    onOpen: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    onSelectionChanged: _propTypes2.default.func,
    parentNode: checkElementType,
    placement: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right']),
    scrollNode: checkElementType,
    selectionChangeMode: _propTypes2.default.string,
    selectionType: _propTypes2.default.string,
    showContinueButton: _propTypes2.default.bool,
    startDate: _propTypeDateString2.default,
    year: _propTypes2.default.number,
    /** Duration of the fade transition when the tooltip closes in milliseconds */
    fadeOutDuration: _propTypes2.default.number
};
Base.defaultProps = {
    centered: true,
    className: '',
    clearButtonLabel: 'Clear dates',
    closeOnOutsideClick: true,
    continueButtonLabel: 'Continue',
    isDelayed: false,
    isMobile: true,
    isOpen: false,
    calendarLabels: {},
    locale: 'en_US',
    modalTitle: null,
    numMonthsToDisplay: 2,
    onFocus: function onFocus() {},
    onOpen: function onOpen() {},
    onClose: function onClose() {},
    onSubmit: function onSubmit() {},
    onCancel: function onCancel() {},
    placement: 'bottom',
    selectionChangeMode: 'start',
    selectionType: 'range',
    showContinueButton: false
};
Base.checkElementType = checkElementType;
exports.default = Base;
//# sourceMappingURL=Base.js.map

/***/ }),

/***/ "X0fC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _shiitake = __webpack_require__("YW+/");

var _shiitake2 = _interopRequireDefault(_shiitake);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("JRXi");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AspectRatioCardTitle = function AspectRatioCardTitle(_ref) {
    var title = _ref.title;
    return _react2.default.createElement(
        _shiitake2.default,
        { lines: 1, throttleRate: 200, className: 'AspectRatioCardTitle', tagName: 'h4' },
        title
    );
};

AspectRatioCardTitle.propTypes = {
    /** The text to display. Text will be truncated as necessary. */
    title: _propTypes2.default.string.isRequired
};

exports.default = AspectRatioCardTitle;
//# sourceMappingURL=AspectRatioCardTitle.js.map

/***/ }),

/***/ "XAeO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = translations;

var _constants = __webpack_require__("hXMO");

function translations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var type = action.type,
        payload = action.payload;

    switch (type) {
        case _constants.SET_TRIPBOARD_TRANSLATIONS:
            return payload.translations['traveler/tripboards'].messages;
        default:
            return state;
    }
}
//# sourceMappingURL=translations.js.map

/***/ }),

/***/ "XWbl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("RgpV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * StarRating
 *
 * TODO: div needs aria-label="1.4 out of 5" messaging -- need MessageFormat solution
 * TODO: determine any need for displaying roundRating value next to stars
 */

var StarRating = function (_Component) {
    _inherits(StarRating, _Component);

    function StarRating(props) {
        _classCallCheck(this, StarRating);

        var _this = _possibleConstructorReturn(this, (StarRating.__proto__ || Object.getPrototypeOf(StarRating)).call(this, props));

        _this.renderStars = function (className) {
            var height = 16;
            var width = 86;

            if (_this.props.size === 'sm') {
                height = 12;
                width = 66;
            }

            if (_this.props.size === 'lg') {
                height = 24;
                width = 130;
            }

            return _react2.default.createElement(
                'svg',
                { className: className, xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 86 16' },
                _react2.default.createElement('path', { stroke: 'none', fill: 'currentColor', d: 'M14.9 6.7l-3.4 3.4.9 4.5-.1.3h-.4L8 12.4l-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.5-3.4-.1-.3c.1-.1.1-.2.3-.2h4.5l2-5.1L8 1l.3.2 2 5.1h4.5l.3.2-.2.2zm70 0l-3.4 3.4.9 4.5-.1.3h-.4L78 12.4l-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4c-.2 0-.2-.1-.2-.3.1-.1.1-.2.3-.2h4.5l2-5.1.2-.1.3.2 2 5.1h4.5l.3.2-.2.2zm-17.5 0L64 10.1l.9 4.5-.1.3h-.4l-3.9-2.5-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4-.1-.3c.1-.1.1-.2.3-.2h4.5l2-5.1.1-.1.3.2 2 5.1h4.5l.3.2-.2.2zm-17.5 0l-3.4 3.4.9 4.5-.1.3h-.4L43 12.4l-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4c-.2 0-.2-.1-.2-.3.1-.1.1-.2.3-.2h4.5l2-5.1.2-.1.3.2 2 5.1h4.5l.3.2-.2.2zm-17.5 0L29 10.1l.9 4.5-.1.3h-.4l-3.9-2.5-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4-.1-.3c.1-.1.1-.2.3-.2h4.5l2-5.1.1-.1.3.2 2 5.1h4.5l.3.2-.2.2z' })
            );
        };

        var rating = _this.roundRating(props.rating);

        _this.state = {
            rating: rating,
            ratingClass: _this.getRatingClass(rating)
        };
        return _this;
    }

    _createClass(StarRating, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.rating !== this.props.rating) {
                var roundRating = this.roundRating(nextProps.rating);

                this.setState({
                    roundRating: roundRating,
                    ratingClass: this.getRatingClass(roundRating)
                });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.rating !== this.props.rating;
        }
    }, {
        key: 'roundRating',
        value: function roundRating(rawRating) {
            return (Math.round(rawRating * 2) / 2).toFixed(1);
        }
    }, {
        key: 'getRatingClass',
        value: function getRatingClass(roundedRating) {
            var affix = this.roundRating(roundedRating).replace('.0', '').replace('.5', '-5');

            return 'StarRating__stars StarRating__stars--' + affix;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                rating = _props.rating,
                size = _props.size,
                className = _props.className,
                rest = _objectWithoutProperties(_props, ['rating', 'size', 'className']); // eslint-disable-line no-unused-vars


            var _state = this.state,
                roundRating = _state.roundRating,
                ratingClass = _state.ratingClass;

            var ratingClasses = (0, _classnames2.default)('StarRating', _defineProperty({}, 'StarRating--' + size, size), className);
            var bottomStarClasses = (0, _classnames2.default)('StarRating__stars', _defineProperty({}, 'StarRating__stars--' + size, size));
            var topStarClasses = (0, _classnames2.default)('StarRating__stars', _defineProperty({}, 'StarRating__stars--' + size, size), ratingClass);

            return _react2.default.createElement(
                'div',
                { className: ratingClasses },
                !(roundRating === 5) && _react2.default.createElement(
                    'div',
                    { className: bottomStarClasses },
                    this.renderStars((0, _classnames2.default)('StarRating__svg'))
                ),
                !(roundRating === 0) && _react2.default.createElement(
                    'div',
                    { className: topStarClasses },
                    this.renderStars((0, _classnames2.default)('StarRating__svg', 'StarRating__svg--top'))
                )
            );
        }
    }]);

    return StarRating;
}(_react.Component);

StarRating.propTypes = {
    /** Raw Rating Number.  StarRating will round to the correct half star. */
    rating: _propTypes2.default.number.isRequired,
    /** The StarRating size variation, one of: 'lg'|'sm' */
    size: _propTypes2.default.oneOf(['lg', 'sm'])
};
exports.default = StarRating;
//# sourceMappingURL=StarRating.js.map

/***/ }),

/***/ "Xcr0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XrqK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y86b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("yFei");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TripBoardHit(_ref) {
    var thumbnails = _ref.thumbnails,
        tripBoardTitle = _ref.tripBoardTitle,
        rest = _objectWithoutProperties(_ref, ['thumbnails', 'tripBoardTitle']);

    return _react2.default.createElement(
        'div',
        _extends({}, rest, { className: 'react-trip-board-button__hit' }),
        _react2.default.createElement(
            'h6',
            { className: 'react-trip-board-button__hit-title' },
            tripBoardTitle
        ),
        _react2.default.createElement(
            'div',
            { className: 'react-trip-board-button__hit-images' },
            _react2.default.createElement('div', { className: 'react-trip-board-button__hit-image-1', style: { backgroundImage: thumbnails[0] ? 'url(' + thumbnails[0] + ')' : 'none' } }),
            _react2.default.createElement('div', { className: 'react-trip-board-button__hit-image-2', style: { backgroundImage: thumbnails[1] ? 'url(' + thumbnails[1] + ')' : 'none' } }),
            _react2.default.createElement('div', { className: 'react-trip-board-button__hit-image-3', style: { backgroundImage: thumbnails[2] ? 'url(' + thumbnails[2] + ')' : 'none' } }),
            _react2.default.createElement('div', { className: 'react-trip-board-button__hit-image-4', style: { backgroundImage: thumbnails[3] ? 'url(' + thumbnails[3] + ')' : 'none' } })
        )
    );
}

TripBoardHit.propTypes = {
    thumbnails: _propTypes2.default.arrayOf(_propTypes2.default.string),
    tripBoardTitle: _propTypes2.default.string
};

TripBoardHit.defaultProps = {
    thumbnails: [],
    tripBoardTitle: ''
};

exports.default = TripBoardHit;
//# sourceMappingURL=TripBoardHit.js.map

/***/ }),

/***/ "YTz9":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "YUK5":
/***/ (function(module, exports) {

/**
 * @name InfoBox
 * @version 1.1.13 [March 19, 2014]
 * @author Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
 * @copyright Copyright 2010 Gary Little [gary at luxcentral.com]
 * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
 *  <p>
 *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
 *  additional properties for advanced styling. An InfoBox can also be used as a map label.
 *  <p>
 *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
 */

/*!
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*jslint browser:true */
/*global google */

/**
 * @name InfoBoxOptions
 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
 * @property {boolean} [disableAutoPan=false] Disable auto-pan on <tt>open</tt>.
 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
 *  to the map pixel corresponding to <tt>position</tt>.
 * @property {LatLng} position The geographic location at which to display the InfoBox.
 * @property {number} zIndex The CSS z-index style value for the InfoBox.
 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
 * @property {string} [boxClass="infoBox"] The name of the CSS class defining the styles for the InfoBox container.
 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
 *  style values to be applied to the InfoBox. Style values defined here override those that may
 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
 *  are removed from the InfoBox before the new style values are applied.
 * @property {string} closeBoxMargin The CSS margin style value for the close box.
 *  The default is "2px" (a 2-pixel margin on all sides).
 * @property {string} closeBoxURL The URL of the image representing the close box.
 *  Note: The default is the URL for Google's standard close box.
 *  Set this property to "" if no close box is required.
 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
 *  map edge after an auto-pan.
 * @property {boolean} [isHidden=false] Hide the InfoBox on <tt>open</tt>.
 *  [Deprecated in favor of the <tt>visible</tt> property.]
 * @property {boolean} [visible=true] Show the InfoBox on <tt>open</tt>.
 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
 * @property {boolean} enableEventPropagation Propagate mousedown, mousemove, mouseover, mouseout,
 *  mouseup, click, dblclick, touchstart, touchend, touchmove, and contextmenu events in the InfoBox
 *  (default is <tt>false</tt> to mimic the behavior of a <tt>google.maps.InfoWindow</tt>). Set
 *  this property to <tt>true</tt> if the InfoBox is being used as a map label.
 */

/**
 * Creates an InfoBox with the options specified in {@link InfoBoxOptions}.
 *  Call <tt>InfoBox.open</tt> to add the box to the map.
 * @constructor
 * @param {InfoBoxOptions} [opt_opts]
 */
function InfoBox(opt_opts) {

  opt_opts = opt_opts || {};

  google.maps.OverlayView.apply(this, arguments);

  // Standard options (in common with google.maps.InfoWindow):
  //
  this.content_ = opt_opts.content || "";
  this.disableAutoPan_ = opt_opts.disableAutoPan || false;
  this.maxWidth_ = opt_opts.maxWidth || 0;
  this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
  this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
  this.zIndex_ = opt_opts.zIndex || null;

  // Additional options (unique to InfoBox):
  //
  this.boxClass_ = opt_opts.boxClass || "infoBox";
  this.boxStyle_ = opt_opts.boxStyle || {};
  this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
  this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
  if (opt_opts.closeBoxURL === "") {
    this.closeBoxURL_ = "";
  }
  this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);

  if (typeof opt_opts.visible === "undefined") {
    if (typeof opt_opts.isHidden === "undefined") {
      opt_opts.visible = true;
    } else {
      opt_opts.visible = !opt_opts.isHidden;
    }
  }
  this.isHidden_ = !opt_opts.visible;

  this.alignBottom_ = opt_opts.alignBottom || false;
  this.pane_ = opt_opts.pane || "floatPane";
  this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;

  this.div_ = null;
  this.closeListener_ = null;
  this.moveListener_ = null;
  this.mapListener_ = null;
  this.contextListener_ = null;
  this.eventListeners_ = null;
  this.fixedWidthSet_ = null;
}

/* InfoBox extends OverlayView in the Google Maps API v3.
 */
InfoBox.prototype = new google.maps.OverlayView();

/**
 * Creates the DIV representing the InfoBox.
 * @private
 */
InfoBox.prototype.createInfoBoxDiv_ = function () {

  var i;
  var events;
  var bw;
  var me = this;

  // This handler prevents an event in the InfoBox from being passed on to the map.
  //
  var cancelHandler = function (e) {
    e.cancelBubble = true;
    if (e.stopPropagation) {
      e.stopPropagation();
    }
  };

  // This handler ignores the current event in the InfoBox and conditionally prevents
  // the event from being passed on to the map. It is used for the contextmenu event.
  //
  var ignoreHandler = function (e) {

    e.returnValue = false;

    if (e.preventDefault) {

      e.preventDefault();
    }

    if (!me.enableEventPropagation_) {

      cancelHandler(e);
    }
  };

  if (!this.div_) {

    this.div_ = document.createElement("div");

    this.setBoxStyle_();

    if (typeof this.content_.nodeType === "undefined") {
      this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
    } else {
      this.div_.innerHTML = this.getCloseBoxImg_();
      this.div_.appendChild(this.content_);
    }

    // Add the InfoBox DIV to the DOM
    this.getPanes()[this.pane_].appendChild(this.div_);

    this.addClickHandler_();

    if (this.div_.style.width) {

      this.fixedWidthSet_ = true;

    } else {

      if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {

        this.div_.style.width = this.maxWidth_;
        this.fixedWidthSet_ = true;

      } else { // The following code is needed to overcome problems with MSIE

        bw = this.getBoxWidths_();

        this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
        this.fixedWidthSet_ = false;
      }
    }

    this.panBox_(this.disableAutoPan_);

    if (!this.enableEventPropagation_) {

      this.eventListeners_ = [];

      // Cancel event propagation.
      //
      // Note: mousemove not included (to resolve Issue 152)
      events = ["mousedown", "mouseover", "mouseout", "mouseup",
      "click", "dblclick", "touchstart", "touchend", "touchmove"];

      for (i = 0; i < events.length; i++) {

        this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], cancelHandler));
      }

      // Workaround for Google bug that causes the cursor to change to a pointer
      // when the mouse moves over a marker underneath InfoBox.
      this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function (e) {
        this.style.cursor = "default";
      }));
    }

    this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);

    /**
     * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
     * @name InfoBox#domready
     * @event
     */
    google.maps.event.trigger(this, "domready");
  }
};

/**
 * Returns the HTML <IMG> tag for the close box.
 * @private
 */
InfoBox.prototype.getCloseBoxImg_ = function () {

  var img = "";

  if (this.closeBoxURL_ !== "") {

    img  = "<img";
    img += " src='" + this.closeBoxURL_ + "'";
    img += " align=right"; // Do this because Opera chokes on style='float: right;'
    img += " style='";
    img += " position: relative;"; // Required by MSIE
    img += " cursor: pointer;";
    img += " margin: " + this.closeBoxMargin_ + ";";
    img += "'>";
  }

  return img;
};

/**
 * Adds the click handler to the InfoBox close box.
 * @private
 */
InfoBox.prototype.addClickHandler_ = function () {

  var closeBox;

  if (this.closeBoxURL_ !== "") {

    closeBox = this.div_.firstChild;
    this.closeListener_ = google.maps.event.addDomListener(closeBox, "click", this.getCloseClickHandler_());

  } else {

    this.closeListener_ = null;
  }
};

/**
 * Returns the function to call when the user clicks the close box of an InfoBox.
 * @private
 */
InfoBox.prototype.getCloseClickHandler_ = function () {

  var me = this;

  return function (e) {

    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    e.cancelBubble = true;

    if (e.stopPropagation) {

      e.stopPropagation();
    }

    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */
    google.maps.event.trigger(me, "closeclick");

    me.close();
  };
};

/**
 * Pans the map so that the InfoBox appears entirely within the map's visible area.
 * @private
 */
InfoBox.prototype.panBox_ = function (disablePan) {

  var map;
  var bounds;
  var xOffset = 0, yOffset = 0;

  if (!disablePan) {

    map = this.getMap();

    if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama

      if (!map.getBounds().contains(this.position_)) {
      // Marker not in visible area of map, so set center
      // of map to the marker position first.
        map.setCenter(this.position_);
      }

      bounds = map.getBounds();

      var mapDiv = map.getDiv();
      var mapWidth = mapDiv.offsetWidth;
      var mapHeight = mapDiv.offsetHeight;
      var iwOffsetX = this.pixelOffset_.width;
      var iwOffsetY = this.pixelOffset_.height;
      var iwWidth = this.div_.offsetWidth;
      var iwHeight = this.div_.offsetHeight;
      var padX = this.infoBoxClearance_.width;
      var padY = this.infoBoxClearance_.height;
      var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);

      if (pixPosition.x < (-iwOffsetX + padX)) {
        xOffset = pixPosition.x + iwOffsetX - padX;
      } else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
        xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
      }
      if (this.alignBottom_) {
        if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
          yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
        } else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
          yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
        }
      } else {
        if (pixPosition.y < (-iwOffsetY + padY)) {
          yOffset = pixPosition.y + iwOffsetY - padY;
        } else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
          yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
        }
      }

      if (!(xOffset === 0 && yOffset === 0)) {

        // Move the map to the shifted center.
        //
        var c = map.getCenter();
        map.panBy(xOffset, yOffset);
      }
    }
  }
};

/**
 * Sets the style of the InfoBox by setting the style sheet and applying
 * other specific styles requested.
 * @private
 */
InfoBox.prototype.setBoxStyle_ = function () {

  var i, boxStyle;

  if (this.div_) {

    // Apply style values from the style sheet defined in the boxClass parameter:
    this.div_.className = this.boxClass_;

    // Clear existing inline style values:
    this.div_.style.cssText = "";

    // Apply style values defined in the boxStyle parameter:
    boxStyle = this.boxStyle_;
    for (i in boxStyle) {

      if (boxStyle.hasOwnProperty(i)) {

        this.div_.style[i] = boxStyle[i];
      }
    }

    // Fix for iOS disappearing InfoBox problem.
    // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
    this.div_.style.WebkitTransform = "translateZ(0)";

    // Fix up opacity style for benefit of MSIE:
    //
    if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
      // See http://www.quirksmode.org/css/opacity.html
      this.div_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(Opacity=" + (this.div_.style.opacity * 100) + ")\"";
      this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
    }

    // Apply required styles:
    //
    this.div_.style.position = "absolute";
    this.div_.style.visibility = 'hidden';
    if (this.zIndex_ !== null) {

      this.div_.style.zIndex = this.zIndex_;
    }
    if (!this.div_.style.overflow) {
      this.div_.style.overflow = "auto";
    }
  }
};

/**
 * Get the widths of the borders of the InfoBox.
 * @private
 * @return {Object} widths object (top, bottom left, right)
 */
InfoBox.prototype.getBoxWidths_ = function () {

  var computedStyle;
  var bw = {top: 0, bottom: 0, left: 0, right: 0};
  var box = this.div_;

  if (document.defaultView && document.defaultView.getComputedStyle) {

    computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");

    if (computedStyle) {

      // The computed styles are always in pixel units (good!)
      bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
      bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
      bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
      bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
    }

  } else if (document.documentElement.currentStyle) { // MSIE

    if (box.currentStyle) {

      // The current styles may not be in pixel units, but assume they are (bad!)
      bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
      bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
      bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
      bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
    }
  }

  return bw;
};

/**
 * Invoked when <tt>close</tt> is called. Do not call it directly.
 */
InfoBox.prototype.onRemove = function () {

  if (this.div_) {

    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};

/**
 * Draws the InfoBox based on the current map projection and zoom level.
 */
InfoBox.prototype.draw = function () {

  this.createInfoBoxDiv_();

  var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);

  this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";

  if (this.alignBottom_) {
    this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
  } else {
    this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
  }

  if (this.isHidden_) {

    this.div_.style.visibility = "hidden";

  } else {

    this.div_.style.visibility = "visible";
  }
};

/**
 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
 *  is <tt>open</tt>ed.
 * @param {InfoBoxOptions} opt_opts
 */
InfoBox.prototype.setOptions = function (opt_opts) {
  if (typeof opt_opts.boxClass !== "undefined") { // Must be first

    this.boxClass_ = opt_opts.boxClass;
    this.setBoxStyle_();
  }
  if (typeof opt_opts.boxStyle !== "undefined") { // Must be second

    this.boxStyle_ = opt_opts.boxStyle;
    this.setBoxStyle_();
  }
  if (typeof opt_opts.content !== "undefined") {

    this.setContent(opt_opts.content);
  }
  if (typeof opt_opts.disableAutoPan !== "undefined") {

    this.disableAutoPan_ = opt_opts.disableAutoPan;
  }
  if (typeof opt_opts.maxWidth !== "undefined") {

    this.maxWidth_ = opt_opts.maxWidth;
  }
  if (typeof opt_opts.pixelOffset !== "undefined") {

    this.pixelOffset_ = opt_opts.pixelOffset;
  }
  if (typeof opt_opts.alignBottom !== "undefined") {

    this.alignBottom_ = opt_opts.alignBottom;
  }
  if (typeof opt_opts.position !== "undefined") {

    this.setPosition(opt_opts.position);
  }
  if (typeof opt_opts.zIndex !== "undefined") {

    this.setZIndex(opt_opts.zIndex);
  }
  if (typeof opt_opts.closeBoxMargin !== "undefined") {

    this.closeBoxMargin_ = opt_opts.closeBoxMargin;
  }
  if (typeof opt_opts.closeBoxURL !== "undefined") {

    this.closeBoxURL_ = opt_opts.closeBoxURL;
  }
  if (typeof opt_opts.infoBoxClearance !== "undefined") {

    this.infoBoxClearance_ = opt_opts.infoBoxClearance;
  }
  if (typeof opt_opts.isHidden !== "undefined") {

    this.isHidden_ = opt_opts.isHidden;
  }
  if (typeof opt_opts.visible !== "undefined") {

    this.isHidden_ = !opt_opts.visible;
  }
  if (typeof opt_opts.enableEventPropagation !== "undefined") {

    this.enableEventPropagation_ = opt_opts.enableEventPropagation;
  }

  if (this.div_) {

    this.draw();
  }
};

/**
 * Sets the content of the InfoBox.
 *  The content can be plain text or an HTML DOM node.
 * @param {string|Node} content
 */
InfoBox.prototype.setContent = function (content) {
  this.content_ = content;

  if (this.div_) {

    if (this.closeListener_) {

      google.maps.event.removeListener(this.closeListener_);
      this.closeListener_ = null;
    }

    // Odd code required to make things work with MSIE.
    //
    if (!this.fixedWidthSet_) {

      this.div_.style.width = "";
    }

    if (typeof content.nodeType === "undefined") {
      this.div_.innerHTML = this.getCloseBoxImg_() + content;
    } else {
      this.div_.innerHTML = this.getCloseBoxImg_();
      this.div_.appendChild(content);
    }

    // Perverse code required to make things work with MSIE.
    // (Ensures the close box does, in fact, float to the right.)
    //
    if (!this.fixedWidthSet_) {
      this.div_.style.width = this.div_.offsetWidth + "px";
      if (typeof content.nodeType === "undefined") {
        this.div_.innerHTML = this.getCloseBoxImg_() + content;
      } else {
        this.div_.innerHTML = this.getCloseBoxImg_();
        this.div_.appendChild(content);
      }
    }

    this.addClickHandler_();
  }

  /**
   * This event is fired when the content of the InfoBox changes.
   * @name InfoBox#content_changed
   * @event
   */
  google.maps.event.trigger(this, "content_changed");
};

/**
 * Sets the geographic location of the InfoBox.
 * @param {LatLng} latlng
 */
InfoBox.prototype.setPosition = function (latlng) {

  this.position_ = latlng;

  if (this.div_) {

    this.draw();
  }

  /**
   * This event is fired when the position of the InfoBox changes.
   * @name InfoBox#position_changed
   * @event
   */
  google.maps.event.trigger(this, "position_changed");
};

/**
 * Sets the zIndex style for the InfoBox.
 * @param {number} index
 */
InfoBox.prototype.setZIndex = function (index) {

  this.zIndex_ = index;

  if (this.div_) {

    this.div_.style.zIndex = index;
  }

  /**
   * This event is fired when the zIndex of the InfoBox changes.
   * @name InfoBox#zindex_changed
   * @event
   */
  google.maps.event.trigger(this, "zindex_changed");
};

/**
 * Sets the visibility of the InfoBox.
 * @param {boolean} isVisible
 */
InfoBox.prototype.setVisible = function (isVisible) {

  this.isHidden_ = !isVisible;
  if (this.div_) {
    this.div_.style.visibility = (this.isHidden_ ? "hidden" : "visible");
  }
};

/**
 * Returns the content of the InfoBox.
 * @returns {string | Node}
 */
InfoBox.prototype.getContent = function () {

  return this.content_;
};

/**
 * Returns the geographic location of the InfoBox.
 * @returns {LatLng}
 */
InfoBox.prototype.getPosition = function () {

  return this.position_;
};

/**
 * Returns the zIndex for the InfoBox.
 * @returns {number}
 */
InfoBox.prototype.getZIndex = function () {

  return this.zIndex_;
};

/**
 * Returns a flag indicating whether the InfoBox is visible.
 * @returns {boolean}
 */
InfoBox.prototype.getVisible = function () {

  var isVisible;

  if ((typeof this.getMap() === "undefined") || (this.getMap() === null)) {
    isVisible = false;
  } else {
    isVisible = !this.isHidden_;
  }
  return isVisible;
};

/**
 * Shows the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
 */
InfoBox.prototype.show = function () {

  this.isHidden_ = false;
  if (this.div_) {
    this.div_.style.visibility = "visible";
  }
};

/**
 * Hides the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
 */
InfoBox.prototype.hide = function () {

  this.isHidden_ = true;
  if (this.div_) {
    this.div_.style.visibility = "hidden";
  }
};

/**
 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
 *  anchor is dragged to a new location, the InfoBox moves as well.
 * @param {Map|StreetViewPanorama} map
 * @param {MVCObject} [anchor]
 */
InfoBox.prototype.open = function (map, anchor) {

  var me = this;

  if (anchor) {

    this.position_ = anchor.getPosition();
    this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function () {
      me.setPosition(this.getPosition());
    });

    this.mapListener_ = google.maps.event.addListener(anchor, "map_changed", function() {
      me.setMap(this.map);
    });
  }

  this.setMap(map);

  if (this.div_) {

    this.panBox_();
  }
};

/**
 * Removes the InfoBox from the map.
 */
InfoBox.prototype.close = function () {

  var i;

  if (this.closeListener_) {

    google.maps.event.removeListener(this.closeListener_);
    this.closeListener_ = null;
  }

  if (this.eventListeners_) {

    for (i = 0; i < this.eventListeners_.length; i++) {

      google.maps.event.removeListener(this.eventListeners_[i]);
    }
    this.eventListeners_ = null;
  }

  if (this.moveListener_) {

    google.maps.event.removeListener(this.moveListener_);
    this.moveListener_ = null;
  }

  if (this.mapListener_) {

    google.maps.event.removeListener(this.mapListener_);
    this.mapListener_ = null;
  }

  if (this.contextListener_) {

    google.maps.event.removeListener(this.contextListener_);
    this.contextListener_ = null;
  }

  this.setMap(null);
};


module.exports = { default: InfoBox, InfoBox: InfoBox }; 

/***/ }),

/***/ "YW+/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResizeListener = __webpack_require__("wVRO");

var _ResizeListener2 = _interopRequireDefault(_ResizeListener);

var _constants = __webpack_require__("GAvn");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class Shiitake
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description React line clamp that won't get you fired
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Shiitake = function (_React$Component) {
  _inherits(Shiitake, _React$Component);

  function Shiitake(props) {
    _classCallCheck(this, Shiitake);

    var _this = _possibleConstructorReturn(this, (Shiitake.__proto__ || Object.getPrototypeOf(Shiitake)).call(this, props));

    var allChildren = typeof props.children === 'string' ? props.children : '';
    var children = props.renderFullOnServer ? allChildren : '';

    _this.state = {
      lastCalculatedWidth: -1,
      testChildren: '',
      children: children,
      allChildren: allChildren
    };

    _this.handleResize = _this.handleResize.bind(_this);
    return _this;
  }

  _createClass(Shiitake, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleResize();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      var children = newProps.children,
          lines = newProps.lines;

      // if we've got different children, reset and retest

      if (children !== this.state.allChildren) {
        var allChildren = typeof children === 'string' ? children : '';
        this.setState({ lastCalculatedWidth: -1, children: children, allChildren: allChildren });
        this._setTestChildren(0, children.length);
      } else if (lines !== this.props.lines) {
        // for a lines number change, retrim the full string
        this._callDeffered(function () {
          _this2.setState({ testChildren: '', lastCalculatedWidth: -1, children: _this2.state.allChildren });
          _this2.handleResize();
        });
      }
    }
  }, {
    key: '_callDeffered',
    value: function _callDeffered(func) {
      var _this3 = this;

      setTimeout(function () {
        if (_this3.spreader) {
          func.bind(_this3)();
        }
      }, 0);
    }
  }, {
    key: '_checkHeight',
    value: function _checkHeight(start, end) {
      var contentHeight = this.testChildren.offsetHeight;
      var halfWay = end - Math.round((end - start) / 2);

      // TODO: refine this flag, make simpler
      var linear = end - start < 6 || end === this.state.testChildren.length && end !== this.state.allChildren.length || this.state.lastCalculatedWidth > -1;

      // do we need to trim?
      if (contentHeight > this._targetHeight) {
        // chunk/ trim down
        if (linear) {
          this._setTestChildren(this.state.testChildren.length, this.state.testChildren.length - 1);
        } else {
          this._setTestChildren(start, halfWay);
        }

        // we've used all the characters in a window expand situation
      } else if (this.state.testChildren.length === this.state.allChildren.length) {
        this._setChildren();
      } else if (linear) {
        // if we just got here by decrementing one, we're good
        if (start > end) {
          this._setChildren();
        } else {
          // window grew, increment up one
          this._setTestChildren(this.state.testChildren.length, this.state.testChildren.length + 1);
        }
      } else {
        // chunk up, still in binary search mode
        this._setTestChildren(halfWay, end);
      }
    }

    // this will render test children trimmed at halfway point then come around to test height again

  }, {
    key: '_setTestChildren',
    value: function _setTestChildren(start, end) {
      // if it's within the treshold or has already been calculated, go linear
      var trimEnd = end - start < 6 || this.state.lastCalculatedWidth > -1 ? end : end - Math.round((end - start) / 2);

      this.setState({ testChildren: this.state.allChildren.substring(0, trimEnd) });
      this._callDeffered(this._checkHeight.bind(this, start, end));
    }
  }, {
    key: '_setChildren',
    value: function _setChildren() {
      var children = this.state.allChildren;

      // are we actually trimming?
      if (this.state.testChildren.length < this.state.allChildren.length) {
        children = this.state.testChildren.split(' ').slice(0, -1).join(' ');
      }
      this._handlingResize = false;
      this.setState({ children: children, lastCalculatedWidth: this.spreader.offsetWidth });
    }

    // adds the trimmed content to state and fills the sizer on resize events

  }, {
    key: 'handleResize',
    value: function handleResize() {
      // if we don't have a spreader, let it come around again
      if (!this.spreader) {
        return;
      }

      var availableWidth = this.spreader.offsetWidth;
      this._targetHeight = this.sizer.offsetHeight;

      // set the max height right away, so that the resize throttle doesn't allow line break jumps
      // also populate with the full string if we don't have a working trimmed string yet
      this.setState({ fixHeight: this._targetHeight, children: this.state.children || this.state.allChildren });

      // was there a width change, or lines change?
      if (availableWidth !== this.state.lastCalculatedWidth && !this._handlingResize) {
        this._handlingResize = true;

        // first render?
        if (this.state.testChildren === '') {
          // give it the full string and check the height
          this.setState({ testChildren: this.state.allChildren });
          this._callDeffered(this._checkHeight.bind(this, 0, this.state.allChildren.length));

          // window got smaller?
        } else if (availableWidth < this.state.lastCalculatedWidth) {
          // increment down one
          this._callDeffered(this._checkHeight.bind(this, this.state.testChildren.length, this.state.testChildren.length - 1));

          // window got larger?
        } else {
          // increment up one
          this._callDeffered(this._checkHeight.bind(this, this.state.testChildren.length, this.state.testChildren.length + 1));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          renderFullOnServer = _props.renderFullOnServer,
          className = _props.className,
          throttleRate = _props.throttleRate,
          overflowNode = _props.overflowNode;
      var _state = this.state,
          fixHeight = _state.fixHeight,
          children = _state.children,
          testChildren = _state.testChildren;

      var tagNames = { main: (0, _constants.setTag)(this.props.tagName) };

      var vertSpacers = [];
      for (var i = 0; i < this.props.lines; i++) {
        vertSpacers.push(_react2.default.createElement(
          'span',
          { style: _constants.block, key: i },
          'W'
        ));
      }

      var thisHeight = (fixHeight || 0) + 'px';
      var maxHeight = renderFullOnServer ? '' : thisHeight;

      var overflow = testChildren.length < this.state.allChildren.length ? overflowNode : null;

      return _react2.default.createElement(
        tagNames.main,
        _extends({ className: className || '' }, (0, _constants.passProps)(this.props)),
        _react2.default.createElement(_ResizeListener2.default, { handleResize: this.handleResize, throttleRate: throttleRate }),
        _react2.default.createElement(
          'span',
          { style: _extends({}, _constants.wrapperStyles, { maxHeight: maxHeight }) },
          _react2.default.createElement(
            'span',
            { style: _constants.childrenStyles },
            children,
            overflow
          ),
          _react2.default.createElement(
            'span',
            { ref: function ref(node) {
                _this4.spreader = node;
              }, style: _constants.spreaderStyles, 'aria-hidden': 'true' },
            this.state.allChildren
          ),
          _react2.default.createElement(
            'span',
            { style: _constants.sizerWrapperStyles, 'aria-hidden': 'true' },
            _react2.default.createElement(
              'span',
              { ref: function ref(node) {
                  _this4.sizer = node;
                }, style: _constants.block },
              vertSpacers
            ),
            _react2.default.createElement(
              'span',
              { ref: function ref(node) {
                  _this4.testChildren = node;
                }, style: _constants.block },
              testChildren,
              overflow
            )
          )
        )
      );
    }
  }]);

  return Shiitake;
}(_react2.default.Component);

Shiitake.propTypes = {
  lines: _propTypes2.default.number.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.string.isRequired,
  renderFullOnServer: _propTypes2.default.bool,
  throttleRate: _propTypes2.default.number,
  tagName: _propTypes2.default.string,
  overflowNode: _propTypes2.default.node
};
Shiitake.defaultProps = {
  className: '',
  renderFullOnServer: false,
  throttleRate: undefined,
  tagName: undefined,
  overflowNode: '\u2026',
  // in case someone accidentally passes something undefined in as children
  children: ''
};
exports.default = Shiitake;

/***/ }),

/***/ "YjQv":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = "object" != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "Yzt6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _Controls = __webpack_require__("rvLH");

var _Controls2 = _interopRequireDefault(_Controls);

var _reactCalendarBase = __webpack_require__("MHlU");

var _reactCalendarBase2 = _interopRequireDefault(_reactCalendarBase);

var _reactDetermineIfMobile = __webpack_require__("54yA");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _lodash = __webpack_require__("R3sX");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavCalendarMonth = function (_Component) {
    _inherits(NavCalendarMonth, _Component);

    function NavCalendarMonth(props) {
        _classCallCheck(this, NavCalendarMonth);

        var _this = _possibleConstructorReturn(this, (NavCalendarMonth.__proto__ || Object.getPrototypeOf(NavCalendarMonth)).call(this, props));

        _initialiseProps.call(_this);

        var _this$getMonthYear = _this.getMonthYear(props),
            month = _this$getMonthYear.month,
            year = _this$getMonthYear.year;

        var _this$getControlsStat = _this.getControlsState(month, year),
            canAdvance = _this$getControlsStat.canAdvance,
            canRetreat = _this$getControlsStat.canRetreat;

        // When mobile mode is "scrolling", it takes too long to render a lot of months up front.
        // Instead we are using an infinite scrolling technique. We start by rendering a single month,
        // then listen for scroll events and load additional months as we approach the end of the scroll
        // list. If there is a selection, we want to scroll to the month with the selection. In order for
        // that to work, we may need to render more than 1 month at the start. getInitialNumMonths() determines
        // how many months to load at the start.


        var loadedMonths = _this.getInitialNumMonths(month, year, props.selectedDate, props.selectionStart, props.scrollToMonth);
        var maxLoadableMonths = props.maxDate ? _this.getMaxNumMonths(month, year, props.maxDate) : null;

        _this.state = {
            month: month,
            year: year,
            controls: true,
            loadedMonths: loadedMonths,
            maxLoadableMonths: maxLoadableMonths,
            canAdvance: canAdvance,
            canRetreat: canRetreat,
            direction: null,
            column: null,
            activeMonth: null,
            refresh: false
        };

        _this.lazyLoadHandler = (0, _lodash2.default)(_this.lazyLoadHandler.bind(_this), 80);
        return _this;
    }

    _createClass(NavCalendarMonth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setupInfiniteScrolling();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // If mobileBehavior changes, set the date back to the original.
            // This prevents a bug that is likely only seen in dev, but whatevs.
            if (nextProps.mobileBehavior !== this.props.mobileBehavior) {
                var _getMonthYear = this.getMonthYear(_extends({}, this.props, nextProps)),
                    month = _getMonthYear.month,
                    year = _getMonthYear.year;

                this.setState({
                    month: month,
                    year: year
                });
            }

            // If month changes and we have a year, update state.
            if (nextProps.month !== this.props.month && (nextProps.year || this.props.year)) {
                this.setState({
                    month: nextProps.month,
                    year: nextProps.year || this.props.year
                });
            }

            // If year changes and we have a month, update state.
            if (nextProps.year !== this.props.year && (nextProps.month >= 0 || this.props.month >= 0)) {
                this.setState({
                    month: nextProps.month >= 0 ? nextProps.month : this.props.month,
                    year: nextProps.year
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _state = this.state,
                canAdvance = _state.canAdvance,
                canRetreat = _state.canRetreat;


            if (canAdvance !== prevState.canAdvance || canRetreat !== prevState.canRetreat) {
                this.props.onUpdateFocusable();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.scrollParent.removeEventListener('scroll', this.lazyLoadHandler);
        }
    }, {
        key: 'getInitialNumMonths',
        value: function getInitialNumMonths(month, year, selectedDate, selectionStart, scrollToMonth) {
            var numMonths = 2;
            var selected = selectedDate || selectionStart || '';

            if (selected && scrollToMonth) {
                var selectedMonth = selected.split('-')[1];
                var selectedYear = selected.split('-')[0];
                var selDate = new Date(selectedYear, selectedMonth, 1);
                var monthDate = new Date(year, month, 1);

                // In certain circumstances this can return a negative number.
                //  1) selection date is in the past
                //  2) consumer is hardwiring the month/year (if not, all is well)
                //  3) has to be in mobile view with mode to "scrolling"
                // It is not immediately obvious what to do in these situations, and since we
                // do not have a use case that fits the scenario above, we'll punt on it for now.
                return selDate.getMonth() - monthDate.getMonth() + 12 * (selDate.getFullYear() - monthDate.getFullYear()) + 1;
            }

            return numMonths;
        }
    }, {
        key: 'getMaxNumMonths',
        value: function getMaxNumMonths(month, year, maxDate) {
            // Get the maximum number of months to load, including start and end months
            var numMonths = void 0;
            var monthDate = new Date(year, month, 1);
            numMonths = (maxDate.getFullYear() - monthDate.getFullYear()) * 12;
            numMonths -= monthDate.getMonth();
            numMonths += maxDate.getMonth() + 1;
            return numMonths <= 0 ? 0 : numMonths;
        }
    }, {
        key: 'isWithinBounds',
        value: function isWithinBounds(month, year, boundaryDate, minOrMax) {
            // Normalize the min/max Date and current Date so we can compare the 1st of each month
            // When advancing, offset the number of months so maxDate stops in last column
            // Once the current Date tries to exceed the min/max Date, return false
            var isMin = minOrMax === 'min';
            var offset = this.props.isMobile || isMin ? 0 : this.props.numMonthsToDisplay - 1;
            var monthDate = new Date(year, month + offset, 1);
            var boundaryMonthDate = new Date(boundaryDate.getFullYear(), boundaryDate.getMonth(), 1);
            var monthDiff = isMin ? monthDate - boundaryMonthDate : boundaryMonthDate - monthDate;

            if (monthDiff <= 0) {
                return false;
            }

            return true;
        }
    }, {
        key: 'getControlsState',
        value: function getControlsState(month, year) {
            var _props = this.props,
                minDate = _props.minDate,
                maxDate = _props.maxDate;

            var canRetreat = minDate ? this.isWithinBounds(month, year, minDate, 'min') : true;
            var canAdvance = maxDate ? this.isWithinBounds(month, year, maxDate, 'max') : true;

            return { canAdvance: canAdvance, canRetreat: canRetreat };
        }

        // Initialize what is needed for infinite scrolling.

    }, {
        key: 'setupInfiniteScrolling',
        value: function setupInfiniteScrolling() {
            try {
                this.elem = (0, _reactDom.findDOMNode)(this);

                // Determine what element (or window) scrolls
                this.scrollParent = this.getScrollParent(this.elem);
                if (this.elem === this.scrollParent) {
                    this.elem = this.elem.firstChild;
                }

                // Listen for scroll events
                if (this.props.isMobile && this.props.mobileBehavior === 'scrolling') {
                    this.scrollParent.addEventListener('scroll', this.lazyLoadHandler);
                }
            } catch (e) {
                // Used to catch errors during unit testing. Should not happen
                // in browser.
            }
        }

        // Utility to get the scrolling element. We can't guarantee that the window
        // is what is scrolling. The datepickers, for example, scroll within a div.

    }, {
        key: 'getScrollParent',
        value: function getScrollParent(element) {
            var style = window.getComputedStyle(element);
            var excludeStaticParent = style.position === 'absolute';
            var overflowRegex = /(auto|scroll)/;

            if (style.position === 'fixed') {
                return window;
            }

            while (element) {
                style = window.getComputedStyle(element);
                if (excludeStaticParent && style.position === 'static') {
                    continue;
                }
                if (overflowRegex.test(style.overflow + style.overflowY)) {
                    return element;
                }
                element = element.parentElement;
            }

            return window;
        }

        // Throttled call that loads new months if we approach the end of the list

    }, {
        key: 'lazyLoadHandler',
        value: function lazyLoadHandler() {
            var _state2 = this.state,
                loadedMonths = _state2.loadedMonths,
                maxLoadableMonths = _state2.maxLoadableMonths;

            var elemBottom = this.elem.getBoundingClientRect().bottom;
            var viewPortHeight = this.scrollParent.clientHeight || this.scrollParent.innerHeight;
            var diffBuffer = viewPortHeight * 0.8;

            if (elemBottom - diffBuffer <= viewPortHeight) {
                if (loadedMonths < maxLoadableMonths || maxLoadableMonths === null) {
                    this.setState({ loadedMonths: loadedMonths + 1 });
                }
            }
        }
    }, {
        key: 'getMonthYear',
        value: function getMonthYear(props) {
            // If month and year were passed in, use those
            if ((props.month || props.month === 0) && props.year) {
                return { month: props.month, year: props.year };
            }

            // If there is a selection (range or single), use that
            var dateString = props.selectionStart || props.selectedDate;

            if (dateString) {
                var dateElems = dateString.split('-');
                return { month: +dateElems[1] - 1, year: +dateElems[0] };
            }

            // Otherwise init the calendar with today's month
            var today = new Date();
            return { month: today.getMonth(), year: today.getFullYear() };
        }
    }, {
        key: 'addMonthsToMonth',
        value: function addMonthsToMonth(year, month, num) {
            var date = new Date(year, month, '01');
            date.setMonth(date.getMonth() + num);
            return { year: date.getFullYear(), month: date.getMonth() };
        }

        // If the user is navigating the calendar days via arrow keys and not using the prev/next buttons,
        // then a callback is triggered within calendar-base to notify us when we need to move to the previous or next month.

    }, {
        key: 'getNumColumns',
        value: function getNumColumns() {
            return this.props.numColumns || this.props.numMonthsToDisplay;
        }
    }, {
        key: 'render',
        value: function render() {
            // Some of these are itemized to strip them out. ...rest is passed into calendar
            var _props2 = this.props,
                isMobile = _props2.isMobile,
                mobileBehavior = _props2.mobileBehavior,
                onNextClicked = _props2.onNextClicked,
                onPrevClicked = _props2.onPrevClicked,
                numMonthsToDisplay = _props2.numMonthsToDisplay,
                className = _props2.className,
                wdioPrefix = _props2.wdioPrefix,
                locale = _props2.locale,
                labels = _props2.labels,
                i18n = _props2.i18n,
                rest = _objectWithoutProperties(_props2, ['isMobile', 'mobileBehavior', 'onNextClicked', 'onPrevClicked', 'numMonthsToDisplay', 'className', 'wdioPrefix', 'locale', 'labels', 'i18n']); // eslint-disable-line no-unused-vars

            var numMonths = this.props.numMonthsToDisplay;
            var numColumns = this.getNumColumns();
            var hasControls = !this.props.isMobile || this.props.mobileBehavior === 'single';

            if (isMobile) {
                if (mobileBehavior === 'single') {
                    numMonths = 1;
                } else {
                    numMonths = this.state.loadedMonths;
                }
                numColumns = 1;
            }

            return _react2.default.createElement(
                _Controls2.default,
                {
                    className: className,
                    enabled: hasControls,
                    isMobile: isMobile,
                    numMonths: numMonths,
                    onPrevClicked: this.handlePrevClicked,
                    onNextClicked: this.handleNextClicked,
                    canAdvance: this.state.canAdvance,
                    canRetreat: this.state.canRetreat,
                    wdioPrefix: wdioPrefix,
                    i18n: i18n
                },
                _react2.default.createElement(_reactCalendarBase2.default, _extends({}, rest, {
                    month: this.state.month,
                    year: this.state.year,
                    numMonthsToDisplay: numMonths,
                    numColumns: numColumns,
                    padWeeks: true,
                    wdioPrefix: wdioPrefix,
                    locale: locale,
                    labels: labels,
                    onArrowNavigation: this.handleArrowNavigation,
                    direction: this.state.direction,
                    column: this.state.column,
                    activeMonth: this.state.activeMonth,
                    refresh: this.state.refresh
                }))
            );
        }
    }]);

    return NavCalendarMonth;
}(_react.Component);

NavCalendarMonth.propTypes = {
    /** Number of months to show in a desktop horizontal list. */
    numMonthsToDisplay: _propTypes2.default.number,
    /** Number of months to advance/retreat per next/previous button click. Falls back to 1 on mobile. */
    numMonthsToAdvance: _propTypes2.default.number,
    /** Number of columns to use before breaking to a new line. Defaults to numMonthsToDisplay*/
    numColumns: _propTypes2.default.number,
    /** There are two different mobile behaviors, 1) single - collapses to a single month. 2) scrolling - switches to a vertical scrolling list. Currently capped at 24 months. */
    mobileBehavior: _propTypes2.default.oneOf(['single', 'scrolling']),
    /** Default 480, Point at which mobile vs desktop views are switched. Anything below or equal to this number will result in mobile view. */
    mobileBreakpoint: _propTypes2.default.number,
    /** Force mobile view. This is useful for server-side rendering when you know if it is mobile or not. It helps prevent react's server/client mismatch warnings. */
    isMobile: _propTypes2.default.bool,
    /** Zero-based index representing the month. This is only necessary if you want to force the calendar to a specific month. By default, displays the month of any selected date or range. If nothing is selected, defaults to today's month. */
    month: _propTypes2.default.number,
    /** Number representing the year, e.g. 2016, . This is only necessary if you want to force the calendar to a specific month. By default, displays the month of any selected date or range. If nothing is selected, defaults to today's month. */
    year: _propTypes2.default.number,
    /** Minimum allowable date before which the prev button will be disabled; scrollable mode uses month and year props. */
    minDate: _propTypes2.default.instanceOf(Date),
    /** Maximum allowable date after which the next button will be disabled; scrollable mode stops loading more months. */
    maxDate: _propTypes2.default.instanceOf(Date),
    /** onNextClicked({month, year}) Triggered when the 'Next' button is clicked, passes the new month/year. */
    onNextClicked: _propTypes2.default.func,
    /** onPrevClicked({month, year}) Triggered when the 'Prev' button is clicked, passes the new month/year. */
    onPrevClicked: _propTypes2.default.func,
    /** By default, the calender elements are given a data-wdio attribute of "calendar-controls" and "calender".
    If you have more than one on a page you can add a prefix to those two strings by using this property. */
    wdioPrefix: _propTypes2.default.string,
    /** A moniker or BCP-47 style language tag string. Defaults to 'en-US'. */
    locale: _propTypes2.default.string,
    /** Optional labels object to override default locale-driven labels */
    labels: _propTypes2.default.shape({
        monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortMonthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        dayNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortDayNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    /** Object containing translations for the current locale. It is assumed that the parent app will prepare and provide the i18n object matching the shape seen here. */
    i18n: _propTypes2.default.shape({
        ariaLabelPrevButton: _propTypes2.default.string,
        ariaLabelNextButton: _propTypes2.default.string
    }),
    /** Callback to notify parent when there is an update (due to next/previous being clicked) and the focusable elements within the component need to be refreshed. */
    onUpdateFocusable: _propTypes2.default.func
};
NavCalendarMonth.defaultProps = {
    numMonthsToDisplay: 2,
    numMonthsToAdvance: 1,
    mobileBehavior: 'single',
    onNextClicked: function onNextClicked() {},
    onPrevClicked: function onPrevClicked() {},
    minDate: new Date(),
    maxDate: null,
    labels: {},
    i18n: {
        ariaLabelPrevButton: 'Previous month',
        ariaLabelNextButton: 'Next month'
    },
    onUpdateFocusable: function onUpdateFocusable() {}
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handlePrevClicked = function () {
        var _props3 = _this2.props,
            minDate = _props3.minDate,
            isMobile = _props3.isMobile,
            onPrevClicked = _props3.onPrevClicked;

        var numMonthsToAdvance = isMobile ? 1 : _this2.props.numMonthsToAdvance;

        var _addMonthsToMonth = _this2.addMonthsToMonth(_this2.state.year, _this2.state.month, -numMonthsToAdvance),
            month = _addMonthsToMonth.month,
            year = _addMonthsToMonth.year;

        var _getControlsState = _this2.getControlsState(month, year),
            canAdvance = _getControlsState.canAdvance,
            canRetreat = _getControlsState.canRetreat;

        // If target date is before min date, set date to minDate


        if (canRetreat === false) {
            month = minDate.getMonth();
            year = minDate.getFullYear();
        }

        _this2.setState({ month: month, year: year, canAdvance: canAdvance, canRetreat: canRetreat });
        onPrevClicked({ month: month, year: year });
    };

    this.handleNextClicked = function () {
        var _props4 = _this2.props,
            maxDate = _props4.maxDate,
            isMobile = _props4.isMobile,
            onNextClicked = _props4.onNextClicked;

        var offset = isMobile ? 0 : _this2.props.numMonthsToDisplay - 1;
        var numMonthsToAdvance = _this2.props.isMobile ? 1 : _this2.props.numMonthsToAdvance;

        var _addMonthsToMonth2 = _this2.addMonthsToMonth(_this2.state.year, _this2.state.month, numMonthsToAdvance),
            month = _addMonthsToMonth2.month,
            year = _addMonthsToMonth2.year;

        var _getControlsState2 = _this2.getControlsState(month, year),
            canAdvance = _getControlsState2.canAdvance,
            canRetreat = _getControlsState2.canRetreat;

        // If target date is after max date, set date to maxDate


        if (canAdvance === false) {
            month = maxDate.getMonth() - offset;
            year = maxDate.getFullYear();
        }

        _this2.setState({ month: month, year: year, canAdvance: canAdvance, canRetreat: canRetreat });
        onNextClicked({ month: month, year: year });
    };

    this.handleArrowNavigation = function (direction, column) {
        var _props5 = _this2.props,
            numMonthsToDisplay = _props5.numMonthsToDisplay,
            isMobile = _props5.isMobile,
            numMonthsToAdvance = _props5.numMonthsToAdvance;
        var _state3 = _this2.state,
            canAdvance = _state3.canAdvance,
            canRetreat = _state3.canRetreat;

        var numMonthsToAdv = isMobile ? 1 : numMonthsToAdvance;

        // The right arrow key was used while on the last day of a last visible month,
        // so we'll fake the next button being click by calling handleNextClicked()
        if (canAdvance && direction === 'next') {
            _this2.setState({
                direction: direction,
                activeMonth: numMonthsToDisplay - numMonthsToAdv - 1,
                refresh: !_this2.state.refresh
            });
            _this2.handleNextClicked();
            // The left arrow key was used while on the first day of the first visible month,
            // so we'll fake a prev button being clicked by calling handlePrevClicked()
        } else if (canRetreat && direction === 'prev') {
            _this2.setState({
                direction: direction,
                activeMonth: numMonthsToDisplay - (numMonthsToDisplay - numMonthsToAdv),
                refresh: !_this2.state.refresh
            });
            _this2.handlePrevClicked();
            // The up arrow key was used while on the first day of the first visible month,
            // so we'll fake a prev button being clicked by calling handlePrevClicked()
        } else if (canRetreat && direction === 'up') {
            _this2.setState({
                direction: direction,
                column: column,
                activeMonth: numMonthsToDisplay - (numMonthsToDisplay - numMonthsToAdv),
                refresh: !_this2.state.refresh
            });
            _this2.handlePrevClicked();
            // The down arrow key was used while on the last day of a last visible month,
            // so we'll fake the next button being click by calling handleNextClicked()
        } else if (canAdvance && direction === 'down') {
            _this2.setState({
                direction: direction,
                column: column,
                activeMonth: numMonthsToDisplay - numMonthsToAdv - 1,
                refresh: !_this2.state.refresh
            });
            _this2.handleNextClicked();
        }
    };
};

exports.default = (0, _reactDetermineIfMobile2.default)(NavCalendarMonth);
//# sourceMappingURL=NavCalendarMonth.js.map

/***/ }),

/***/ "ZGEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZTHW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function round(value) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

    var adj = Math.pow(10, decimalPlaces);
    return Math.round(value * adj) / adj;
}

function getAspectRatio(width, height) {
    return width > 0 && height > 0 ? round(width / height, 3) : 0;
}

var SETTINGS = {
    NEXT_PREV_THRESHOLD: 30,
    DISMISS_THRESHOLD: 60, // 30
    MAX_PAN_Y_THRESHOLD: 60,
    TRANSITION_DURATION: 300,
    SLIDE_TRANSITION_DURATION: 300 + 17,
    ROTATION_TRANSITION_DURATION: 500,
    MODAL_TRANSITION_DURATION: 400,
    INIT_DELAY: 500,
    PAN_END_TIMEOUT: 1000,
    DEFAULT_WIDTH: 4,
    DEFAULT_HEIGHT: 3,
    DEFAULT_ASPECT_RATIO: getAspectRatio(4, 3),
    VIDEO_WIDTH_DEFAULT: 1280,
    VIDEO_HEIGHT_DEFAULT: 720,
    VIDEO_ASPECT_RATIO: getAspectRatio(16, 9),
    VIDEO_BAR_HEIGHT: 60
};

var MEDIA_TYPE = {
    VIDEO: 'video',
    VIRTUAL_TOUR: 'virtualtour',
    IMAGE: 'image'
};

var CAROUSEL_TYPE = {
    INLINE: 'inline',
    MODAL: 'modal',
    FULLSCREEN: 'fullscreen',
    CUSTOM: 'custom'
};

var utils = {
    hexToRGB: function hexToRGB(hex) {
        var defaultRGB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0, 0];

        var isValidHex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
        if (isValidHex) {
            var h = hex.replace('#', '');
            h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));
            return h.map(function (val, i) {
                return parseInt(h[i].length === 1 ? h[i] + h[i] : h[i], 16);
            });
        }
        return defaultRGB;
    },
    getRGBString: function getRGBString(rgb, pct) {
        return 'rgba(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + ', ' + pct + ')';
    },


    getAspectRatio: getAspectRatio,

    useHeightForImageBoundSize: function useHeightForImageBoundSize(slideSize, boundSide) {
        return slideSize === 'height' || slideSize === 'contain' && boundSide === 'height' || slideSize === 'cover' && boundSide === 'width';
    },
    useWidthForImageBoundSize: function useWidthForImageBoundSize(slideSize, boundSide) {
        return slideSize === 'contain' && boundSide === 'width' || slideSize === 'cover' && boundSide === 'height';
    },
    getImageBoundSide: function getImageBoundSide(imageAspectRatio, slideAspectRatio) {
        return imageAspectRatio < slideAspectRatio ? 'height' : 'width';
    },
    getChanges: function getChanges() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$possibleChanges = _ref.possibleChanges,
            possibleChanges = _ref$possibleChanges === undefined ? [] : _ref$possibleChanges,
            _ref$knownChanges = _ref.knownChanges,
            knownChanges = _ref$knownChanges === undefined ? {} : _ref$knownChanges;

        var hasKnownChanges = knownChanges.constructor === Object && Object.keys(knownChanges).length > 0;
        var changes = _extends({}, knownChanges);
        var changed = possibleChanges.reduce(function (accum, data) {
            if (data.value !== data.oldValue) {
                changes[data.key] = data.value;
                return accum || true;
            }
            return accum || false;
        }, hasKnownChanges);
        return { changed: changed, changes: changes };
    },
    getImageSize: function getImageSize(carouselWidth, carouselHeight, imageAspectRatio, slideSize, boundSide) {
        var size = { height: 0, width: 0 };
        if (imageAspectRatio > 0 && carouselWidth > 0 && carouselHeight > 0) {
            boundSide = boundSide || utils.getImageBoundSide(imageAspectRatio, utils.getAspectRatio(carouselWidth, carouselHeight));
            if (utils.useHeightForImageBoundSize(slideSize, boundSide)) {
                size.height = Math.round(carouselHeight);
                size.width = Math.round(carouselHeight * imageAspectRatio);
            } else if (utils.useWidthForImageBoundSize(slideSize, boundSide)) {
                size.height = Math.round(carouselWidth / imageAspectRatio);
                size.width = Math.round(carouselWidth);
            }
        }
        return size;
    },
    getNextIndex: function getNextIndex(index, length) {
        return index < length - 1 ? index + 1 : 0;
    },
    getPrevIndex: function getPrevIndex(index, length) {
        return index > 0 ? index - 1 : length - 1;
    },
    getAdjIndex: function getAdjIndex(index, length, distance, increment) {
        var incrDecrFunc = increment ? utils.getNextIndex : utils.getPrevIndex;
        var i = void 0;
        for (i = 0; i < distance; i++) {
            index = incrDecrFunc(index, length);
        }
        return index;
    },
    getIndex: function getIndex(index, length, increment) {
        return utils.getAdjIndex(index, length, 1, increment);
    },
    getMatchingGradientStyle: function getMatchingGradientStyle(angle, overlayColor) {
        if (!angle || !overlayColor) {
            return {};
        }

        var rgb = utils.hexToRGB(overlayColor);
        var rgbFrom = 'rgba(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + ', .5)';
        var rgbTo = 'rgba(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + ', 0)';

        return {
            background: 'linear-gradient(' + angle + ', ' + rgbFrom + ', ' + rgbTo + ')'
        };
    },


    /**
     * getIndices()
     * returns a array of indices.
     * @param length images array length
     * @param start start position (i.e. current index)
     * @param count number of indices to add to the return array
     * @param increment the direction to count: up (true) or down (false)
     * @return array of indices
     */
    getIndices: function getIndices(length, start, count, increment) {
        var incrDecrFunc = increment ? utils.getNextIndex : utils.getPrevIndex;
        var arrayFunc = increment ? 'push' : 'unshift';
        var a = [];
        var i = void 0;
        for (i = 0; i < count; i++) {
            start = incrDecrFunc(start, length);
            a[arrayFunc](start);
        }
        return a;
    },


    /**
     * getRenderIndices()
     * returns an array of rendered indices which includes the start index in the middle and an equal count of indices before and after the start index
     * @param length images array images
     * @param start start position (i.e. current index)
     * @param countPerSide the count per side of the start postion to return
     * @return array of indices (alway odd in count)
     */
    getRenderIndices: function getRenderIndices(length, start, countPerSide) {
        return utils.getIndices(length, start, countPerSide, false).concat([start], utils.getIndices(length, start, countPerSide, true));
    },


    /**
     * getPreloadIndices()
     * returns an array of preload indices which appear before the start and after the end of the rendered indices
     * @param length images array images
     * @param start start position (i.e. current index)
     * @param countPerSide rendered indices will always be odd, so the count per side of the start postion to return
     * @return array of preload indices.
     */
    getPreloadIndices: function getPreloadIndices(length, start, distance, countPerSide) {
        var s1 = utils.getAdjIndex(start, length, distance, false);
        var s2 = utils.getAdjIndex(start, length, distance, true);
        return utils.getIndices(length, s1, countPerSide, false).concat(utils.getIndices(length, s2, countPerSide, true));
    },
    imagesDidChange: function imagesDidChange(images, newImages) {
        return newImages.length !== images.length || newImages.some(function (image, index) {
            return image.src !== images[index].src;
        });
    },
    isTouchEnabled: function isTouchEnabled() {
        return "object" !== 'undefined' && 'ontouchstart' in window || typeof navigator !== 'undefined' && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
    },
    getPrevIndexForRender: function getPrevIndexForRender(_ref2) {
        var index = _ref2.index,
            prevIndex = _ref2.prevIndex,
            images = _ref2.images;

        return typeof prevIndex !== 'undefined' ? prevIndex : utils.getPrevIndex(index, images.length);
    },
    computeSlideData: function computeSlideData(_ref3) {
        var index = _ref3.index,
            image = _ref3.image,
            carouselWidth = _ref3.carouselWidth,
            carouselHeight = _ref3.carouselHeight,
            carouselAspectRatio = _ref3.carouselAspectRatio,
            slideSize = _ref3.slideSize,
            mediaType = _ref3.mediaType;

        var isVideo = mediaType === MEDIA_TYPE.VIDEO;
        var width = image.width,
            height = image.height;


        if (isVideo) {
            width = SETTINGS.VIDEO_WIDTH_DEFAULT;
            height = SETTINGS.VIDEO_HEIGHT_DEFAULT;
        }

        var imageAspectRatio = utils.getAspectRatio(width, height);
        var slideAspectRatio = slideSize === 'height' && imageAspectRatio || carouselAspectRatio;
        var slideWidth = slideSize === 'height' && slideAspectRatio ? Math.round(carouselHeight * slideAspectRatio) : carouselWidth;

        if (isVideo && slideWidth > carouselWidth) {
            slideWidth = carouselWidth;
            slideAspectRatio = carouselAspectRatio;
        }

        return {
            index: index,
            slideHeight: carouselHeight,
            slideWidth: slideWidth,
            slideAspectRatio: slideAspectRatio,
            imageWidth: width,
            imageHeight: height,
            imageAspectRatio: imageAspectRatio,
            // isVideo,
            mediaType: mediaType
        };
    },
    hasPlaceholders: function hasPlaceholders(images) {
        return images.some(function (image) {
            return !image.src;
        });
    },
    hasSizeMetadata: function hasSizeMetadata(images) {
        return images.every(function (image) {
            return image.width && image.height;
        });
    },
    getImageProps: function getImageProps(img) {
        if (img && img.naturalWidth && img.naturalHeight) {
            var naturalWidth = img.naturalWidth,
                naturalHeight = img.naturalHeight;

            return {
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                aspectRatio: utils.getAspectRatio(naturalWidth, naturalHeight)
            };
        }
        return {
            naturalWidth: 0,
            naturalHeight: 0,
            aspectRatio: 0
        };
    },
    normalize: function normalize(_ref4) {
        var _ref4$min = _ref4.min,
            min = _ref4$min === undefined ? 0 : _ref4$min,
            _ref4$max = _ref4.max,
            max = _ref4$max === undefined ? 1 : _ref4$max,
            value = _ref4.value;

        return Math.min(max, Math.max(min, value));
    },
    getSetStateIfChanged: function getSetStateIfChanged(callback) {
        return function (_ref5) {
            var possibleChanges = _ref5.possibleChanges,
                knownChanges = _ref5.knownChanges;

            var _utils$getChanges = utils.getChanges({ possibleChanges: possibleChanges, knownChanges: knownChanges }),
                changed = _utils$getChanges.changed,
                changes = _utils$getChanges.changes;

            if (changed) {
                callback(changes);
            }

            return changed;
        };
    },
    areObjectValuesDifferent: function areObjectValuesDifferent() {
        var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var oldValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var keysList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var changedKey = void 0;
        var oldValue = void 0;
        var value = void 0;
        var changed = keysList.some(function (key) {
            var didChange = values[key] !== oldValues[key];
            if (didChange) {
                changedKey = key;
                oldValue = oldValues[key];
                value = values[key];
            }
            return didChange;
        });
        return { changed: changed, changedKey: changedKey, value: value, oldValue: oldValue };
    },
    getVideoDefaults: function getVideoDefaults() {
        var VIDEO_ASPECT_RATIO = SETTINGS.VIDEO_ASPECT_RATIO,
            VIDEO_WIDTH_DEFAULT = SETTINGS.VIDEO_WIDTH_DEFAULT,
            VIDEO_HEIGHT_DEFAULT = SETTINGS.VIDEO_HEIGHT_DEFAULT;

        return {
            aspectRatio: VIDEO_ASPECT_RATIO,
            naturalWidth: VIDEO_WIDTH_DEFAULT,
            naturalHeight: VIDEO_HEIGHT_DEFAULT
        };
    },
    getVideoSize: function getVideoSize(dimensions) {
        var carouselHeight = dimensions.carouselHeight,
            carouselWidth = dimensions.carouselWidth,
            imageHeight = dimensions.imageHeight,
            imageWidth = dimensions.imageWidth;


        if (!(carouselWidth || carouselHeight) && imageWidth && imageHeight) {
            return { imageWidth: imageWidth, imageHeight: imageHeight, imageAspectRatio: utils.getAspectRatio(imageWidth, imageHeight) };
        }

        return {
            imageWidth: Math.min(imageWidth, carouselWidth),
            imageHeight: Math.min(imageHeight, carouselHeight),
            imageAspectRatio: Math.min(utils.getAspectRatio(imageWidth, imageHeight), utils.getAspectRatio(carouselWidth, carouselHeight))
        };
    },
    isVideo: function isVideo(mediaSrc) {
        return (/youtu\.?be/.test(mediaSrc)
        );
    },
    getMediaType: function getMediaType() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            src = _ref6.src,
            mediaType = _ref6.mediaType;

        if (mediaType === MEDIA_TYPE.VIDEO || utils.isVideo(src)) {
            return MEDIA_TYPE.VIDEO;
        } else if (mediaType === MEDIA_TYPE.VIRTUAL_TOUR) {
            return MEDIA_TYPE.VIRTUAL_TOUR;
        }
        return MEDIA_TYPE.IMAGE;
    },
    getVideoId: function getVideoId(mediaSrc) {
        var videoId = mediaSrc.match(/youtu.*\/(?:watch.*v=)?([a-zA-Z0-9_-]+)/);
        return videoId && videoId[1] && videoId[1].length === 11 ? videoId[1] : null;
    },


    // added 1.1.0
    getSlideMargin: function getSlideMargin(carouselWidth, slideWidth) {
        return (carouselWidth - slideWidth) / 2;
    },
    getPanPercent: function getPanPercent(_ref7) {
        var carouselWidth = _ref7.carouselWidth,
            slidesData = _ref7.slidesData,
            index = _ref7.index,
            length = _ref7.length,
            deltaX = _ref7.deltaX;

        var isNext = deltaX < 0;
        var nextIndex = utils.getIndex(index, length, isNext);
        var curSlideWidth = slidesData[index].slideWidth;
        var curSlideMargin = utils.getSlideMargin(carouselWidth, curSlideWidth);
        var nextSlideWidth = slidesData[nextIndex].slideWidth;
        var nextSlideMargin = utils.getSlideMargin(carouselWidth, nextSlideWidth);
        var totalDistance = nextSlideWidth + nextSlideMargin - curSlideMargin;
        var pct = Math.abs(deltaX) / totalDistance;
        return pct;
    },


    round: round,

    getBgOpacityPctOnPanY: function getBgOpacityPctOnPanY(height, deltaY) {
        var mult = 1.5;
        var pct = (height / mult + (0 - Math.abs(deltaY))) / (height / mult);
        return utils.normalize({ value: Math.round(pct * 100) / 100 });
    },
    prevOrNext: function prevOrNext(_ref8) {
        var _ref8$index = _ref8.index,
            index = _ref8$index === undefined ? 0 : _ref8$index,
            _ref8$renderedIndices = _ref8.renderedIndices,
            renderedIndices = _ref8$renderedIndices === undefined ? [] : _ref8$renderedIndices;

        var indexOfIndex = renderedIndices.indexOf(index);
        if (indexOfIndex > -1) {
            var side = Math.floor(renderedIndices.length / 2);
            if (indexOfIndex < side) {
                return 'prev';
            } else if (indexOfIndex > side) {
                return 'next';
            }
        }
        return '';
    },
    isPrev: function isPrev(_ref9) {
        var _ref9$index = _ref9.index,
            index = _ref9$index === undefined ? 0 : _ref9$index,
            _ref9$renderedIndices = _ref9.renderedIndices,
            renderedIndices = _ref9$renderedIndices === undefined ? [] : _ref9$renderedIndices;

        return utils.prevOrNext({ index: index, renderedIndices: renderedIndices }) === 'prev';
    },
    isNext: function isNext(_ref10) {
        var _ref10$index = _ref10.index,
            index = _ref10$index === undefined ? 0 : _ref10$index,
            _ref10$renderedIndice = _ref10.renderedIndices,
            renderedIndices = _ref10$renderedIndice === undefined ? [] : _ref10$renderedIndice;

        return utils.prevOrNext({ index: index, renderedIndices: renderedIndices }) === 'next';
    }
};

exports.SETTINGS = SETTINGS;
exports.MEDIA_TYPE = MEDIA_TYPE;
exports.CAROUSEL_TYPE = CAROUSEL_TYPE;
exports.utils = utils;
exports.default = utils;
//# sourceMappingURL=CarouselUtil.js.map

/***/ }),

/***/ "Zk5a":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "ZmSW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCardCarousel = __webpack_require__("F8cY");

var _reactUnveil = __webpack_require__("kSlA");

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _SearchCard = __webpack_require__("lEyX");

var _SearchCard2 = _interopRequireDefault(_SearchCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecentActivityStateless(_ref) {
    var breakpoints = _ref.breakpoints,
        cardIndex = _ref.cardIndex,
        isMobile = _ref.isMobile,
        onArrowClick = _ref.onArrowClick,
        onClick = _ref.onClick,
        onEnter = _ref.onEnter,
        summaries = _ref.summaries,
        title = _ref.title;

    function handleNextAndPreviousClick(e, newIndex) {
        if (onArrowClick) {
            onArrowClick(e, newIndex);
        }
    }

    function handleNextClick(e, newIndex) {
        (0, _edapWrapper2.default)().push({
            name: 'generic.event',
            data: {
                eventcategory: 'scratchpad',
                eventaction: 'smparentarrow',
                eventlabel: 'advance'
            }
        });

        handleNextAndPreviousClick(e, newIndex);
    }

    function handlePreviousClick(e, newIndex) {
        (0, _edapWrapper2.default)().push({
            name: 'generic.event',
            data: {
                eventcategory: 'scratchpad',
                eventaction: 'smparentarrow',
                eventlabel: 'back'
            }
        });

        handleNextAndPreviousClick(e, newIndex);
    }

    function handleResize(_ref2) {
        var needsControls = _ref2.needsControls;

        var arrowsPresent = !isMobile && needsControls;

        (0, _edapWrapper2.default)().push({
            name: 'generic.event',
            data: {
                eventcategory: 'scratchpad',
                eventaction: 'smparentarrow',
                eventlabel: arrowsPresent ? 'present' : 'notpresent',
                highfrequency: 'true'
            }
        });
    }

    function handleSearchClick(e, id, position, searchStartDate, searchEndDate, lbsUuid) {
        var totalCards = summaries.length;

        (0, _edapWrapper2.default)().push({
            name: 'generic.event',
            data: {
                eventcategory: 'scratchpad',
                eventaction: 'smparentclick',
                eventlabel: position + '/' + totalCards
            }
        });

        if (onClick) {
            onClick(e, id, position, searchStartDate, searchEndDate, lbsUuid);
        }
    }

    if (summaries.length === 0) {
        return null;
    }

    return _react2.default.createElement(
        _reactUnveil.Waypoint,
        { onEnter: onEnter },
        _react2.default.createElement(
            _reactCardCarousel.CardCarousel,
            {
                breakpoints: breakpoints,
                cardIndex: cardIndex,
                onNextClick: handleNextClick,
                onPreviousClick: handlePreviousClick,
                onResize: handleResize,
                title: title,
                paging: true,
                scrolling: isMobile
            },
            summaries.map(function (cardProps, index) {
                return _react2.default.createElement(_SearchCard2.default, _extends({ key: index }, cardProps, { onClick: handleSearchClick, position: index + 1 }));
            })
        )
    );
}

RecentActivityStateless.propTypes = {
    breakpoints: _propTypes2.default.objectOf(_propTypes2.default.number),
    cardIndex: _propTypes2.default.number,
    isMobile: _propTypes2.default.bool,
    onArrowClick: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    summaries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    title: _propTypes2.default.string
};

RecentActivityStateless.defaultProps = {
    breakpoints: {
        '2340': 8,
        '2040': 7,
        '1740': 6,
        '1440': 5,
        '1140': 4,
        '840': 3,
        '769': 2,
        '680': 4,
        '490': 3,
        '0': 2
    },
    onArrowClick: function onArrowClick() {},
    onClick: function onClick() {},
    onEnter: function onEnter() {},
    summaries: [],
    title: ''
};

exports.default = RecentActivityStateless;
//# sourceMappingURL=RecentActivityStateless.js.map

/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BQO6"), __esModule: true };

/***/ }),

/***/ "a+sF":
/***/ (function(module, exports) {

/**
 * Keep this in alphabetical order please!
 * TODO: runtime configuration of these tests
 */
var HA_PULSE_AA_TEST = 'HA_PULSE_AA_TEST';
var HA_PULSE_ACTIVITY_INDICATORS = 'ha_pulse_activity_indicators'; // 28106
var HA_PULSE_CREATE_BOARD = 'ha_pulse_create_board'; // 28908
var HA_PULSE_EMPTY_SEARCH_TEST = 'ha_pulse_empty_search_test'; // 28200
var HA_PULSE_IMPROVED_EMPTY_STATE = 'ha_pulse_improved_empty_state'; // 29036
var HA_PULSE_PUBLIC_SEARCH_TEST = 'ha_pulse_public_search_test'; // 28459
var HA_PULSE_GOOGLE_MAP = 'ha_pulse_google_map'; // 27654
var HA_PULSE_GUEST_CONTEXT_TEST = 'ha_pulse_guest_context_test'; // 29041
var HA_PULSE_HEART_REMOVE_TEST = 'ha_pulse_heart_remove_test'; // 28891
var HA_PULSE_INVITE_ACCEPT_MODAL_TEST = "ha_pulse_invite_accept_modal_test"; // 29313
var HA_PULSE_PRIVATE_SEARCH_TEST = 'ha_pulse_private_search_test'; // 28608
var HA_PULSE_RECENT_ACTIVITY_TEST = 'ha_pulse_recent_activity_test';
var HA_PULSE_RECO_AB_TEST = 'ha_pulse_reco_ab_test';
var HA_PULSE_REMOVE_BACK_BUTTON_TEST = 'ha_pulse_remove_back_button_test';
var HA_PULSE_SHARED_TRIPBOARD_AB_TEST = 'ha_pulse_shared_tripboard_ab_test';
var HA_PULSE_SIMILAR_PROPERTIES = 'ha_pulse_similar_properties'; // 27564
var HA_PULSE_SWAP_REVIEWS_PRICE = 'ha_pulse_swap_reviews_price'; // 27249
var HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE = 'ha_pulse_tripboard_invite_button_throttle'; // 26484
var HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE = 'ha_pulse_tripboard_share_button_throttle'; // 26440
var HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE = 'ha_pulse_tripboard_share_facebook_throttle';
var HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE = 'ha_pulse_tripboard_share_pinterest_throttle';
var HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE = 'ha_pulse_tripboard_share_twitter_throttle';
var HA_PULSE_TRIPBOARDS_CAROUSEL_TEST = 'ha_pulse_tripboards_carousel_test'; // 27507
var LOADING_ANIMATION = 'ha_pulse_tripboard_loading_animation_test';
var NEW_MODAL = 'ha_pulse_tripboard_new_modal_test'; // 25891
var SKELETON_ABC = 'ha_pulse_skeleton_abc_test'; // 25647
var WATERFALL_AB = 'ha_pulse_waterfall_ab_test'; // 25978
var HA_GDPR_BANNER = 'ha_gdpr_banner';

// Put all tests in this array!!! :)
var EVALUATE = [HA_PULSE_AA_TEST, HA_PULSE_ACTIVITY_INDICATORS, HA_PULSE_CREATE_BOARD, HA_PULSE_EMPTY_SEARCH_TEST, HA_PULSE_IMPROVED_EMPTY_STATE, HA_PULSE_PUBLIC_SEARCH_TEST, HA_PULSE_GOOGLE_MAP, HA_PULSE_GUEST_CONTEXT_TEST, HA_PULSE_HEART_REMOVE_TEST, HA_PULSE_INVITE_ACCEPT_MODAL_TEST, HA_PULSE_PRIVATE_SEARCH_TEST, HA_PULSE_RECENT_ACTIVITY_TEST, HA_PULSE_RECO_AB_TEST, HA_PULSE_REMOVE_BACK_BUTTON_TEST, HA_PULSE_SHARED_TRIPBOARD_AB_TEST, HA_PULSE_SIMILAR_PROPERTIES, HA_PULSE_SWAP_REVIEWS_PRICE, HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE, HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE, HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE, HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE, HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE, HA_PULSE_TRIPBOARDS_CAROUSEL_TEST, LOADING_ANIMATION, NEW_MODAL, SKELETON_ABC, WATERFALL_AB, HA_GDPR_BANNER];

// Will we use this? Not sure.
var EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE: EVALUATE,
    EVALUATE_AND_LOG: EVALUATE_AND_LOG,
    HA_PULSE_AA_TEST: HA_PULSE_AA_TEST,
    HA_PULSE_ACTIVITY_INDICATORS: HA_PULSE_ACTIVITY_INDICATORS,
    HA_PULSE_CREATE_BOARD: HA_PULSE_CREATE_BOARD,
    HA_PULSE_EMPTY_SEARCH_TEST: HA_PULSE_EMPTY_SEARCH_TEST,
    HA_PULSE_IMPROVED_EMPTY_STATE: HA_PULSE_IMPROVED_EMPTY_STATE,
    HA_PULSE_PUBLIC_SEARCH_TEST: HA_PULSE_PUBLIC_SEARCH_TEST,
    HA_PULSE_PRIVATE_SEARCH_TEST: HA_PULSE_PRIVATE_SEARCH_TEST,
    HA_PULSE_GOOGLE_MAP: HA_PULSE_GOOGLE_MAP,
    HA_PULSE_GUEST_CONTEXT_TEST: HA_PULSE_GUEST_CONTEXT_TEST,
    HA_PULSE_HEART_REMOVE_TEST: HA_PULSE_HEART_REMOVE_TEST,
    HA_PULSE_INVITE_ACCEPT_MODAL_TEST: HA_PULSE_INVITE_ACCEPT_MODAL_TEST,
    HA_PULSE_RECENT_ACTIVITY_TEST: HA_PULSE_RECENT_ACTIVITY_TEST,
    HA_PULSE_RECO_AB_TEST: HA_PULSE_RECO_AB_TEST,
    HA_PULSE_REMOVE_BACK_BUTTON_TEST: HA_PULSE_REMOVE_BACK_BUTTON_TEST,
    HA_PULSE_SHARED_TRIPBOARD_AB_TEST: HA_PULSE_SHARED_TRIPBOARD_AB_TEST,
    HA_PULSE_SIMILAR_PROPERTIES: HA_PULSE_SIMILAR_PROPERTIES,
    HA_PULSE_SWAP_REVIEWS_PRICE: HA_PULSE_SWAP_REVIEWS_PRICE,
    HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE: HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE: HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE: HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE: HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE: HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE,
    HA_PULSE_TRIPBOARDS_CAROUSEL_TEST: HA_PULSE_TRIPBOARDS_CAROUSEL_TEST,
    LOADING_ANIMATION: LOADING_ANIMATION,
    NEW_MODAL: NEW_MODAL,
    SKELETON_ABC: SKELETON_ABC,
    WATERFALL_AB: WATERFALL_AB,
    HA_GDPR_BANNER: HA_GDPR_BANNER
};

/***/ }),

/***/ "a/OS":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "a67U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactFormComponents = __webpack_require__("QyGt");

var _reactDetermineIfMobile = __webpack_require__("54yA");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _propTypeDateString = __webpack_require__("NTt2");

var _propTypeDateString2 = _interopRequireDefault(_propTypeDateString);

var _dateUtils = __webpack_require__("pkO5");

var _edap = __webpack_require__("0lN5");

var _edap2 = _interopRequireDefault(_edap);

var _Base = __webpack_require__("X/Bi");

var _Base2 = _interopRequireDefault(_Base);

var _reactSvg = __webpack_require__("Ye17");

var _ARROW_RIGHT__ = __webpack_require__("3BH2");

__webpack_require__("sWRA");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateRangePicker = function (_Component) {
    _inherits(DateRangePicker, _Component);

    function DateRangePicker(props) {
        _classCallCheck(this, DateRangePicker);

        var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

        _initialiseProps.call(_this);

        var _getMonthYear = (0, _dateUtils.getMonthYear)(props.date),
            month = _getMonthYear.month,
            year = _getMonthYear.year;

        var isOpen = _this.props.isOpen;


        _this.state = {
            month: month,
            year: year,
            isOpen: isOpen,
            selectionChangeMode: 'all'
        };
        return _this;
    }

    _createClass(DateRangePicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isOpen !== nextProps.isOpen && this.state.isOpen !== nextProps.isOpen) {
                if (nextProps.isOpen) {
                    this.handleFocusInput1();
                } else {
                    this.handleClose();
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            // When rendering the calendar in the modal, we display 24 months and allow scrolling.
            // Rendering the 24 months immediately screws up the CSS transitions and makes things
            // janky. So we display an empty modal first, then start rendering the calendar.
            if (this.props.isMobile && this.state.isDelayed) {
                window.setTimeout(function () {
                    _this2.setState({ isDelayed: false });
                }, 50);
            }
        }
    }, {
        key: 'setSelectionChangeMode',
        value: function setSelectionChangeMode(mode) {
            this.setState({ selectionChangeMode: mode });
            this.props.onSelectionModeChange(mode === 'end');
        }
    }, {
        key: 'openCalendar',
        value: function openCalendar(selectionChangeMode, formControlClass) {
            var _props = this.props,
                isMobile = _props.isMobile,
                startDate = _props.startDate,
                disableTextInput = _props.disableTextInput;


            if (isMobile) {
                // Open, but set isDelayed to true so the calendar waits a moment to render.
                this.setState({
                    isOpen: true,
                    isDelayed: true
                });
            } else {
                var _getMonthYear2 = (0, _dateUtils.getMonthYear)(startDate),
                    month = _getMonthYear2.month,
                    year = _getMonthYear2.year;

                var dateInput = (0, _reactDom.findDOMNode)(this).getElementsByClassName(formControlClass)[0];

                if (document && document.activeElement !== dateInput) {
                    // as we may be clicking on the overlay, rather than tabbing to the input
                    // force focus of the input for text entry (text entry is TODO)
                    if (!disableTextInput) {
                        dateInput.focus();
                    }

                    this.setState({
                        isOpen: true,
                        month: month,
                        year: year
                    });
                }
            }

            if (this.state.selectionChangeMode !== selectionChangeMode) {
                this.setSelectionChangeMode(selectionChangeMode);
            }
        }
    }, {
        key: 'contains',
        value: function contains(elem, target) {
            return elem && (0, _reactDom.findDOMNode)(elem).contains(target);
        }
    }, {
        key: 'getWdio',
        value: function getWdio(prefix, elementClass) {
            return prefix ? prefix + '-' + elementClass : elementClass;
        }
    }, {
        key: 'renderInputs',
        value: function renderInputs() {
            var _this3 = this;

            var _props2 = this.props,
                startDate = _props2.startDate,
                endDate = _props2.endDate,
                inputLabel1 = _props2.inputLabel1,
                inputLabel2 = _props2.inputLabel2,
                inputName1 = _props2.inputName1,
                inputName2 = _props2.inputName2,
                positionIconRight = _props2.positionIconRight,
                inputIcon1 = _props2.inputIcon1,
                inputIcon2 = _props2.inputIcon2,
                errorMsg = _props2.errorMsg,
                readOnly = _props2.readOnly,
                wdioPrefix = _props2.wdioPrefix,
                locale = _props2.locale,
                consolidateInputs = _props2.consolidateInputs,
                dateFormatOptions = _props2.dateFormatOptions,
                showArrow = _props2.showArrow,
                splitInputs = _props2.splitInputs;


            var isShowArrow = showArrow && !consolidateInputs && !splitInputs;
            var isSplitInputs = splitInputs && !consolidateInputs;

            var leftContent = !positionIconRight ? inputIcon1 : null;
            var rightContent = positionIconRight ? inputIcon1 : null;

            var leftContent2 = !positionIconRight ? inputIcon2 : null;
            var rightContent2 = positionIconRight ? inputIcon2 : null;

            var focus01 = this.state.isOpen && this.state.selectionChangeMode !== 'end';
            var focus02 = this.state.isOpen && this.state.selectionChangeMode === 'end';

            var input1Classes = (0, _classnames2.default)({ 'not-empty': focus01 });
            var input2Classes = (0, _classnames2.default)({ 'not-empty': focus02 });

            var input1InputClasses = (0, _classnames2.default)({
                'form-control--arrival': !consolidateInputs,
                'form-control--arrive-depart': consolidateInputs,
                'DateRangePicker__input--mimic-focus': consolidateInputs ? this.state.isOpen : focus01,
                'DateRangePicker__input--margined': isSplitInputs
            });

            var input2InputClasses = (0, _classnames2.default)('form-control--departure DateRangePicker__FormInput-departure', {
                'DateRangePicker__input--mimic-focus': focus02,
                'form-control--no-arrow': !isShowArrow,
                'DateRangePicker__input--margined': isSplitInputs
            });

            var overlayClasses = (0, _classnames2.default)('picker__overlay', {
                'picker__overlay--selectable': !readOnly
            });

            var formGroupClasses = (0, _classnames2.default)('form-group', 'position-relative', 'form-combined__input1', {
                'DateRangePicker__form-group--margined': isSplitInputs
            });

            var inputValue1 = consolidateInputs ? (0, _dateUtils.getLocaleConsolidatedDateString)(startDate, endDate, locale, dateFormatOptions) : (0, _dateUtils.getLocaleDateString)(startDate, locale, dateFormatOptions);
            var inputValue2 = (0, _dateUtils.getLocaleDateString)(endDate, locale, dateFormatOptions);

            return _react2.default.createElement(
                'div',
                { className: 'form-combined-row' },
                _react2.default.createElement(
                    'div',
                    { className: formGroupClasses },
                    _react2.default.createElement(_reactFormComponents.FormInput, {
                        className: input1Classes,
                        inputClassName: input1InputClasses,
                        name: inputName1,
                        label: inputLabel1,
                        value: inputValue1,
                        onChange: this.handleChangeInput1,
                        onFocus: readOnly ? null : this.handleFocusInput1,
                        errorMsg: errorMsg,
                        ref: function ref(c) {
                            return _this3.input1 = c;
                        },
                        readOnly: readOnly ? 'readOnly' : '',
                        'data-wdio': this.getWdio(wdioPrefix, 'date-range-input-start'),
                        leftContent: leftContent,
                        rightContent: rightContent
                    }),
                    _react2.default.createElement('div', {
                        className: overlayClasses,
                        ref: function ref(c) {
                            return _this3.overlay1 = c;
                        },
                        onClick: readOnly ? null : this.handleFocusInput1
                    })
                ),
                isShowArrow && _react2.default.createElement(
                    'div',
                    { className: 'form-group form-combined__svg' },
                    _react2.default.createElement(_reactSvg.SVGIcon, { markup: _ARROW_RIGHT__.ARROW_RIGHT__24 })
                ),
                !consolidateInputs && _react2.default.createElement(
                    'div',
                    { className: 'form-group position-relative form-combined__input2' },
                    _react2.default.createElement(_reactFormComponents.FormInput, {
                        className: input2Classes,
                        inputClassName: input2InputClasses,
                        name: inputName2,
                        label: inputLabel2,
                        value: inputValue2,
                        onChange: this.handleChangeInput2,
                        onFocus: readOnly ? null : this.handleFocusInput2,
                        ref: function ref(c) {
                            return _this3.input2 = c;
                        },
                        readOnly: readOnly ? 'readOnly' : '',
                        'data-wdio': this.getWdio(wdioPrefix, 'date-range-input-end'),
                        leftContent: leftContent2,
                        rightContent: rightContent2
                    }),
                    _react2.default.createElement('div', {
                        className: overlayClasses,
                        ref: function ref(c) {
                            return _this3.overlay2 = c;
                        },
                        onClick: readOnly ? null : this.handleFocusInput2
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = (0, _classnames2.default)(this.props.className, 'date-range form-combined form-combined--dates');

            return _react2.default.createElement(_Base2.default, {
                fadeOutDuration: this.props.fadeOutDuration,
                alertTemplateComponent: this.props.alertTemplateComponent,
                alertTemplateData: this.props.alertTemplateData,
                calendarLabels: this.props.calendarLabels,
                calendarRefFunc: this.calendarRefFunc,
                centered: this.props.centered,
                className: classes,
                clearButtonLabel: this.props.clearButtonLabel // TODO: Linguaize
                , continueButtonLabel: this.props.continueButtonLabel // TODO: Linguaize
                , dayData: this.props.dayData,
                dayTemplateComponent: this.props.dayTemplateComponent,
                endDate: this.props.endDate,
                inputs: this.renderInputs(),
                isDelayed: this.state.isDelayed,
                isMobile: this.props.isMobile,
                isOpen: this.state.isOpen,
                locale: this.props.locale,
                maxDate: this.props.maxDate,
                minDate: this.props.minDate,
                modalTitle: this.props.modalTitle,
                month: this.state.month,
                numMonthsToDisplay: 2,
                onDatesCleared: this.handleClearDates,
                onClose: this.handleClose,
                onDisabledDayClick: this.props.onDisabledDayClick,
                onFocus: this.props.onFocus,
                onOpen: this.handleOpen,
                onSubmit: this.handleSubmit,
                onCancel: this.props.onCancel,
                onSelectionChanged: this.handleDateChange,
                parentNode: this.props.parentNode,
                placement: this.props.placement,
                scrollNode: this.props.scrollNode,
                selectionChangeMode: this.state.selectionChangeMode,
                selectionType: 'range',
                enableSameDayDateRange: this.props.enableSameDayDateRange,
                showContinueButton: this.props.showContinueButton,
                startDate: this.props.startDate,
                year: this.state.year
            });
        }
    }]);

    return DateRangePicker;
}(_react.Component);

DateRangePicker.propTypes = {
    /** The location on a page where an action takes place (for edap events) **/
    actionLocation: _propTypes2.default.string,
    /** An optional passed in React component, used to render an alert within the date picker pop up. **/
    alertTemplateComponent: _propTypes2.default.func,
    /** An optional object, used to pass data to the alert component. **/
    alertTemplateData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** Optional labels object to override default locale-driven labels */
    calendarLabels: _propTypes2.default.shape({
        monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortMonthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        dayNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortDayNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    /** Centers tooltip position, true by default */
    centered: _propTypes2.default.bool,
    /** The text label displayed on the clear button */
    clearButtonLabel: _propTypes2.default.string,
    /** The text label displayed on the continue button */
    continueButtonLabel: _propTypes2.default.string,
    /** Consolidate check in and check out fields into a single input field */
    consolidateInputs: _propTypes2.default.bool,
    /** Options object, eg. {month: 'short', day: 'numeric'} (See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString) */
    dateFormatOptions: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** DayData that will power any passed in template */
    dayData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** An optional passed in React component, used to render each day. **/
    dayTemplateComponent: _propTypes2.default.func,
    /** Prevents keyboard input. Useful on iPad to prevent software keyboard from popping up. */
    disableTextInput: _propTypes2.default.bool,
    /** Selected start date */
    endDate: _propTypeDateString2.default,
    /** Form input error message */
    errorMsg: _propTypes2.default.string,
    /** Determines which side of the input field inputIcons1 shows. Positions right if true. */
    positionIconRight: _propTypes2.default.bool,
    /** Add content to the left of the input 1. This can be a string, element, or component */
    inputIcon1: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
    /** Add content to the left of the input 2. This can be a string, element, or component */
    inputIcon2: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
    /** Form input label for the start date input*/
    inputLabel1: _propTypes2.default.string,
    /** Form input label for the end date input*/
    inputLabel2: _propTypes2.default.string,
    /** Form input name for the start date input*/
    inputName1: _propTypes2.default.string.isRequired,
    /** Form input name for the end date input*/
    inputName2: _propTypes2.default.string,
    /** Determines whether the date picker is open or not */
    isOpen: _propTypes2.default.bool,
    /** A moniker or BCP-47 style language tag string. */
    locale: _propTypes2.default.string,
    /** Maximum allowable date after which the next button will be disabled; scrollable mode stops loading more months. */
    maxDate: _propTypes2.default.instanceOf(Date),
    /** Minimum allowable date before which the prev button will be disabled; scrollable mode uses month and year props. */
    minDate: _propTypes2.default.instanceOf(Date),
    /* Custom title for modal */
    modalTitle: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    /** Function to call when a date is selected on the calendar */
    onDateRangeChange: _propTypes2.default.func,
    /** Function to call when dates are cleared */
    onDateRangeClear: _propTypes2.default.func,
    /** An optional passed in React component, used to trigger Next Available arrival and departure dates when clicked on disabled dates. **/
    onDisabledDayClick: _propTypes2.default.func,
    /** Optional callback for when the date picker gains focus */
    onFocus: _propTypes2.default.func,
    /** Function to call when the date picker opens */
    onOpen: _propTypes2.default.func,
    /** Function to call when a date picker is closed */
    onClose: _propTypes2.default.func,
    /** Optional callback when date picker toggles between selecting startDate and endDate, passes true as a param if selecting end date */
    onSelectionModeChange: _propTypes2.default.func,
    /** Optional callback when date picker is submitted (continue) */
    onSubmit: _propTypes2.default.func,
    /** Options callback when date picker is closed (X, Esc) */
    onCancel: _propTypes2.default.func,
    /** The DOM element to use as the parent for the date range picker when visible. This is useful in scenarios where the date range picker needs to break out of its current container due to overflow or z-index issues. */
    parentNode: _Base2.default.checkElementType,
    /** Defines placement of tooltip. default: 'bottom' */
    placement: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right']),
    /** Display-only mode */
    readOnly: _propTypes2.default.bool,
    /** The DOM element that the date range picker needs to scroll with. Only specify this if parentNode was specified and the date picker is displayed in a container that is scrollable independent of the browser window. */
    scrollNode: _Base2.default.checkElementType,
    /** Controls whether an arrow is displayed between the begin and end date inputs */
    showArrow: _propTypes2.default.bool,
    /** Show "continue" button in modal on mobile */
    showContinueButton: _propTypes2.default.bool,
    /** Controls whether begin and end date inputs are separated visually */
    splitInputs: _propTypes2.default.bool,
    /** Selected start date */
    startDate: _propTypeDateString2.default,
    /** By default, the input elements are given a data-wdio attribute of "date-range-input-start" and "date-range-input-end".
    If you have more than one on a page you can add a prefix to those two strings by using this property. */
    wdioPrefix: _propTypes2.default.string,
    /** Enable date range being the same date. By default, if the end date is selected to be the same as the start date, the entire selection is canceled */
    enableSameDayDateRange: _propTypes2.default.bool,
    /** Duration of the fade transition when the tooltip closes in milliseconds */
    fadeOutDuration: _propTypes2.default.number
};
DateRangePicker.defaultProps = {
    actionLocation: 'top',
    calendarLabels: {},
    centered: true,
    clearButtonLabel: 'Clear',
    continueButtonLabel: 'Continue',
    consolidateInputs: false,
    dateFormatOptions: {},
    disableTextInput: false,
    isOpen: false,
    onClose: function onClose() {},
    onDateRangeChange: function onDateRangeChange() {},
    onDateRangeClear: function onDateRangeClear() {},
    onFocus: function onFocus() {},
    onOpen: function onOpen() {},
    onSelectionModeChange: function onSelectionModeChange() {},
    onSubmit: function onSubmit() {},
    onCancel: function onCancel() {},
    placement: 'bottom',
    readOnly: false,
    positionIconRight: false,
    showArrow: true,
    showContinueButton: false,
    splitInputs: false,
    enableSameDayDateRange: false,
    fadeOutDuration: 400
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleFocusInput1 = function () {
        var _props3 = _this4.props,
            endDate = _props3.endDate,
            startDate = _props3.startDate;

        var className = _this4.props.consolidateInputs ? 'form-control--arrive-depart' : 'form-control--arrival';

        if (startDate && !endDate) {
            _this4.props.onDateRangeChange('', '');
        }

        _this4.openCalendar('start', className);
    };

    this.handleFocusInput2 = function () {
        var startDate = _this4.props.startDate;


        if (!startDate) {
            _this4.handleFocusInput1();
        } else {
            _this4.openCalendar('end', 'form-control--departure');
        }
    };

    this.handleWindowClick = function (event) {
        // We want to close the tooltip when the user clicks anything on the screen,
        // outside of the tooltip. This is for non-mobile.
        var isWithin = _this4.contains(_this4.input1, event.target) || _this4.contains(_this4.input2, event.target) || _this4.contains(_this4.overlay1, event.target) || _this4.contains(_this4.overlay2, event.target) || _this4.contains(_this4.calendar, event.target);

        if (isWithin) {
            event.stopImmediatePropagation();
        } else {
            _this4.handleClose();
        }
    };

    this.handleDateChange = function (startDateString, endDateString) {
        _this4.props.onDateRangeChange(startDateString, endDateString);

        if (endDateString && !_this4.props.isMobile) {
            // Delaying to allow selection visual to appear before closing
            window.setTimeout(function () {
                _this4.handleClose();
            }, 20);
        } else if (endDateString) {
            _this4.setSelectionChangeMode('start');
        } else if (!startDateString) {
            _this4.setSelectionChangeMode('all');
        } else {
            _this4.setSelectionChangeMode('end');
        }

        if (endDateString) {
            (0, _edap2.default)('datepicker.dates.selected', {
                actionlocation: _this4.props.actionLocation
            });
        }
    };

    this.handleClearDates = function (event) {
        var _props4 = _this4.props,
            actionLocation = _props4.actionLocation,
            onDateRangeChange = _props4.onDateRangeChange,
            onDateRangeClear = _props4.onDateRangeClear;


        event.preventDefault();
        onDateRangeChange('', '');

        (0, _edap2.default)('datepicker.dates.cleared', {
            actionlocation: actionLocation
        });

        _this4.setSelectionChangeMode('all');
        onDateRangeClear();
    };

    this.handleClose = function () {
        var _props5 = _this4.props,
            actionLocation = _props5.actionLocation,
            onClose = _props5.onClose,
            isMobile = _props5.isMobile;

        if (_this4.state.isOpen) {
            _this4.setState({ isOpen: false }, onClose);

            if (!isMobile && document && document.documentElement) {
                // Stop listening for clicks outside of the tooltip
                document.documentElement.removeEventListener('mouseup', _this4.handleWindowClick);
                document.documentElement.removeEventListener('touchstart', _this4.handleWindowClick);
            }

            (0, _edap2.default)('datepicker.close', {
                actionlocation: actionLocation
            });
        }
    };

    this.handleOpen = function () {
        var _props6 = _this4.props,
            actionLocation = _props6.actionLocation,
            isMobile = _props6.isMobile,
            onOpen = _props6.onOpen;
        var isOpen = _this4.state.isOpen;

        if (isOpen) {
            onOpen();

            if (!isMobile && document && document.documentElement) {
                // Listen for clicks outside this component. Done via a setTimeout
                // in order to ignore the initial bubble of the click that initiated
                // the open.
                window.setTimeout(function () {
                    document.documentElement.addEventListener('mouseup', _this4.handleWindowClick);
                    document.documentElement.addEventListener('touchstart', _this4.handleWindowClick);
                }, 0);
            }

            (0, _edap2.default)('datepicker.open', {
                actionlocation: actionLocation
            });
        }
    };

    this.handleChangeInput1 = function () {
        // TODO: allow keyboard entry
    };

    this.handleChangeInput2 = function () {
        // TODO: allow keyboard entry
    };

    this.handleSubmit = function () {
        _this4.props.onSubmit();
    };

    this.calendarRefFunc = function (c) {
        _this4.calendar = c;
    };
};

exports.default = (0, _reactDetermineIfMobile2.default)(DateRangePicker);
//# sourceMappingURL=DateRangePicker.js.map

/***/ }),

/***/ "aCM0":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    getRawTag = __webpack_require__("uLhX"),
    objectToString = __webpack_require__("+66z");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "aLzV":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var createDesc = __webpack_require__("YTz9");
module.exports = __webpack_require__("qs+f") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "aUQ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "abPz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("Aq0r");
var step = __webpack_require__("beh1");
var Iterators = __webpack_require__("yYxz");
var toIObject = __webpack_require__("ksFB");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("4dmN")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "akZ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("Ighh").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "amq8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__("JgUz");

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__("F6Hy");

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__("WhHO");

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),

/***/ "anwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optimisticRemoveListingFromTripBoardResponse = exports.removeListingFromCache = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactApollo = __webpack_require__("3zLD");

var _graphql = __webpack_require__("qm98");

var _withFetchPreviews = __webpack_require__("+TD/");

var removeListingFromCache = exports.removeListingFromCache = function removeListingFromCache(listingId, hav, pageSize, listingPageSize) {
    return function (proxy) {
        var cache = (0, _withFetchPreviews.readPreviewsCache)(proxy, hav, pageSize, listingPageSize);
        if (!cache || !cache.paginatedTripBoards) {
            return; // we aren't being fed a populated cache, why bother?
        }
        var boards = cache.paginatedTripBoards.tripBoards || [];
        for (var index = 0; index < boards.length; index++) {
            var tripboard = boards[index];
            var listingRefs = tripboard.listingRefs.filter(function (listing) {
                return listing !== listingId;
            });
            var listings = tripboard.listings.filter(function (_ref) {
                var thisListingId = _ref.listingId;
                return thisListingId !== listingId;
            });
            tripboard.listingRefs = listingRefs;
            tripboard.listings = listings;
        }

        (0, _withFetchPreviews.writePreviewsCache)(proxy, hav, pageSize, listingPageSize, cache);
    };
};

var optimisticRemoveListingFromTripBoardResponse = exports.optimisticRemoveListingFromTripBoardResponse = {
    removeUnitFromTripBoards: true
};

var withRemoveFromTripBoards = (0, _reactApollo.graphql)(_graphql.removeUnitFromTripBoardsMutation, {
    options: function options(props) {
        return _extends({}, props.mutationConfig, {
            optimisticResponse: optimisticRemoveListingFromTripBoardResponse
        });
    },
    name: 'removeFromTripBoards',
    alias: 'withRemoveFromTripBoardsMutation'
});

exports.default = withRemoveFromTripBoards;
//# sourceMappingURL=with-remove-from-trip-boards.js.map

/***/ }),

/***/ "avdD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b753":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bG61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var readCookie = function readCookie(name) {
    var cookieSource = typeof document !== 'undefined' ? document.cookie : '';

    var regexValue = '=([^;]+)';
    var match = cookieSource.match(new RegExp(name + regexValue));
    var result = '';

    if (match && match.length > 0) {
        try {
            result = JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
            result = '';
        }
    }

    return result;
};

var getHav = function getHav() {
    var hav = void 0;
    // did we already get it server side?
    if (true) {
        hav = window.tripboardConfig && window.tripboardConfig.hav || '';
    }
    if (!hav) {
        hav = readCookie('hav');
    }
    return hav;
};

exports.getHav = getHav;
//# sourceMappingURL=havCookie.js.map

/***/ }),

/***/ "bIbi":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD"),
    root = __webpack_require__("TQ3y");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "bSeU":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "beh1":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "bfTJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

module.exports = __webpack_require__("gSaG").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "blYT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "c/7n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactQuantity = __webpack_require__("9TIe");

var _reactQuantity2 = _interopRequireDefault(_reactQuantity);

var _reactFormComponents = __webpack_require__("QyGt");

__webpack_require__("AgU7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * GuestFields
 */
var GuestFields = function (_Component) {
    _inherits(GuestFields, _Component);

    /* istanbul ignore next */
    function GuestFields(props) {
        _classCallCheck(this, GuestFields);

        var _this = _possibleConstructorReturn(this, (GuestFields.__proto__ || Object.getPrototypeOf(GuestFields)).call(this, props));

        _this.handleAdultsUpdate = _this.handleUpdate.bind(_this, 'adultsCount');
        _this.handleChildrenUpdate = _this.handleUpdate.bind(_this, 'childrenCount');
        _this.handlePetChange = _this.handlePetChange.bind(_this);
        return _this;
    }

    _createClass(GuestFields, [{
        key: 'handleUpdate',
        value: function handleUpdate(key, count) {
            count = parseInt(count, 10);
            this.props.onChange(key, count);
        }
    }, {
        key: 'handlePetChange',
        value: function handlePetChange(event) {
            this.props.onChange(event.target.name, event.target.value === 'true');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                adultsCount = _props.adultsCount,
                adultsLabel = _props.adultsLabel,
                adultsIncreaseLabel = _props.adultsIncreaseLabel,
                adultsDecreaseLabel = _props.adultsDecreaseLabel,
                adultsMax = _props.adultsMax,
                adultsMin = _props.adultsMin,
                childrenCount = _props.childrenCount,
                childrenMax = _props.childrenMax,
                childrenMin = _props.childrenMin,
                childrenLabel = _props.childrenLabel,
                childrenIncreaseLabel = _props.childrenIncreaseLabel,
                childrenDecreaseLabel = _props.childrenDecreaseLabel,
                petLabel = _props.petLabel,
                petIncluded = _props.petIncluded,
                petYesLabel = _props.petYesLabel,
                petNoLabel = _props.petNoLabel,
                showpetOption = _props.showpetOption;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'guest-fields', 'data-wdio': 'guest-fields' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group guest-fields__form-group guest-fields__form-group--adults' },
                        _react2.default.createElement(_reactQuantity2.default, {
                            increaseLabel: adultsIncreaseLabel,
                            decreaseLabel: adultsDecreaseLabel,
                            id: 'adult-quantity-selector',
                            'data-wdio': 'guest-fields-adult-quantity-selector',
                            min: adultsMin,
                            max: adultsMax,
                            value: adultsCount,
                            onIncrement: this.handleAdultsUpdate,
                            onDecrement: this.handleAdultsUpdate,
                            label: adultsLabel,
                            disableInput: true
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group guest-fields__form-group guest-fields__form-group--children' },
                        _react2.default.createElement(_reactQuantity2.default, {
                            increaseLabel: childrenIncreaseLabel,
                            decreaseLabel: childrenDecreaseLabel,
                            id: 'children-quantity-selector',
                            'data-wdio': 'guest-fields-children-quantity-selector',
                            value: childrenCount,
                            min: childrenMin,
                            max: childrenMax,
                            onIncrement: this.handleChildrenUpdate,
                            onDecrement: this.handleChildrenUpdate,
                            label: childrenLabel,
                            disableInput: true
                        })
                    ),
                    showpetOption && _react2.default.createElement(
                        'div',
                        { className: 'form-group guest-fields__form-group guest-fields__form-group--pet' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'guest-fields-pet', className: 'guest-fields__label' },
                            petLabel
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'guest-fields__radio-group' },
                            _react2.default.createElement(
                                _reactFormComponents.RadioGroup,
                                { id: 'guest-fields__radio-group--pet', name: 'petIncluded', ariaLabel: 'pet included?', label: 'pet' },
                                _react2.default.createElement(_reactFormComponents.RadioButton, {
                                    className: 'guest-fields__radio-button--no-pet',
                                    id: 'guest-fields-no-pet',
                                    inline: true,
                                    value: false,
                                    label: petNoLabel,
                                    checked: !petIncluded,
                                    onChange: this.handlePetChange,
                                    'data-wdio': 'guest-fields-no-pet-quantity-selector'
                                }),
                                _react2.default.createElement(_reactFormComponents.RadioButton, {
                                    className: 'guest-fields__radio-button--has-pet',
                                    id: 'guest-fields-pet',
                                    value: true,
                                    label: petYesLabel,
                                    inline: true,
                                    checked: petIncluded,
                                    onChange: this.handlePetChange,
                                    'data-wdio': 'guest-fields-pet-quantity-selector'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GuestFields;
}(_react.Component);

GuestFields.propTypes = {
    /** Number of Adults */
    adultsCount: _propTypes2.default.number,
    /** Label for Adults */
    adultsLabel: _propTypes2.default.string,
    /** Label for Increase Adults quantity selector */
    adultsIncreaseLabel: _propTypes2.default.string,
    /** Label for Decrease Adults quantity selector */
    adultsDecreaseLabel: _propTypes2.default.string,
    /** Max Number of Adults */
    adultsMax: _propTypes2.default.number,
    /** Min Number of Adults */
    adultsMin: _propTypes2.default.number,
    /** Number of Children */
    childrenCount: _propTypes2.default.number,
    /** Label for Children */
    childrenLabel: _propTypes2.default.string,
    /** Label for Increase Children quantity selector */
    childrenIncreaseLabel: _propTypes2.default.string,
    /** Label for Decrease Children quantity selector */
    childrenDecreaseLabel: _propTypes2.default.string,
    /** Max Number of Children */
    childrenMax: _propTypes2.default.number,
    /** Min Number of Children */
    childrenMin: _propTypes2.default.number,
    /** pet Checked false by default */
    petIncluded: _propTypes2.default.bool,
    /** Label for pet Yes */
    petLabel: _propTypes2.default.string,
    /** Label for pet Yes */
    petYesLabel: _propTypes2.default.string,
    /** Label for pet No */
    petNoLabel: _propTypes2.default.string,
    /** Show pet Radio Group false by default */
    showpetOption: _propTypes2.default.bool,
    /** Disable inputs edit, true by default */
    disableInput: _propTypes2.default.bool
};
GuestFields.defaultProps = {
    adultsCount: 0,
    childrenCount: 0,
    petIncluded: false,
    showpetOption: false,
    adultsLabel: 'Adult(s)',
    adultsIncreaseLabel: 'Increase Adults',
    adultsDecreaseLabel: 'Decrease Adults',
    adultsMin: 0,
    childrenLabel: 'Children',
    childrenIncreaseLabel: 'Increase Children',
    childrenDecreaseLabel: 'Decrease Children',
    childrenMin: 0,
    petLabel: 'Pets',
    petYesLabel: 'Yes',
    petNoLabel: 'No',
    disableInput: true,

    className: '',
    onChange: function onChange() {} };
exports.default = GuestFields;
//# sourceMappingURL=GuestFields.js.map

/***/ }),

/***/ "c8Kh":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "cHop":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CREATE_TOAST = 'CREATE_TOAST';
var REMOVE_TOAST_BY_ID = 'REMOVE_TOAST_BY_ID';

exports.CREATE_TOAST = CREATE_TOAST;
exports.REMOVE_TOAST_BY_ID = REMOVE_TOAST_BY_ID;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "d0RQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d6Sb":
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),

/***/ "dUKy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT__16 = void 0;
var EDIT__16 = '<svg data-id="SVG_EDIT__16"  width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.9.7l2.4 2.4L11 6.5l-5.2 5.1-3 .6.6-3zM10 2.5L12.6 5m-6.6 9.3h8.8m-13.4 0h2"/></g></svg>';
exports.EDIT__16 = EDIT__16;

/***/ }),

/***/ "dUsL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("2Zwn"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactLifecyclesCompat = __webpack_require__("R8mX");

var _ChildMapping = __webpack_require__("NjwZ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "dqtQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e0/m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toasterState;

var _constants = __webpack_require__("cHop");

function toasterState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _constants.CREATE_TOAST:
            if (!action.props.renderContent) {
                return state;
            }

            action.props.id = Date.now();
            return state.concat({ props: action.props });
        case _constants.REMOVE_TOAST_BY_ID:
            return state.filter(function (el) {
                return el.props.id !== action.payload.id;
            });
        default:
            return state;
    }
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "e4Gq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBKN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PHOTO_ICON = '<svg data-id="SVG_PHOTO_ICON" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-578.000000, -1178.000000)"><g transform="translate(576.000000, 1176.000000)"><g id="Photo" transform="translate(3.000000, 3.000000)"><path d="M0.2501,0.291 L16.2501,0.291 C17.0781,0.291 17.7501,0.962 17.7501,1.791 L17.7501,17.791 L1.7501,17.791 C0.9221,17.791 0.2501,17.119 0.2501,16.291 L0.2501,3.379" id="Stroke-174"></path><polyline id="Stroke-175" points="0.2501 15.3984 5.2561 10.3924 12.6531 17.7914"></polyline><polyline id="Stroke-176" points="9.6729 11.2314 14.1089 6.7954 17.7499 10.4364"></polyline><path d="M5.3966,5.4375 C5.3966,4.3005 6.3186,3.3785 7.4566,3.3785 C8.5926,3.3785 9.5146,4.3005 9.5146,5.4375 C9.5146,6.5745 8.5926,7.4965 7.4566,7.4965 C6.3186,7.4965 5.3966,6.5745 5.3966,5.4375 Z" id="Stroke-177" ></path></g></g></g></g></svg>';

exports.PHOTO_ICON = PHOTO_ICON;
exports.default = PHOTO_ICON;
//# sourceMappingURL=PHOTO_ICON.js.map

/***/ }),

/***/ "eFps":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("+gg+");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "eNOg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eS3o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Constructs a localization data object by parsing either a moniker or BCP-47
 * language tag. The constructed object will be composed of the following
 * properties:
 *      data: Original passed in value.
 *      brand: Brand variant (eg. HA, VRBO).
 *      code: BCP-47 style language tag (ie. no brand variant).
 *      language: The language of the locale (ie. en). ISO 639.
 *      region: The country code (ie. US). ISO 3166-1.
 * @param {string} locale - A moniker or BCP-47 language code.
 */
function LanguageTag() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';

  locale = locale.trim();
  var tags = locale.split(/_|-/);

  this.data = locale;
  this.language = tags[0] && tags[0].length === 2 ? tags[0] : 'en';
  this.region = tags.length > 1 && tags[1] && tags[1].length === 2 ? tags[1] : null;
  this.brand = tags.length > 2 && tags[2] ? tags[2] : null;
  this.code = this.region ? this.language + '-' + this.region : this.language;
}

module.exports = LanguageTag;
//# sourceMappingURL=LanguageTag.js.map

/***/ }),

/***/ "eXOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_d3276433b58c8a2853f4
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/classnames/index.js from dll-reference vendor_d3276433b58c8a2853f4
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("HW6M");
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-destination-typeahead/node_modules/store/store.js
var store = __webpack_require__("Ahf/");
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/functions/edap.js
var _getEdap = function _getEdap() {
  return window.edap || [];
};

var triggerEdapEvent = function triggerEdapEvent(eventName, eventData) {
  window.edap = _getEdap();
  window.edap.push(function (edap) {
    edap.trigger(eventName, eventData);
  });
};

function emitFocusEvent(prefilledValue) {
  triggerEdapEvent('typeahead.focus', {
    prefilledvalue: prefilledValue
  });
}
function emitStartEvent(prefilledValue) {
  triggerEdapEvent('typeahead.start', {
    prefilledvalue: prefilledValue
  });
}
/**
 * emitGE()
 * options {mixed} - edap parameters for events
 */

function emitGE(_ref) {
  var eventaction = _ref.eventaction,
      _ref$eventlabel = _ref.eventlabel,
      eventlabel = _ref$eventlabel === void 0 ? '' : _ref$eventlabel,
      _ref$eventvalue = _ref.eventvalue,
      eventvalue = _ref$eventvalue === void 0 ? '' : _ref$eventvalue;
  triggerEdapEvent('generic.event', {
    eventcategory: 'typeahead',
    eventaction: eventaction,
    eventlabel: eventlabel,
    eventvalue: eventvalue
  });
}
/**
 * emitSE()
 * Emits selection event for typeahead
 **/

function emitSE(selectionData) {
  var eventName = 'typeahead.selection';
  triggerEdapEvent(eventName, selectionData);
}
//# sourceMappingURL=edap.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/functions/string.js
// i18n transliterations
var TRANSLITERATOR_TABLE = {
  standard: {
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    Æ: 'AE',
    Č: 'C',
    Ç: 'C',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ï: 'I',
    Ð: '?',
    Ñ: 'N',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Õ: 'O',
    Ö: 'O',
    Ø: 'O',
    Š: 'S',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    Ý: 'Y',
    Þ: '?',
    ß: 'ss',
    à: 'a',
    á: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    å: 'a',
    ā: 'a',
    æ: 'ae',
    č: 'c',
    ç: 'c',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    ì: 'i',
    í: 'i',
    î: 'i',
    ï: 'i',
    ī: 'i',
    ð: '?',
    ñ: 'n',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ø: 'o',
    š: 's',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ü: 'u',
    ý: 'y',
    þ: '?',
    ÿ: 'y'
  },
  da: {
    Ø: 'O'
  },
  de: {
    ä: 'ae',
    ö: 'oe',
    ü: 'ue',
    Ä: 'Ae',
    Ö: 'Oe',
    Ü: 'Ue',
    ß: 'ss'
  },
  fi: {
    Î: 'OE',
    Ü: 'Y',
    ü: 'y',
    Ũ: 'Y',
    ũ: 'y',
    Đ: 'D',
    đ: 'd',
    þ: 'TH',
    Þ: 'th',
    Š: 'SH',
    š: 'sh',
    Ž: 'ZH',
    ž: 'zh'
  }
};
/**
 * transliterate()
 * @param {*} string
 * @param {*} lang
 */

function transliterate(string, lang) {
  var transliteratedString = '';

  for (var i = 0; i < string.length; i++) {
    var stringChar = string.charAt(i);
    var lookup = TRANSLITERATOR_TABLE[lang] || {};
    transliteratedString += lookup[stringChar] || TRANSLITERATOR_TABLE.standard[stringChar] || stringChar;
  }

  return transliteratedString;
}
/**
 * normalize()
 * Helper function to create normalized search tokens
 * @param {*} string
 * @param {*} lang
 */

function normalize(string, lang) {
  return transliterate(string, lang).replace(/(-|,)/g, ' ').replace(/[^0-9a-zA-Z\s]+/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
}
//# sourceMappingURL=string.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/functions/recent.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable complexity */


 // Flag for ensuring only 1 exposure event is raised

var observedRecents = false;
var getRecentSearchesSortedHashMap = {}; // Perf Hash Map

var RECENT_SEARCHES_LOCAL_STORAGE_KEY = 'react-destination-typeahead-recent-searches';
var RECENT_SEARCHES_SESSION_EXPOSURE_KEY = 'react-destination-typeahead-session-exposure';
var MAX_LOCALSTORAGE_ITEMS = 100;
var MAX_LOCALSTORAGE_EXPIRY = parseInt(Date.now(), 10) - 86400 * 28 * 1000; // 28 days

/**
 * resetHashMap()
 * Clears perf optimized hash map
 */

function resetHashMap() {
  getRecentSearchesSortedHashMap = {};
}
/**
 * filterObject
 * Helper function to filter JS objects
 * @param {*} obj
 * @param {*} predicate
 */

function filterObject(obj, predicate) {
  var result = {};
  var key = null;

  for (key in obj) {
    if (obj.hasOwnProperty(key) && !predicate(key, obj[key])) {
      result[key] = obj[key];
    }
  }

  return result;
}
/**
 * getRecentSearches()
 * Get recent searches from local storage
 */

function getRecentSearches(recentSearchesLimit) {
  var recentSearches = store_default.a.enabled && store_default.a.get(RECENT_SEARCHES_LOCAL_STORAGE_KEY);

  if (recentSearches && recentSearches.length > 0) {
    if (recentSearchesLimit) {
      return recentSearches.slice(0, recentSearchesLimit);
    }

    return recentSearches;
  }

  return [];
}
/**
 * setRecentSearches()
 * Update recent search local storage
 * @param {*} data
 */

function setRecentSearches(data) {
  return store_default.a.enabled && store_default.a.set(RECENT_SEARCHES_LOCAL_STORAGE_KEY, data);
}
/**
 * pruneLocalStorage()
 * Cleans up localstorage items related to typeahead
 */

function pruneLocalStorage() {
  var items = getRecentSearches();
  var itemsPruned = 0;
  var i = 0;
  var item = null; // remove expired entries first.
  // iterate in reverse so we can safely remove items

  for (i = items.length - 1; i > -1; i--) {
    item = items[i];

    if (item.expireTime < MAX_LOCALSTORAGE_EXPIRY) {
      items.splice(i, 1);
      itemsPruned++;
    }
  } // if still exceeds max, sort and cut off oldest to maximum


  if (items.length > MAX_LOCALSTORAGE_ITEMS) {
    // perform sort
    items = items.sort(function (a, b) {
      if (a.expireTime > b.expireTime) {
        return -1;
      }

      if (a.expireTime < b.expireTime) {
        return 1;
      }

      return 0;
    });

    for (i = items.length - 1; i > -1 + MAX_LOCALSTORAGE_ITEMS; i--) {
      items.splice(i, 1);
      itemsPruned++;
    }
  }

  if (itemsPruned > 0) {
    setRecentSearches(items);
  }

  return itemsPruned;
}
/**
 * newRecentSearchMatch()
 * Function to augment search matches with a "score"
 * @param {*} query - the current user search query that is entered into the search box
 * @param {*} lang - the language so transliterate can properly tokenize
 * @param {*} recentSearch - the search result
 */

function newRecentSearchMatch(query, lang, recentSearch) {
  var normalizedQ = normalize(query, lang);
  var normalizedTerm = normalize(recentSearch.selectedDestination.term);
  var normalizedQTokens = normalizedQ.split(' ');
  var score = null; // Look for strict prefix matches first

  if (normalizedTerm.indexOf(normalizedQ) === 0) {
    score = 0;
  } else {
    score = 1;

    for (var i = 0; i < normalizedQTokens.length && score !== null; i++) {
      var normalizedQToken = normalizedQTokens[i];
      var regex = new RegExp("\\b" + normalizedQToken);

      if (!regex.test(normalizedTerm)) {
        score = null;
      }
    }
  }

  return {
    recentSearch: recentSearch,
    score: score
  };
}
/**
 * addRecentSearch()
 * @param {obj} state - Add a recent search to local storage}
 */

function addRecentSearch(selectedDestination) {
  var selectedDestinationFiltered = filterObject(selectedDestination, function (key) {
    return key === 'highlightedTerm';
  }); // Create persistence object intended for user local storage

  var data = {
    selectedDestination: selectedDestinationFiltered
  }; // Do a search for currently stored recents

  var currentData = getRecentSearches(); // Filter out old instance of recent term and limit storage to 100 items

  currentData = currentData.map(function (recentSearch) {
    // Filter bad data or uuid match
    if (!recentSearch || !recentSearch.selectedDestination || recentSearch.selectedDestination.uuid === selectedDestinationFiltered.uuid) {
      return false;
    }

    return recentSearch;
  }).filter(function (i) {
    return i;
  }).slice(0, MAX_LOCALSTORAGE_ITEMS); // Add expireTime property

  data.expireTime = new Date().getTime() + MAX_LOCALSTORAGE_EXPIRY; // add 4 week TTL
  // Add new search to collection

  currentData.unshift(data); // Update local storage

  setRecentSearches(currentData);
}
/**
 * getRecentSearchesSorted()
 * Get recent searches + client side computation
 */

function getRecentSearchesSorted(locale, search, max) {
  if (getRecentSearchesSortedHashMap[search]) {
    return getRecentSearchesSortedHashMap[search];
  } // If locale is something other than 'en', pass it into getRecentSearches for client-side lookup optimization


  var lang = locale !== 'en' ? locale : null;
  var query = search || '';
  var recentSearchesLimit = max || 3;
  var recentSearches = getRecentSearches(); // TODO: optimize access to this / cache

  var bestRecentSearches = [];
  var recentSearchMatches = [];

  for (var i = 0; i < recentSearches.length; i++) {
    var recentSearch = recentSearches[i]; // if valid data model

    if (recentSearch.selectedDestination && recentSearch.selectedDestination.term && recentSearch.selectedDestination.uuid) {
      var recentSearchMatch = newRecentSearchMatch(query, lang, recentSearch);

      if (recentSearchMatch.score !== null) {
        recentSearchMatches.push(recentSearchMatch);
      }
    }
  }

  recentSearchMatches.sort(function (a, b) {
    return a.score - b.score;
  }); // Pick the first set of searches (recentSearchesLimit)

  for (var _i = 0; _i < Math.min(recentSearchesLimit, recentSearchMatches.length); _i++) {
    bestRecentSearches.push(recentSearchMatches[_i].recentSearch);
  } // Segment


  if (bestRecentSearches.length > 0 && !observedRecents) {
    observedRecents = true;
    emitGE({
      eventaction: 'exposure.recentsearches'
    });
  } // Map to regular results


  bestRecentSearches = bestRecentSearches.map(function (recent) {
    return _extends({
      recentlyviewed: true
    }, recent.selectedDestination);
  }); // Store in hash for perf

  getRecentSearchesSortedHashMap[search] = bestRecentSearches;
  return bestRecentSearches;
}
//# sourceMappingURL=recent.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/enum.js
// UISTATES - enumeration of possible uistates with coorelating CSS classes for values
var UISTATES = {
  SELECT_DESTINATION: 'open-select-destination',
  CLOSED: 'closed'
}; // KEYCODES - browser keycodes

var KEYCODES = {
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  SPACE: 32,
  TAB: 9,
  ESCAPE: 27
};
//# sourceMappingURL=enum.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/functions/keyboard.js


function getPreviousIndexes(results, destinationIndex) {
  if (destinationIndex > 0) {
    var previousDestinationIndex = destinationIndex - 1;
    var previousResult = results[previousDestinationIndex];
    var prevDestinationSubDestinations = previousResult.subSuggestions;

    if (prevDestinationSubDestinations && !previousResult.recentlyviewed) {
      return {
        selectDestinationIndex: previousDestinationIndex,
        selectDestinationSubIndex: prevDestinationSubDestinations.length - 1
      };
    }

    return {
      selectDestinationIndex: previousDestinationIndex,
      selectDestinationSubIndex: -1
    };
  }

  var lastDestinationIndex = results.length - 1;
  var lastDestinationSubDestinations = results[lastDestinationIndex].subSuggestions;

  if (lastDestinationSubDestinations) {
    return {
      selectDestinationIndex: lastDestinationIndex,
      selectDestinationSubIndex: lastDestinationSubDestinations.length - 1
    };
  }

  return {
    selectDestinationIndex: lastDestinationIndex,
    selectDestinationSubIndex: -1
  };
}

function getNextIndexes(results, destinationIndex) {
  if (destinationIndex < results.length - 1) {
    return {
      selectDestinationIndex: destinationIndex + 1,
      selectDestinationSubIndex: -1
    };
  }

  return {
    selectDestinationIndex: 0,
    selectDestinationSubIndex: -1
  };
}
/**
 * keypress()
 * Process keypress event
 * @param {*} state
 * @param {*} ev
 */


function keypress(state, ev) {
  if (state === void 0) {
    state = {};
  }

  if (ev === void 0) {
    ev = {};
  }

  var _state = state,
      uistate = _state.uistate,
      selectDestinationIndex = _state.selectDestinationIndex,
      selectDestinationSubIndex = _state.selectDestinationSubIndex,
      results = _state.results;
  var _ev = ev,
      keyCode = _ev.keyCode; // 'escape'

  if (keyCode === KEYCODES.ESCAPE) {
    return {
      uistate: UISTATES.CLOSED
    };
  } // 'tab'


  if (keyCode === KEYCODES.TAB && ev.target.className.indexOf('search-destination-input__close') !== -1) {
    if (uistate === UISTATES.SELECT_DESTINATION) {
      return true;
    }
  } // 'enter' or 'tab' from clear results


  if (keyCode === KEYCODES.ENTER) {
    ev.preventDefault();
    ev.stopPropagation();

    if (uistate === UISTATES.SELECT_DESTINATION) {
      return true;
    }
  } // 'up'


  if (keyCode === KEYCODES.UP) {
    ev.preventDefault();
    ev.stopPropagation();

    if (uistate === UISTATES.SELECT_DESTINATION) {
      if (selectDestinationSubIndex >= 0) {
        return {
          selectDestinationSubIndex: selectDestinationSubIndex - 1
        };
      }

      return getPreviousIndexes(results, selectDestinationIndex);
    }
  } // 'down'


  if (keyCode === KEYCODES.DOWN) {
    ev.preventDefault();
    ev.stopPropagation();

    if (uistate === UISTATES.CLOSED) {
      return {
        uistate: UISTATES.SELECT_DESTINATION
      };
    }

    if (uistate === UISTATES.SELECT_DESTINATION) {
      if (selectDestinationIndex === -1) {
        return {
          selectDestinationIndex: 0
        };
      }

      var currentResult = results[selectDestinationIndex];
      var currentSubDestinations = currentResult.subSuggestions;

      if (!currentResult.recentlyviewed && currentSubDestinations && currentSubDestinations.length - 1 > selectDestinationSubIndex) {
        return {
          selectDestinationSubIndex: selectDestinationSubIndex + 1
        };
      }

      return getNextIndexes(results, selectDestinationIndex);
    }
  } // 'right'


  if (keyCode === KEYCODES.RIGHT) {
    if (uistate === UISTATES.SELECT_DESTINATION) {
      if (ev.target && ev.target.value && ev.target.value.length === ev.target.selectionStart) {
        return true;
      }
    }
  }

  return false;
}
//# sourceMappingURL=keyboard.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/functions/searchinput.js
function searchinput__extends() { searchinput__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return searchinput__extends.apply(this, arguments); }


/**
 * getHintSuggestion()
 * Returns `term` if it contains `search` (case insensitive).  `term` is returned in the same casing as `search`
 * @param {string} search
 * @param {string} term
 */

function getHintSuggestion(search, term) {
  if (!search || !term) {
    return '';
  }

  var fullMatch = true;
  var hintSuggestion = '';
  var i = 0;

  for (i = 0; i < search.length; i++) {
    var searchChar = search[i];
    var termChar = term[i];

    if (searchChar && termChar && searchChar.toLowerCase() !== termChar.toLowerCase()) {
      fullMatch = false;
      break;
    } else {
      hintSuggestion += searchChar;
    }
  }

  if (fullMatch !== false) {
    hintSuggestion += term.substr(search.length);
  } else {
    hintSuggestion = '';
  }

  return hintSuggestion;
}
/**
 * focusSearchInput()
 * Maintain focus on searchinput when in select destination state
 * @param {*} state
 */

function focusSearchInput(state) {
  if (state.uistate !== UISTATES.SELECT_DESTINATION) {
    return {
      uistate: UISTATES.SELECT_DESTINATION
    };
  }

  return false;
}
/**
 * highlightResults()
 * Enhance returned results with computed highlights
 * TODO: optimize o(n^2) algorithm
 */

function highlightResults(search, results) {
  var index = 0;
  var dupeDict = {}; // do not compute dupes

  var computedResults = [];
  var computedResult = null;

  for (var i = 0; i < results.length; i++) {
    var result = results[i];
    var previouslyComputedResult = dupeDict[result.uuid];

    if (previouslyComputedResult) {
      // Continue in loop and do not re-compute highlight
      continue;
    } else {
      computedResult = searchinput__extends({
        highlightedTerm: []
      }, result);
      dupeDict[result.uuid] = computedResult;
    }

    var placeFullname = computedResult.term;
    index = 0;

    for (var j = 0; j < placeFullname.length; j++) {
      var highlighted = index < search.length && placeFullname[j].toLowerCase() === search[index].toLowerCase();

      if (highlighted) {
        index++;
      }

      computedResult.highlightedTerm[j] = {
        value: placeFullname[j],
        highlighted: highlighted
      };
    }

    computedResults.push(computedResult);
  }

  return computedResults;
}
/**
 * isValidPropertyId()
 * Returns boolean to indicate if it's a valid property id
 * Valid property ids:
 * p1078525vb 1078525vb 1078525 ...
 * more suffixes you can find here:
 * https://github.homeawaycorp.com/hacommons/global-config-service/blob/master/data/src/main/resources/global-config/common/data-stores.json
 * @param {string} search
 */

function isValidPropertyId(search) {
  return search.match(/^p?(\d+)(ha|vb|tr|a|d|o|r|h|)$/) !== null;
}
//# sourceMappingURL=searchinput.js.map
// EXTERNAL MODULE: ./node_modules/fetch-jsonp/build/fetch-jsonp.js
var fetch_jsonp = __webpack_require__("PKY1");
var fetch_jsonp_default = /*#__PURE__*/__webpack_require__.n(fetch_jsonp);

// EXTERNAL MODULE: ./node_modules/lru-cache/index.js
var lru_cache = __webpack_require__("GvH4");
var lru_cache_default = /*#__PURE__*/__webpack_require__.n(lru_cache);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/store.js
function store__extends() { store__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return store__extends.apply(this, arguments); }





var cache = lru_cache_default()(100); // maximum of 100 entries into cache

function getRandomNumber() {
  return Math.floor(Math.random() * 10000000000);
}

var store_TypeaheadStore =
/*#__PURE__*/
function () {
  /**
   * init()
   * Initialize the store
   */
  function TypeaheadStore(config) {
    this.config = {};
    this._getResultsIndex = 0;
    this._pendingResultsHashMap = {};
    this.config = config;
  }
  /**
   * getConfig()
   * Get configuration
   * @param {*} path
   */


  var _proto = TypeaheadStore.prototype;

  _proto.getConfig = function getConfig(path) {
    return this.config.getMergedState(path);
  }
  /**
   * writeToCache()
   * Interface between this class and writing to cache structure
   * @param {*} key
   * @param {*} data
   */
  ;

  _proto.writeToCache = function writeToCache(key, data) {
    return cache.set(key.toLowerCase(), data);
  }
  /**
   * readFromCache()
   * Interface between this class and reading from cache structure
   * @param {*} key
   */
  ;

  _proto.readFromCache = function readFromCache(key) {
    return cache.get(key.toLowerCase());
  }
  /**
   * _mapGoogleModel()
   * Convert the model, received from Google into client-side model
   * @param {*} model
   */
  ;

  _proto._mapGoogleModel = function _mapGoogleModel(model) {
    return {
      google: model,
      uuid: model.place_id,
      term: model.description,
      type: model.types[0],
      poweredByGoogle: true
    };
  }
  /**
   * _mapGoogleModel()
   * Convert the model, received from API into client-side model
   * @param {*} model
   */
  ;

  _proto._mapModel = function _mapModel(model) {
    if (model.place) {
      return store__extends({
        uuid: model.place.uuid,
        term: model.place.fullName || model.place.name && model.place.name.full,
        type: model.place.types && model.place.types.length && model.place.types[0]
      }, model.subSuggestions ? {
        subSuggestions: model.subSuggestions
      } : {}, model.matchType ? {
        matchType: model.matchType
      } : {});
    }

    return model;
  }
  /**
   * convertToUIModel
   * Converts supplied data to uniform UI model that consuming apps depend on via `onUpdate()` interface
   * Removal or Changes to existing top level data properties should be MAJOR breaking changes
   * Additions to top level data properties should be MINOR / PATCH changes
   * @param {*} suggestions
   * @param apiResultsFrom
   * @param searchInput
   * @param resultsUuid
   */
  ;

  _proto.convertToUIModel = function convertToUIModel(suggestions, apiResultsFrom, searchInput, resultsUuid) {
    var _this = this;

    suggestions = suggestions.map(function (suggestion) {
      if (apiResultsFrom === 'GOOGLE') {
        return _this._mapGoogleModel(suggestion);
      }

      return _this._mapModel(suggestion);
    }); // Get Recent searches

    var recents = getRecentSearchesSorted(this.getConfig('locale'), searchInput, this.getConfig('recentSearchesDisplayMax'));
    var results = recents.concat(suggestions); // Process Highlighting

    var resultsWithHighlights = highlightResults(searchInput, results);
    return {
      results: results,
      resultsWithHighlights: resultsWithHighlights,
      poweredByGoogle: apiResultsFrom === 'GOOGLE',
      resultsUuid: resultsUuid || null
    };
  }
  /**
   * stringifyQuery()
   * Dependency free query param encoding.  Light-weight alternative to packages like `qs` and `query-string`.
   * Fetch does not support query param encoding as there is no universally accepted standard (yet)
   * See https://github.com/github/fetch/issues/256
   * @param {*} params
   */
  ;

  _proto.stringifyQuery = function stringifyQuery(params) {
    var esc = encodeURIComponent;
    var query = Object.keys(params).map(function (k) {
      return esc(k) + "=" + esc(params[k]);
    }).join('&');
    return query;
  }
  /**
   * convertLocaleFormat()
   * Convert locale to 'languageCode_countryCode' format
   */
  ;

  _proto.convertLocaleFormat = function convertLocaleFormat(locale) {
    return locale.replace('-', '_').substr(0, 5);
  }
  /**
   * Helper function to ensure registered API routes have consistent slashes
   * @param {*} input
   */
  ;

  _proto.ensureStartsAndEndsWithSlash = function ensureStartsAndEndsWithSlash(input) {
    return input.replace(/^(\/)?([^\/]*)(\/)?$/, '/$2/').replace('//', '/');
  }
  /**
   * getGoogleSuggestions()
   * Get suggestion results from Google
   * @param {*} input
   */
  ;

  _proto.getGoogleSuggestions = function getGoogleSuggestions(input) {
    var prefix = this.ensureStartsAndEndsWithSlash(this.getConfig('appPrefix'));
    var googlePlaceSuggestionsUrl = prefix + "getGooglePlaceSuggestions";
    var language = this.getConfig('locale');
    var types = 'geocode';
    var query = this.stringifyQuery({
      input: input,
      language: language,
      types: types
    });
    var requestUrl = googlePlaceSuggestionsUrl + "?" + query;
    return window.fetch(requestUrl).then(function (response) {
      return response.json();
    }).then(function (data) {
      return data;
    });
  }
  /**
   * buildRemoteParams()
   * @param {*} searchInput
   */
  ;

  _proto.buildRemoteParams = function buildRemoteParams(searchInput) {
    var limit = this.getConfig('isMobile') ? this.getConfig('popoverMaxDisplayCountMobile') : this.getConfig('popoverMaxDisplayCount');
    return {
      site: this.getConfig('site'),
      size: limit,
      input: searchInput,
      locale: this.convertLocaleFormat(this.getConfig('locale')),
      _: getRandomNumber(),
      _restfully: true
    };
  }
  /**
   * _isApiV2()
   * Check if we should use v2 API
   * @param {*} filterType
   */
  ;

  _proto._isApiV2 = function _isApiV2(filterType) {
    if (filterType) {
      return filterType >= 1 && filterType <= 3;
    }

    return false;
  };

  _proto._fetchResults = function _fetchResults(_ref) {
    var _this2 = this;

    var url = _ref.url,
        searchInput = _ref.searchInput,
        getResultsIndex = _ref.getResultsIndex,
        callback = _ref.callback;
    return fetch_jsonp_default()(url).then(function (response) {
      return response.json();
    }).then(function (jsonData) {
      // If we have zero results and it's not a valid property id, fallback to Google)
      if (jsonData.suggestions.length === 0 && !isValidPropertyId(searchInput)) {
        return _this2.getGoogleSuggestions(searchInput).then(function (googleJsonData) {
          var results = googleJsonData.predictions; // Convert google results to uniform data results

          var suggestions = _this2.convertToUIModel(results, 'GOOGLE', searchInput); // Write to cache


          _this2.writeToCache(searchInput, suggestions); // If this is latest request, invoke callback


          if (getResultsIndex === _this2._getResultsIndex) {
            callback(suggestions);
          }

          return suggestions;
        });
      } // Convert results to uniform data results


      var suggestions = _this2.convertToUIModel(jsonData.suggestions, 'HOMEAWAY', searchInput, jsonData.uuid); // Write To Cache


      _this2.writeToCache(searchInput, suggestions); // If this is latest request, invoke callback


      if (getResultsIndex === _this2._getResultsIndex) {
        return callback(suggestions);
      }

      return suggestions;
    }).catch(function (ex) {
      // eslint-disable-next-line
      console.error('Exception occurred while requesting typeahead results:', ex);
      delete _this2._pendingResultsHashMap[searchInput];
    });
  }
  /**
   * getResults()
   * Implements Bloodhound to optimize data retrival of search results either from cache or AJAX request
   * Uses local LRU Cache for data + highlight results
   * Uses "_getResultsIndex" and "_pendingResultsHashMap" to optimize rendering performance for last requested suggestisons.
   */
  ;

  _proto.getResults = function getResults(searchInput, filterType, callback) {
    var _this3 = this;

    if (searchInput === false) {
      return this._getResultsIndex++;
    } // Truncate trailing spaces to optimize queries
    // IE Typing in ("Bora ") should re-use cached results from ("Bora")


    searchInput = searchInput.replace(/^(.*?)\s*$/, '$1');

    var isApiV2 = this._isApiV2(filterType); // Count unique resource request


    var getResultsIndex = ++this._getResultsIndex;
    var remoteParams = this.buildRemoteParams(searchInput);
    var remoteQueryString = "?" + this.stringifyQuery(remoteParams);
    var remotePath = this.getConfig('remotePath'); // NOTE: when V1 path is deprecated, we will no longer need this side effect

    if (isApiV2) {
      remotePath = remotePath.replace('v1', 'v2');
    }

    var url = "" + this.getConfig('baseUrl') + remotePath + remoteQueryString; // Check if we already have result in cache

    if (this.readFromCache(searchInput)) {
      return callback(this.readFromCache(searchInput));
    } else if (this._pendingResultsHashMap[searchInput]) {
      return this._pendingResultsHashMap[searchInput].then(function (suggestions) {
        if (getResultsIndex === _this3._getResultsIndex) {
          return callback(suggestions);
        }

        return false;
      });
    }

    this._pendingResultsHashMap[searchInput] = this._fetchResults({
      url: url,
      searchInput: searchInput,
      getResultsIndex: getResultsIndex,
      callback: callback
    });
    return this._pendingResultsHashMap[searchInput];
  };

  return TypeaheadStore;
}();
//# sourceMappingURL=store.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/transpiled/index.js
var transpiled = __webpack_require__("Ye17");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js + 226 modules
var esm = __webpack_require__("QnUD");

// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/functions/suggestiondetails.js

var resultTypes = [{
  typesAssigned: ['locality'],
  label: 'typecity',
  icon: esm["CITY__16"]
}, {
  typesAssigned: ['train_station'],
  label: 'typetrainstation',
  icon: esm["TRAIN__16"]
}, {
  typesAssigned: ['metro_station'],
  label: 'typemetrostation',
  icon: esm["TRAIN__16"]
}, {
  typesAssigned: ['continent', 'country', 'administrative_division_level_1', 'administrative_division_level_2', 'administrative_division_level_3', 'administrative_division_level_4', 'administrative_division_level_5', 'touristic_region', 'natural_feature', 'postal_code', 'natural_feature', 'beach', 'island', 'ski_area'],
  label: 'typeregion',
  icon: esm["MAP__16"]
}, {
  typesAssigned: ['neighborhood', 'sublocality_level_1', 'sublocality_level_2', 'sublocality_level_3', 'sublocality_level_4', 'sublocality_level_5', 'neighborhood'],
  label: 'typeneighborhood',
  icon: esm["MAP__16"]
}, {
  typesAssigned: ['point_of_interest', 'poi', 'premise', 'premises', 'event', 'establishment', 'museum', 'park', 'restaurant', 'transportation'],
  label: 'typelandmark',
  icon: esm["LOCATION__16"]
}, {
  typesAssigned: ['airport'],
  label: 'typeairport',
  icon: esm["PLANE__16"]
}];
function getSuggestionDetails(type) {
  var details = [];

  if (type) {
    type = type.toLowerCase();
    details = resultTypes.filter(function (resultData) {
      return resultData.typesAssigned.indexOf(type) >= 0;
    });
  }

  return {
    label: details[0] ? details[0].label : 'typeregion',
    icon: details[0] ? details[0].icon : esm["LOCATION__16"]
  };
}
//# sourceMappingURL=suggestiondetails.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/components/resultrow.js
function resultrow__extends() { resultrow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return resultrow__extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var delayIncrCount = 40;
var resultrow_ResultRow =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ResultRow, _Component);

  function ResultRow() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.skipFilters = function (suggestion) {
      return _this.props.skipFilters || suggestion.recentlyviewed || !suggestion.subSuggestions;
    };

    _this.displayTerm = function (result, subResult) {
      var _this$props = _this.props,
          showResultLabels = _this$props.showResultLabels,
          showResultIcons = _this$props.showResultIcons,
          messages = _this$props.messages,
          poweredByGoogle = _this$props.poweredByGoogle,
          truncateResultTerms = _this$props.truncateResultTerms;
      var titleDOM = [];
      var iconDOM = [];
      var dom = [];
      var highlightedTerm = result.highlightedTerm;
      var reactKey = "searchresults-" + result.uuid + "-span";
      var suggestionsDetails = getSuggestionDetails(result.type);

      if (showResultIcons) {
        iconDOM.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(transpiled["SVGIcon"], {
          key: "result__icon-" + result.uuid,
          markup: suggestionsDetails.icon,
          className: "result__icon"
        }));
      }

      for (var i = 0; i < highlightedTerm.length; i++) {
        if (highlightedTerm[i].highlighted === true) {
          titleDOM.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
            className: "highlighted result__char",
            key: reactKey + "-" + i
          }, highlightedTerm[i].value));
        } else {
          titleDOM.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
            key: reactKey + "-" + i,
            className: "result__char"
          }, highlightedTerm[i].value));
        }
      }

      titleDOM.push('');

      if (subResult && subResult.filter && subResult.filter.name) {
        dom.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
          className: "result__mark result__name-inline",
          key: "result-inline-filter-" + result.uuid
        }, subResult.filter.name));
      }

      if (result.recentlyviewed) {
        dom.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
          className: "recentlyviewed micro",
          key: reactKey + "-recentlyviewed"
        }, messages.recentlyviewed));
      } // show type labels for destinations except Google failover destinations


      if (suggestionsDetails.label && showResultLabels && (!poweredByGoogle || result.recentlyviewed)) {
        dom.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
          key: "result__label-" + result.uuid,
          className: "result__label hidden-xs small"
        }, messages[suggestionsDetails.label]));
      }

      var resultCharsClassName = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('result__chars', {
        'result__chars--truncate-term': truncateResultTerms
      }); // return dom;

      return [].concat(iconDOM, [reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
        className: resultCharsClassName,
        key: "result-chars-" + reactKey
      }, titleDOM)], dom);
    };

    _this.renderResultRow = function (attributes, selected, style, title) {
      return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", resultrow__extends({
        tabIndex: "-1"
      }, attributes), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        className: "result__bg bg-brand"
      }), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        role: "option",
        "aria-selected": selected,
        tabIndex: "-1",
        className: "result__content",
        style: style
      }, title));
    };

    _this.renderSubSuggestions = function (result, suggestionIndex, attributes, classNames, style) {
      var _this$props2 = _this.props,
          filterType = _this$props2.filterType,
          selectDestinationSubIndex = _this$props2.selectDestinationSubIndex,
          showResultIcons = _this$props2.showResultIcons,
          inputHasIcon = _this$props2.inputHasIcon;
      return result.subSuggestions.map(function (subSuggestion, index) {
        var _extends2;

        var filterTitleDOM = null;
        var selected = index === selectDestinationSubIndex;

        var subSuggestionAttributes = resultrow__extends({}, attributes, (_extends2 = {}, _extends2['className'] = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
          selected: selected
        }, classNames), _extends2['data-sub-suggestion-key'] = index, _extends2['key'] = "searchresults-div-" + suggestionIndex + "-" + index + "-sub-result", _extends2));

        if (filterType === 2) {
          // inline mark with result
          subSuggestionAttributes.className = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()(subSuggestionAttributes.className, _this.getResultClassesForIcons({
            showResultIcons: showResultIcons,
            inputHasIcon: inputHasIcon
          }));
          filterTitleDOM = _this.displayTerm(result, subSuggestion);
        } else {
          // below with arrow or mark
          subSuggestionAttributes.className = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()(subSuggestionAttributes.className, _this.getResultClassesForIcons({
            showResultIcons: showResultIcons,
            inputHasIcon: inputHasIcon,
            subResult: true
          }));
          filterTitleDOM = _this.getFilterTitle(subSuggestion);
        }

        if (!filterTitleDOM) {
          return null;
        }

        return _this.renderResultRow(subSuggestionAttributes, selected, style, filterTitleDOM);
      });
    };

    _this.getFilterTitle = function (subSuggestion) {
      var _this$props3 = _this.props,
          filterType = _this$props3.filterType,
          showResultIcons = _this$props3.showResultIcons;
      var filterName = subSuggestion.filter && subSuggestion.filter.name;

      if (!filterName) {
        return null;
      }

      return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment, null, filterType === 1 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
        className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('result__name', 'result__mark', {
          'result__name-intended': !showResultIcons,
          'result__name-intended-icon': showResultIcons
        })
      }, filterName), filterType === 3 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment, null, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
        className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
          'SVGIcon--arrow': !showResultIcons,
          'SVGIcon--arrow-icon': showResultIcons
        })
      }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(transpiled["SVGIcon"], {
        id: "ARROW_DOWN_RIGHT__16"
      })), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
        className: "result__name"
      }, filterName)));
    };

    return _this;
  }

  var _proto = ResultRow.prototype;

  _proto.getResultClassesForIcons = function getResultClassesForIcons(_ref) {
    var _classnames;

    var showResultIcons = _ref.showResultIcons,
        inputHasIcon = _ref.inputHasIcon,
        subResult = _ref.subResult;
    var suffix = subResult ? '-is-sub-result' : '';
    return classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()((_classnames = {}, _classnames["result--has-icon-no-input-icon" + suffix] = showResultIcons && !inputHasIcon, _classnames["result--has-icon-has-input-icon" + suffix] = showResultIcons && inputHasIcon, _classnames["result--no-icon-has-input-icon" + suffix] = !showResultIcons && inputHasIcon, _classnames["result--no-icon-no-input-icon" + suffix] = !showResultIcons && !inputHasIcon, _classnames));
  };

  _proto.render = function render() {
    var _attributes, _extends3;

    var _this$props4 = this.props,
        index = _this$props4.index,
        hasSelectedIndex = _this$props4.hasSelectedIndex,
        selectDestinationSubIndex = _this$props4.selectDestinationSubIndex,
        isMobile = _this$props4.isMobile,
        last = _this$props4.last,
        result = _this$props4.result,
        selected = _this$props4.selected,
        useAnim = _this$props4.useAnim,
        showResultIcons = _this$props4.showResultIcons,
        inputHasIcon = _this$props4.inputHasIcon;
    var filtersDOM = null;
    var classNames = {
      result: true,
      in: true,
      'has-selected-index': hasSelectedIndex,
      'recent-search__result': result.recentlyviewed,
      last: last,
      mobile: isMobile,
      desktop: !isMobile
    };
    var style = {};

    if (useAnim) {
      style.animationDelay = index * delayIncrCount + "ms";
    }

    var suggestionDOM = this.displayTerm(result);
    var attributes = (_attributes = {}, _attributes['data-suggestion-key'] = index, _attributes['key'] = "searchresults-div-" + index + "-result", _attributes);

    var resultAttributes = resultrow__extends({}, attributes, (_extends3 = {}, _extends3['className'] = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
      selected: selected && selectDestinationSubIndex === -1
    }, classNames, this.getResultClassesForIcons({
      showResultIcons: showResultIcons,
      inputHasIcon: inputHasIcon
    })), _extends3));

    var skipFilters = this.skipFilters(result);

    if (!skipFilters) {
      filtersDOM = this.renderSubSuggestions(result, index, attributes, classNames, style);
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment, null, this.renderResultRow(resultAttributes, selected, style, suggestionDOM), filtersDOM);
  };

  return ResultRow;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
//# sourceMappingURL=resultrow.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/components/results.js
function results__extends() { results__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return results__extends.apply(this, arguments); }

function results__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





function isChangedBy(num, threshold) {
  return Math.abs(num) > threshold;
}

var results_Results =
/*#__PURE__*/
function (_Component) {
  results__inheritsLoose(Results, _Component);

  function Results() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.onClickProxy = function (ev) {
      // If child item, derive id and call onClick callback
      var suggestionKey = ev.target.attributes['data-suggestion-key'];

      if (suggestionKey) {
        var suggestionKeyValue = parseInt(suggestionKey.value, 10);
        var suggestion = _this.props.results[suggestionKeyValue];

        if (suggestion) {
          var subSuggestionKey = ev.target.attributes['data-sub-suggestion-key'];
          var subSuggestion = null;

          if (subSuggestionKey) {
            var subSuggestionKeyValue = parseInt(subSuggestionKey.value, 10);
            subSuggestion = suggestion.subSuggestions[subSuggestionKeyValue];
          }

          suggestion.suggestionDepth = suggestionKeyValue + 1; // 1-based depth

          _this.props.onSelectDestination(suggestion, subSuggestion);

          return true;
        }

        _this.props.onError('results.js error: unable to resolve destination from results click');
      }

      return false;
    };

    _this.handleTouchStart = function (ev) {
      var _ev$target$getBoundin = ev.target.getBoundingClientRect(),
          left = _ev$target$getBoundin.left,
          top = _ev$target$getBoundin.top;

      _this.touchLeft = left;
      _this.touchTop = top;
      _this.touchStartTime = Date.now();
    };

    _this.handleTouchEnd = function (ev) {
      var _ev$target$getBoundin2 = ev.target.getBoundingClientRect(),
          left = _ev$target$getBoundin2.left,
          top = _ev$target$getBoundin2.top;

      var touchElapseTime = Date.now() - _this.touchStartTime;

      var leftChanged = _this.touchLeft - left;
      var topChanged = _this.touchTop - top;

      if (touchElapseTime < 250 && !isChangedBy(leftChanged, 20) && !isChangedBy(topChanged, 20)) {
        _this.onClickProxy(ev);

        ev.stopPropagation();
        ev.preventDefault();

        _this.props.onBlur();

        return true;
      }

      return false;
    };

    _this.computeSpinnerDom = function () {
      var spinner = null;
      var showSpinner = _this.props.showSpinner && _this.props.xhrPending === true && _this.props.results === false;

      if (showSpinner) {
        spinner = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
          className: "result inactive"
        }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
          className: "loading-spinner"
        }));
      }

      return spinner;
    };

    _this.computeResultsDom = function () {
      var _this$props = _this.props,
          filterType = _this$props.filterType,
          selectDestinationIndex = _this$props.selectDestinationIndex,
          selectDestinationSubIndex = _this$props.selectDestinationSubIndex,
          results = _this$props.results,
          skipFilters = _this$props.skipFilters;
      var hasSelectedIndex = selectDestinationIndex > -1;
      var resultsDOM = results.map(function (result, index) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(resultrow_ResultRow, results__extends({}, _this.props, {
          key: "result-row-" + result.uuid,
          index: index,
          hasSelectedIndex: hasSelectedIndex,
          filterType: filterType,
          last: results[index + 1] && !results[index + 1].recentlyviewed,
          result: result,
          selected: selectDestinationIndex === index,
          selectDestinationSubIndex: selectDestinationSubIndex,
          skipFilters: skipFilters
        }));
      });
      return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", null, resultsDOM);
    };

    return _this;
  }

  var _proto = Results.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        results = _this$props2.results,
        useAnim = _this$props2.useAnim,
        poweredByGoogle = _this$props2.poweredByGoogle;
    var resultsDOM = null;
    var classNames = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
      'search-results-container': true,
      'no-anim': !useAnim,
      'poweredbygoogle-logo': poweredByGoogle
    });

    if (results && results.length > 0) {
      resultsDOM = this.computeResultsDom();
    }

    var spinnerDOM = this.computeSpinnerDom();
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      id: "Typeahead__results",
      role: "listbox",
      tabIndex: "-1",
      className: classNames,
      onClick: this.onClickProxy,
      onTouchStart: this.handleTouchStart,
      onTouchEnd: this.handleTouchEnd
    }, resultsDOM, spinnerDOM);
  };

  return Results;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
//# sourceMappingURL=results.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/raf-optimized/lib/transpiled/index.js
var lib_transpiled = __webpack_require__("pick");
var lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(lib_transpiled);

// EXTERNAL MODULE: ./node_modules/react-transition-group/CSSTransition.js
var CSSTransition = __webpack_require__("4JXe");
var CSSTransition_default = /*#__PURE__*/__webpack_require__.n(CSSTransition);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/components/typeahead.js
function typeahead__extends() { typeahead__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return typeahead__extends.apply(this, arguments); }

function typeahead__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }









var typeahead_Typeahead =
/*#__PURE__*/
function (_Component) {
  typeahead__inheritsLoose(Typeahead, _Component);

  function Typeahead() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.onResize = function () {
      _this.sizePopover();
    };

    _this.showResults = function () {
      var hasValidUIState = _this.props.uistate === UISTATES.SELECT_DESTINATION;
      var hasValidSearch = !!_this.props.search && _this.props.search.length > 0;
      var hasValidResults = _this.props.results !== false && _this.props.results && _this.props.results.length !== 0;
      var hasSpinnerAndXhrPending = _this.props.results === false && _this.props.showSpinner === true && _this.props.xhrPending === true;
      return hasValidUIState && hasValidSearch && (hasValidResults || hasSpinnerAndXhrPending);
    };

    _this.handleFocus = function (e) {
      if (!_this.props.isTypeaheadInputFocus) {
        _this.props.onFocus(e);

        return true;
      }

      return false;
    };

    _this.handleBlur = function () {
      _this.userInput.blur();

      _this.props.onBlur();
    };

    _this.handleKeyDownOnClear = function (e) {
      if (e.keyCode === KEYCODES.ENTER || e.keyCode === KEYCODES.SPACE) {
        e.stopPropagation();
        e.preventDefault();

        _this.props.onClear();

        return true;
      }

      return false;
    };

    _this.setUserInputRef = function (el) {
      _this.userInput = el;
    };

    _this.setHeaderRef = function (el) {
      _this.header = el;
    };

    _this.setPopoverRef = function (el) {
      _this.popover = el;
    };

    return _this;
  }

  var _proto = Typeahead.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.clearResize = Object(lib_transpiled["resize"])(this.onResize);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isTypeaheadInputFocus && nextProps.isTypeaheadInputFocus !== this.props.isTypeaheadInputFocus) {
      this.userInput.focus();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.sizePopover();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.clearResize) {
      this.clearResize();
      this.clearResize = null;
    }
  };

  _proto.sizePopover = function sizePopover() {
    var _this$props = this.props,
        isMobile = _this$props.isMobile,
        popoverDesktopWidth = _this$props.popoverDesktopWidth;

    if (!isMobile && popoverDesktopWidth !== 'auto' && this.popover) {
      var oldWidth = Math.round(this.popover.getBoundingClientRect().width);
      var newWidth = this.getMaxWidth();

      if (newWidth !== oldWidth) {
        this.popover.style.width = newWidth + "px";
      }
    }
  };

  _proto.assignStateClass = function assignStateClass() {
    return " state--" + this.props.uistate;
  };

  _proto.isDestinationSelected = function isDestinationSelected() {
    return !!this.props.selectedDestination && this.props.uistate !== UISTATES.SELECT_DESTINATION;
  };

  _proto.getWindowWidth = function getWindowWidth() {
    if (true) {
      return window.innerWidth;
    } else if (typeof document !== 'undefined') {
      return document.documentElement.clientWidth || document.body.clientWidth || 0;
    }

    return 0;
  };

  _proto.getMaxWidth = function getMaxWidth() {
    var _this$props2 = this.props,
        popoverDesktopWidth = _this$props2.popoverDesktopWidth,
        popoverDesktopMinMarginRight = _this$props2.popoverDesktopMinMarginRight;
    var popoverLeft = this.popover ? this.popover.getBoundingClientRect().left : 0;
    var parsedPopoverDesktopWidth = parseInt(popoverDesktopWidth, 10);
    var maxWidth = Math.max(200, Math.round(this.getWindowWidth() - popoverLeft - (popoverDesktopMinMarginRight || 0)));
    return parsedPopoverDesktopWidth < maxWidth ? parsedPopoverDesktopWidth : maxWidth;
  };

  _proto.getPopoverWidthStyles = function getPopoverWidthStyles() {
    var _this$props3 = this.props,
        isMobile = _this$props3.isMobile,
        popoverDesktopWidth = _this$props3.popoverDesktopWidth,
        popoverDesktopMinWidth = _this$props3.popoverDesktopMinWidth,
        popoverDesktopMaxWidth = _this$props3.popoverDesktopMaxWidth;

    if (isMobile) {
      return {
        width: '100%'
      };
    } else if (popoverDesktopWidth !== 'auto') {
      return {
        width: this.getMaxWidth() + "px"
      };
    }

    return {
      minWidth: popoverDesktopMinWidth,
      maxWidth: popoverDesktopMaxWidth
    };
  };

  _proto.renderResults = function renderResults() {
    if (this.showResults()) {
      return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        className: "search-destination-results-container pop-up-container",
        tabIndex: "-1",
        style: this.getPopoverWidthStyles(),
        ref: this.setPopoverRef
      }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        className: "pop-up-container__arrows"
      }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        className: "pop-up-container__arrow__outer pop-up-container__arrow"
      }), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        className: "pop-up-container__arrow__inner pop-up-container__arrow"
      })), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(results_Results, {
        selectDestinationIndex: this.props.selectDestinationIndex,
        selectDestinationSubIndex: this.props.selectDestinationSubIndex,
        results: this.props.results,
        search: this.props.search,
        useAnim: this.props.useResultsAnimation,
        onSelectDestination: this.props.onSelectDestination,
        onError: this.props.onError,
        onBlur: this.handleBlur,
        isMobile: this.props.isMobile,
        messages: {
          noresultsfound: this.props.messages.noresultsfound,
          recentlyviewed: this.props.messages.recentlyviewed,
          resultsfound: this.props.messages.resultsfound,
          destinationselected: this.props.messages.destinationselected,
          typeairport: this.props.messages.typeairport,
          typecity: this.props.messages.typecity,
          typelandmark: this.props.messages.typelandmark,
          typeneighborhood: this.props.messages.typeneighborhood,
          typeregion: this.props.messages.typeregion,
          typetrainstation: this.props.messages.typetrainstation,
          typemetrostation: this.props.messages.typemetrostation
        },
        showSpinner: this.props.showSpinner,
        xhrPending: this.props.xhrPending,
        poweredByGoogle: this.props.poweredByGoogle,
        showResultIcons: this.props.showResultIcons,
        showResultLabels: this.props.showResultLabels,
        skipFilters: this.props.skipFilters,
        filterType: this.props.filterType,
        inputHasIcon: !!this.props.icon,
        truncateResultTerms: this.props.truncateResultTerms
      }));
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", null);
  };

  _proto.render = function render() {
    // search is user input text, displayTerm is the destination label text
    var userInput = this.props.displayTerm || this.props.search;
    var inputEmpty = !(this.isDestinationSelected() || userInput);
    var placeholderText = inputEmpty ? this.props.messages.destinationplaceholdermsg : this.props.messages.where;
    var searchInputWrapperAttrs = {};
    searchInputWrapperAttrs['aria-controls'] = this.showResults() ? 'Typeahead__results' : null;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", typeahead__extends({
      className: "search-destination-input",
      role: "combobox" //eslint-disable-line jsx-a11y/role-has-required-aria-props
      ,
      "aria-haspopup": "listbox",
      "aria-expanded": this.showResults()
    }, searchInputWrapperAttrs), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      role: "presentation",
      className: "search-destination-input__header" + this.assignStateClass(),
      onClick: this.props.onClick,
      ref: this.setHeaderRef
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('search-destination-input__header__inputs', 'form-group', 'has-feedback', 'floating-label', {
        'not-empty': !inputEmpty,
        'has-icon': this.props.icon
      }),
      "data-toggle": "label"
    }, this.props.uistate === UISTATES.SELECT_DESTINATION ? reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("input", {
      "aria-hidden": true,
      type: "text",
      size: "10",
      className: "form-control hint",
      value: this.props.searchSuggestion || '',
      readOnly: true,
      autoComplete: "off"
    }) : null, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("label", {
      htmlFor: "react-destination-typeahead"
    }, placeholderText), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("input", {
      type: "text",
      id: "react-destination-typeahead",
      size: "10",
      tabIndex: "0",
      placeholder: placeholderText,
      className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('control', 'form-control'),
      onFocus: this.handleFocus,
      onKeyDown: this.props.onKeyDown,
      onChange: this.props.onChange,
      onBlur: this.props.onBlur,
      value: userInput,
      autoComplete: "off",
      "aria-autocomplete": "both",
      ref: this.setUserInputRef
    }), this.props.icon ? reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
      className: "form-control-icon search-destination-input__icon"
    }, this.props.icon) : null, this.showResults() ? reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("button", {
      "aria-label": this.props.messages.clearsearch,
      className: "form-control-feedback search-destination-input__close",
      tabIndex: "0",
      onClick: this.props.onClear,
      onTouchEnd: this.props.onClear,
      onKeyDown: this.handleKeyDownOnClear
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(transpiled["SVGIcon"], {
      markup: esm["CLOSE__16"]
    })) : null)), this.props.usePopoverAnimation ? reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(CSSTransition_default.a, {
      in: this.showResults(),
      classNames: "search-destination-results-container",
      timeout: {
        enter: 250,
        exit: 250
      },
      mountOnEnter: true,
      unmountOnExit: true
    }, this.renderResults()) : this.renderResults());
  };

  return Typeahead;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
//# sourceMappingURL=typeahead.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/components/ariastatus.js
function ariastatus__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }


/**
 * isResultsChanged()
 * Check if results were updated with new entries
 * @param {array} prevResults
 * @param {array} nextResults
 */

function isResultsChanged(prevResults, nextResults) {
  prevResults = prevResults || [];
  nextResults = nextResults || [];

  if (prevResults.length !== nextResults.length) {
    return true;
  }

  var nextResultsDict = nextResults.reduce(function (result, nextResultItem) {
    result[nextResultItem.uuid] = true;
    return result;
  }, {});
  var changedResult = prevResults.find(function (prevResultsItem) {
    return !nextResultsDict[prevResultsItem.uuid];
  });
  return !!changedResult;
}

var ariastatus_AriaStatus =
/*#__PURE__*/
function (_Component) {
  ariastatus__inheritsLoose(AriaStatus, _Component);

  function AriaStatus() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      bump: false
    };
    return _this;
  }

  var _proto = AriaStatus.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var results = _ref.results,
        selectedDestination = _ref.selectedDestination,
        selectDestinationIndex = _ref.selectDestinationIndex;
    // If user has new selected destination
    var newDestination = (selectedDestination && selectedDestination.uuid) !== (this.props.selectedDestination && this.props.selectedDestination.uuid); // If selectDestinationIndex has changed

    var newSelectIndex = selectDestinationIndex !== this.props.selectDestinationIndex; // Results have changed

    var newResults = isResultsChanged(this.props.results, results); // Compute has changed

    var hasChanged = newDestination || newSelectIndex || newResults;

    if (hasChanged) {
      this.setState(function (_ref2) {
        var bump = _ref2.bump;
        return {
          bump: !bump
        };
      });
    }

    return hasChanged;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        results = _this$props.results,
        selectDestinationIndex = _this$props.selectDestinationIndex,
        selectedDestination = _this$props.selectedDestination,
        messages = _this$props.messages;
    var bump = this.state.bump;
    var content = null;

    if (selectDestinationIndex > -1 && results[selectDestinationIndex]) {
      // announce term
      var destinationTerm = results[selectDestinationIndex].term;
      content = destinationTerm;
    } else if (selectedDestination) {
      // announce selected destination
      content = messages.destinationselected.replace('{DESTINATION}', selectedDestination.term);
    } else if (results) {
      // announce results
      content = messages.resultsfound.replace('{NUM_RESULTS}', results.length);
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: "sr-only",
      "aria-atomic": "true",
      "aria-live": "polite",
      role: "status"
    }, content, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
      "aria-hidden": true
    }, bump ? ',' : ',,'));
  };

  return AriaStatus;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
//# sourceMappingURL=ariastatus.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/components/svgdefinitions.js

var svgdefinitions_SvgDefinitions = function SvgDefinitions() {
  return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("svg", {
    display: "none",
    width: "0",
    height: "0",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("defs", null, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("symbol", {
    id: "SVG_ARROW_DOWN_RIGHT__16",
    viewBox: "0 0 16 16"
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", {
    d: "M11.733 12.9L15 9.633l-3.267-3.266"
  }), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", {
    d: "M15 9.634H1.934A.934.934 0 0 1 1 8.7V3.1"
  })))));
};
//# sourceMappingURL=svgdefinitions.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/container.css
var container = __webpack_require__("zXiQ");
var container_default = /*#__PURE__*/__webpack_require__.n(container);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/container.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container_TypeaheadContainer; });
function container__extends() { container__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return container__extends.apply(this, arguments); }

function container__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 *  This is the top level component class that is responsible for managing the state of
 *  it's underlying sub-components
 */
// Libs

 // Functions




 // Data


 // View components



 // Style


var PIDRegExp = /^(p\d+)/;

var container_TypeaheadContainer =
/*#__PURE__*/
function (_Component) {
  container__inheritsLoose(TypeaheadContainer, _Component);

  /* istanbul ignore next */
  function TypeaheadContainer(props) {
    var _this;

    _this = _Component.call(this, props) || this; // Default state
    // This is where we apply global context to the component

    _this.incrementNoSelectionCounter = function (resultsNext) {
      var results = _this.state.results;

      if (!results || results.length === 0 && resultsNext.length === 0) {
        return;
      }

      if (results.length !== resultsNext.length) {
        _this.data.noSelectionCounter++;
        return;
      }

      var isResultsChanged = resultsNext.find(function (element, index) {
        return !results[index] || results[index].uuid !== element.uuid;
      });

      if (isResultsChanged) {
        _this.data.noSelectionCounter++;
      }
    };

    _this.handleError = function (msg) {
      console.error(msg); //eslint-disable-line

      return emitGE({
        eventaction: 'error',
        eventvalue: msg,
        eventlabel: ''
      });
    };

    _this.handleTopLevelKeyEvents = function (ev) {
      // Dispatch keyboard event
      var result = keypress(_this.state, ev); // true: keypress() resulted in selected destination

      if (result === true) {
        var selectedIndex = _this.state.selectDestinationIndex === -1 ? 0 : _this.state.selectDestinationIndex;
        var selectedDestination = _this.state.results[selectedIndex];
        _this.data.selectionDepth = selectedIndex + 1; // 1-based selectionDepth

        var selectedSubDestination = null;

        if (_this.state.selectDestinationSubIndex > -1) {
          selectedSubDestination = selectedDestination.subSuggestions[_this.state.selectDestinationSubIndex];
        }

        _this.handleSelectDestination(selectedDestination, selectedSubDestination);

        setTimeout(function () {
          _this.containerEl.querySelector('input.control').blur();
        }, 1);
      } else if (result) {
        // control key press ESC, Up, Down
        _this.setState(result);

        _this.handleFocus();
      } else {
        // char key press
        _this.triggerStartEdap();
      }

      return result;
    };

    _this.handleOnMouseOver = function () {
      if (_this.state.selectDestinationIndex !== -1) {
        _this.setState({
          selectDestinationIndex: -1
        });
      }

      if (_this.state.uistate !== UISTATES.CLOSED) {
        _this.handleFocus();

        return true;
      }

      return false;
    };

    _this.goToClosedStateIfClickedOutside = function (e) {
      if (_this.state.uistate !== UISTATES.CLOSED) {
        if (_this.containerEl && !_this.containerEl.contains(e.target)) {
          _this.checkUserInputOnClickOutside();

          _this.close();

          return true;
        }
      }

      return false;
    };

    _this.checkUserInputOnClickOutside = function () {
      var state = _this.state;
      var isEmptyOrDifferentSelectedDestination = !state.selectedDestination || !state.selectedDestination.term || state.selectedDestination.term.toLowerCase() !== state.search.toLowerCase();

      if (state.search && isEmptyOrDifferentSelectedDestination) {
        _this.handleSelectDestination(state.search);
      }
    };

    _this.handleTypeaheadClick = function () {
      _this.setState({
        uistate: UISTATES.SELECT_DESTINATION
      });
    };

    _this.handleFocus = function (e) {
      var state = focusSearchInput(_this.state);

      if (e && e.currentTarget) {
        var target = e.currentTarget; // setTimeout is needed because some browsers eg. MS Edge are unable to select synchronously

        setTimeout(function () {
          return target.select();
        }, 50);
      }

      if (state) {
        // If results is not initialized, fetch em
        _this.state.uistate = state.uistate; //eslint-disable-line

        if (_this.state.results === false) {
          _this.handleSearchInputChange();
        } // Make sure to update to open state


        _this.setState(state);
      }
      /* istanbul ignore next */


      if (_this.state.isTypeaheadInputFocus) {
        _this.setState({
          isTypeaheadInputFocus: false
        });
      }

      _this.triggerFocusEdap();

      _this.props.onFocus();
    };

    _this.getRecentDisplayedNumber = function (results) {
      return results.reduce(function (recentsNumber, result) {
        if (result.recentlyviewed) {
          recentsNumber++;
        }

        return recentsNumber;
      }, 0);
    };

    _this.getNonStandardDisplayedNumber = function (results) {
      var nonStandardResult = results.find(function (result) {
        return result.subSuggestions;
      });
      return nonStandardResult ? nonStandardResult.subSuggestions.length : 0;
    };

    _this.handleSearchInputChange = function (ev) {
      var userInput = (ev ? ev.target.value : _this.state.search) || '';
      var firstResultTerm = _this.state.results && _this.state.results[0] && _this.state.results[0].term;
      var showInlineSuggestion = _this.props.showInlineSuggestion; // Increment "backspace" counter if user delete character

      if (userInput.length < _this.data.userInputLength) {
        _this.data.backspaceCounter++;
      }

      _this.data.userInputLength = userInput.length; // Trim preceding whitespace

      userInput = userInput.replace(/^\s(.*)/, '$1'); // Emit a `used` event (one per pageview)

      if (userInput.length && !_this.state.used) {
        emitGE({
          eventaction: 'used'
        });

        _this.setState({
          used: true
        });
      } // If userInput is empty, set an empty state


      if (!userInput || userInput.length === 0 || PIDRegExp.test(userInput)) {
        _this.setState({
          results: false,
          search: userInput,
          searchSuggestion: '',
          selectedDestination: false
        });

        _this.store.getResults(false); // Send signal to store that user has changed input


        return false;
      }

      _this.setState({
        search: userInput,
        searchSuggestion: showInlineSuggestion ? getHintSuggestion(userInput, firstResultTerm) : '',
        uistate: UISTATES.SELECT_DESTINATION,
        xhrPending: true
      }); // fetch results from store (either via XHR or cache)


      _this.store.getResults(userInput, _this.props.filterType, function (searchResults) {
        // Update post-fetch state
        firstResultTerm = searchResults.results[0] && searchResults.results[0].term;

        _this.setState({
          searchSuggestion: showInlineSuggestion ? getHintSuggestion(userInput, firstResultTerm) : '',
          results: searchResults.resultsWithHighlights,
          poweredByGoogle: searchResults.poweredByGoogle,
          xhrPending: false
        });

        _this.data.resultsUuid = searchResults.resultsUuid;
      });

      return true;
    };

    _this.close = function () {
      // forces typeahead to lose focus
      window.document.activeElement.blur();

      _this.setState({
        uistate: UISTATES.CLOSED
      });
    };

    _this.handleSelectDestination = function (_selectedDestination, _selectedSubDestination) {
      // Optimize function
      if (_this.state.uistate !== UISTATES.SELECT_DESTINATION) {
        return false;
      }

      var selectedDestination = container__extends({}, _selectedDestination);

      delete selectedDestination.highlightedTerm;

      var selectedSubDestination = container__extends({}, _selectedSubDestination);

      var filterId = selectedSubDestination && selectedSubDestination.filter && selectedSubDestination.filter.id;
      var resultsUuid = _this.data.resultsUuid;
      var totalResults = 0;
      var nonStandardDisplayed = 0;
      var recentsDisplayed = 0;

      if (_this.state.results) {
        recentsDisplayed = _this.getRecentDisplayedNumber(_this.state.results);
        nonStandardDisplayed = _this.getNonStandardDisplayedNumber(_this.state.results);
        totalResults = _this.state.results.length - recentsDisplayed;
      }

      var selectionType = 'standard';

      if (selectedDestination.poweredByGoogle) {
        selectionType = 'google';
        totalResults = 0; // google is not standard results so totalResults is 0
      } else if (filterId) {
        selectionType = 'filter';
      }

      if (!selectedDestination.uuid) {
        // If user has no input, cancel selection
        if (!_this.state.search) {
          return false;
        }

        selectedDestination = {
          term: _this.state.search
        };
        emitGE({
          eventaction: 'selected-destination-with-no-results',
          eventlabel: null,
          eventvalue: selectedDestination.term
        });
      } else {
        var selectionData = container__extends({
          userinput: _this.state.search,
          totalbackspaces: _this.data.backspaceCounter,
          totalnoselections: _this.data.noSelectionCounter,
          totalresults: totalResults,
          selectiondepth: selectedDestination.suggestionDepth || _this.data.selectionDepth,
          selectiontype: selectionType,
          nonstandarddisplayed: nonStandardDisplayed,
          recentsdisplayed: recentsDisplayed,
          prevsearch: _this.data.prevsearch,
          geouuid: selectedDestination.uuid,
          geotypes: selectedDestination.type,
          geoname: selectedDestination.term,
          matchtype: selectedDestination.matchType
        }, resultsUuid ? {
          resultsuuid: resultsUuid
        } : {}, filterId ? {
          filterid: filterId
        } : {}, selectionType === 'google' ? {
          googleselectionplaceid: selectedDestination.uuid
        } : {});

        emitSE(selectionData);
      } // reset "backspace" and "noSelection" counter after selection


      _this.data = container__extends({}, _this.data, {
        backspaceCounter: 0,
        noSelectionCounter: 0,
        prevsearch: selectedDestination.term
      });
      var updateState = {
        searchSuggestion: '',
        selectedDestination: selectedDestination,
        selectedSubDestination: selectedSubDestination,
        selectDestinationIndex: -1,
        selectDestinationSubIndex: -1
      };

      if (_this.state.retainUserInput === true) {
        updateState.search = selectedDestination.term;
      } // Add destination to recently searched except PID and destination created from custom user input


      if (!PIDRegExp.test(_this.state.search) && selectedDestination.uuid) {
        addRecentSearch(selectedDestination);
      } // Updated state


      _this.setState(updateState, function () {
        // Invoke onSelectDestination() callback
        _this.props.onSelectDestination(selectedDestination, selectedSubDestination);

        _this.close();
      });

      return true;
    };

    _this._getSelectedTermFromState = function () {
      var selectedDestination = _this.state.selectedDestination;
      return selectedDestination && selectedDestination.term || '';
    };

    _this._getSelectedFilterNameFromState = function () {
      var selectedSubDestination = _this.state.selectedSubDestination;
      return selectedSubDestination && selectedSubDestination.filter && selectedSubDestination.filter.name;
    };

    _this.handleClear = function () {
      _this.setState({
        search: '',
        searchSuggestion: '',
        selectedDestination: false,
        isTypeaheadInputFocus: true,
        results: false
      });
    };

    _this.createContainerRef = function (el) {
      _this.containerEl = el;
    };

    _this.state = container__extends({
      uistate: UISTATES.CLOSED,
      results: false,
      xhrPending: false,
      searchSuggestion: '',
      selectedDestination: '',
      selectedSubDestination: '',
      selectDestinationIndex: -1,
      selectDestinationSubIndex: -1,
      used: false,
      isTypeaheadInputFocus: false
    }, _this.props);
    _this.data = {
      backspaceCounter: 0,
      userInputLength: 0,
      noSelectionCounter: 0,
      prevsearch: null,
      resultsUuid: null,
      selectionDepth: 1 // 1-based depth

    };
    return _this;
  }

  var _proto = TypeaheadContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // Initialize the typeahead store /w initial state as configuration
    this.store = new store_TypeaheadStore(this.props.config); // Remove old/invalid entries from localStorage

    pruneLocalStorage(); // If value is set, pre-warm typeahead results

    if (this.state.search && this.state.search.length > 0) {
      this.data.prevsearch = this.state.search;
      this.store.getResults(this.state.search, this.props.filterType, function () {});
    } // add window click handler to close pop ups


    window.addEventListener('click', this.goToClosedStateIfClickedOutside, true);
    window.addEventListener('touchstart', this.goToClosedStateIfClickedOutside, true);
  }
  /**
   * componentWillReceiveProps()
   * @param {*} nextProps
   */
  ;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    // Sync filtered list of new props to sync with state.
    var nextState = {};
    /* istanbul ignore next */

    Object.keys(nextProps).forEach(function (prop) {
      if (nextProps[prop] !== _this2.props[prop] && nextProps[prop] !== _this2.state[prop]) {
        var nextStateValue = nextProps[prop];

        if (prop === 'search') {
          // If parent context updates "search", invalidate selectedDestination in order to render search text.
          _this2.setState({
            selectedDestination: false,
            results: false
          });
        }

        nextState[prop] = nextStateValue;
      }
    });

    if (Object.keys(nextState).length > 0) {
      this.setState(container__extends({}, nextState));
      return true;
    }

    return false;
  }
  /**
   * componentWillUpdate
   * @param {*} nextProps
   * @param {*} nextState
   */
  ;

  _proto.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    this.incrementNoSelectionCounter(nextState.results);

    if (this.state.uistate !== UISTATES.CLOSED && nextState.uistate === UISTATES.CLOSED) {
      this.props.onClose(nextState.search || this.state.search); // eslint-disable-line no-unused-expressions
    }

    if (this.state.search !== nextState.search || this.state.selectedDestination !== nextState.selectedDestination) {
      // Invoke `onUpdate()` callback
      this.props.onUpdate(nextState);
    }
  }
  /**
   * incrementNoSelectionCounter()
   * Increments noSelectionCounter if results list was updated with new suggestions
   */
  ;

  _proto.triggerFocusEdap = function triggerFocusEdap() {
    if (!this.state.wasFirstFocus) {
      this.setState({
        wasFirstFocus: true
      });
      emitFocusEvent(this.state.search || null);
    }
  };

  _proto.triggerStartEdap = function triggerStartEdap() {
    if (!this.state.wasFirstInput) {
      this.setState({
        wasFirstInput: true
      });
      emitStartEvent(this.state.search || null);
    }
  };

  /**
   * getInputDisplayTerm()
   * Helper method to get search term for destination input
   */
  _proto.getInputDisplayTerm = function getInputDisplayTerm() {
    if (this.state.uistate === UISTATES.SELECT_DESTINATION) {
      return this.state.search;
    }

    var term = this._getSelectedTermFromState();

    var filter = this._getSelectedFilterNameFromState();

    var displayTerm = '';

    if (term) {
      if (!this.props.hideSelectedFilter && filter) {
        displayTerm = term + " > " + filter;
      } else {
        displayTerm = term;
      }
    }

    return displayTerm;
  }
  /**
   * handleClear()
   * Clears user search
   */
  ;

  /**
   * render()
   * Render the component
   */
  _proto.render = function render() {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      role: "presentation",
      onKeyDown: this.handleTopLevelKeyEvents,
      onMouseOver: this.handleOnMouseOver,
      className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('react-destination-typeahead', this.state.uistate, {
        'react-destination-typeahead--no-icon': !this.state.icon
      }),
      ref: this.createContainerRef
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(svgdefinitions_SvgDefinitions, null), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(ariastatus_AriaStatus, container__extends({}, this.props, this.state)), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(typeahead_Typeahead, container__extends({}, this.props, this.state, {
      onFocus: this.handleFocus,
      onClick: this.handleTypeaheadClick,
      onClear: this.handleClear,
      onChange: this.handleSearchInputChange,
      onSelectDestination: this.handleSelectDestination,
      onError: this.handleError,
      displayTerm: this.getInputDisplayTerm(),
      rootElem: this.containerEl,
      isMobile: this.props.isMobile,
      onBlur: this.props.onBlur,
      isTypeaheadInputFocus: this.props.isTypeaheadInputFocus || this.state.isTypeaheadInputFocus,
      showSpinner: this.props.showSpinner,
      showResultIcons: this.props.showResultIcons,
      showResultLabels: this.props.showResultLabels,
      skipFilters: this.props.filterType < 1 || this.props.filterType > 3,
      filterType: this.props.filterType
    })));
  };

  return TypeaheadContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var esm_container = (container_TypeaheadContainer);

//# sourceMappingURL=container.js.map

/***/ }),

/***/ "f+uk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f7Xe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fC4T":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "fM2g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNN3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fPr/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _AspectRatioCardUtil = __webpack_require__("RiTF");

var _AspectRatioCardUtil2 = _interopRequireDefault(_AspectRatioCardUtil);

var _AspectRatioCardImage = __webpack_require__("BxE1");

var _AspectRatioCardImage2 = _interopRequireDefault(_AspectRatioCardImage);

__webpack_require__("lulc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AspectRatioCard = function (_Component) {
    _inherits(AspectRatioCard, _Component);

    function AspectRatioCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AspectRatioCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AspectRatioCard.__proto__ || Object.getPrototypeOf(AspectRatioCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            loaded: false
        }, _this.handleLoad = function (cb) {
            return function (event) {
                if (!_this.state.loaded) {
                    _this.setState({
                        loaded: true
                    });
                }

                if (cb) {
                    cb(event);
                }
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AspectRatioCard, [{
        key: 'getSlots',


        /**
         * Filter the children to determine which slots each child should be assigned
         * during render.
         *
         * @param {Object} children - The opaque children of the component.
         */
        value: function getSlots(children) {
            var _this2 = this;

            var shouldHandleLoad = this.props.async || this.props.hasHover && this.props.hasHoverOverlay;
            var slots = {
                figure: null,
                caption: null,
                content: null,
                extra: []
            };

            _react2.default.Children.forEach(children, function (child) {
                var childSlot = _react2.default.isValidElement(child) && child.props && child.props['data-slot'];
                if (childSlot && childSlot in slots && !slots[childSlot]) {
                    var props = {};
                    var cloneChild = false;
                    // Pass through the aspect ratio property for
                    // AspectRatioCardImage children.
                    if (child.type === _AspectRatioCardImage2.default) {
                        cloneChild = true;
                        props.aspectRatio = _this2.props.aspectRatio;
                    }
                    // Use the "card" slot onLoad method for async loading determination.
                    if (childSlot === 'figure' && shouldHandleLoad && !_this2.state.loaded && child.props.onLoad) {
                        cloneChild = true;
                        props.onLoad = _this2.handleLoad(child.props.onLoad);
                    }
                    if (cloneChild) {
                        child = _react2.default.cloneElement(child, props);
                    }
                    slots[childSlot] = child;
                } else {
                    slots.extra.push(child);
                }
            });

            return slots;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                aspectRatio = _props.aspectRatio,
                async = _props.async,
                hasHover = _props.hasHover,
                hasHoverOverlay = _props.hasHoverOverlay,
                children = _props.children;

            var useHasHoverOverlayModifier = this.state.loaded && hasHover && hasHoverOverlay;
            var aspectRatioData = _AspectRatioCardUtil2.default.getAspectRatioData(aspectRatio);
            var isNotLoaded = async && !this.state.loaded;
            var rootClass = (0, _classnames2.default)('AspectRatioCard', {
                'AspectRatioCard--has-hover': hasHover,
                'AspectRatioCard--has-hover-overlay': useHasHoverOverlayModifier
            });
            var topClass = (0, _classnames2.default)('AspectRatioCard__top', 'AspectRatioCard__top--' + aspectRatioData.ratioString);
            var bottomClass = (0, _classnames2.default)('AspectRatioCard__bottom', { 'AspectRatioCard__bottom--not-loaded': isNotLoaded });
            var figureClass = (0, _classnames2.default)('AspectRatioCard__figure', {
                'AspectRatioCard__figure--not-loaded': isNotLoaded,
                'AspectRatioCard__figure--has-hover-overlay': useHasHoverOverlayModifier
            });
            var captionClass = (0, _classnames2.default)('AspectRatioCard__caption', { 'AspectRatioCard__caption--not-loaded': isNotLoaded });
            var contentClass = (0, _classnames2.default)('AspectRatioCard__content', { 'AspectRatioCard__content--not-loaded': isNotLoaded });
            var slots = this.getSlots(children);
            var figureElement = hasHover ? _react2.default.createElement(
                'div',
                { className: 'AspectRatioCard__figure-perspective-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: figureClass },
                    slots.figure
                )
            ) : _react2.default.createElement(
                'div',
                { className: figureClass },
                slots.figure
            );

            return _react2.default.createElement(
                'div',
                { className: rootClass },
                slots.figure && _react2.default.createElement(
                    'div',
                    { className: topClass },
                    figureElement
                ),
                (slots.caption || slots.content) && _react2.default.createElement(
                    'div',
                    { className: bottomClass },
                    slots.caption && _react2.default.createElement(
                        'div',
                        { className: captionClass },
                        slots.caption
                    ),
                    slots.content && _react2.default.createElement(
                        'div',
                        { className: contentClass },
                        slots.content
                    )
                )
            );
        }
    }], [{
        key: 'getControlOffset',


        /**
         * Method intended for use with the getControlOffset property of the
         * CardCarousel to center the controls within the "card" slot instead of
         * centering over the full height which is the default behavior.
         *
         * @param {Number} cardWidth - Width of the card in the CardCarousel in pixels.
         * @param {Number} controlHeight - Height in pixels of the CardCarousel control.
         * @param {String} aspectRatio - The aspect ratio of the card.
         */
        value: function getControlOffset(cardWidth, controlHeight, aspectRatio) {
            var aspectRatioData = _AspectRatioCardUtil2.default.getAspectRatioData(aspectRatio);
            var imageHeight = Math.round(cardWidth * aspectRatioData.heightMultiplier);

            return Math.round(imageHeight ? (imageHeight - controlHeight) / 2 : 0);
        }
    }]);

    return AspectRatioCard;
}(_react.Component);

AspectRatioCard.propTypes = {
    /** The card aspect ratio, which determines the maintained aspect ratio of the image block. */
    aspectRatio: _propTypes2.default.oneOf(['4x3', '3x4']).isRequired,
    /** Flag to indicate async loading which will hide the content of the card until it has loaded. If true, uses the onLoad property of the "card" slot child to determine if the content has been laoded. */
    async: _propTypes2.default.bool,
    /** Flag to indicate whether to use the default hover state of the aspect ratio card */
    hasHover: _propTypes2.default.bool,
    /** Flag to indicate whether to use the darkening/brightening overlay effect with the hover state. Only applies if hasHover and card implements onLoad callback. In general, should be used, unless card figure is not an image. */
    hasHoverOverlay: _propTypes2.default.bool
};
AspectRatioCard.defaultProps = {
    async: false,
    hasHover: true,
    hasHoverOverlay: true
};
exports.default = AspectRatioCard;
//# sourceMappingURL=AspectRatioCard.js.map

/***/ }),

/***/ "fdqI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("R3sX");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactButtons = __webpack_require__("HfJ9");

var _CHEVRON_LEFT__ = __webpack_require__("pAW9");

var _CHEVRON_RIGHT__ = __webpack_require__("Jq3D");

__webpack_require__("oUFU");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SETTINGS = {
    TRANSITION_DURATION_SLIDE: 350,
    TRANSITION_DURATION_SLIDE_PAGING: 500,
    THROTTLE_TIME_RESIZE: 300
};

var CardCarousel = function (_Component) {
    _inherits(CardCarousel, _Component);

    function CardCarousel(props) {
        _classCallCheck(this, CardCarousel);

        var _this = _possibleConstructorReturn(this, (CardCarousel.__proto__ || Object.getPrototypeOf(CardCarousel)).call(this, props));

        _this.handleNext = function (evt) {
            _this.props.onNextClick(evt, _this.getNewIndex(true));
        };

        _this.handlePrevious = function (evt) {
            _this.props.onPreviousClick(evt, _this.getNewIndex(false));
        };

        _this.setControlHeight = function (elem) {
            if (elem && elem.firstChild) {
                _this.controlHeight = elem.firstChild.offsetHeight;
            }
        };

        _this.setContent = function (content) {
            _this.content = content;
        };

        _this.setContainer = function (container) {
            _this.container = container;
        };

        _this.setViewbox = function (viewbox) {
            _this.viewbox = viewbox;
        };

        _this.controlHeight = 0;
        _this.timeouts = {};
        _this.isTouchEnabled = "object" !== 'undefined' && 'ontouchstart' in window || typeof navigator !== 'undefined' && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);

        _this.state = {
            cardCount: _this.getCardCountFromBreakpoint(0),
            carouselState: '',
            controlHeight: 0,
            viewboxTransform: 'none'
        };

        _this.throttledWindowResize = (0, _lodash2.default)(_this.handleWindowResize.bind(_this), SETTINGS.THROTTLE_TIME_RESIZE, {
            leading: true,
            trailing: true
        });
        return _this;
    }

    _createClass(CardCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (true) {
                window.addEventListener('resize', this.throttledWindowResize);
                this.updateBasedOnComponentWidth(true);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var newIndex = this.normalizeIndex(nextProps.cardIndex);
            if (newIndex !== this.props.cardIndex) {
                this.slide(this.props.cardIndex, newIndex);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var viewboxTransform = this.getViewboxPos(this.getOffsetByIndex(this.props.cardIndex));
            if (viewboxTransform !== this.state.viewboxTransform) {
                this.setState({ viewboxTransform: viewboxTransform });
            }

            if (this.controlHeight !== this.state.controlHeight) {
                this.setState({ controlHeight: this.controlHeight });
            }

            // If transitioned from scrolling to non-scrolling, reset the scrollLeft
            // position.
            if (!this.props.scrolling && prevProps && prevProps.scrolling && this.container) {
                this.container.scrollLeft = 0;
            }

            if (this.props.scrolling && this.props.cardIndex !== prevProps.cardIndex) {
                this.scrollTo(this.props.cardIndex);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (true) {
                window.removeEventListener('resize', this.throttledWindowResize);
            }
        }
    }, {
        key: 'updateBasedOnComponentWidth',
        value: function updateBasedOnComponentWidth(force) {
            var viewboxTransform = this.getViewboxPos(this.getOffsetByIndex(this.props.cardIndex));
            var cardCount = this.getCardCountFromBreakpoint(this.state.cardCount, force);

            this.handleOnResizeCallback(cardCount);

            if (this.props.scrolling && (this.props.cardIndex >= 0 && cardCount !== this.state.cardCount || force)) {
                this.scrollTo(this.props.cardIndex, cardCount);
            }

            this.setState({
                viewboxTransform: viewboxTransform,
                cardCount: cardCount
            });
        }
    }, {
        key: 'handleOnResizeCallback',
        value: function handleOnResizeCallback(cardCount) {
            var needsControls = this.getAreControlsNecessary(cardCount);
            var breakpoints = this.props.breakpoints ? this.sortBreakpoints(this.props.breakpoints) : 'none';
            var numberChildren = this.props.children ? this.props.children.length : 0;

            this.props.onResize({
                numberCardsVisible: cardCount,
                numberCardsTotal: numberChildren,
                breakpoints: breakpoints,
                needsControls: needsControls
            });
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.updateBasedOnComponentWidth();
        }

        /** Returns a boolean indicating the display of fwd/back nav arrows  */

    }, {
        key: 'getAreControlsNecessary',
        value: function getAreControlsNecessary(cardCount) {
            return this.props.children && this.props.children.length > cardCount;
        }
    }, {
        key: 'getCardCountFromBreakpoint',
        value: function getCardCountFromBreakpoint() {
            var cardCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var forceSetState = arguments[1];
            var breakpoints = this.props.breakpoints;

            var width = this.content ? this.content.clientWidth : 0;
            var i = void 0;
            var bp = void 0;
            var parsedBp = void 0;
            var sortedBreakpoints = this.sortBreakpoints(breakpoints);

            for (i = 0; i < sortedBreakpoints.length; i++) {
                bp = sortedBreakpoints[i];
                parsedBp = parseInt(bp, 10);
                if (width >= parsedBp) {
                    var newCardCount = breakpoints[bp];
                    if (newCardCount !== cardCount || forceSetState) {
                        cardCount = newCardCount;
                    }
                    break;
                }
            }
            return cardCount;
        }
    }, {
        key: 'getOffsetByIndex',
        value: function getOffsetByIndex(index) {
            var normalizedIndex = this.normalizeIndex(index);
            var cardWidth = this.getCardWidthPct(this.state.cardCount);
            return cardWidth * normalizedIndex * 100;
        }
    }, {
        key: 'getViewboxPos',
        value: function getViewboxPos(pct) {
            if (this.container) {
                return this.props.scrolling ? 'translateX(0%)' : 'translateX(-' + pct + '%)';
            }

            return 'none';
        }
    }, {
        key: 'normalizeIndex',
        value: function normalizeIndex(index) {
            var cardCount = this.state.cardCount;
            var scrolling = this.props.scrolling;

            var newCount = scrolling ? cardCount - 1 : cardCount;
            var maxIndex = this.props.children ? this.props.children.length - newCount : 0;
            if (!index || index < 0) {
                return 0;
            } else if (index > maxIndex) {
                return maxIndex;
            }
            return index;
        }
    }, {
        key: 'slide',
        value: function slide(oldIndex, newIndex) {
            var _this2 = this;

            var paging = this.props.paging;

            var viewboxTransform = this.getViewboxPos(this.getOffsetByIndex(newIndex));

            var state = {
                viewboxTransform: viewboxTransform,
                carouselState: paging ? 'paging' : 'animating'
            };

            this.setState(state, function () {
                clearTimeout(_this2.timeouts.slide);
                _this2.timeouts.slide = setTimeout(function () {
                    delete _this2.timeouts.slide;
                    _this2.setState({
                        carouselState: ''
                    });
                }, paging ? SETTINGS.TRANSITION_DURATION_SLIDE_PAGING : SETTINGS.TRANSITION_DURATION_SLIDE);
            });
        }
    }, {
        key: 'sortBreakpoints',
        value: function sortBreakpoints() {
            var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return Object.keys(breakpoints).sort(function (a, b) {
                var parsedA = parseInt(a, 10);
                var parsedB = parseInt(b, 10);

                if (parsedA === parsedB) {
                    return 0;
                }
                return parsedA > parsedB ? -1 : 1;
            });
        }
    }, {
        key: 'getNewIndex',
        value: function getNewIndex(isNext) {
            var _props = this.props,
                paging = _props.paging,
                children = _props.children,
                cardIndex = _props.cardIndex;
            var cardCount = this.state.cardCount;

            var length = children.length;
            var pageCount = paging ? cardCount - 1 : 1;
            var newIndex = this.normalizeIndex(cardIndex);
            while (pageCount > 0) {
                if (isNext) {
                    newIndex = newIndex < length - 2 ? newIndex + 1 : newIndex; // 0;
                } else {
                    newIndex = newIndex > 0 ? newIndex - 1 : newIndex; // length - 1;
                }
                pageCount--;
            }
            return this.normalizeIndex(newIndex);
        }
    }, {
        key: 'getCardWidthPx',
        value: function getCardWidthPx(cardCountOverride) {
            var cardCount = this.state.cardCount;

            var newCardCount = cardCountOverride || cardCount;
            var _props2 = this.props,
                scrolling = _props2.scrolling,
                scrollingPeekPct = _props2.scrollingPeekPct;

            var containerWidth = this.container ? this.container.clientWidth - this.viewbox.offsetLeft : 0;
            return containerWidth > 0 && newCardCount > 0 ? containerWidth / (newCardCount - (scrolling ? 1 - scrollingPeekPct : 0)) : 0;
        }
    }, {
        key: 'getCardWidthPct',
        value: function getCardWidthPct(cardCount) {
            var _props3 = this.props,
                scrolling = _props3.scrolling,
                scrollingPeekPct = _props3.scrollingPeekPct;


            return cardCount > 0 ? 1 / (cardCount - (scrolling ? 1 - scrollingPeekPct : 0)) : 0;
        }
    }, {
        key: 'calcControlOffset',
        value: function calcControlOffset() {
            // If a method to get the control offset was specified and the container
            // has been rendered with some width (not SSR) then get the offset through
            // the function. Otherwise, return -1 so the render will simply center
            // the controls. This minimizes shifting difference between server/client
            // rendering.
            // Note: 8 is a hard coded value for the padding of the card container in order
            // to prevent calculating this dynamically.
            return this.props.getControlOffset && this.container && this.container.clientWidth ? this.props.getControlOffset(this.getCardWidthPx() - 8, this.controlHeight) : -1;
        }
    }, {
        key: 'curve',
        value: function curve(x) {
            return -2 * Math.pow(x, 3) + 3 * Math.pow(x, 2);
        }
    }, {
        key: 'scrollTiming',
        value: function scrollTiming(time, target, origin, range) {
            var done = time >= SETTINGS.TRANSITION_DURATION_SLIDE;
            var position = done ? target : origin + range * this.curve(time / SETTINGS.TRANSITION_DURATION_SLIDE);
            return { done: done, position: position };
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo(cardIndex, cardCount) {
            var _this3 = this;

            if (this.animating || "object" === 'undefined') {
                return;
            }
            var normalizedIndex = this.normalizeIndex(cardIndex);
            var cardWidth = this.getCardWidthPx(cardCount);

            var slide = Math.round(cardWidth * normalizedIndex);

            this.animating = true;
            var start = void 0;
            var element = this.container;
            var origin = element.scrollLeft;
            var range = slide - origin;

            var step = function step(timestamp) {
                if (!start) {
                    start = timestamp;
                }

                var _scrollTiming = _this3.scrollTiming(timestamp - start, slide, origin, range),
                    position = _scrollTiming.position,
                    done = _scrollTiming.done;

                element.scrollLeft = position;

                if (done) {
                    _this3.animating = false;
                } else {
                    window.requestAnimationFrame(step);
                }
            };

            window.requestAnimationFrame(step);
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var _this4 = this;

            var pct = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var children = this.props.children;

            return _react2.default.Children.map(children, function (child, index) {
                var id = 'card-' + index;
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'CardCarousel__card-container',
                        style: { width: pct * 100 + '%' },
                        key: index,
                        'data-id': id,
                        ref: function ref(_ref) {
                            /* istanbul ignore next */
                            _this4[id] = _ref;
                        }
                    },
                    child
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                actionHref = _props4.actionHref,
                actionHrefTarget = _props4.actionHrefTarget,
                actionText = _props4.actionText,
                cardIndex = _props4.cardIndex,
                children = _props4.children,
                onActionClick = _props4.onActionClick,
                scrolling = _props4.scrolling,
                title = _props4.title,
                subheading = _props4.subheading;
            var _state = this.state,
                carouselState = _state.carouselState,
                cardCount = _state.cardCount,
                viewboxTransform = _state.viewboxTransform;

            var normalizedIndex = this.normalizeIndex(cardIndex);
            var isAnimating = carouselState === 'animating' || carouselState === 'paging';
            var hasAction = (onActionClick || actionHref) && actionText;
            var hasHeader = title || hasAction;
            var hasSubheading = title && subheading;
            var hasPrev = normalizedIndex > 0;
            var hasNext = children ? normalizedIndex < children.length - cardCount : false;
            var controlOffset = this.calcControlOffset();
            var hasControlOffset = controlOffset >= 0;
            var needsControls = this.getAreControlsNecessary(cardCount);
            var cardWidth = this.getCardWidthPct(cardCount);

            var headerClasses = (0, _classnames2.default)('CardCarousel__header', {
                'CardCarousel__header--scrolling': scrolling,
                'CardCarousel__header--not-scrolling': !scrolling
            });

            var titleClasses = (0, _classnames2.default)('CardCarousel__title', {
                'CardCarousel__title--scrolling': scrolling
            });

            var navPrevClasses = (0, _classnames2.default)('CardCarousel__nav CardCarousel__nav-prev', {
                'CardCarousel__nav--animating': isAnimating,
                'CardCarousel__nav--disabled': !hasPrev,
                'CardCarousel__nav--no_offset': !hasControlOffset
            });

            var navNextClasses = (0, _classnames2.default)('CardCarousel__nav CardCarousel__nav-next', {
                'CardCarousel__nav--animating': isAnimating,
                'CardCarousel__nav--disabled': !hasNext,
                'CardCarousel__nav--no_offset': !hasControlOffset
            });

            var navStyle = hasControlOffset ? {
                'paddingTop': controlOffset
            } : {};

            var viewboxClasses = (0, _classnames2.default)('CardCarousel__viewbox', {
                'CardCarousel__viewbox--animating': isAnimating,
                'CardCarousel__viewbox--paging': carouselState === 'paging',
                'CardCarousel__viewbox--touch-enabled': this.isTouchEnabled,
                'CardCarousel__viewbox--scrolling': scrolling
            });

            var viewboxStyles = viewboxTransform ? {
                transform: viewboxTransform
            } : {
                transform: 'none'
            };

            var containerClasses = (0, _classnames2.default)('CardCarousel__container', {
                'CardCarousel__container--scrolling': scrolling,
                'CardCarousel__container--touch-enabled': this.isTouchEnabled
            });

            var titleElement = title && _react2.default.createElement(
                'h2',
                { className: titleClasses },
                title
            );

            var buttonLink = hasAction && _react2.default.createElement(_reactButtons.ButtonLink, {
                className: (0, _classnames2.default)('CardCarousel__action', {
                    'CardCarousel__subheading-action': hasSubheading
                }),
                href: actionHref,
                target: actionHrefTarget,
                onClick: onActionClick,
                label: actionText,
                size: 'sm'
            });

            return _react2.default.createElement(
                'div',
                { className: 'CardCarousel' },
                hasHeader && _react2.default.createElement(
                    'div',
                    { className: headerClasses },
                    hasSubheading && _react2.default.createElement(
                        'div',
                        { className: 'CardCarousel__title-container' },
                        titleElement,
                        _react2.default.createElement(
                            'div',
                            { className: 'CardCarousel__subheading-container' },
                            _react2.default.createElement(
                                'p',
                                { className: 'CardCarousel__subheading' },
                                subheading
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'CardCarousel__action-container' },
                                buttonLink
                            )
                        )
                    ),
                    !hasSubheading && titleElement,
                    !hasSubheading && buttonLink
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'CardCarousel__content',
                        ref: this.setContent
                    },
                    !scrolling && _react2.default.createElement(
                        'div',
                        {
                            className: navPrevClasses,
                            onClick: this.handlePrevious,
                            tabIndex: -1,
                            style: navStyle,
                            role: 'presentation'
                        },
                        needsControls && _react2.default.createElement(
                            'div',
                            { ref: this.setControlHeight },
                            _react2.default.createElement(_reactButtons.ButtonIcon, {
                                label: this.props.previousLabel,
                                circle: true,
                                svgMarkup: _CHEVRON_LEFT__.CHEVRON_LEFT__16,
                                'aria-label': this.props.previousLabel,
                                disabled: !hasPrev
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: containerClasses,
                            ref: this.setContainer
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                className: viewboxClasses,
                                style: viewboxStyles,
                                ref: this.setViewbox
                            },
                            this.renderChildren(cardWidth)
                        )
                    ),
                    !scrolling && _react2.default.createElement(
                        'div',
                        {
                            className: navNextClasses,
                            onClick: this.handleNext,
                            tabIndex: -1,
                            style: navStyle,
                            role: 'presentation'
                        },
                        needsControls && _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_reactButtons.ButtonIcon, {
                                label: this.props.nextLabel,
                                circle: true,
                                svgMarkup: _CHEVRON_RIGHT__.CHEVRON_RIGHT__16,
                                'aria-label': this.props.nextLabel,
                                disabled: !hasNext
                            })
                        )
                    )
                )
            );
        }
    }]);

    return CardCarousel;
}(_react.Component);

CardCarousel.propTypes = {
    /** Text to display for the action area. */
    actionText: _propTypes2.default.string,
    /** The url to navigate to when the action is clicked. If specified, an <a href> tag is used for the action instead of a normal button. */
    actionHref: _propTypes2.default.string,
    /** The browsing context to display a specfied actionHref in. ie "_blank", "_parent". Default is "_self". */
    actionHrefTarget: _propTypes2.default.string,
    /** Specifies the viewport width breakpoints and how many items to display in the carousel at each breakpoint. */
    breakpoints: _propTypes2.default.objectOf(_propTypes2.default.number),
    /** Specifies which card is displayed as the first visible card in the carousel. */
    cardIndex: _propTypes2.default.number.isRequired,
    /** `getControlOffset(cardWidth, controlHeight)` Invoked on render to adjust the positioning of the carousel controls which are vertically centered by default.  Invoked with the card width and control component height in pixels. */
    getControlOffset: _propTypes2.default.func,
    /** `onActionClick(event)` Triggered when the `actionText` is clicked. Passes the click event. */
    onActionClick: _propTypes2.default.func,
    /** `onNextClick(event, nextCardIndex)` Triggered when the "next" control button is clicked. Passes the click event and the proposed new `cardIndex` value. */
    onNextClick: _propTypes2.default.func.isRequired,
    /** `onPreviousClick(event, nextCardIndex)` Triggered when the "previous" control button is clicked. Passes the click event and the proposed new `cardIndex` value. */
    onPreviousClick: _propTypes2.default.func.isRequired,
    /** `onResize({numberCardsVisible, numberChildren, breakpoints, needsControls})` Triggered when the browser resizes. */
    onResize: _propTypes2.default.func,
    /**  The translated label for the "next" control button. */
    nextLabel: _propTypes2.default.string,
    /** Adjusts the `nextCardIndex` passed to `onNextClick` and `onPreviousClick`. If `true` the index will be adjusted based on the number of items visible in the carousel. If false, the index is adjusted by 1 item. */
    paging: _propTypes2.default.bool,
    /** The translated label for the "previous" control button. */
    previousLabel: _propTypes2.default.string,
    /** Hides the navigation controls and allows free horizontal scrolling. */
    scrolling: _propTypes2.default.bool,
    /** When scrolling is enabled, determines the percentage of "card peek", a UX pattern to indicate additional content is available for scrolling. Accepts a value of 0.2 or 0.5 which represents 20% and 50% peek respectively. */
    scrollingPeekPct: _propTypes2.default.oneOf([0.2, 0.5]),
    /** The title content. */
    title: _propTypes2.default.string,
    /** The subheading text under the title */
    subheading: _propTypes2.default.string
};
CardCarousel.defaultProps = {
    breakpoints: {
        '1200': 4,
        '992': 3,
        '768': 4,
        '420': 3,
        '0': 2
    },
    cardIndex: 0,
    nextLabel: 'Next',
    onNextClick: function onNextClick() {},
    onPreviousClick: function onPreviousClick() {},
    onResize: function onResize() {},
    paging: true,
    previousLabel: 'Previous',
    scrolling: false,
    scrollingPeekPct: 0.2
};
exports.default = CardCarousel;
//# sourceMappingURL=CardCarousel.js.map

/***/ }),

/***/ "fq9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "frhy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gCWN":
/***/ (function(module, exports) {



/***/ }),

/***/ "gFo6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gGqR":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObject = __webpack_require__("yCNF");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "gPAl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gSaG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSwipeable = __webpack_require__("7610");

var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _ArrowNext = __webpack_require__("B/BN");

var _ArrowNext2 = _interopRequireDefault(_ArrowNext);

var _ArrowPrevious = __webpack_require__("UzhU");

var _ArrowPrevious2 = _interopRequireDefault(_ArrowPrevious);

__webpack_require__("F6ea");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SCROLL_TRANSITION = 250;

var HorizontalScroll = function (_Component) {
    _inherits(HorizontalScroll, _Component);

    function HorizontalScroll(props) {
        _classCallCheck(this, HorizontalScroll);

        var _this = _possibleConstructorReturn(this, (HorizontalScroll.__proto__ || Object.getPrototypeOf(HorizontalScroll)).call(this, props));

        _this.handleSwiped = function (event, deltaX, deltaY, isFlicked, velocity) {
            var direction = deltaX > 0 ? 'left' : 'right';
            /* If the speed of the swipe is above 0.25 velocity then move to the next slide
            else snap to the closest item */
            if (velocity > 0.35) {
                _this.moveDirection(direction);
            } else {
                _this.snapToClosestComponent(deltaX, direction);
            }
        };

        _this.moveToIndex = function (index) {
            // If an index is present and valid move to the slide position
            if (index && index >= 0 && index < _this.itemPositions.length) {
                _this.animateTo(-_this.itemPositions[index].left);
                _this.currentIndex = index;
            }
        };

        _this.moveDirection = function (direction) {
            // If we have a direction and the next index won't be out of bounds, move to it
            if (direction === 'left' && _this.currentIndex < _this.itemPositions.length - 1) {
                _this.currentIndex = _this.currentIndex + 1;
                _this.animateTo(-_this.itemPositions[_this.currentIndex].left);
            } else if (direction === 'right' && _this.currentIndex > 0) {
                _this.currentIndex = _this.currentIndex - 1;
                _this.animateTo(-_this.itemPositions[_this.currentIndex].left);
            }
        };

        _this.snapToClosestComponent = function (deltaX, direction) {
            var scrollLeftPosition = _this.state.scrollLeftPosition;

            var newPosition = scrollLeftPosition - deltaX;

            var _this$getRangeInfo = _this.getRangeInfo(),
                contentWidth = _this$getRangeInfo.contentWidth,
                wrapperWidth = _this$getRangeInfo.wrapperWidth;

            /* if the position is positive, then animate back to the first item
            else if the value is more than the last item animate back to the end
            else calculate the next item to snap to */


            if (newPosition > 0) {
                _this.animateTo(0);
            } else if (Math.abs(newPosition) + wrapperWidth > contentWidth) {
                _this.animateTo(-(contentWidth - wrapperWidth));
            } else {
                _this.moveToClosetComponent(newPosition, direction);
            }
        };

        _this.moveToClosetComponent = function (position, direction) {
            var snapPoint = 0;
            var compIndex = 0;
            if (direction === 'left') {
                _this.itemPositions.forEach(function (component, index) {
                    if (component.left < Math.abs(position)) {
                        snapPoint = component.left;
                        compIndex = index;
                    }
                });
            } else if (direction === 'right') {
                for (var i = _this.itemPositions.length - 1; i > 0; i--) {
                    var component = _this.itemPositions[i];
                    if (component.left > Math.abs(position)) {
                        snapPoint = component.left;
                        compIndex = i;
                    }
                }
            }
            _this.animateTo(-snapPoint);
            _this.currentIndex = compIndex;
        };

        _this.handleSwiping = function (event, deltaX) {
            var scrollLeftPosition = _this.currentScrollPosition - deltaX;

            var _this$getRangeInfo2 = _this.getRangeInfo(),
                contentWidth = _this$getRangeInfo2.contentWidth,
                wrapperWidth = _this$getRangeInfo2.wrapperWidth;

            if (_this.currentScrollPosition <= 0 && scrollLeftPosition < 0 && Math.abs(scrollLeftPosition) < contentWidth - wrapperWidth) {
                _this.setState({ scrollLeftPosition: scrollLeftPosition });
            }
            event.preventDefault();
        };

        _this.handleArrowClick = function (direction) {
            var _this$getRangeInfo3 = _this.getRangeInfo(),
                contentWidth = _this$getRangeInfo3.contentWidth,
                wrapperWidth = _this$getRangeInfo3.wrapperWidth;

            var scrollLeftPosition = _this.state.scrollLeftPosition;

            var snapPoint = 0;
            if (direction === 'right') {
                _this.itemPositions.forEach(function (component) {
                    if (component.left < Math.abs(scrollLeftPosition) + wrapperWidth) {
                        snapPoint = component.left;
                    }
                });

                /* case where the left offset would be greater than the actual content width
                so it should align right offest of the last item to the right side of the viewport */
                if (snapPoint > contentWidth - wrapperWidth) {
                    snapPoint = contentWidth - wrapperWidth;
                }
            } else if (direction === 'left') {
                _this.itemPositions.forEach(function (component) {
                    if (component.left < Math.abs(scrollLeftPosition) - wrapperWidth + _this.itemPositions[_this.currentIndex].width) {
                        snapPoint = component.left;
                    }
                });
            }

            _this.animateTo(-snapPoint);

            _this.currentIndex = _this.itemPositions.findIndex(function (item) {
                return snapPoint === item.left;
            });

            /* case for if we hit the end of the content width */
            if (_this.currentIndex === -1) {
                _this.currentIndex = _this.itemPositions.length - 1;
            }
        };

        _this.firstUpdate = true;
        _this.state = {
            nextArrowVisible: false,
            previousArrowVisible: false,
            arrowDisabled: false,
            scrollLeftPosition: 0,
            selectedIndex: props.selectedIndex
        };
        // Specifies the current scroll position (left offset)
        _this.currentScrollPosition = 0;
        // Specifies the current item index
        _this.currentIndex = 0;
        return _this;
    }

    _createClass(HorizontalScroll, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var selectedIndex = this.props.selectedIndex;
            var scrollLeftPosition = this.state.scrollLeftPosition;


            this.setArrowState(scrollLeftPosition, this.getRangeInfo());
            // If we have an index to scroll to from props thats not 0, lets scroll there.
            if (selectedIndex !== 0) {
                this.moveToIndex(selectedIndex);
            }
        }

        /**
        * Determine whether the previouse arrow and next arrow should be visible.
        * @function setArrowState
        * @param {Number} Left - The left position of the scrollable content
        * @param {Object} Range - The range information from getRangeInfo
        */

    }, {
        key: 'setArrowState',
        value: function setArrowState(left, range) {
            this.setState({
                previousArrowVisible: left < range.max,
                nextArrowVisible: left > range.min
            });
        }

        /**
         * This function gets used to get some information about the divs the content is in
         * so we can use this to determine scroll positions
         * @function getRangeInfo
         * @returns {Object} Return information about the size of the content divs
         */

    }, {
        key: 'getRangeInfo',
        value: function getRangeInfo() {
            var wrapperWidth = this.contentWrapperRef.offsetWidth;
            var contentWidth = this.contentRef.scrollWidth;

            return {
                contentWidth: contentWidth,
                wrapperWidth: wrapperWidth,
                min: wrapperWidth - contentWidth,
                max: 0,
                viewable: wrapperWidth,
                contentLeft: this.contentRef.offsetLeft
            };
        }

        /**
        * Handles the on ending swipe after the user has lifted the mouse or finger
        * @function handleSwiped
        * @param {SyntheticEvent} event React SyntheticEvent
        * @param {Number} deltaX Delta in x direction from where the swipe start occurs
        * @param {Number} deltaY Delta in y direction from where the swipe start occurs
        * @param {Boolean} isFlicked True if the user made a fast swipe
        * @param {Number} velocity The speed at which the full swipe occured
        *
        */


        /**
        * Moves to the specified item index
        * @function moveToIndex
        * @param {Number} index Index to move to
        *
        */


        /**
        * Moves to the specified item index
        * @function moveDirection
        * @param {String} direction 'left' or 'right' direction of the swipe
        *
        */

    }, {
        key: 'animateTo',


        /**
        * Animate to a specific pixel offset
        * @function animateTo
        * @param {Number} val Offset to animate to
        */
        value: function animateTo(val) {
            var _this2 = this;

            // Add the scroll-transition class for smooth transform
            _reactDom2.default.findDOMNode(this.contentRef).classList.toggle('scroll-transition');
            this.setState({
                arrowDisabled: true,
                scrollLeftPosition: val
            }, function () {
                // On state update, set a timeout, then remove the scroll-transition class
                /* istanbul ignore next */
                setTimeout(function () {
                    _reactDom2.default.findDOMNode(_this2.contentRef).classList.toggle('scroll-transition');
                    _this2.setState({ arrowDisabled: false });
                }, SCROLL_TRANSITION);
            });
            this.currentScrollPosition = val;
            this.setArrowState(val, this.getRangeInfo());
        }

        /**
        * Snaps to the closest component based on the x delta at the end of the swipe based on direction
        * @function snapToClosestComponent
        * @param {Number} deltaX Delta in x direction from where the swipe start occurs
        * @param {String} direction 'left' or 'right' direction of the swipe
        */


        /**
        * Moves the left offset to the closest item based on position and direction
        * @function moveToClosetComponent
        * @param {Number} position The position of the left offset of the contentWidth
        * @param {String} direction 'left' or 'right'
        */


        /**
        * Updates the scroll position based on swiping
        * @function handleSwiping
        * @param {SyntheticEvent} event React SyntheticEvent
        * @param {Number} deltaX Delta in x direction from where the swipe start occurs
        */


        /**
        * Scrolls to the next item that is partially out of view based on direction
        * @function handleArrowClick
        * @param {String} direction 'left' or 'right'
        */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                arrowBackgroundColor = _props.arrowBackgroundColor,
                children = _props.children,
                onPreviousClick = _props.onPreviousClick,
                onNextClick = _props.onNextClick;
            var _state = this.state,
                scrollLeftPosition = _state.scrollLeftPosition,
                previousArrowVisible = _state.previousArrowVisible,
                nextArrowVisible = _state.nextArrowVisible,
                arrowDisabled = _state.arrowDisabled;

            /* istanbul ignore next */

            var onPreviousArrowClick = function onPreviousArrowClick() {
                _this3.handleArrowClick('left');
                if (onPreviousClick) {
                    onPreviousClick();
                }
            };

            /* istanbul ignore next */
            var onNextArrowClick = function onNextArrowClick() {
                _this3.handleArrowClick('right');
                if (onNextClick) {
                    onNextClick();
                }
            };

            var setContentWrapperRef = function setContentWrapperRef(component) {
                _this3.contentWrapperRef = component;
            };

            var setContentRef = function setContentRef(component) {
                _this3.contentRef = component;
            };

            var setPreviousArrowRef = function setPreviousArrowRef(component) {
                _this3.previousArrowRef = component;
            };

            var setNextArrowRef = function setNextArrowRef(component) {
                _this3.nextArrowRef = component;
            };

            this.itemPositions = [];

            if (!children) {
                return null;
            }

            var newChildren = _react2.default.Children.map(children, function (child) {
                return _react2.default.cloneElement(child, {
                    ref: function ref(component) {
                        var domElement = _reactDom2.default.findDOMNode(component);
                        if (component && domElement) {
                            _this3.itemPositions.push({
                                domElement: domElement,
                                left: domElement.offsetLeft,
                                width: domElement.offsetWidth
                            });
                        }
                    },
                    className: (0, _classnames2.default)(child.props.className, 'horizontal-scroll-item')
                });
            });

            return _react2.default.createElement(
                _reactSwipeable2.default,
                {
                    onSwiped: this.handleSwiped,
                    onSwiping: this.handleSwiping,
                    trackMouse: true,
                    className: 'horizontal-scroll',
                    style: { touchAction: 'none' }
                },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('horizontal-scroll-arrow', { 'not-shown': !previousArrowVisible }) },
                    _react2.default.createElement(_ArrowPrevious2.default, {
                        disabled: arrowDisabled,
                        arrowBackgroundColor: arrowBackgroundColor,
                        onClick: onPreviousArrowClick,
                        refCallback: setPreviousArrowRef
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'horizontal-scroll-center', ref: setContentWrapperRef },
                    _react2.default.createElement(
                        'div',
                        { className: 'horizontal-scroll-content', ref: setContentRef, style: { transform: 'translate(' + scrollLeftPosition + 'px)' } },
                        newChildren
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('horizontal-scroll-arrow', { 'not-shown': !nextArrowVisible }) },
                    _react2.default.createElement(_ArrowNext2.default, {
                        disabled: arrowDisabled,
                        arrowBackgroundColor: arrowBackgroundColor,
                        onClick: onNextArrowClick,
                        refCallback: setNextArrowRef
                    })
                )
            );
        }
    }]);

    return HorizontalScroll;
}(_react.Component);

HorizontalScroll.propTypes = {
    arrowBackgroundColor: _propTypes2.default.shape({
        red: _propTypes2.default.number,
        green: _propTypes2.default.number,
        blue: _propTypes2.default.number
    }),
    children: _propTypes2.default.node,
    onArrowsShown: _propTypes2.default.func,
    onFirstTimeArrowsShown: _propTypes2.default.func,
    onNextClick: _propTypes2.default.func,
    onPreviousClick: _propTypes2.default.func
};

HorizontalScroll.defaultProps = {
    arrowBackgroundColor: {
        red: 255,
        green: 255,
        blue: 255
    },
    selectedIndex: 0
};

exports.default = HorizontalScroll;
//# sourceMappingURL=HorizontalScroll.js.map

/***/ }),

/***/ "gUIY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.edapTriggerPriceSummaryDisplay = undefined;

var _edapTriggerPriceSummaryDisplay = __webpack_require__("pxCC");

Object.defineProperty(exports, 'edapTriggerPriceSummaryDisplay', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_edapTriggerPriceSummaryDisplay).default;
    }
});

var _PriceSummary = __webpack_require__("lYoF");

var _PriceSummary2 = _interopRequireDefault(_PriceSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PriceSummary2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "gYGY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "gYZ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gyRD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = void 0;

var _invariant = _interopRequireDefault(__webpack_require__("JiIc"));

var _defineToStringTag = _interopRequireDefault(__webpack_require__("hSN0"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  _defineProperty(this, "body", void 0);

  _defineProperty(this, "name", void 0);

  _defineProperty(this, "locationOffset", void 0);

  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  !(this.locationOffset.line > 0) ? (0, _invariant.default)(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? (0, _invariant.default)(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.Source = Source;
(0, _defineToStringTag.default)(Source);

/***/ }),

/***/ "hJMz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hSN0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyToStringTag;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The `applyToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method applyToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function applyToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}

/***/ }),

/***/ "hXMO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TO_TRIPBOARD = exports.ADD_TO_TRIPBOARD = 'ADD_TO_TRIPBOARD';
var ADD_TO_BOARD = exports.ADD_TO_BOARD = 'ADD_TO_BOARD';
var CREATE_BOARD = exports.CREATE_BOARD = 'CREATE_BOARD';
var CREATE_TRIPBOARD = exports.CREATE_TRIPBOARD = 'CREATE_TRIPBOARD';
var CREATE_TRIPBOARD_ERROR = exports.CREATE_TRIPBOARD_ERROR = 'CREATE_TRIPBOARD_ERROR';
var CREATE_TRIPBOARD_SUCCESS = exports.CREATE_TRIPBOARD_SUCCESS = 'CREATE_TRIPBOARD_SUCCESS';
var REMOVE_FROM_TRIPBOARD = exports.REMOVE_FROM_TRIPBOARD = 'REMOVE_FROM_TRIPBOARD';
var SET_TRIPBOARD_STATE = exports.SET_TRIPBOARD_STATE = 'SET_TRIPBOARD_STATE';
var GET_TRIPBOARD_PREVIEWS = exports.GET_TRIPBOARD_PREVIEWS = 'GET_TRIPBOARD_PREVIEWS';
var GET_TRIPBOARD_PREVIEWS_ERROR = exports.GET_TRIPBOARD_PREVIEWS_ERROR = 'GET_TRIPBOARD_PREVIEWS_ERROR';
var LOADING_TRIPBOARD_PREVIEWS = exports.LOADING_TRIPBOARD_PREVIEWS = 'LOADING_TRIPBOARD_PREVIEWS';
var SET_TRIPBOARD_TRANSLATIONS = exports.SET_TRIPBOARD_TRANSLATIONS = 'SET_TRIPBOARD_TRANSLATIONS';
var MAX_TRIPBOARD_NAME_LENGTH = exports.MAX_TRIPBOARD_NAME_LENGTH = 25;
var NEW_MODAL = exports.NEW_MODAL = 'ha_pulse_tripboard_new_modal_test';
var LOADING_ANIMATION = exports.LOADING_ANIMATION = 'ha_pulse_tripboard_loading_animation_test';
var SET_HAV = exports.SET_HAV = 'TRIPBOARDS_SET_HAV';
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "haWr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("f+uk");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-danger: 0 */


var noop = function noop() {};

var Toast = function (_Component) {
    _inherits(Toast, _Component);

    function Toast(props) {
        _classCallCheck(this, Toast);

        var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

        _this.add = function () {
            if (_this.state.isAdded) {
                return;
            }

            _this.setState({
                isAdded: true
            });
        };

        _this.close = function () {
            if (_this.state.isClosed) {
                return;
            }

            clearTimeout(_this.timeoutId);

            // animate out
            _this.setState({
                isClosed: true
            });

            _this.props.onClose(_this.props);
            _this.remove();
        };

        _this.handleCloseClick = function () {
            _this.props.onCloseClick(_this.props);
            _this.close();
        };

        _this.handleContentClick = function (e) {
            _this.props.onContentClick(e, _this.props);
        };

        _this.remove = function () {
            // animate removal
            setTimeout(function () {
                _this.setState({
                    isRemoved: true
                });
            }, 250);

            // trigger callback so container can update additional state
            // all animations take 500ms, so giving removal animations time to complete
            setTimeout(function () {
                _this.props.onRemove(_this.props.id);
            }, 750);
        };

        _this.timeoutId = null;

        _this.state = {
            isAdded: false,
            isClosed: false,
            isRemoved: false
        };
        return _this;
    }

    _createClass(Toast, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                autoClose = _props.autoClose,
                autoCloseAfter = _props.autoCloseAfter,
                onAutoClose = _props.onAutoClose;
            var isClosed = this.state.isClosed;

            if (autoClose) {
                this.timeoutId = setTimeout(function () {
                    if (!isClosed) {
                        onAutoClose(_this2.props);
                        _this2.close();
                    }
                }, autoCloseAfter);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timeoutId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isAdded = _state.isAdded,
                isClosed = _state.isClosed,
                isRemoved = _state.isRemoved;
            var _props2 = this.props,
                renderContent = _props2.renderContent,
                thumbnail = _props2.thumbnail,
                type = _props2.type;

            var containerClasses = (0, _classnames2.default)({
                'toaster__toast': true,
                'is-added': isAdded,
                'is-closed': isClosed,
                'is-removed': isRemoved,
                'toaster__toast-inverse': type === 'inverse'
            });

            // animate in
            setTimeout(this.add, 250);

            return _react2.default.createElement(
                'div',
                { className: containerClasses },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'btn btn-link btn-sm toaster__toast-x',
                        onClick: this.handleCloseClick,
                        type: 'button'
                    },
                    _react2.default.createElement(
                        'svg',
                        { className: 'toaster__toast-svg toaster__toast-x-svg inline-svg' },
                        _react2.default.createElement('use', { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '#toast-x' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'toaster__toast-flex',
                        onClick: this.handleContentClick
                    },
                    thumbnail && _react2.default.createElement('img', { className: 'toaster__toast-thumbnail', src: '' + thumbnail }),
                    _react2.default.createElement(
                        'span',
                        { className: 'toaster__toast-message' },
                        renderContent()
                    )
                )
            );
        }
    }]);

    return Toast;
}(_react.Component);

Toast.propTypes = {
    autoClose: _propTypes2.default.bool,
    autoCloseAfter: _propTypes2.default.number,
    onAutoClose: _propTypes2.default.func,
    onCloseClick: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    onContentClick: _propTypes2.default.func,
    onRemove: _propTypes2.default.func,
    renderContent: _propTypes2.default.func.isRequired,
    thumbnail: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['default', 'inverse']),
    id: _propTypes2.default.number
};
Toast.defaultProps = {
    autoClose: true,
    autoCloseAfter: 5000, // 5 seconds,
    onAutoClose: noop,
    onCloseClick: noop,
    onClose: noop,
    onContentClick: noop,
    onRemove: noop,
    renderContent: noop,
    thumbnail: null,
    type: 'default'
};
exports.default = Toast;
//# sourceMappingURL=Toast.js.map

/***/ }),

/***/ "hgbu":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("a/OS")('wks');
var uid = __webpack_require__("GmwO");
var Symbol = __webpack_require__("YjQv").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "hlwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hrPF":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "i4Cv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ "iANj":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "iEo0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iTOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iXid":
/***/ (function(module, exports) {

module.exports = {"monthNames":["January","February","March","April","May","June","July","August","September","October","November","December"],"shortMonthNames":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"longDayNames":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"dayNames":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"shortDayNames":["S","M","T","W","T","F","S"]}

/***/ }),

/***/ "ieDx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ieo+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inspect;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Used to print values in error messages.
 */
function inspect(value) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value) {
        if (typeof value.inspect === 'function') {
          return value.inspect();
        } else if (Array.isArray(value)) {
          return '[' + value.map(inspect).join(', ') + ']';
        }

        var properties = Object.keys(value).map(function (k) {
          return "".concat(k, ": ").concat(inspect(value[k]));
        }).join(', ');
        return properties ? '{ ' + properties + ' }' : '{}';
      }

      return String(value);

    default:
      return String(value);
  }
}

/***/ }),

/***/ "ir1l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__("rprB");
var objectAssign = __webpack_require__("BEQ0");
var decodeComponent = __webpack_require__("i4Cv");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),

/***/ "j6PF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__("5WWy");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tooltip2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "jAkQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toasterReducers = exports.toasterActions = exports.Toaster = undefined;

var _Toaster = __webpack_require__("UgnD");

var _Toaster2 = _interopRequireDefault(_Toaster);

var _actions = __webpack_require__("+oMz");

var _actions2 = _interopRequireDefault(_actions);

var _reducers = __webpack_require__("e0/m");

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Toaster = _Toaster2.default;
exports.toasterActions = _actions2.default;
exports.toasterReducers = _reducers2.default; /**
                                               * This index.js file is the entry point for your component and
                                               * is referenced from package.json. It's best to keep it lightweight
                                               * and do all of your work in component and subcomponent files.
                                              **/
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "jJn2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jc71":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jkO+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k//m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k/pb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__ = __webpack_require__("SIAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__("amq8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  // Otherwise, a change in the start/end time playerVars also requires a player
  // update.
  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};

  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

/**
 * Neutralise API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */
function filterResetOptions(opts) {
  return _extends({}, opts, {
    playerVars: _extends({}, opts.playerVars, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className;
}

var YouTube = function (_React$Component) {
  _inherits(YouTube, _React$Component);

  function YouTube(props) {
    _classCallCheck(this, YouTube);

    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));

    _this.onPlayerReady = function (event) {
      return _this.props.onReady(event);
    };

    _this.onPlayerError = function (event) {
      return _this.props.onError(event);
    };

    _this.onPlayerStateChange = function (event) {
      _this.props.onStateChange(event);
      switch (event.data) {

        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);
          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);
          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);
          break;

        default:
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      return _this.props.onPlaybackRateChange(event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      return _this.props.onPlaybackQualityChange(event);
    };

    _this.createPlayer = function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return;
      // create player
      var playerOpts = _extends({}, _this.props.opts, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });
      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default()(_this.container, playerOpts);
      // attach event handlers
      _this.internalPlayer.on('ready', _this.onPlayerReady);
      _this.internalPlayer.on('error', _this.onPlayerError);
      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    };

    _this.resetPlayer = function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
      });
    };

    _this.updateVideo = function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();
        return;
      }

      // set queueing options
      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };
      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;
        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }
        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      // if autoplay is enabled loadVideoById
      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);
        return;
      }
      // default behaviour just cues the video
      _this.internalPlayer.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  /**
    * Expose PlayerState constants for convenience. These constants can also be
    * accessed through the global YT object after the YouTube IFrame API is instantiated.
    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
    */


  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all Youtube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }

    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onError
     *
     * @param {Object} event
     *   @param {Integer} data  - error type
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
     *
     * @param {Object} event
     *   @param {Integer} data  - status change type
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
     *
     * @param {Object} event
     *   @param {Float} data    - playback rate
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
     *
     * @param {Object} event
     *   @param {String} data   - playback quality
     *   @param {Object} target - actual YT player
     */


    /**
     * Initialize the Youtube Player API on the container and attach event handlers
     */


    /**
     * Shorthand for destroying and then re-creating the Youtube Player
     */


    /**
     * Method to update the id and class of the Youtube Player iframe.
     * React should update this automatically but since the Youtube Player API
     * replaced the DIV that is mounted by React we need to do this manually.
     */


    /**
     * Call Youtube Player API methods to update the currently playing video.
     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
     * Youtube Player API methods to update the video.
     */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
      );
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any),

  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};


/* harmony default export */ __webpack_exports__["default"] = (YouTube);

/***/ }),

/***/ "k1pe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kR2y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbQE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("2Zwn"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = __webpack_require__("O27J");

var _TransitionGroup = _interopRequireDefault(__webpack_require__("dUsL"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "kgUV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TripBoardGraphqlTypeKeyMap = {
    TripBoard: 'uuid',
    Listing: 'listingId'
};

var dataIdFromObjectForTripBoard = function dataIdFromObjectForTripBoard(object) {
    return !!TripBoardGraphqlTypeKeyMap[object.__typename] && object[TripBoardGraphqlTypeKeyMap[object.__typename]];
};

exports.default = dataIdFromObjectForTripBoard;
//# sourceMappingURL=data-id-from-object-for-trip-board.js.map

/***/ }),

/***/ "kiBT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BzqH"), __esModule: true };

/***/ }),

/***/ "ksFB":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("wiaE");
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "l69y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l7nI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lEyX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvg = __webpack_require__("Ye17");

var _HOUSE__ = __webpack_require__("vx06");

__webpack_require__("L337");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
function SearchCard(props) {
    var count = props.count,
        endDate = props.endDate,
        id = props.id,
        imageUri = props.imageUri,
        lbsUuid = props.lbsUuid,
        onClick = props.onClick,
        position = props.position,
        searchEndDate = props.searchEndDate,
        searchStartDate = props.searchStartDate,
        startDate = props.startDate,
        title = props.title;


    var handleClick = function handleClick(event) {
        if (onClick) {
            onClick(event, id, position, searchStartDate, searchEndDate, lbsUuid);
        }
    };

    return _react2.default.createElement(
        'div',
        { className: 'SearchCard card card--xxs', role: 'button', onClick: handleClick },
        _react2.default.createElement(
            'div',
            { className: 'SearchCard__fallback-image' },
            _react2.default.createElement(
                'svg',
                { className: 'inline-svg SearchCard__fallback-svg', viewBox: '0 0 60 44' },
                _react2.default.createElement(
                    'title',
                    null,
                    'Mansion'
                ),
                _react2.default.createElement(
                    'g',
                    { fillRule: 'evenodd' },
                    _react2.default.createElement('path', { d: 'M40.445619 28.0942809L40.445619 21.5457702C40.445619 21.1001532 40.0789524 20.7397277 39.625619 20.7397277L34.1760952 20.7397277C33.7237143 20.7397277 33.3570476 21.1001532 33.3570476 21.5457702L33.3570476 28.0942809C33.3570476 28.5389617 33.7237143 28.8993872 34.1760952 28.8993872L39.625619 28.8993872C40.0789524 28.8993872 40.445619 28.5389617 40.445619 28.0942809M14.651619 27.8888851L9.20304762 27.8888851C8.75066667 27.8888851 8.384 28.2493106 8.384 28.6939915L8.384 35.2434383C8.384 35.6881191 8.75066667 36.0485447 9.20304762 36.0485447L14.651619 36.0485447C15.104 36.0485447 15.471619 35.6881191 15.471619 35.2434383L15.471619 28.6939915C15.471619 28.2493106 15.104 27.8888851 14.651619 27.8888851M24.578 27.8888851L19.1275238 27.8888851C18.6751429 27.8888851 18.3084762 28.2493106 18.3084762 28.6939915L18.3084762 35.2434383C18.3084762 35.6881191 18.6751429 36.0485447 19.1275238 36.0485447L24.578 36.0485447C25.030381 36.0485447 25.3970476 35.6881191 25.3970476 35.2434383L25.3970476 28.6939915C25.3970476 28.2493106 25.030381 27.8888851 24.578 27.8888851M45.9828571 28.8996681L51.4314286 28.8996681C51.8847619 28.8996681 52.2514286 28.5392426 52.2514286 28.0945617L52.2514286 21.5451149C52.2514286 21.100434 51.8847619 20.7400085 51.4314286 20.7400085L45.9828571 20.7400085C45.5304762 20.7400085 45.1638095 21.100434 45.1638095 21.5451149L45.1638095 28.0945617C45.1638095 28.5392426 45.5304762 28.8996681 45.9828571 28.8996681' }),
                    _react2.default.createElement('path', { d: 'M39.7764762,43.1922723 L39.7764762,43.1922723 C39.8898095,43.1922723 39.9974286,43.1698043 40.0955238,43.1286128 C39.9974286,43.1698043 39.8898095,43.1922723 39.7764762,43.1922723 L39.7764762,43.1922723 Z M0.860285714,22.9822298 L5.4012381,9.88801702 L0.860285714,22.9822298 C0.839333333,23.044017 0.826,23.1067404 0.820285714,23.1704 C0.826,23.1067404 0.839333333,23.044017 0.860285714,22.9822298 L0.860285714,22.9822298 Z M19.8231429,4.78120851 C19.8240952,4.67074043 19.8479048,4.56588936 19.8898095,4.4704 C19.8479048,4.56588936 19.8240952,4.67074043 19.8231429,4.78120851 L19.8231429,4.78120851 Z M26.8469524,4.47695319 C26.7640952,4.28410213 26.6069524,4.12963404 26.4107619,4.04818723 C26.6069524,4.12963404 26.7640952,4.28410213 26.8469524,4.47695319 L26.8469524,4.47695319 Z M29.618381,16.4842723 L42.8050476,3.25993191 L55.9907619,16.4842723 L29.618381,16.4842723 Z M38.9574286,33.4542298 L38.9574286,41.5811234 L30.0012381,41.5811234 L30.0012381,18.0954213 L55.6079048,18.0954213 L55.6079048,41.5811234 L46.6517143,41.5811234 L46.6517143,33.4542298 C46.6517143,33.0086128 46.2850476,32.6481872 45.8317143,32.6481872 L39.7764762,32.6481872 C39.3240952,32.6481872 38.9574286,33.0086128 38.9574286,33.4542298 L38.9574286,33.4542298 Z M5.78504762,41.5811234 L28.3621905,41.5811234 L28.3621905,24.0475915 L5.78504762,24.0475915 L5.78504762,41.5811234 Z M21.4526667,9.34316596 L25.2726667,9.34316596 L25.2726667,5.5956766 L21.4526667,5.5956766 L21.4526667,9.34316596 Z M2.7812381,22.4364426 L6.76314286,10.9543149 L32.838381,10.9543149 L27.0821905,16.7267404 C26.8507619,16.9579745 26.7840952,17.3024851 26.9117143,17.6020596 C27.0393333,17.901634 27.3374286,18.0954213 27.6669524,18.0954213 L28.3621905,18.0954213 L28.3621905,22.4364426 L2.7812381,22.4364426 Z M43.3898095,1.54580426 L58.5269524,16.7267404 L43.3898095,1.54580426 C43.313619,1.46810213 43.2221905,1.40818723 43.1221905,1.36699574 C43.2221905,1.40818723 43.313619,1.46810213 43.3898095,1.54580426 L43.3898095,1.54580426 Z M59.0564762,16.2165277 L43.9193333,1.03559149 C43.6269524,0.742570213 43.2212381,0.574995745 42.8050476,0.574995745 C42.3879048,0.574995745 41.9821905,0.743506383 41.6907619,1.03559149 L34.1326667,8.61482553 L27.6526667,8.61482553 L27.6526667,4.78963404 C27.6526667,3.94427234 26.9526667,3.25618723 26.0917143,3.25618723 L20.6421905,3.25618723 C19.7917143,3.25618723 19.0917143,3.93584681 19.0812381,4.77278298 L19.0812381,8.61482553 L6.17742857,8.61482553 C5.50790476,8.61482553 4.91457143,9.03235745 4.69933333,9.65397447 L0.159333333,22.7472511 C-0.00352380952,23.2144 0.0745714286,23.7339745 0.366952381,24.1355915 C0.659333333,24.5372085 1.13361905,24.7768681 1.63647619,24.7768681 L3.40504762,24.7768681 L3.40504762,42.3862298 C3.40504762,43.2325277 4.10504762,43.9206128 4.966,43.9206128 L39.7764762,43.9206128 C40.6374286,43.9206128 41.3374286,43.2325277 41.3374286,42.3862298 L41.3374286,34.9876766 L44.2707619,34.9876766 L44.2707619,42.3862298 C44.2707619,43.2325277 44.9717143,43.9206128 45.8317143,43.9206128 L56.4279048,43.9206128 C57.2879048,43.9206128 57.9888571,43.2325277 57.9888571,42.3862298 L57.9888571,18.8237617 C58.5993333,18.8059745 59.1421905,18.4408681 59.3802857,17.8838468 C59.6240952,17.312783 59.4974286,16.6584 59.0564762,16.2165277 L59.0564762,16.2165277 Z' })
                )
            )
        ),
        imageUri && _react2.default.createElement('div', { className: 'SearchCard__image', style: { backgroundImage: 'url(' + imageUri + ')' } }),
        _react2.default.createElement(
            'div',
            { className: 'SearchCard__content' },
            _react2.default.createElement(
                'div',
                { className: 'SearchCard__title h3' },
                title
            ),
            startDate && endDate && _react2.default.createElement(
                'div',
                { className: 'SearchCard__dates small' },
                startDate + ' \u2013 ' + endDate
            ),
            _react2.default.createElement(
                'div',
                { className: 'SearchCard__bottom-bar' },
                _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _HOUSE__.HOUSE__16, className: 'SearchCard__icon' }),
                _react2.default.createElement(
                    'small',
                    { className: 'SearchCard__count' },
                    count
                )
            )
        )
    );
}

SearchCard.propTypes = {
    count: _propTypes2.default.number,
    endDate: _propTypes2.default.string,
    id: _propTypes2.default.string,
    imageUri: _propTypes2.default.string,
    startDate: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    position: _propTypes2.default.number
};

exports.default = SearchCard;
//# sourceMappingURL=SearchCard.js.map

/***/ }),

/***/ "lIME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lLC2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

module.exports = {
  DatePicker: __webpack_require__("w5KI").default,
  DateRangePicker: __webpack_require__("a67U").default,
  dateUtils: __webpack_require__("pkO5")
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "lMBm":
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__("6o+p"),
    flatRest = __webpack_require__("2N6f"),
    getData = __webpack_require__("wKps"),
    getFuncName = __webpack_require__("K96V"),
    isArray = __webpack_require__("NGEn"),
    isLaziable = __webpack_require__("5DDM");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),

/***/ "lVWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Overlay = exports.Marker = exports.injectMap = exports.GoogleMap = exports.Circle = undefined;

var _Circle = __webpack_require__("rZOV");

var _Circle2 = _interopRequireDefault(_Circle);

var _GoogleMap = __webpack_require__("u9ZQ");

var _GoogleMap2 = _interopRequireDefault(_GoogleMap);

var _injectMap = __webpack_require__("wkAJ");

var _injectMap2 = _interopRequireDefault(_injectMap);

var _Marker = __webpack_require__("O+Vf");

var _Marker2 = _interopRequireDefault(_Marker);

var _Overlay = __webpack_require__("Kxgp");

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Circle = _Circle2.default;
exports.GoogleMap = _GoogleMap2.default;
exports.injectMap = _injectMap2.default;
exports.Marker = _Marker2.default;
exports.Overlay = _Overlay2.default; /**
                                      * This index.js file is the entry point for your component and
                                      * is referenced from package.json. It's best to keep it lightweight
                                      * and do all of your work in component and subcomponent files.
                                     **/
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "lYoF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("gPAl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PriceSummary = function (_Component) {
    _inherits(PriceSummary, _Component);

    function PriceSummary() {
        _classCallCheck(this, PriceSummary);

        return _possibleConstructorReturn(this, (PriceSummary.__proto__ || Object.getPrototypeOf(PriceSummary)).apply(this, arguments));
    }

    _createClass(PriceSummary, [{
        key: 'render',
        value: function render() {
            var priceSummary = this.props.priceSummary;


            if (priceSummary) {
                var formattedAmount = priceSummary.formattedAmount,
                    pricePeriodDescription = priceSummary.pricePeriodDescription;

                return _react2.default.createElement(
                    'span',
                    { className: 'PriceSummary' },
                    _react2.default.createElement(
                        'strong',
                        { className: 'PriceSummary__amount' },
                        formattedAmount
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'PriceSummary__period' },
                        pricePeriodDescription
                    )
                );
            }

            return null;
        }
    }]);

    return PriceSummary;
}(_react.Component);

PriceSummary.propTypes = {
    priceSummary: _propTypes2.default.shape({
        /** Price, already formatted for a locale  */
        formattedAmount: _propTypes2.default.string.isRequired,
        /** String describing the period of the price (per night, avg/night, total, etc) */
        pricePeriodDescription: _propTypes2.default.string.isRequired,
        /** EDAP event payload fully describing the 'price.summary.display' event for this priceSummary */
        edapEventJson: _propTypes2.default.string.isRequired
    })
};
exports.default = PriceSummary;
//# sourceMappingURL=PriceSummary.js.map

/***/ }),

/***/ "lmMP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = auth;

var _constants = __webpack_require__("hXMO");

function auth() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var type = action.type,
        payload = action.payload;

    switch (type) {
        case _constants.SET_HAV:
            return { hav: payload.hav };
        default:
            return state;
    }
}
//# sourceMappingURL=auth.js.map

/***/ }),

/***/ "lpBX":
/***/ (function(module, exports) {

/**
 * Calendar constructor
 *
 * @param   {Object}  options               Calendar options
 *   @param {Object}  options.startDate     Date object indicating the selected start date
 *   @param {Object}  options.endDate       Date object indicating the selected end date
 *   @param {Boolean} options.siblingMonths Calculate dates from sibling months (before and after the current month, based on weekStart)
 *   @param {Boolean} options.weekNumbers   Caclulate the week days
 *   @param {Number}  options.weekStart     Day of the week to start the calendar, respects `Date.prototype.getDay` (defaults to `0`, Sunday)
 */
function Calendar (options) {
	options = options || {};

	this.startDate = options.startDate;
	this.endDate = options.endDate;
	this.siblingMonths = options.siblingMonths;
	this.weekNumbers = options.weekNumbers;
	this.weekStart = options.weekStart;

	if (this.weekStart === undefined) {
		this.weekStart = 0;
	}
}

/**
 * Calculate a calendar month
 *
 * @param  {Number} year  Year
 * @param  {Number} month Month [0-11]
 * @return {Array}        Calendar days
 */
Calendar.prototype.getCalendar = function (year, month) {
	var date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));

	year = date.getUTCFullYear();
	month = date.getUTCMonth();

	var calendar = [],
		firstDay = date.getUTCDay(),

		firstDate = - (((7 - this.weekStart) + firstDay) % 7),
		lastDate = Calendar.daysInMonth(year, month),
		lastDay = ((lastDate - firstDate) % 7),
		lastDatePreviousMonth = Calendar.daysInMonth(year, month - 1),
		i = firstDate,
		max = (lastDate - i) + (lastDay != 0 ? 7 - lastDay : 0) + firstDate,
		currentDay,
		currentDate,
		currentDateObject,
		currentWeekNumber = null,
		otherMonth,
		otherYear;

	while (i < max) {
		currentDate = i + 1;
		currentDay = ((i < 1 ? 7 + i : i) + firstDay) % 7;
		if (currentDate < 1 || currentDate > lastDate) {
			if (this.siblingMonths) {
				if (currentDate < 1) {
					otherMonth = month - 1;
					otherYear = year;
					if (otherMonth < 0) {
						otherMonth = 11;
						otherYear --;
					}
					currentDate = lastDatePreviousMonth + currentDate;
				}
				else if (currentDate > lastDate) {
					otherMonth = month + 1;
					otherYear = year;
					if (otherMonth > 11) {
						otherMonth = 0;
						otherYear ++;
					}
					currentDate = i - lastDate + 1;
				}
				currentDateObject = {
					day: currentDate,
					weekDay: currentDay,
					month: otherMonth,
					year: otherYear,
					siblingMonth: true
				};
			}
			else {
				currentDateObject = false;
			}
		}
		else {
			currentDateObject = {
				day: currentDate,
				weekDay: currentDay,
				month: month,
				year: year
			};
		}

		if (currentDateObject && this.weekNumbers) {
			if (currentWeekNumber === null) {
				currentWeekNumber = Calendar.calculateWeekNumber(currentDateObject);
			}
			else if (currentDay == 1 && currentWeekNumber == 52) {
				currentWeekNumber = 1;
			}
			else if (currentDay == 1) {
				currentWeekNumber ++;
			}
			currentDateObject.weekNumber = currentWeekNumber;
		}

		if (currentDateObject && this.startDate) {
			currentDateObject.selected = this.isDateSelected(currentDateObject);
		}

		calendar.push(currentDateObject);
		i ++;
	}

	return calendar;
};

/**
 * Checks if a date is selected
 *
 * @param  {Object}  date Date object
 * @return {Boolean}      Selected status of the date
 */
Calendar.prototype.isDateSelected = function (date) {
	if (date.year == this.startDate.year && date.month == this.startDate.month && date.day == this.startDate.day) {
		return true;
	}
	else if (this.endDate) {
		if (date.year == this.startDate.year && date.month == this.startDate.month && date.day < this.startDate.day) {
			return false;
		}
		else if (date.year == this.endDate.year && date.month == this.endDate.month && date.day > this.endDate.day) {
			return false;
		}
		else if (date.year == this.startDate.year && date.month < this.startDate.month) {
			return false;
		}
		else if (date.year == this.endDate.year && date.month > this.endDate.month) {
			return false;
		}
		else if (date.year < this.startDate.year) {
			return false;
		}
		else if (date.year > this.endDate.year) {
			return false;
		}
		return true;
	}
	return false;
};

/**
 * Sets the selected period start
 *
 * @param {Object} date Date object
 */
Calendar.prototype.setStartDate = function (date) {
	this.startDate = date;
};

/**
 * Sets the selected period end
 *
 * @param {Object} date Date object
 */
Calendar.prototype.setEndDate = function (date) {
	this.endDate = date;
};

/**
 * Sets one selected date
 *
 * @param {Object} date Date object
 */
Calendar.prototype.setDate = Calendar.prototype.setStartDate;

/**
 * Calculates the difference between two dates (date1 - date2), in days
 *
 * @param  {Object} date1 Date object
 * @param  {Object} date2 Date object
 * @return {Number}       Days between the dates
 */
Calendar.diff = function (date1, date2) {
	date1 = new Date(Date.UTC(date1.year, date1.month, date1.day, 0, 0, 0, 0));
	date2 = new Date(Date.UTC(date2.year, date2.month, date2.day, 0, 0, 0, 0));
	return Math.ceil((date1.getTime() - date2.getTime()) / 86400000);
};

/**
 * Calculates the interval between two dates
 *
 * @param  {Object} date1 Date object
 * @param  {Object} date2 Date object
 * @return {Number}       Number of days
 */
Calendar.interval = function (date1, date2) {
	return Math.abs(Calendar.diff(date1, date2)) + 1;
};

/**
 * Quickly compare two dates
 *
 * @param  {Object} leftDate  Left date
 * @param  {Object} rightDate Right date
 * @return {Number}           Comparison result: -1 (left < right), 0 (equal) or 1 (left > right)
 */
Calendar.compare = function (leftDate, rightDate) {
	if (typeof leftDate != 'object' || typeof rightDate != 'object' || leftDate === null || rightDate === null) {
		throw new TypeError('dates must be objects');
	}

	if (leftDate.year < rightDate.year) {
		return -1;
	} else if (leftDate.year > rightDate.year) {
		return 1;
	} else if (leftDate.month < rightDate.month) {
		return -1;
	} else if (leftDate.month > rightDate.month) {
		return 1;
	} else if (leftDate.day < rightDate.day) {
		return -1;
	} else if (leftDate.day > rightDate.day) {
		return 1;
	}

	return 0;
}

/**
 * Calculates the number of days in a month
 *
 * @param  {Number} year  Year
 * @param  {Number} month Month [0-11]
 * @return {Number}       Length of the month
 */
Calendar.daysInMonth = function (year, month) {
	return new Date(year, month + 1, 0).getDate();
};

/**
 * Calculates if a given year is a leap year
 *
 * @param  {Number}  year Year
 * @return {Boolean}      Leap year or not
 */
Calendar.isLeapYear = function (year) {
	return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}

/**
 * Calculates the week number for a given date
 *
 * @param  {Object} date Date object
 * @return {Number}      Week number
 */
// Adapted from http://techblog.procurios.nl/k/news/view/33796/14863/calculate-iso-8601-week-and-year-in-javascript.html
Calendar.calculateWeekNumber = function (date) {
	// Creates the requested date
	var current = new Date(Date.UTC(date.year, date.month, date.day, 0, 0, 0, 0));

	// Create a copy of the object
	var target = new Date(current.valueOf());

	// ISO week date weeks start on monday so correct the day number
	var dayNr = (current.getUTCDay() + 6) % 7;

	// ISO 8601 states that week 1 is the week with the first thursday of that
	// year. Set the target date to the thursday in the target week.
	target.setUTCDate(target.getUTCDate() - dayNr + 3);

	// Store the millisecond value of the target date
	var firstThursday = target.valueOf();

	// Set the target to the first thursday of the year

	// First set the target to january first
	target.setUTCMonth(0, 1);

	// Not a thursday? Correct the date to the next thursday
	if (target.getUTCDay() != 4) {
		target.setUTCMonth(0, 1 + ((4 - target.getUTCDay()) + 7) % 7);
	}

	// The weeknumber is the number of weeks between the  first thursday of the
	// year and the thursday in the target week.
	// 604800000 = 7 * 24 * 3600 * 1000
	return 1 + Math.ceil((firstThursday - target) / 604800000);
}

/**
 * Exports the Calendar
 */
module.exports = { Calendar: Calendar };


/***/ }),

/***/ "lu7F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lulc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lx7a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("sGP0");
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),

/***/ "m+HC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optimisticNewTripBoardResponse = exports.handleOnMutationError = exports.handleOnMutationComplete = exports.addTripBoardToCache = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactApollo = __webpack_require__("3zLD");

var _graphql = __webpack_require__("qm98");

var _edap = __webpack_require__("H/Ty");

var _edap2 = _interopRequireDefault(_edap);

var _TripBoard = __webpack_require__("Dtfn");

var _TripBoard2 = _interopRequireDefault(_TripBoard);

var _withFetchPreviews = __webpack_require__("+TD/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var addTripBoardToCache = exports.addTripBoardToCache = function addTripBoardToCache(hav, pageSize, listingPageSize) {
    return function (proxy, response) {
        var data = response.data;


        var cache = (0, _withFetchPreviews.readPreviewsCache)(proxy, hav, pageSize, listingPageSize);
        if (cache && data && data.createTripBoard && cache.paginatedTripBoards) {
            cache.paginatedTripBoards.tripBoards = [_extends({}, data.createTripBoard)].concat(_toConsumableArray(cache.paginatedTripBoards.tripBoards));

            (0, _withFetchPreviews.writePreviewsCache)(proxy, hav, pageSize, listingPageSize, cache);
        }
    };
};

var handleOnMutationComplete = exports.handleOnMutationComplete = function handleOnMutationComplete(listingId) {
    return function (data) {
        var createTripBoard = data && data.createTripBoard || {};
        var uuid = createTripBoard.uuid,
            stay = createTripBoard.stay,
            listings = createTripBoard.listings,
            name = createTripBoard.name;

        var _ref = stay || {},
            adultCount = _ref.adultCount,
            childrenCount = _ref.childrenCount,
            petsIncluded = _ref.petsIncluded;

        var _ref2 = stay && stay.dateRange || {},
            arrival = _ref2.arrival,
            departure = _ref2.departure;

        var firstListing = listings && listings[0] || {};
        var firstImage = firstListing.images && firstListing.images[0] && firstListing.images[0].c6_uri || '';
        _TripBoard2.default.confirm(name, firstImage, listingId, uuid);
        _edap2.default.boardSaved(true, adultCount, childrenCount, petsIncluded, arrival, departure, listingId, uuid);
        _edap2.default.create(uuid, listingId);
    };
};

var handleOnMutationError = exports.handleOnMutationError = function handleOnMutationError(listingId) {
    return function () {
        _TripBoard2.default.showCreateError(listingId);
        _edap2.default.boardCreateError(listingId);
    };
};

var optimisticNewTripBoardResponse = exports.optimisticNewTripBoardResponse = function optimisticNewTripBoardResponse(name, listingRefs, stay, thumbnailUrl) {
    var reducedListings = listingRefs.map(function (listingId) {
        return {
            __typename: 'Listing',
            listingId: listingId,
            images: [{ __typename: 'Image', c6_uri: thumbnailUrl, width: 800, height: 600 }]
        };
    });
    var newStay = _extends({ __typename: 'Stay' }, stay);
    if (newStay.dateRange) {
        newStay.dateRange.__typename = 'StayDateRange';
    }
    return {
        createTripBoard: {
            __typename: 'createTripBoard',
            uuid: -1,
            name: name,
            stay: newStay,
            listings: reducedListings,
            listingRefs: listingRefs
        }
    };
};

var withCreateNewTripBoard = (0, _reactApollo.graphql)(_graphql.createNewTripboardMutation, {
    options: function options(_ref3) {
        var mutationConfig = _ref3.mutationConfig,
            listingId = _ref3.listingId;
        return _extends({}, mutationConfig, {
            onError: handleOnMutationError(listingId),
            onCompleted: handleOnMutationComplete(listingId)
        });
    },
    name: 'createTripBoard',
    alias: 'withCreateNewTripBoardMutation'
});

exports.default = withCreateNewTripBoard;
//# sourceMappingURL=with-create-new-trip-board.js.map

/***/ }),

/***/ "m1bQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mSTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getEnv */
/* unused harmony export isEnv */
/* harmony export (immutable) */ __webpack_exports__["b"] = isProduction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDevelopment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTest;
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    // default environment
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("W2nU")))

/***/ }),

/***/ "mTAn":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "mZVS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToasterSvgs = function (_Component) {
    _inherits(ToasterSvgs, _Component);

    function ToasterSvgs() {
        _classCallCheck(this, ToasterSvgs);

        return _possibleConstructorReturn(this, (ToasterSvgs.__proto__ || Object.getPrototypeOf(ToasterSvgs)).apply(this, arguments));
    }

    _createClass(ToasterSvgs, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "svg",
                { display: "none", width: "0", height: "0", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                _react2.default.createElement(
                    "defs",
                    null,
                    _react2.default.createElement(
                        "symbol",
                        { id: "toast-x", viewBox: "0 0 18 18" },
                        _react2.default.createElement(
                            "title",
                            null,
                            'x'
                        ),
                        _react2.default.createElement(
                            "g",
                            { transform: "translate(1.000000, 1.000000)" },
                            _react2.default.createElement("path", { d: "M0.444444444,0.444444444 L15.5293891,15.5293891" }),
                            _react2.default.createElement("path", { d: "M15.5293891,0.444444444 L0.444444444,15.5293891" })
                        )
                    )
                )
            );
        }
    }]);

    return ToasterSvgs;
}(_react.Component);

exports.default = ToasterSvgs;
//# sourceMappingURL=ToasterSvgs.js.map

/***/ }),

/***/ "mc59":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mgkl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _dateUtils = __webpack_require__("SCsJ");

var _dateUtils2 = _interopRequireDefault(_dateUtils);

__webpack_require__("Xcr0");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line complexity
function DaySelection(_ref) {
    var day = _ref.day,
        selectionStart = _ref.selectionStart,
        selectionEnd = _ref.selectionEnd,
        selectedDate = _ref.selectedDate,
        hoverDate = _ref.hoverDate,
        simple = _ref.simple,
        dayTemplate = _ref.dayTemplate,
        ariaLabelDate = _ref.ariaLabelDate;

    if (!day) {
        return false;
    }

    var isSingleDate = false;
    var isBoundStart = false;
    var isBoundEnd = false;
    var isTween = false;

    var compare = _dateUtils2.default.compareDateStrings;

    var dayContent = dayTemplate || _react2.default.createElement(
        'div',
        { className: 'date', 'aria-hidden': 'true' },
        _react2.default.createElement(
            'p',
            { className: 'hidden' },
            ariaLabelDate
        ),
        day.day
    );

    if (selectedDate && compare(selectedDate, day.dateString) === 0) {
        isSingleDate = true;
    } else if (hoverDate && compare(hoverDate, day.dateString) === 0 && selectionStart && compare(selectionStart, day.dateString) >= 0) {
        isBoundEnd = true;
    } else if (selectionStart && compare(selectionStart, day.dateString) === 0) {
        isBoundStart = true;
    } else if (selectionEnd && compare(selectionEnd, day.dateString) === 0) {
        isBoundEnd = true;
    } else if (selectionStart && selectionEnd && compare(selectionStart, day.dateString) > 0 && compare(selectionEnd, day.dateString) < 0) {
        isTween = true;
    } else if (selectionStart && hoverDate && compare(selectionStart, day.dateString) > 0 && compare(hoverDate, day.dateString) <= 0) {
        isTween = true;
    }

    var isBound = isBoundStart || isBoundEnd || isSingleDate;

    var tweenClasses = (0, _classnames2.default)({
        'tween': !(isBound && !simple && isSingleDate),
        'start': isBoundStart && simple,
        'end': isBoundEnd && simple,
        'hidden': !hoverDate && !selectionEnd
    });

    if (isBound || isTween) {
        return _react2.default.createElement(
            'div',
            { 'aria-selected': 'true', className: 'selection' },
            !isBound && _react2.default.createElement('div', { className: tweenClasses }),
            isBound && _react2.default.createElement(
                'div',
                { className: 'bound bg-brand text-white' },
                dayContent
            ),
            !isBound && dayContent
        );
    }

    return dayContent;
}

DaySelection.defaultProps = { isSelected: function isSelected() {} };

exports.default = DaySelection;
//# sourceMappingURL=DaySelection.js.map

/***/ }),

/***/ "mgnk":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "n6Q6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nC2W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectiveLocation = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

exports.DirectiveLocation = DirectiveLocation;

/***/ }),

/***/ "nF8R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUS__16 = void 0;
var PLUS__16 = '<svg data-id="SVG_PLUS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 12.5v-9M12.5 8h-9" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
exports.PLUS__16 = PLUS__16;

/***/ }),

/***/ "nTj+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TripBoardButton = __webpack_require__("zq7B");

var _TripBoardButton2 = _interopRequireDefault(_TripBoardButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function is here so we can pull the ReactDOM.render logic out of stab-hit and PDP.
function renderTripBoardButton(element, props) {
    return _reactDom2.default.render(_react2.default.createElement(_TripBoardButton2.default, props), element);
}

exports.default = renderTripBoardButton;
//# sourceMappingURL=RenderTripBoardButton.js.map

/***/ }),

/***/ "nb0Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("2Zwn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ "nclR":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("Wdy1");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("NMac").set });


/***/ }),

/***/ "oA90":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

module.exports = __webpack_require__("Yzt6").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "oUFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p0bc":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "pAW9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHEVRON_LEFT__16 = void 0;
var CHEVRON_LEFT__16 = '<svg data-id="SVG_CHEVRON_LEFT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M10 13L5.4 8 10 3"/></svg>';
exports.CHEVRON_LEFT__16 = CHEVRON_LEFT__16;

/***/ }),

/***/ "pDqy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pEGt":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("DvwR");
var enumBugKeys = __webpack_require__("B5V0");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pJz2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pkO5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocaleConsolidatedDateString = exports.getLocaleDateString = exports.getMonthYear = undefined;

var _LanguageTag = __webpack_require__("eS3o");

var _LanguageTag2 = _interopRequireDefault(_LanguageTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _locale = 'en-US';
var _languageTag = new _LanguageTag2.default(_locale);

/**
 * Helper for getting year and month from date string
 * 
 * @param {String} dateString   Date string in yyy-mm-dd format
 * @return {Object} {month, year}
 */
function getMonthYear(dateString) {
    if (dateString) {
        var dateElems = dateString.split('-');
        return { month: +dateElems[1] - 1, year: +dateElems[0] };
    }

    var today = new Date();
    return { month: today.getMonth(), year: today.getFullYear() };
}

/**
 * Helper for getting string with a language sensitive representation of the date portion of this date.
 * 
 * @param {String} dateString   Date string in yyy-mm-dd format
 * @param {String} locale   Moniker or BCP-47 language tag (fr_FR_HA|fr-FR)
 * @param {Object} options  Date.prototype.toLocaleDateString() options ( https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString)
 * @return {String} Language sensitive representation of the date portion of 
 */
function getLocaleDateString(dateString, locale, options) {
    locale = locale || _locale;
    if (!dateString) {
        return '';
    }

    if (locale !== _locale) {
        _locale = locale;
        _languageTag = new _LanguageTag2.default(_locale);
    }
    var parts = dateString.split('-');
    var dateObj = new Date(parts[0], parts[1] - 1, parts[2]);
    return dateObj.toLocaleDateString(_languageTag.code, options);
}

/**
 * Helper for getting language sensitive representation of the date range.
 * 
 * @param {String} startDateString   Date string in yyy-mm-dd format
 * @param {String} endDateString   Date string in yyy-mm-dd format
 * @param {String} locale   Moniker or BCP-47 language tag (fr_FR_HA|fr-FR)
 * @param {Object} options  Date.prototype.toLocaleDateString() options ( https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString)
 * @return {String} Language sensitive representation of the date portion of 
 */
function getLocaleConsolidatedDateString(startDateString, endDateString, locale) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // eslint-disable-line complexity
    if (!startDateString || !endDateString) {
        return getLocaleDateString(startDateString || endDateString, locale, options);
    }

    var startDate = getLocaleDateString(startDateString, locale, options);
    var endDate = getLocaleDateString(endDateString, locale, options);
    var sameMonth = startDateString.split('-')[1] === endDateString.split('-')[1];
    var dedupeMonth = Object.keys(options).length === 2 && !!options.day && !!options.month;

    if (sameMonth && dedupeMonth) {
        var startDateDate = getLocaleDateString(startDateString, locale, { day: 'numeric' });
        var endDateDate = getLocaleDateString(endDateString, locale, { day: 'numeric' });

        // Use "Sep 5 - 30" or "05. - 30. Sep."
        var isDecimalDay = startDate.indexOf(startDateDate + '.') >= 0;
        var formattedDateRange = startDate.replace(startDateDate, '' + startDateDate + (isDecimalDay ? '.' : '') + ' - ' + endDateDate);
        return formattedDateRange;
    }

    // Use "mmm dd - mmm dd" or "mm/dd/yyyy - mm/dd/yyyy"
    return startDate + ' - ' + endDate;
}

exports.getMonthYear = getMonthYear;
exports.getLocaleDateString = getLocaleDateString;
exports.getLocaleConsolidatedDateString = getLocaleConsolidatedDateString;
//# sourceMappingURL=dateUtils.js.map

/***/ }),

/***/ "pxCC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PRICE_SUMMARY_DISPLAY_EVENT = undefined;
exports.default = edapTriggerPriceSummaryDisplay;

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRICE_SUMMARY_DISPLAY_EVENT = exports.PRICE_SUMMARY_DISPLAY_EVENT = 'price.summary.display';

/**
 * Given a priceSummary returned by graphql-traveler-opas, triggers an EDAP
 * event asserting that the priceSummary has been displayed to the user.
 * @param {TravelerPricesSummary} priceSummary
 * @param edapOptions
 * @throws {Error} Throws if `priceSummary.edapEventJson` is missing or malformed
 */
function edapTriggerPriceSummaryDisplay(priceSummary, options) {
    var edapEvent = void 0;
    try {
        edapEvent = JSON.parse(priceSummary.edapEventJson);
    } catch (e) {
        throw new Error('Bad or missing edapEventJson for priceSummary');
    }
    (0, _edapWrapper2.default)().push({
        name: PRICE_SUMMARY_DISPLAY_EVENT,
        data: edapEvent,
        options: options
    });
}
//# sourceMappingURL=edapTriggerPriceSummaryDisplay.js.map

/***/ }),

/***/ "q4WY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Returns true if passed an object
function isObject(obj) {
    return obj === Object(obj);
}

// Return true if passed an empty object
function isEmptyObject(obj) {
    return isObject(obj) && Object.keys(obj).length === 0;
}

// If object x has key y which is an array of length z, return that array
function getObjectKeyOfLength(obj, key, length) {
    if (!isObject(obj)) {
        return null;
    }
    return obj[key] && obj[key].length === length ? obj[key] : null;
}

exports.isObject = isObject;
exports.isEmptyObject = isEmptyObject;
exports.getObjectKeyOfLength = getObjectKeyOfLength;
//# sourceMappingURL=Objects.js.map

/***/ }),

/***/ "qP7s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TripBoardHit = __webpack_require__("Y86b");

var _TripBoardHit2 = _interopRequireDefault(_TripBoardHit);

__webpack_require__("REiz");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddToTripBoard(_ref) {
    var onTripBoardClicked = _ref.onTripBoardClicked,
        tripBoards = _ref.tripBoards;

    var tripBoardHits = tripBoards.map(function (tripBoard, index) {
        var boardId = tripBoard.boardId,
            name = tripBoard.name,
            _tripBoard$listings = tripBoard.listings,
            listings = _tripBoard$listings === undefined ? [] : _tripBoard$listings;

        var thumbnails = listings.filter(function (listing) {
            return listing && listing.images;
        }).reduce(function (currentThumbnails, listing) {
            return currentThumbnails.concat([listing.images[0].c6_uri]);
        }, []);

        var onClick = function onClick(event) {
            onTripBoardClicked(event, boardId);
        };

        return _react2.default.createElement(_TripBoardHit2.default, {
            key: 'trip-board-hit-' + index,
            onClick: onClick,
            tripBoardTitle: name,
            thumbnails: thumbnails
        });
    });

    return _react2.default.createElement(
        'div',
        { className: 'react-trip-board-button__add-to' },
        tripBoardHits
    );
}

AddToTripBoard.propTypes = {
    onTripBoardClicked: _propTypes2.default.func,
    tripBoards: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

AddToTripBoard.defaultProps = {
    onTripBoardClicked: function onTripBoardClicked() {},
    tripBoards: []
};

exports.default = AddToTripBoard;
//# sourceMappingURL=AddToTripBoard.js.map

/***/ }),

/***/ "qWiE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("e4Gq");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Arrow(props) {
    var arrowBackgroundColor = props.arrowBackgroundColor,
        className = props.className,
        children = props.children,
        refCallback = props.refCallback,
        style = props.style,
        viewBox = props.viewBox,
        rest = _objectWithoutProperties(props, ['arrowBackgroundColor', 'className', 'children', 'refCallback', 'style', 'viewBox']); // eslint-disable-line no-unused-vars


    return _react2.default.createElement(
        'button',
        _extends({}, rest, {
            className: (0, _classnames2.default)('horizontal-scroll-button', 'btn', 'btn-empty', className),
            ref: refCallback,
            style: _extends({}, style, { opacity: 1 })
        }),
        _react2.default.createElement(
            'span',
            { className: 'horizontal-scroll-button-content' },
            _react2.default.createElement(
                'svg',
                { viewBox: viewBox },
                children
            )
        )
    );
}

Arrow.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    refCallback: _propTypes2.default.func,
    style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    viewBox: _propTypes2.default.string
};

exports.default = Arrow;
//# sourceMappingURL=Arrow.js.map

/***/ }),

/***/ "qm98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dataIdFromObjectForTripboard = exports.transformTripboardData = exports.removeUnitFromTripBoardsMutation = exports.updateStayMutation = exports.createNewTripboardMutation = exports.addToTripboardMutation = exports.fetchPreviewsQuery = undefined;

var _queries = __webpack_require__("OdER");

var _tripboards = __webpack_require__("slQZ");

var _dataIdFromObjectForTripBoard = __webpack_require__("kgUV");

var _dataIdFromObjectForTripBoard2 = _interopRequireDefault(_dataIdFromObjectForTripBoard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.fetchPreviewsQuery = _queries.fetchPreviewsQuery;
exports.addToTripboardMutation = _queries.addToTripboardMutation;
exports.createNewTripboardMutation = _queries.createNewTripboardMutation;
exports.updateStayMutation = _queries.updateStayMutation;
exports.removeUnitFromTripBoardsMutation = _queries.removeUnitFromTripBoardsMutation;
exports.transformTripboardData = _tripboards.transformTripboardData;
exports.dataIdFromObjectForTripboard = _dataIdFromObjectForTripBoard2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "qngo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if ("object" !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafrex/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports.default = detectPassiveEvents;

/***/ }),

/***/ "qojq":
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__("lMBm");

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),

/***/ "qrdl":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "qs+f":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zyKz")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "r3+g":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var anObject = __webpack_require__("FKWp");
var getKeys = __webpack_require__("pEGt");

module.exports = __webpack_require__("qs+f") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "r6wq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

module.exports = __webpack_require__("c/7n").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "r94d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Constructs a localization data object by parsing either a moniker or BCP-47
 * language tag. The constructed object will be composed of the following
 * properties:
 *      data: Original passed in value.
 *      brand: Brand variant (eg. HA, VRBO).
 *      code: BCP-47 style validated language tag (ie. no brand variant).
 *      language: The language of the locale (ie. en). ISO 639.
 *      region: The country code (ie. US). ISO 3166-1.
 * @param {string} locale - A moniker or BCP-47 language code.
 */
function LanguageTag(locale) {
    locale = locale ? locale.trim() : '';
    var tags = locale.split(/_|-/);

    this.data = locale;
    this.language = tags[0] && tags[0].length === 2 ? tags[0] : null;
    this.region = tags.length > 1 && tags[1] && tags[1].length === 2 ? tags[1] : null;
    this.brand = tags.length > 2 && tags[2] ? tags[2] : null;

    // Validate a BCP-47 style language tag based on the language and region.
    try {
        var code = this.language && this.region ? this.language + '-' + this.region : this.language;
        var validLocale = Intl.DateTimeFormat.supportedLocalesOf([code]);
        this.code = validLocale && validLocale.length === 1 ? validLocale[0] : null;
    } catch (e) {
        // Ignore error, code will be undefined.
    }
}

module.exports = LanguageTag;
//# sourceMappingURL=LanguageTag.js.map

/***/ }),

/***/ "rCVp":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("1C79");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ "rKx+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ajQ");
var $Object = __webpack_require__("iANj").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "rSCM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HeartIcon;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("6aXM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeartIcon(_ref) {
    var iconClass = _ref.iconClass,
        iconClassBg = _ref.iconClassBg,
        isAbacusLoadingTestOn = _ref.isAbacusLoadingTestOn,
        isModalHeart = _ref.isModalHeart;

    var bkgdIconClass = 'react-trip-board-button__heart-core-bg ' + iconClassBg;
    var height = '15px';
    var viewBox = '-1 -1 18 15';
    var width = '17px';

    if (isAbacusLoadingTestOn) {
        height = '40px';
        viewBox = '-10 -12 36 35';
        width = '40px';
    }

    return _react2.default.createElement(
        'div',
        { className: 'react-trip-board-button__heart-core' },
        _react2.default.createElement(
            'svg',
            {
                height: height,
                viewBox: viewBox,
                width: width
            },
            !isModalHeart && _react2.default.createElement('path', {
                className: bkgdIconClass,
                d: 'M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z'
            }),
            _react2.default.createElement('path', {
                className: iconClass,
                d: 'M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z'
            })
        )
    );
}
//# sourceMappingURL=HeartIcon.js.map

/***/ }),

/***/ "rZOV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global google */

var Circle = function (_PureComponent) {
    _inherits(Circle, _PureComponent);

    function Circle(props) {
        _classCallCheck(this, Circle);

        var _this = _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).call(this, props));

        var id = props.id,
            onClick = props.onClick,
            rest = _objectWithoutProperties(props, ['id', 'onClick']);

        var circle = new google.maps.Circle(rest);

        google.maps.event.addListener(circle, 'click', function () {
            onClick(id);
        });

        _this.circle = circle;
        return _this;
    }

    _createClass(Circle, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                id = _props.id,
                map = _props.map,
                onClick = _props.onClick,
                rest = _objectWithoutProperties(_props, ['id', 'map', 'onClick']); // eslint-disable-line no-unused-vars


            this.circle.setOptions(rest);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            /* Remove all marker listeners */
            google.maps.event.clearInstanceListeners(this.circle);

            /* Remove circle */
            this.circle.setMap(null);
        }
    }, {
        key: 'render',
        value: function render() {
            return false;
        }
    }]);

    return Circle;
}(_react.PureComponent);

Circle.propTypes = {
    /** Unique identifier for the circle */
    id: _propTypes2.default.string.isRequired,
    /** Reference to the map (injected by default if wrapped in GoogleMap component) */
    map: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** Callback for clicking on the circle */
    onClick: _propTypes2.default.func,
    /** Stroke color of the outer radius */
    strokeColor: _propTypes2.default.string,
    /** Stroke opacity of the outer radius */
    strokeOpacity: _propTypes2.default.number,
    /** Stroke weight of the outer radius */
    strokeWeight: _propTypes2.default.number,
    /** Fill color of the inner circle */
    fillColor: _propTypes2.default.string,
    /** Fill opacity of the inner circle */
    fillOpacity: _propTypes2.default.number,
    /** Center of the circle */
    center: _propTypes2.default.shape({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }).isRequired,
    radius: _propTypes2.default.number.isRequired
};
Circle.defaultProps = {
    onClick: /* istanbul ignore next */function onClick() {},
    fillColor: '#0067db', // @ha-core-blue
    fillOpacity: 0.5,
    radius: 500,
    strokeWeight: 0
};
exports.default = Circle;
//# sourceMappingURL=Circle.js.map

/***/ }),

/***/ "rjjF":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("bSeU");
var createDesc = __webpack_require__("YTz9");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var has = __webpack_require__("x//u");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("qs+f") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "rpn+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rprB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ "rvLH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("w0I2");

var _reactButtons = __webpack_require__("HfJ9");

var _CHEVRON_LEFT__ = __webpack_require__("pAW9");

var _CHEVRON_RIGHT__ = __webpack_require__("Jq3D");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Controls(props) {
    var isMobile = props.isMobile,
        className = props.className,
        enabled = props.enabled,
        numMonths = props.numMonths,
        i18n = props.i18n;


    var dataWdio = props.wdioPrefix ? props.wdioPrefix + '-calendar-controls' : 'calendar-controls';

    var isMobileSingleMonth = isMobile && enabled;
    var isDesktopSingleMonth = !isMobile && numMonths === 1;
    var isDesktopMultiMonth = !isMobile && numMonths > 1;

    var parentClasses = (0, _classnames2.default)('', {
        'cal-controls__calendar-parent--top-single': isMobileSingleMonth,
        'cal-controls__calendar-parent--middle-single': isDesktopSingleMonth,
        'cal-controls__calendar-parent--middle-multi': isDesktopMultiMonth
    });

    var buttonClasses = (0, _classnames2.default)('cal-controls__button', {
        'cal-controls__button--top': isMobileSingleMonth,
        'cal-controls__button--middle': isDesktopSingleMonth || isDesktopMultiMonth
    });

    if (enabled) {
        return _react2.default.createElement(
            'div',
            { role: 'application', className: (className || '') + ' cal-controls clearfix', 'data-wdio': dataWdio },
            _react2.default.createElement(
                'div',
                { className: (buttonClasses || '') + ' cal-controls__button--prev text-center' },
                _react2.default.createElement(_reactButtons.ButtonIcon, { label: i18n.ariaLabelPrevButton, circle: true, svgMarkup: _CHEVRON_LEFT__.CHEVRON_LEFT__16, size: 'sm', className: 'btn-hover-zoom', onClick: props.onPrevClicked, disabled: !props.canRetreat })
            ),
            _react2.default.createElement(
                'div',
                { className: '' + (parentClasses || '') },
                props.children
            ),
            _react2.default.createElement(
                'div',
                { className: (buttonClasses || '') + ' cal-controls__button--next text-center' },
                _react2.default.createElement(_reactButtons.ButtonIcon, { label: i18n.ariaLabelNextButton, circle: true, svgMarkup: _CHEVRON_RIGHT__.CHEVRON_RIGHT__16, size: 'sm', className: 'btn-hover-zoom', onClick: props.onNextClicked, disabled: !props.canAdvance })
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: (className || '') + ' cal-controls--empty', 'data-wdio': dataWdio },
        props.children
    );
}

exports.default = Controls;
//# sourceMappingURL=Controls.js.map

/***/ }),

/***/ "rwgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_d3276433b58c8a2853f4
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_d3276433b58c8a2853f4
var prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_d3276433b58c8a2853f4
var react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// CONCATENATED MODULE: ./node_modules/rc-hammerjs/es/Hammer.js








// https://github.com/hammerjs/hammer.js/issues/930
// https://github.com/JedWatson/react-hammerjs/issues/14
// require('hammerjs') when in a browser. This is safe because Hammer is only
// invoked in componentDidMount, which is not executed on the server.
var Hammer =  true ? __webpack_require__("rxKx") : undefined;

var privateProps = {
	children: true,
	direction: true,
	options: true,
	recognizeWith: true,
	vertical: true
};

/**
 * Hammer Component
 * ================
 */

var handlerToEvent = {
	action: 'tap press',
	onDoubleTap: 'doubletap',
	onPan: 'pan',
	onPanCancel: 'pancancel',
	onPanEnd: 'panend',
	onPanStart: 'panstart',
	onPinch: 'pinch',
	onPinchCancel: 'pinchcancel',
	onPinchEnd: 'pinchend',
	onPinchIn: 'pinchin',
	onPinchOut: 'pinchout',
	onPinchStart: 'pinchstart',
	onPress: 'press',
	onPressUp: 'pressup',
	onRotate: 'rotate',
	onRotateCancel: 'rotatecancel',
	onRotateEnd: 'rotateend',
	onRotateMove: 'rotatemove',
	onRotateStart: 'rotatestart',
	onSwipe: 'swipe',
	onSwipeRight: 'swiperight',
	onSwipeLeft: 'swipeleft',
	onSwipeUp: 'swipeup',
	onSwipeDown: 'swipedown',
	onTap: 'tap'
};

Object.keys(handlerToEvent).forEach(function (i) {
	privateProps[i] = true;
});

function updateHammer(hammer, props) {
	var _this = this;

	if (props.hasOwnProperty('vertical')) {
		console.warn('vertical is deprecated, please use `direction` instead');
	}

	var directionProp = props.direction;
	if (directionProp || props.hasOwnProperty('vertical')) {
		var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
		hammer.get('pan').set({ direction: Hammer[direction] });
		hammer.get('swipe').set({ direction: Hammer[direction] });
	}

	if (props.options) {
		Object.keys(props.options).forEach(function (option) {
			if (option === 'recognizers') {
				Object.keys(props.options.recognizers).forEach(function (gesture) {
					var recognizer = hammer.get(gesture);
					recognizer.set(props.options.recognizers[gesture]);
					if (props.options.recognizers[gesture].requireFailure) {
						recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
					}
				}, _this);
			} else {
				var key = option;
				var optionObj = {};
				optionObj[key] = props.options[option];
				hammer.set(optionObj);
			}
		}, this);
	}

	if (props.recognizeWith) {
		Object.keys(props.recognizeWith).forEach(function (gesture) {
			var recognizer = hammer.get(gesture);
			recognizer.recognizeWith(props.recognizeWith[gesture]);
		}, this);
	}

	Object.keys(props).forEach(function (p) {
		var e = handlerToEvent[p];
		if (e) {
			hammer.off(e);
			hammer.on(e, props[p]);
		}
	});
}

var Hammer_HammerComponent = function (_React$Component) {
	inherits_default()(HammerComponent, _React$Component);

	function HammerComponent() {
		classCallCheck_default()(this, HammerComponent);

		return possibleConstructorReturn_default()(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
	}

	createClass_default()(HammerComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.hammer = new Hammer(react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.findDOMNode(this));
			updateHammer(this.hammer, this.props);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.hammer) {
				updateHammer(this.hammer, this.props);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.hammer) {
				this.hammer.stop();
				this.hammer.destroy();
			}
			this.hammer = null;
		}
	}, {
		key: 'render',
		value: function render() {
			var props = {};

			Object.keys(this.props).forEach(function (i) {
				if (!privateProps[i]) {
					props[i] = this.props[i];
				}
			}, this);

			// Reuse the child provided
			// This makes it flexible to use whatever element is wanted (div, ul, etc)
			return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.cloneElement(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Children.only(this.props.children), props);
		}
	}]);

	return HammerComponent;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Component);

Hammer_HammerComponent.displayName = 'Hammer';
Hammer_HammerComponent.propTypes = {
	className: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};
/* harmony default export */ var es_Hammer = (Hammer_HammerComponent);
// CONCATENATED MODULE: ./node_modules/rc-hammerjs/es/index.js


/* harmony default export */ var es = __webpack_exports__["default"] = (es_Hammer);

/***/ }),

/***/ "rxKx":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),

/***/ "sGP0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__("GiK3");

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),

/***/ "sNwG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactButtons = __webpack_require__("HfJ9");

var _reactSvg = __webpack_require__("Ye17");

var _HEART_SELECTED__ = __webpack_require__("OFFT");

var _AddToTripBoard = __webpack_require__("qP7s");

var _AddToTripBoard2 = _interopRequireDefault(_AddToTripBoard);

var _AddToTripBoardNewModal = __webpack_require__("Ib78");

var _AddToTripBoardNewModal2 = _interopRequireDefault(_AddToTripBoardNewModal);

var _CreateTripBoard = __webpack_require__("3ZWP");

var _CreateTripBoard2 = _interopRequireDefault(_CreateTripBoard);

var _CreateTripBoardNewModal = __webpack_require__("Ho0a");

var _CreateTripBoardNewModal2 = _interopRequireDefault(_CreateTripBoardNewModal);

var _constants = __webpack_require__("hXMO");

var _edap = __webpack_require__("H/Ty");

var _edap2 = _interopRequireDefault(_edap);

var _TripBoardNewModal = __webpack_require__("KYm/");

var _TripBoardNewModal2 = _interopRequireDefault(_TripBoardNewModal);

var _reactModal = __webpack_require__("XSjK");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _abacusClientUtils = __webpack_require__("k4AA");

var _abacusClientUtils2 = _interopRequireDefault(_abacusClientUtils);

__webpack_require__("Pvdb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TripBoardModalContainer = function (_Component) {
    _inherits(TripBoardModalContainer, _Component);

    function TripBoardModalContainer(props) {
        _classCallCheck(this, TripBoardModalContainer);

        var _this = _possibleConstructorReturn(this, (TripBoardModalContainer.__proto__ || Object.getPrototypeOf(TripBoardModalContainer)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            isEditing: true,
            isOpen: false,
            caret: null,
            listingId: null,
            position: null,
            currentView: _constants.CREATE_BOARD,
            newBoardName: '',
            isNewModalTestOn: false,
            heartPosition: null,
            tripBoards: [],
            translations: {},
            onCreate: function onCreate() {},
            onAdd: function onAdd() {},
            onClose: function onClose() {}
        };
        return _this;
    }

    _createClass(TripBoardModalContainer, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                isNewModalTestOn = _state.isNewModalTestOn,
                isOpen = _state.isOpen,
                position = _state.position,
                translations = _state.translations;
            var _props = this.props,
                className = _props.className,
                id = _props.id;


            if (isNewModalTestOn) {
                className = 'react-trip-board-button__new-modal';
                id = 'react-trip-board-button-new-modal';
            }

            return _react2.default.createElement(
                _reactModal2.default,
                {
                    id: id,
                    className: className,
                    title: this.renderTitle(),
                    translations: translations,
                    onClose: this.onClose,
                    position: position,
                    isOpen: isOpen
                },
                this.renderContent()
            );
        }
    }]);

    return TripBoardModalContainer;
}(_react.Component);

TripBoardModalContainer.defaultProps = {
    className: 'react-trip-board-button__modal',
    id: 'react-trip-board-button-modal'
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.componentWillMount = function () {
        var isNewModalTestOn = "object" !== 'undefined' && typeof window.__ABACUS__ !== 'undefined' ? _abacusClientUtils2.default.evaluateExperiment(_constants.NEW_MODAL).value > 0 : false;

        _this2.setState({
            isNewModalTestOn: isNewModalTestOn
        });
    };

    this.handleAddNewTripBoard = function () {
        _this2.setState({
            currentView: _constants.CREATE_BOARD,
            isEditing: true
        });

        _edap2.default.boardCreateClick(_this2.state.listingId);
    };

    this.handleAdd = function (e, boardId) {
        _this2.state.onAdd(_this2.state.addToBoard, boardId);
    };

    this.handleNameChange = function (event) {
        // todo set flag for first input and then handle
        _this2.setState({
            newBoardName: event.target.value,
            isEditing: true
        });
    };

    this.createIsDisabled = function () {
        var trimmendLength = _this2.state.newBoardName.trim().length;
        return trimmendLength < 1 || trimmendLength > _constants.MAX_TRIPBOARD_NAME_LENGTH;
    };

    this.handleClickCancel = function () {
        var _state2 = _this2.state,
            listingId = _state2.listingId,
            newBoardName = _state2.newBoardName;

        _edap2.default.boardCreateCancel(listingId, newBoardName);

        _this2.setState({
            currentView: _constants.ADD_TO_BOARD,
            newBoardName: '',
            isEditing: false
        });
    };

    this.handleModalClose = function () {
        var _state3 = _this2.state,
            currentView = _state3.currentView,
            listingId = _state3.listingId,
            newBoardName = _state3.newBoardName;

        var isCreateBoard = currentView === _constants.CREATE_BOARD;

        if (isCreateBoard) {
            _edap2.default.boardCreateDismiss(listingId, newBoardName);
        } else {
            _edap2.default.boardAddDismiss(listingId);
        }

        // Closing the modal and changing the view at the same time will
        // cause the view change to happen before the modal is closed.
        // In react-modal there is a setTimeout for 500ms while the modal fades out.
        // Set timeout for 501ms before changing the state of the open view to ensure the modal is closed.
        setTimeout(function () {
            _this2.setState(function () {
                return {
                    currentView: _this2.props.tripBoards && _this2.props.tripBoards.length > 0 ? _constants.ADD_TO_BOARD : _constants.CREATE_BOARD,
                    newBoardName: '',
                    isEditing: false
                };
            });
        }, 501);
    };

    this.handleClickCreate = function (event) {
        event.preventDefault();
        if (_this2.createIsDisabled()) {
            return;
        }
        var _state4 = _this2.state,
            createBoard = _state4.createBoard,
            listingId = _state4.listingId,
            newBoardName = _state4.newBoardName;

        _this2.state.onCreate(createBoard, newBoardName);

        _edap2.default.boardCreate(listingId, newBoardName);
    };

    this.close = function () {
        _this2.setState({ isOpen: false });
    };

    this.open = function (props) {
        var noop = function noop() {};

        var listingId = props.listingId,
            position = props.position,
            refButton = props.refButton,
            thumbnailUrl = props.thumbnailUrl,
            tripBoards = props.tripBoards,
            onCreate = props.onCreate,
            onAdd = props.onAdd,
            onClose = props.onClose,
            createBoard = props.createBoard,
            addToBoard = props.addToBoard,
            translations = props.translations,
            rating = props.rating,
            headline = props.headline,
            reviewCount = props.reviewCount;


        var currentView = tripBoards.length > 0 ? _constants.ADD_TO_BOARD : _constants.CREATE_BOARD;
        var isEditing = currentView === _constants.CREATE_BOARD;

        _this2.setState({
            isEditing: isEditing,
            isOpen: true,
            currentView: currentView,
            newBoardName: '',

            // callbacks
            onCreate: onCreate || noop,
            onAdd: onAdd || noop,
            onClose: onClose || noop,

            // actions
            createBoard: createBoard,
            addToBoard: addToBoard,

            // lingua translations
            translations: translations,

            // button props
            listingId: listingId,
            position: position,
            refButton: refButton,
            thumbnailUrl: thumbnailUrl,
            tripBoards: tripBoards,
            rating: rating,
            headline: headline,
            reviewCount: reviewCount
        });
    };

    this.onClose = function () {
        _this2.close();
        _this2.handleModalClose();
        _this2.state.onClose();
    };

    this.renderContent = function () {
        var _state5 = _this2.state,
            currentView = _state5.currentView,
            newBoardName = _state5.newBoardName,
            isNewModalTestOn = _state5.isNewModalTestOn,
            tripBoards = _state5.tripBoards,
            translations = _state5.translations,
            rating = _state5.rating,
            headline = _state5.headline,
            reviewCount = _state5.reviewCount,
            thumbnailUrl = _state5.thumbnailUrl;


        var innerContent = !isNewModalTestOn ? _react2.default.createElement(_AddToTripBoard2.default, { tripBoards: tripBoards, translations: translations, onTripBoardClicked: _this2.handleAdd }) : _react2.default.createElement(
            _TripBoardNewModal2.default,
            {
                rating: rating,
                headline: headline,
                reviewCount: reviewCount,
                thumbnailUrl: thumbnailUrl
            },
            _react2.default.createElement(_AddToTripBoardNewModal2.default, {
                tripBoards: tripBoards,
                translations: translations,
                onTripBoardClicked: _this2.handleAdd,
                onCreateBoardClicked: _this2.handleAddNewTripBoard
            })
        );

        if (currentView === _constants.CREATE_BOARD) {
            innerContent = !isNewModalTestOn ? _react2.default.createElement(_CreateTripBoard2.default, {
                handleClickCancel: _this2.handleClickCancel,
                handleClickCreate: _this2.handleClickCreate,
                newBoardName: newBoardName,
                onNameChange: _this2.handleNameChange,
                showCancel: tripBoards.length > 0,
                translations: translations,
                createIsDisabled: _this2.createIsDisabled()
            }) : _react2.default.createElement(
                _TripBoardNewModal2.default,
                {
                    rating: rating,
                    headline: headline,
                    reviewCount: reviewCount,
                    thumbnailUrl: thumbnailUrl
                },
                _react2.default.createElement(_CreateTripBoardNewModal2.default, {
                    handleClickCancel: _this2.handleClickCancel,
                    handleClickCreate: _this2.handleClickCreate,
                    newBoardName: newBoardName,
                    onNameChange: _this2.handleNameChange,
                    showCancel: tripBoards.length > 0,
                    translations: translations,
                    createIsDisabled: _this2.createIsDisabled()
                })
            );
        }
        return innerContent;
    };

    this.renderTitle = function () {
        var _state6 = _this2.state,
            currentView = _state6.currentView,
            isNewModalTestOn = _state6.isNewModalTestOn,
            translations = _state6.translations,
            tripBoards = _state6.tripBoards;

        var title = currentView === _constants.CREATE_BOARD ? translations['tripboards.modal.create.new.list.copy'] : translations['tripboards.modal.add.to'];
        var createButtonText = translations['tripboards.modal.create.new.list'] || '';
        var emptyState = translations['tripboards.main.empty.state'];
        var heartMessages = emptyState && emptyState.split('{heart}');
        var createNewButton = _react2.default.createElement(
            'div',
            { className: 'react-trip-board-button__create', onClick: _this2.handleAddNewTripBoard, role: 'button' },
            _react2.default.createElement(
                _reactButtons.ButtonIcon,
                { className: 'react-trip-board-button__create-button', circle: true, label: createButtonText },
                _react2.default.createElement(
                    'svg',
                    { className: 'react-trip-board-button__create-svg-plus', viewBox: '0 0 50 50' },
                    _react2.default.createElement('path', { d: 'M50 22H28V0h-6v22H0v6h22v22h6V28h22' })
                )
            ),
            _react2.default.createElement(
                'span',
                { className: 'react-trip-board-button__create-label' },
                createButtonText
            )
        );

        return _react2.default.createElement(
            'div',
            { className: 'react-trip-board-button__title' },
            _react2.default.createElement(
                'h2',
                { className: 'react-trip-board-button__title-text' },
                title
            ),
            tripBoards.length <= 0 && currentView === _constants.CREATE_BOARD && isNewModalTestOn && _react2.default.createElement(
                'div',
                { className: 'react-trip-board-button__cta-text' },
                heartMessages,
                ' ',
                _react2.default.createElement(_reactSvg.SVGIcon, {
                    inlineFlex: true,
                    markup: _HEART_SELECTED__.HEART_SELECTED__16,
                    className: 'react-trip-board-button__cta_heart'
                })
            ),
            currentView !== _constants.CREATE_BOARD && !isNewModalTestOn && createNewButton
        );
    };
};

exports.default = TripBoardModalContainer;
//# sourceMappingURL=TripBoardModalContainer.js.map

/***/ }),

/***/ "sWRA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sgb3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("YSwN"))(14);

/***/ }),

/***/ "shmE":
/***/ (function(module, exports) {

var hasOwnProperty = Object.prototype.hasOwnProperty

module.exports = PseudoMap

function PseudoMap (set) {
  if (!(this instanceof PseudoMap)) // whyyyyyyy
    throw new TypeError("Constructor PseudoMap requires 'new'")

  this.clear()

  if (set) {
    if ((set instanceof PseudoMap) ||
        (typeof Map === 'function' && set instanceof Map))
      set.forEach(function (value, key) {
        this.set(key, value)
      }, this)
    else if (Array.isArray(set))
      set.forEach(function (kv) {
        this.set(kv[0], kv[1])
      }, this)
    else
      throw new TypeError('invalid argument')
  }
}

PseudoMap.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  Object.keys(this._data).forEach(function (k) {
    if (k !== 'size')
      fn.call(thisp, this._data[k].value, this._data[k].key)
  }, this)
}

PseudoMap.prototype.has = function (k) {
  return !!find(this._data, k)
}

PseudoMap.prototype.get = function (k) {
  var res = find(this._data, k)
  return res && res.value
}

PseudoMap.prototype.set = function (k, v) {
  set(this._data, k, v)
}

PseudoMap.prototype.delete = function (k) {
  var res = find(this._data, k)
  if (res) {
    delete this._data[res._index]
    this._data.size--
  }
}

PseudoMap.prototype.clear = function () {
  var data = Object.create(null)
  data.size = 0

  Object.defineProperty(this, '_data', {
    value: data,
    enumerable: false,
    configurable: true,
    writable: false
  })
}

Object.defineProperty(PseudoMap.prototype, 'size', {
  get: function () {
    return this._data.size
  },
  set: function (n) {},
  enumerable: true,
  configurable: true
})

PseudoMap.prototype.values =
PseudoMap.prototype.keys =
PseudoMap.prototype.entries = function () {
  throw new Error('iterators are not implemented in this version')
}

// Either identical, or both NaN
function same (a, b) {
  return a === b || a !== a && b !== b
}

function Entry (k, v, i) {
  this.key = k
  this.value = v
  this._index = i
}

function find (data, k) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k))
      return data[key]
  }
}

function set (data, k, v) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k)) {
      data[key].value = v
      return
    }
  }
  data.size++
  data[key] = new Entry(k, v, key)
}


/***/ }),

/***/ "slQZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var transformTripboardData = exports.transformTripboardData = function transformTripboardData(paginatedTripBoards) {
    var transformedData = {};
    transformedData.boards = paginatedTripBoards && paginatedTripBoards.tripBoards ? paginatedTripBoards.tripBoards.map(function (tripboard) {
        return _extends({}, tripboard, { boardId: tripboard.uuid });
    }) : [];

    return transformedData;
};
//# sourceMappingURL=tripboards.js.map

/***/ }),

/***/ "t/I/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locatedError = locatedError;

var _GraphQLError = __webpack_require__("QmgZ");

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new _GraphQLError.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),

/***/ "t5lc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tRR0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecentActivityStateless = exports.RecentActivityContainer = exports.RecentActivity = undefined;

var _RecentActivity = __webpack_require__("Aq9S");

var _RecentActivity2 = _interopRequireDefault(_RecentActivity);

var _RecentActivityContainer = __webpack_require__("1sG0");

var _RecentActivityContainer2 = _interopRequireDefault(_RecentActivityContainer);

var _RecentActivityStateless = __webpack_require__("ZmSW");

var _RecentActivityStateless2 = _interopRequireDefault(_RecentActivityStateless);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RecentActivity = _RecentActivity2.default;
exports.RecentActivityContainer = _RecentActivityContainer2.default;
exports.RecentActivityStateless = _RecentActivityStateless2.default; /**
                                                                      * This index.js file is the entry point for your component and
                                                                      * is referenced from package.json. It's best to keep it lightweight
                                                                      * and do all of your work in component and subcomponent files.
                                                                     **/
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "tYO1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0/jl");
__webpack_require__("gCWN");
__webpack_require__("3ggi");
__webpack_require__("OoWg");
module.exports = __webpack_require__("iANj").Symbol;


/***/ }),

/***/ "tlQw":
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__("6u75");

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

var experimentalFragmentVariables = false;
function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;

module.exports = gql;


/***/ }),

/***/ "tyeG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tz60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("0Lvz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("4dmN")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "u1/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/graphql/language/printer.js
var printer = __webpack_require__("xC4e");
var printer_default = /*#__PURE__*/__webpack_require__.n(printer);

// EXTERNAL MODULE: ./node_modules/apollo-utilities/lib/index.js + 11 modules
var lib = __webpack_require__("+zi7");

// CONCATENATED MODULE: ./node_modules/apollo-client/core/networkStatus.js
/**
 * The current status of a query’s execution in our system.
 */
var NetworkStatus;
(function (NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
//# sourceMappingURL=networkStatus.js.map
// EXTERNAL MODULE: ./node_modules/apollo-link/lib/index.js + 4 modules
var apollo_link_lib = __webpack_require__("uekS");

// CONCATENATED MODULE: ./node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

// CONCATENATED MODULE: ./node_modules/symbol-observable/es/index.js
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (true) {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var es_result = symbolObservablePonyfill(root);
/* harmony default export */ var es = (es_result);

// CONCATENATED MODULE: ./node_modules/apollo-client/util/Observable.js
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// This simplified polyfill attempts to follow the ECMAScript Observable proposal.
// See https://github.com/zenparsing/es-observable


// rxjs interopt
var Observable_Observable = (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[es] = function () {
        return this;
    };
    return Observable;
}(apollo_link_lib["b" /* Observable */]));

//# sourceMappingURL=Observable.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/errors/ApolloError.js
var ApolloError___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var generateErrorMessage = function (err) {
    var message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    ApolloError___extends(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        Object.setPrototypeOf(_this, ApolloError.prototype);
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=ApolloError.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/core/types.js
var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
//# sourceMappingURL=types.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/core/ObservableQuery.js
var ObservableQuery___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue &&
        ((storeValue.graphQLErrors &&
            storeValue.graphQLErrors.length > 0 &&
            policy === 'none') ||
            storeValue.networkError);
};
var ObservableQuery_ObservableQuery = (function (_super) {
    ObservableQuery___extends(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var scheduler = _a.scheduler, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        // active state
        _this.isCurrentlyPolling = false;
        _this.isTornDown = false;
        // query information
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = scheduler.queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        // related classes
        _this.scheduler = scheduler;
        _this.queryManager = scheduler.queryManager;
        // interal data stores
        _this.observers = [];
        _this.subscriptionHandles = [];
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            var subscription;
            var observer = {
                next: function (result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    if (!that.observers.some(function (obs) { return obs !== observer; })) {
                        that.queryManager.removeQuery(that.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: function (error) {
                    reject(error);
                },
            };
            subscription = that.subscribe(observer);
        });
    };
    /**
     * Return the result of the query from the local cache as well as some fetching status
     * `loading` and `networkStatus` allow to know if a request is in flight
     * `partial` lets you know if the result from the local cache is complete or partial
     * @return {result: Object, loading: boolean, networkStatus: number, partial: boolean}
     */
    ObservableQuery.prototype.currentResult = function () {
        if (this.isTornDown) {
            return {
                data: this.lastError ? {} : this.lastResult ? this.lastResult.data : {},
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error,
            };
        }
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        if (hasError(queryStoreValue, this.options.errorPolicy)) {
            return {
                data: {},
                loading: false,
                networkStatus: queryStoreValue.networkStatus,
                error: new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }),
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryLoading = !queryStoreValue ||
            queryStoreValue.networkStatus === NetworkStatus.loading;
        // We need to be careful about the loading state we show to the user, to try
        // and be vaguely in line with what the user would have seen from .subscribe()
        // but to still provide useful information synchronously when the query
        // will not end up hitting the server.
        // See more: https://github.com/apollostack/apollo-client/issues/707
        // Basically: is there a query in flight right now (modolo the next tick)?
        var loading = (this.options.fetchPolicy === 'network-only' && queryLoading) ||
            (partial && this.options.fetchPolicy !== 'cache-only');
        // if there is nothing in the query store, it means this query hasn't fired yet or it has been cleaned up. Therefore the
        // network status is dependent on queryLoading.
        var networkStatus;
        if (queryStoreValue) {
            networkStatus = queryStoreValue.networkStatus;
        }
        else {
            networkStatus = loading ? NetworkStatus.loading : NetworkStatus.ready;
        }
        var result = {
            data: data,
            loading: isNetworkRequestInFlight(networkStatus),
            networkStatus: networkStatus,
        };
        if (queryStoreValue &&
            queryStoreValue.graphQLErrors &&
            this.options.errorPolicy === 'all') {
            result.errors = queryStoreValue.graphQLErrors;
        }
        if (!partial) {
            var stale = false;
            this.lastResult = __assign({}, result, { stale: stale });
        }
        return __assign({}, result, { partial: partial });
    };
    // Returns the last result that observer.next was called with. This is not the same as
    // currentResult! If you're not sure which you need, then you probably need currentResult.
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        // early return if trying to read from cache during refetch
        if (fetchPolicy === 'cache-only') {
            return Promise.reject(new Error('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (!Object(lib["q" /* isEqual */])(this.variables, variables)) {
            // update observable variables
            this.variables = __assign({}, this.variables, variables);
        }
        if (!Object(lib["q" /* isEqual */])(this.options.variables, this.variables)) {
            // Update the existing options with new variables
            this.options.variables = __assign({}, this.options.variables, this.variables);
        }
        // Override fetchPolicy for this call only
        // only network-only and no-cache are safe to use
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        var combinedOptions = __assign({}, this.options, { fetchPolicy: isNetworkFetchPolicy ? fetchPolicy : 'network-only' });
        return this.queryManager
            .fetchQuery(this.queryId, combinedOptions, FetchType.refetch)
            .then(function (result) { return Object(lib["x" /* maybeDeepFreeze */])(result); });
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        // early return if no update Query
        if (!fetchMoreOptions.updateQuery) {
            throw new Error('updateQuery option is required. This function defines how to update the query data with the new results.');
        }
        return Promise.resolve()
            .then(function () {
            var qid = _this.queryManager.generateQueryId();
            var combinedOptions;
            if (fetchMoreOptions.query) {
                // fetch a new query
                combinedOptions = fetchMoreOptions;
            }
            else {
                // fetch the same query with a possibly new variables
                combinedOptions = __assign({}, _this.options, fetchMoreOptions, { variables: __assign({}, _this.variables, fetchMoreOptions.variables) });
            }
            combinedOptions.fetchPolicy = 'network-only';
            return _this.queryManager.fetchQuery(qid, combinedOptions, FetchType.normal, _this.queryId);
        })
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult, _a) {
                var variables = _a.variables;
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: variables,
                });
            });
            return fetchMoreResult;
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (data) {
                if (options.updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return options.updateQuery(previous, {
                            subscriptionData: data,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                console.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptionHandles.push(subscription);
        return function () {
            var i = _this.subscriptionHandles.indexOf(subscription);
            if (i >= 0) {
                _this.subscriptionHandles.splice(i, 1);
                subscription.unsubscribe();
            }
        };
    };
    // Note: if the query is not active (there are no subscribers), the promise
    // will return null immediately.
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldOptions = this.options;
        this.options = __assign({}, this.options, opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        // If fetchPolicy went from cache-only to something else, or from something else to network-only
        var tryFetch = (oldOptions.fetchPolicy !== 'network-only' &&
            opts.fetchPolicy === 'network-only') ||
            (oldOptions.fetchPolicy === 'cache-only' &&
                opts.fetchPolicy !== 'cache-only') ||
            (oldOptions.fetchPolicy === 'standby' &&
                opts.fetchPolicy !== 'standby') ||
            false;
        return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. If you want to force new results, use `refetch`.
     *
     * Note: if the variables have not changed, the promise will return the old
     * results immediately, and the `next` callback will *not* fire.
     *
     * Note: if the query is not active (there are no subscribers), the promise
     * will return null immediately.
     *
     * @param variables: The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     *
     * @param tryFetch: Try and fetch new results even if the variables haven't
     * changed (we may still just hit the store, but if there's nothing in there
     * this will refetch)
     *
     * @param fetchResults: Option to ignore fetching results when updating variables
     *
     */
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        // since setVariables restarts the subscription, we reset the tornDown status
        this.isTornDown = false;
        var newVariables = variables ? variables : this.variables;
        if (Object(lib["q" /* isEqual */])(newVariables, this.variables) && !tryFetch) {
            // If we have no observers, then we don't actually want to make a network
            // request. As soon as someone observes the query, the request will kick
            // off. For now, we just store any changes. (See #1077)
            if (this.observers.length === 0 || !fetchResults) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.result();
        }
        else {
            this.lastVariables = this.variables;
            this.variables = newVariables;
            this.options.variables = newVariables;
            // See comment above
            if (this.observers.length === 0) {
                return new Promise(function (resolve) { return resolve(); });
            }
            // Use the same options as before, but with new variables
            return this.queryManager
                .fetchQuery(this.queryId, __assign({}, this.options, { variables: this.variables }))
                .then(function (result) { return Object(lib["x" /* maybeDeepFreeze */])(result); });
        }
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var _a = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(lib["D" /* tryFunctionOrLogError */])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            this.queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            this.queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
            this.isCurrentlyPolling = false;
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        if (this.options.fetchPolicy === 'cache-first' ||
            this.options.fetchPolicy === 'cache-only') {
            throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
        }
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        this.options.pollInterval = pollInterval;
        this.isCurrentlyPolling = true;
        this.scheduler.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        // Zen Observable has its own error function, in order to log correctly
        // we need to declare a custom error if nothing is passed
        if (observer._subscription &&
            observer._subscription._observer &&
            !observer._subscription._observer.error) {
            observer._subscription._observer.error = function (error) {
                console.error('Unhandled error', error.message, error.stack);
            };
        }
        this.observers.push(observer);
        // Deliver initial result
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        // setup the query if it hasn't been done before
        if (this.observers.length === 1)
            this.setUpQuery();
        return function () {
            _this.observers = _this.observers.filter(function (obs) { return obs !== observer; });
            if (_this.observers.length === 0) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        if (this.shouldSubscribe) {
            this.queryManager.addObservableQuery(this.queryId, this);
        }
        if (!!this.options.pollInterval) {
            if (this.options.fetchPolicy === 'cache-first' ||
                this.options.fetchPolicy === 'cache-only') {
                throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
            }
            this.isCurrentlyPolling = true;
            this.scheduler.startPollingQuery(this.options, this.queryId);
        }
        var observer = {
            next: function (result) {
                _this.lastResult = result;
                _this.observers.forEach(function (obs) { return obs.next && obs.next(result); });
            },
            error: function (error) {
                _this.lastError = error;
                _this.observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
        };
        this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        this.isTornDown = true;
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        // stop all active GraphQL subscriptions
        this.subscriptionHandles.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptionHandles = [];
        this.queryManager.removeObservableQuery(this.queryId);
        this.queryManager.stopQuery(this.queryId);
        this.observers = [];
    };
    return ObservableQuery;
}(Observable_Observable));

//# sourceMappingURL=ObservableQuery.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-dedup/lib/dedupLink.js
var dedupLink___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/*
 * Expects context to contain the forceFetch field if no dedup
 */
var dedupLink_DedupLink = /** @class */ (function (_super) {
    dedupLink___extends(DedupLink, _super);
    function DedupLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFlightRequestObservables = new Map();
        _this.subscribers = new Map();
        return _this;
    }
    DedupLink.prototype.request = function (operation, forward) {
        var _this = this;
        // sometimes we might not want to deduplicate a request, for example when we want to force fetch it.
        if (operation.getContext().forceFetch) {
            return forward(operation);
        }
        var key = operation.toKey();
        var cleanup = function (key) {
            _this.inFlightRequestObservables.delete(key);
            var prev = _this.subscribers.get(key);
            return prev;
        };
        if (!this.inFlightRequestObservables.get(key)) {
            // this is a new request, i.e. we haven't deduplicated it yet
            // call the next link
            var singleObserver_1 = forward(operation);
            var subscription_1;
            var sharedObserver = new apollo_link_lib["b" /* Observable */](function (observer) {
                // this will still be called by each subscriber regardless of
                // deduplication status
                var prev = _this.subscribers.get(key);
                if (!prev)
                    prev = { next: [], error: [], complete: [] };
                _this.subscribers.set(key, {
                    next: prev.next.concat([observer.next.bind(observer)]),
                    error: prev.error.concat([observer.error.bind(observer)]),
                    complete: prev.complete.concat([observer.complete.bind(observer)]),
                });
                if (!subscription_1) {
                    subscription_1 = singleObserver_1.subscribe({
                        next: function (result) {
                            var prev = cleanup(key);
                            _this.subscribers.delete(key);
                            if (prev) {
                                prev.next.forEach(function (next) { return next(result); });
                                prev.complete.forEach(function (complete) { return complete(); });
                            }
                        },
                        error: function (error) {
                            var prev = cleanup(key);
                            _this.subscribers.delete(key);
                            if (prev)
                                prev.error.forEach(function (err) { return err(error); });
                        },
                    });
                }
                return function () {
                    if (subscription_1)
                        subscription_1.unsubscribe();
                    _this.inFlightRequestObservables.delete(key);
                };
            });
            this.inFlightRequestObservables.set(key, sharedObserver);
        }
        // return shared Observable
        return this.inFlightRequestObservables.get(key);
    };
    return DedupLink;
}(apollo_link_lib["a" /* ApolloLink */]));

//# sourceMappingURL=dedupLink.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-dedup/lib/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/scheduler/scheduler.js
// The QueryScheduler is supposed to be a mechanism that schedules polling queries such that
// they are clustered into the time slots of the QueryBatcher and are batched together. It
// also makes sure that for a given polling query, if one instance of the query is inflight,
// another instance will not be fired until the query returns or times out. We do this because
// another query fires while one is already in flight, the data will stay in the "loading" state
// even after the first query has returned.
var scheduler___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var scheduler_QueryScheduler = (function () {
    function QueryScheduler(_a) {
        var queryManager = _a.queryManager, ssrMode = _a.ssrMode;
        // Map going from queryIds to query options that are in flight.
        this.inFlightQueries = {};
        // Map going from query ids to the query options associated with those queries. Contains all of
        // the queries, both in flight and not in flight.
        this.registeredQueries = {};
        // Map going from polling interval with to the query ids that fire on that interval.
        // These query ids are associated with a set of options in the this.registeredQueries.
        this.intervalQueries = {};
        // Map going from polling interval widths to polling timers.
        this.pollingTimers = {};
        this.ssrMode = false;
        this.queryManager = queryManager;
        this.ssrMode = ssrMode || false;
    }
    QueryScheduler.prototype.checkInFlight = function (queryId) {
        var query = this.queryManager.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== NetworkStatus.ready &&
            query.networkStatus !== NetworkStatus.error);
    };
    QueryScheduler.prototype.fetchQuery = function (queryId, options, fetchType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queryManager
                .fetchQuery(queryId, options, fetchType)
                .then(function (result) {
                resolve(result);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    QueryScheduler.prototype.startPollingQuery = function (options, queryId, listener) {
        if (!options.pollInterval) {
            throw new Error('Attempted to start a polling query without a polling interval.');
        }
        // Do not poll in SSR mode
        if (this.ssrMode)
            return queryId;
        this.registeredQueries[queryId] = options;
        if (listener) {
            this.queryManager.addQueryListener(queryId, listener);
        }
        this.addQueryOnInterval(queryId, options);
        return queryId;
    };
    QueryScheduler.prototype.stopPollingQuery = function (queryId) {
        // Remove the query options from one of the registered queries.
        // The polling function will then take care of not firing it anymore.
        delete this.registeredQueries[queryId];
    };
    // Fires the all of the queries on a particular interval. Called on a setInterval.
    QueryScheduler.prototype.fetchQueriesOnInterval = function (interval) {
        var _this = this;
        // XXX this "filter" here is nasty, because it does two things at the same time.
        // 1. remove queries that have stopped polling
        // 2. call fetchQueries for queries that are polling and not in flight.
        // TODO: refactor this to make it cleaner
        this.intervalQueries[interval] = this.intervalQueries[interval].filter(function (queryId) {
            // If queryOptions can't be found from registeredQueries or if it has a
            // different interval, it means that this queryId is no longer registered
            // and should be removed from the list of queries firing on this interval.
            //
            // We don't remove queries from intervalQueries immediately in
            // stopPollingQuery so that we can keep the timer consistent when queries
            // are removed and replaced, and to avoid quadratic behavior when stopping
            // many queries.
            if (!(_this.registeredQueries.hasOwnProperty(queryId) &&
                _this.registeredQueries[queryId].pollInterval === interval)) {
                return false;
            }
            // Don't fire this instance of the polling query is one of the instances is already in
            // flight.
            if (_this.checkInFlight(queryId)) {
                return true;
            }
            var queryOptions = _this.registeredQueries[queryId];
            var pollingOptions = scheduler___assign({}, queryOptions);
            pollingOptions.fetchPolicy = 'network-only';
            // don't let unhandled rejections happen
            _this.fetchQuery(queryId, pollingOptions, FetchType.poll).catch(function () { });
            return true;
        });
        if (this.intervalQueries[interval].length === 0) {
            clearInterval(this.pollingTimers[interval]);
            delete this.intervalQueries[interval];
        }
    };
    // Adds a query on a particular interval to this.intervalQueries and then fires
    // that query with all the other queries executing on that interval. Note that the query id
    // and query options must have been added to this.registeredQueries before this function is called.
    QueryScheduler.prototype.addQueryOnInterval = function (queryId, queryOptions) {
        var _this = this;
        var interval = queryOptions.pollInterval;
        if (!interval) {
            throw new Error("A poll interval is required to start polling query with id '" + queryId + "'.");
        }
        // If there are other queries on this interval, this query will just fire with those
        // and we don't need to create a new timer.
        if (this.intervalQueries.hasOwnProperty(interval.toString()) &&
            this.intervalQueries[interval].length > 0) {
            this.intervalQueries[interval].push(queryId);
        }
        else {
            this.intervalQueries[interval] = [queryId];
            // set up the timer for the function that will handle this interval
            this.pollingTimers[interval] = setInterval(function () {
                _this.fetchQueriesOnInterval(interval);
            }, interval);
        }
    };
    // Used only for unit testing.
    QueryScheduler.prototype.registerPollingQuery = function (queryOptions) {
        if (!queryOptions.pollInterval) {
            throw new Error('Attempted to register a non-polling query with the scheduler.');
        }
        return new ObservableQuery_ObservableQuery({
            scheduler: this,
            options: queryOptions,
        });
    };
    return QueryScheduler;
}());

//# sourceMappingURL=scheduler.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/data/mutations.js
var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutationString, variables) {
        this.store[mutationId] = {
            mutationString: mutationString,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = error;
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = null;
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

//# sourceMappingURL=mutations.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/data/queries.js
var queries___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var queries_QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
        if (previousQuery &&
            previousQuery.document !== query.document &&
            Object(printer["print"])(previousQuery.document) !== Object(printer["print"])(query.document)) {
            // XXX we're throwing an error here to catch bugs where a query gets overwritten by a new one.
            // we should implement a separate action for refetching so that QUERY_INIT may never overwrite
            // an existing query (see also: https://github.com/apollostack/apollo-client/issues/732)
            throw new Error('Internal Error: may not update existing query string in store');
        }
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!Object(lib["q" /* isEqual */])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        // TODO break this out into a separate function
        var networkStatus;
        if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
        }
        else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
        }
        else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
            // TODO: can we determine setVariables here if it's a refetch and the variables have changed?
        }
        else {
            networkStatus = NetworkStatus.loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        // XXX right now if QUERY_INIT is fired twice, like in a refetch situation, we just overwrite
        // the store. We probably want a refetch action instead, because I suspect that if you refetch
        // before the initial fetch is done, you'll get an error.
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        // If the action had a `moreForQueryId` property then we need to set the
        // network status on that query as well to `fetchMore`.
        //
        // We have a complement to this if statement in the query result and query
        // error action branch, but importantly *not* in the client result branch.
        // This is because the implementation of `fetchMore` *always* sets
        // `fetchPolicy` to `network-only` so we would never have a client result.
        if (typeof query.fetchMoreForQueryId === 'string') {
            this.store[query.fetchMoreForQueryId].networkStatus =
                NetworkStatus.fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors =
            result.errors && result.errors.length ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        // If we have a `fetchMoreForQueryId` then we need to update the network
        // status for that query. See the branch for query initialization for more
        // explanation about this process.
        if (typeof fetchMoreForQueryId === 'string') {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        // If we have a `fetchMoreForQueryId` then we need to update the network
        // status for that query. See the branch for query initialization for more
        // explanation about this process.
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = complete
            ? NetworkStatus.ready
            : NetworkStatus.loading;
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        // keep only the queries with query ids that are associated with observables
        this.store = Object.keys(this.store)
            .filter(function (queryId) {
            return observableQueryIds.indexOf(queryId) > -1;
        })
            .reduce(function (res, key) {
            // XXX set loading to true so listeners don't trigger unless they want results with partial data
            res[key] = queries___assign({}, _this.store[key], { networkStatus: NetworkStatus.loading });
            return res;
        }, {});
    };
    return QueryStore;
}());

//# sourceMappingURL=queries.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/core/QueryManager.js
var QueryManager___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};













var defaultQueryInfo = {
    listeners: [],
    invalidated: false,
    document: null,
    newData: null,
    lastRequestId: null,
    observableQuery: null,
    subscriptions: [],
};
var QueryManager_QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d;
        this.mutationStore = new MutationStore();
        this.queryStore = new queries_QueryStore();
        // let's not start at zero to avoid pain with bad checks
        this.idCounter = 1;
        // XXX merge with ObservableQuery but that needs to be expanded to support mutations and
        // subscriptions as well
        this.queries = new Map();
        // A map going from a requestId to a promise that has not yet been resolved. We use this to keep
        // track of queries that are inflight and reject them in case some
        // destabalizing action occurs (e.g. reset of the Apollo store).
        this.fetchQueryPromises = new Map();
        // A map going from the name of a query to an observer issued for it by watchQuery. This is
        // generally used to refetches for refetchQueries and to update mutation results through
        // updateQueries.
        this.queryIdsByName = {};
        this.link = link;
        this.deduplicator = apollo_link_lib["a" /* ApolloLink */].from([new dedupLink_DedupLink(), link]);
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.scheduler = new scheduler_QueryScheduler({ queryManager: this, ssrMode: ssrMode });
    }
    QueryManager.prototype.mutate = function (_a) {
        var _this = this;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, updateWithProxyFn = _a.update, _c = _a.errorPolicy, errorPolicy = _c === void 0 ? 'none' : _c, fetchPolicy = _a.fetchPolicy, _d = _a.context, context = _d === void 0 ? {} : _d;
        if (!mutation) {
            throw new Error('mutation option is required. You must specify your GraphQL document in the mutation option.');
        }
        if (fetchPolicy && fetchPolicy !== 'no-cache') {
            throw new Error("fetchPolicy for mutations currently only supports the 'no-cache' policy");
        }
        var mutationId = this.generateQueryId();
        var cache = this.dataStore.getCache();
        (mutation = cache.transformDocument(mutation)),
            (variables = Object(lib["c" /* assign */])({}, Object(lib["e" /* getDefaultValues */])(Object(lib["j" /* getMutationDefinition */])(mutation)), variables));
        var mutationString = Object(printer["print"])(mutation);
        this.setQuery(mutationId, function () { return ({ document: mutation }); });
        // Create a map of update queries by id to the query instead of by name.
        var generateUpdateQueriesInfo = function () {
            var ret = {};
            if (updateQueriesByName) {
                Object.keys(updateQueriesByName).forEach(function (queryName) {
                    return (_this.queryIdsByName[queryName] || []).forEach(function (queryId) {
                        ret[queryId] = {
                            updater: updateQueriesByName[queryName],
                            query: _this.queryStore.get(queryId),
                        };
                    });
                });
            }
            return ret;
        };
        this.mutationStore.initMutation(mutationId, mutationString, variables);
        this.dataStore.markMutationInit({
            mutationId: mutationId,
            document: mutation,
            variables: variables || {},
            updateQueries: generateUpdateQueriesInfo(),
            update: updateWithProxyFn,
            optimisticResponse: optimisticResponse,
        });
        this.broadcastQueries();
        return new Promise(function (resolve, reject) {
            var storeResult;
            var error;
            var operation = _this.buildOperationForLink(mutation, variables, QueryManager___assign({}, context, { optimisticResponse: optimisticResponse }));
            Object(apollo_link_lib["c" /* execute */])(_this.link, operation).subscribe({
                next: function (result) {
                    if (Object(lib["o" /* graphQLResultHasError */])(result) && errorPolicy === 'none') {
                        error = new ApolloError({
                            graphQLErrors: result.errors,
                        });
                        return;
                    }
                    _this.mutationStore.markMutationResult(mutationId);
                    if (fetchPolicy !== 'no-cache') {
                        _this.dataStore.markMutationResult({
                            mutationId: mutationId,
                            result: result,
                            document: mutation,
                            variables: variables || {},
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                        });
                    }
                    storeResult = result;
                },
                error: function (err) {
                    _this.mutationStore.markMutationError(mutationId, err);
                    _this.dataStore.markMutationComplete({
                        mutationId: mutationId,
                        optimisticResponse: optimisticResponse,
                    });
                    _this.broadcastQueries();
                    _this.setQuery(mutationId, function () { return ({ document: undefined }); });
                    reject(new ApolloError({
                        networkError: err,
                    }));
                },
                complete: function () {
                    if (error) {
                        _this.mutationStore.markMutationError(mutationId, error);
                    }
                    _this.dataStore.markMutationComplete({
                        mutationId: mutationId,
                        optimisticResponse: optimisticResponse,
                    });
                    _this.broadcastQueries();
                    if (error) {
                        reject(error);
                        return;
                    }
                    // allow for conditional refetches
                    // XXX do we want to make this the only API one day?
                    if (typeof refetchQueries === 'function')
                        refetchQueries = refetchQueries(storeResult);
                    refetchQueries.forEach(function (refetchQuery) {
                        if (typeof refetchQuery === 'string') {
                            _this.refetchQueryByName(refetchQuery);
                            return;
                        }
                        _this.query({
                            query: refetchQuery.query,
                            variables: refetchQuery.variables,
                            fetchPolicy: 'network-only',
                        });
                    });
                    _this.setQuery(mutationId, function () { return ({ document: undefined }); });
                    if (errorPolicy === 'ignore' &&
                        storeResult &&
                        Object(lib["o" /* graphQLResultHasError */])(storeResult)) {
                        delete storeResult.errors;
                    }
                    resolve(storeResult);
                },
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, 
        // This allows us to track if this is a query spawned by a `fetchMore`
        // call for another query. We need this data to compute the `fetchMore`
        // network status for the query this is fetching for.
        fetchMoreForQueryId) {
        var _this = this;
        var _a = options.variables, variables = _a === void 0 ? {} : _a, _b = options.metadata, metadata = _b === void 0 ? null : _b, _c = options.fetchPolicy, fetchPolicy = _c === void 0 ? 'cache-first' : _c;
        var cache = this.dataStore.getCache();
        var query = cache.transformDocument(options.query);
        var storeResult;
        var needToFetch = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        // If this is not a force fetch, we want to diff the query against the
        // store before we fetch it from the network interface.
        // TODO we hit the cache even if the policy is network-first. This could be unnecessary if the network is up.
        if (fetchType !== FetchType.refetch &&
            fetchPolicy !== 'network-only' &&
            fetchPolicy !== 'no-cache') {
            var _d = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                returnPartialData: true,
                optimistic: false,
            }), complete = _d.complete, result = _d.result;
            // If we're in here, only fetch if we have missing fields
            needToFetch = !complete || fetchPolicy === 'cache-and-network';
            storeResult = result;
        }
        var shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
        // we need to check to see if this is an operation that uses the @live directive
        if (Object(lib["p" /* hasDirectives */])(['live'], query))
            shouldFetch = true;
        var requestId = this.generateRequestId();
        // set up a watcher to listen to cache updates
        var cancel = this.updateQueryWatch(queryId, query, options);
        // Initialize query in store with unique requestId
        this.setQuery(queryId, function () { return ({
            document: query,
            lastRequestId: requestId,
            invalidated: true,
            cancel: cancel,
        }); });
        this.invalidate(true, fetchMoreForQueryId);
        this.queryStore.initQuery({
            queryId: queryId,
            document: query,
            storePreviousVariables: shouldFetch,
            variables: variables,
            isPoll: fetchType === FetchType.poll,
            isRefetch: fetchType === FetchType.refetch,
            metadata: metadata,
            fetchMoreForQueryId: fetchMoreForQueryId,
        });
        this.broadcastQueries();
        // If there is no part of the query we need to fetch from the server (or,
        // fetchPolicy is cache-only), we just write the store result as the final result.
        var shouldDispatchClientResult = !shouldFetch || fetchPolicy === 'cache-and-network';
        if (shouldDispatchClientResult) {
            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
            this.invalidate(true, queryId, fetchMoreForQueryId);
            this.broadcastQueries();
        }
        if (shouldFetch) {
            var networkResult = this.fetchRequest({
                requestId: requestId,
                queryId: queryId,
                document: query,
                options: options,
                fetchMoreForQueryId: fetchMoreForQueryId,
            }).catch(function (error) {
                // This is for the benefit of `refetch` promises, which currently don't get their errors
                // through the store like watchQuery observers do
                if (isApolloError(error)) {
                    throw error;
                }
                else {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    _this.removeFetchQueryPromise(requestId);
                    throw new ApolloError({ networkError: error });
                }
            });
            // we don't return the promise for cache-and-network since it is already
            // returned below from the cache
            if (fetchPolicy !== 'cache-and-network') {
                return networkResult;
            }
            else {
                // however we need to catch the error so it isn't unhandled in case of
                // network error
                networkResult.catch(function () { });
            }
        }
        // If we have no query to send to the server, we should return the result
        // found within the store.
        return Promise.resolve({ data: storeResult });
    };
    // Returns a query listener that will update the given observer based on the
    // results (or lack thereof) for a particular query.
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        var previouslyHadError = false;
        return function (queryStoreValue, newData) {
            // we're going to take a look at the data, so the query is no longer invalidated
            _this.invalidate(false, queryId);
            // The query store value can be undefined in the event of a store
            // reset.
            if (!queryStoreValue)
                return;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            // don't watch the store for queries on standby
            if (fetchPolicy === 'standby')
                return;
            var errorPolicy = observableQuery
                ? observableQuery.options.errorPolicy
                : options.errorPolicy;
            var lastResult = observableQuery
                ? observableQuery.getLastResult()
                : null;
            var lastError = observableQuery ? observableQuery.getLastError() : null;
            var shouldNotifyIfLoading = (!newData && queryStoreValue.previousVariables != null) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            // if this caused by a cache broadcast but the query is still in flight
            // don't notify the observer
            // if (
            //   isCacheBroadcast &&
            //   isNetworkRequestInFlight(queryStoreValue.networkStatus)
            // ) {
            //   shouldNotifyIfLoading = false;
            // }
            var networkStatusChanged = Boolean(lastResult &&
                queryStoreValue.networkStatus !== lastResult.networkStatus);
            var errorStatusChanged = errorPolicy &&
                (lastError && lastError.graphQLErrors) !==
                    queryStoreValue.graphQLErrors &&
                errorPolicy !== 'none';
            if (!isNetworkRequestInFlight(queryStoreValue.networkStatus) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                shouldNotifyIfLoading) {
                // If we have either a GraphQL error or a network error, we create
                // an error and tell the observer about it.
                if (((!errorPolicy || errorPolicy === 'none') &&
                    queryStoreValue.graphQLErrors &&
                    queryStoreValue.graphQLErrors.length > 0) ||
                    queryStoreValue.networkError) {
                    var apolloError_1 = new ApolloError({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    });
                    previouslyHadError = true;
                    if (observer.error) {
                        try {
                            observer.error(apolloError_1);
                        }
                        catch (e) {
                            // Throw error outside this control flow to avoid breaking Apollo's state
                            setTimeout(function () {
                                throw e;
                            }, 0);
                        }
                    }
                    else {
                        // Throw error outside this control flow to avoid breaking Apollo's state
                        setTimeout(function () {
                            throw apolloError_1;
                        }, 0);
                        if (!Object(lib["v" /* isProduction */])()) {
                            /* tslint:disable-next-line */
                            console.info('An unhandled error was thrown because no error handler is registered ' +
                                'for the query ' +
                                Object(printer["print"])(queryStoreValue.document));
                        }
                    }
                    return;
                }
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        // clear out the latest new data, since we're now using it
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                        data = newData.result;
                        isMissing = !newData.complete ? !newData.complete : false;
                    }
                    else {
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        }
                        else {
                            var document_1 = _this.getQuery(queryId).document;
                            var readResult = _this.dataStore.getCache().diff({
                                query: document_1,
                                variables: queryStoreValue.previousVariables ||
                                    queryStoreValue.variables,
                                optimistic: true,
                            });
                            data = readResult.result;
                            isMissing = !readResult.complete;
                        }
                    }
                    var resultFromStore = void 0;
                    // If there is some data missing and the user has told us that they
                    // do not tolerate partial data then we want to return the previous
                    // result and mark it as stale.
                    if (isMissing && fetchPolicy !== 'cache-only') {
                        resultFromStore = {
                            data: lastResult && lastResult.data,
                            loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: true,
                        };
                    }
                    else {
                        resultFromStore = {
                            data: data,
                            loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: false,
                        };
                    }
                    // if the query wants updates on errors we need to add it to the result
                    if (errorPolicy === 'all' &&
                        queryStoreValue.graphQLErrors &&
                        queryStoreValue.graphQLErrors.length > 0) {
                        resultFromStore.errors = queryStoreValue.graphQLErrors;
                    }
                    if (observer.next) {
                        var isDifferentResult = !(lastResult &&
                            resultFromStore &&
                            lastResult.networkStatus === resultFromStore.networkStatus &&
                            lastResult.stale === resultFromStore.stale &&
                            // We can do a strict equality check here because we include a `previousResult`
                            // with `readQueryFromStore`. So if the results are the same they will be
                            // referentially equal.
                            lastResult.data === resultFromStore.data);
                        if (isDifferentResult || previouslyHadError) {
                            try {
                                observer.next(Object(lib["x" /* maybeDeepFreeze */])(resultFromStore));
                            }
                            catch (e) {
                                // Throw error outside this control flow to avoid breaking Apollo's state
                                setTimeout(function () {
                                    throw e;
                                }, 0);
                            }
                        }
                    }
                    previouslyHadError = false;
                }
                catch (error) {
                    previouslyHadError = true;
                    if (observer.error)
                        observer.error(new ApolloError({ networkError: error }));
                    return;
                }
            }
        };
    };
    // The shouldSubscribe option is a temporary fix that tells us whether watchQuery was called
    // directly (i.e. through ApolloClient) or through the query method within QueryManager.
    // Currently, the query method uses watchQuery in order to handle non-network errors correctly
    // but we don't want to keep track observables issued for the query method since those aren't
    // supposed to be refetched in the event of a store reset. Once we unify error handling for
    // network errors and non-network errors, the shouldSubscribe option will go away.
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
        if (options.fetchPolicy === 'standby') {
            throw new Error('client.watchQuery cannot be called with fetchPolicy set to "standby"');
        }
        // get errors synchronously
        var queryDefinition = Object(lib["m" /* getQueryDefinition */])(options.query);
        // assign variable default values if supplied
        if (queryDefinition.variableDefinitions &&
            queryDefinition.variableDefinitions.length) {
            var defaultValues = Object(lib["e" /* getDefaultValues */])(queryDefinition);
            options.variables = Object(lib["c" /* assign */])({}, defaultValues, options.variables);
        }
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = QueryManager___assign({}, options);
        return new ObservableQuery_ObservableQuery({
            scheduler: this.scheduler,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
        if (!options.query) {
            throw new Error('query option is required. You must specify your GraphQL document in the query option.');
        }
        if (options.query.kind !== 'Document') {
            throw new Error('You must wrap the query string in a "gql" tag.');
        }
        if (options.returnPartialData) {
            throw new Error('returnPartialData option only supported on watchQuery.');
        }
        if (options.pollInterval) {
            throw new Error('pollInterval option only supported on watchQuery.');
        }
        if (typeof options.notifyOnNetworkStatusChange !== 'undefined') {
            throw new Error('Cannot call "query" with "notifyOnNetworkStatusChange" option. Only "watchQuery" has that option.');
        }
        options.notifyOnNetworkStatusChange = false;
        var requestId = this.idCounter;
        return new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resolve, reject);
            return _this.watchQuery(options, false)
                .result()
                .then(function (result) {
                _this.removeFetchQueryPromise(requestId);
                resolve(result);
            })
                .catch(function (error) {
                _this.removeFetchQueryPromise(requestId);
                reject(error);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        var queryId = this.idCounter.toString();
        this.idCounter++;
        return queryId;
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.queryStore.stopQuery(queryId);
        this.invalidate(true, queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var _b = _a.listeners, listeners = _b === void 0 ? [] : _b;
            return ({
                listeners: listeners.concat([listener]),
                invalidate: false,
            });
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    // Adds a promise to this.fetchQueryPromises for a given request ID.
    QueryManager.prototype.addFetchQueryPromise = function (requestId, resolve, reject) {
        this.fetchQueryPromises.set(requestId.toString(), {
            resolve: resolve,
            reject: reject,
        });
    };
    // Removes the promise in this.fetchQueryPromises for a particular request ID.
    QueryManager.prototype.removeFetchQueryPromise = function (requestId) {
        this.fetchQueryPromises.delete(requestId.toString());
    };
    // Adds an ObservableQuery to this.observableQueries and to this.observableQueriesByName.
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
        // Insert the ObservableQuery into this.observableQueriesByName if the query has a name
        var queryDef = Object(lib["m" /* getQueryDefinition */])(observableQuery.options.query);
        if (queryDef.name && queryDef.name.value) {
            var queryName = queryDef.name.value;
            // XXX we may we want to warn the user about query name conflicts in the future
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
            this.queryIdsByName[queryName].push(observableQuery.queryId);
        }
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var _a = this.getQuery(queryId), observableQuery = _a.observableQuery, cancel = _a.cancel;
        if (cancel)
            cancel();
        if (!observableQuery)
            return;
        var definition = Object(lib["m" /* getQueryDefinition */])(observableQuery.options.query);
        var queryName = definition.name ? definition.name.value : null;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (queryName) {
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
                return !(observableQuery.queryId === val);
            });
        }
    };
    QueryManager.prototype.clearStore = function () {
        // Before we have sent the reset action to the store,
        // we can no longer rely on the results returned by in-flight
        // requests since these may depend on values that previously existed
        // in the data portion of the store. So, we cancel the promises and observers
        // that we have issued so far and not yet resolved (in the case of
        // queries).
        this.fetchQueryPromises.forEach(function (_a) {
            var reject = _a.reject;
            reject(new Error('Store reset while query was in flight(not completed in link chain)'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        // begin removing data from the store
        var reset = this.dataStore.reset();
        return reset;
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        // Similarly, we have to have to refetch each of the queries currently being
        // observed. We refetch instead of error'ing on these since the assumption is that
        // resetting the store doesn't eliminate the need for the queries currently being
        // watched. If there is an existing query in flight when the store is reset,
        // the promise for it will be rejected and its results will not be written to the
        // store.
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.getObservableQueryPromises = function (includeStandby) {
        var _this = this;
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (!observableQuery)
                return;
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (fetchPolicy !== 'cache-only' &&
                (includeStandby || fetchPolicy !== 'standby')) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.setQuery(queryId, function () { return ({ newData: null }); });
            _this.invalidate(true, queryId);
        });
        return observableQueryPromises;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var observableQueryPromises = this.getObservableQueryPromises(includeStandby);
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (options) {
        var _this = this;
        var query = options.query;
        var cache = this.dataStore.getCache();
        var transformedDoc = cache.transformDocument(query);
        var variables = Object(lib["c" /* assign */])({}, Object(lib["e" /* getDefaultValues */])(Object(lib["k" /* getOperationDefinition */])(query)), options.variables);
        var sub;
        var observers = [];
        return new Observable_Observable(function (observer) {
            observers.push(observer);
            // If this is the first observer, actually initiate the network subscription
            if (observers.length === 1) {
                var handler = {
                    next: function (result) {
                        _this.dataStore.markSubscriptionResult(result, transformedDoc, variables);
                        _this.broadcastQueries();
                        // It's slightly awkward that the data for subscriptions doesn't come from the store.
                        observers.forEach(function (obs) {
                            // XXX I'd prefer a different way to handle errors for subscriptions
                            if (obs.next)
                                obs.next(result);
                        });
                    },
                    error: function (error) {
                        observers.forEach(function (obs) {
                            if (obs.error)
                                obs.error(error);
                        });
                    },
                };
                // TODO: Should subscriptions also accept a `context` option to pass
                // through to links?
                var operation = _this.buildOperationForLink(transformedDoc, variables);
                sub = Object(apollo_link_lib["c" /* execute */])(_this.link, operation).subscribe(handler);
            }
            return function () {
                observers = observers.filter(function (obs) { return obs !== observer; });
                // If we removed the last observer, tear down the network subscription
                if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                }
            };
        });
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryInStore(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        var subscriptions = this.getQuery(queryId).subscriptions;
        // teardown all links
        subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        // XXX test this
        if (newData) {
            return Object(lib["x" /* maybeDeepFreeze */])({ data: newData.result, partial: false });
        }
        else {
            try {
                // the query is brand new, so we read from the store to see if anything is there
                var data = this.dataStore.getCache().read({
                    query: query,
                    variables: variables,
                    previousResult: lastResult ? lastResult.data : undefined,
                    optimistic: optimistic,
                });
                return Object(lib["x" /* maybeDeepFreeze */])({ data: data, partial: false });
            }
            catch (e) {
                return Object(lib["x" /* maybeDeepFreeze */])({ data: {}, partial: true });
            }
        }
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            if (!foundObserveableQuery) {
                throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            }
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var data = this.getCurrentQueryResult(observableQuery, false).data;
        return {
            previousResult: data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (!info.invalidated || !info.listeners)
                return;
            info.listeners
                .filter(function (x) { return !!x; })
                .forEach(function (listener) {
                listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    // Takes a request id, query id, a query document and information associated with the query
    // and send it to the network interface. Returns
    // a promise for the result associated with that request.
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, context = options.context, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var operation = this.buildOperationForLink(document, variables, QueryManager___assign({}, context, { 
            // TODO: Should this be included for all entry points via
            // buildOperationForLink?
            forceFetch: !this.queryDeduplication }));
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resolve, reject);
            var subscription = Object(apollo_link_lib["c" /* execute */])(_this.deduplicator, operation).subscribe({
                next: function (result) {
                    // default the lastRequestId to 1
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        if (fetchPolicy !== 'no-cache') {
                            try {
                                _this.dataStore.markQueryResult(result, document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        }
                        else {
                            _this.setQuery(queryId, function () { return ({
                                newData: { result: result.data, complete: true },
                            }); });
                        }
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (result.errors && errorPolicy === 'none') {
                        reject(new ApolloError({
                            graphQLErrors: result.errors,
                        }));
                        return;
                    }
                    else if (errorPolicy === 'all') {
                        errorsFromStore = result.errors;
                    }
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                        // We don't write fetchMore results to the store because this would overwrite
                        // the original result in case an @connection directive is used.
                        resultFromStore = result.data;
                    }
                    else {
                        try {
                            // ensure result is combined with data already in store
                            resultFromStore = _this.dataStore.getCache().read({
                                variables: variables,
                                query: document,
                                optimistic: false,
                            });
                            // this will throw an error if there are missing fields in
                            // the results which can happen with errors from the server.
                            // tslint:disable-next-line
                        }
                        catch (e) { }
                    }
                },
                error: function (error) {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    reject(error);
                },
                complete: function () {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: NetworkStatus.ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                return ({
                    subscriptions: subscriptions.concat([subscription]),
                });
            });
        });
    };
    // Refetches a query given that query's name. Refetches
    // all ObservableQuery instances associated with the query name.
    QueryManager.prototype.refetchQueryByName = function (queryName) {
        var _this = this;
        var refetchedQueries = this.queryIdsByName[queryName];
        // early return if the query named does not exist (not yet fetched)
        // this used to warn but it may be inteneded behavoir to try and refetch
        // un called queries because they could be on different routes
        if (refetchedQueries === undefined)
            return;
        return Promise.all(refetchedQueries
            .map(function (id) { return _this.getQuery(id).observableQuery; })
            .filter(function (x) { return !!x; })
            .map(function (x) { return x.refetch(); }));
    };
    QueryManager.prototype.generateRequestId = function () {
        var requestId = this.idCounter;
        this.idCounter++;
        return requestId;
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return this.queries.get(queryId) || QueryManager___assign({}, defaultQueryInfo);
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = QueryManager___assign({}, prev, updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (invalidated, queryId, fetchMoreForQueryId) {
        if (queryId)
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        if (fetchMoreForQueryId) {
            this.setQuery(fetchMoreForQueryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.buildOperationForLink = function (document, variables, extraContext) {
        var cache = this.dataStore.getCache();
        return {
            query: cache.transformForLink
                ? cache.transformForLink(document)
                : document,
            variables: variables,
            operationName: Object(lib["l" /* getOperationName */])(document) || undefined,
            context: QueryManager___assign({}, extraContext, { cache: cache, 
                // getting an entry's cache key is useful for cacheResolvers & state-link
                getCacheKey: function (obj) {
                    if (cache.config) {
                        // on the link, we just want the id string, not the full id value from toIdValue
                        return cache.config.dataIdFromObject(obj);
                    }
                    else {
                        throw new Error('To use context.getCacheKey, you need to use a cache that has a configurable dataIdFromObject, like apollo-cache-inmemory.');
                    }
                } }),
        };
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/data/store.js

var store_DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(lib["o" /* graphQLResultHasError */])(result);
        if (ignoreErrors && Object(lib["o" /* graphQLResultHasError */])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        // the subscription interface should handle not sending us results we no longer subscribe to.
        // XXX I don't think we ever send in an object with errors, but we might in the future...
        if (!Object(lib["o" /* graphQLResultHasError */])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            var changeFn_1 = function () {
                _this.markMutationResult({
                    mutationId: mutation.mutationId,
                    result: { data: optimistic_1 },
                    document: mutation.document,
                    variables: mutation.variables,
                    updateQueries: mutation.updateQueries,
                    update: mutation.update,
                });
            };
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    changeFn_1();
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        // Incorporate the result from this mutation into the store
        if (!Object(lib["o" /* graphQLResultHasError */])(mutation.result)) {
            var cacheWrites_1 = [];
            cacheWrites_1.push({
                result: mutation.result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            if (mutation.updateQueries) {
                Object.keys(mutation.updateQueries)
                    .filter(function (id) { return mutation.updateQueries[id]; })
                    .forEach(function (queryId) {
                    var _a = mutation.updateQueries[queryId], query = _a.query, updater = _a.updater;
                    // Read the current query result from the store.
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (!complete) {
                        return;
                    }
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = Object(lib["D" /* tryFunctionOrLogError */])(function () {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: Object(lib["l" /* getOperationName */])(query.document) || undefined,
                            queryVariables: query.variables,
                        });
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) {
                        cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables,
                        });
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
            });
            // If the mutation has some writes associated with it then we need to
            // apply those writes to the store by running this reducer again with a
            // write action.
            var update_1 = mutation.update;
            if (update_1) {
                this.cache.performTransaction(function (c) {
                    Object(lib["D" /* tryFunctionOrLogError */])(function () { return update_1(c, mutation.result); });
                });
            }
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (!optimisticResponse)
            return;
        this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

//# sourceMappingURL=store.js.map
// EXTERNAL MODULE: ./node_modules/apollo-client/version.js
var version = __webpack_require__("3Y6g");
var version_default = /*#__PURE__*/__webpack_require__.n(version);

// CONCATENATED MODULE: ./node_modules/apollo-client/ApolloClient.js
var ApolloClient___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var hasSuggestedDevtools = false;
var supportedDirectives = new apollo_link_lib["a" /* ApolloLink */](function (operation, forward) {
    operation.query = Object(lib["y" /* removeConnectionDirectiveFromDocument */])(operation.query);
    return forward(operation);
});
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over a {@link NetworkInterface} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */
var ApolloClient_ApolloClient = (function () {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @param link The {@link ApolloLink} over which GraphQL documents will be resolved into a response.
     *
     * @param cache The initial cache to use in the data store.
     *
     * @param ssrMode Determines whether this is being run in Server Side Rendering (SSR) mode.
     *
     * @param ssrForceFetchDelay Determines the time interval before we force fetch queries for a
     * server side render.
     *
     * @param queryDeduplication If set to false, a query will still be sent to the server even if a query
     * with identical parameters (query, variables, operationName) is already in flight.
     *
     */
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        var link = options.link, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions;
        if (!link || !cache) {
            throw new Error("\n        In order to initialize Apollo Client, you must specify link & cache properties on the config object.\n        This is part of the required upgrade when migrating from Apollo Client 1.0 to Apollo Client 2.0.\n        For more information, please visit:\n          https://www.apollographql.com/docs/react/basics/setup.html\n        to help you get started.\n      ");
        }
        // remove apollo-client supported directives
        this.link = supportedDirectives.concat(link);
        this.cache = cache;
        this.store = new store_DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.ssrMode = ssrMode;
        this.defaultOptions = defaultOptions || {};
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        // Attach the client instance to window to let us be found by chrome devtools, but only in
        // development mode
        var defaultConnectToDevTools = !Object(lib["v" /* isProduction */])() &&
            "object" !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && "object" !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */
        if (!hasSuggestedDevtools && !Object(lib["v" /* isProduction */])()) {
            hasSuggestedDevtools = true;
            if ("object" !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                // First check if devtools is not installed
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    // Only for Chrome
                    if (window.navigator && window.navigator.userAgent.indexOf('Chrome') > -1) {
                        // tslint:disable-next-line
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = version["version"];
    }
    /**
     * This watches the results of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer.
     * <p /><p />
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     * <p /><p />
     * For example, suppose you call watchQuery on a GraphQL query that fetches an person's
     * first name and last name and this person has a particular object identifer, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and his/her first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     * <p /><p />
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     *
     */
    ApolloClient.prototype.watchQuery = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.watchQuery) {
            options = ApolloClient___assign({}, this.defaultOptions.watchQuery, options);
        }
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = ApolloClient___assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and returns a
     * {@link Promise} which is either resolved with the resulting data or rejected
     * with an error.
     *
     * @param options An object of type {@link WatchQueryOptions} that allows us to describe
     * how this query should be treated e.g. whether it is a polling query, whether it should hit the
     * server at all or just resolve from the cache, etc.
     */
    ApolloClient.prototype.query = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.query) {
            options = ApolloClient___assign({}, this.defaultOptions.query, options);
        }
        if (options.fetchPolicy === 'cache-and-network') {
            throw new Error('cache-and-network fetchPolicy can only be used with watchQuery');
        }
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = ApolloClient___assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * {@link Promise} which is either resolved with the resulting data or rejected with an
     * error.
     *
     * It takes options as an object with the following keys and values:
     */
    ApolloClient.prototype.mutate = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.mutate) {
            options = ApolloClient___assign({}, this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */
    ApolloClient.prototype.subscribe = function (options) {
        this.initQueryManager();
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     */
    ApolloClient.prototype.readQuery = function (options) {
        return this.initProxy().readQuery(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.readFragment = function (options) {
        return this.initProxy().readFragment(options);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.initProxy().writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.initProxy().writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    /**
     * Sugar for writeQuery & writeFragment
     * This method will construct a query from the data object passed in.
     * If no id is supplied, writeData will write the data to the root.
     * If an id is supplied, writeData will write a fragment to the object
     * specified by the id in the store.
     *
     * Since you aren't passing in a query to check the shape of the data,
     * you must pass in an object that conforms to the shape of valid GraphQL data.
     */
    ApolloClient.prototype.writeData = function (options) {
        var result = this.initProxy().writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(apollo_link_lib["c" /* execute */])(this.link, payload);
    };
    /**
     * This initializes the query manager that tracks queries and the cache
     */
    ApolloClient.prototype.initQueryManager = function () {
        var _this = this;
        if (this.queryManager)
            return;
        this.queryManager = new QueryManager_QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: this.queryDeduplication,
            ssrMode: this.ssrMode,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager
                ? _this.queryManager.clearStore()
                : Promise.resolve(null);
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () {
            return _this.queryManager
                ? _this.queryManager.reFetchObservableQueries()
                : Promise.resolve(null);
        });
    };
    /**
     * Allows callbacks to be registered that are executed with the store is reset.
     * onResetStore returns an unsubscribe function for removing your registered callbacks.
     */
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager
            ? this.queryManager.reFetchObservableQueries(includeStandby)
            : Promise.resolve(null);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */
    ApolloClient.prototype.extract = function (optimistic) {
        return this.initProxy().extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */
    ApolloClient.prototype.restore = function (serializedState) {
        return this.initProxy().restore(serializedState);
    };
    /**
     * Initializes a data proxy for this client instance if one does not already
     * exist and returns either a previously initialized proxy instance or the
     * newly initialized instance.
     */
    ApolloClient.prototype.initProxy = function () {
        if (!this.proxy) {
            this.initQueryManager();
            this.proxy = this.cache;
        }
        return this.proxy;
    };
    return ApolloClient;
}());
/* harmony default export */ var apollo_client_ApolloClient = (ApolloClient_ApolloClient);
//# sourceMappingURL=ApolloClient.js.map
// CONCATENATED MODULE: ./node_modules/apollo-client/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "printAST", function() { return printer["print"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return ObservableQuery_ObservableQuery; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return NetworkStatus; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FetchType", function() { return FetchType; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ApolloError", function() { return ApolloError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return apollo_client_ApolloClient; });






// export the client as both default and named

/* harmony default export */ var apollo_client = __webpack_exports__["default"] = (apollo_client_ApolloClient);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "u8nl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u9ZQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("hJMz");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Google maps uses numbering for position */
var positionPropType = _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);

/* global google */

var GoogleMap = function (_Component) {
    _inherits(GoogleMap, _Component);

    function GoogleMap(props) {
        _classCallCheck(this, GoogleMap);

        var _this = _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).call(this, props));

        _this.state = {
            map: null
        };

        _this.createBounds = _this.createBounds.bind(_this);
        _this.setMap = _this.setMap.bind(_this);
        _this.setListeners = _this.setListeners.bind(_this);
        return _this;
    }

    _createClass(GoogleMap, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                bounds = _props.bounds,
                center = _props.center,
                zoom = _props.zoom;
            var map = this.state.map;


            if (JSON.stringify(prevProps.bounds) !== JSON.stringify(bounds)) {
                map.fitBounds(this.createBounds(bounds), 0);
            }

            if (JSON.stringify(prevProps.center) !== JSON.stringify(center)) {
                map.setCenter(center);
            }

            if (prevProps.zoom !== zoom) {
                /* setZoom is ignored until map idles after fitbounds (fitBounds is async)
                so add listener for idle then set the zoom */
                google.maps.event.addListenerOnce(map, 'idle', function () {
                    map.setZoom(zoom);
                });
            }
        }
    }, {
        key: 'createBounds',
        value: function createBounds(_ref) {
            var neLat = _ref.neLat,
                neLong = _ref.neLong,
                swLat = _ref.swLat,
                swLong = _ref.swLong;

            return new google.maps.LatLngBounds(new google.maps.LatLng(swLat, swLong), new google.maps.LatLng(neLat, neLong));
        }
    }, {
        key: 'setMap',
        value: function setMap(node) {
            if (!node) {
                return;
            }

            var _props2 = this.props,
                bounds = _props2.bounds,
                center = _props2.center,
                onMapLoad = _props2.onMapLoad,
                options = _props2.options,
                zoom = _props2.zoom;

            var fitBounds = this.createBounds(bounds);
            var map = new google.maps.Map(node, _extends({}, options));

            if (center) {
                map.setCenter(new google.maps.LatLng(center.lat, center.lng));
            } else {
                map.fitBounds(fitBounds);
            }

            /* setZoom is ignored until map idles after fitbounds (fitBounds is async)
            so add listener for idle then set the zoom */
            if (zoom !== null) {
                google.maps.event.addListenerOnce(map, 'idle', function () {
                    map.setZoom(zoom);
                });
            }

            /* Google maps will fire listeners, specifically 'zoom_changed' 'center_changed'
            and 'idle' before the tiles are loaded. Preventing this to give false callbacks */
            google.maps.event.addListenerOnce(map, 'tilesloaded', this.setListeners);

            onMapLoad(map);

            this.setState({ map: map });
        }
    }, {
        key: 'setListeners',
        value: function setListeners() {
            var map = this.state.map;
            var _props3 = this.props,
                onBoundsChanged = _props3.onBoundsChanged,
                onCenterChanged = _props3.onCenterChanged,
                onClick = _props3.onClick,
                onDrag = _props3.onDrag,
                onDragEnd = _props3.onDragEnd,
                onDragStart = _props3.onDragStart,
                onDoubleClick = _props3.onDoubleClick,
                onHeadingChanged = _props3.onHeadingChanged,
                onIdle = _props3.onIdle,
                onMouseMove = _props3.onMouseMove,
                onMouseOut = _props3.onMouseOut,
                onMouseOver = _props3.onMouseOver,
                onProjectionChanged = _props3.onProjectionChanged,
                onResize = _props3.onResize,
                onRightClick = _props3.onRightClick,
                onTilesLoaded = _props3.onTilesLoaded,
                onZoomChanged = _props3.onZoomChanged;


            google.maps.event.addListener(map, 'bounds_changed', onBoundsChanged);
            google.maps.event.addListener(map, 'center_changed', onCenterChanged);
            google.maps.event.addListener(map, 'click', onClick);
            google.maps.event.addListener(map, 'drag', onDrag);
            google.maps.event.addListener(map, 'dragend', onDragEnd);
            google.maps.event.addListener(map, 'dragstart', onDragStart);
            google.maps.event.addListener(map, 'dblclick', onDoubleClick);
            google.maps.event.addListener(map, 'heading_changed', onHeadingChanged);
            google.maps.event.addListener(map, 'idle', onIdle);
            google.maps.event.addListener(map, 'mousemove', onMouseMove);
            google.maps.event.addListener(map, 'mouseout', onMouseOut);
            google.maps.event.addListener(map, 'mouseover', onMouseOver);
            google.maps.event.addListener(map, 'projection_changed', onProjectionChanged);
            google.maps.event.addListener(map, 'resize', onResize);
            google.maps.event.addListener(map, 'rightclick', onRightClick);
            google.maps.event.addListener(map, 'tilesloaded', onTilesLoaded);
            google.maps.event.addListener(map, 'zoom_changed', onZoomChanged);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props4 = this.props,
                children = _props4.children,
                containerElement = _props4.containerElement;
            var map = this.state.map;


            if (!map || !children) {
                return (0, _react.cloneElement)(containerElement, {
                    ref: this.setMap
                });
            }

            return (0, _react.cloneElement)(containerElement, {
                ref: this.setMap
            }, _react.Children.toArray(children).map(function (child) {
                return (0, _react.cloneElement)(child, { map: _this2.state.map });
            }));
        }
    }]);

    return GoogleMap;
}(_react.Component);

GoogleMap.propTypes = {
    /** The bounding box that google maps will attempt to take */
    bounds: _propTypes2.default.shape({
        neLat: _propTypes2.default.number,
        neLong: _propTypes2.default.number,
        swLat: _propTypes2.default.number,
        swLong: _propTypes2.default.number
    }),
    /** The center lat, lng that google maps will use over bounds if present */
    center: _propTypes2.default.shape({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }),
    /** Element that will wrap around the mapElement */
    containerElement: _propTypes2.default.element,
    /** Element to display while the map is loading */
    loadingElement: _propTypes2.default.element,
    /** https://developers.google.com/maps/documentation/javascript/reference/3/#MapOptions */
    options: _propTypes2.default.shape({
        backgroundColor: _propTypes2.default.string,
        center: _propTypes2.default.shape({
            lat: _propTypes2.default.number.isRequired,
            long: _propTypes2.default.number.isRequired
        }),
        clickableIcons: _propTypes2.default.boolean,
        disableDefaultUI: _propTypes2.default.boolean,
        disableDoubleClickZoom: _propTypes2.default.boolean,
        draggable: _propTypes2.default.boolean,
        draggableCursor: _propTypes2.default.boolean,
        draggingCursor: _propTypes2.default.boolean,
        fullscreenControl: _propTypes2.default.boolean,
        fullscreenControlOptions: _propTypes2.default.shape({
            position: positionPropType
        }),
        gestureHandling: _propTypes2.default.oneOf(['auto', 'cooperative', 'greedy', 'none']),
        heading: _propTypes2.default.number,
        keyboardShortcuts: _propTypes2.default.boolean,
        mapTypeControl: _propTypes2.default.boolean,
        mapTypeControlOptions: _propTypes2.default.shape({
            mapTypeIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
            position: positionPropType,
            style: _propTypes2.default.oneOf([0, 1, 2, 3, 4])
        }),
        mapTypeId: _propTypes2.default.oneOf(['hybrid', 'roadmap', 'satellite', 'terrain']),
        maxZoom: _propTypes2.default.number,
        minZoom: _propTypes2.default.number,
        noClear: _propTypes2.default.boolean,
        panControl: _propTypes2.default.boolean,
        panControlOptions: _propTypes2.default.shape({
            position: positionPropType
        }),
        rotateControl: _propTypes2.default.boolean,
        rotateControlOptions: _propTypes2.default.shape({
            position: positionPropType
        }),
        scaleControl: _propTypes2.default.boolean,
        scaleControlOptions: _propTypes2.default.shape({
            position: positionPropType
        }),
        scrollwheel: _propTypes2.default.boolean,
        streetView: _propTypes2.default.object,
        streetViewControl: _propTypes2.default.boolean,
        streetViewControlOptions: _propTypes2.default.shape({
            position: positionPropType
        }),
        styles: _propTypes2.default.arrayOf(_propTypes2.default.object),
        tilt: _propTypes2.default.number,
        zoomControl: _propTypes2.default.boolean,
        zoomControlOptions: _propTypes2.default.shape({
            position: positionPropType
        })
    }),
    /* Level of zoom of the map */
    zoom: _propTypes2.default.number
};
GoogleMap.defaultProps = {
    // World search determined by HomeAway
    bounds: {
        neLat: 82.12492067499629,
        neLong: 58.172218749999956,
        swLat: -78.48103194080132,
        swLong: -124.99184375000004
    },
    containerElement: _react2.default.createElement('div', { className: 'Map' }),
    options: {},
    onBoundsChanged: /* istanbul ignore next */function onBoundsChanged() {},
    onCenterChanged: /* istanbul ignore next */function onCenterChanged() {},
    onClick: /* istanbul ignore next */function onClick() {},
    onDoubleClick: /* istanbul ignore next */function onDoubleClick() {},
    onDrag: /* istanbul ignore next */function onDrag() {},
    onDragEnd: /* istanbul ignore next */function onDragEnd() {},
    onDragStart: /* istanbul ignore next */function onDragStart() {},
    onHeadingChanged: /* istanbul ignore next */function onHeadingChanged() {},
    onIdle: /* istanbul ignore next */function onIdle() {},
    onMapLoad: /* istanbul ignore next */function onMapLoad() {},
    onMouseMove: /* istanbul ignore next */function onMouseMove() {},
    onMouseOut: /* istanbul ignore next */function onMouseOut() {},
    onMouseOver: /* istanbul ignore next */function onMouseOver() {},
    onProjectionChanged: /* istanbul ignore next */function onProjectionChanged() {},
    onResize: /* istanbul ignore next */function onResize() {},
    onRightClick: /* istanbul ignore next */function onRightClick() {},
    onTilesLoaded: /* istanbul ignore next */function onTilesLoaded() {},
    onZoomChanged: /* istanbul ignore next */function onZoomChanged() {},
    zoom: 0
};
exports.default = GoogleMap;
//# sourceMappingURL=GoogleMap.js.map

/***/ }),

/***/ "uDiQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uIr7":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "uL9r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rotateArray = exports.getDayNamesInstance = undefined;

var _LanguageTag = __webpack_require__("r94d");

var _LanguageTag2 = _interopRequireDefault(_LanguageTag);

var _firstDayOfWeek = __webpack_require__("/HXb");

var _firstDayOfWeek2 = _interopRequireDefault(_firstDayOfWeek);

var _Objects = __webpack_require__("q4WY");

var _Labels = __webpack_require__("wc36");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Some locales have a different day than sunday as the start of week.
// Defaults the first day of week by comparing UTC day of week to
// locale-specific day of week. This default will only be used if init
// is not invoked to initialize based on a locale.
var _firstDayDate = new Date(2000, 0, 3);
var DEFAULT_FIRST_DAY = _firstDayDate.getDay() - _firstDayDate.getUTCDay();

var _instances = {};

function rotateArray(array, offset) {
    return [].concat(_toConsumableArray(array.slice(offset)), _toConsumableArray(array.slice(0, offset)));
}

function DayNames(languageTag, labels) {
    // Determine the first day of week offset from Sunday (0) for the specified
    // country code. If the country code is not specified or is not recognized,
    // use the default JS API calculated first day.
    var dayOffset = languageTag && languageTag.region ? Number(_firstDayOfWeek2.default[languageTag.region]) : DEFAULT_FIRST_DAY;
    var locale = languageTag.code;

    // Make sure that dayOffset is not NaN by comparing with itself.
    this.dayOffset = dayOffset !== dayOffset ? DEFAULT_FIRST_DAY : dayOffset; // eslint-disable-line no-self-compare

    this.longDayNames = (0, _Objects.getObjectKeyOfLength)(labels, 'longDayNames', 7) || (0, _Labels.getLocaleDateStrings)(locale, { weekday: 'long' }, false) || (0, _Labels.getDefaultLabels)('longDayNames') || [];
    this.dayNames = (0, _Objects.getObjectKeyOfLength)(labels, 'dayNames', 7) || (0, _Labels.getLocaleDateStrings)(locale, { weekday: 'short' }, false) || (0, _Labels.getDefaultLabels)('dayNames') || [];
    this.shortDayNames = (0, _Objects.getObjectKeyOfLength)(labels, 'shortDayNames', 7) || (0, _Labels.getLocaleDateStrings)(locale, { weekday: 'narrow' }, false) || (0, _Labels.getDefaultLabels)('shortDayNames') || [];

    if (this.dayOffset) {
        this.longDayNames = rotateArray(this.longDayNames, this.dayOffset);
        this.dayNames = rotateArray(this.dayNames, this.dayOffset);
        this.shortDayNames = rotateArray(this.shortDayNames, this.dayOffset);
    }
}

DayNames.prototype.getLongDayNames = function () {
    return this.longDayNames;
};

DayNames.prototype.getDayNames = function () {
    return this.dayNames;
};

DayNames.prototype.getShortDayNames = function () {
    return this.shortDayNames;
};

DayNames.prototype.getStartOfWeek = function () {
    return this.dayOffset;
};

function getDayNamesInstance(locale, labels) {
    var languageTag = locale ? new _LanguageTag2.default(locale) : {};
    var code = languageTag.code || 'default';

    labels = labels || {};

    if (!(0, _Objects.isEmptyObject)(labels)) {
        return new DayNames(languageTag, labels);
    }

    if (!_instances[code]) {
        _instances[code] = new DayNames(languageTag, labels);
    }

    return _instances[code];
}

exports.getDayNamesInstance = getDayNamesInstance;
exports.rotateArray = rotateArray;
//# sourceMappingURL=DayNames.js.map

/***/ }),

/***/ "uLhX":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "uekS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/zen-observable/index.js
var zen_observable = __webpack_require__("zSos");
var zen_observable_default = /*#__PURE__*/__webpack_require__.n(zen_observable);

// CONCATENATED MODULE: ./node_modules/zen-observable-ts/lib/zenObservable.js

var Observable = zen_observable_default.a;
//# sourceMappingURL=zenObservable.js.map
// CONCATENATED MODULE: ./node_modules/zen-observable-ts/lib/index.js


/* harmony default export */ var lib = (Observable);
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/apollo-utilities/lib/index.js + 11 modules
var apollo_utilities_lib = __webpack_require__("+zi7");

// EXTERNAL MODULE: ./node_modules/graphql/language/printer.js
var printer = __webpack_require__("xC4e");
var printer_default = /*#__PURE__*/__webpack_require__.n(printer);

// CONCATENATED MODULE: ./node_modules/apollo-link/lib/linkUtils.js
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new Error("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = /** @class */ (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));

function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    console.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
// backwards compat
var makePromise = toPromise;
function fromPromise(promise) {
    return new lib(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new lib(function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    // best guess at an operation name
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(apollo_utilities_lib["l" /* getOperationName */])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign({}, context, next(context));
        }
        else {
            context = __assign({}, context, next);
        }
    };
    var getContext = function () { return (__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    // XXX we're assuming here that variables will be serialized in the same order.
    // that might not always be true
    return Object(printer["print"])(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}
//# sourceMappingURL=linkUtils.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link/lib/link.js


var passthrough = function (op, forward) { return (forward ? forward(op) : lib.of()); };
var toLink = function (handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
};
var empty = function () {
    return new ApolloLink(function (op, forward) { return lib.of(); });
};
var from = function (links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
};
var split = function (test, left, right) {
    if (right === void 0) { right = new ApolloLink(passthrough); }
    var leftLink = toLink(left);
    var rightLink = toLink(right);
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || lib.of()
                : rightLink.request(operation) || lib.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || lib.of()
                : rightLink.request(operation, forward) || lib.of();
        });
    }
};
// join two Links together
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
        console.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || lib.of(); }) || lib.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || lib.of();
            }) || lib.of());
        });
    }
};
var ApolloLink = /** @class */ (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        if (right === void 0) { right = new ApolloLink(passthrough); }
        return this.concat(split(test, left, right));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw new Error('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());

function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || lib.of());
}
//# sourceMappingURL=link.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link/lib/index.js
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return empty; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return from; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return split; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return concat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return execute; });
/* unused concated harmony import createOperation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createOperation; });
/* unused concated harmony import makePromise */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return makePromise; });
/* unused concated harmony import toPromise */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return toPromise; });
/* unused concated harmony import fromPromise */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fromPromise; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return fromError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return lib; });




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "ukpD":
/***/ (function(module, exports) {

module.exports = Yallist

Yallist.Node = Node
Yallist.create = Yallist

function Yallist (list) {
  var self = this
  if (!(self instanceof Yallist)) {
    self = new Yallist()
  }

  self.tail = null
  self.head = null
  self.length = 0

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item)
    })
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i])
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next
  var prev = node.prev

  if (next) {
    next.prev = prev
  }

  if (prev) {
    prev.next = next
  }

  if (node === this.head) {
    this.head = next
  }
  if (node === this.tail) {
    this.tail = prev
  }

  node.list.length--
  node.next = null
  node.prev = null
  node.list = null
}

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var head = this.head
  node.list = this
  node.next = head
  if (head) {
    head.prev = node
  }

  this.head = node
  if (!this.tail) {
    this.tail = node
  }
  this.length++
}

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var tail = this.tail
  node.list = this
  node.prev = tail
  if (tail) {
    tail.next = node
  }

  this.tail = node
  if (!this.head) {
    this.head = node
  }
  this.length++
}

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value
  this.tail = this.tail.prev
  if (this.tail) {
    this.tail.next = null
  } else {
    this.head = null
  }
  this.length--
  return res
}

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value
  this.head = this.head.next
  if (this.head) {
    this.head.prev = null
  } else {
    this.tail = null
  }
  this.length--
  return res
}

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.next
  }
}

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.prev
  }
}

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.next
  }
  return res
}

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.prev
  }
  return res
}

Yallist.prototype.reduce = function (fn, initial) {
  var acc
  var walker = this.head
  if (arguments.length > 1) {
    acc = initial
  } else if (this.head) {
    walker = this.head.next
    acc = this.head.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i)
    walker = walker.next
  }

  return acc
}

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc
  var walker = this.tail
  if (arguments.length > 1) {
    acc = initial
  } else if (this.tail) {
    walker = this.tail.prev
    acc = this.tail.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i)
    walker = walker.prev
  }

  return acc
}

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.next
  }
  return arr
}

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.prev
  }
  return arr
}

Yallist.prototype.slice = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.reverse = function () {
  var head = this.head
  var tail = this.tail
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev
    walker.prev = walker.next
    walker.next = p
  }
  this.head = tail
  this.tail = head
  return this
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self)
  if (!self.head) {
    self.head = self.tail
  }
  self.length++
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self)
  if (!self.tail) {
    self.tail = self.head
  }
  self.length++
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list
  this.value = value

  if (prev) {
    prev.next = this
    this.prev = prev
  } else {
    this.prev = null
  }

  if (next) {
    next.prev = this
    this.next = next
  } else {
    this.next = null
  }
}


/***/ }),

/***/ "uywk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v1/r":
/***/ (function(module, exports) {

var INVITATION_EXPIRED = 'TB11';
var INVITATION_NOTFOUND = 'TB10';
var BOARD_NOT_FOUND = 'TB1';
var BOARD_ERROR_CODES = [INVITATION_EXPIRED, INVITATION_NOTFOUND, BOARD_NOT_FOUND];

var codeIsError = function codeIsError(code) {
    return code === INVITATION_EXPIRED || code === INVITATION_NOTFOUND || code === BOARD_NOT_FOUND;
};

module.exports = { codeIsError: codeIsError, INVITATION_EXPIRED: INVITATION_EXPIRED, INVITATION_NOTFOUND: INVITATION_NOTFOUND, BOARD_NOT_FOUND: BOARD_NOT_FOUND, BOARD_ERROR_CODES: BOARD_ERROR_CODES };

/***/ }),

/***/ "vIb5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vmzn":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("EarI");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "vx06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOUSE__16 = void 0;
var HOUSE__16 = '<svg data-id="SVG_HOUSE__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.93 5.33v7.65c0 .83-.68 1.5-1.5 1.5H4.59a1.5 1.5 0 0 1-1.5-1.5V8.3"/><path d="M1 6.83l6.05-4.98a1.5 1.5 0 0 1 1.9 0L15 6.83M3.1 5.1V2.16M9.71 11.93V8.29h-3.4v6.2"/></g></svg>';
exports.HOUSE__16 = HOUSE__16;

/***/ }),

/***/ "w0I2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w1c7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__("IVRI");

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "w5KI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactFormComponents = __webpack_require__("QyGt");

var _reactDetermineIfMobile = __webpack_require__("54yA");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _propTypeDateString = __webpack_require__("NTt2");

var _propTypeDateString2 = _interopRequireDefault(_propTypeDateString);

var _dateUtils = __webpack_require__("pkO5");

var _Base = __webpack_require__("X/Bi");

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = function (_Component) {
    _inherits(DatePicker, _Component);

    function DatePicker(props) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        var _getMonthYear = (0, _dateUtils.getMonthYear)(props.date),
            month = _getMonthYear.month,
            year = _getMonthYear.year;

        var isOpen = props.isOpen;


        _this.state = {
            month: month,
            year: year,
            isOpen: isOpen
        };

        // Binds
        _this.calendarRefFunc = _this.calendarRefFunc.bind(_this);
        _this.handleClearDates = _this.handleClearDates.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleDateChange = _this.handleDateChange.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleOpen = _this.handleOpen.bind(_this);
        return _this;
    }

    _createClass(DatePicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isOpen !== nextProps.isOpen && this.state.isOpen !== nextProps.isOpen) {
                if (nextProps.isOpen) {
                    this.handleFocus();
                } else {
                    this.handleClose();
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            // When rendering the calendar in the modal, we display 24 months and allow scrolling.
            // Rendering the 24 months immediately screws up the CSS transitions and makes things
            // janky. So we display an empty modal first, then start rendering the calendar.
            if (this.props.isMobile && this.state.isDelayed) {
                window.setTimeout(function () {
                    _this2.setState({ isDelayed: false });
                }, 50);
            }
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            if (this.props.isMobile) {
                // Open, but set isDelayed to true so the calendar waits a moment to render
                this.setState({ isOpen: true, isDelayed: true });
            } else {
                var _getMonthYear2 = (0, _dateUtils.getMonthYear)(this.props.date),
                    month = _getMonthYear2.month,
                    year = _getMonthYear2.year;

                var dateInput = _reactDom2.default.findDOMNode(this).querySelector('input');

                // prevent double setState when dateInput receives focus;
                if (document && document.activeElement !== dateInput) {
                    // as we may be clicking on the overlay, rather than tabbing to the input
                    // force focus of the input for text entry (text entry is TODO)
                    if (!this.props.disableTextInput) {
                        dateInput.focus();
                    }

                    this.setState({
                        isOpen: true,
                        month: month,
                        year: year
                    });
                }
            }
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            if (this.state.isOpen) {
                this.setState({ isOpen: false }, this.props.onClose);
            }
        }
    }, {
        key: 'handleOpen',
        value: function handleOpen() {
            if (this.state.isOpen) {
                this.props.onOpen();
            }
        }
    }, {
        key: 'contains',
        value: function contains(elem, target) {
            return elem && _reactDom2.default.findDOMNode(elem).contains(target);
        }
    }, {
        key: 'handleDateChange',
        value: function handleDateChange(dateString) {
            var _this3 = this;

            this.props.onDateChange(dateString);

            // Delaying to allow selection visual to appear before closing
            window.setTimeout(function () {
                _this3.handleClose();
            }, 20);
        }
    }, {
        key: 'handleClearDates',
        value: function handleClearDates(event) {
            var _props = this.props,
                onDateChange = _props.onDateChange,
                onDateClear = _props.onDateClear;

            event.preventDefault();
            onDateChange('');
            onDateClear();
        }
    }, {
        key: 'handleChangeInput',
        value: function handleChangeInput() {
            // TODO: allow keyboard entry
        }
    }, {
        key: 'calendarRefFunc',
        value: function calendarRefFunc(c) {
            this.calendar = c;
        }
    }, {
        key: 'getWdio',
        value: function getWdio(prefix, elementClass) {
            return prefix ? prefix + '-' + elementClass : elementClass;
        }
    }, {
        key: 'renderInput',
        value: function renderInput() {
            var _this4 = this;

            var _props2 = this.props,
                date = _props2.date,
                label = _props2.label,
                name = _props2.name,
                errorMsg = _props2.errorMsg,
                className = _props2.className,
                readOnly = _props2.readOnly,
                wdioPrefix = _props2.wdioPrefix,
                locale = _props2.locale,
                dateFormatOptions = _props2.dateFormatOptions;


            var inputClasses = (0, _classnames2.default)(className, {
                'date-picker__input': true,
                'not-empty': this.state.isOpen
            });

            var overlayClasses = (0, _classnames2.default)('picker__overlay', {
                'picker__overlay--selectable': !readOnly
            });

            var inputValue = (0, _dateUtils.getLocaleDateString)(date, locale, dateFormatOptions);

            return _react2.default.createElement(
                'div',
                { className: 'position-relative' },
                _react2.default.createElement(_reactFormComponents.FormInput, {
                    className: inputClasses,
                    name: name,
                    label: label,
                    value: inputValue,
                    onChange: this.handleChangeInput,
                    onFocus: readOnly ? null : this.handleFocus,
                    errorMsg: errorMsg,
                    ref: function ref(c) {
                        return _this4.input = c;
                    },
                    readOnly: readOnly ? 'readOnly' : '',
                    'data-wdio': this.getWdio(wdioPrefix, 'date-picker-input')
                }),
                _react2.default.createElement('div', {
                    className: overlayClasses,
                    ref: function ref(c) {
                        return _this4.overlay = c;
                    },
                    onClick: readOnly ? null : this.handleFocus
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = (0, _classnames2.default)(this.props.className, 'date-picker');

            return _react2.default.createElement(_Base2.default, {
                fadeOutDuration: this.props.fadeOutDuration,
                calendarRefFunc: this.calendarRefFunc,
                className: classes,
                clearButtonLabel: this.props.clearButtonLabel // TODO: Linguaize
                , date: this.props.date,
                dayData: this.props.dayData,
                dayTemplateComponent: this.props.dayTemplateComponent,
                inputs: this.renderInput(),
                isDelayed: this.state.isDelayed,
                isMobile: this.props.isMobile,
                isOpen: this.state.isOpen,
                calendarLabels: this.props.calendarLabels,
                locale: this.props.locale,
                modalTitle: this.props.modalTitle // TODO: Linguaize
                , month: this.state.month,
                maxDate: this.props.maxDate,
                minDate: this.props.minDate,
                numMonthsToDisplay: 1,
                onDatesCleared: this.handleClearDates,
                onDisabledDayClick: this.props.onDisabledDayClick,
                onFocus: this.props.onFocus,
                onOpen: this.handleOpen,
                onClose: this.handleClose,
                onSubmit: this.props.onSubmit,
                onCancel: this.props.onCancel,
                onSelectionChanged: this.handleDateChange,
                parentNode: this.props.parentNode,
                scrollNode: this.props.scrollNode,
                selectionChangeMode: 'all',
                selectionType: 'single',
                showContinueButton: this.props.showContinueButton,
                year: this.state.year
            });
        }
    }]);

    return DatePicker;
}(_react.Component);

DatePicker.propTypes = {
    /** Optional labels object to override default locale-driven labels */
    calendarLabels: _propTypes2.default.shape({
        monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortMonthNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        dayNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
        shortDayNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    /** The text label displayed on the clear button */
    clearButtonLabel: _propTypes2.default.string,
    /** Selected date */
    date: _propTypeDateString2.default,
    /** Options object, eg. {month: 'short', day: 'numeric'} (See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString) */
    dateFormatOptions: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** DayData that will power any passed in template */
    dayData: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    /** An optional passed in React component, used to render each day. **/
    dayTemplateComponent: _propTypes2.default.func,
    /** Prevents keyboard input. Useful on iPad to prevent software keyboard from popping up. */
    disableTextInput: _propTypes2.default.bool,
    /** Form input's error message */
    errorMsg: _propTypes2.default.node,
    /** Determines whether the date picker is open or not */
    isOpen: _propTypes2.default.bool,
    /** Form input's label */
    label: _propTypes2.default.string.isRequired,
    /** A moniker or BCP-47 style language tag string. */
    locale: _propTypes2.default.string,
    /** The title of the modal displayed on mobile */
    modalTitle: _propTypes2.default.string,
    /** Maximum allowable date after which the next button will be disabled; scrollable mode stops loading more months. */
    maxDate: _propTypes2.default.instanceOf(Date),
    /** Minimum allowable date before which the prev button will be disabled; scrollable mode uses month and year props. */
    minDate: _propTypes2.default.instanceOf(Date),
    /** Form input's name property */
    name: _propTypes2.default.string.isRequired,
    /** Function to call when a date is selected on the calendar */
    onDateChange: _propTypes2.default.func,
    /** Function to call when the date is cleared */
    onDateClear: _propTypes2.default.func,
    /** An optional passed in React component, used to trigger Next Available arrival and departure dates when clicked on disabled dates. **/
    onDisabledDayClick: _propTypes2.default.func,
    /** Optional callback for when the date picker gains focus */
    onFocus: _propTypes2.default.func,
    /** Function to call when the date picker opens */
    onOpen: _propTypes2.default.func,
    /** Function to call when a date picker is closed */
    onClose: _propTypes2.default.func,
    /** Optional callback when date picker is submitted (continue) */
    onSubmit: _propTypes2.default.func,
    /** Options callback when date picker is closed (X, Esc) */
    onCancel: _propTypes2.default.func,
    /** The DOM element to use as the parent for the date picker when visible. This is useful in scenarios where the date picker needs to break out of its current container due to overflow or z-index issues. */
    parentNode: _Base2.default.checkElementType,
    /** Display-only mode */
    readOnly: _propTypes2.default.bool,
    /** The DOM element that the date picker needs to scroll with. Only specify this if parentNode was specified and the date picker is displayed in a container that is scrollable independent of the browser window. */
    scrollNode: _Base2.default.checkElementType,
    /** Show "continue" button in modal on mobile */
    showContinueButton: _propTypes2.default.bool,
    /** By default, the input element is given a data-wdio attribute of "date-picker-input".
    If you have more than one on a page you can add a prefix by using this property. */
    wdioPrefix: _propTypes2.default.bool,
    /** Duration of the fade transition when the tooltip closes in milliseconds */
    fadeOutDuration: _propTypes2.default.number
};
DatePicker.defaultProps = {
    calendarLabels: {},
    clearButtonLabel: 'clear',
    dateFormatOptions: {},
    disableTextInput: false,
    isOpen: false,
    modalTitle: 'Select a date',
    onClose: function onClose() {},
    onDateChange: function onDateChange() {},
    onDateClear: function onDateClear() {},
    onFocus: function onFocus() {},
    onOpen: function onOpen() {},
    readOnly: false,
    showContinueButton: false,
    fadeOutDuration: 400
};
exports.default = (0, _reactDetermineIfMobile2.default)(DatePicker);
//# sourceMappingURL=DatePicker.js.map

/***/ }),

/***/ "w5xw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fullV1 = fullV1;
function fullV1(_ref) {
    var env = _ref.env,
        site = _ref.site,
        puuid = _ref.puuid,
        hav = _ref.hav;

    var envMap = {
        dev: '-test',
        test: '-test',
        stage: '-stage',
        production: ''
    };

    var url = 'https://svc' + (envMap[env] || envMap.production) + '.homeaway.com/sp2/fullV1?site=' + site + '&havId=' + hav + '&includeSearchImages=true&_restfully=true';

    if (puuid && puuid !== '-1') {
        url = url + '&publicUserId=' + puuid;
    }

    var init = {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    };

    return fetch(url, init).then(function (response) {
        if (response.ok) {
            return response.json();
        }
        throw new Error('Call to /fullV1 failed.');
    });
}
//# sourceMappingURL=scratchpad.js.map

/***/ }),

/***/ "w7pv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("f7Xe");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Carousel = __webpack_require__("zaqd");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _CarouselUtil = __webpack_require__("ZTHW");

var _reactTransitionGroup = __webpack_require__("463A");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-line

var ModalCarouselContainer = function (_Component) {
    _inherits(ModalCarouselContainer, _Component);

    function ModalCarouselContainer(props) {
        _classCallCheck(this, ModalCarouselContainer);

        // hash of timeout ids mapped to readable keys
        var _this = _possibleConstructorReturn(this, (ModalCarouselContainer.__proto__ || Object.getPrototypeOf(ModalCarouselContainer)).call(this, props));

        _this.closeClick = function (e) {
            e.stopPropagation();
            _this.props.onClose();
        };

        _this.toggleDetails = function () {
            _this.setState({
                detailsHidden: !_this.state.detailsHidden
            });
        };

        _this.toggleHeader = function (hideHeader) {
            if (_this.state.headerHidden !== hideHeader) {
                _this.setState({
                    headerHidden: hideHeader
                });
            }
        };

        _this.closeModal = function () {
            var fromPanY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (fromPanY) {
                var closeFromPanY = _this.state.closeFromPanY;

                if (!closeFromPanY) {
                    _this.setState({
                        closeFromPanY: true
                    }, function () {
                        _this.props.onClose();
                    });
                }
            } else {
                _this.props.onClose();
            }
        };

        _this.timeouts = {};
        // initial state
        _this.state = {
            detailsHidden: false,
            headerHidden: false,
            closeFromPanY: false
        };
        return _this;
    }

    _createClass(ModalCarouselContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _state = this.state,
                headerHidden = _state.headerHidden,
                detailsHidden = _state.detailsHidden,
                closeFromPanY = _state.closeFromPanY;
            // if fullscreen modal will open, always show header and details, and make sure closeFromPanY is false

            if (nextProps.fullScreen && !this.props.fullScreen && (headerHidden || detailsHidden || closeFromPanY)) {
                this.setState({
                    headerHidden: false,
                    detailsHidden: false,
                    closeFromPanY: false
                });
            }
        }

        /* eslint-disable complexity */

    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            // For large, outside, container components like this, it is better to hand in
            // a single, or a few, objects.  The smaller, composed, componenents have
            // the more granular props.
            // Moving to a few larger objects will simplyfy this.
            var shouldUpdate = nextProps.index !== this.props.index || nextProps.prevIndex !== this.props.prevIndex || nextProps.fullScreen !== this.props.fullScreen || nextState.headerHidden !== this.state.headerHidden || nextState.detailsHidden !== this.state.detailsHidden || nextProps.renderedIndices.join(',') !== this.props.renderedIndices.join(',');

            return shouldUpdate;
        }
        /* eslint-enable complexity */

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            for (var key in this.timeouts) {
                if (this.timeouts.hasOwnProperty(key)) {
                    clearTimeout(this.timeouts[key]);
                }
            }
            this.timeouts = {};
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                images = _props.images,
                index = _props.index,
                fullScreen = _props.fullScreen,
                overlayColor = _props.overlayColor,
                pinchZoom = _props.pinchZoom,
                rest = _objectWithoutProperties(_props, ['images', 'index', 'fullScreen', 'overlayColor', 'pinchZoom']);

            var _state2 = this.state,
                detailsHidden = _state2.detailsHidden,
                headerHidden = _state2.headerHidden,
                closeFromPanY = _state2.closeFromPanY;


            var headerClass = (0, _classnames2.default)('modal-carousel-container__header', {
                'modal-carousel-container__header--hidden': detailsHidden,
                'modal-carousel-container__header--hidden-for-pan-dismiss': headerHidden
            });

            return _react2.default.createElement(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: 'modal-carousel-container-css-trans',
                    timeout: {
                        enter: _CarouselUtil.SETTINGS.MODAL_TRANSITION_DURATION,
                        exit: _CarouselUtil.SETTINGS.MODAL_TRANSITION_DURATION
                    },
                    exit: !closeFromPanY,
                    'in': fullScreen,
                    mountOnEnter: true,
                    unmountOnExit: true
                },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-carousel-container', key: 'modalCarousel' },
                    _react2.default.createElement(
                        'div',
                        { className: headerClass, style: _CarouselUtil.utils.getMatchingGradientStyle('to bottom', overlayColor) },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-carousel-container-header__count' },
                            _react2.default.createElement(
                                'span',
                                { className: 'modal-carousel-container-header__count--current' },
                                index + 1
                            ),
                            ' / ' + images.length
                        ),
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'modal-carousel-container-header__close',
                                role: 'button',
                                tabIndex: '0',
                                onClick: this.closeClick
                            },
                            _react2.default.createElement(
                                'svg',
                                { className: 'modal-carousel-container-header__close-circle-x inline-svg', version: '1.1', x: '0px', y: '0px', viewBox: '0 0 50 50' },
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement('path', { d: 'M1.5 50a1.5 1.5 0 0 1-1-2.6l47-47a1.5 1.5 0 0 1 2 2.2l-47 46.8a1.5 1.5 0 0 1-1 .5z' }),
                                    _react2.default.createElement('path', { d: 'M48.4 50a1.5 1.5 0 0 1-1-.4l-47-47A1.5 1.5 0 0 1 2.8.3l46.7 47a1.5 1.5 0 0 1-1 2.6z' })
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(_Carousel2.default, _extends({
                        images: images,
                        index: index,
                        onImageClick: this.toggleDetails,
                        onPanY: this.toggleHeader,
                        detailsHidden: detailsHidden,
                        overlayColor: overlayColor,
                        carouselType: _CarouselUtil.CAROUSEL_TYPE.FULLSCREEN,
                        closeModal: this.closeModal,
                        displayCaptions: true,
                        hasOrientationChangeResize: true,
                        pinchZoom: pinchZoom
                    }, rest))
                )
            );
        }
    }]);

    return ModalCarouselContainer;
}(_react.Component);

ModalCarouselContainer.propTypes = {
    /** Flag used to render full screen modal carousel.*/
    fullScreen: _propTypes2.default.bool.isRequired,
    /** Current image index. */
    index: _propTypes2.default.number.isRequired,
    /** Image data objects. Contains properties: src, lowResSrc, and altText. */
    images: _propTypes2.default.instanceOf(Array).isRequired,
    /** Indices from images array to render. */
    renderedIndices: _propTypes2.default.instanceOf(Array).isRequired,
    /** Updates image index to next image. Takes current index and images length as params. */
    onNextImage: _propTypes2.default.func.isRequired,
    /** Updates image index to previous image. Takes current index and images length as params. */
    onPrevImage: _propTypes2.default.func.isRequired,
    /** Function to execute when modal carousel is close button is clicked.*/
    onClose: _propTypes2.default.func.isRequired,
    /** Distance between slides */
    slideMargin: _propTypes2.default.number,
    /** Maximum opacity of overlay for non-current slides. */
    maxOverlayOpacity: _propTypes2.default.number,
    /** How many images at the front and tail of the renderedIndices should be rendered as low res.*/
    renderedLowResCountPerSide: _propTypes2.default.number,
    /** does not set a color style for the carousel background */
    hideBackground: _propTypes2.default.bool,
    /** Flag for determining if arrows should show */
    showArrows: _propTypes2.default.bool,
    /** renders previous and next buttons. Takes {handlePrev, handleNext} as argument */
    renderButtons: _propTypes2.default.func,
    /** Overlay color for image background.*/
    overlayColor: _propTypes2.default.string,
    /** How images size to slide and how slides flow within carousel. 'height' - images size to set height and flow horizantally,
    'width' - images size to set width and flow horizontally, 'contain' - images size to be contained in full height/width slide and flow horizontally, 'cover' - images size to cover full height/width slide and flow horizontally. */
    slideSize: _propTypes2.default.oneOf(['height', 'cover', 'contain']),
    /** Indicates whether carousel pans horizantally or horizontally and vertically. Possible vales are: 'horizontal' or 'all'.*/
    panDirection: _propTypes2.default.string,
    /** Multiplier which controls the rate at which the overlay opacity changes. 1 means the opacity will go from maximum to 0 when slide to be current slide is in current slide x-position. 0.5 means the opacity will go from maximum to 0 when slide to be current slide is half-way to the current slide x-position.*/
    overlayAccelerationMultiplier: _propTypes2.default.number,
    /** Indicates if carousel handles keyboard events, i.e. do arrow keys navigate images */
    handlesKeyboardNavigation: _propTypes2.default.bool,
    /** Enables pinch to zoom */
    pinchZoom: _propTypes2.default.bool,
    /** Maximum zoom level of slides beyond their actual pixel ratios. Ex. a 400px wide viewport at 1.5 maxZoom viewing a 2000px wide image could have a total scale factor of 7.5*/
    maxZoom: _propTypes2.default.number
};
ModalCarouselContainer.defaultProps = {
    fullScreen: false,
    index: 0,
    images: [],
    renderedIndices: [],
    onNextImage: function onNextImage() {},
    onPrevImage: function onPrevImage() {},
    onClose: function onClose() {},
    slideMargin: 50,
    maxOverlayOpacity: 0.9,
    renderedLowResCountPerSide: 0,
    hideBackground: false,
    showArrows: false,
    overlayAccelerationMultiplier: 0.625,
    panDirection: 'all',
    slideSize: 'contain',
    overlayColor: '#000000',
    handlesKeyboardNavigation: false,
    pinchZoom: false,
    maxZoom: 1.5
};
exports.default = ModalCarouselContainer;
//# sourceMappingURL=ModalCarouselContainer.js.map

/***/ }),

/***/ "wKps":
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__("5183"),
    noop = __webpack_require__("qrdl");

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),

/***/ "wSKX":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "wVAM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVRO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class ResizeListener
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description extendable component that uses the provided .handleResize() method
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/* eslint-env browser */

var defaultThrottleRate = 200;

var ResizeListener = function (_React$Component) {
  _inherits(ResizeListener, _React$Component);

  function ResizeListener() {
    _classCallCheck(this, ResizeListener);

    var _this = _possibleConstructorReturn(this, (ResizeListener.__proto__ || Object.getPrototypeOf(ResizeListener)).call(this));

    _this._handleResize = _this._handleResize.bind(_this);
    return _this;
  }

  _createClass(ResizeListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to bind again when passing to the window listner in for IE10
      this._handleResize = this._handleResize.bind(this);
      window.addEventListener('resize', this._handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleResize);
    }
  }, {
    key: '_handleResize',
    value: function _handleResize() {
      var _this2 = this;

      if (!this._resizeTimer) {
        this.props.handleResize();

        // throttle the listener
        this._resizeTimer = setTimeout(function () {
          // if a resize came in while we paused, adjust again once after the pause before we start listening again
          if (_this2._pendingResize) {
            _this2.props.handleResize();
          }

          _this2._resizeTimer = false;
        }, this.props.throttleRate);
      } else {
        this._pendingResize = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ResizeListener;
}(_react2.default.Component);

ResizeListener.propTypes = {
  handleResize: _propTypes2.default.func.isRequired,
  throttleRate: _propTypes2.default.number
};
ResizeListener.defaultProps = {
  throttleRate: defaultThrottleRate
};
exports.default = ResizeListener;

/***/ }),

/***/ "wXdB":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "wc36":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocaleDateStrings = exports.getDefaultLabels = undefined;

var _en = __webpack_require__("iXid");

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Return false if broswer does not support locales, per `toLocateDateString` spec
function getLocaleSupport() {
    try {
        new Date().toLocaleDateString('i');
    } catch (e) {
        return e.name === 'RangeError';
    }
    return false;
}

// If localeDateString is supported with locale and options, generate array of labels using toLocaleDateString
function getLocaleDateStrings(locale, options, useMonth) {
    // If locale wasn't specified, use a valid BCP-47 formatted
    // but non-existing locale (xx-XX) to get the default values.
    var date = new Date(2017, 0, 1); // New Years was a Sunday.
    var supportsLocales = getLocaleSupport();
    var targetNum = useMonth ? 12 : 7;
    var labelArray = [];
    locale = !locale ? 'xx-XX' : locale;

    if (supportsLocales) {
        for (var i = 0; i < targetNum; i++) {
            labelArray.push(date.toLocaleDateString(locale, options));
            if (useMonth) {
                date.setMonth(date.getMonth() + 1);
            } else {
                date.setDate(date.getDate() + 1);
            }
        }
        return labelArray;
    }
    return null;
}

// Return the default labels in English as a fallback
function getDefaultLabels(key) {
    return _en2.default[key];
}

exports.getDefaultLabels = getDefaultLabels;
exports.getLocaleDateStrings = getLocaleDateStrings;
//# sourceMappingURL=Labels.js.map

/***/ }),

/***/ "wiaE":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("NZra");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "wkAJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = __webpack_require__("OAwv");

var _queryString2 = _interopRequireDefault(_queryString);

var _reactUnveil = __webpack_require__("kSlA");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global google */

function injectMap(BaseComponent) {
    var Container = function (_Component) {
        _inherits(Container, _Component);

        function Container(props) {
            _classCallCheck(this, Container);

            var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));

            _this.state = {
                isLoading: true,
                unveiled: props.unveilOptions.unveiled
            };

            _this.loadMap = _this.loadMap.bind(_this);
            _this.initMap = _this.initMap.bind(_this);

            /* used to keep track of if the map has started to load. If it has we do not
            want to load it again */
            _this.hasMapStartedLoading = false;
            return _this;
        }

        _createClass(Container, [{
            key: 'initMap',
            value: function initMap() {
                if ((typeof google === 'undefined' || !google.maps) && !this.hasMapStartedLoading) {
                    this.hasMapStartedLoading = true;
                    this.loadMap();
                } else {
                    this.setState({ isLoading: false }); // eslint-disable-line react/no-did-mount-set-state
                }
                this.setState({ unveiled: true });
            }
        }, {
            key: 'loadMap',
            value: function loadMap() {
                var _this2 = this;

                var _props = this.props,
                    apiKey = _props.apiKey,
                    googleMapsApiOptions = _props.googleMapsApiOptions;

                var map = document.createElement('script');

                map.type = 'text/javascript';
                map.async = true;
                /* istanbul ignore next */
                map.onload = function () {
                    return _this2.setState({ isLoading: false });
                };
                map.src = 'https://maps.googleapis.com/maps/api/js?v=quarterly&key=' + apiKey + '&' + _queryString2.default.stringify(googleMapsApiOptions);

                /* Enzyme ignore document overriding so we can't mock the document away for SSR */
                /* istanbul ignore else */
                if (document && document.body) {
                    document.body.appendChild(map);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _props2 = this.props,
                    apiKey = _props2.apiKey,
                    loadingElement = _props2.loadingElement,
                    googleMapsApiOptions = _props2.googleMapsApiOptions,
                    unveilOptions = _props2.unveilOptions,
                    rest = _objectWithoutProperties(_props2, ['apiKey', 'loadingElement', 'googleMapsApiOptions', 'unveilOptions']); // eslint-disable-line no-unused-vars


                var threshold = unveilOptions.threshold,
                    throttleAmount = unveilOptions.throttleAmount;
                var _state = this.state,
                    isLoading = _state.isLoading,
                    unveiled = _state.unveiled;


                return _react2.default.createElement(
                    _reactUnveil.Unveil,
                    {
                        style: { height: '100%' },
                        onUnveil: this.initMap,
                        threshold: threshold,
                        throttleAmount: throttleAmount,
                        unveiled: unveiled
                    },
                    isLoading && loadingElement,
                    !isLoading && _react2.default.createElement(BaseComponent, rest)
                );
            }
        }]);

        return Container;
    }(_react.Component);

    Container.propTypes = {
        /** API key generated by expedia (see injectMaps docs for more info on how to get one) */
        apiKey: _propTypes2.default.string.isRequired,
        /** Additional options for the google maps api */
        googleMapsApiOptions: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
        /** Loading element to display */
        loadingElement: _propTypes2.default.node,
        /** Options to pass down into @homeaway/react-unveil */
        unveilOptions: _propTypes2.default.shape({
            onUnveil: _propTypes2.default.func,
            threshold: _propTypes2.default.number,
            throttleAmount: _propTypes2.default.number,
            unveiled: _propTypes2.default.bool
        })
    };
    Container.defaultProps = {
        googleMapsApiOptions: {
            language: 'en_US',
            region: 'US'
        },
        loadingElement: null,
        unveilOptions: {
            threshold: 0,
            throttleAmount: 400,
            unveiled: false
        }
    };

    return Container;
}

exports.default = injectMap;
//# sourceMappingURL=injectMap.js.map

/***/ }),

/***/ "wq4h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("BDlB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselPageNumber = function CarouselPageNumber(_ref) {
    var index = _ref.index,
        images = _ref.images;
    return _react2.default.createElement(
        'div',
        { className: 'carousel-page-number label label--black', 'aria-hidden': 'true' },
        index + 1 + ' / ' + images.length
    );
};

// Style
// Third Party Imports


CarouselPageNumber.propTypes = {
    index: _propTypes2.default.number.isRequired,
    images: _propTypes2.default.PropTypes.instanceOf(Array).isRequired
};

exports.default = CarouselPageNumber;
//# sourceMappingURL=CarouselPageNumber.js.map

/***/ }),

/***/ "wwwz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "x//u":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "x08l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactYoutube = __webpack_require__("k/pb");

var _reactYoutube2 = _interopRequireDefault(_reactYoutube);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _rcHammerjs = __webpack_require__("rwgm");

var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);

var _reactSvg = __webpack_require__("Ye17");

var _CarouselUtil = __webpack_require__("ZTHW");

var _PHOTO_ICON = __webpack_require__("eBKN");

var _PHOTO_ICON2 = _interopRequireDefault(_PHOTO_ICON);

__webpack_require__("Gq4c");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Third Party Imports


// Artifactory Imports


// Primary Imports


// styles


var CarouselSlide = function (_Component) {
    _inherits(CarouselSlide, _Component);

    function CarouselSlide(props) {
        _classCallCheck(this, CarouselSlide);

        var _this = _possibleConstructorReturn(this, (CarouselSlide.__proto__ || Object.getPrototypeOf(CarouselSlide)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            slideAspectRatio = _this$props.slideAspectRatio,
            imageAspectRatio = _this$props.imageAspectRatio,
            imageHeight = _this$props.imageHeight,
            imageWidth = _this$props.imageWidth,
            slideWidth = _this$props.slideWidth,
            slideHeight = _this$props.slideHeight;


        _this.state = {
            imageAspectRatio: imageAspectRatio,
            slideWidth: slideWidth,
            slideHeight: slideHeight,
            imageWidth: imageWidth,
            imageHeight: imageHeight,
            captionHeight: 0,
            detailsToggled: false,
            boundSide: _CarouselUtil.utils.getImageBoundSide(imageAspectRatio, slideAspectRatio),
            isImageError: false,
            iframeLoaded: false,
            pinchAllowed: false
        };

        _this.scale = 1;

        _this.lastImgPan = {
            deltaX: 0,
            deltaY: 0
        };

        _this.timeouts = {};

        // get a setStateIfChanged method that uses this component's setState method
        _this.setStateIfChanged = _CarouselUtil.utils.getSetStateIfChanged(function (changes) {
            return _this.setState(changes);
        });
        return _this;
    }

    _createClass(CarouselSlide, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // eslint-disable-line complexity
            var _state = this.state,
                detailsToggled = _state.detailsToggled,
                boundSide = _state.boundSide,
                imageWidth = _state.imageWidth,
                imageHeight = _state.imageHeight,
                imageAspectRatio = _state.imageAspectRatio,
                slideWidth = _state.slideWidth,
                slideHeight = _state.slideHeight,
                iframeLoaded = _state.iframeLoaded;
            var mediaType = nextProps.mediaType,
                persistVideoIframe = nextProps.persistVideoIframe,
                isCurrent = nextProps.isCurrent;

            var isVideo = mediaType === _CarouselUtil.MEDIA_TYPE.VIDEO;
            var newImageAspectRatio = imageAspectRatio || nextProps.imageAspectRatio || 0;
            var possibleChanges = [{
                key: 'detailsToggled',
                value: nextProps.detailsHidden !== this.props.detailsHidden,
                oldValue: detailsToggled
            }, {
                key: 'boundSide',
                value: _CarouselUtil.utils.getImageBoundSide(newImageAspectRatio, nextProps.slideAspectRatio),
                oldValue: boundSide
            }];

            if (isVideo && !isCurrent && !persistVideoIframe) {
                possibleChanges.push({
                    key: 'iframeLoaded',
                    value: false,
                    oldValue: iframeLoaded
                });
            }
            if (imageAspectRatio === 0 && nextProps.imageAspectRatio > 0) {
                // image hasn't been loaded yet and dimension haven't
                // been passed previously but are being passed now
                possibleChanges.push({
                    key: 'imageWidth',
                    value: nextProps.imageWidth,
                    oldValue: imageWidth
                }, {
                    key: 'imageHeight',
                    value: nextProps.imageHeight,
                    oldValue: imageHeight
                }, {
                    key: 'imageAspectRatio',
                    value: newImageAspectRatio,
                    oldValue: imageAspectRatio
                });
            }

            if (nextProps.slideWidth && nextProps.slideWidth !== this.props.slideWidth || nextProps.slideHeight && nextProps.slideHeight !== this.props.slideHeight) {
                // slide aspect size (and possibly ratio) has changed and
                // new slide size is being passed though props now
                possibleChanges.push({
                    key: 'slideWidth',
                    value: nextProps.slideWidth,
                    oldValue: slideWidth
                }, {
                    key: 'slideHeight',
                    value: nextProps.slideHeight,
                    oldValue: slideHeight
                });
            }

            // look at changing props and compare to state and update state if needed
            this.setStateIfChanged({
                possibleChanges: possibleChanges
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var index = nextProps.index,
                shouldRender = nextProps.shouldRender,
                panning = nextProps.panning,
                sliding = nextProps.sliding;

            var shouldUpdate = !sliding && !panning && (shouldRender || shouldRender !== this.props.shouldRender);
            return shouldUpdate;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(nextProps) {
            var _props = this.props,
                displayCaptions = _props.displayCaptions,
                captionsAlignment = _props.captionsAlignment,
                isCurrent = _props.isCurrent,
                persistVideoIframe = _props.persistVideoIframe;


            if (!isCurrent && !persistVideoIframe) {
                this.videoPlayer = null;
            }

            if (persistVideoIframe) {
                this.pauseVideoIfPlaying();
            }

            if (nextProps && nextProps.isCurrent !== isCurrent && isCurrent === true) {

                this.scale = 1;

                this.lastImgPan = {
                    deltaX: 0,
                    deltaY: 0
                };

                this.props.updateChildScale(1);
            }

            // only executes if displaysCaptions === true && captionsAlignment === 'imageBottom'.
            // this checks DOM Elements heights to see if caption needs to be absolutely postioned.
            if (displayCaptions && captionsAlignment === 'imageBottom') {
                this.setStateIfChanged({
                    possibleChanges: [{
                        key: 'captionHeight',
                        value: this.getCaptionHeight(this.captionBottom),
                        oldValue: this.state.captionHeight
                    }]
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            /* istanbul ignore else */
            if (this.videoPlayer) {
                this.videoPlayer.stopVideo();
            }

            this.videoPlayer = null;
        }
    }, {
        key: 'getCaptionHeight',
        value: function getCaptionHeight(captionBottomDOM) {
            return this.props.displayCaptions && captionBottomDOM && captionBottomDOM.offsetHeight && Math.ceil(captionBottomDOM.offsetHeight) || 0;
        }
    }, {
        key: 'doesCaptionNeedAbsPos',
        value: function doesCaptionNeedAbsPos(boundSide, imageHeight, captionHeight) {
            var _props2 = this.props,
                slideSize = _props2.slideSize,
                carouselHeight = _props2.carouselHeight;


            return slideSize === 'height' || slideSize === 'cover' || slideSize === 'contain' && (boundSide === 'height' || carouselHeight < imageHeight + captionHeight * 2);
        }
    }, {
        key: 'getCaptionClass',
        value: function getCaptionClass(top, boundSide) {
            var imageHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var captionHeight = arguments[3];
            var _props3 = this.props,
                imageAltText = _props3.imageAltText,
                detailsHidden = _props3.detailsHidden,
                displayCaptions = _props3.displayCaptions,
                captionsAlignment = _props3.captionsAlignment,
                isCurrent = _props3.isCurrent,
                slideSize = _props3.slideSize,
                carouselWidth = _props3.carouselWidth;
            var slideWidth = this.state.slideWidth;

            var captionNeedAbsPos = displayCaptions && (captionsAlignment === 'slideBottom' || this.doesCaptionNeedAbsPos(boundSide, imageHeight, captionHeight));

            return (0, _classnames2.default)('carousel-slide__caption', {
                'carousel-slide__caption--top': top,
                'carousel-slide__caption--bottom': !top,
                'carousel-slide__caption--needs-absolute-pos': captionNeedAbsPos,
                'carousel-slide__caption--not-shown': !imageAltText || !displayCaptions,
                'carousel-slide__caption--hidden': detailsHidden || !isCurrent,
                'carousel-slide__caption--toggled': this.state.detailsToggled,
                'carousel-slide__caption--fit-to-view': slideSize === 'height' && slideWidth > carouselWidth
            });
        }
    }, {
        key: 'getImageClass',
        value: function getImageClass() {
            var _props4 = this.props,
                slideSize = _props4.slideSize,
                gestureEnabled = _props4.gestureEnabled,
                pinchZoom = _props4.pinchZoom;
            var _state2 = this.state,
                boundSide = _state2.boundSide,
                imgPinchError = _state2.imgPinchError;

            return (0, _classnames2.default)('carousel-slide__img', {
                'carousel-slide__img--height-100': _CarouselUtil.utils.useHeightForImageBoundSize(slideSize, boundSide),
                'carousel-slide__img--width-100': _CarouselUtil.utils.useWidthForImageBoundSize(slideSize, boundSide),
                'carousel-slide__img--contain': slideSize === 'contain',
                'carousel-slide__img--cover': slideSize === 'cover',
                'carousel-slide__img--pinch-zoom': gestureEnabled && pinchZoom,
                'carousel-slide__img--wiggle': imgPinchError
            });
        }
    }, {
        key: 'getSlideClass',
        value: function getSlideClass() {
            var _props5 = this.props,
                imageSrc = _props5.imageSrc,
                slideSize = _props5.slideSize,
                isCurrent = _props5.isCurrent,
                isPrev = _props5.isPrev,
                isNext = _props5.isNext;
            var isImageError = this.state.isImageError;


            var isPlaceholder = !imageSrc;

            return (0, _classnames2.default)('carousel-slide', {
                'carousel-slide--height': slideSize === 'height',
                'carousel-slide--contain': slideSize === 'contain',
                'carousel-slide--cover': slideSize === 'cover',
                'carousel-slide--current': isCurrent,
                'carousel-slide--previous': isPrev,
                'carousel-slide--next': isNext,
                'carousel-slide--error': isImageError,
                'carousel-slide--is-placeholder': !isImageError && isPlaceholder
            });
        }
    }, {
        key: 'getOverlayClass',
        value: function getOverlayClass() {
            var _props6 = this.props,
                isCurrent = _props6.isCurrent,
                isPrev = _props6.isPrev,
                isNext = _props6.isNext;


            return (0, _classnames2.default)('carousel-slide__overlay', {
                'carousel-slide__overlay--current': isCurrent,
                'carousel-slide__overlay--prev': isPrev,
                'carousel-slide__overlay--next': isNext
            });
        }
    }, {
        key: 'getPreviewUrl',
        value: function getPreviewUrl(videoId) {
            return 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
            // return `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
        }
    }, {
        key: 'pauseVideoIfPlaying',
        value: function pauseVideoIfPlaying() {
            var _props7 = this.props,
                isCurrent = _props7.isCurrent,
                mediaType = _props7.mediaType;

            var isVideo = mediaType === _CarouselUtil.MEDIA_TYPE.VIDEO;
            if (isVideo && !isCurrent && this.videoPlayer && _reactYoutube2.default.PlayerState && this.videoPlayer.getPlayerState() === _reactYoutube2.default.PlayerState.PLAYING) {
                this.videoPlayer.pauseVideo();
            }
        }
    }, {
        key: 'renderVideoLoader',
        value: function renderVideoLoader() {
            return _react2.default.createElement(
                'div',
                { className: 'carousel-slide-video-loader-container' },
                _react2.default.createElement(
                    'svg',
                    { version: '1.1', viewBox: '0 0 68 48', width: '68px', height: '64px' },
                    _react2.default.createElement('path', { className: 'carousel-slide-video-loader-container__bg', d: 'M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'carousel-slide-video-loader-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'carousel-slide-video-loader' },
                        _react2.default.createElement(
                            'svg',
                            { className: 'carousel-slide-video-loader__circular', viewBox: '25 25 50 50' },
                            _react2.default.createElement('circle', { className: 'carousel-slide-video-loader__path', cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '6', strokeMiterlimit: '10' })
                        )
                    )
                )
            );
        }
    }, {
        key: 'getVideoSizeData',
        value: function getVideoSizeData() {
            var _props8 = this.props,
                maxVideoHeight = _props8.maxVideoHeight,
                slideSize = _props8.slideSize;
            var _state3 = this.state,
                imageAspectRatio = _state3.imageAspectRatio,
                slideWidth = _state3.slideWidth,
                slideHeight = _state3.slideHeight;

            /* istanbul ignore else */

            if (slideSize !== 'contain') {
                return {
                    height: slideHeight,
                    width: slideWidth,
                    top: 0,
                    left: 0
                };
            }
            var usableHeight = Math.min(slideHeight, maxVideoHeight);

            var _utils$getImageSize = _CarouselUtil.utils.getImageSize(slideWidth, usableHeight, imageAspectRatio, 'contain'),
                height = _utils$getImageSize.height,
                width = _utils$getImageSize.width;

            var left = (slideWidth - width) / 2;
            var top = (slideHeight - height) / 2;

            return {
                height: height,
                width: width,
                left: left,
                top: top
            };
        }

        /** GESTURE CODE */

    }, {
        key: 'render',


        /** END GESTURE CODE */

        value: function render() {
            // eslint-disable-line complexity
            var _props9 = this.props,
                imageSrc = _props9.imageSrc,
                imageAltText = _props9.imageAltText,
                overlayStyle = _props9.overlayStyle,
                index = _props9.index,
                renderPlaceholder = _props9.renderPlaceholder,
                overlayColor = _props9.overlayColor,
                shouldRender = _props9.shouldRender,
                setSlideRef = _props9.setSlideRef,
                slideAspectRatio = _props9.slideAspectRatio,
                slideStyle = _props9.slideStyle,
                displayCaptions = _props9.displayCaptions,
                truncateCaptions = _props9.truncateCaptions,
                carouselWidth = _props9.carouselWidth,
                carouselHeight = _props9.carouselHeight,
                slideSize = _props9.slideSize,
                onVideoPlay = _props9.onVideoPlay,
                isCurrent = _props9.isCurrent,
                mediaType = _props9.mediaType,
                persistVideoIframe = _props9.persistVideoIframe,
                gestureEnabled = _props9.gestureEnabled,
                pinchZoom = _props9.pinchZoom;
            var _state4 = this.state,
                boundSide = _state4.boundSide,
                imageAspectRatio = _state4.imageAspectRatio,
                isImageError = _state4.isImageError,
                slideWidth = _state4.slideWidth,
                iframeLoaded = _state4.iframeLoaded;


            if (slideAspectRatio > 0) {
                var isVideo = mediaType === _CarouselUtil.MEDIA_TYPE.VIDEO;
                var isPlaceholder = !imageSrc;
                var renderCaptions = imageAltText && displayCaptions && !isImageError;
                var imageSize = renderCaptions ? _CarouselUtil.utils.getImageSize(carouselWidth, carouselHeight, imageAspectRatio, slideSize, boundSide) : 0;
                var captionHeight = renderCaptions ? this.getCaptionHeight(this.captionBottom) : 0;
                var videoId = isVideo && _CarouselUtil.utils.getVideoId(imageSrc) || '';
                var captionContentFitToView = slideSize === 'height' && slideWidth > carouselWidth;
                var captionContentClass = (0, _classnames2.default)('carousel-slide-caption__content', {
                    'carousel-slide-caption__content--truncated': truncateCaptions,
                    'carousel-slide-caption__content--fit-to-view': captionContentFitToView
                });
                var captionContentStyle = {
                    maxWidth: captionContentFitToView ? carouselWidth + 'px' : ''
                };
                var videoOverlayClass = (0, _classnames2.default)('carousel-slide__video-overlay', {
                    'carousel-slide__video-overlay--current': isCurrent
                });
                var videoOverlayStyle = {};
                var videoPreviewClass = (0, _classnames2.default)('carousel-slide__video-preview', {
                    'carousel-slide__video-preview--iframe-doesnt-persist': !persistVideoIframe,
                    'carousel-slide__video-preview--current': isCurrent,
                    'carousel-slide__video-preview--current-and-loaded': isCurrent && this.state.iframeLoaded,
                    'carousel-slide__video-preview--iframe-persist-and-loaded': persistVideoIframe && iframeLoaded
                });
                var videoWrapperClass = (0, _classnames2.default)('carousel-slide__video-wrapper', {
                    'carousel-slide__video-wrapper--current': isCurrent
                });

                var _getVideoSizeData = this.getVideoSizeData(),
                    height = _getVideoSizeData.height,
                    width = _getVideoSizeData.width,
                    left = _getVideoSizeData.left,
                    top = _getVideoSizeData.top;

                var videoStyles = { backgroundImage: 'url(' + this.getPreviewUrl(videoId) + ')' };
                if (slideSize === 'contain') {
                    videoStyles.width = width + 'px';
                    videoStyles.height = height + 'px';
                    videoStyles.transform = 'translate(' + left + 'px, ' + top + 'px)';
                }

                var hammerOptions = {
                    recognizers: {

                        pan: {
                            threshold: 5
                        },
                        pinch: {
                            enable: true
                        }
                    }
                };

                return _react2.default.createElement(
                    'li',
                    {
                        style: slideStyle
                        // style={this.getSlideStyle()}
                        , className: this.getSlideClass(),
                        'data-index': index,
                        ref: setSlideRef,
                        onClick: this.onSlideClick
                    },
                    renderCaptions &&
                    // top caption (not shown but used for image positioning if caption position === 'imageBottom')
                    _react2.default.createElement(
                        'div',
                        { className: this.getCaptionClass(true, boundSide, imageSize.height, captionHeight) },
                        _react2.default.createElement(
                            'span',
                            { className: captionContentClass, style: captionContentStyle },
                            imageAltText
                        )
                    ),
                    shouldRender && !isPlaceholder && !isImageError && !isVideo && pinchZoom &&
                    // image

                    _react2.default.createElement(
                        _rcHammerjs2.default,
                        {
                            onPan: this.onPan,
                            onPanStart: this.onPanStart,
                            onPanEnd: this.onPanEnd,
                            direction: 'DIRECTION_ALL',
                            onPinch: this.onPinch,
                            onPinchStart: this.onPinchStart,
                            onPinchEnd: this.onPinchEnd,
                            options: hammerOptions,
                            key: 'slide-hammer-handler-' + index
                        },
                        _react2.default.createElement('img', {
                            className: this.getImageClass(),
                            src: imageSrc,
                            alt: imageAltText,
                            onLoad: this.onImageLoad,
                            onError: this.onImageError,
                            style: {
                                transform: this.props.isCurrent ? 'inherit' : 'scale(1) translate(0px, 0px)'
                            }
                        })
                    ),
                    shouldRender && !isPlaceholder && !isImageError && !isVideo && !pinchZoom &&
                    // image
                    _react2.default.createElement('img', {
                        className: this.getImageClass(),
                        src: imageSrc,
                        alt: imageAltText,
                        onLoad: this.onImageLoad,
                        onError: this.onImageError
                    }),
                    shouldRender && !isPlaceholder && !isImageError && isVideo && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            'div',
                            {
                                className: videoPreviewClass,
                                style: videoStyles
                            },
                            isCurrent && !iframeLoaded && this.renderVideoLoader()
                        ),
                        (persistVideoIframe || isCurrent) && _react2.default.createElement(
                            'div',
                            { className: videoWrapperClass },
                            _react2.default.createElement(_reactYoutube2.default, {
                                className: 'carousel-slide__iframe',
                                videoId: videoId,
                                opts: {
                                    height: height,
                                    width: width,
                                    playerVars: {
                                        rel: 0,
                                        playisinline: 1
                                    }
                                },
                                onReady: this.onIframeLoad,
                                onPlay: onVideoPlay,
                                onError: this.onImageError
                            }),
                            gestureEnabled && _react2.default.createElement('div', {
                                className: videoOverlayClass,
                                style: videoOverlayStyle,
                                onClick: this.onVideoOverlayClick
                            })
                        )
                    ),
                    isPlaceholder && !isImageError &&
                    // placeholder slide ui
                    renderPlaceholder(this.props),
                    isImageError &&
                    // image error slide ui
                    _react2.default.createElement(
                        'div',
                        { className: 'carousel-slide__error' },
                        _react2.default.createElement(_reactSvg.SVGIcon, {
                            className: 'carousel-slide__load-error-icon icon-gray',
                            markup: _PHOTO_ICON2.default
                        })
                    ),
                    renderCaptions &&
                    // bottom caption
                    _react2.default.createElement(
                        'div',
                        {
                            style: _CarouselUtil.utils.getMatchingGradientStyle('to top', overlayColor),
                            className: this.getCaptionClass(false, boundSide, imageSize.height, captionHeight),
                            ref: this.setCaptionBottomRef
                        },
                        _react2.default.createElement(
                            'span',
                            { className: captionContentClass, style: captionContentStyle },
                            imageAltText
                        )
                    ),
                    overlayStyle.backgroundColor !== '' &&
                    // overlay
                    _react2.default.createElement('div', {
                        className: this.getOverlayClass(),
                        style: overlayStyle
                    })
                );
            }
            return null;
        }
    }]);

    return CarouselSlide;
}(_react.Component);

CarouselSlide.propTypes = {
    index: _propTypes2.default.number.isRequired,
    imageSrc: _propTypes2.default.string.isRequired,
    shouldRender: _propTypes2.default.bool.isRequired,
    captionsAlignment: _propTypes2.default.oneOf(['slideBottom', 'imageBottom']).isRequired,
    detailsHidden: _propTypes2.default.bool,
    displayCaption: _propTypes2.default.bool,
    truncateCaptions: _propTypes2.default.bool,
    panning: _propTypes2.default.bool,
    updateSlideDataOnImageLoad: _propTypes2.default.bool,
    isCurrent: _propTypes2.default.bool,
    isNext: _propTypes2.default.bool,
    isPrev: _propTypes2.default.bool,
    slideStyle: _propTypes2.default.objectOf(_propTypes2.default.any),
    overlayStyle: _propTypes2.default.objectOf(_propTypes2.default.any),
    imageLowResSrc: _propTypes2.default.string,
    imageAltText: _propTypes2.default.string,
    slideSize: _propTypes2.default.string,
    overlayOpacity: _propTypes2.default.number,
    carouselWidth: _propTypes2.default.number,
    carouselHeight: _propTypes2.default.number,
    carouselAspectRatio: _propTypes2.default.number,
    slideWidth: _propTypes2.default.number,
    slideHeight: _propTypes2.default.number,
    slideAspectRatio: _propTypes2.default.number,
    imageWidth: _propTypes2.default.number,
    imageHeight: _propTypes2.default.number,
    imageAspectRatio: _propTypes2.default.number,
    imageLoadedCallback: _propTypes2.default.func,
    setSlideRef: _propTypes2.default.func,
    renderPlaceholder: _propTypes2.default.func,
    onVideoPlay: _propTypes2.default.func,
    persistVideoIframe: _propTypes2.default.bool,
    maxVideoHeight: _propTypes2.default.number,
    gestureEnabled: _propTypes2.default.bool,
    onSlideClick: _propTypes2.default.func,
    mediaType: _propTypes2.default.string,
    maxZoom: _propTypes2.default.number
};
CarouselSlide.defaultProps = {
    index: 0,
    imageSrc: '',
    shouldRender: false,
    captionsAlignment: 'slideBottom',
    detailsHidden: false,
    displayCaption: false,
    truncateCaptions: false,
    panning: false,
    updateSlideDataOnImageLoad: false,
    isCurrent: false,
    isNext: false,
    isPrev: false,
    slideStyle: { order: '', zIndex: '' },
    overlayStyle: { backgroundColor: 'rgba(0, 0, 0, .7)' },
    imageLowResSrc: '',
    imageAltText: '',
    slideSize: 'height',
    overlayOpacity: 0,
    carouselWidth: 0,
    carouselHeight: 0,
    carouselAspectRatio: 0,
    slideWidth: 0,
    slideHeight: 0,
    slideAspectRatio: 0,
    imageWidth: 0,
    imageHeight: 0,
    imageAspectRatio: 0,
    imageLoadedCallback: function imageLoadedCallback() {},
    setSlideRef: function setSlideRef() {},
    renderPlaceholder: function renderPlaceholder(_ref) {
        var index = _ref.index;

        return _react2.default.createElement(
            'div',
            { className: 'carousel-slide__placeholder' },
            _react2.default.createElement(
                'span',
                null,
                index + 1
            )
        );
    },
    onVideoPlay: function onVideoPlay() {},
    persistVideoIframe: false,
    gestureEnabled: false,
    onSlideClick: function onSlideClick() {},
    mediaType: '',
    updateChildScale: function updateChildScale() {},
    maxZoom: 1.5
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onImageLoad = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _state5 = _this2.state,
            boundSide = _state5.boundSide,
            imageWidth = _state5.imageWidth,
            imageHeight = _state5.imageHeight,
            imageAspectRatio = _state5.imageAspectRatio,
            slideWidth = _state5.slideWidth,
            slideHeight = _state5.slideHeight,
            pinchAllowed = _state5.pinchAllowed;
        var _props10 = _this2.props,
            index = _props10.index,
            imageLoadedCallback = _props10.imageLoadedCallback,
            carouselAspectRatio = _props10.carouselAspectRatio,
            isCurrent = _props10.isCurrent,
            slideSize = _props10.slideSize,
            imageSrc = _props10.imageSrc,
            carouselWidth = _props10.carouselWidth,
            carouselHeight = _props10.carouselHeight,
            maxZoom = _props10.maxZoom,
            mediaType = _props10.mediaType,
            updateSlideDataOnImageLoad = _props10.updateSlideDataOnImageLoad;

        var _utils$getImageProps = _CarouselUtil.utils.getImageProps(e.target),
            naturalWidth = _utils$getImageProps.naturalWidth,
            naturalHeight = _utils$getImageProps.naturalHeight,
            aspectRatio = _utils$getImageProps.aspectRatio;

        var imageAspectRatioHasChanged = imageAspectRatio !== aspectRatio;
        var slideAspectRatioHasChanged = updateSlideDataOnImageLoad && slideSize === 'height' && imageAspectRatioHasChanged;
        var possibleChanges = [];
        var slideData = { index: index };
        var slideAspectRatio = _this2.props.slideAspectRatio;

        if (naturalWidth * maxZoom > carouselWidth || naturalHeight * maxZoom > carouselHeight) {
            possibleChanges.push({
                key: 'pinchAllowed',
                value: true,
                oldValue: pinchAllowed
            });
        }

        // slideAspectRatioHasChanged can be short-circuited by the updateSlideDataOnImageLoad prop, which by default
        // is set to false and prevents slideAspectRatio changes from evaluating or having any propagated effects
        if (slideAspectRatioHasChanged) {
            // if slideSize is "height" (i.e slide width is dependant on image width)
            // get new slide size data using updated image aspect ratio
            slideData = _CarouselUtil.utils.computeSlideData({
                index: index,
                image: {
                    width: naturalWidth,
                    height: naturalHeight,
                    src: imageSrc
                },
                carouselWidth: carouselWidth,
                carouselHeight: carouselHeight,
                carouselAspectRatio: carouselAspectRatio,
                slideSize: slideSize,
                mediaType: mediaType
            });
            slideAspectRatio = slideData.slideAspectRatio;
            // add more possible state changes based on new slide width/height
            // if differ from previous slide width/height
            possibleChanges.push({
                key: 'slideWidth',
                value: slideData.slideWidth,
                oldValue: slideWidth
            }, {
                key: 'slideHeight',
                value: slideData.slideHeight,
                oldValue: slideHeight
            });
        }

        if (imageAspectRatioHasChanged) {
            // add possible state changes for properties
            // that are impacted by the image aspect ratio
            var newBoundSide = _CarouselUtil.utils.getImageBoundSide(aspectRatio, slideAspectRatio);
            possibleChanges.push({
                key: 'imageAspectRatio',
                value: aspectRatio,
                oldValue: imageAspectRatio
            }, {
                key: 'boundSide',
                value: newBoundSide,
                oldValue: boundSide
            }, {
                key: 'imageWidth',
                value: naturalWidth,
                oldValue: imageWidth
            }, {
                key: 'imageHeight',
                value: naturalHeight,
                oldValue: imageHeight
            });
        }

        _this2.setStateIfChanged({
            possibleChanges: possibleChanges
        });

        if (isCurrent || slideAspectRatioHasChanged) {
            imageLoadedCallback({
                slideData: slideData,
                dataHasChanged: slideAspectRatioHasChanged,
                isCurrentSlide: isCurrent
            });
        }
    };

    this.onIframeLoad = function (e) {
        var _props11 = _this2.props,
            imageLoadedCallback = _props11.imageLoadedCallback,
            isCurrent = _props11.isCurrent;


        if (e && e.target) {
            _this2.videoPlayer = e.target;
        }

        clearTimeout(_this2.timeouts.iframeLoaded);
        _this2.timeouts.iframeLoaded = setTimeout(function () {
            delete _this2.timeouts.iframeLoaded;
            _this2.setStateIfChanged({
                possibleChanges: [{
                    key: 'iframeLoaded',
                    value: true,
                    oldValue: _this2.state.iframeLoaded
                }]
            });
        }, 150);

        if (isCurrent) {
            imageLoadedCallback({
                isCurrentSlide: isCurrent
            });
        }
    };

    this.onImageError = function () {
        var _state6 = _this2.state,
            imageAspectRatio = _state6.imageAspectRatio,
            slideWidth = _state6.slideWidth,
            slideHeight = _state6.slideHeight;
        var _props12 = _this2.props,
            slideSize = _props12.slideSize,
            imageSrc = _props12.imageSrc,
            isCurrent = _props12.isCurrent,
            mediaType = _props12.mediaType,
            imageLoadedCallback = _props12.imageLoadedCallback,
            index = _props12.index,
            carouselWidth = _props12.carouselWidth,
            carouselHeight = _props12.carouselHeight,
            carouselAspectRatio = _props12.carouselAspectRatio,
            updateSlideDataOnImageLoad = _props12.updateSlideDataOnImageLoad;

        var possibleChanges = [{
            key: 'isImageError',
            value: true,
            oldValue: _this2.state.isImageError
        }];

        if (mediaType === _CarouselUtil.MEDIA_TYPE.VIDEO && _this2.videoPlayer) {
            _this2.videoPlayer = null;
        }

        var slideAspectRatioHasChanged = updateSlideDataOnImageLoad && slideSize === 'height' && imageAspectRatio === 0;
        var slideData = { index: index };

        // slideAspectRatioHasChanged can be short-circuited by the updateSlideDataOnImageLoad prop, which by default
        // is set to false and prevents slideAspectRatio changes from evaluating or having any propagated effects
        if (slideAspectRatioHasChanged) {
            slideData = _CarouselUtil.utils.computeSlideData({
                index: index,
                image: {
                    width: _CarouselUtil.SETTINGS.DEFAULT_WIDTH,
                    height: _CarouselUtil.SETTINGS.DEFAULT_HEIGHT,
                    src: imageSrc
                },
                carouselWidth: carouselWidth,
                carouselHeight: carouselHeight,
                carouselAspectRatio: carouselAspectRatio,
                slideSize: slideSize,
                mediaType: mediaType
            });
            possibleChanges.push({
                key: 'slideWidth',
                value: slideData.slideWidth,
                oldValue: slideWidth
            }, {
                key: 'slideHeight',
                value: slideData.slideHeight,
                oldValue: slideHeight
            });
        }

        _this2.setStateIfChanged({
            possibleChanges: possibleChanges
        });

        if (isCurrent || slideAspectRatioHasChanged) {
            imageLoadedCallback({
                slideData: slideData,
                dataHasChanged: slideAspectRatioHasChanged,
                isCurrentSlide: isCurrent
            });
        }
    };

    this.setCaptionBottomRef = function (ref) {
        _this2.captionBottom = ref;
    };

    this.onVideoOverlayClick = function (e) {
        // eslint-disable-line complexity
        if (_this2.props.isCurrent) {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            }

            if (_this2.videoPlayer && _reactYoutube2.default.PlayerState) {
                var statesToPause = [_reactYoutube2.default.PlayerState.PLAYING];
                var statesToPlay = [_reactYoutube2.default.PlayerState.UNSTARTED, _reactYoutube2.default.PlayerState.ENDED, _reactYoutube2.default.PlayerState.PAUSED, _reactYoutube2.default.PlayerState.CUED];
                var playerState = _this2.videoPlayer.getPlayerState();

                /* istanbul ignore else */
                if (statesToPause.indexOf(playerState) > -1) {
                    _this2.videoPlayer.pauseVideo();
                } else if (statesToPlay.indexOf(playerState) > -1) {
                    _this2.videoPlayer.playVideo();
                }
            }
        }
    };

    this.onSlideClick = function () {
        var _props13 = _this2.props,
            index = _props13.index,
            isCurrent = _props13.isCurrent,
            onSlideClick = _props13.onSlideClick;

        onSlideClick({ index: index, isCurrent: isCurrent });
    };

    this.getTranslateValues = function (currScale, e) {
        if (e.target) {
            var _props14 = _this2.props,
                carouselWidth = _props14.carouselWidth,
                carouselHeight = _props14.carouselHeight,
                maxZoom = _props14.maxZoom;


            if (Math.abs(currScale - e.target.naturalWidth * maxZoom / e.target.width) * 100 < 1 && e.distance <= 1.5) {
                // prevents jitter when zooming when already at max zoom, 1.5 < sqrt(2) which is a diagonal move of 1
                return {
                    newX: _this2.lastImgPan.deltaX,
                    newY: _this2.lastImgPan.deltaY
                };
            }

            var newX = void 0,
                newY = void 0;
            var originalWidth = e.target.width;
            var originalHeight = e.target.height;

            var maxHeightOffset = (originalHeight * currScale - carouselHeight) / 2 / currScale;
            var maxWidthOffset = (originalWidth * currScale - carouselWidth) / 2 / currScale;

            if (e.deltaY / currScale + _this2.lastImgPan.deltaY > maxHeightOffset || e.deltaY / currScale + _this2.lastImgPan.deltaY < -maxHeightOffset) {
                var isNegative = e.deltaY + _this2.lastImgPan.deltaY < 0;
                newY = isNegative ? -maxHeightOffset : maxHeightOffset;
            } else {
                newY = e.deltaY / currScale + _this2.lastImgPan.deltaY;
            }

            if (e.deltaX / currScale + _this2.lastImgPan.deltaX > maxWidthOffset || e.deltaX / currScale + _this2.lastImgPan.deltaX < -maxWidthOffset) {
                var _isNegative = e.deltaX + _this2.lastImgPan.deltaX < 0;
                newX = _isNegative ? -maxWidthOffset : maxWidthOffset;
            } else {
                newX = e.deltaX / currScale + _this2.lastImgPan.deltaX;
            }

            return {
                newX: newX,
                newY: newY
            };
        }

        return {
            newX: _this2.lastImgPan.deltaX,
            newY: _this2.lastImgPan.deltaY
        };
    };

    this.getTransformString = function (e) {
        var _props15 = _this2.props,
            carouselHeight = _props15.carouselHeight,
            carouselWidth = _props15.carouselWidth,
            isCurrent = _props15.isCurrent,
            maxZoom = _props15.maxZoom;


        var originalWidth = e.target.width;
        var originalHeight = e.target.height;
        var imgNaturalWidth = e.target.naturalWidth;

        var currScale = Math.sqrt(e.scale) * _this2.scale;

        if (currScale < 1) {
            currScale = 1;
        }

        if (currScale * originalWidth > imgNaturalWidth * maxZoom) {
            currScale = imgNaturalWidth * maxZoom / originalWidth;
        }

        var cancelYChanges = false;
        var cancelXChanges = false;
        if (originalHeight * currScale < carouselHeight) {
            cancelYChanges = true;
        }

        if (originalWidth * currScale < carouselWidth) {
            cancelXChanges = true;
        }

        var _getTranslateValues = _this2.getTranslateValues(currScale, e),
            newX = _getTranslateValues.newX,
            newY = _getTranslateValues.newY;

        var translateString = '';

        if (currScale === 1) {
            translateString = '0px,0px';
        } else {
            translateString = (cancelXChanges ? '0px' : newX + 'px') + ',' + (cancelYChanges ? '0px' : newY + 'px');
        }

        var transformString = isCurrent ? 'scale(' + currScale + ') translate(' + translateString + ')' : 'scale(1) translate(0px, 0px)';

        return transformString;
    };

    this.onPan = function (e) {
        if (!_this2.state.pinchAllowed) {
            return;
        }

        var transformString = _this2.getTransformString(e);
        e.target.style.transform = transformString;
    };

    this.onPanEnd = function (e) {
        if (!_this2.state.pinchAllowed) {
            return;
        }

        var transformString = _this2.getTransformString(e);
        e.target.style.transform = transformString;

        var currScale = Math.sqrt(e.scale) * _this2.scale;

        var _getTranslateValues2 = _this2.getTranslateValues(currScale, e),
            newX = _getTranslateValues2.newX,
            newY = _getTranslateValues2.newY;

        if (e.target.classList.contains('carousel-slide__img')) {
            _this2.lastImgPan.deltaX = newX;
            _this2.lastImgPan.deltaY = newY;
        }
    };

    this.onPanStart = function () {
        if (!_this2.state.pinchAllowed) {
            return;
        }

        _this2.props.updateChildScale(_this2.scale);
    };

    this.onPinchStart = function () {
        // use this to block parent panning
        if (!_this2.state.pinchAllowed && !_this2.state.imgPinchError) {
            _this2.setState({
                imgPinchError: true
            });

            /* istanbul ignore next */
            setTimeout(function () {
                _this2.setState({
                    imgPinchError: false
                });

                _this2.props.updateChildScale(1);
            }, 600);
        }

        //this just blocks panning
        _this2.props.updateChildScale(1.1);
    };

    this.onPinch = function (e) {
        /* istanbul ignore else */
        if (!_this2.state.pinchAllowed) {
            return;
        }

        if (e.target.classList.contains('carousel-slide__img')) {
            // console.log('trying to prevent thrashing', Math.abs(this.lastPinchScale - e.scale) * 100);
            // only do scales bigger than 1% to prevent layout thrashing at max scale
            var transformString = _this2.getTransformString(e);
            e.target.style.transform = transformString;
        }
    };

    this.onPinchEnd = function (e) {
        /* istanbul ignore else */

        if (!_this2.state.pinchAllowed) {
            return;
        }

        if (e.target.classList.contains('carousel-slide__img')) {
            var maxZoom = _this2.props.maxZoom;

            var newScaleFactor = _this2.scale * Math.sqrt(e.scale);
            var imgNaturalWidth = e.target.naturalWidth;
            var imgCurrentWidth = e.target.width;

            if (newScaleFactor < 1) {
                newScaleFactor = 1;
            }
            if (newScaleFactor * e.target.width > e.target.naturalWidth * maxZoom) {
                newScaleFactor = imgNaturalWidth * maxZoom / imgCurrentWidth;
            }

            _this2.scale = newScaleFactor;
            _this2.props.updateChildScale(_this2.scale);
        }
    };
};

exports.default = CarouselSlide;
//# sourceMappingURL=CarouselSlide.js.map

/***/ }),

/***/ "xC4e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.print = print;

var _visitor = __webpack_require__("Hw4J");

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return (0, _visitor.visit)(ast, {
    leave: printDocASTReducer
  });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (args.every(function (arg) {
      return arg.indexOf('\n') === -1;
    }) ? wrap('(', join(args, ', '), ')') : wrap('(\n', indent(join(args, '\n')), '\n)')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        locations = _ref31.locations;
    return 'directive @' + name + (args.every(function (arg) {
      return arg.indexOf('\n') === -1;
    }) ? wrap('(', join(args, ', '), ')') : wrap('(\n', indent(join(args, '\n')), '\n)')) + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */


function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */


function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? "\"\"\"".concat(escaped.replace(/"$/, '"\n'), "\"\"\"") : "\"\"\"\n".concat(isDescription ? escaped : indent(escaped), "\n\"\"\"");
}

/***/ }),

/***/ "xGNz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHav = exports.setTripboardTranslations = undefined;

var _constants = __webpack_require__("hXMO");

var setTripboardTranslations = function setTripboardTranslations(payload) {
  return { type: _constants.SET_TRIPBOARD_TRANSLATIONS, payload: payload };
};
var setHav = function setHav(payload) {
  return { type: _constants.SET_HAV, payload: payload };
};

exports.setTripboardTranslations = setTripboardTranslations;
exports.setHav = setHav;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "xtBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_d3276433b58c8a2853f4
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/node_modules/prop-types/index.js
var prop_types = __webpack_require__("MwfY");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-modal/lib/esm/index.js + 3 modules
var esm = __webpack_require__("XSjK");

// EXTERNAL MODULE: delegated ./node_modules/classnames/index.js from dll-reference vendor_d3276433b58c8a2853f4
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("HW6M");
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-buttons/lib/transpiled/index.js
var transpiled = __webpack_require__("HfJ9");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchButton/style.css
var style = __webpack_require__("XrqK");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchButton/index.js



var SearchButton_SearchButton = function SearchButton(_ref) {
  var className = _ref.className,
      label = _ref.label,
      disabled = _ref.disabled;
  return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
    className: className
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(transpiled["ButtonPrimary"], {
    className: "search__button",
    disabled: disabled,
    type: "submit",
    label: label
  }));
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-date-pickers/lib/transpiled/index.js
var lib_transpiled = __webpack_require__("lLC2");
var lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/DatePicker/style.css
var DatePicker_style = __webpack_require__("k1pe");
var DatePicker_style_default = /*#__PURE__*/__webpack_require__.n(DatePicker_style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/DatePicker/index.js
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var DatePicker_DatePicker =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(DatePicker, _Component);

  function DatePicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleDateRangeChange = function (checkinDate, checkoutDate) {
      _this.props.onInputCheckIn(checkinDate);

      _this.props.onInputCheckOut(checkoutDate);

      _this.setState({
        showContinueButton: !!(checkinDate && checkoutDate)
      });
    };

    _this.state = {
      showContinueButton: false
    };
    return _this;
  }

  var _proto = DatePicker.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        actionLocation = _this$props.actionLocation,
        checkIn = _this$props.checkIn,
        checkOut = _this$props.checkOut,
        consolidateInputs = _this$props.consolidateInputs,
        isMobile = _this$props.isMobile,
        calendarLabels = _this$props.calendarLabels,
        edapLabel = _this$props.edapLabel,
        labels = _this$props.labels,
        locale = _this$props.locale,
        dayTemplateComponent = _this$props.dayTemplateComponent,
        onClose = _this$props.onClose,
        onOpen = _this$props.onOpen,
        isOpen = _this$props.isOpen,
        splitInputs = _this$props.splitInputs;
    var showContinueButton = this.state.showContinueButton;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(lib_transpiled["DateRangePicker"], {
      id: "react-searchbox-daterange-picker",
      actionLocation: actionLocation,
      isOpen: isOpen,
      isMobile: isMobile,
      startDate: checkIn,
      endDate: checkOut,
      inputLabel1: labels.label,
      inputLabel2: labels.label2,
      inputName1: 'checkin',
      inputName2: 'checkout',
      onDateRangeChange: this.handleDateRangeChange,
      className: 'DatePicker__range',
      calendarLabels: calendarLabels,
      dateFormatOptions: {
        month: 'short',
        day: 'numeric'
      },
      locale: locale,
      edapLabel: edapLabel,
      disableTextInput: true,
      clearButtonLabel: labels.clear,
      showContinueButton: showContinueButton,
      dayTemplateComponent: dayTemplateComponent,
      continueButtonLabel: labels.done,
      consolidateInputs: consolidateInputs,
      onClose: onClose,
      onOpen: onOpen,
      showArrow: false,
      splitInputs: splitInputs
    });
  };

  return DatePicker;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
DatePicker_DatePicker.propTypes = {
  actionLocation: prop_types_default.a.string,
  calendarLabels: prop_types_default.a.shape({}),
  checkIn: prop_types_default.a.string,
  checkOut: prop_types_default.a.string,
  consolidateInputs: prop_types_default.a.bool,
  dayTemplateComponent: prop_types_default.a.func,
  edapLabel: prop_types_default.a.string,
  isMobile: prop_types_default.a.bool,
  isOpen: prop_types_default.a.bool,
  labels: prop_types_default.a.shape({
    label: prop_types_default.a.string,
    clear: prop_types_default.a.string
  }),
  locale: prop_types_default.a.string,
  onClose: prop_types_default.a.func,
  onInputCheckIn: prop_types_default.a.func.isRequired,
  onInputCheckOut: prop_types_default.a.func.isRequired,
  onOpen: prop_types_default.a.func,
  splitInputs: prop_types_default.a.bool
};
DatePicker_DatePicker.defaultProps = {
  checkIn: '',
  checkOut: '',
  dayTemplateComponent: function dayTemplateComponent() {},
  edapLabel: '',
  isMobile: false,
  isOpen: false,
  labels: {
    label: 'Dates',
    clear: 'Clear'
  },
  locale: 'en_US',
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  query: 'Where do you want to go?',
  splitInputs: false
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/config.js
var config = __webpack_require__("9uIi");

// CONCATENATED MODULE: ./node_modules/@homeaway/react-destination-typeahead/lib/esm/index.js

/* harmony default export */ var lib_esm = (config["a" /* default */]);
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/Typeahead/style.css
var Typeahead_style = __webpack_require__("5Du6");
var Typeahead_style_default = /*#__PURE__*/__webpack_require__.n(Typeahead_style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/Typeahead/index.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Typeahead__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var Typeahead_Typeahead =
/*#__PURE__*/
function (_Component) {
  Typeahead__inheritsLoose(Typeahead, _Component);

  function Typeahead() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleChange = function (result) {
      if (result.selectedDestination) {
        _this.props.onInputQuery(result);
      }
    };

    _this.onClose = function (searchTerm) {
      _this.props.onInputQuery({
        search: searchTerm,
        selectedDestination: {}
      });
    };

    return _this;
  }

  var _proto = Typeahead.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        query = _this$props.query,
        labels = _this$props.labels,
        typeaheadProps = _this$props.typeaheadProps,
        showIcon = _this$props.showIcon;
    var defaultIcon = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("svg", null, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("use", {
      xlinkHref: "#magnifier"
    }));
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(lib_esm, _extends({
      search: query,
      onUpdate: this.handleChange,
      onClose: this.onClose,
      icon: showIcon ? defaultIcon : false,
      messages: labels
    }, typeaheadProps));
  };

  return Typeahead;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

Typeahead_Typeahead.propTypes = {
  query: prop_types_default.a.string,
  onInputQuery: prop_types_default.a.func.isRequired,
  locale: prop_types_default.a.string,
  typeaheadProps: prop_types_default.a.shape({})
};
Typeahead_Typeahead.defaultProps = {
  query: ''
};

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-guest-picker/lib/transpiled/index.js
var react_guest_picker_lib_transpiled = __webpack_require__("U7UD");
var react_guest_picker_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_guest_picker_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/GuestPicker/style.css
var GuestPicker_style = __webpack_require__("WUh3");
var GuestPicker_style_default = /*#__PURE__*/__webpack_require__.n(GuestPicker_style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/GuestPicker/index.js
function GuestPicker__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var GuestPicker_GuestPicker =
/*#__PURE__*/
function (_Component) {
  GuestPicker__inheritsLoose(GuestPicker, _Component);

  function GuestPicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleGuestSelectorChange = function (key, value) {
      var _this$setState;

      _this.props.onInputGuest(key, value);

      _this.setState((_this$setState = {}, _this$setState[key] = value, _this$setState));
    };

    _this.handleGuestSelectorCleared = function () {
      var clearedState = {
        adultsCount: 0,
        childrenCount: 0,
        petIncluded: false
      };

      _this.setState(clearedState);

      _this.props.onInputGuest('clear', clearedState);
    };

    _this.handleGuestSelectorExited = function (undoState) {
      _this.setState(undoState);

      _this.props.onExit(undoState);
    };

    _this.state = {
      adultsCount: props.guests.adultsCount || props.guests.adultsMin || 0,
      childrenCount: props.guests.childrenCount || 0,
      petIncluded: props.guests.petIncluded || false
    };
    return _this;
  }

  var _proto = GuestPicker.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        isMobile = _this$props.isMobile,
        labels = _this$props.labels,
        onOpen = _this$props.onOpen,
        onClose = _this$props.onClose,
        isOpen = _this$props.isOpen,
        showClearButton = _this$props.showClearButton,
        guests = _this$props.guests;
    var _this$state = this.state,
        adultsCount = _this$state.adultsCount,
        childrenCount = _this$state.childrenCount,
        petIncluded = _this$state.petIncluded;
    var adultsLabel = adultsCount === 1 ? adultsCount + " " + labels.adult : adultsCount + " " + labels.adults;
    var childrenLabel = childrenCount === 1 ? childrenCount + " " + labels.child : childrenCount + " " + labels.children;

    var guestLabel = function guestLabel(numGuests, pet) {
      var petString = pet ? ", " + labels.pets : '';
      return numGuests ? numGuests + " " + labels.guests + petString : '';
    };

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_guest_picker_lib_transpiled_default.a, {
      id: 'react-searchbox-guest-picker',
      isOpen: isOpen,
      isMobile: isMobile,
      label: labels.label,
      name: 'Guests',
      guestLabel: guestLabel(adultsCount + childrenCount, petIncluded),
      adultsLabel: adultsLabel,
      adultsCount: adultsCount,
      adultsMin: guests.adultsMin,
      childrenLabel: childrenLabel,
      childrenCount: childrenCount,
      petIncluded: petIncluded,
      showPetOption: true,
      onChange: this.handleGuestSelectorChange,
      onClear: this.handleGuestSelectorCleared,
      onExit: this.handleGuestSelectorExited,
      onClose: onClose,
      onOpen: onOpen,
      applyButtonLabel: labels.applyBtn,
      clearButtonLabel: labels.clearBtn,
      petLabel: labels.pets,
      petYesLabel: labels.yesBtn,
      petNoLabel: labels.noBtn,
      modalTitle: labels.modalTitle,
      continueButtonLabel: labels.mobileBtn,
      disableTextInput: true,
      showClearButton: showClearButton
    });
  };

  return GuestPicker;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

GuestPicker_GuestPicker.propTypes = {
  isMobile: prop_types_default.a.bool,
  showClearButton: prop_types_default.a.bool,
  guests: prop_types_default.a.shape({
    adultsCount: prop_types_default.a.number,
    childrenCount: prop_types_default.a.number,
    petIncluded: prop_types_default.a.bool,
    adultsMin: prop_types_default.a.number
  }).isRequired,
  onInputGuest: prop_types_default.a.func.isRequired,
  labels: prop_types_default.a.shape({
    label: prop_types_default.a.string,
    adult: prop_types_default.a.string,
    adults: prop_types_default.a.string,
    child: prop_types_default.a.string,
    children: prop_types_default.a.string,
    pets: prop_types_default.a.string,
    guests: prop_types_default.a.string,
    yesBtn: prop_types_default.a.string,
    noBtn: prop_types_default.a.string,
    clearBtn: prop_types_default.a.string,
    applyBtn: prop_types_default.a.string,
    modalTitle: prop_types_default.a.string,
    mobileBtn: prop_types_default.a.string
  }).isRequired,
  isOpen: prop_types_default.a.bool,
  onOpen: prop_types_default.a.func,
  onClose: prop_types_default.a.func,
  onExit: prop_types_default.a.func
};
GuestPicker_GuestPicker.defaultProps = {
  isMobile: false,
  guests: {},
  labels: {
    label: 'Dates',
    clear: 'Clear'
  },
  isOpen: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onExit: function onExit() {}
};

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchForm/style.css
var SearchForm_style = __webpack_require__("KTwR");
var SearchForm_style_default = /*#__PURE__*/__webpack_require__.n(SearchForm_style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchForm/index.js
function SearchForm__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










var SearchForm_SearchForm =
/*#__PURE__*/
function (_React$Component) {
  SearchForm__inheritsLoose(SearchForm, _React$Component);

  function SearchForm() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SearchForm.prototype;

  /* eslint-disable complexity */
  _proto.render = function render() {
    var _this$props = this.props,
        actionLocation = _this$props.actionLocation,
        checkIn = _this$props.checkIn,
        checkOut = _this$props.checkOut,
        consolidateDateInputs = _this$props.consolidateDateInputs,
        extendedSearchBar = _this$props.extendedSearchBar,
        guests = _this$props.guests,
        query = _this$props.query,
        isMobile = _this$props.isMobile,
        edapDatePickerLabel = _this$props.edapDatePickerLabel,
        labels = _this$props.labels,
        locale = _this$props.locale,
        typeaheadProps = _this$props.typeaheadProps,
        hideDates = _this$props.hideDates,
        hideGuests = _this$props.hideGuests,
        showClearButton = _this$props.showClearButton,
        dayTemplateComponent = _this$props.dayTemplateComponent,
        isDatePickerOpen = _this$props.isDatePickerOpen,
        isGuestPickerOpen = _this$props.isGuestPickerOpen,
        onDatePickerClose = _this$props.onDatePickerClose,
        onDatePickerOpen = _this$props.onDatePickerOpen,
        onGuestPickerOpen = _this$props.onGuestPickerOpen,
        onGuestPickerClose = _this$props.onGuestPickerClose,
        onGuestPickerExit = _this$props.onGuestPickerExit,
        buttonComponent = _this$props.buttonComponent,
        splitDatePicker = _this$props.splitDatePicker,
        useMobileExpanded = _this$props.useMobileExpanded;
    var modalInputClasses = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
      'SearchForm__input--modal': !useMobileExpanded && isMobile
    });
    var modalButtonClasses = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
      'SearchForm__button--modal': !useMobileExpanded && isMobile
    });
    var extendedSearchBarClasses = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('SearchForm__input', {
      'SearchForm__input--extended': extendedSearchBar
    });
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("form", {
      className: "SearchForm",
      onSubmit: this.props.onSubmit
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: "SearchForm__input SearchForm__input--typeahead " + extendedSearchBarClasses + " " + modalInputClasses
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Typeahead_Typeahead, {
      showIcon: false,
      query: query,
      onInputQuery: this.props.onInputQuery,
      labels: labels.typeahead,
      typeaheadProps: typeaheadProps
    })), !hideDates && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: "SearchForm__input SearchForm__input--date-picker " + modalInputClasses
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(DatePicker_DatePicker, {
      actionLocation: actionLocation,
      isMobile: isMobile,
      onInputCheckOut: this.props.onInputCheckOut,
      onInputCheckIn: this.props.onInputCheckIn,
      calendarLabels: labels.calendarLabels,
      checkIn: checkIn,
      checkOut: checkOut,
      consolidateInputs: consolidateDateInputs,
      edapLabel: edapDatePickerLabel,
      labels: labels.datePicker,
      locale: locale,
      dayTemplateComponent: dayTemplateComponent,
      onClose: onDatePickerClose,
      onOpen: onDatePickerOpen,
      isOpen: isDatePickerOpen,
      splitInputs: splitDatePicker
    })), !hideGuests && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: "SearchForm__input SearchForm__input--guest-picker " + modalInputClasses
    }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(GuestPicker_GuestPicker, {
      isOpen: isGuestPickerOpen,
      onOpen: onGuestPickerOpen,
      onClose: onGuestPickerClose,
      onExit: onGuestPickerExit,
      isMobile: isMobile,
      guests: guests,
      onInputGuest: this.props.onInputGuest,
      labels: labels.guests,
      showClearButton: showClearButton
    })), buttonComponent && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: "SearchForm__button " + modalButtonClasses
    }, buttonComponent), !buttonComponent && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(SearchButton_SearchButton, {
      className: "SearchForm__button " + modalButtonClasses,
      label: labels.buttonTitle
    }));
  }
  /* eslint-enable complexity */
  ;

  return SearchForm;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Component);

SearchForm_SearchForm.propTypes = {
  isMobile: prop_types_default.a.bool,
  showClearButton: prop_types_default.a.bool,
  actionLocation: prop_types_default.a.string,
  maxNumGuests: prop_types_default.a.number,
  query: prop_types_default.a.string,
  onInputQuery: prop_types_default.a.func.isRequired,
  onSubmit: prop_types_default.a.func.isRequired,
  guests: prop_types_default.a.shape({
    adultsCount: prop_types_default.a.number,
    childrenCount: prop_types_default.a.number,
    petIncluded: prop_types_default.a.bool,
    adultsMin: prop_types_default.a.number
  }).isRequired,
  onInputGuest: prop_types_default.a.func.isRequired,
  checkIn: prop_types_default.a.string,
  onInputCheckIn: prop_types_default.a.func.isRequired,
  checkOut: prop_types_default.a.string,
  onInputCheckOut: prop_types_default.a.func.isRequired,
  consolidateDateInputs: prop_types_default.a.bool,
  edapDatePickerLabel: prop_types_default.a.string,
  labels: prop_types_default.a.shape({}),
  locale: prop_types_default.a.string,
  typeaheadProps: prop_types_default.a.shape({}),
  hideDates: prop_types_default.a.bool,
  hideGuests: prop_types_default.a.bool,
  isDatePickerOpen: prop_types_default.a.bool,
  isGuestPickerOpen: prop_types_default.a.bool,
  onDatePickerClose: prop_types_default.a.func,
  onDatePickerOpen: prop_types_default.a.func,
  onGuestPickerOpen: prop_types_default.a.func,
  onGuestPickerClose: prop_types_default.a.func,
  onGuestPickerExit: prop_types_default.a.func,
  buttonComponent: prop_types_default.a.object,
  // eslint-disable-line react/forbid-prop-types
  extendedSearchBar: prop_types_default.a.bool,
  splitDatePicker: prop_types_default.a.bool
};
SearchForm_SearchForm.defaultProps = {
  isMobile: false,
  query: 'Where do you want to go?',
  extendedSearchBar: false,
  hideDates: false,
  hideGuests: false,
  locale: 'en_US',
  isDatePickerOpen: false,
  isGuestPickerOpen: false,
  onDatePickerClose: function onDatePickerClose() {},
  onDatePickerOpen: function onDatePickerOpen() {},
  onGuestPickerOpen: function onGuestPickerOpen() {},
  onGuestPickerClose: function onGuestPickerClose() {},
  onGuestPickerExit: function onGuestPickerExit() {},
  splitDatePicker: false
};
/* harmony default export */ var components_SearchForm = (SearchForm_SearchForm);
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchIcon/style.css
var SearchIcon_style = __webpack_require__("1fcP");
var SearchIcon_style_default = /*#__PURE__*/__webpack_require__.n(SearchIcon_style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchIcon/index.js



var SearchIcon_SearchIcon = function SearchIcon() {
  return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("svg", {
    className: "search__icon",
    viewBox: "2 3 23 20"
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("line", {
    className: "st0",
    x1: "22.3",
    y1: "22.3",
    x2: "17.7",
    y2: "17.7",
    strokeLinecap: "round"
  }), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("circle", {
    fill: "none",
    className: "st0",
    cx: "12.3",
    cy: "12.3",
    r: "7.5"
  }));
};

/* harmony default export */ var components_SearchIcon = (SearchIcon_SearchIcon);
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchCta/style.css
var SearchCta_style = __webpack_require__("7LCA");
var SearchCta_style_default = /*#__PURE__*/__webpack_require__.n(SearchCta_style);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/SearchCta/index.js



var SearchCta_SearchCta = function SearchCta(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick;
  return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
    className: "search__cta-container"
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("button", {
    className: "search__cta",
    onClick: onClick
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
    className: "search__cta-label"
  }, label), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("span", {
    className: "search__cta-icon"
  }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_SearchIcon, null))));
};
/* harmony default export */ var components_SearchCta = (SearchCta_SearchCta);
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/utils/validationSelectedDate.js
function isDateValid(value) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(value).getTime() >= today.getTime();
}
//# sourceMappingURL=validationSelectedDate.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/datePickerTemplates/DayAvailability/index.js
function DayAvailability__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var clickable = function clickable(_ref) {
  var isPast = _ref.isPast,
      isToday = _ref.isToday;
  return !isPast && !isToday;
};
/**
 * Stripped down version of PDP day availability
 * https://github.homeawaycorp.com/traveler/react-trip-details/blob/master/src/components/calendarTemplates/DayAvailability/DayAvailability.js
 */


var DayAvailability_DefaultTemplate =
/*#__PURE__*/
function (_Component) {
  DayAvailability__inheritsLoose(DefaultTemplate, _Component);

  function DefaultTemplate() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = DefaultTemplate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        day = _this$props.day,
        isPast = _this$props.isPast,
        isToday = _this$props.isToday;
    var dateClasses = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
      date: true,
      today: false,
      past: isPast || isToday
    });
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: dateClasses
    }, day);
  };

  return DefaultTemplate;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

DayAvailability_DefaultTemplate.canClick = clickable;
DayAvailability_DefaultTemplate.canHover = clickable;
/* harmony default export */ var DayAvailability = (DayAvailability_DefaultTemplate);
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/components/Search/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Search_Search; });
function Search__extends() { Search__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Search__extends.apply(this, arguments); }

function Search__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }









var Search_Search =
/*#__PURE__*/
function (_Component) {
  Search__inheritsLoose(Search, _Component);

  function Search(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onInputQuery = function (query) {
      _this.setState({
        destination: query.search,
        lbsId: query.selectedDestination.uuid,
        geoType: query.selectedDestination.type
      });
    };

    _this.onInputCheckIn = function (value) {
      var valid = isDateValid(value);
      var clearButton = value === '';

      if (valid || clearButton) {
        _this.setState({
          checkIn: value
        });
      }

      if (valid) {
        _this.setState({
          checkOut: ''
        });
      }
    };

    _this.onInputCheckOut = function (value) {
      if (isDateValid(value) || value === '') {
        _this.setState({
          checkOut: value
        });
      }
    };

    _this.onInputGuest = function (key, value) {
      if (key === 'clear') {
        _this.setState({
          guests: value
        });
      } else {
        var _extends2;

        _this.setState({
          guests: Search__extends({}, _this.state.guests, (_extends2 = {}, _extends2[key] = value, _extends2))
        });
      }
    };

    _this.onSubmit = function (e) {
      e.preventDefault();
      var event = {
        checkIn: _this.state.checkIn,
        checkOut: _this.state.checkOut,
        guests: _this.state.guests,
        destination: _this.state.destination,
        subDestination: _this.state.subDestination,
        lbsId: _this.state.lbsId,
        geoType: _this.state.geoType
      };

      _this.props.onSubmit(event);
    };

    _this.openModal = function () {
      if (!_this.state.hasCustomControls) {
        _this.setState({
          isOpen: true
        });
      }

      _this.props.onSearchModalOpen();
    };

    _this.closeModal = function () {
      if (!_this.state.hasCustomControls) {
        _this.setState({
          isOpen: false
        });
      }

      _this.props.onSearchModalClose();
    };

    _this.onGuestPickerExit = function (undoState) {
      _this.setState({
        guests: undoState
      });

      var onGuestPickerExit = _this.props.onGuestPickerExit;

      if (onGuestPickerExit) {
        onGuestPickerExit(undoState);
      }
    };

    _this.onSelectDestination = function () {
      var _this$props = _this.props,
          typeaheadProps = _this$props.typeaheadProps,
          openDatePickerAfterSearch = _this$props.openDatePickerAfterSearch;
      var _this$state = _this.state,
          checkIn = _this$state.checkIn,
          checkOut = _this$state.checkOut;

      if (openDatePickerAfterSearch && !checkIn && !checkOut) {
        _this.setState({
          isDatePickerOpen: true
        });
      } // if passed second argument (subDestination) save it in the state


      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args && args.length && args.length >= 2) {
        _this.setState({
          subDestination: args[1]
        });
      }

      return typeaheadProps && typeaheadProps.onSelectDestination && typeaheadProps.onSelectDestination.apply(typeaheadProps, args);
    };

    _this.state = {
      destination: props.destination,
      checkIn: props.checkIn,
      checkOut: props.checkOut,
      guests: props.guests,
      isDatePickerOpen: props.isDatePickerOpen,
      lbsId: props.lbsId,
      geoType: props.geoType,
      hasCustomControls: props.onCtaClick && typeof props.isSearchModalOpen === 'boolean'
    };
    return _this;
  }

  var _proto = Search.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this$props2 = this.props,
        checkIn = _this$props2.checkIn,
        checkOut = _this$props2.checkOut,
        isDatePickerOpen = _this$props2.isDatePickerOpen;
    var newState = {};

    if (nextProps.checkIn !== checkIn || nextProps.checkOut !== checkOut) {
      newState = Search__extends({}, newState, {
        checkIn: nextProps.checkIn,
        checkOut: nextProps.checkOut,
        guests: nextProps.guests
      });
    }

    if (nextProps.isDatePickerOpen !== isDatePickerOpen) {
      newState = Search__extends({}, newState, {
        isDatePickerOpen: nextProps.isDatePickerOpen
      });
    }

    var stateChanged = !!Object.keys(newState).length;

    if (stateChanged) {
      this.setState(newState);
    }

    return stateChanged;
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    if (nextProps === void 0) {
      nextProps = {};
    }

    if (nextState === void 0) {
      nextState = {};
    }

    if (this.props.onUpdate) {
      this.props.onUpdate(nextState);
    }

    if (nextProps.isSearchModalOpen === false && nextState.isOpen) {
      this.closeModal();
    }
  };

  // eslint-disable-next-line complexity
  _proto.render = function render() {
    var _this$state2 = this.state,
        destination = _this$state2.destination,
        guests = _this$state2.guests,
        checkIn = _this$state2.checkIn,
        checkOut = _this$state2.checkOut,
        isOpen = _this$state2.isOpen,
        hasCustomControls = _this$state2.hasCustomControls,
        isDatePickerOpen = _this$state2.isDatePickerOpen;
    var _this$props3 = this.props,
        actionLocation = _this$props3.actionLocation,
        buttonComponent = _this$props3.buttonComponent,
        edapDatePickerLabel = _this$props3.edapDatePickerLabel,
        labels = _this$props3.labels,
        locale = _this$props3.locale,
        typeaheadProps = _this$props3.typeaheadProps,
        isMobile = _this$props3.isMobile,
        consolidateDateInputs = _this$props3.consolidateDateInputs,
        dayTemplateComponent = _this$props3.dayTemplateComponent,
        onDatePickerOpen = _this$props3.onDatePickerOpen,
        onDatePickerClose = _this$props3.onDatePickerClose,
        onGuestPickerOpen = _this$props3.onGuestPickerOpen,
        onGuestPickerClose = _this$props3.onGuestPickerClose,
        useMobileExpanded = _this$props3.useMobileExpanded,
        hideDates = _this$props3.hideDates,
        hideGuests = _this$props3.hideGuests,
        showClearButton = _this$props3.showClearButton,
        isGuestPickerOpen = _this$props3.isGuestPickerOpen,
        isSearchModalOpen = _this$props3.isSearchModalOpen,
        onCtaClick = _this$props3.onCtaClick,
        splitDatePicker = _this$props3.splitDatePicker,
        extendedSearchBar = _this$props3.extendedSearchBar;
    var searchForm = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_SearchForm, {
      actionLocation: actionLocation,
      buttonComponent: buttonComponent,
      consolidateDateInputs: consolidateDateInputs,
      extendedSearchBar: extendedSearchBar,
      isMobile: isMobile,
      query: destination,
      maxNumGuests: this.props.maxNumberOfGuests,
      onSubmit: this.onSubmit,
      onInputQuery: this.onInputQuery,
      guests: guests,
      onInputGuest: this.onInputGuest,
      checkIn: checkIn,
      onInputCheckIn: this.onInputCheckIn,
      checkOut: checkOut,
      onInputCheckOut: this.onInputCheckOut,
      edapDatePickerLabel: edapDatePickerLabel,
      labels: labels,
      locale: locale,
      dayTemplateComponent: dayTemplateComponent || DayAvailability,
      typeaheadProps: Search__extends({}, typeaheadProps, {
        onSelectDestination: this.onSelectDestination
      }),
      hideDates: hideDates,
      hideGuests: hideGuests,
      showClearButton: showClearButton,
      isDatePickerOpen: isDatePickerOpen,
      isGuestPickerOpen: isGuestPickerOpen,
      onDatePickerOpen: onDatePickerOpen,
      onDatePickerClose: onDatePickerClose,
      onGuestPickerOpen: onGuestPickerOpen,
      onGuestPickerClose: onGuestPickerClose,
      onGuestPickerExit: this.onGuestPickerExit,
      splitDatePicker: splitDatePicker,
      useMobileExpanded: useMobileExpanded
    });

    if (isMobile && !useMobileExpanded) {
      return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
        className: "search__container"
      }, reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_SearchCta, {
        label: destination,
        onClick: hasCustomControls ? onCtaClick : this.openModal
      }), reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(esm["default"], {
        id: "search",
        isOpen: hasCustomControls ? isSearchModalOpen : isOpen,
        onClose: this.closeModal,
        title: labels.mobileTitle,
        isWorkflow: true
      }, searchForm));
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("div", {
      className: "search__container"
    }, searchForm);
  };

  return Search;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

Search_Search.propTypes = {
  actionLocation: prop_types_default.a.string,
  destination: prop_types_default.a.string,
  geoType: prop_types_default.a.string,
  isMobile: prop_types_default.a.bool.isRequired,
  showClearButton: prop_types_default.a.bool,
  checkIn: prop_types_default.a.string,
  checkOut: prop_types_default.a.string,
  consolidateDateInputs: prop_types_default.a.bool,
  guests: prop_types_default.a.shape({
    adultsCount: prop_types_default.a.number,
    childrenCount: prop_types_default.a.number,
    petIncluded: prop_types_default.a.bool
  }),
  maxNumberOfGuests: prop_types_default.a.number,
  stickScrollTop: prop_types_default.a.number,
  isDatePickerOpen: prop_types_default.a.bool,
  isSearchModalOpen: prop_types_default.a.bool,
  onCtaClick: prop_types_default.a.func,
  onSearchModalOpen: prop_types_default.a.func,
  onSearchModalClose: prop_types_default.a.func,
  onDatePickerOpen: prop_types_default.a.func,
  onDatePickerClose: prop_types_default.a.func,
  onGuestPickerOpen: prop_types_default.a.func,
  onGuestPickerClose: prop_types_default.a.func,
  onSubmit: prop_types_default.a.func.isRequired,
  onUpdate: prop_types_default.a.func,
  edapDatePickerLabel: prop_types_default.a.string,
  labels: prop_types_default.a.shape({
    mobileTitle: prop_types_default.a.string,
    buttonTitle: prop_types_default.a.string,
    calendarLabels: prop_types_default.a.shape({}),
    datePicker: prop_types_default.a.shape({}),
    guests: prop_types_default.a.shape({})
  }),
  locale: prop_types_default.a.string,
  typeaheadProps: prop_types_default.a.shape({}),
  useMobileExpanded: prop_types_default.a.bool,
  showGuests: prop_types_default.a.bool,
  dayTemplateComponent: prop_types_default.a.element,
  buttonComponent: prop_types_default.a.object,
  // eslint-disable-line react/forbid-prop-types
  extendedSearchBar: prop_types_default.a.bool,
  splitDatePicker: prop_types_default.a.bool,
  openDatePickerAfterSearch: prop_types_default.a.bool
};
Search_Search.defaultProps = {
  actionLocation: '',
  isMobile: false,
  consolidateDateInputs: true,
  destination: null,
  extendedSearchBar: false,
  lbsId: null,
  geoType: null,
  guests: {
    adultsCount: 1,
    childrenCount: 0,
    petIncluded: false
  },
  maxNumberOfGuests: 10,
  onUpdate: function onUpdate() {},
  edapRefinements: [],
  locale: 'en_US',
  labels: {
    mobileTitle: 'Search',
    buttonTitle: 'Search',
    calendarLabels: {},
    datePicker: {
      checkIn: 'Check In',
      checkOut: 'Check Out',
      labels: 'Clear',
      done: 'Done'
    },
    guests: {
      label: 'Guests',
      adult: 'Adult',
      adults: 'Adults',
      child: 'Child',
      children: 'Children',
      pets: 'pets',
      guests: 'guests',
      yesBtn: 'Yes',
      noBtn: 'No',
      clearBtn: 'Clear',
      applyBtn: 'Apply',
      modalTitle: 'Select guest ',
      mobileBtn: 'Continue'
    }
  },
  useMobileExpanded: false,
  hideDates: false,
  hideGuests: false,
  isDatePickerOpen: false,
  isSearchModalOpen: false,
  onCtaClick: null,
  onSearchModalOpen: function onSearchModalOpen() {},
  onSearchModalClose: function onSearchModalClose() {},
  onDatePickerOpen: function onDatePickerOpen() {},
  onDatePickerClose: function onDatePickerClose() {},
  onGuestPickerOpen: function onGuestPickerOpen() {},
  onGuestPickerClose: function onGuestPickerClose() {},
  dayTemplateComponent: null,
  splitDatePicker: false,
  openDatePickerAfterSearch: false
};

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "yCNF":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "yFei":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yTOT":
/***/ (function(module, exports) {

function decodeFilterValue(value) {
  var regEx = /\+/g;
  return decodeURIComponent(value).replace(regEx, ' ');
}

function encodeFilterValue(value) {
  var regEx = /%20+/g;
  return encodeURIComponent(value).replace(regEx, '+');
}

var LOCATION_PARAM_KEY = 'Location Type';
var PROPERTY_PARAM_KEY = 'Property Type';
var FEATURE_PARAM_KEY = 'Features';
module.exports = {
  PROPERTY_PARAM_KEY: PROPERTY_PARAM_KEY,
  LOCATION_PARAM_KEY: LOCATION_PARAM_KEY,
  FEATURE_PARAM_KEY: FEATURE_PARAM_KEY,
  decodeFilterValue: decodeFilterValue,
  encodeFilterValue: encodeFilterValue
};
//# sourceMappingURL=filterRefinementUtils.js.map

/***/ }),

/***/ "yYxz":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "yfti":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ymrj":
/***/ (function(module, exports, __webpack_require__) {

/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/
module.exports = __webpack_require__("xtBF").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "zFiE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),

/***/ "zSos":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("UjR9").Observable;


/***/ }),

/***/ "zW/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var SearchUrlParameters_namespaceObject = {};
__webpack_require__.d(SearchUrlParameters_namespaceObject, "ADULTS_COUNT", function() { return ADULTS_COUNT; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "ARRIVAL", function() { return ARRIVAL; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "ASCENDING", function() { return ASCENDING; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "BATHROOMS", function() { return BATHROOMS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "BATHROOMS_REFINEMENT", function() { return BATHROOMS_REFINEMENT; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "BEDROOMS", function() { return BEDROOMS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "BEDROOMS_REFINEMENT", function() { return BEDROOMS_REFINEMENT; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "CHILDREN_COUNT", function() { return CHILDREN_COUNT; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "DEPARTURE", function() { return DEPARTURE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "FILTER", function() { return FILTER; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "FROM_DATE", function() { return FROM_DATE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "KEYWORDS", function() { return KEYWORDS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MAX_BATHROOMS", function() { return MAX_BATHROOMS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MAX_BEDROOMS", function() { return MAX_BEDROOMS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MAX_NIGHTLY_PRICE", function() { return MAX_NIGHTLY_PRICE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MAX_PRICE", function() { return MAX_PRICE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MAX_SLEEPS", function() { return MAX_SLEEPS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MIN_BATHROOMS", function() { return MIN_BATHROOMS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MIN_BEDROOMS", function() { return MIN_BEDROOMS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MIN_NIGHTLY_PRICE", function() { return MIN_NIGHTLY_PRICE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MIN_PRICE", function() { return MIN_PRICE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "MIN_SLEEPS", function() { return MIN_SLEEPS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "NE_LAT", function() { return NE_LAT; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "NE_LONG", function() { return NE_LONG; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "ORDER_BY", function() { return ORDER_BY; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "PAGE", function() { return PAGE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "PET_INCLUDED", function() { return PET_INCLUDED; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "QUERY", function() { return QUERY; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "REGION", function() { return REGION; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "SEARCH_TERM_UUID", function() { return SEARCH_TERM_UUID; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "SLEEPS", function() { return SLEEPS; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "SW_LAT", function() { return SW_LAT; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "SW_LONG", function() { return SW_LONG; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "TO_DATE", function() { return TO_DATE; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "VIEW", function() { return VIEW; });
__webpack_require__.d(SearchUrlParameters_namespaceObject, "ZOOM", function() { return ZOOM; });

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_d3276433b58c8a2853f4
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_d3276433b58c8a2853f4
var react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: ./node_modules/apollo-client/index.js + 15 modules
var apollo_client = __webpack_require__("u1/p");

// EXTERNAL MODULE: ./node_modules/apollo-link/lib/index.js + 4 modules
var lib = __webpack_require__("uekS");

// EXTERNAL MODULE: ./node_modules/graphql/language/printer.js
var printer = __webpack_require__("xC4e");
var printer_default = /*#__PURE__*/__webpack_require__.n(printer);

// CONCATENATED MODULE: ./node_modules/apollo-link-http-common/lib/index.js
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//TODO: when conditional types come in ts 2.8, operations should be a generic type that extends Operation | Array<Operation>
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            //Network error
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        //TODO should really error per response in a Batch based on properties
        //    - could be done in a validation link
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            //Data error
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (false)
            library = 'node-fetch';
        throw new Error("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    /*
     * use the rest of the configs to populate the options
     * configs later in the list will overwrite earlier fields
     */
    configs.forEach(function (config) {
        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = __assign({}, http, config.http);
    });
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = Object(printer["print"])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = new Error("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//selects "/graphql" by default
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-batch/lib/batching.js
var batching___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

// QueryBatcher doesn't fire requests immediately. Requests that were enqueued within
// a certain amount of time (configurable through `batchInterval`) will be batched together
// into one query.
var batching_OperationBatcher = /** @class */ (function () {
    function OperationBatcher(_a) {
        var batchInterval = _a.batchInterval, _b = _a.batchMax, batchMax = _b === void 0 ? 0 : _b, batchHandler = _a.batchHandler, _c = _a.batchKey, batchKey = _c === void 0 ? function () { return ''; } : _c;
        this.queuedRequests = new Map();
        this.batchInterval = batchInterval;
        this.batchMax = batchMax;
        this.batchHandler = batchHandler;
        this.batchKey = batchKey;
    }
    OperationBatcher.prototype.enqueueRequest = function (request) {
        var _this = this;
        var requestCopy = batching___assign({}, request);
        var queued = false;
        var key = this.batchKey(request.operation);
        if (!requestCopy.observable) {
            requestCopy.observable = new lib["b" /* Observable */](function (observer) {
                if (!_this.queuedRequests.has(key)) {
                    _this.queuedRequests.set(key, []);
                }
                if (!queued) {
                    _this.queuedRequests.get(key).push(requestCopy);
                    queued = true;
                }
                //called for each subscriber, so need to save all listeners(next, error, complete)
                requestCopy.next = requestCopy.next || [];
                if (observer.next)
                    requestCopy.next.push(observer.next.bind(observer));
                requestCopy.error = requestCopy.error || [];
                if (observer.error)
                    requestCopy.error.push(observer.error.bind(observer));
                requestCopy.complete = requestCopy.complete || [];
                if (observer.complete)
                    requestCopy.complete.push(observer.complete.bind(observer));
                // The first enqueued request triggers the queue consumption after `batchInterval` milliseconds.
                if (_this.queuedRequests.get(key).length === 1) {
                    _this.scheduleQueueConsumption(key);
                }
                // When amount of requests reaches `batchMax`, trigger the queue consumption without waiting on the `batchInterval`.
                if (_this.queuedRequests.get(key).length === _this.batchMax) {
                    _this.consumeQueue(key);
                }
            });
        }
        return requestCopy.observable;
    };
    // Consumes the queue.
    // Returns a list of promises (one for each query).
    OperationBatcher.prototype.consumeQueue = function (key) {
        if (key === void 0) { key = ''; }
        var queuedRequests = this.queuedRequests.get(key);
        if (!queuedRequests) {
            return;
        }
        this.queuedRequests.delete(key);
        var requests = queuedRequests.map(function (queuedRequest) { return queuedRequest.operation; });
        var forwards = queuedRequests.map(function (queuedRequest) { return queuedRequest.forward; });
        var observables = [];
        var nexts = [];
        var errors = [];
        var completes = [];
        queuedRequests.forEach(function (batchableRequest, index) {
            observables.push(batchableRequest.observable);
            nexts.push(batchableRequest.next);
            errors.push(batchableRequest.error);
            completes.push(batchableRequest.complete);
        });
        var batchedObservable = this.batchHandler(requests, forwards) || lib["b" /* Observable */].of();
        var onError = function (error) {
            //each callback list in batch
            errors.forEach(function (rejecters) {
                if (rejecters) {
                    //each subscriber to request
                    rejecters.forEach(function (e) { return e(error); });
                }
            });
        };
        batchedObservable.subscribe({
            next: function (results) {
                if (!Array.isArray(results)) {
                    results = [results];
                }
                if (nexts.length !== results.length) {
                    var error = new Error("server returned results with length " + results.length + ", expected length of " + nexts.length);
                    error.result = results;
                    return onError(error);
                }
                results.forEach(function (result, index) {
                    // attach the raw response to the context for usage
                    requests[index].setContext({ response: result });
                    if (nexts[index]) {
                        nexts[index].forEach(function (next) { return next(result); });
                    }
                });
            },
            error: onError,
            complete: function () {
                completes.forEach(function (complete) {
                    if (complete) {
                        //each subscriber to request
                        complete.forEach(function (c) { return c(); });
                    }
                });
            },
        });
        return observables;
    };
    OperationBatcher.prototype.scheduleQueueConsumption = function (key) {
        var _this = this;
        if (key === void 0) { key = ''; }
        setTimeout(function () {
            if (_this.queuedRequests.get(key) && _this.queuedRequests.get(key).length) {
                _this.consumeQueue(key);
            }
        }, this.batchInterval);
    };
    return OperationBatcher;
}());

//# sourceMappingURL=batching.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-batch/lib/batchLink.js
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var batchLink_BatchLink = /** @class */ (function (_super) {
    __extends(BatchLink, _super);
    function BatchLink(fetchParams) {
        if (fetchParams === void 0) { fetchParams = {}; }
        var _this = _super.call(this) || this;
        var _a = fetchParams.batchInterval, batchInterval = _a === void 0 ? 10 : _a, _b = fetchParams.batchMax, batchMax = _b === void 0 ? 0 : _b, _c = fetchParams.batchHandler, batchHandler = _c === void 0 ? function () { return null; } : _c, _d = fetchParams.batchKey, batchKey = _d === void 0 ? function () { return ''; } : _d;
        _this.batcher = new batching_OperationBatcher({
            batchInterval: batchInterval,
            batchMax: batchMax,
            batchHandler: batchHandler,
            batchKey: batchKey,
        });
        //make this link terminating
        if (fetchParams.batchHandler.length <= 1) {
            _this.request = function (operation) { return _this.batcher.enqueueRequest({ operation: operation }); };
        }
        return _this;
    }
    BatchLink.prototype.request = function (operation, forward) {
        return this.batcher.enqueueRequest({
            operation: operation,
            forward: forward,
        });
    };
    return BatchLink;
}(lib["a" /* ApolloLink */]));

//# sourceMappingURL=batchLink.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-batch/lib/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-batch-http/lib/batchHttpLink.js
var batchHttpLink___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



/**
 * Transforms Operation for into HTTP results.
 * context can include the headers property, which will be passed to the fetch function
 */
var batchHttpLink_BatchHttpLink = /** @class */ (function (_super) {
    batchHttpLink___extends(BatchHttpLink, _super);
    function BatchHttpLink(fetchParams) {
        if (fetchParams === void 0) { fetchParams = {}; }
        var _this = _super.call(this) || this;
        var _a = fetchParams.uri, uri = _a === void 0 ? '/graphql' : _a, 
        // use default global fetch is nothing passed in
        fetcher = fetchParams.fetch, includeExtensions = fetchParams.includeExtensions, batchInterval = fetchParams.batchInterval, batchMax = fetchParams.batchMax, batchKey = fetchParams.batchKey, requestOptions = __rest(fetchParams, ["uri", "fetch", "includeExtensions", "batchInterval", "batchMax", "batchKey"]);
        // dev warnings to ensure fetch is present
        checkFetcher(fetcher);
        //fetcher is set here rather than the destructuring to ensure fetch is
        //declared before referencing it. Reference in the destructuring would cause
        //a ReferenceError
        if (!fetcher) {
            fetcher = fetch;
        }
        var linkConfig = {
            http: { includeExtensions: includeExtensions },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers,
        };
        _this.batchInterval = batchInterval || 10;
        _this.batchMax = batchMax || 10;
        var batchHandler = function (operations) {
            var chosenURI = selectURI(operations[0], uri);
            var context = operations[0].getContext();
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: context.headers,
            };
            //uses fallback, link, and then context to build options
            var optsAndBody = operations.map(function (operation) {
                return selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig);
            });
            var body = optsAndBody.map(function (_a) {
                var body = _a.body;
                return body;
            });
            var options = optsAndBody[0].options;
            // There's no spec for using GET with batches.
            if (options.method === 'GET') {
                return Object(lib["d" /* fromError */])(new Error('apollo-link-batch-http does not support GET requests'));
            }
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return Object(lib["d" /* fromError */])(parseError);
            }
            var controller;
            if (!options.signal) {
                var _a = createSignalIfSupported(), _controller = _a.controller, signal = _a.signal;
                controller = _controller;
                if (controller)
                    options.signal = signal;
            }
            return new lib["b" /* Observable */](function (observer) {
                // the raw response is attached to the context in the BatchingLink
                fetcher(chosenURI, options)
                    .then(parseAndCheckHttpResponse(operations))
                    .then(function (result) {
                    // we have data and can send it to back up the link chain
                    observer.next(result);
                    observer.complete();
                    return result;
                })
                    .catch(function (err) {
                    // fetch was cancelled so its already been cleaned up in the unsubscribe
                    if (err.name === 'AbortError')
                        return;
                    // if it is a network error, BUT there is graphql result info
                    // fire the next observer before calling error
                    // this gives apollo-client (and react-apollo) the `graphqlErrors` and `networErrors`
                    // to pass to UI
                    // this should only happen if we *also* have data as part of the response key per
                    // the spec
                    if (err.result && err.result.errors && err.result.data) {
                        // if we dont' call next, the UI can only show networkError because AC didn't
                        // get andy graphqlErrors
                        // this is graphql execution result info (i.e errors and possibly data)
                        // this is because there is no formal spec how errors should translate to
                        // http status codes. So an auth error (401) could have both data
                        // from a public field, errors from a private field, and a status of 401
                        // {
                        //  user { // this will have errors
                        //    firstName
                        //  }
                        //  products { // this is public so will have data
                        //    cost
                        //  }
                        // }
                        //
                        // the result of above *could* look like this:
                        // {
                        //   data: { products: [{ cost: "$10" }] },
                        //   errors: [{
                        //      message: 'your session has timed out',
                        //      path: []
                        //   }]
                        // }
                        // status code of above would be a 401
                        // in the UI you want to show data where you can, errors as data where you can
                        // and use correct http status codes
                        observer.next(err.result);
                    }
                    observer.error(err);
                });
                return function () {
                    // XXX support canceling this request
                    // https://developers.google.com/web/updates/2017/09/abortable-fetch
                    if (controller)
                        controller.abort();
                };
            });
        };
        batchKey =
            batchKey ||
                (function (operation) {
                    var context = operation.getContext();
                    var contextConfig = {
                        http: context.http,
                        options: context.fetchOptions,
                        credentials: context.credentials,
                        headers: context.headers,
                    };
                    //may throw error if config not serializable
                    return selectURI(operation, uri) + JSON.stringify(contextConfig);
                });
        _this.batcher = new batchLink_BatchLink({
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey: batchKey,
            batchHandler: batchHandler,
        });
        return _this;
    }
    BatchHttpLink.prototype.request = function (operation) {
        return this.batcher.request(operation);
    };
    return BatchHttpLink;
}(lib["a" /* ApolloLink */]));

//# sourceMappingURL=batchHttpLink.js.map
// CONCATENATED MODULE: ./node_modules/apollo-link-batch-http/lib/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/apollo-utilities/lib/index.js + 11 modules
var apollo_utilities_lib = __webpack_require__("+zi7");

// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/utils.js
function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        // No selection set here
        return null;
    }
    if (Array.isArray(obj)) {
        // GraphQL queries don't include arrays
        return selectionSetFromObj(obj[0]);
    }
    // Now we know it's an object
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
        };
        // Recurse
        var nestedSelSet = selectionSetFromObj(obj[key]);
        if (nestedSelSet) {
            field.selectionSet = nestedSelSet;
        }
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=utils.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/cache.js
var cache___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var cache_ApolloCache = /** @class */ (function () {
    function ApolloCache() {
    }
    // optional API
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    // experimental
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    // DataProxy API
    /**
     *
     * @param options
     * @param optimistic
     */
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(apollo_utilities_lib["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(apollo_utilities_lib["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            // Since we can't use fragments without having a typename in the store,
            // we need to make sure we have one.
            // To avoid overwriting an existing typename, we need to read it out first
            // and generate a fake one if none exists.
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
                // Do nothing, since an error just means no typename exists
            }
            // tslint:disable-next-line
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            // Add a type here to satisfy the inmemory cache
            var dataToWrite = cache___assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/types/Cache.js
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/types/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/fragmentMatcher.js

var haveWarned = false;
/**
 * This fragment matcher is very basic and unable to match union or interface type conditions
 */
var fragmentMatcher_HeuristicFragmentMatcher = /** @class */ (function () {
    function HeuristicFragmentMatcher() {
        // do nothing
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true; // we don't need to initialize this fragment matcher.
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            if (!haveWarned) {
                console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                console.warn('Could not find __typename on Fragment ', typeCondition, obj);
                console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
                /* istanbul ignore if */
                if (!Object(apollo_utilities_lib["w" /* isTest */])()) {
                    // When running tests, we want to print the warning every time
                    haveWarned = true;
                }
            }
            context.returnPartialData = true;
            return true;
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        // XXX here we reach an issue - we don't know if this fragment should match or not. It's either:
        // 1. A fragment on a non-matching concrete type or interface or union
        // 2. A fragment on a matching interface or union
        // If it's 1, we don't want to return anything, if it's 2 we want to match. We can't tell the
        // difference, so we warn the user, but still try to match it (backcompat).
        Object(apollo_utilities_lib["E" /* warnOnceInDevelopment */])("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types.\n     Apollo Client will not be able to able to accurately map fragments." +
            "To make this error go away, use the IntrospectionFragmentMatcher as described in the docs: " +
            "https://www.apollographql.com/docs/react/recipes/fragment-matching.html", 'error');
        context.returnPartialData = true;
        return true;
    };
    return HeuristicFragmentMatcher;
}());

var IntrospectionFragmentMatcher = /** @class */ (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        if (!this.isReady) {
            // this should basically never happen in proper use.
            throw new Error('FragmentMatcher.match() was called before FragmentMatcher.init()');
        }
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

//# sourceMappingURL=fragmentMatcher.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/objectCache.js
var ObjectCache = /** @class */ (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = undefined;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());

function defaultNormalizedCacheFactory(seed) {
    return new ObjectCache(seed);
}
//# sourceMappingURL=objectCache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/writeToStore.js
var writeToStore___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var writeToStore___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var WriteError = /** @class */ (function (_super) {
    writeToStore___extends(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));

function enhanceErrorWithDocument(error, document) {
    // XXX A bit hacky maybe ...
    var enhancedError = new WriteError("Error writing result to store for query:\n " + Object(printer["print"])(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
/**
 * Writes the result of a query to the store.
 *
 * @param result The result object returned for the query document.
 *
 * @param query The query document whose result we are writing to the store.
 *
 * @param store The {@link NormalizedCache} used by Apollo for the `data` portion of the store.
 *
 * @param variables A map from the name of a variable to its value. These variables can be
 * referenced by the query document.
 *
 * @param dataIdFromObject A function that returns an object identifier given a particular result
 * object. See the store documentation for details and an example of this function.
 *
 * @param fragmentMap A map from the name of a fragment to its fragment definition. These fragments
 * can be referenced within the query document.
 *
 * @param fragmentMatcherFunction A function to use for matching fragment conditions in GraphQL documents
 */
function writeQueryToStore(_a) {
    var result = _a.result, query = _a.query, _b = _a.storeFactory, storeFactory = _b === void 0 ? defaultNormalizedCacheFactory : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, _d = _a.fragmentMap, fragmentMap = _d === void 0 ? {} : _d, fragmentMatcherFunction = _a.fragmentMatcherFunction;
    var queryDefinition = Object(apollo_utilities_lib["m" /* getQueryDefinition */])(query);
    variables = Object(apollo_utilities_lib["c" /* assign */])({}, Object(apollo_utilities_lib["e" /* getDefaultValues */])(queryDefinition), variables);
    try {
        return writeSelectionSetToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            selectionSet: queryDefinition.selectionSet,
            context: {
                store: store,
                storeFactory: storeFactory,
                processedData: {},
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMap: fragmentMap,
                fragmentMatcherFunction: fragmentMatcherFunction,
            },
        });
    }
    catch (e) {
        throw enhanceErrorWithDocument(e, query);
    }
}
function writeResultToStore(_a) {
    var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.storeFactory, storeFactory = _b === void 0 ? defaultNormalizedCacheFactory : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
    // XXX TODO REFACTOR: this is a temporary workaround until query normalization is made to work with documents.
    var operationDefinition = Object(apollo_utilities_lib["k" /* getOperationDefinition */])(document);
    var selectionSet = operationDefinition.selectionSet;
    var fragmentMap = Object(apollo_utilities_lib["d" /* createFragmentMap */])(Object(apollo_utilities_lib["g" /* getFragmentDefinitions */])(document));
    variables = Object(apollo_utilities_lib["c" /* assign */])({}, Object(apollo_utilities_lib["e" /* getDefaultValues */])(operationDefinition), variables);
    try {
        return writeSelectionSetToStore({
            result: result,
            dataId: dataId,
            selectionSet: selectionSet,
            context: {
                store: store,
                storeFactory: storeFactory,
                processedData: {},
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMap: fragmentMap,
                fragmentMatcherFunction: fragmentMatcherFunction,
            },
        });
    }
    catch (e) {
        throw enhanceErrorWithDocument(e, document);
    }
}
function writeSelectionSetToStore(_a) {
    var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
    var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
    selectionSet.selections.forEach(function (selection) {
        var included = Object(apollo_utilities_lib["A" /* shouldInclude */])(selection, variables);
        if (Object(apollo_utilities_lib["r" /* isField */])(selection)) {
            var resultFieldKey = Object(apollo_utilities_lib["z" /* resultKeyNameFromField */])(selection);
            var value = result[resultFieldKey];
            if (included) {
                if (typeof value !== 'undefined') {
                    writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    // if this is a defered field we don't need to throw / warn
                    var isDefered = selection.directives &&
                        selection.directives.length &&
                        selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                    if (!isDefered && context.fragmentMatcherFunction) {
                        // XXX We'd like to throw an error, but for backwards compatibility's sake
                        // we just print a warning for the time being.
                        //throw new WriteError(`Missing field ${resultFieldKey} in ${JSON.stringify(result, null, 2).substring(0, 100)}`);
                        if (!Object(apollo_utilities_lib["v" /* isProduction */])()) {
                            console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                        }
                    }
                }
            }
        }
        else {
            // This is not a field, so it must be a fragment, either inline or named
            var fragment = void 0;
            if (Object(apollo_utilities_lib["t" /* isInlineFragment */])(selection)) {
                fragment = selection;
            }
            else {
                // Named fragment
                fragment = (fragmentMap || {})[selection.name.value];
                if (!fragment) {
                    throw new Error("No fragment named " + selection.name.value + ".");
                }
            }
            var matches = true;
            if (context.fragmentMatcherFunction && fragment.typeCondition) {
                // TODO we need to rewrite the fragment matchers for this to work properly and efficiently
                // Right now we have to pretend that we're passing in an idValue and that there's a store
                // on the context.
                var idValue = Object(apollo_utilities_lib["C" /* toIdValue */])({ id: 'self', typename: undefined });
                var fakeContext = {
                    // NOTE: fakeContext always uses ObjectCache
                    // since this is only to ensure the return value of 'matches'
                    store: new ObjectCache({ self: result }),
                    returnPartialData: false,
                    hasMissingField: false,
                    cacheRedirects: {},
                };
                matches = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                if (!Object(apollo_utilities_lib["v" /* isProduction */])() && fakeContext.returnPartialData) {
                    console.error('WARNING: heuristic fragment matching going on!');
                }
            }
            if (included && matches) {
                writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context,
                });
            }
        }
    });
    return store;
}
// Checks if the id given is an id that was generated by Apollo
// rather than by dataIdFromObject.
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (Object(apollo_utilities_lib["s" /* isIdValue */])(value) && isGeneratedId(value.id) && Object(apollo_utilities_lib["s" /* isIdValue */])(realValue)) {
            mergeWithGenerated(value.id, realValue.id, cache);
        }
        cache.delete(generatedKey);
        cache.set(realKey, writeToStore___assign({}, generated, real));
    });
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}
function writeFieldToStore(_a) {
    var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
    var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
    var storeValue;
    var storeObject;
    var storeFieldName = Object(apollo_utilities_lib["B" /* storeKeyNameFromField */])(field, variables);
    // specifies if we need to merge existing keys in the store
    var shouldMerge = false;
    // If we merge, this will be the generatedKey
    var generatedKey = '';
    // If this is a scalar value...
    if (!field.selectionSet || value === null) {
        storeValue =
            value != null && typeof value === 'object'
                ?
                    // an id.
                    { type: 'json', json: value }
                :
                    value;
    }
    else if (Array.isArray(value)) {
        var generatedId = dataId + "." + storeFieldName;
        storeValue = processArrayValue(value, generatedId, field.selectionSet, context);
    }
    else {
        // It's an object
        var valueDataId = dataId + "." + storeFieldName;
        var generated = true;
        // We only prepend the '$' if the valueDataId isn't already a generated
        // id.
        if (!isGeneratedId(valueDataId)) {
            valueDataId = '$' + valueDataId;
        }
        if (dataIdFromObject) {
            var semanticId = dataIdFromObject(value);
            // We throw an error if the first character of the id is '$. This is
            // because we use that character to designate an Apollo-generated id
            // and we use the distinction between user-desiginated and application-provided
            // ids when managing overwrites.
            if (semanticId && isGeneratedId(semanticId)) {
                throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
            }
            if (semanticId) {
                valueDataId = semanticId;
                generated = false;
            }
        }
        if (!isDataProcessed(valueDataId, field, context.processedData)) {
            writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context,
            });
        }
        // We take the id and escape it (i.e. wrap it with an enclosing object).
        // This allows us to distinguish IDs from normal scalars.
        var typename = value.__typename;
        storeValue = Object(apollo_utilities_lib["C" /* toIdValue */])({ id: valueDataId, typename: typename }, generated);
        // check if there was a generated id at the location where we're
        // about to place this new id. If there was, we have to merge the
        // data from that id with the data we're about to write in the store.
        storeObject = store.get(dataId);
        var escapedId = storeObject && storeObject[storeFieldName];
        if (escapedId !== storeValue && Object(apollo_utilities_lib["s" /* isIdValue */])(escapedId)) {
            var hadTypename = escapedId.typename !== undefined;
            var hasTypename = typename !== undefined;
            var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
            // If there is already a real id in the store and the current id we
            // are dealing with is generated, we throw an error.
            // One exception we allow is when the typename has changed, which occurs
            // when schema defines a union, both with and without an ID in the same place.
            // checks if we "lost" the read id
            if (generated && !escapedId.generated && !typenameChanged) {
                throw new Error("Store error: the application attempted to write an object with no provided id" +
                    (" but the store already contains an id of " + escapedId.id + " for this object. The selectionSet") +
                    " that was trying to be written is:\n" +
                    Object(printer["print"])(field));
            }
            // checks if we "lost" the typename
            if (hadTypename && !hasTypename) {
                throw new Error("Store error: the application attempted to write an object with no provided typename" +
                    (" but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet") +
                    " that was trying to be written is:\n" +
                    Object(printer["print"])(field));
            }
            if (escapedId.generated) {
                generatedKey = escapedId.id;
                // we should only merge if it's an object of the same type
                // otherwise, we should delete the generated object
                if (typenameChanged) {
                    store.delete(generatedKey);
                }
                else {
                    shouldMerge = true;
                }
            }
        }
    }
    var newStoreObj = writeToStore___assign({}, store.get(dataId), (_b = {}, _b[storeFieldName] = storeValue, _b));
    if (shouldMerge) {
        mergeWithGenerated(generatedKey, storeValue.id, store);
    }
    storeObject = store.get(dataId);
    if (!storeObject || storeValue !== storeObject[storeFieldName]) {
        store.set(dataId, newStoreObj);
    }
    var _b;
}
function processArrayValue(value, generatedId, selectionSet, context) {
    return value.map(function (item, index) {
        if (item === null) {
            return null;
        }
        var itemDataId = generatedId + "." + index;
        if (Array.isArray(item)) {
            return processArrayValue(item, itemDataId, selectionSet, context);
        }
        var generated = true;
        if (context.dataIdFromObject) {
            var semanticId = context.dataIdFromObject(item);
            if (semanticId) {
                itemDataId = semanticId;
                generated = false;
            }
        }
        if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
            writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context,
            });
        }
        return Object(apollo_utilities_lib["C" /* toIdValue */])({ id: itemDataId, typename: item.__typename }, generated);
    });
}
//# sourceMappingURL=writeToStore.js.map
// CONCATENATED MODULE: ./node_modules/graphql-anywhere/lib/graphql.js

/* Based on graphql function from graphql-js:
 *
 * graphql(
 *   schema: GraphQLSchema,
 *   requestString: string,
 *   rootValue?: ?any,
 *   contextValue?: ?any,
 *   variableValues?: ?{[key: string]: any},
 *   operationName?: ?string
 * ): Promise<GraphQLResult>
 *
 * The default export as of graphql-anywhere is sync as of 4.0,
 * but below is an exported alternative that is async.
 * In the 5.0 version, this will be the only export again
 * and it will be async
 *
 */
function graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) { execOptions = {}; }
    var mainDefinition = Object(apollo_utilities_lib["i" /* getMainDefinition */])(document);
    var fragments = Object(apollo_utilities_lib["g" /* getFragmentDefinitions */])(document);
    var fragmentMap = Object(apollo_utilities_lib["d" /* createFragmentMap */])(fragments);
    var resultMapper = execOptions.resultMapper;
    // Default matcher always matches all fragments
    var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher,
    };
    return executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
function executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function (selection) {
        if (!Object(apollo_utilities_lib["A" /* shouldInclude */])(selection, variables)) {
            // Skip this entirely
            return;
        }
        if (Object(apollo_utilities_lib["r" /* isField */])(selection)) {
            var fieldResult = executeField(selection, rootValue, execContext);
            var resultFieldKey = Object(apollo_utilities_lib["z" /* resultKeyNameFromField */])(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) {
                    result[resultFieldKey] = fieldResult;
                }
                else {
                    merge(result[resultFieldKey], fieldResult);
                }
            }
        }
        else {
            var fragment = void 0;
            if (Object(apollo_utilities_lib["t" /* isInlineFragment */])(selection)) {
                fragment = selection;
            }
            else {
                // This is a named fragment
                fragment = fragmentMap[selection.name.value];
                if (!fragment) {
                    throw new Error("No fragment named " + selection.name.value);
                }
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) {
        return execContext.resultMapper(result, rootValue);
    }
    return result;
}
function executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = Object(apollo_utilities_lib["b" /* argumentsObjectFromField */])(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: Object(apollo_utilities_lib["z" /* resultKeyNameFromField */])(field),
        directives: Object(apollo_utilities_lib["f" /* getDirectiveInfoFromField */])(field, variables),
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    // Handle all scalar types here
    if (!field.selectionSet) {
        return result;
    }
    // From here down, the field has a selection set, which means it's trying to
    // query a GraphQLObjectType
    if (result == null) {
        // Basically any field in a GraphQL response can be null, or missing
        return result;
    }
    if (Array.isArray(result)) {
        return executeSubSelectedArray(field, result, execContext);
    }
    // Returned value is an object, and the query has a sub-selection. Recurse.
    return executeSelectionSet(field.selectionSet, result, execContext);
}
function executeSubSelectedArray(field, result, execContext) {
    return result.map(function (item) {
        // null value in array
        if (item === null) {
            return null;
        }
        // This is a nested array, recurse
        if (Array.isArray(item)) {
            return executeSubSelectedArray(field, item, execContext);
        }
        // This is an object, run the selection set on it
        return executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var hasOwn = Object.prototype.hasOwnProperty;
function merge(dest, src) {
    if (src !== null && typeof src === 'object') {
        Object.keys(src).forEach(function (key) {
            var srcVal = src[key];
            if (!hasOwn.call(dest, key)) {
                dest[key] = srcVal;
            }
            else {
                merge(dest[key], srcVal);
            }
        });
    }
}
//# sourceMappingURL=graphql.js.map
// CONCATENATED MODULE: ./node_modules/graphql-anywhere/lib/utilities.js

function utilities_filter(doc, data) {
    var resolver = function (fieldName, root, args, context, info) {
        return root[info.resultKey];
    };
    return graphql(resolver, doc, data);
}
// TODO: we should probably make check call propType and then throw,
// rather than the other way round, to avoid constructing stack traces
// for things like oneOf uses in React. At this stage I doubt many people
// are using this like that, but in the future, who knows?
function check(doc, data) {
    var resolver = function (fieldName, root, args, context, info) {
        if (!{}.hasOwnProperty.call(root, info.resultKey)) {
            throw new Error(info.resultKey + " missing on " + root);
        }
        return root[info.resultKey];
    };
    graphql(resolver, doc, data, {}, {}, {
        fragmentMatcher: function () { return false; },
    });
}
// Lifted/adapted from
//   https://github.com/facebook/react/blob/master/src/isomorphic/classic/types/ReactPropTypes.js
var ANONYMOUS = '<<anonymous>>';
function PropTypeError(message) {
    this.message = message;
    this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;
var reactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context',
};
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (props[propName] == null) {
            var locationName = reactPropTypeLocationNames[location];
            if (isRequired) {
                if (props[propName] === null) {
                    return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required " +
                        ("in `" + componentName + "`, but its value is `null`."));
                }
                return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required in " +
                    ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
        }
        else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
function propType(doc) {
    return createChainableTypeChecker(function (props, propName) {
        var prop = props[propName];
        try {
            if (!prop.loading) {
                check(doc, prop);
            }
            return null;
        }
        catch (e) {
            // Need a much better error.
            // Also we aren't checking for extra fields
            return e;
        }
    });
}
//# sourceMappingURL=utilities.js.map
// CONCATENATED MODULE: ./node_modules/graphql-anywhere/lib/index.js


/* harmony default export */ var graphql_anywhere_lib = (graphql);
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/readFromStore.js
var readFromStore___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


/**
 * The key which the cache id for a given value is stored in the result object. This key is private
 * and should not be used by Apollo client users.
 *
 * Uses a symbol if available in the environment.
 *
 * @private
 */
var ID_KEY = typeof Symbol !== 'undefined' ? Symbol('id') : '@@id';
/**
 * Resolves the result of a query solely from the store (i.e. never hits the server).
 *
 * @param {Store} store The {@link NormalizedCache} used by Apollo for the `data` portion of the
 * store.
 *
 * @param {DocumentNode} query The query document to resolve from the data available in the store.
 *
 * @param {Object} [variables] A map from the name of a variable to its value. These variables can
 * be referenced by the query document.
 *
 * @param {any} previousResult The previous result returned by this function for the same query.
 * If nothing in the store changed since that previous result then values from the previous result
 * will be returned to preserve referential equality.
 */
function readQueryFromStore(options) {
    var optsPatch = { returnPartialData: false };
    return diffQueryAgainstStore(readFromStore___assign({}, options, optsPatch)).result;
}
var readStoreResolver = function (fieldName, idValue, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    assertIdValue(idValue);
    var objId = idValue.id;
    var obj = context.store.get(objId);
    var storeKeyName = fieldName;
    if (args || directives) {
        // We happen to know here that getStoreKeyName returns its first
        // argument unmodified if there are no args or directives, so we can
        // avoid calling the function at all in that case, as a small but
        // important optimization to this frequently executed code.
        storeKeyName = Object(apollo_utilities_lib["n" /* getStoreKeyName */])(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (obj) {
        fieldValue = obj[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            (obj.__typename || objId === 'ROOT_QUERY')) {
            var typename = obj.__typename || 'Query';
            // Look for the type in the custom resolver map
            var type = context.cacheRedirects[typename];
            if (type) {
                // Look for the field in the custom resolver map
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(obj, args, {
                        getCacheKey: function (storeObj) {
                            return Object(apollo_utilities_lib["C" /* toIdValue */])({
                                id: context.dataIdFromObject(storeObj),
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        if (!context.returnPartialData) {
            throw new Error("Can't find field " + storeKeyName + " on object (" + objId + ") " + JSON.stringify(obj, null, 2) + ".");
        }
        context.hasMissingField = true;
        return fieldValue;
    }
    // if this is an object scalar, it must be a json blob and we have to unescape it
    if (Object(apollo_utilities_lib["u" /* isJsonValue */])(fieldValue)) {
        // If the JSON blob is the same now as in the previous result, return the previous result to
        // maintain referential equality.
        //
        // `isEqual` will first perform a referential equality check (with `===`) in case the JSON
        // value has not changed in the store, and then a deep equality check if that fails in case a
        // new JSON object was returned by the API but that object may still be the same.
        if (idValue.previousResult &&
            Object(apollo_utilities_lib["q" /* isEqual */])(idValue.previousResult[resultKey], fieldValue.json)) {
            return idValue.previousResult[resultKey];
        }
        return fieldValue.json;
    }
    // If we had a previous result, try adding that previous result value for this field to our field
    // value. This will create a new value without mutating the old one.
    if (idValue.previousResult) {
        fieldValue = addPreviousResultToIdValues(fieldValue, idValue.previousResult[resultKey]);
    }
    return fieldValue;
};
/**
 * Given a store and a query, return as much of the result as possible and
 * identify if any data was missing from the store.
 * @param  {DocumentNode} query A parsed GraphQL query document
 * @param  {Store} store The Apollo Client store object
 * @param  {any} previousResult The previous result returned by this function for the same query
 * @return {result: Object, complete: [boolean]}
 */
function diffQueryAgainstStore(_a) {
    var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
    // Throw the right validation error by trying to find a query in the document
    var queryDefinition = Object(apollo_utilities_lib["m" /* getQueryDefinition */])(query);
    variables = Object(apollo_utilities_lib["c" /* assign */])({}, Object(apollo_utilities_lib["e" /* getDefaultValues */])(queryDefinition), variables);
    var context = {
        // Global settings
        store: store,
        returnPartialData: returnPartialData,
        dataIdFromObject: (config && config.dataIdFromObject) || null,
        cacheRedirects: (config && config.cacheRedirects) || {},
        // Flag set during execution
        hasMissingField: false,
    };
    var rootIdValue = {
        type: 'id',
        id: rootId,
        previousResult: previousResult,
    };
    var result = graphql_anywhere_lib(readStoreResolver, query, rootIdValue, context, variables, {
        fragmentMatcher: fragmentMatcherFunction,
        resultMapper: readFromStore_resultMapper,
    });
    return {
        result: result,
        complete: !context.hasMissingField,
    };
}
function assertIdValue(idValue) {
    if (!Object(apollo_utilities_lib["s" /* isIdValue */])(idValue)) {
        throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
    }
}
/**
 * Adds a previous result value to id values in a nested array. For a single id value and a single
 * previous result then the previous value is added directly.
 *
 * For arrays we put all of the ids from the previous result array in a map and add them to id
 * values with the same id.
 *
 * This function does not mutate. Instead it returns new instances of modified values.
 *
 * @private
 */
function addPreviousResultToIdValues(value, previousResult) {
    // If the value is an `IdValue`, add the previous result to it whether or not that
    // `previousResult` is undefined.
    //
    // If the value is an array, recurse over each item trying to add the `previousResult` for that
    // item.
    if (Object(apollo_utilities_lib["s" /* isIdValue */])(value)) {
        return readFromStore___assign({}, value, { previousResult: previousResult });
    }
    else if (Array.isArray(value)) {
        var idToPreviousResult_1 = new Map();
        // If the previous result was an array, we want to build up our map of ids to previous results
        // using the private `ID_KEY` property that is added in `resultMapper`.
        if (Array.isArray(previousResult)) {
            previousResult.forEach(function (item) {
                // item can be null
                if (item && item[ID_KEY]) {
                    idToPreviousResult_1.set(item[ID_KEY], item);
                    // idToPreviousResult[item[ID_KEY]] = item;
                }
            });
        }
        // For every value we want to add the previous result.
        return value.map(function (item, i) {
            // By default the previous result for this item will be in the same array position as this
            // item.
            var itemPreviousResult = previousResult && previousResult[i];
            // If the item is an id value, we should check to see if there is a previous result for this
            // specific id. If there is, that will be the value for `itemPreviousResult`.
            if (Object(apollo_utilities_lib["s" /* isIdValue */])(item)) {
                itemPreviousResult =
                    idToPreviousResult_1.get(item.id) || itemPreviousResult;
            }
            return addPreviousResultToIdValues(item, itemPreviousResult);
        });
    }
    // Return the value, nothing changed.
    return value;
}
/**
 * Maps a result from `graphql-anywhere` to a final result value.
 *
 * If the result and the previous result from the `idValue` pass a shallow equality test, we just
 * return the `previousResult` to maintain referential equality.
 *
 * We also add a private id property to the result that we can use later on.
 *
 * @private
 */
function readFromStore_resultMapper(resultFields, idValue) {
    // If we had a previous result, we may be able to return that and preserve referential equality
    if (idValue.previousResult) {
        var currentResultKeys_1 = Object.keys(resultFields);
        var sameAsPreviousResult = 
        // Confirm that we have the same keys in both the current result and the previous result.
        Object.keys(idValue.previousResult).every(function (key) { return currentResultKeys_1.indexOf(key) > -1; }) &&
            // Perform a shallow comparison of the result fields with the previous result. If all of
            // the shallow fields are referentially equal to the fields of the previous result we can
            // just return the previous result.
            //
            // While we do a shallow comparison of objects, but we do a deep comparison of arrays.
            currentResultKeys_1.every(function (key) {
                return areNestedArrayItemsStrictlyEqual(resultFields[key], idValue.previousResult[key]);
            });
        if (sameAsPreviousResult) {
            return idValue.previousResult;
        }
    }
    resultFields[ID_KEY] = idValue.id;
    return resultFields;
}
/**
 * Compare all the items to see if they are all referentially equal in two arrays no matter how
 * deeply nested the arrays are.
 *
 * @private
 */
function areNestedArrayItemsStrictlyEqual(a, b) {
    // If `a` and `b` are referentially equal, return true.
    if (a === b) {
        return true;
    }
    // If either `a` or `b` are not an array or not of the same length return false. `a` and `b` are
    // known to not be equal here, we checked above.
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
        return false;
    }
    // Otherwise let us compare all of the array items (which are potentially nested arrays!) to see
    // if they are equal.
    return a.every(function (item, i) { return areNestedArrayItemsStrictlyEqual(item, b[i]); });
}
//# sourceMappingURL=readFromStore.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/recordingCache.js
var recordingCache___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var RecordingCache = /** @class */ (function () {
    function RecordingCache(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
        this.recordedData = {};
    }
    RecordingCache.prototype.record = function (transaction) {
        transaction(this);
        var recordedData = this.recordedData;
        this.recordedData = {};
        return recordedData;
    };
    RecordingCache.prototype.toObject = function () {
        return recordingCache___assign({}, this.data, this.recordedData);
    };
    RecordingCache.prototype.get = function (dataId) {
        if (this.recordedData.hasOwnProperty(dataId)) {
            // recording always takes precedence:
            return this.recordedData[dataId];
        }
        return this.data[dataId];
    };
    RecordingCache.prototype.set = function (dataId, value) {
        if (this.get(dataId) !== value) {
            this.recordedData[dataId] = value;
        }
    };
    RecordingCache.prototype.delete = function (dataId) {
        this.recordedData[dataId] = undefined;
    };
    RecordingCache.prototype.clear = function () {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) { return _this.delete(dataId); });
        this.recordedData = {};
    };
    RecordingCache.prototype.replace = function (newData) {
        this.clear();
        this.recordedData = recordingCache___assign({}, newData);
    };
    return RecordingCache;
}());

function record(startingState, transaction) {
    var recordingCache = new RecordingCache(startingState);
    return recordingCache.record(transaction);
}
//# sourceMappingURL=recordingCache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/inMemoryCache.js
var inMemoryCache___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var inMemoryCache___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var defaultConfig = {
    fragmentMatcher: new fragmentMatcher_HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    storeFactory: defaultNormalizedCacheFactory,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var inMemoryCache_InMemoryCache = /** @class */ (function (_super) {
    inMemoryCache___extends(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.optimistic = [];
        _this.watches = [];
        // Set this while in a transaction to prevent broadcasts...
        // don't forget to turn it back on!
        _this.silenceBroadcast = false;
        _this.config = inMemoryCache___assign({}, defaultConfig, config);
        // backwards compat
        if (_this.config.customResolvers) {
            console.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            console.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = _this.config.addTypename;
        _this.data = _this.config.storeFactory();
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        if (optimistic && this.optimistic.length > 0) {
            var patches = this.optimistic.map(function (opt) { return opt.data; });
            return Object.assign.apply(Object, [{}, this.data.toObject()].concat(patches));
        }
        return this.data.toObject();
    };
    InMemoryCache.prototype.read = function (query) {
        if (query.rootId && this.data.get(query.rootId) === undefined) {
            return null;
        }
        return readQueryFromStore({
            store: this.config.storeFactory(this.extract(query.optimistic)),
            query: this.transformDocument(query.query),
            variables: query.variables,
            rootId: query.rootId,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            previousResult: query.previousResult,
            config: this.config,
        });
    };
    InMemoryCache.prototype.write = function (write) {
        writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        return diffQueryAgainstStore({
            store: this.config.storeFactory(this.extract(query.optimistic)),
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.push(watch);
        return function () {
            _this.watches = _this.watches.filter(function (c) { return c !== watch; });
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw new Error("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (id) {
        var _this = this;
        // Throw away optimistic changes of that particular mutation
        var toPerform = this.optimistic.filter(function (item) { return item.id !== id; });
        this.optimistic = [];
        // Re-run all of our optimistic data actions on top of one another.
        toPerform.forEach(function (change) {
            _this.recordOptimisticTransaction(change.transaction, change.id);
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.performTransaction = function (transaction) {
        // TODO: does this need to be different, or is this okay for an in-memory cache?
        var alreadySilenced = this.silenceBroadcast;
        this.silenceBroadcast = true;
        transaction(this);
        if (!alreadySilenced) {
            // Don't un-silence since this is a nested transaction
            // (for example, a transaction inside an optimistic record)
            this.silenceBroadcast = false;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        var _this = this;
        this.silenceBroadcast = true;
        var patch = record(this.extract(true), function (recordingCache) {
            // swapping data instance on 'this' is currently necessary
            // because of the current architecture
            var dataCache = _this.data;
            _this.data = recordingCache;
            _this.performTransaction(transaction);
            _this.data = dataCache;
        });
        this.optimistic.push({
            id: id,
            transaction: transaction,
            data: patch,
        });
        this.silenceBroadcast = false;
        this.broadcastWatches();
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename)
            return Object(apollo_utilities_lib["a" /* addTypenameToDocument */])(document);
        return document;
    };
    InMemoryCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: this.transformDocument(Object(apollo_utilities_lib["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName)),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            query: this.transformDocument(Object(apollo_utilities_lib["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName)),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        // Skip this when silenced (like inside a transaction)
        if (this.silenceBroadcast)
            return;
        // right now, we invalidate all queries whenever anything changes
        this.watches.forEach(function (c) {
            var newData = _this.diff({
                query: c.query,
                variables: c.variables,
                // TODO: previousResult isn't in the types - this will only work
                // with ObservableQuery which is in a different package
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic,
            });
            c.callback(newData);
        });
    };
    return InMemoryCache;
}(cache_ApolloCache));

//# sourceMappingURL=inMemoryCache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/index.js






//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-trip-board-button/lib/transpiled/index.js
var transpiled = __webpack_require__("LPd1");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// CONCATENATED MODULE: ./src/universal/routes.js
var ROOT = '/tripboard';
var ROOT2 = ROOT + '/';
var ROOT_LEGACY = '/traveler/scratchpad';

var API = '/traveler/scratchpad/api';
var FAVORITES = '/favorites';
var RECENT = '/recent';
var RECENT_DETAILS = RECENT + '/:linkId';
var TRIPBOARD = ROOT;
var TRIPBOARD2 = TRIPBOARD + '/';
var TRIPBOARD_DETAILS = TRIPBOARD + '/:boardId';
var TRIPBOARD_ERROR = TRIPBOARD + '/error';
var TRIPBOARD_MARKETING = TRIPBOARD + '/m/:boardId';

var routes = {
    FAVORITES: '' + ROOT_LEGACY + FAVORITES,
    FAVORITES_DETAILS: '' + ROOT_LEGACY + FAVORITES + '/:boardId',
    RECENT: RECENT,
    RECENT_DETAILS: RECENT_DETAILS,
    ROOT: ROOT,
    TRIPBOARD: TRIPBOARD,
    TRIPBOARD_DETAILS: TRIPBOARD_DETAILS,
    TRIPBOARD_ERROR: TRIPBOARD_ERROR,
    TRIPBOARD_MARKETING: TRIPBOARD_MARKETING
};

/* harmony default export */ var universal_routes = (routes);
// CONCATENATED MODULE: ./src/universal/client-side-apollo-client.js







var client_side_apollo_client_cache = new inMemoryCache_InMemoryCache({
    dataIdFromObject: function dataIdFromObject(object) {
        return Object(transpiled["dataIdFromObjectForTripboard"])(object) || defaultDataIdFromObject(object);
    }
}).restore(window.__INITIAL_APOLLO_STATE__);

// setup link with crumb support
var client_side_apollo_client_link = new batchHttpLink_BatchHttpLink({
    uri: API + '/graphql',
    credentials: 'same-origin',
    headers: {
        'x-csrf-token': window.ha.crumb,
        /** @todo remove when http-client includes fix for accept-language header */
        'x-homeaway-displaylocale': window && window.__INITIAL_STATE__ && window.__INITIAL_STATE__.system && window.__INITIAL_STATE__.system.locale
    }
});

// client-side apollo client
var client_side_apollo_client_client = new apollo_client["ApolloClient"]({
    cache: client_side_apollo_client_cache,
    link: client_side_apollo_client_link,
    shouldBatch: true
});

// export as singleton
/* harmony default export */ var client_side_apollo_client = (client_side_apollo_client_client);
// EXTERNAL MODULE: delegated ./node_modules/redux/es/index.js from dll-reference vendor_d3276433b58c8a2853f4
var esfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("2KeS");

// CONCATENATED MODULE: ./src/universal/utils/createReducer.js

/**
 * Simple utility to clean up reducer files.
**/
var createReducer = function createReducer() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments[1];

        if (typeof handlers[action.type] === 'function') {
            return handlers[action.type](state, action);
        }

        return state;
    };
};

/* harmony default export */ var utils_createReducer = (createReducer);
// CONCATENATED MODULE: ./src/universal/actions/actions.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* istanbul ignore next */
var ACTIONS = {
    FETCH_BASE_PAGE_DATA_SUCCESS: 'FETCH_BASE_PAGE_DATA_SUCCESS',
    FETCH_BASE_PAGE_DATA_ERROR: 'FETCH_BASE_PAGE_DATA_ERROR',

    TRIGGER_EDAP_PAGEVIEW: 'TRIGGER_EDAP_PAGEVIEW',
    TRIGGER_EDAP_EVENT: 'TRIGGER_EDAP_EVENT',
    UPDATE_TRIP_DATA: 'UPDATE_TRIP_DATA',
    INIT_TRIP_DATA: 'INIT_TRIP_DATA'
};

/* istanbul ignore next */
var ACTION_CREATORS = {
    fetchBasePageDataSuccess: function fetchBasePageDataSuccess(response) {
        return {
            type: ACTIONS.FETCH_BASE_PAGE_DATA_SUCCESS,
            payload: {
                response: response
            }
        };
    },
    fetchBasePageDataError: function fetchBasePageDataError(response) {
        return {
            type: ACTIONS.FETCH_BASE_PAGE_DATA_ERROR,
            payload: {
                response: response
            }
        };
    },
    triggerEdapPageView: function triggerEdapPageView() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PAGEVIEW
        };
    },
    triggerEdapEvent: function triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName: eventName,
                eventData: eventData,
                options: options
            }
        };
    },
    updateTripData: function updateTripData(tripData) {
        return {
            type: ACTIONS.UPDATE_TRIP_DATA,
            payload: tripData
        };
    },
    initTripData: function initTripData(tripData) {
        return {
            type: ACTIONS.INIT_TRIP_DATA,
            payload: tripData
        };
    }
};

/* harmony default export */ var actions = (_extends({}, ACTIONS, ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/reducers/system.js
var _actionHandlers;

var system__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var system_initialState = {};

var actionHandlers = (_actionHandlers = {}, _actionHandlers[actions.FETCH_BASE_PAGE_DATA_SUCCESS] = function (state, _ref) {
    var payload = _ref.payload;

    return system__extends({}, state, payload.response.system);
}, _actionHandlers);

/* harmony default export */ var reducers_system = (utils_createReducer(actionHandlers, system_initialState));
// CONCATENATED MODULE: ./src/universal/reducers/translations.js
var translations__actionHandlers;

var translations__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var translations_initialState = {};

var translations_actionHandlers = (translations__actionHandlers = {}, translations__actionHandlers[actions.FETCH_BASE_PAGE_DATA_SUCCESS] = function (state, _ref) {
    var payload = _ref.payload;

    return translations__extends({}, state, payload.response.translations);
}, translations__actionHandlers);

/* harmony default export */ var reducers_translations = (utils_createReducer(translations_actionHandlers, translations_initialState));
// CONCATENATED MODULE: ./src/universal/reducers/header.js
var header__actionHandlers;

var header__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var header_initialState = {};

var header_actionHandlers = (header__actionHandlers = {}, header__actionHandlers[actions.FETCH_BASE_PAGE_DATA_SUCCESS] = function (state, _ref) {
    var payload = _ref.payload;

    return header__extends({}, state, payload.response.header);
}, header__actionHandlers);

/* harmony default export */ var reducers_header = (utils_createReducer(header_actionHandlers, header_initialState));
// CONCATENATED MODULE: ./src/universal/reducers/footer.js
var footer__actionHandlers;

var footer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var footer_initialState = {};

var footer_actionHandlers = (footer__actionHandlers = {}, footer__actionHandlers[actions.FETCH_BASE_PAGE_DATA_SUCCESS] = function (state, _ref) {
    var payload = _ref.payload;

    return footer__extends({}, state, payload.response.footer);
}, footer__actionHandlers);

/* harmony default export */ var reducers_footer = (utils_createReducer(footer_actionHandlers, footer_initialState));
// CONCATENATED MODULE: ./src/universal/utils/fetch-wrapper.js
/**
 * Wrapped fetch post which correctly accounts for CSRF protection
 *
 * @param {string} url endpoint URL
 * @param {object} data POST payload
 */
function post(url, data) {
    return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json;charset=UTF-8',
            'x-csrf-token': window.ha.crumb
        },
        body: JSON.stringify(data)
    });
}
// CONCATENATED MODULE: ./src/universal/recent-activity/actions.js
var actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* istanbul ignore next */
var actions_ACTIONS = {
    FETCH_RECENT_ACTIVITY: 'FETCH_RECENT_ACTIVITY',
    FETCH_RECENT_ACTIVITY_START: 'FETCH_RECENT_ACTIVITY_START',
    FETCH_RECENT_ACTIVITY_SUCCESS: 'FETCH_RECENT_ACTIVITY_SUCCESS',
    FETCH_RECENT_ACTIVITY_ERROR: 'FETCH_RECENT_ACTIVITY_ERROR',
    REMOVE_RECENT_ACTIVITY_SEARCH: 'REMOVE_RECENT_ACTIVITY_SEARCH',
    REMOVE_RECENT_ACTIVITY_PROPERTY: 'REMOVE_RECENT_ACTIVITY_PROPERTY',
    CHANGE_RECENT_ACTIVITY_CARD_INDEX: 'CHANGE_RECENT_ACTIVITY_CARD_INDEX' // RecentActivityCarousel
};

/* istanbul ignore next */
var actions_ACTION_CREATORS = {
    fetchRecentActivity: function fetchRecentActivity() {
        return { type: actions_ACTIONS.FETCH_RECENT_ACTIVITY };
    },
    fetchRecentActivityStart: function fetchRecentActivityStart() {
        return { type: actions_ACTIONS.FETCH_RECENT_ACTIVITY_START };
    },
    fetchRecentActivitySuccess: function fetchRecentActivitySuccess(payload) {
        return { type: actions_ACTIONS.FETCH_RECENT_ACTIVITY_SUCCESS, payload: payload };
    },
    fetchRecentActivityError: function fetchRecentActivityError(payload) {
        return { type: actions_ACTIONS.FETCH_RECENT_ACTIVITY_ERROR, payload: payload };
    },
    removeRecentActivitySearch: function removeRecentActivitySearch(payload) {
        var propertyIds = payload.propertyIds,
            scratchpadId = payload.scratchpadId;

        post(API + '/recent-activity/deleteByIds', {
            ids: [].concat(propertyIds, [scratchpadId])
        });

        return { type: actions_ACTIONS.REMOVE_RECENT_ACTIVITY_SEARCH, payload: payload };
    },
    removeRecentActivityProperty: function removeRecentActivityProperty(payload) {
        var scratchpadId = payload.scratchpadId;

        post(API + '/recent-activity/deleteByIds', {
            ids: [scratchpadId]
        });

        return { type: actions_ACTIONS.REMOVE_RECENT_ACTIVITY_PROPERTY, payload: payload };
    },
    // RecentActivityCarousel
    changeRecentActivityCardIndex: function changeRecentActivityCardIndex(payload) {
        return { type: actions_ACTIONS.CHANGE_RECENT_ACTIVITY_CARD_INDEX, payload: payload };
    }
};

/* harmony default export */ var recent_activity_actions = (actions__extends({}, actions_ACTIONS, actions_ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/utils/constants.js
var constants__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getBoardIdListingId = function getBoardIdListingId(boardId, listingId) {
    var bid = 'bid=' + boardId;
    var lid = 'lid=' + listingId;
    if (boardId && listingId) {
        return [bid, lid].join(';');
    }
    if (boardId) {
        return bid;
    }
    if (listingId) {
        return lid;
    }
    return null;
};

var getPositionLabel = function getPositionLabel(position, total) {
    return 'position=' + (position + 1) + ';total=' + total;
};

var getTotal = function getTotal(total) {
    return 'total=' + total;
};

var ENTER_CHAR_CODE = 13;
var MAX_TRIPBOARD_NAME_LENGTH = 25;
var GOOGLE_MAPS_CHANNEL_ID = 'homeaway-pulse';

var CONSTANTS = {
    GOOGLE_MAPS_CHANNEL_ID: GOOGLE_MAPS_CHANNEL_ID,
    MAX_TRIPBOARD_NAME_LENGTH: MAX_TRIPBOARD_NAME_LENGTH,
    ENTER_CHAR_CODE: ENTER_CHAR_CODE,
    EDAP: {
        CHANGE_SEEN: {
            ACTION: 'changeSeen',
            getLabel: getPositionLabel
        }
    },
    OWNER: 'owner',
    VIEWER: 'viewer',
    COLLABORATOR: 'collaborator'
};

var API_STATUS = {
    START: 'START',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
};

var ROLES = {
    COLLABORATOR: 'COLLABORATOR',
    OWNER: 'OWNER',
    VIEWER: 'VIEWER',
    ADMIN: 'ADMIN'
};

var EDAP = {
    CATEGORY: 'Scratchpad',
    CHANGE_SEEN: {
        ACTION: 'changeSeen',
        getLabel: getPositionLabel
    },
    EMAIL_PREFERENCES: 'email preferences',
    TRIP_BOARDS_CATEGORY: 'Tripboards',

    // triggered when trip board summary hit is clicked
    TRIP_BOARDS_BOARD_CLICK: {
        ACTION: 'board.click',
        getLabel: getPositionLabel
    },

    // triggered when user clicks trash icon on trip board (starts the trip board delete flow)
    TRIP_BOARDS_BOARD_DELETE_START: 'board.delete.start',

    // triggered when user clicks, "yes, delete" for the trip board delete flow
    // this gets triggered whether the API call is successful or not (attempt)
    TRIP_BOARDS_BOARD_DELETE_ATTEMPT: 'board.delete.attempt',

    // triggered when user clicks, "cancel" for the trip board delete flow
    TRIP_BOARDS_BOARD_DELETE_CANCEL: 'board.delete.cancel',

    // triggered when user clicks on "edit" and starts edit board flow
    TRIP_BOARDS_BOARD_EDIT_START: 'board.edit.start',

    // triggered when user clicks "cancel" from edit board flow
    TRIP_BOARDS_BOARD_EDIT_CANCEL: 'board.edit.cancel',

    // triggered when user clicks "done" from edit board flow regardless if a change was made
    TRIP_BOARDS_BOARD_EDIT_DONE: 'board.edit.done',

    // triggered when a user has changed the board name and clicked "done"
    // this gets triggered whether the API call is successful or not (attempt)
    TRIP_BOARDS_BOARD_EDIT_NAME: {
        ACTION: 'board.edit.name.attempt',
        getLabel: function getLabel(oldName, newName) {
            return 'from=' + oldName + ';to=' + newName;
        }
    },

    // triggered when user clicks listing hit on trip board details
    TRIP_BOARDS_LISTING_CLICK: {
        ACTION: 'listing.click',
        getLabel: getPositionLabel
    },

    // triggered when user clicks "X" on listing hit on trip board details to delete listing
    // this gets triggered whether the API call is successful or not (attempt)
    TRIP_BOARDS_LISTING_DELETE: {
        ACTION: 'listing.delete.attempt',
        getLabel: getPositionLabel
    },

    // triggered when trip board summaries page is loaded
    TRIP_BOARDS_SUMMARIES_LOAD: {
        ACTION: 'board.summary.load',
        getLabel: getTotal
    },

    // triggered when trip board details page is loaded
    TRIP_BOARDS_DETAILS_LOAD: {
        ACTION: 'board.details.load',
        getLabel: getTotal
    },

    getBoardIdListingId: getBoardIdListingId
};

/* harmony default export */ var constants = (constants__extends({}, CONSTANTS, { EDAP: EDAP }));
// CONCATENATED MODULE: ./src/universal/recent-activity/recent-activity-reducer.js
var recent_activity_reducer__actionHandlers;

var recent_activity_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var recent_activity_reducer_initialState = {
    fetch: null,
    cardIndex: 0, // RecentActivityCarousel
    summaries: []
};

var recent_activity_reducer_actionHandlers = (recent_activity_reducer__actionHandlers = {}, recent_activity_reducer__actionHandlers[recent_activity_actions.FETCH_RECENT_ACTIVITY_START] = function (state) {
    return recent_activity_reducer__extends({}, state, {
        fetch: API_STATUS.START
    });
}, recent_activity_reducer__actionHandlers[recent_activity_actions.FETCH_RECENT_ACTIVITY_SUCCESS] = function (state, _ref) {
    var payload = _ref.payload;

    return recent_activity_reducer__extends({}, state, payload, {
        fetch: API_STATUS.SUCCESS
    });
}, recent_activity_reducer__actionHandlers[recent_activity_actions.FETCH_RECENT_ACTIVITY_ERROR] = function (state) {
    return recent_activity_reducer__extends({}, state, {
        fetch: API_STATUS.ERROR
    });
}, recent_activity_reducer__actionHandlers[recent_activity_actions.REMOVE_RECENT_ACTIVITY_SEARCH] = function (state, _ref2) {
    var payload = _ref2.payload;

    var summaries = state.summaries.reduce(function (newSummaries, summary) {
        if (summary.scratchpadId !== payload.scratchpadId) {
            return newSummaries.concat(summary);
        }
        return newSummaries;
    }, []);

    return recent_activity_reducer__extends({}, state, {
        summaries: summaries
    });
}, recent_activity_reducer__actionHandlers[recent_activity_actions.REMOVE_RECENT_ACTIVITY_PROPERTY] = function (state, _ref3) {
    var payload = _ref3.payload;

    var summaries = state.summaries.map(function (summary) {
        var newSummary = recent_activity_reducer__extends({}, summary);
        if (newSummary.scratchpadId === payload.searchId) {
            newSummary.propertiesSummary.properties = newSummary.propertiesSummary.properties.reduce(function (properties, property) {
                if (property.scratchpadId !== payload.scratchpadId) {
                    return properties.concat(property);
                }
                return properties;
            }, []);
        }
        return newSummary;
    });

    return recent_activity_reducer__extends({}, state, {
        summaries: summaries
    });
}, recent_activity_reducer__actionHandlers[recent_activity_actions.CHANGE_RECENT_ACTIVITY_CARD_INDEX] = function (state, _ref4) {
    var payload = _ref4.payload;

    return recent_activity_reducer__extends({}, state, {
        cardIndex: payload.cardIndex
    });
}, recent_activity_reducer__actionHandlers);

/* harmony default export */ var recent_activity_reducer = (utils_createReducer(recent_activity_reducer_actionHandlers, recent_activity_reducer_initialState));
// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_d3276433b58c8a2853f4
var prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// EXTERNAL MODULE: delegated ./node_modules/react-redux/es/index.js from dll-reference vendor_d3276433b58c8a2853f4
var react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("RH2O");

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 13 modules
var es = __webpack_require__("F8kA");

// CONCATENATED MODULE: ./src/universal/utils/client-logger.js
var noop = Function.prototype;

// we only want to run this client-side
var clientLogger = { captureException: noop, captureBreadcrumb: noop };
/* istanbul ignore if */
if ("object" !== 'undefined' && window.Raven) {
    clientLogger = window.Raven;
}

var LOG_ERROR = {
    level: 'error'
};

/* harmony default export */ var client_logger = (clientLogger);
// CONCATENATED MODULE: ./src/universal/utils/ha-wrapper.js
var ha_wrapper_noop = Function.prototype;

var haWrapper = {
    apiPrefix: null,
    userTiming: {
        mark: ha_wrapper_noop,
        measure: ha_wrapper_noop,
        measureAndSend: ha_wrapper_noop,
        clearMarks: ha_wrapper_noop,
        clearMeasures: ha_wrapper_noop,
        markAndMeasureAndSend: ha_wrapper_noop,
        getEntriesByName: ha_wrapper_noop
    }
};
// we only want to run this client-side
/* istanbul ignore if */
if ("object" !== 'undefined' && window.ha) {
    haWrapper = window.ha;
}

/* harmony default export */ var ha_wrapper = (haWrapper);
// CONCATENATED MODULE: ./src/universal/utils/logger.js



function log() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var urlPrefix = ha_wrapper.apiPrefix;
    if (!urlPrefix) {
        return;
    }
    post('/' + urlPrefix + '/api/logger', { data: data });
}

function logNoListingUrl(boardId, listingId) {
    log({ message: 'No listing url', boardId: boardId, listingId: listingId });
}

/* harmony default export */ var logger = ({
    log: log,
    logNoListingUrl: logNoListingUrl
});
// CONCATENATED MODULE: ./src/universal/components/error-boundary/error-boundary.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var error_boundary_ErrorBoundary = function (_Component) {
    _inherits(ErrorBoundary, _Component);

    function ErrorBoundary() {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.componentWillReceiveProps = function () {
            /* We want to clear this state everytime ErrorBoundary re-renders */
            _this.setState({ hasError: false });
        };

        _this.state = { hasError: false };
        return _this;
    }

    ErrorBoundary.prototype.componentDidCatch = function componentDidCatch(error, info) {
        this.setState({ hasError: true });
        client_logger.captureException(error, { extra: info });
        logger.log({ message: 'Error boundary page rendered. error: ' + error + ' info: ' + info });
    };

    ErrorBoundary.prototype.render = function render() {
        var hasError = this.state.hasError;


        var errorStyle = {
            paddingTop: '40px',
            paddingBottom: '40px'
        };

        if (hasError) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'row text-center', style: errorStyle },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'svg',
                    { className: 'inline-svg svg-xl svg-warning ' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xlinkHref: '#svg-alert' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'h3',
                    null,
                    this.props.errorTitle
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'p',
                    null,
                    this.props.errorMessage
                )
            );
        }

        return this.props.children;
    };

    return ErrorBoundary;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

error_boundary_ErrorBoundary.propTypes = {
    errorTitle: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    errorMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};


/* harmony default export */ var error_boundary = (error_boundary_ErrorBoundary);
// CONCATENATED MODULE: ./src/universal/components/error-boundary/index.js


// EXTERNAL MODULE: ./node_modules/@homeaway/react-unveil/lib/transpiled/index.js
var lib_transpiled = __webpack_require__("kSlA");
var lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(lib_transpiled);

// EXTERNAL MODULE: delegated ./node_modules/classnames/index.js from dll-reference vendor_d3276433b58c8a2853f4
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4 = __webpack_require__("HW6M");
var classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default = /*#__PURE__*/__webpack_require__.n(classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/actions.js
var comments_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NAMESPACE = 'COMMENTS';
var comments_actions_ACTIONS = {
    MODAL_CLOSE: NAMESPACE + '_MODAL_CLOSE',
    MODAL_OPEN: NAMESPACE + '_MODAL_OPEN'
};

/* istanbul ignore next */
var comments_actions_ACTION_CREATORS = {
    close: function close() {
        return { type: comments_actions_ACTIONS.MODAL_CLOSE };
    },
    open: function open(_ref) {
        var baseLocation = _ref.baseLocation,
            boardId = _ref.boardId,
            endDate = _ref.endDate,
            listingId = _ref.listingId,
            startDate = _ref.startDate,
            rest = _objectWithoutProperties(_ref, ['baseLocation', 'boardId', 'endDate', 'listingId', 'startDate']);

        return {
            type: comments_actions_ACTIONS.MODAL_OPEN,
            payload: comments_actions__extends({ baseLocation: baseLocation, boardId: boardId, endDate: endDate, listingId: listingId, startDate: startDate }, rest)
        };
    }
};

/* harmony default export */ var comments_actions = (comments_actions__extends({}, comments_actions_ACTIONS, comments_actions_ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/components/svg-def/collaborate.js
var COLLABORATE__24 = '<svg data-id="SVG_COLLABORATE__24" width="20" height="22" viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M-2-1h24v24H-2z"/><g transform="translate(1 1)" stroke="#364352" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M10.582 13.646H6.847c-3.438 0-6.225 2.909-6.225 6.498h11.205"/><ellipse cx="8.715" cy="5.198" rx="4.357" ry="4.549"/><path d="M15.562 13.646v5.198M13.072 16.245h4.98"/></g></g></svg>';
// CONCATENATED MODULE: ./src/universal/components/svg-def/comments.js
var COMMENTS__24 = '<svg xmlns="http://www.w3.org/2000/svg" data-id="SVG_COMMENTS__24" width="20" height="19" viewBox="0 0 20 19"><g fill="none" fill-rule="evenodd"><g stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M12.626 9.533H5M15 5.533H5M.75 5.533V16.25a1.5 1.5 0 0 0 2.795.757l1.947-3.33H19.25V2.844a1.5 1.5 0 0 0-1.5-1.5h-17"/></g><path d="M-2-3h24v24H-2z"/></g></svg>';
var COMMENTS_16 = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">\n<g fill="none" fill-rule="evenodd">\n    <path stroke="#323F4D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.987 6.99h-5.77M11.784 3.962H4.217M1 3.962v8.11a1.136 1.136 0 0 0 2.115.574l1.474-2.52H15V2.291a1.5 1.5 0 0 0-1.5-1.5H1"/>\n</g>\n</svg>\n';
// CONCATENATED MODULE: ./src/universal/components/svg-def/base-location.js
var LOCATION__16 = '<svg data-id="SVG_LOCATION__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8.3 1C5.3 1 3 3.4 3 6.3c0 4 4.5 8.7 5.3 8.7.8 0 5.3-4.8 5.3-8.7 0-3-2.4-5.3-5.3-5.3zm0 7.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8z" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg>';
// CONCATENATED MODULE: ./src/universal/components/svg-def/votes.js
var VOTETHUMB__32 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <path d=\"M-1243-708h4069v2389h-4069z\"/>\n    <g>\n        <rect width=\"30.5\" height=\"30.5\" x=\".75\" y=\".75\" rx=\"15.25\"/>\n        <g class=\"vote-thumb-svg\">\n            <path stroke-linecap=\"round\" d=\"M13.773 22H9a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1\"/>\n            <path stroke-linecap=\"square\" d=\"M13 15l1.998-7c1.132 0 1.997.827 1.997 1.91v3.817h4.995a1.996 1.996 0 0 1 1.997 2.228l-.732 4.454c-.133.955-.999 1.591-1.998 1.591H13v-7z\"/>\n        </g>\n        <path d=\"M4 3h24v24H4z\"/>\n    </g>\n</g>\n</svg>\n";

var VOTEPLUS__32 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <g>\n        <text class=\"vote-plus-svg\" font-family=\"Lato-Bold, Lato\" font-size=\"14\" font-weight=\"bold\">\n            <tspan x=\"7\" y=\"21\">+1</tspan>\n        </text>\n    </g>\n</g>\n</svg>\n";

var VOTEDPLUS__32 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <g>\n        <g fill-rule=\"nonzero\">\n            <path d=\"M4 4h24v24H4z\"/>\n            <path class=\"voted-plus-svg\" d=\"M13 20.17l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413l4.175 4.175a1 1 0 0 0 1.414 0l10.588-10.588a.997.997 0 0 0-1.41-1.41L13 20.17z\"/>\n        </g>\n    </g>\n</g>\n</svg>\n";

var VOTETHUMB__16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"14\" viewBox=\"0 0 16 14\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <path d=\"M0-1h16v16H0z\"/>\n    <g stroke=\"#323F4D\" stroke-linecap=\"square\" stroke-width=\"1.5\">\n        <path d=\"M4.5 13.25H1.75A.75.75 0 0 1 1 12.5V7.875a.75.75 0 0 1 .75-.75h1M5.375 7.125L7.123 1c.99 0 1.748.724 1.748 1.67v3.341h4.37c1.049 0 1.864.891 1.748 1.95l-.641 3.897c-.117.835-.874 1.392-1.748 1.392H5.375V7.125z\"/>\n    </g>\n</g>\n</svg>\n";

var VOTEDTHUMB__16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"14\" viewBox=\"0 0 16 14\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <path d=\"M0-1h16v16H0z\"/>\n    <g stroke=\"#323F4D\" stroke-linecap=\"square\" stroke-width=\"1.5\" fill-rule=\"nonzero\" fill=\"#0067db\">\n        <path d=\"M4.5 13.25H1.75A.75.75 0 0 1 1 12.5V7.875a.75.75 0 0 1 .75-.75h1M5.375 7.125L7.123 1c.99 0 1.748.724 1.748 1.67v3.341h4.37c1.049 0 1.864.891 1.748 1.95l-.641 3.897c-.117.835-.874 1.392-1.748 1.392H5.375V7.125z\"/>\n    </g>\n</g>\n</svg>\n";

var VOTEPLUS__16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <g>\n        <text class=\"vote-plus-svg\" font-family=\"Lato-Bold, Lato\" font-size=\"14\" font-weight=\"bold\">\n            <tspan x=\"7\" y=\"21\">+1</tspan>\n        </text>\n    </g>\n</g>\n</svg>\n";

var VOTEDPLUS__16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n<g fill=\"none\" fill-rule=\"evenodd\">\n    <g>\n        <g fill-rule=\"nonzero\">\n            <path d=\"M4 4h24v24H4z\"/>\n            <path class=\"voted-plus-svg\" d=\"M13 20.17l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413l4.175 4.175a1 1 0 0 0 1.414 0l10.588-10.588a.997.997 0 0 0-1.41-1.41L13 20.17z\"/>\n        </g>\n    </g>\n</g>\n</svg>\n";
// CONCATENATED MODULE: ./src/universal/components/svg-def/map-tabs.js
var LISTICON = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title> Icon - \u03B2eta / System Controls / Grid-L / 1 - 24 / 1 - Gray</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"Map-iteration\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <g id=\"v5\" transform=\"translate(-174.000000, -363.000000)\" stroke=\"currentColor\">\n            <g id=\"Group-3\">\n                <g id=\"::-TB---Tools\" transform=\"translate(163.000000, 272.000000)\">\n                    <g id=\"Group-9\" transform=\"translate(0.000000, 80.000000)\">\n                        <g id=\"Group-8\">\n                            <g id=\"Tab-Navigation--\u03B2eta-/-1---Horizontal-/-1---Default-\" transform=\"translate(8.000000, 8.000000)\">\n                                <g id=\"-Icon---\u03B2eta-/-System-Controls-/-Grid-L-/-1---24-/-1---Gray\">\n                                    <g id=\"Grid-L\" transform=\"translate(3.000000, 3.000000)\">\n                                        <polygon id=\"Stroke-340\" stroke-width=\"1.5\" points=\"0.923 7.077 7.076 7.077 7.076 0.923 0.923 0.923\"></polygon>\n                                        <polygon id=\"Stroke-341\" stroke-width=\"1.5\" points=\"10.923 7.077 17.077 7.077 17.077 0.923 10.923 0.923\"></polygon>\n                                        <polygon id=\"Stroke-354\" stroke-width=\"1.5\" points=\"0.923 17.077 7.076 17.077 7.076 10.923 0.923 10.923\"></polygon>\n                                        <polygon id=\"Stroke-355\" stroke-width=\"1.5\" points=\"10.923 17.077 17.077 17.077 17.077 10.923 10.923 10.923\"></polygon>\n                                    </g>\n                                </g>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>";

var MAPICON = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill-rule=\"evenodd\">\n    <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.52 9.77l2.1 4.18-3.67-1.04L4.66 15 1 13.95l2.1-4.18\" fill=\"none\"></path>\n    <path d=\"M4.98 6.46a3.44 3.44 0 0 1 .37-4.43l.02-.02a3.44 3.44 0 0 1 4.87 0l.02.02a3.44 3.44 0 0 1 .37 4.43l-2.82 3.96-2.83-3.96z\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n    <path d=\"M8.78 4.46a.97.97 0 1 1-1.95 0 .97.97 0 0 1 1.95 0\" stroke=\"none\" fill=\"currentColor\"></path>\n    </g>\n</svg>";
// CONCATENATED MODULE: ./src/universal/components/svg-def/index.js







// EXTERNAL MODULE: ./node_modules/@homeaway/abacus-client-utils/lib/transpiled/index.js
var abacus_client_utils_lib_transpiled = __webpack_require__("k4AA");
var abacus_client_utils_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(abacus_client_utils_lib_transpiled);

// EXTERNAL MODULE: ./src/universal/abacus/experiments.js
var experiments = __webpack_require__("a+sF");
var experiments_default = /*#__PURE__*/__webpack_require__.n(experiments);

// EXTERNAL MODULE: ./node_modules/@homeaway/edap-wrapper/lib/index.js
var edap_wrapper_lib = __webpack_require__("xEA1");
var lib_default = /*#__PURE__*/__webpack_require__.n(edap_wrapper_lib);

// CONCATENATED MODULE: ./src/universal/utils/edap.js
var edap__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var GENERIC_EVENT = 'generic.event';
var TEST_EXPOSURE = 'test.exposure';
var PAGE_VIEW = 'pageview';
var PRIMARY_ACTION_RENDERED = 'primary.action.rendered';
var PAGE_TRIPBOARD_MAIN = 'tripboards main';
var PAGE_TRIPBOARD_DETAILS = 'tripboards tripboard details';
var PAGE_TRIPBOARD_DETAILS_MAP = 'tripboards tripboard details map';
var PAGE_RECENT_ACTIVITY_DETAILS = 'tripboards recentactivity details';
var PAR_METRIC_NAME = 'primaryActionRendered';


var edap_getEdapRoleFromRole = function getEdapRoleFromRole() {
    var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var edapRole = role;
    if (edapRole === ROLES.OWNER) {
        edapRole = ROLES.ADMIN; /* hacky hack because 'OWNER' is not a valid enum in named events  TODO: remove this when edap updates with OWNER in accesstype enum*/
    }

    return edapRole.toLowerCase();
};

var edap_getPositionLabel = function getPositionLabel(position, total) {
    return 'position=' + (position + 1) + ';total=' + total;
};

var edap_getTotal = function getTotal(total) {
    return 'total=' + total;
};

var edap_logMetric = function logMetric(metric, metricLogName) {
    var loadTimeAnalytics = ha_wrapper.userTiming.getEntriesByName(metric);
    var metricMark = Math.ceil(loadTimeAnalytics.length ? loadTimeAnalytics[0].startTime : 0);
    var urlPrefix = ha_wrapper.apiPrefix;

    if (urlPrefix && metricLogName) {
        var _post;

        post('/' + urlPrefix + '/api/metrics', (_post = {}, _post[metricLogName] = metricMark, _post));
    }
};

var edap_markPAR = function markPAR() {
    ha_wrapper.userTiming.mark(PRIMARY_ACTION_RENDERED);
    edap_logMetric(PRIMARY_ACTION_RENDERED, PAR_METRIC_NAME);
};

var edap_trigger = function trigger(name, data, options) {
    lib_default()().push({
        name: name,
        data: data,
        options: options
    });
};

var pageview = function pageview(pagename) {
    if ("object" !== 'undefined' && window.analyticsdatalayer && pagename) {
        window.analyticsdatalayer = edap__extends({}, window.analyticsdatalayer, {
            pagename: pagename
        });
        edap_trigger(PAGE_VIEW);
    }
};

/* harmony default export */ var edap = ({
    getPositionLabel: edap_getPositionLabel,
    getEdapRoleFromRole: edap_getEdapRoleFromRole,
    getTotal: edap_getTotal,
    logMetric: edap_logMetric,
    markPAR: edap_markPAR,
    pageview: pageview,
    trigger: edap_trigger
});
// CONCATENATED MODULE: ./src/universal/tripboard/edap.js



var CATEGORY = 'tripboards';

// generic event utility methods
function edap_getBoardIdListingId(boardId, listingId) {
    if (typeof listingId !== 'undefined') {
        return 'bid=' + boardId + ';lid=' + listingId;
    }
    return 'bid=' + boardId;
}

function getDatesLabel(startDate, endDate) {
    var end = endDate || 'none';
    var start = startDate || 'none';
    return 'startDate=' + start + ';endDate=' + end;
}

function boardEventTrigger(eventaction) {
    return function (boardId) {
        var data = {
            eventcategory: CATEGORY,
            eventaction: eventaction,
            eventlabel: edap_getBoardIdListingId(boardId)
        };
        edap.trigger(GENERIC_EVENT, data);
    };
}

// generic events
var generic = {
    TRIP_BOARDS_ACTIVITY_SEEN: 'board.activity.seen',
    TRIP_BOARDS_ACTIVITY_INDICATOR: 'board.activity.indicator',
    TRIP_BOARDS_ACTIVITY_INDICATOR_TOOLTIP: 'board.activity.indicator.tooltip',
    TRIP_BOARDS_BOARD_DELETE_START: 'board.delete.start',
    TRIP_BOARDS_BOARD_DELETE_CANCEL: 'board.delete.cancel',
    TRIP_BOARDS_BOARD_DELETE_ATTEMPT: 'board.delete.attempt',
    TRIP_BOARDS_BOARD_EDIT_START: 'board.edit.start',
    TRIP_BOARDS_BOARD_EDIT_CANCEL: 'board.edit.cancel',
    TRIP_BOARDS_BOARD_EDIT_NAME: 'board.edit.name.attempt',
    TRIP_BOARDS_BOARD_EDIT_DONE: 'board.edit.done',
    TRIP_BOARDS_COMMENT_CLICK: 'board.comment.click',
    TRIP_BOARDS_COMMENT_ADD: 'board.comment.add',
    TRIP_BOARDS_COMMENT_VIEW_PROPERTY: 'board.comment.view.property',
    TRIP_BOARDS_LISTING_CLICK: 'listing.click',
    TRIP_BOARDS_LISTING_DELETE: 'listing.delete.attempt',
    TRIP_BOARDS_LOGIN: 'board.login.clicked',
    TRIP_BOARDS_SIGNUP: 'board.signup.clicked',
    TRIP_BOARDS_MAP_MARKER_CLICKED: 'board.map.marker.clicked',
    TRIP_BOARDS_MAP_PROPERTY_CLICKED: 'board.map.property.clicked',
    TRIP_BOARDS_MAP_TAB_CLICKED: 'board.map.tab.clicked',
    TRIP_BOARDS_MAP_INTERACTION: 'board.map.interaction',
    TRIP_BOARDS_SUMMARIES_LOAD: 'board.summary.load',
    TRIP_BOARDS_SUMMARIES_CLICK: 'boards.summary.click',
    TRIP_BOARDS_DETAILS_LOAD: 'board.details.load',
    TRIP_BOARDS_COLLABORATE_CLICK: 'boards.collaborate.click',
    TRIP_BOARDS_COPY_CLICK: 'boards.copy.click',
    TRIP_BOARDS_CAROUSEL_HIT_ARROW_CLICK: 'boards.carousel.hit.arrow.click',
    TRIP_BOARDS_CAROUSEL_COMMENTS_ARROW_CLICK: 'boards.carousel.comments.arrow.click',
    TRIP_BOARDS_CAROUSEL_HIT_CLICK: 'boards.carousel.hit.image.click',
    TRIP_BOARDS_SHARE_CLICK: 'boards.share.click',
    TRIP_BOARDS_COPY_URL: 'boards.url.copy',
    TRIP_BOARDS_CUT_URL: 'boards.url.cut',
    TRIP_BOARDS_DATES_CLICK: 'boards.dates.click',
    TRIP_BOARDS_DATES_CHANGE: 'boards.dates.change',
    TRIP_BOARDS_GUESTS_CLICK: 'boards.guests.click',
    TRIP_BOARDS_GUESTS_CHANGE: 'boards.guests.change',
    TRIP_BOARDS_INVITE_ACCEPT: 'board.invite.accept',
    TRIP_BOARDS_INVITE_INVALID: 'board.invite.invalid',
    TRIP_BOARDS_INVITE_INVALID_POP: 'board.invite.invalid.pop',
    TRIP_BOARDS_INVITE_INVALID_CLOSE: 'board.invite.invalid.close',
    TRIP_BOARDS_INVITE_EXPIRED_POP: 'board.invite.expired.pop',
    TRIP_BOARDS_INVITE_EXPIRED_CLOSE: 'board.invite.expired.close',
    TRIP_BOARDS_INVITE_EXPIRED_VIEW_TRIPBOARD_CLICK: 'board.invite.expired.view.tripboard.click',
    TRIP_BOARDS_INVITE_MODAL_POP: 'board.invite.modal.pop',
    TRIP_BOARDS_INVITE_MODAL_CLOSE: 'board.invite.modal.close',
    TRIP_BOARDS_INVITE_MODAL_LOGIN: 'board.invite.modal.login',
    TRIP_BOARDS_VOTES_VOTE_UP: 'board.votes.voteUp',
    TRIP_BOARDS_VOTES_VOTE_DOWN: 'board.votes.voteDown',
    TRIP_BOARDS_VOTES_VOTERS_CLOSE: 'board.votes.voters.close',
    TRIP_BOARDS_VOTES_VOTERS_OPEN: 'board.votes.voters.open',
    TRIP_BOARDS_PLACES_EMPTY: 'board.search.data.error',
    TRIP_BOARDS_LISTING_DELETE_MODAL_OPEN: 'board.listing.delete.modal.open',
    TRIP_BOARDS_LISTING_DELETE_MODAL_CLOSE: 'board.listing.delete.modal.close',
    BOARD_CREATE_ATTEMPT: 'board.create.attempt',
    BOARD_CREATE_CLICK: 'board.create.click',
    BOARD_SAVED: 'board.saved',
    BOARD_CREATE_ERROR: 'board.create.error',
    BOARD_CREATE_SKIP: 'board.create.skip',
    TRIP_BOARDS_CREATE_CONTROL_CLICK: 'board.create.control.click',
    TRIP_BOARDS_CREATE_MODAL_SEEN: 'board.create.control.modal.view',
    TRIP_BOARDS_CREATE_MODAL_CLOSED: 'board.create.control.modal.closed',
    TRIP_BOARDS_CREATE_MODAL_ERRORED: 'board.create.control.modal.error',
    TRIP_BOARDS_LEARNMORE_CLICK: 'board.login.learnmore.click'
};

// generic event methods
generic.activityIndicator = boardEventTrigger(generic.TRIP_BOARDS_ACTIVITY_INDICATOR);
generic.activityIndicatorTooltip = boardEventTrigger(generic.TRIP_BOARDS_ACTIVITY_INDICATOR_TOOLTIP);
generic.activitySeen = boardEventTrigger(generic.TRIP_BOARDS_ACTIVITY_SEEN);
generic.deleteStart = boardEventTrigger(generic.TRIP_BOARDS_BOARD_DELETE_START);
generic.deleteCancel = boardEventTrigger(generic.TRIP_BOARDS_BOARD_DELETE_CANCEL);
generic.deleteAttempt = boardEventTrigger(generic.TRIP_BOARDS_BOARD_DELETE_ATTEMPT);
generic.editStart = boardEventTrigger(generic.TRIP_BOARDS_BOARD_EDIT_START);
generic.editCancel = boardEventTrigger(generic.TRIP_BOARDS_BOARD_EDIT_CANCEL);
generic.editDone = boardEventTrigger(generic.TRIP_BOARDS_BOARD_EDIT_DONE);

generic.boardClick = function boardClick(boardId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_SUMMARIES_CLICK,
        eventlabel: edap.getPositionLabel(position, total) + ';' + edap_getBoardIdListingId(boardId)
    });
};

generic.editAttempt = function editAttempt(boardId, from, to) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_BOARD_EDIT_NAME,
        eventlabel: 'from=' + from + ';to=' + to + ';' + edap_getBoardIdListingId(boardId)
    });
};

generic.listingClick = function listingClick(boardId, listingId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_CLICK,
        eventlabel: edap.getPositionLabel(position, total) + ';' + edap_getBoardIdListingId(boardId, listingId)
    });
};

generic.listingDelete = function listingDelete(boardId, listingId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_DELETE,
        eventlabel: edap.getPositionLabel(position, total) + ';' + edap_getBoardIdListingId(boardId, listingId)
    });
};

generic.listingDeleteModalOpen = function listingDeleteModalOpen(boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_DELETE_MODAL_OPEN,
        eventlabel: '' + edap_getBoardIdListingId(boardId, listingId)
    });
};

generic.listingDeleteModalClose = function listingDeleteModalClose(boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_DELETE_MODAL_CLOSE,
        eventlabel: '' + edap_getBoardIdListingId(boardId, listingId)
    });
};

generic.placesError = function (boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_PLACES_EMPTY,
        eventlabel: '' + edap_getBoardIdListingId(boardId)
    });
};

generic.detailsLoad = function detailsLoad(boardId, endDate, total, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_DETAILS_LOAD,
        eventlabel: edap.getTotal(total) + ';' + edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
};

generic.summariesLoad = function summariesLoad(total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_SUMMARIES_LOAD,
        eventlabel: edap.getTotal(total)
    });
};

generic.carouselHitArrowClick = function carouselHitArrowClick(direction) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CAROUSEL_HIT_ARROW_CLICK,
        eventlabel: direction
    });
};

generic.carouselHitClick = function carouselHitClick(position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CAROUSEL_HIT_CLICK,
        eventlabel: edap.getPositionLabel(position, total)
    });
};

generic.carouselCommentsArrowClick = function carouselCommentsArrowClick(direction) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CAROUSEL_COMMENTS_ARROW_CLICK,
        eventlabel: direction
    });
};

generic.copyClick = function copyClick(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_COPY_CLICK,
        eventlabel: edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
};

generic.shareClick = function shareClick(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_SHARE_CLICK,
        eventlabel: edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
};

generic.copyUrl = function copyUrl(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_COPY_URL,
        eventlabel: edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
};

generic.cutUrl = function cutUrl(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CUT_URL,
        eventlabel: edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
};

generic.datesClick = function datesClick(boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_DATES_CLICK,
        eventlabel: edap_getBoardIdListingId(boardId)
    });
};

generic.datesChange = function datesChange(boardId, startDate, endDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_DATES_CHANGE,
        eventlabel: getDatesLabel(startDate, endDate) + ';' + edap_getBoardIdListingId(boardId)
    });
};

generic.guestsClick = function guestsClick(boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_GUESTS_CLICK,
        eventlabel: edap_getBoardIdListingId(boardId)
    });
};

generic.guestsChange = function guestsChange(boardId, adultsCount, childrenCount, petsIncluded) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_GUESTS_CHANGE,
        eventlabel: 'adultsCount=' + adultsCount + ';childrenCount=' + childrenCount + ';petsIncluded=' + petsIncluded + ';' + edap_getBoardIdListingId(boardId)
    });
};

generic.mapInteraction = function mapInteraction(boardId, interaction) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_INTERACTION,
        eventlabel: edap_getBoardIdListingId(boardId) + ';interaction=' + interaction
    });
};

generic.mapMarkerClicked = function mapMarkerClicked(boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_MARKER_CLICKED,
        eventlabel: '' + edap_getBoardIdListingId(boardId, listingId)
    });
};

generic.mapPropertyClicked = function mapPropertyClicked(boardId, index, total, listingId) {
    var edapIndex = index || '1';
    var edapTotal = total || '1';
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_PROPERTY_CLICKED,
        eventlabel: edap_getBoardIdListingId(boardId, listingId) + ';position=' + edapIndex + ';total=' + edapTotal
    }, {
        delayProcessing: true
    });
};

generic.mapTabClicked = function mapTabClicked(boardId, mapTestValue, index) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_TAB_CLICKED,
        eventlabel: edap_getBoardIdListingId(boardId) + '; testValue=' + mapTestValue + '; index=' + index
    });
};

generic.viewProperty = function (boardId, endDate, listingId, startDate, index, total) {
    var edapIndex = index || '1';
    var edapTotal = total || '1';
    edap.trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COMMENT_VIEW_PROPERTY,
        eventcategory: CATEGORY,
        eventlabel: edap_getBoardIdListingId(boardId, listingId) + ';' + getDatesLabel(startDate, endDate) + ';position=' + edapIndex + ';total=' + edapTotal
    }, { delayProcessing: true });
};

generic.tripboardLogin = function () {
    edap.trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_LOGIN,
        eventcategory: CATEGORY
    }, { delayProcessing: true });
};

generic.tripboardSignup = function () {
    edap.trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_SIGNUP,
        eventcategory: CATEGORY
    }, { delayProcessing: true });
};

generic.boardCreate = function (boardName, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_ATTEMPT,
        eventlabel: 'name=' + boardName + '; lid=' + listingId
    });
};

generic.learnMoreClick = function () {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LEARNMORE_CLICK
    });
};

generic.boardSaved = function (boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_SAVED,
        eventlabel: 'isnewboard=1; lid=' + listingId + '; bid=' + boardId
    });
};

generic.boardCreateClick = function (listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_CLICK,
        eventlabel: 'lid=' + listingId
    });
};

generic.boardCreateError = function (listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_ERROR,
        eventlabel: 'lid=' + listingId
    });
};

generic.boardCreateSkip = function () {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_SKIP
    });
};

/** @name accesstype edap enum (edap-integrations@8.6.0) */
var ACCESS_TYPE = {
    OWNER: 'admin',
    COLLABORATOR: 'collaborator',
    VIEWER: 'viewer'
};

/** @name entitytype edap enum (edap-integrations@8.6.0) */
var ENTITY_TYPE = {
    BOARD: 'trip board', // @entityvalue: '<trip board uuid>' '3635e571-a3f9-4af6-a252-6019b78e2992'
    LISTING: 'unit', // @entityvlaue: '<listingid>' '321.21011.21011'
    DATE: 'date', // @entityvlaue: '<date>' '2014-04-20'
    GUESTS: 'guests', // @entityvalue: '<guest count>' '2'
    CHILDREN: 'children', // @entityvalue: '<child count>' '0'
    PETS: 'pets', // @entityvalue: '<pets count>' '0'
    ROLE: 'role' // @entityvalue: '<role>' 'collaborator'
};

// lookup table to validate entitytype values above
var ENTITY_TYPE_MAP = {};
Object.values(ENTITY_TYPE).forEach(function (val) {
    ENTITY_TYPE_MAP[val] = true;
});

// named event utility methods
function getAccessType() {
    var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return ACCESS_TYPE[role.toUpperCase()] || ACCESS_TYPE.VIEWER;
}

function isValidEntityType(type) {
    return type in ENTITY_TYPE_MAP;
}

function isValidEntityArgs(boardid, entitytype) {
    return boardid && isValidEntityType(entitytype);
}

function tripboardEntityAction(namedEvent, needsAccessType) {
    return function (boardid, entitytype, entityvalue, role) {
        var accesstype = role ? getAccessType(role) : null;
        if (!isValidEntityArgs(boardid, entitytype) || needsAccessType && !role) {
            return;
        }

        if (accesstype) {
            edap.trigger(namedEvent, {
                boardid: boardid,
                entitytype: entitytype,
                entityvalue: entityvalue,
                accesstype: accesstype
            });
            return;
        }

        edap.trigger(namedEvent, {
            boardid: boardid,
            entitytype: entitytype,
            entityvalue: entityvalue
        });
    };
}

// named events (edap-integrations@9.10.0)
var named = {
    TRIP_BOARD_CLICK: 'tripboards.click',
    TRIP_BOARD_DELETE: 'tripboards.delete',
    TRIP_BOARD_REMOVE: 'tripboards.remove',
    TRIP_BOARD_UPDATE: 'tripboards.update',
    TRIP_BOARD_VIEW: 'tripboards.view',
    TRIP_BOARD_SEARCH_DATED: 'dated.search.submit',
    TRIP_BOARD_SEARCH: 'search.submit',
    HEARTING_CLICK: 'hearting.click',
    TRIP_BOARD_CREATE: 'tripboards.create'
};

// named event methods
named.click = tripboardEntityAction(named.TRIP_BOARD_CLICK);
named.remove = tripboardEntityAction(named.TRIP_BOARD_REMOVE, true);
named.update = tripboardEntityAction(named.TRIP_BOARD_UPDATE, true);

named.create = function tripboardCreate(boardid) {
    if (!boardid) {
        return;
    }
    edap.trigger(named.TRIP_BOARD_CREATE, { boardid: boardid });
};

named.delete = function tripboardDelete(boardid) {
    if (!boardid) {
        return;
    }
    edap.trigger(named.TRIP_BOARD_DELETE, { boardid: boardid });
};

named.view = function tripboardView(boardid, role) {
    if (!boardid) {
        return;
    }
    edap.trigger(named.TRIP_BOARD_VIEW, {
        accesstype: getAccessType(role),
        boardid: boardid
    });
};

named.search = function tripboardSearch(boardid, role, dated, type) {
    if (!boardid) {
        return;
    }
    if (dated) {
        edap.trigger(named.TRIP_BOARD_SEARCH_DATED, {
            accesstype: getAccessType(role),
            actionlocation: type,
            boardid: boardid
        });
    } else {
        edap.trigger(named.TRIP_BOARD_SEARCH, {
            accesstype: getAccessType(role),
            actionlocation: type,
            boardid: boardid
        });
    }
};

named.heartClicked = function heartingClicked(boardid, actionstate) {
    edap.trigger(named.HEARTING_CLICK, {
        boardid: boardid,
        actionstate: actionstate
    });
};

var TripboardEdapTrigger = {
    activityIndicator: generic.activityIndicator,
    activityIndicatorTooltip: generic.activityIndicatorTooltip,
    activitySeen: generic.activitySeen,
    deleteStart: generic.deleteStart,
    deleteCancel: generic.deleteCancel,
    deleteAttempt: function deleteAttempt(boardId) {
        generic.deleteAttempt(boardId);
        named.delete(boardId);
    },
    editStart: generic.editStart,
    editCancel: generic.editCancel,
    editDone: generic.editDone,
    boardClick: function boardClick(boardId, position, total) {
        generic.boardClick(boardId, position, total);
        named.click(boardId, ENTITY_TYPE.BOARD, boardId);
    },
    editAttempt: function editAttempt(boardId, from, to, role) {
        generic.editAttempt(boardId, from, to);
        named.update(boardId, ENTITY_TYPE.BOARD, to, role);
    },
    listingClick: function listingClick(boardId, listingId, position, total) {
        generic.listingClick(boardId, listingId, position, total);
        named.click(boardId, ENTITY_TYPE.LISTING, listingId);
    },
    listingDelete: function listingDelete(boardId, listingId, position, total, role) {
        generic.listingDelete(boardId, listingId, position, total);
        named.remove(boardId, ENTITY_TYPE.LISTING, listingId, role);
    },
    tripboardSearch: function tripboardSearch(boardId, role, dated, type) {
        named.search(boardId, role, dated, type);
    },
    tripboardCreate: function tripboardCreate(boardId) {
        named.create(boardId);
    },

    boardCreate: generic.boardCreate,
    boardCreateClick: generic.boardCreateClick,
    boardCreateSkip: generic.boardCreateSkip,
    boardCreateError: generic.boardCreateError,
    boardSaved: generic.boardSaved,

    tripboardLogin: generic.tripboardLogin,
    tripboardSignup: generic.tripboardSignup,

    detailsLoad: generic.detailsLoad,
    learnMoreClick: generic.learnMoreClick,
    tripboardsView: named.view,
    summariesLoad: generic.summariesLoad,
    copyClick: generic.copyClick,
    shareClick: generic.shareClick,
    heartClicked: named.heartClicked,
    copyUrl: generic.copyUrl,
    cutUrl: generic.cutUrl,
    datesClick: generic.datesClick,
    datesChange: generic.datesChange,
    invalidInviteModalPop: generic.invalidInviteModalPop,
    invalidInviteModalClose: generic.invalidInviteModalClose,
    listingDeleteModalOpen: generic.listingDeleteModalOpen,
    listingDeleteModalClose: generic.listingDeleteModalClose,
    carouselHitArrowClick: generic.carouselHitArrowClick,
    carouselCommentsArrowClick: generic.carouselCommentsArrowClick,
    carouselHitClick: generic.carouselHitClick,
    guestsClick: generic.guestsClick,
    guestsChange: generic.guestsChange,
    viewProperty: generic.viewProperty,
    placesError: generic.placesError,
    mapInteraction: generic.mapInteraction,
    mapMarkerClicked: generic.mapMarkerClicked,
    mapPropertyClicked: generic.mapPropertyClicked,
    mapTabClicked: generic.mapTabClicked
};

// Abacus: ha_pulse_shared_tripboard_ab_test
// Triggered from the tripboard-details copmonent.
var evalAndLogSharedTripBoard = function logSharedTripBoard() {
    abacus_client_utils_lib_transpiled_default.a.evaluateExperimentAndLog(experiments["HA_PULSE_SHARED_TRIPBOARD_AB_TEST"]);
};

/* harmony default export */ var tripboard_edap = (TripboardEdapTrigger);
// CONCATENATED MODULE: ./src/universal/tripboard/comments/edap.js



var edap_named = {
    TRIPBOARDS_VOTE: 'tripboards.vote',
    TRIPBOARDS_CARD_COMMENT_ADD: 'tripboards.card.comment.add',
    TRIPBOARDS_CARD_COMMENT_DELETE: 'tripbards.card.comment.delete',
    TRIPBOARDS_CARD_COMMENT_EDIT: 'tripboards.card.comment.edit'
};

var edap_namedCommentEvent = function namedCommentEvent(event, boardId, role, endDate, startDate, listingId) {
    var accesstype = edap.getEdapRoleFromRole(role);
    var options = {
        boardid: boardId,
        accesstype: accesstype,
        listingid: listingId
    };

    if (endDate && startDate) {
        options.eventenddate = endDate;
        options.eventstartdate = startDate;
    }

    edap_trigger(event, options);
};

var edap_addComment = function addComment(boardId, endDate, listingId, startDate, role) {
    edap_namedCommentEvent(edap_named.TRIPBOARDS_CARD_COMMENT_ADD, boardId, role, endDate, startDate, listingId);

    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COMMENT_ADD,
        eventcategory: CATEGORY,
        eventlabel: edap_getBoardIdListingId(boardId, listingId) + ';' + getDatesLabel(startDate, endDate)
    });
};

var edap_viewComments = function viewComments(boardId, endDate, listingId, startDate) {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COMMENT_CLICK,
        eventcategory: CATEGORY,
        eventlabel: edap_getBoardIdListingId(boardId, listingId) + ';' + getDatesLabel(startDate, endDate)
    });
};

/* harmony default export */ var comments_edap = ({
    addComment: edap_addComment,
    viewComments: edap_viewComments
});
// EXTERNAL MODULE: ./node_modules/react-apollo/react-apollo.browser.umd.js
var react_apollo_browser_umd = __webpack_require__("3zLD");
var react_apollo_browser_umd_default = /*#__PURE__*/__webpack_require__.n(react_apollo_browser_umd);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/transpiled/index.js
var react_svg_lib_transpiled = __webpack_require__("Ye17");
var react_svg_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_svg_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/components/auth/auth-context.js

var AuthContext = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createContext({});
/* harmony default export */ var auth_context = (AuthContext);
// CONCATENATED MODULE: ./src/universal/components/auth/with-auth.js
var with_auth__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function withAuth(Component) {
    return function AuthComponent(props) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            auth_context.Consumer,
            null,
            function (auth) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Component, with_auth__extends({}, props, auth));
            }
        );
    };
}

/* harmony default export */ var with_auth = (withAuth);
// CONCATENATED MODULE: ./src/universal/components/auth/logged-in.js



function LoggedIn(_ref) {
    var children = _ref.children,
        _ref$inverse = _ref.inverse,
        inverse = _ref$inverse === undefined ? false : _ref$inverse,
        _ref$isLoggedIn = _ref.isLoggedIn,
        isLoggedIn = _ref$isLoggedIn === undefined ? false : _ref$isLoggedIn;

    if (inverse && !isLoggedIn || !inverse && isLoggedIn) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            children
        );
    }
    return null;
}

/* harmony default export */ var logged_in = (with_auth(LoggedIn));
// CONCATENATED MODULE: ./src/universal/components/auth/index.js




// CONCATENATED MODULE: ./src/universal/components/translations/translations-context.js

var TranslationsContext = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createContext({});
/* harmony default export */ var translations_context = (TranslationsContext);
// CONCATENATED MODULE: ./src/universal/components/translations/with-translations.js
var with_translations__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function mapTranslationsProps() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var translations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allowUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var props = {};
    for (var key in config) {
        if (config.hasOwnProperty(key)) {
            if (!allowUndefined) {
                props[config[key]] = translations[key] || '';
            } else if (translations[key]) {
                props[config[key]] = translations[key];
            }
        }
    }
    return props;
}

function withTranslations(Component) {
    return function TranslationsComponent(props) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            translations_context.Consumer,
            null,
            function (translations) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Component, with_translations__extends({}, props, { translations: translations }));
            }
        );
    };
}

/**
 * @param {object literal} config
 * @param {boolean} allowUndefined - Default: false; default props to empty string or allow them to be undefined
 */
function withTranslationsAsProps(config, allowUndefined) {
    return function (Component) {
        return function (props) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                translations_context.Consumer,
                null,
                function (translations) {
                    var translationsProps = mapTranslationsProps(config, translations, allowUndefined);
                    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Component, with_translations__extends({}, props, translationsProps));
                }
            );
        };
    };
}
// CONCATENATED MODULE: ./src/universal/components/translations/index.js



// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__("tlQw");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/comments-graphql.js
var _templateObject = _taggedTemplateLiteralLoose(['\nquery localizedUnitNotes($hav: String!, $tripBoardUuid: String!, $unitTriad: String!, $locale: String!, $timezone: String!) {\n    localizedUnitNotes(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad, locale: $locale, timezone: $timezone) {\n        pagination {\n            totalItems\n        },\n        unitNotes {\n            localeCreateTime,\n            localeCreateDate,\n            wasCreatedToday,\n            createTime,\n            isMine,\n            text,\n            updateTime,\n            author {\n                firstName,\n                lastName,\n                publicImageUrl\n            }\n            uuid\n        }\n    }\n}'], ['\nquery localizedUnitNotes($hav: String!, $tripBoardUuid: String!, $unitTriad: String!, $locale: String!, $timezone: String!) {\n    localizedUnitNotes(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad, locale: $locale, timezone: $timezone) {\n        pagination {\n            totalItems\n        },\n        unitNotes {\n            localeCreateTime,\n            localeCreateDate,\n            wasCreatedToday,\n            createTime,\n            isMine,\n            text,\n            updateTime,\n            author {\n                firstName,\n                lastName,\n                publicImageUrl\n            }\n            uuid\n        }\n    }\n}']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\nmutation addLocalizedNoteToTripBoardUnit($hav: String!, $tripBoardUnitNoteInput: TripBoardUnitNoteInput!, $locale: String!, $timezone: String!) {\n    addLocalizedNoteToTripBoardUnit(hav: $hav, tripBoardUnitNoteInput: $tripBoardUnitNoteInput, locale: $locale, timezone: $timezone) {\n        uuid,\n        createTime,\n        updateTime,\n        localeCreateTime,\n        localeCreateDate,\n        unitTriad,\n        isMine,\n        text,\n        author {\n            firstName,\n            lastName,\n            publicImageUrl\n        }\n    }\n}'], ['\nmutation addLocalizedNoteToTripBoardUnit($hav: String!, $tripBoardUnitNoteInput: TripBoardUnitNoteInput!, $locale: String!, $timezone: String!) {\n    addLocalizedNoteToTripBoardUnit(hav: $hav, tripBoardUnitNoteInput: $tripBoardUnitNoteInput, locale: $locale, timezone: $timezone) {\n        uuid,\n        createTime,\n        updateTime,\n        localeCreateTime,\n        localeCreateDate,\n        unitTriad,\n        isMine,\n        text,\n        author {\n            firstName,\n            lastName,\n            publicImageUrl\n        }\n    }\n}']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }



var POLL_INTERVAL = 1000;

var GET_NOTES = src_default()(_templateObject);

var ADD_NOTE = src_default()(_templateObject2);

// locale + timezone required for localized notes
var comments_graphql_mapStateToProps = function mapStateToProps(_ref) {
    var locale = _ref.system.locale,
        _ref$tripboard = _ref.tripboard;
    _ref$tripboard = _ref$tripboard === undefined ? {} : _ref$tripboard;
    var _ref$tripboard$commen = _ref$tripboard.comments;
    _ref$tripboard$commen = _ref$tripboard$commen === undefined ? {} : _ref$tripboard$commen;
    var _ref$tripboard$commen2 = _ref$tripboard$commen.timezone,
        timezone = _ref$tripboard$commen2 === undefined ? '0' : _ref$tripboard$commen2;
    return {
        locale: locale,
        timezone: timezone
    };
};

var getOptions = function getOptions(_ref2) {
    var boardId = _ref2.boardId,
        hav = _ref2.hav,
        listingId = _ref2.listingId,
        locale = _ref2.locale,
        timezone = _ref2.timezone;
    return {
        variables: {
            tripBoardUuid: boardId,
            hav: hav,
            unitTriad: listingId,
            locale: locale,
            timezone: timezone
        },
        notifyOnNetworkStatusChange: false,
        errorPolicy: 'all'
    };
};

var pollingOptions = function pollingOptions(_ref3) {
    var boardId = _ref3.boardId,
        hav = _ref3.hav,
        listingId = _ref3.listingId,
        locale = _ref3.locale,
        timezone = _ref3.timezone;
    return {
        variables: {
            tripBoardUuid: boardId,
            hav: hav,
            unitTriad: listingId,
            locale: locale,
            timezone: timezone
        },
        notifyOnNetworkStatusChange: false,
        pollInterval: POLL_INTERVAL,
        errorPolicy: 'all'
    };
};

var mutationProps = function mutationProps(_ref4) {
    var mutate = _ref4.mutate,
        ownProps = _ref4.ownProps;
    return {
        addNote: function addNote(_ref5) {
            var onError = _ref5.onError,
                onLoading = _ref5.onLoading,
                onSuccess = _ref5.onSuccess,
                text = _ref5.text;
            var hav = ownProps.hav,
                boardId = ownProps.boardId,
                listingId = ownProps.listingId,
                locale = ownProps.locale,
                timezone = ownProps.timezone;

            onLoading(); // component state hook

            return mutate({
                variables: {
                    hav: hav,
                    tripBoardUnitNoteInput: {
                        text: text,
                        tripBoardUuid: boardId,
                        unitTriad: listingId
                    },
                    locale: locale,
                    timezone: timezone
                },
                update: function update(proxy) {
                    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var addLocalizedNoteToTripBoardUnit = data.data.addLocalizedNoteToTripBoardUnit;

                    var variables = {
                        hav: hav,
                        tripBoardUuid: boardId,
                        unitTriad: listingId,
                        locale: locale,
                        timezone: timezone
                    };

                    var cache = proxy.readQuery({ query: GET_NOTES, variables: variables }) || {};
                    var localizedUnitNotes = cache.localizedUnitNotes;

                    // were we successful?

                    if (addLocalizedNoteToTripBoardUnit && localizedUnitNotes && Array.isArray(localizedUnitNotes.unitNotes)) {
                        cache.localizedUnitNotes.pagination.total++;
                        cache.localizedUnitNotes.unitNotes.unshift(addLocalizedNoteToTripBoardUnit);
                        proxy.writeQuery({ query: GET_NOTES, variables: variables, data: cache });
                        onSuccess(); // component state hook
                    } else {
                        onError(); // component state hook
                    }
                }
            }).catch(function () {
                onError(); // component state hook
            });
        }
    };
};
// EXTERNAL MODULE: ./src/universal/tripboard/comments/components/comments-icon.less
var comments_icon = __webpack_require__("K9ox");
var comments_icon_default = /*#__PURE__*/__webpack_require__.n(comments_icon);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/comments-icon.js
var comments_icon__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function comments_icon__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function comments_icon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function comments_icon__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function comments_icon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var comments_icon_CommentsIcon = function (_Component) {
    comments_icon__inherits(CommentsIcon, _Component);

    function CommentsIcon(props) {
        comments_icon__classCallCheck(this, CommentsIcon);

        var _this = comments_icon__possibleConstructorReturn(this, _Component.call(this, props));

        _this.buttonRef = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createRef();
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    CommentsIcon.prototype.componentDidMount = function componentDidMount() {
        // onClick via React does not work when rendered inside a google overlay
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.addEventListener('click', this.onClick);
        }
    };

    CommentsIcon.prototype.componentWillUnmount = function componentWillUnmount() {
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.removeEventListener('click', this.onClick);
        }
    };

    CommentsIcon.prototype.onClick = function onClick(event) {
        var _props = this.props,
            baseLocation = _props.baseLocation,
            boardId = _props.boardId,
            endDate = _props.endDate,
            listingId = _props.listingId,
            open = _props.open,
            startDate = _props.startDate,
            rest = comments_icon__objectWithoutProperties(_props, ['baseLocation', 'boardId', 'endDate', 'listingId', 'open', 'startDate']);

        comments_edap.viewComments(boardId, endDate, listingId, startDate);
        open(comments_icon__extends({ baseLocation: baseLocation, endDate: endDate, boardId: boardId, listingId: listingId, startDate: startDate }, rest));
        event.preventDefault();
    };

    CommentsIcon.prototype.render = function render() {
        var _props2 = this.props,
            className = _props2.className,
            unitNotes = _props2.data.localizedUnitNotes,
            langAddComment = _props2.langAddComment,
            _props2$isSmall = _props2.isSmall,
            isSmall = _props2$isSmall === undefined ? false : _props2$isSmall;

        var count = unitNotes && unitNotes.pagination && unitNotes.pagination.totalItems || 0;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'comments-icon ' + (className || '') },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'button',
                {
                    'aria-label': langAddComment,
                    className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('comments-icon__button', { 'comments-icon__button--small': isSmall }),
                    type: 'button',
                    ref: this.buttonRef
                },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'comments-icon__SVGIcon', markup: isSmall ? COMMENTS_16 : COMMENTS__24 })
            ),
            count > 0 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'span',
                { className: 'comments-icon__count text-muted text-sm' },
                count
            )
        );
    };

    return CommentsIcon;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

comments_icon_CommentsIcon.defaultProps = {
    data: {},
    open: function open() {}
};

var mapDispatchToProps = {
    open: comments_actions.open
};

/* harmony default export */ var components_comments_icon = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(comments_graphql_mapStateToProps, mapDispatchToProps), Object(react_apollo_browser_umd["graphql"])(GET_NOTES, { options: getOptions }), withTranslationsAsProps({
    'tripboards.add.comment': 'langAddComment'
}))(comments_icon_CommentsIcon));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-buttons/lib/transpiled/index.js
var react_buttons_lib_transpiled = __webpack_require__("HfJ9");
var react_buttons_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_buttons_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("y1vT");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/transpiled/index.js
var react_form_components_lib_transpiled = __webpack_require__("QyGt");
var react_form_components_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_form_components_lib_transpiled);

// EXTERNAL MODULE: ./src/universal/components/form-char-counter/form-char-counter.less
var form_char_counter = __webpack_require__("n6Q6");
var form_char_counter_default = /*#__PURE__*/__webpack_require__.n(form_char_counter);

// CONCATENATED MODULE: ./src/universal/components/form-char-counter/form-char-counter.js
var form_char_counter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function form_char_counter__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var getCount = function getCount() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (typeof value !== 'string') {
        return max;
    }
    return max - value.length;
};

var isOverLimit = function isOverLimit() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var count = getCount(value, max);
    return count < 0;
};

function FormCharCounter(_ref) {
    var errorMsg = _ref.errorMsg,
        helpText = _ref.helpText,
        langOverCharLimit = _ref.langOverCharLimit,
        maxLength = _ref.maxLength,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? '' : _ref$value,
        rest = form_char_counter__objectWithoutProperties(_ref, ['errorMsg', 'helpText', 'langOverCharLimit', 'maxLength', 'value']);

    var count = getCount(value, maxLength);
    var isOver = isOverLimit(value, maxLength);
    var langError = errorMsg || (isOver ? langOverCharLimit : null);
    var containerClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
        'form-char-counter': true,
        'has-error': !!errorMsg,
        'has-help': !!helpText,
        'has-limit-error': !!isOver
    });
    var counterClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
        'form-char-counter__count': true,
        'has-limit-error': !!isOver,
        'help-block': true
    });

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: containerClass },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_form_components_lib_transpiled["FormTextArea"], form_char_counter__extends({
            helpText: helpText,
            errorMsg: langError,
            value: value
        }, rest)),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: counterClass },
            count
        )
    );
}

/* harmony default export */ var form_char_counter_form_char_counter = (withTranslationsAsProps({
    'tripboards.over.char.limit': 'langOverCharLimit'
})(FormCharCounter));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-loading-overlay/lib/transpiled/index.js
var react_loading_overlay_lib_transpiled = __webpack_require__("/RGw");
var react_loading_overlay_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_loading_overlay_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/tripboard/user/user.js
var user__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function user__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function user__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function user__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function user__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creating a Context for the current trip board user,
 * so that components on the details page can access
 * the user's profile information from anywhere.
 *
 * Example use case:
 *
 * We leverage optimistic responses for votes, so there
 * is a delay in getting the voter information back from
 * the mutation response. To improve this, we simply grab
 * the user from the Context, so that we can immediately
 * display user information instead of waiting for the
 * mutation response.
 */



var TRIP_BOARD_USER = {
    isMe: true,
    profile: null,
    role: {
        type: ROLES.VIEWER
    }
};

var user_tripBoardUser = function tripBoardUser() {
    var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user__extends({}, TRIP_BOARD_USER);

    var usr = user__extends({}, user);
    var role = user.role.type.toLowerCase();
    // computed properties
    usr.isCollaborator = role === ROLES.COLLABORATOR.toLowerCase();
    usr.isOwner = role === ROLES.OWNER.toLowerCase();
    usr.isViewer = role === ROLES.VIEWER.toLowerCase();
    return usr;
};

var UserContext = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createContext(user_tripBoardUser(TRIP_BOARD_USER));

/**
 * The current trip board user's role can change between trip board
 * views. Some boards the user will be owner of, others a collaborator
 * or viewer. This component keeps the user data for the UserContext
 * provider up-to-date between trip board views.
 */
var user_UserProvider = function (_React$Component) {
    user__inherits(UserProvider, _React$Component);

    function UserProvider(props) {
        user__classCallCheck(this, UserProvider);

        var _this = user__possibleConstructorReturn(this, _React$Component.call(this, props));

        var children = props.children,
            rest = user__objectWithoutProperties(props, ['children']); // eslint-disable-line no-unused-vars


        _this.state = user_tripBoardUser(user__extends({}, TRIP_BOARD_USER, rest));
        return _this;
    }

    UserProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var children = nextProps.children,
            rest = user__objectWithoutProperties(nextProps, ['children']); // eslint-disable-line no-unused-vars


        var user = user_tripBoardUser(user__extends({}, rest));
        this.setState(user);
    };

    UserProvider.prototype.render = function render() {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            UserContext.Provider,
            { value: this.state },
            this.props.children
        );
    };

    return UserProvider;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Component);

user_UserProvider.defaultProps = user__extends({}, TRIP_BOARD_USER);
function withUser(Component) {
    return function UserComponent(props) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            UserContext.Consumer,
            null,
            function (user) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Component, user__extends({}, props, { user: user }));
            }
        );
    };
}
// EXTERNAL MODULE: ./src/universal/tripboard/comments/components/add-comment.less
var add_comment = __webpack_require__("jkO+");
var add_comment_default = /*#__PURE__*/__webpack_require__.n(add_comment);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/add-comment.js
function add_comment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function add_comment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function add_comment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var logCharLimitError = lodash_debounce_default()(log, 500, {
    leading: false,
    trailing: true
});

var MAXLENGTH = 280;

var add_comment_AddComment = function (_Component) {
    add_comment__inherits(AddComment, _Component);

    function AddComment(props) {
        add_comment__classCallCheck(this, AddComment);

        var _this = add_comment__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onError = function () {
            /* istanbul ignore next */
            var startPolling = _this.props.startPolling;
            /* istanbul ignore next */

            _this.setState({
                error: true,
                loading: false
            });
            /* istanbul ignore next */
            startPolling();
        };

        _this.onLoading = function () {
            /* istanbul ignore next */
            _this.setState({ loading: true });
        };

        _this.onSuccess = function () {
            /* istanbul ignore next */
            var startPolling = _this.props.startPolling;
            /* istanbul ignore next */

            _this.reset();
            /* istanbul ignore next */
            startPolling();
        };

        _this.reset = function () {
            /* istanbul ignore next */
            _this.setState(AddComment.initialState);
        };

        _this.submit = function (e) {
            var _this$props = _this.props,
                addNote = _this$props.addNote,
                boardId = _this$props.boardId,
                endDate = _this$props.endDate,
                listingId = _this$props.listingId,
                startDate = _this$props.startDate,
                stopPolling = _this$props.stopPolling,
                user = _this$props.user;

            var role = user && user.role && user.role.type || '';
            var _this$state = _this.state,
                disabled = _this$state.disabled,
                text = _this$state.text;
            var onError = _this.onError,
                onLoading = _this.onLoading,
                onSuccess = _this.onSuccess;

            e.preventDefault();
            if (disabled) {
                return;
            }
            stopPolling();
            comments_edap.addComment(boardId, endDate, listingId, startDate, role);
            addNote({ onError: onError, onLoading: onLoading, onSuccess: onSuccess, text: text });
        };

        _this.onKeyPress = function (e) {
            /* istanbul ignore next */
            if (e.charCode === ENTER_CHAR_CODE) {
                _this.submit(e);
            }
        };

        _this.updateText = function (e) {
            /* istanbul ignore next */
            var text = e.target.value;
            var isOverCharLimit = isOverLimit(text, MAXLENGTH);

            _this.setState({
                disabled: isOverCharLimit,
                text: text
            });

            // Log in splunk so we can see how often this is happening
            /* istanbul ignore next */
            if (isOverCharLimit) {
                logCharLimitError({ message: 'Comment exceeds character limit: ' + text.length });
            }
        };

        _this.state = AddComment.initialState;
        return _this;
    }

    // hook for graphql


    // hook for graphql


    // hook for graphql


    AddComment.prototype.render = function render() {
        var _props = this.props,
            langAddComment = _props.langAddComment,
            langError = _props.langError,
            langPost = _props.langPost;
        var _state = this.state,
            disabled = _state.disabled,
            loading = _state.loading,
            error = _state.error,
            text = _state.text;

        var isValid = !!text.length;
        var buttonClass = isValid ? 'is-valid' : '';
        var errorMsg = error ? langError : null;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'form',
            {
                className: 'add-comment',
                id: 'add-comment-form',
                onSubmit: this.submit
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loading }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(form_char_counter_form_char_counter, {
                autoExpand: true,
                className: 'add-comment__textarea',
                errorMsg: errorMsg,
                id: 'add-comment-input',
                label: langAddComment,
                maxHeight: '169px',
                maxLength: MAXLENGTH,
                onChange: this.updateText,
                onKeyPress: this.onKeyPress,
                value: this.state.text
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'add-comment__buttons ' + buttonClass },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], {
                    disabled: disabled,
                    label: langPost,
                    size: 'xs',
                    type: 'submit'
                })
            )
        );
    };

    return AddComment;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

add_comment_AddComment.defaultProps = {
    stopPolling: function stopPolling() {}
};
add_comment_AddComment.initialState = {
    disabled: false,
    error: null,
    loading: false,
    text: ''
};
/* harmony default export */ var components_add_comment = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, withUser, withTranslationsAsProps({
    'tripboards.add.comment': 'langAddComment',
    'tripboards.error': 'langError',
    'tripboards.post': 'langPost'
}), Object(react_apollo_browser_umd["graphql"])(ADD_NOTE, { props: mutationProps }))(add_comment_AddComment));
// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js + 226 modules
var esm = __webpack_require__("QnUD");

// CONCATENATED MODULE: ./src/universal/tripboard/avatar/avatar-name.js


var getInitial = function getInitial(name) {
    return typeof name === 'string' ? name.charAt(0).toUpperCase() : null;
};

function AvatarName(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName;

    if (!firstName || !firstName.length) {
        return null;
    }
    var lastInitial = getInitial(lastName);
    lastInitial = lastInitial ? lastInitial + '.' : '';
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'strong',
        { className: 'avatar__name' },
        firstName + ' ' + lastInitial
    );
}

function Initials(_ref2) {
    var firstName = _ref2.firstName,
        lastName = _ref2.lastName,
        _ref2$sm = _ref2.sm,
        sm = _ref2$sm === undefined ? false : _ref2$sm;

    var first = getInitial(firstName);
    if (!first) {
        return null;
    }
    if (sm) {
        return first;
    }
    var last = getInitial(lastName);
    return '' + first + (last ? last : '');
}

Initials.defaultProps = {
    sm: false
};

/* harmony default export */ var avatar_name = (AvatarName);
// EXTERNAL MODULE: ./src/universal/tripboard/avatar/avatar.less
var avatar = __webpack_require__("wwwz");
var avatar_default = /*#__PURE__*/__webpack_require__.n(avatar);

// CONCATENATED MODULE: ./src/universal/tripboard/avatar/avatar.js









var DEFAULT_PROFILE_PIC = 'default-profile-pic.png';

var logEmptyProfile = lodash_debounce_default()(log, 500, {
    leading: false,
    trailing: true
});

var hasProfileImage = function hasProfileImage(publicImageUrl) {
    if (typeof publicImageUrl !== 'string' || publicImageUrl === '') {
        return false;
    }
    return publicImageUrl.indexOf(DEFAULT_PROFILE_PIC) === -1;
};

var isProfileEmpty = function isProfileEmpty(firstName) {
    var hasImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return !(firstName && firstName.length) && !hasImage;
};

function Avatar(_ref) {
    var className = _ref.className,
        firstName = _ref.firstName,
        lastName = _ref.lastName,
        _ref$allowEmpty = _ref.allowEmpty,
        allowEmpty = _ref$allowEmpty === undefined ? false : _ref$allowEmpty,
        publicImageUrl = _ref.publicImageUrl,
        _ref$sm = _ref.sm,
        sm = _ref$sm === undefined ? false : _ref$sm;

    var hasImage = hasProfileImage(publicImageUrl);
    var isEmpty = isProfileEmpty(firstName, hasImage);
    var avatarClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
        'avatar': true,
        'avatar__is-empty': isEmpty,
        'avatar__sm': sm
    });

    if (isEmpty && !allowEmpty) {
        return null;
    }

    // Log in splunk so we can see how often this is happening
    /* istanbul ignore next */
    if (isEmpty) {
        logEmptyProfile({ message: 'Empty profile rendered: user profile is empty.' });
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        { className: avatarClass + ' ' + className, style: hasImage ? { backgroundImage: 'url(' + publicImageUrl + ')' } : {}
        },
        isEmpty && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: esm["PERSON__16"] }),
        hasImage ? null : reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Initials, { firstName: firstName, lastName: lastName, sm: sm })
    );
}

Avatar.defaultProps = {
    sm: false
};

/* harmony default export */ var avatar_avatar = (Avatar);
// EXTERNAL MODULE: ./src/universal/tripboard/comments/components/comment.less
var comment = __webpack_require__("+Oa1");
var comment_default = /*#__PURE__*/__webpack_require__.n(comment);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/comment.js
/* istanbul ignore file */
/**
 * @todo Timestamp: https://jira.homeawaycorp.com/browse/SCRATCHPAD-1882
 */





function Comment(_ref) {
    var text = _ref.text,
        user = _ref.user,
        timestamp = _ref.timestamp;

    var firstName = user && user.firstName;
    var lastName = user && user.lastName;
    var publicImageUrl = user && user.publicImageUrl;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'comment' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'comment__row' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(avatar_avatar, {
                allowEmpty: true,
                className: 'comment__avatar',
                firstName: firstName,
                publicImageUrl: publicImageUrl,
                sm: true
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'comment__content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(avatar_name, { firstName: firstName, lastName: lastName }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    { className: 'comment__body' },
                    text
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('br', null),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    { className: 'comment__timestamp' },
                    timestamp
                )
            )
        )
    );
}
// EXTERNAL MODULE: ./src/universal/tripboard/comments/components/user-is-typing.less
var user_is_typing = __webpack_require__("jc71");
var user_is_typing_default = /*#__PURE__*/__webpack_require__.n(user_is_typing);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/user-is-typing.js
/* istanbul ignore file */




function UserIsTyping() {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'user-is-typing' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], null)
    );
}
// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/comments-list.js
var comments_list__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function comments_list__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function comments_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function comments_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function comments_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var hasNewComment = function hasNewComment() {
    var newComments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var oldComments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!Array.isArray(newComments) || !Array.isArray(oldComments)) {
        return false;
    }
    return newComments.length !== oldComments.length;
};

var isMyComment = function isMyComment(newComment) {
    return !!(newComment && newComment.isMine);
};

var comments_list_CommentsList = function (_Component) {
    comments_list__inherits(CommentsList, _Component);

    function CommentsList(props) {
        comments_list__classCallCheck(this, CommentsList);

        var _this = comments_list__possibleConstructorReturn(this, _Component.call(this, props));

        _this.userIsTyping = function () {
            var _this$props = _this.props,
                pollInterval = _this$props.pollInterval,
                startPolling = _this$props.startPolling,
                stopPolling = _this$props.stopPolling;


            stopPolling();
            _this.setState({ isReceivingUserComment: true });

            /* istanbul ignore next */
            _this.timeout = setTimeout(function () {
                startPolling();
                _this.setState({ isReceivingUserComment: false });
            }, pollInterval + 500);
        };

        _this.timeout = null;
        _this.state = {
            isReceivingUserComment: false
        };
        return _this;
    }

    CommentsList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var comments = this.props.comments;

        var newComments = nextProps.comments;

        if (!hasNewComment(newComments, comments)) {
            return;
        }

        if (!isMyComment(newComments[0])) {
            this.userIsTyping();
        }
    };

    /* istanbul ignore next */


    CommentsList.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    };

    // make it look like another user is typing


    CommentsList.prototype.render = function render() {
        var _props = this.props,
            comments = _props.comments,
            loading = _props.loading;
        var isReceivingUserComment = this.state.isReceivingUserComment;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'comments-modal__comments__list ' + (loading ? 'is-loading' : '') },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loading }),
            isReceivingUserComment && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(UserIsTyping, null),
            comments && comments.map(function (props, idx) {
                if (isReceivingUserComment && idx === 0) {
                    return null;
                }

                var author = props.author,
                    uuid = props.uuid,
                    localeCreateTime = props.localeCreateTime,
                    rest = comments_list__objectWithoutProperties(props, ['author', 'uuid', 'localeCreateTime']);

                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Comment, comments_list__extends({ user: author, timestamp: localeCreateTime }, rest, { key: uuid }));
            })
        );
    };

    return CommentsList;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

comments_list_CommentsList.defaultProps = {
    comments: null,
    pollInterval: 1000,
    startPolling: function startPolling() {},
    stopPolling: function stopPolling() {}
};
/* harmony default export */ var comments_list = (comments_list_CommentsList);
// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/comments.js
function comments__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function comments__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function comments__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var comments_Comments = function (_Component) {
    comments__inherits(Comments, _Component);

    function Comments(props) {
        comments__classCallCheck(this, Comments);

        var _this = comments__possibleConstructorReturn(this, _Component.call(this, props));

        _this.stopPolling = function (stopOnlyOnError) {
            var _this$props$data = _this.props.data,
                error = _this$props$data.error,
                stopPolling = _this$props$data.stopPolling;

            if ((!stopOnlyOnError || !!error) && stopPolling) {
                stopPolling();
            }
        };

        _this.startPolling = function () {
            /* istanbul ignore next */
            var data = _this.props.data;
            /* istanbul ignore next */

            setTimeout(function () {
                data.startPolling({ pollInterval: POLL_INTERVAL });
            }, 250);
        };

        return _this;
    }

    Comments.prototype.componentDidUpdate = function componentDidUpdate() {
        this.stopPolling(true);
    };

    Comments.prototype.componentWillUnmount = function componentWillUnmount() {
        this.stopPolling(false);
    };

    Comments.prototype.render = function render() {
        var _props = this.props,
            boardId = _props.boardId,
            _props$data = _props.data,
            error = _props$data.error,
            loading = _props$data.loading,
            stopPolling = _props$data.stopPolling,
            unitNotes = _props$data.localizedUnitNotes,
            endDate = _props.endDate,
            langError = _props.langError,
            listingId = _props.listingId,
            locale = _props.locale,
            startDate = _props.startDate,
            timezone = _props.timezone;


        var comments = unitNotes && unitNotes.unitNotes;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_add_comment, {
                boardId: boardId,
                endDate: endDate,
                listingId: listingId,
                startPolling: this.startPolling,
                stopPolling: stopPolling,
                locale: locale,
                startDate: startDate,
                timezone: timezone
            }),
            error && (!comments || !comments.length) && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'flex flex-space-around text-muted' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-danger', markup: esm["ALERT_WARNING__16"] }),
                langError
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(comments_list, {
                boardId: boardId,
                comments: comments,
                error: error,
                loading: !error && loading,
                listingId: listingId,
                pollInterval: POLL_INTERVAL,
                startPolling: this.startPolling,
                stopPolling: stopPolling
            })
        );
    };

    return Comments;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

comments_Comments.defaultProps = {
    data: {}
};
/* harmony default export */ var components_comments = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(comments_graphql_mapStateToProps), Object(react_apollo_browser_umd["graphql"])(GET_NOTES, { options: pollingOptions }), withTranslationsAsProps({
    'tripboards.error': 'langError'
}))(comments_Comments));
// CONCATENATED MODULE: ./src/universal/tripboard/comments/selectors.js
/* istanbul ignore file */
var getCommentsModalState = function getCommentsModalState(state) {
  return state.tripboard.comments;
};
// EXTERNAL MODULE: ./node_modules/@homeaway/react-determine-if-mobile/lib/transpiled/index.js
var react_determine_if_mobile_lib_transpiled = __webpack_require__("54yA");
var react_determine_if_mobile_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_determine_if_mobile_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-image-carousel/lib/transpiled/index.js
var react_image_carousel_lib_transpiled = __webpack_require__("OEBp");
var react_image_carousel_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_image_carousel_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/a11y-tools/lib/transpiled/index.js
var a11y_tools_lib_transpiled = __webpack_require__("Xmz3");
var a11y_tools_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(a11y_tools_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__16.js
var CHEVRON_RIGHT__16 = __webpack_require__("Jq3D");
var CHEVRON_RIGHT__16_default = /*#__PURE__*/__webpack_require__.n(CHEVRON_RIGHT__16);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/CHEVRON_LEFT__16.js
var CHEVRON_LEFT__16 = __webpack_require__("pAW9");
var CHEVRON_LEFT__16_default = /*#__PURE__*/__webpack_require__.n(CHEVRON_LEFT__16);

// EXTERNAL MODULE: ./src/universal/components/image-carousel/carouselTemplates/CarouselButtonsDesktop/CarouselButtonsDesktop.less
var CarouselButtonsDesktop_CarouselButtonsDesktop = __webpack_require__("9hiw");
var CarouselButtonsDesktop_default = /*#__PURE__*/__webpack_require__.n(CarouselButtonsDesktop_CarouselButtonsDesktop);

// CONCATENATED MODULE: ./src/universal/components/image-carousel/carouselTemplates/CarouselButtonsDesktop/CarouselButtonsDesktop.js
// Third Party Imports






// Artifactory Imports


// Style


var CarouselButtonsDesktop_CarouselButtonsDesktop_CarouselButtonsDesktop = function CarouselButtonsDesktop(_ref) {
    var handlePrev = _ref.handlePrev,
        handleNext = _ref.handleNext,
        _ref$reduceButtonHitT = _ref.reduceButtonHitTarget,
        reduceButtonHitTarget = _ref$reduceButtonHitT === undefined ? false : _ref$reduceButtonHitT;

    var navPrevArrowWrapperClasses = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('carousel-desktop__nav-wrapper carousel-desktop__nav-wrapper--prev', {
        'carousel-desktop__nav-wrapper--reduced': reduceButtonHitTarget
    });
    var navNextArrowWrapperClasses = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('carousel-desktop__nav-wrapper carousel-desktop__nav-wrapper--next', {
        'carousel-desktop__nav-wrapper--reduced': reduceButtonHitTarget
    });

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: navPrevArrowWrapperClasses,
                key: 'carousel__nav-wrapper-0'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIconOverlay"], {
                className: 'carousel-desktop__nav carousel-desktop__nav--prev',
                'aria-label': 'Previous',
                onClick: handlePrev,
                circle: true,
                label: '',
                svgMarkup: CHEVRON_LEFT__16["CHEVRON_LEFT__16"]
            })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: navNextArrowWrapperClasses,
                key: 'carousel__nav-wrapper-1'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIconOverlay"], {
                className: 'carousel-desktop__nav carousel-desktop__nav--next',
                'aria-label': 'Next',
                onClick: handleNext,
                circle: true,
                label: '',
                svgMarkup: CHEVRON_RIGHT__16["CHEVRON_RIGHT__16"]
            })
        )
    );
};

CarouselButtonsDesktop_CarouselButtonsDesktop_CarouselButtonsDesktop.propTypes = {
    handlePrev: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func.isRequired,
    handleNext: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func.isRequired
};

/* harmony default export */ var carouselTemplates_CarouselButtonsDesktop_CarouselButtonsDesktop = (CarouselButtonsDesktop_CarouselButtonsDesktop_CarouselButtonsDesktop);
// EXTERNAL MODULE: ./src/universal/components/image-carousel/carouselTemplates/CarouselButtonsMobile/CarouselButtonsMobile.less
var CarouselButtonsMobile = __webpack_require__("TkRw");
var CarouselButtonsMobile_default = /*#__PURE__*/__webpack_require__.n(CarouselButtonsMobile);

// CONCATENATED MODULE: ./src/universal/components/image-carousel/carouselTemplates/CarouselButtonsMobile/CarouselButtonsMobile.js
// Third Party Imports



// Artifactory Imports



// Style


function CarouselButtonsMobile_CarouselButtonsMobile(_ref) {
    var handlePrev = _ref.handlePrev,
        handleNext = _ref.handleNext;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: 'carousel__nav-wrapper carousel__nav-wrapper--prev carousel__nav-wrapper--reduced',
                key: 'carousel__nav-wrapper-0'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIcon"], {
                className: 'carousel__nav carousel__nav--prev carousel__nav--reduced',
                onClick: handlePrev,
                circle: true,
                label: 'Previous',
                svgMarkup: esm["CHEVRON_LEFT__24"]
            })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: 'carousel__nav-wrapper carousel__nav-wrapper--next carousel__nav-wrapper--reduced',
                key: 'carousel__nav-wrapper-1'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIcon"], {
                className: 'carousel__nav carousel__nav--next carousel__nav--reduced',
                onClick: handleNext,
                circle: true,
                label: 'Next',
                svgMarkup: esm["CHEVRON_RIGHT__24"]
            })
        )
    );
}

CarouselButtonsMobile_CarouselButtonsMobile.propTypes = {
    handlePrev: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func.isRequired,
    handleNext: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func.isRequired
};

/* harmony default export */ var carouselTemplates_CarouselButtonsMobile_CarouselButtonsMobile = (CarouselButtonsMobile_CarouselButtonsMobile);
// EXTERNAL MODULE: ./src/universal/components/image-carousel/carouselTemplates/CarouselPageNumberDesktop/CarouselPageNumberDesktop.less
var CarouselPageNumberDesktop_CarouselPageNumberDesktop = __webpack_require__("ZGEy");
var CarouselPageNumberDesktop_default = /*#__PURE__*/__webpack_require__.n(CarouselPageNumberDesktop_CarouselPageNumberDesktop);

// CONCATENATED MODULE: ./src/universal/components/image-carousel/carouselTemplates/CarouselPageNumberDesktop/CarouselPageNumberDesktop.js
// Third Party Imports




// Style


var CarouselPageNumberDesktop_CarouselPageNumberDesktop_CarouselPageNumberDesktop = function CarouselPageNumberDesktop() {
    return function (_ref) {
        var index = _ref.index,
            images = _ref.images;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'carousel-page-number-desktop' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                react_buttons_lib_transpiled["ButtonOverlay"],
                {
                    className: 'carousel-page-number-desktop__view-fullscreen',
                    label: 'Image ' + (index + 1) + ' of ' + images.length + '.',
                    srOnlyLabel: true,
                    type: 'button',
                    size: 'xs'
                },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'carousel-page-number-desktop__inner-wrapper' },
                    index + 1 + ' / ' + images.length
                )
            )
        );
    };
};

CarouselPageNumberDesktop_CarouselPageNumberDesktop_CarouselPageNumberDesktop.propTypes = {
    index: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number.isRequired,
    images: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.PropTypes.instanceOf(Array).isRequired
};

/* harmony default export */ var carouselTemplates_CarouselPageNumberDesktop_CarouselPageNumberDesktop = (CarouselPageNumberDesktop_CarouselPageNumberDesktop_CarouselPageNumberDesktop);
// EXTERNAL MODULE: ./src/universal/components/image-carousel/image-carousel.less
var image_carousel = __webpack_require__("MpCr");
var image_carousel_default = /*#__PURE__*/__webpack_require__.n(image_carousel);

// CONCATENATED MODULE: ./src/universal/components/image-carousel/image-carousel.js
var image_carousel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function image_carousel__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function image_carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function image_carousel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function image_carousel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var image_carousel_ImageCarouselSlidePlaceholder = function ImageCarouselSlidePlaceholder() {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: true });
};

var trackFocus = new a11y_tools_lib_transpiled["TrackFocus"]();
trackFocus.bindEvents();

var image_carousel_ImageCarousel = function (_Component) {
    image_carousel__inherits(ImageCarousel, _Component);

    function ImageCarousel(props) {
        image_carousel__classCallCheck(this, ImageCarousel);

        var _this = image_carousel__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleNextImage = function (currentIndex, imagesLength) {
            _this.setState({
                index: react_image_carousel_lib_transpiled["CarouselUtil"].getNextIndex(currentIndex, imagesLength)
            });

            _this.props.onCarouselArrowClick('next', _this.state.index);
        };

        _this.handlePreviousImage = function (currentIndex, imagesLength) {
            _this.setState({
                index: react_image_carousel_lib_transpiled["CarouselUtil"].getPrevIndex(currentIndex, imagesLength)
            });

            _this.props.onCarouselArrowClick('back', _this.state.index);
        };

        _this.getRenderedIndices = function () {
            return react_image_carousel_lib_transpiled["CarouselUtil"].getRenderIndices(_this.props.images.length, _this.state.index, 1);
        };

        _this.onImageClick = function () {
            if (_this.props.onCarouselHitClick) {
                _this.props.onCarouselHitClick(_this.state.index, _this.props.images.length);
            }
        };

        _this.renderButtonSet = function () {
            return _this.props.isMobile // eslint-disable-line no-nested-ternary
            ? carouselTemplates_CarouselButtonsMobile_CarouselButtonsMobile : !_this.props.isMobile && _this.props.renderButtonCircle ? carouselTemplates_CarouselButtonsDesktop_CarouselButtonsDesktop : react_image_carousel_lib_transpiled["CarouselButtons"];
        };

        _this.preventEventBubble = function (e) {
            e.preventDefault();
            e.stopPropagation();
        };

        _this.state = { index: 0 };
        return _this;
    }

    // stops event from bubbling through to the anchor tag by default


    ImageCarousel.prototype.render = function render() {
        var _props = this.props,
            images = _props.images,
            renderButtonCircle = _props.renderButtonCircle,
            showPageNumber = _props.showPageNumber,
            slideSize = _props.slideSize;
        // SCRATCHPAD-2439 switching to low res images for DT and Mobile

        var lowResImages = images.filter(function (image) {
            return !!image;
        }).map(function (_ref) {
            var lowResSrc = _ref.src,
                src = _ref.lowResSrc,
                rest = image_carousel__objectWithoutProperties(_ref, ['src', 'lowResSrc']);

            return image_carousel__extends({ src: src, lowResSrc: lowResSrc }, rest);
        });
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: 'image-carousel',
                onClick: this.preventEventBubble,
                onKeyPress: this.preventEventBubble,
                role: 'button',
                tabIndex: '0'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_image_carousel_lib_transpiled["InlineCarouselContainer"], {
                hideBackground: true,
                renderInteractive: true,
                showArrows: true,
                images: lowResImages || [],
                index: this.state.index,
                onImageClick: this.onImageClick,
                onNextImage: this.handleNextImage,
                onPrevImage: this.handlePreviousImage,
                reduceButtonHitTarget: true,
                renderedIndices: this.getRenderedIndices(),
                renderPlaceholder: image_carousel_ImageCarouselSlidePlaceholder,
                overlayColor: '#fff',
                maxOverlayOpacity: renderButtonCircle ? 0.8 : 0,
                slideSize: slideSize,
                showPageNumber: showPageNumber,
                renderButtons: this.renderButtonSet(),
                renderPageNumber: carouselTemplates_CarouselPageNumberDesktop_CarouselPageNumberDesktop(this.onCarouselImageClicked)
            })
        );
    };

    return ImageCarousel;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

image_carousel_ImageCarousel.propTypes = {
    images: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape),
    showPageNumber: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    onCarouselArrowClick: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    onCarouselHitClick: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    renderButtonCircle: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    isMobile: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool
};
image_carousel_ImageCarousel.defaultProps = {
    images: [],
    showPageNumber: false,
    renderButtonCircle: false,
    isMobile: false,
    onCarouselArrowClick: function onCarouselArrowClick() {},
    onCarouselHitClick: function onCarouselHitClick() {}
};
/* harmony default export */ var image_carousel_image_carousel = (image_carousel_ImageCarousel);
// CONCATENATED MODULE: ./src/universal/components/image-carousel/index.js


// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-location.less
var listing_location = __webpack_require__("Jbb1");
var listing_location_default = /*#__PURE__*/__webpack_require__.n(listing_location);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-location.js






function ListingLocation(_ref) {
    var baseLocation = _ref.baseLocation;

    var fullLocation = baseLocation && baseLocation.name && baseLocation.name.full;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'listing-location' },
        fullLocation && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'location-icon', markup: LOCATION__16 }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'location-text' },
            fullLocation
        )
    );
}

ListingLocation.propTypes = {
    baseLocation: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object // eslint-disable-line react/forbid-prop-types
};

/* harmony default export */ var listing_listing_location = (ListingLocation);
// EXTERNAL MODULE: ./node_modules/@homeaway/react-price-summary/lib/transpiled/index.js
var react_price_summary_lib_transpiled = __webpack_require__("gUIY");
var react_price_summary_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_price_summary_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-price.js
function listing_price__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function listing_price__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function listing_price__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LISTING_STATUS = {
    AVAILABLE: 'AVAILABLE',
    DELISTED: 'DELISTED',
    UNAVAILABLE: 'UNAVAILABLE'
};

var listing_price_NoPrice = function NoPrice(_ref) {
    var text = _ref.text;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        { className: 'listing-price__no-price' },
        text
    );
};
var listing_price_UnavailablePrice = function UnavailablePrice(_ref2) {
    var text = _ref2.text;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        { className: 'listing-price__unavailable' },
        text
    );
};

var listing_price_ListingPrice = function (_Component) {
    listing_price__inherits(ListingPrice, _Component);

    function ListingPrice(props) {
        listing_price__classCallCheck(this, ListingPrice);

        return listing_price__possibleConstructorReturn(this, _Component.call(this, props));
    }

    ListingPrice.prototype.componentDidMount = function componentDidMount() {
        /* istanbul ignore next */
        var edapEventJson = this.props.edapEventJson;
        /* istanbul ignore next */

        if (edapEventJson) {
            Object(react_price_summary_lib_transpiled["edapTriggerPriceSummaryDisplay"])({ edapEventJson: edapEventJson });
        }
    };

    ListingPrice.prototype.render = function render() {
        var _props = this.props,
            averagePrice = _props.averagePrice,
            edapEventJson = _props.edapEventJson,
            langAvgNight = _props.langAvgNight,
            langDatesNotAvailable = _props.langDatesNotAvailable,
            langNoPrice = _props.langNoPrice,
            priceSummary = _props.priceSummary,
            status = _props.status,
            stay = _props.stay;

        var formattedAmount = averagePrice && averagePrice.localized || null;
        var pricePeriodDescription = langAvgNight;

        if (status === LISTING_STATUS.DELISTED) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_price_UnavailablePrice, { text: langDatesNotAvailable });
        }

        // dated, so get price from priceSummary
        if (stay) {
            formattedAmount = priceSummary && priceSummary.formattedAmount || formattedAmount;
            pricePeriodDescription = priceSummary && priceSummary.pricePeriodDescription || pricePeriodDescription;
        }

        if (!formattedAmount) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_price_NoPrice, { text: langNoPrice });
        }

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_price_summary_lib_transpiled_default.a, {
            priceSummary: {
                edapEventJson: edapEventJson || '',
                formattedAmount: formattedAmount,
                pricePeriodDescription: pricePeriodDescription
            }
        });
    };

    return ListingPrice;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

listing_price_ListingPrice.defaultProps = {
    averagePrice: null,
    edapEventJson: null,
    langAvgNight: '',
    langDatesNotAvailable: '',
    langNoPrice: '',
    priceSummary: null,
    status: null,
    stay: null
};
var listing_price_allowUndefined = true;
/* harmony default export */ var listing_price = (withTranslationsAsProps({
    'shared.stabHit.rate.average.night.short': 'langAvgNight',
    'shared.stabHit.rate.none': 'langNoPrice',
    'shared.stabHit.dates.not.available': 'langDatesNotAvailable'
}, listing_price_allowUndefined)(listing_price_ListingPrice));
// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("bndy");
var reselect_lib_default = /*#__PURE__*/__webpack_require__.n(reselect_lib);

// CONCATENATED MODULE: ./src/universal/selectors/system.js
/* istanbul ignore file */


var getSystem = function getSystem(state) {
    return state.system;
};

var getFullLocale = Object(reselect_lib["createSelector"])(getSystem, function (system) {
    return system.fullLocale;
});

var getIsMobile = Object(reselect_lib["createSelector"])(getSystem, function (system) {
    return system.isMobile;
});

var getLocale = Object(reselect_lib["createSelector"])(getSystem, function (system) {
    return system.locale;
});

var getSiteName = Object(reselect_lib["createSelector"])(getSystem, function (system) {
    return system.siteName;
});

/* harmony default export */ var selectors_system = ({
    getFullLocale: getFullLocale,
    getIsMobile: getIsMobile,
    getLocale: getLocale,
    getSystem: getSystem,
    getSiteName: getSiteName
});
// EXTERNAL MODULE: ./node_modules/intl-messageformat/index.js
var intl_messageformat = __webpack_require__("plEf");
var intl_messageformat_default = /*#__PURE__*/__webpack_require__.n(intl_messageformat);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-star-rating/lib/transpiled/index.js
var react_star_rating_lib_transpiled = __webpack_require__("W2iw");
var react_star_rating_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_star_rating_lib_transpiled);

// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-reviews.less
var listing_reviews = __webpack_require__("Lgum");
var listing_reviews_default = /*#__PURE__*/__webpack_require__.n(listing_reviews);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-reviews.js









function ListingReviews(_ref) {
    var averageRating = _ref.averageRating,
        langReviews = _ref.langReviews,
        locale = _ref.locale,
        _ref$reviewCount = _ref.reviewCount,
        reviewCount = _ref$reviewCount === undefined ? 0 : _ref$reviewCount;

    // do not show if no reviews
    if (!reviewCount || !averageRating) {
        return null;
    }
    var labelReviews = new intl_messageformat_default.a(langReviews, locale).format({ COUNT: reviewCount });
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        { className: 'listing-reviews flex' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_star_rating_lib_transpiled_default.a, { rating: averageRating }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'listing-reviews__label' },
            labelReviews
        )
    );
}

var listing_reviews_mapStateToProps = function mapStateToProps(state) {
    return { locale: getLocale(state) };
};

/* harmony default export */ var listing_listing_reviews = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'tripboards.reviews.count': 'langReviews'
}), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(listing_reviews_mapStateToProps))(ListingReviews));
// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-rooms.js
/* istanbul ignore file */


function ListingRooms(_ref) {
    var bathrooms = _ref.bathrooms,
        bedrooms = _ref.bedrooms,
        className = _ref.className,
        sleeps = _ref.sleeps;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        { className: 'listing-rooms ' + (className || '') },
        bedrooms + ' \xB7 ' + bathrooms + ' \xB7 ' + sleeps
    );
}

/* harmony default export */ var listing_rooms = (ListingRooms);
// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-pdp-button.less
var listing_pdp_button = __webpack_require__("gYZ2");
var listing_pdp_button_default = /*#__PURE__*/__webpack_require__.n(listing_pdp_button);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-pdp-button.js
/* istanbul ignore file */





function PdpButton(_ref) {
    var detailPageUrl = _ref.detailPageUrl,
        langLabel = _ref.langLabel,
        onClick = _ref.onClick;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
        className: 'listing-pdp-btn',
        href: detailPageUrl,
        label: langLabel,
        onClick: onClick,
        target: '_blank'
    });
}

/* harmony default export */ var listing_listing_pdp_button = (withTranslationsAsProps({
    'tripboards.see.property-details': 'langLabel'
})(PdpButton));
// EXTERNAL MODULE: ./src/universal/tripboard/unavailable-label/components/unavailable-label.less
var unavailable_label = __webpack_require__("yfti");
var unavailable_label_default = /*#__PURE__*/__webpack_require__.n(unavailable_label);

// CONCATENATED MODULE: ./src/universal/tripboard/unavailable-label/components/unavailable-label.js




var unavailable_label_UnavailableLabel = function UnavailableLabel(_ref) {
    var unavailableMessage = _ref.unavailableMessage;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'unavailable-label label label--black' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { title: unavailableMessage, 'aria-label': unavailableMessage, className: 'unavailable-label__message' },
            unavailableMessage
        )
    );
};

/* harmony default export */ var components_unavailable_label = (withTranslationsAsProps({
    'tripboards.error.unavailable': 'unavailableMessage'
})(unavailable_label_UnavailableLabel));
// CONCATENATED MODULE: ./src/universal/tripboard/unavailable-label/index.js


// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-preview.less
var listing_preview = __webpack_require__("uDiQ");
var listing_preview_default = /*#__PURE__*/__webpack_require__.n(listing_preview);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-preview.js
function listing_preview__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function listing_preview__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function listing_preview__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/* istanbul ignore next */

var listing_preview_ListingPreview = function (_Component) {
    listing_preview__inherits(ListingPreview, _Component);

    function ListingPreview(props) {
        listing_preview__classCallCheck(this, ListingPreview);

        var _this = listing_preview__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onCarouselArrowClick = function (direction, index) {
            tripboard_edap.carouselCommentsArrowClick(direction);
            _this.setState({ carouselIndex: index });
        };

        _this.onPdpClick = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                endDate = _this$props.endDate,
                listingId = _this$props.listingId,
                startDate = _this$props.startDate;

            tripboard_edap.viewProperty(boardId, endDate, listingId, startDate, _this.state.carouselIndex, _this.props.images.length);
        };

        _this.state = {
            carouselIndex: 0
        };
        return _this;
    }

    ListingPreview.prototype.render = function render() {
        var _props = this.props,
            availableForDates = _props.availableForDates,
            averagePrice = _props.averagePrice,
            averageRating = _props.averageRating,
            baseLocation = _props.baseLocation,
            bathrooms = _props.bathrooms,
            bedrooms = _props.bedrooms,
            detailPageUrl = _props.detailPageUrl,
            hasCarousel = _props.hasCarousel,
            headline = _props.headline,
            images = _props.images,
            _props$isMobile = _props.isMobile,
            isMobile = _props$isMobile === undefined ? true : _props$isMobile,
            priceSummary = _props.priceSummary,
            reviewCount = _props.reviewCount,
            sleeps = _props.sleeps,
            size = _props.size,
            status = _props.status,
            stay = _props.stay;


        var img = Array.isArray(images) ? images[0] || {} : {};
        var isUnavailable = status === LISTING_STATUS.UNAVAILABLE || stay && !availableForDates;
        var showCarousel = hasCarousel && images.length > 1;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'listing-preview' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'listing-preview__body' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'listing-preview__images' },
                    isUnavailable && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_unavailable_label, null),
                    showCarousel && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(image_carousel_image_carousel, {
                        images: images,
                        isMobile: isMobile,
                        onCarouselArrowClick: this.onCarouselArrowClick,
                        renderButtonCircle: true,
                        showPageNumber: true,
                        slideSize: isMobile ? 'cover' : 'height'
                    }),
                    !showCarousel && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('img', {
                        alt: '',
                        className: 'listing-preview__image ' + (size || ''),
                        src: isMobile ? img.lowResSrc : img.src
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'listing-preview__details' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_location, { baseLocation: baseLocation }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'h3',
                        { className: 'listing-preview__headline' },
                        headline
                    ),
                    isMobile && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'listing-preview__price' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_price, {
                            availableForDates: availableForDates,
                            averagePrice: averagePrice,
                            priceSummary: priceSummary,
                            stay: stay,
                            status: status
                        })
                    ),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'listing-preview__reviews' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_reviews, {
                            averageRating: averageRating,
                            reviewCount: reviewCount
                        })
                    ),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'listing-preview__rooms' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_rooms, {
                            bathrooms: bathrooms,
                            bedrooms: bedrooms,
                            sleeps: sleeps
                        })
                    )
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'listing-preview__footer' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'listing-preview__price-footer' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_price, {
                        availableForDates: availableForDates,
                        averagePrice: averagePrice,
                        priceSummary: priceSummary,
                        stay: stay,
                        status: status
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'listing-preview__pdp-btn-footer' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_pdp_button, {
                        detailPageUrl: detailPageUrl,
                        size: 'sm',
                        onClick: this.onPdpClick
                    })
                )
            )
        );
    };

    return ListingPreview;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var listing_listing_preview = (react_determine_if_mobile_lib_transpiled_default()(listing_preview_ListingPreview));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-modal/lib/esm/index.js + 3 modules
var lib_esm = __webpack_require__("XSjK");

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/edap.js




var TYPES = {
    INVITE: 'invite',
    SHARE: 'share'
};

var voteActionStates = {
    ON: 'on',
    OFF: 'off'
};

var collaborate_edap_named = {
    TRIPBOARDS_VOTE: 'tripboards.vote'
};

var edap_tripboardsVote = function tripboardsVote(actionState, boardId, role, endDate, startDate) {
    var accesstype = edap.getEdapRoleFromRole(role);
    var options = {
        boardid: boardId,
        actionstate: actionState,
        accesstype: accesstype
    };

    if (endDate && startDate) {
        options.eventenddate = endDate;
        options.eventstartdate = startDate;
    }

    edap_trigger('tripboards.vote', options);
};

function getEventLabel(boardId) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TYPES.SHARE;

    var value = edap_getBoardIdListingId(boardId);
    return value + ';type=' + type;
}

function createTrigger(eventaction) {
    return function (boardId, endDate, startDate, type) {
        edap_trigger(GENERIC_EVENT, {
            eventaction: eventaction,
            eventcategory: CATEGORY,
            eventlabel: getEventLabel(boardId, type) + ';' + getDatesLabel(startDate, endDate)
        });
    };
}

function acceptInvite(boardId, endDate, startDate) {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_INVITE_ACCEPT,
        eventcategory: CATEGORY,
        eventlabel: edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
}

function buttonClick(boardId, endDate, startDate) {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COLLABORATE_CLICK,
        eventcategory: CATEGORY,
        eventlabel: edap_getBoardIdListingId(boardId) + ';' + getDatesLabel(startDate, endDate)
    });
}

function invalidInvite(inviteId) {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_INVITE_INVALID,
        eventcategory: CATEGORY,
        eventlabel: 'iid=' + inviteId
    });
}

function expiredInviteModalPop(inviteId, boardId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_EXPIRED_POP,
        eventlabel: 'iid=' + inviteId + ';' + edap_getBoardIdListingId(boardId)
    });
}

function expiredInviteModalClose(inviteId, boardId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_EXPIRED_CLOSE,
        eventlabel: 'iid=' + inviteId + ';' + edap_getBoardIdListingId(boardId)
    });
}

function expiredInvitePublicTripboardViewClick(inviteId, boardId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_EXPIRED_VIEW_TRIPBOARD_CLICK,
        eventlabel: 'iid=' + inviteId + ';' + edap_getBoardIdListingId(boardId)
    });
}

function invalidInviteModalPop(inviteId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_INVALID_POP,
        eventlabel: 'iid=' + inviteId
    });
}

function invalidInviteModalClose(inviteId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_INVALID_CLOSE,
        eventlabel: 'iid=' + inviteId
    });
}

function validInviteModalPop(inviteId, boardId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_MODAL_POP,
        eventlabel: 'iid=' + inviteId + ';bid=' + boardId
    });
}

function validInviteModalClose(inviteId, boardId, closeType) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_MODAL_CLOSE,
        eventlabel: 'iid=' + inviteId + ';bid=' + boardId + ';action=' + closeType
    });
}

function validInviteModalLogin(inviteId, boardId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_MODAL_LOGIN,
        eventlabel: 'iid=' + inviteId + ';bid=' + boardId
    });
}

function votedUp(boardId, endDate, listingId, startDate, role) {
    edap_tripboardsVote(voteActionStates.ON, boardId, role, startDate, endDate);
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTE_UP,
        eventlabel: edap_getBoardIdListingId(boardId, listingId) + ';' + getDatesLabel(startDate, endDate)
    });
}

function votedDown(boardId, endDate, listingId, startDate, role) {
    edap_tripboardsVote(voteActionStates.OFF, boardId, role, startDate, endDate);
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTE_DOWN,
        eventlabel: edap_getBoardIdListingId(boardId, listingId) + ';' + getDatesLabel(startDate, endDate)
    });
}

function votersClose(boardId, listingId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTERS_CLOSE,
        eventlabel: edap_getBoardIdListingId(boardId, listingId)
    });
}

function votersOpen(boardId, listingId) {
    edap_trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTERS_OPEN,
        eventlabel: edap_getBoardIdListingId(boardId, listingId)
    });
}

var edap_copyClick = createTrigger(generic.TRIP_BOARDS_COPY_CLICK);
var edap_copyUrl = createTrigger(generic.TRIP_BOARDS_COPY_URL);
var edap_cutUrl = createTrigger(generic.TRIP_BOARDS_CUT_URL);

/** @todo why is the close event firing twice? */
/* istanbul ignore next */
var debouncedVotersClose = lodash_debounce_default()(votersClose, 250, {
    leading: false,
    trailing: true
});

/* harmony default export */ var collaborate_edap = ({
    acceptInvite: acceptInvite,
    buttonClick: buttonClick,
    copyClick: edap_copyClick,
    copyUrl: edap_copyUrl,
    cutUrl: edap_cutUrl,
    expiredInviteModalPop: expiredInviteModalPop,
    expiredInviteModalClose: expiredInviteModalClose,
    expiredInvitePublicTripboardViewClick: expiredInvitePublicTripboardViewClick,
    invalidInvite: invalidInvite,
    invalidInviteModalPop: invalidInviteModalPop,
    invalidInviteModalClose: invalidInviteModalClose,
    validInviteModalPop: validInviteModalPop,
    validInviteModalClose: validInviteModalClose,
    validInviteModalLogin: validInviteModalLogin,
    votedUp: votedUp,
    votedDown: votedDown,
    votersClose: debouncedVotersClose,
    votersOpen: votersOpen
});
// CONCATENATED MODULE: ./src/universal/tripboard/votes/votes-graphql.js
var votes_graphql__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var votes_graphql__templateObject = votes_graphql__taggedTemplateLiteralLoose(['\n    query unitVotes($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n        unitVotes(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad) {\n            myVote {\n                isMine\n                uuid\n                voter {\n                    firstName\n                    lastName\n                    publicImageUrl\n                }\n            }\n            totalVotes\n            votes {\n                isMine\n                uuid\n                voter {\n                    firstName\n                    lastName\n                    publicImageUrl\n                }\n            }\n        }\n    }\n'], ['\n    query unitVotes($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n        unitVotes(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad) {\n            myVote {\n                isMine\n                uuid\n                voter {\n                    firstName\n                    lastName\n                    publicImageUrl\n                }\n            }\n            totalVotes\n            votes {\n                isMine\n                uuid\n                voter {\n                    firstName\n                    lastName\n                    publicImageUrl\n                }\n            }\n        }\n    }\n']),
    votes_graphql__templateObject2 = votes_graphql__taggedTemplateLiteralLoose(['\n    mutation addOrGetVote($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n        addOrGetVote(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad) {\n            uuid\n            isMine\n            voter {\n                firstName\n                lastName\n                publicImageUrl\n            }\n        }\n    }\n'], ['\n    mutation addOrGetVote($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n        addOrGetVote(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad) {\n            uuid\n            isMine\n            voter {\n                firstName\n                lastName\n                publicImageUrl\n            }\n        }\n    }\n']),
    _templateObject3 = votes_graphql__taggedTemplateLiteralLoose(['\n    mutation removeVoteFromTripBoardUnit($hav: String!, $voteUuid: String!) {\n        removeVoteFromTripBoardUnit(hav: $hav, voteUuid: $voteUuid)\n    }\n'], ['\n    mutation removeVoteFromTripBoardUnit($hav: String!, $voteUuid: String!) {\n        removeVoteFromTripBoardUnit(hav: $hav, voteUuid: $voteUuid)\n    }\n']);

function votes_graphql__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var Voter = {
    firstName: null,
    lastName: null,
    publicImageUrl: null
};

var Vote = {
    isMine: false,
    uuid: null,
    voter: votes_graphql__extends({}, Voter)
};

var GET_VOTES = src_default()(votes_graphql__templateObject);

var ADD_VOTE = src_default()(votes_graphql__templateObject2);

var REMOVE_VOTE = src_default()(_templateObject3);

var getCache = function getCache(proxy, variables) {
    return proxy.readQuery({ query: GET_VOTES, variables: variables }) || {};
};

var queryOptions = function queryOptions(_ref) {
    var hav = _ref.hav,
        listingId = _ref.listingId,
        tripBoardUuid = _ref.tripBoardUuid;

    // eslint-disable-line
    return {
        variables: {
            hav: hav,
            tripBoardUuid: tripBoardUuid,
            unitTriad: listingId
        },
        notifyOnNetworkStatusChange: false,
        errorPolicy: 'all',
        skip: !hav || !listingId || !tripBoardUuid
    };
};

var updateAdd = function updateAdd(proxy, data, variables) {
    var vote = data && data.addOrGetVote;
    var cache = getCache(proxy, variables);
    // were we successful?
    if (vote && cache.unitVotes) {
        cache.unitVotes.myVote = vote;
        cache.unitVotes.totalVotes++;
        cache.unitVotes.votes = cache.unitVotes.votes || [];
        cache.unitVotes.votes.push(vote);
        proxy.writeQuery({ query: GET_VOTES, variables: variables, data: cache });
    }
};

var updateRemove = function updateRemove(proxy, uuid, variables) {
    var cache = getCache(proxy, variables);

    // were we successful?
    if (uuid && cache.unitVotes) {
        cache.unitVotes.myVote = null;
        cache.unitVotes.totalVotes--;
        cache.unitVotes.votes = cache.unitVotes.votes || [];
        cache.unitVotes.votes = cache.unitVotes.votes.filter(function (vote) {
            return vote.uuid !== uuid;
        });
        proxy.writeQuery({ query: GET_VOTES, variables: variables, data: cache });
    }
};

var votes_graphql_voteUp = function voteUp(_ref2) {
    var hav = _ref2.hav,
        unitTriad = _ref2.listingId,
        mutate = _ref2.mutate,
        tripBoardUuid = _ref2.tripBoardUuid,
        endDate = _ref2.endDate,
        startDate = _ref2.startDate,
        role = _ref2.role,
        _ref2$voter = _ref2.voter,
        voter = _ref2$voter === undefined ? {} : _ref2$voter;

    var variables = {
        hav: hav,
        tripBoardUuid: tripBoardUuid,
        unitTriad: unitTriad
    };
    collaborate_edap.votedUp(tripBoardUuid, endDate, unitTriad, startDate, role);
    /* istanbul ignore next */
    mutate({
        variables: variables,
        optimisticResponse: {
            addOrGetVote: {
                uuid: '-1',
                isMine: true,
                voter: votes_graphql__extends({}, voter, {
                    __typename: 'TripBoardUserProfile'
                }),
                __typename: 'Vote'
            }
        },
        /* istanbul ignore next */
        update: function update(proxy, _ref3) {
            var data = _ref3.data;

            /* istanbul ignore next */
            updateAdd(proxy, data, variables);
        }
    });
};

var votes_graphql_voteDown = function voteDown(_ref4) {
    var endDate = _ref4.endDate,
        hav = _ref4.hav,
        unitTriad = _ref4.listingId,
        mutate = _ref4.mutate,
        startDate = _ref4.startDate,
        tripBoardUuid = _ref4.tripBoardUuid,
        uuid = _ref4.uuid,
        role = _ref4.role;

    var variables = {
        hav: hav,
        tripBoardUuid: tripBoardUuid,
        unitTriad: unitTriad
    };

    collaborate_edap.votedDown(tripBoardUuid, endDate, unitTriad, startDate, role);

    /* istanbul ignore next */
    mutate({
        variables: {
            hav: hav,
            voteUuid: uuid
        },
        optimisticResponse: { removeVoteFromTripBoardUnit: true },
        /* istanbul ignore next */
        update: function update(proxy) {
            /* istanbul ignore next */
            updateRemove(proxy, uuid, variables);
        }
    });
};
// EXTERNAL MODULE: ./node_modules/@homeaway/react-tooltip/lib/transpiled/index.js
var react_tooltip_lib_transpiled = __webpack_require__("j6PF");
var react_tooltip_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_tooltip_lib_transpiled);

// EXTERNAL MODULE: ./src/universal/tripboard/avatar/avatar-cluster.less
var avatar_cluster = __webpack_require__("Oelt");
var avatar_cluster_default = /*#__PURE__*/__webpack_require__.n(avatar_cluster);

// CONCATENATED MODULE: ./src/universal/tripboard/avatar/avatar-cluster.js
var avatar_cluster__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var getKey = function getKey(profile, idx) {
    var first = profile && profile.firstName;
    if (first) {
        return first.toLowerCase() + '-' + (idx || 0);
    }
    return '';
};

// handle null profiles + pluck out last 3 profiles and
// display the most recent profile "on top" of the cluster
var sort = function sort() {
    var profiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var filtered = profiles.filter(function (profile) {
        return profile;
    }).reverse();
    filtered.splice(3);
    return filtered.reverse();
};

function AvatarNames(_ref) {
    var profiles = _ref.profiles,
        _ref$showAvatar = _ref.showAvatar,
        showAvatar = _ref$showAvatar === undefined ? false : _ref$showAvatar,
        _ref$sm = _ref.sm,
        sm = _ref$sm === undefined ? false : _ref$sm;

    if (Array.isArray(profiles) && profiles.length) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'ul',
            { className: 'avatar-names' },
            profiles.map(function (profile, idx) {
                // filter out null profiles
                if (!profile || !profile.firstName) {
                    return null;
                }
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'li',
                    { className: 'avatar-names__profile', key: getKey(profile, idx) },
                    showAvatar && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(avatar_avatar, avatar_cluster__extends({}, profile, { sm: sm })),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(avatar_name, profile),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('br', null)
                );
            })
        );
    }
    return null;
}

function AvatarCluster(_ref2) {
    var className = _ref2.className,
        isMobile = _ref2.isMobile,
        onClose = _ref2.onClose,
        onOpen = _ref2.onOpen,
        profiles = _ref2.profiles,
        showAvatar = _ref2.showAvatar,
        sm = _ref2.sm;

    if (Array.isArray(profiles) && profiles.length) {
        var placement = isMobile ? 'top' : 'bottom';
        var trigger = 'click';
        var users = sort(profiles);
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_tooltip_lib_transpiled_default.a,
            {
                content: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(AvatarNames, { profiles: profiles, showAvatar: showAvatar, sm: sm }),
                placement: placement,
                onClose: onClose,
                onOpen: onOpen,
                tooltipType: 'popover',
                trigger: trigger
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'avatar-cluster ' + (className || '') },
                users.map(function (profile, idx) {
                    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(avatar_avatar, avatar_cluster__extends({ key: getKey(profile, idx) }, profile, { sm: sm }));
                })
            )
        );
    }
    return null;
}

AvatarCluster.defaultProps = {
    isMobile: true,
    onClose: function onClose() {},
    onOpen: function onOpen() {},
    profiles: [],
    sm: false
};

/* harmony default export */ var avatar_avatar_cluster = (react_determine_if_mobile_lib_transpiled_default()(AvatarCluster));
// CONCATENATED MODULE: ./src/universal/tripboard/votes/voters.js




var edapHandler = function edapHandler(boardId, listingId, func) {
    return function () {
        func(boardId, listingId);
    };
};

var getVoters = function getVoters() {
    var votes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (!Array.isArray(votes)) {
        return [];
    }
    return votes.filter(function (vote) {
        return vote;
    }).map(function (vote) {
        return vote.voter;
    });
};

var voters_Voters = function Voters(_ref) {
    var listingId = _ref.listingId,
        tripBoardUuid = _ref.tripBoardUuid,
        votes = _ref.votes;

    var profiles = getVoters(votes);
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(avatar_avatar_cluster, {
        className: 'voters',
        onClose: edapHandler(tripBoardUuid, listingId, collaborate_edap.votersClose),
        onOpen: edapHandler(tripBoardUuid, listingId, collaborate_edap.votersOpen),
        profiles: profiles,
        showAvatar: true,
        sm: true
    });
};

voters_Voters.defaultProps = {
    votes: []
};

/* harmony default export */ var voters = (voters_Voters);
// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__("R3sX");
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// CONCATENATED MODULE: ./src/universal/tripboard/votes/vote-button.js
var vote_button__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function vote_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function vote_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function vote_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var plusLocales = ['RU', 'AU', 'GR', 'SC'];

var isPlusLocale = function isPlusLocale() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var isAPlusLocale = false;
    plusLocales.forEach(function (plusLocal) {
        isAPlusLocale = isAPlusLocale || locale.toUpperCase().indexOf(plusLocal) > -1;
    });
    return isAPlusLocale;
};

var vote_button_VoteThumb = function (_Component) {
    vote_button__inherits(VoteThumb, _Component);

    function VoteThumb(props) {
        vote_button__classCallCheck(this, VoteThumb);

        var _this = vote_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.buttonRef = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createRef();
        _this.vote = lodash_throttle_default()(_this.vote, 250);
        return _this;
    }

    VoteThumb.prototype.componentDidMount = function componentDidMount() {
        // onClick via React does not work when rendered inside a google overlay
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.addEventListener('click', this.vote.bind(this));
        }
    };

    VoteThumb.prototype.componentWillUnmount = function componentWillUnmount() {
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.removeEventListener('click', this.vote);
        }
    };

    VoteThumb.prototype.vote = function vote(event) {
        event.stopPropagation();
        if (this.props.isMine) {
            votes_graphql_voteDown(this.props);
        } else {
            votes_graphql_voteUp(this.props);
        }
    };

    VoteThumb.prototype.render = function render() {
        var _props = this.props,
            isMine = _props.isMine,
            label = _props.label,
            _props$showLabel = _props.showLabel,
            showLabel = _props$showLabel === undefined ? false : _props$showLabel,
            markup = _props.markup,
            isSmall = _props.isSmall;

        var className = 'vote';

        var withLabel = showLabel ? 'has-label' : 'no-label';

        if (isMine) {
            className = 'voted';
        }

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'button',
            {
                'aria-label': label,
                className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('btn btn-default btn-xs vote-btn__button vote-btn__button--' + className + ' vote-btn__button--' + withLabel, {
                    'vote-btn--small': isSmall
                }),
                ref: this.buttonRef,
                type: 'button'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'vote-btn__thumb vote-btn__thumb--' + className, markup: markup }),
            showLabel && label
        );
    };

    return VoteThumb;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

vote_button_VoteThumb.defaultProps = vote_button__extends({}, Vote, {
    label: ''
});

/* istanbul ignore next */
var DownThumb = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, Object(react_apollo_browser_umd["graphql"])(REMOVE_VOTE))(vote_button_VoteThumb);

/* istanbul ignore next */
var UpThumb = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, Object(react_apollo_browser_umd["graphql"])(ADD_VOTE))(vote_button_VoteThumb);

var MARKUP_MINE = {
    small: {
        plus: VOTEDPLUS__16,
        thumb: VOTEDTHUMB__16
    },
    notsmall: {
        plus: VOTEDPLUS__32,
        thumb: VOTETHUMB__32
    }
};

var MARKUP_NOT_MINE = {
    small: {
        plus: VOTEPLUS__16,
        thumb: VOTETHUMB__16
    },
    notsmall: {
        plus: VOTEPLUS__32,
        thumb: VOTETHUMB__32
    }
};

var getMarkup = function getMarkup(isSmall, isPlus, isMine) {
    var sizeKey = isSmall ? 'small' : 'notsmall';
    var typeKey = isPlus ? 'plus' : 'thumb';

    return isMine ? MARKUP_MINE[sizeKey][typeKey] : MARKUP_NOT_MINE[sizeKey][typeKey];
};

function VoteButton(_ref) {
    var endDate = _ref.endDate,
        isMine = _ref.isMine,
        langVote = _ref.langVote,
        langVoted = _ref.langVoted,
        locale = _ref.locale,
        listingId = _ref.listingId,
        showLabel = _ref.showLabel,
        startDate = _ref.startDate,
        tripBoardUuid = _ref.tripBoardUuid,
        uuid = _ref.uuid,
        voter = _ref.voter,
        role = _ref.role,
        _ref$isSmall = _ref.isSmall,
        isSmall = _ref$isSmall === undefined ? false : _ref$isSmall;

    var isPlus = isPlusLocale(locale);
    var markup = getMarkup(isSmall, isPlus, isMine);
    var label = langVote;
    var Thumb = UpThumb;

    if (isMine) {
        label = langVoted;
        Thumb = DownThumb;
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'vote-btn' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Thumb, {
            endDate: endDate,
            isMine: isMine,
            label: label,
            listingId: listingId,
            markup: markup,
            showLabel: showLabel,
            startDate: startDate,
            tripBoardUuid: tripBoardUuid,
            uuid: uuid,
            voter: voter,
            isSmall: isSmall,
            role: role
        })
    );
}

VoteButton.defaultProps = vote_button__extends({}, Vote, {
    locale: 'en_US'
});

var vote_button_mapStateToProps = function mapStateToProps(_ref2) {
    var _ref2$system = _ref2.system;
    _ref2$system = _ref2$system === undefined ? {} : _ref2$system;
    var _ref2$system$locale = _ref2$system.locale,
        locale = _ref2$system$locale === undefined ? 'en_US' : _ref2$system$locale;
    return { locale: locale };
};

/* harmony default export */ var vote_button = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withUser, withTranslationsAsProps({
    'tripboards.vote.tooltip': 'langVote',
    'tripboards.voted.tooltip': 'langVoted'
}), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(vote_button_mapStateToProps))(VoteButton));
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js
var index_es = __webpack_require__("Pq8k");

// CONCATENATED MODULE: ./src/universal/tripboard/votes/vote-count.js



var vote_count_VoteCount = function VoteCount(_ref) {
    var _ref$showZero = _ref.showZero,
        showZero = _ref$showZero === undefined ? false : _ref$showZero,
        _ref$sm = _ref.sm,
        sm = _ref$sm === undefined ? false : _ref$sm,
        _ref$totalVotes = _ref.totalVotes,
        totalVotes = _ref$totalVotes === undefined ? 0 : _ref$totalVotes;

    if (totalVotes > 0 || showZero) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'vote-count text-muted ' + (sm ? 'text-sm' : '') },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedMessage"], {
                id: 'tripboards.votes',
                description: 'Number of votes',
                defaultMessage: totalVotes + ' votes',
                values: { votesCount: totalVotes }
            })
        );
    }
    return null;
};

/* harmony default export */ var vote_count = (vote_count_VoteCount);
// EXTERNAL MODULE: ./src/universal/tripboard/votes/votes.less
var votes_votes = __webpack_require__("l69y");
var votes_default = /*#__PURE__*/__webpack_require__.n(votes_votes);

// CONCATENATED MODULE: ./src/universal/tripboard/votes/votes.js
var votes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











// using the unwrapped versions of these components, since
// the Votes component is serving as the interface currently.





function Votes(_ref) {
    var className = _ref.className,
        _ref$data = _ref.data,
        unitVotes = _ref$data.unitVotes,
        loading = _ref$data.loading,
        endDate = _ref.endDate,
        langVote = _ref.langVote,
        langVoted = _ref.langVoted,
        langVotes = _ref.langVotes,
        listingId = _ref.listingId,
        locale = _ref.locale,
        showLabel = _ref.showLabel,
        showVoters = _ref.showVoters,
        startDate = _ref.startDate,
        sm = _ref.sm,
        tripBoardUuid = _ref.tripBoardUuid,
        user = _ref.user,
        _ref$useSmallButton = _ref.useSmallButton,
        useSmallButton = _ref$useSmallButton === undefined ? false : _ref$useSmallButton;

    if (loading || !unitVotes) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'votes ' + className });
    }

    var _ref2 = unitVotes || {},
        _ref2$totalVotes = _ref2.totalVotes,
        totalVotes = _ref2$totalVotes === undefined ? 0 : _ref2$totalVotes,
        _ref2$votes = _ref2.votes,
        votes = _ref2$votes === undefined ? {} : _ref2$votes;

    var myVote = unitVotes.myVote || {};
    var profile = user.profile;

    var role = user && user.role && user.role.type || '';
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'votes ' + className },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(VoteButton, votes__extends({}, myVote, {
            endDate: endDate,
            langVote: langVote,
            langVoted: langVoted,
            locale: locale,
            listingId: listingId,
            showLabel: showLabel,
            startDate: startDate,
            tripBoardUuid: tripBoardUuid,
            voter: profile,
            role: role,
            isSmall: useSmallButton
        })),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'votes__voters-vote-count' },
            showVoters && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(voters, {
                listingId: listingId,
                tripBoardUuid: tripBoardUuid,
                votes: votes
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(vote_count_VoteCount, {
                langVotes: langVotes,
                locale: locale,
                sm: sm,
                totalVotes: totalVotes
            })
        )
    );
}

Votes.defaultProps = {
    className: '',
    data: {},
    locale: 'en_US',
    showLabel: false,
    showVoters: false,
    sm: false,
    user: {}
};

/* harmony default export */ var tripboard_votes_votes = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, withUser, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(vote_button_mapStateToProps), Object(react_apollo_browser_umd["graphql"])(GET_VOTES, { options: queryOptions }), withTranslationsAsProps({
    'tripboards.vote.tooltip': 'langVote',
    'tripboards.voted.tooltip': 'langVoted',
    'tripboards.votes': 'langVotes'
}))(Votes));
// EXTERNAL MODULE: ./src/universal/tripboard/comments/components/comments-modal.less
var comments_modal = __webpack_require__("l7nI");
var comments_modal_default = /*#__PURE__*/__webpack_require__.n(comments_modal);

// CONCATENATED MODULE: ./src/universal/tripboard/comments/components/comments-modal.js
var comments_modal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function comments_modal__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* istanbul ignore file */











var isLarge = function isLarge() {
    return "object" !== 'undefined' && window.innerHeight && window.innerHeight > 1024;
};

function CommentsModal(_ref) {
    var availableForDates = _ref.availableForDates,
        baseLocation = _ref.baseLocation,
        boardId = _ref.boardId,
        detailPageUrl = _ref.detailPageUrl,
        endDate = _ref.endDate,
        hasCarousel = _ref.hasCarousel,
        isOpen = _ref.isOpen,
        listingId = _ref.listingId,
        onClose = _ref.onClose,
        startDate = _ref.startDate,
        rest = comments_modal__objectWithoutProperties(_ref, ['availableForDates', 'baseLocation', 'boardId', 'detailPageUrl', 'endDate', 'hasCarousel', 'isOpen', 'listingId', 'onClose', 'startDate']);

    var isLargeSize = isLarge();
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        lib_esm["default"],
        {
            id: 'comments-modal',
            className: 'comments-modal ' + (isLargeSize ? 'lg' : ''),
            isOpen: isOpen,
            onClose: onClose,
            title: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_pdp_button, {
                boardId: boardId,
                detailPageUrl: detailPageUrl,
                endDate: endDate,
                listingId: listingId,
                size: 'xs',
                startDate: startDate
            })
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'comments-modal__body' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'comments-modal__listing' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_preview, comments_modal__extends({
                    availableForDates: availableForDates,
                    baseLocation: baseLocation,
                    boardId: boardId,
                    detailPageUrl: detailPageUrl,
                    endDate: endDate,
                    hasCarousel: hasCarousel,
                    listingId: listingId,
                    size: isLargeSize ? 'lg' : null,
                    startDate: startDate
                }, rest))
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'comments-modal__comments' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('hr', { className: 'comments-modal__hr comments-modal__hr--votes' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'comments-modal__comments__header' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tripboard_votes_votes, {
                        className: 'comments-modal__votes',
                        endDate: endDate,
                        listingId: listingId,
                        tripBoardUuid: boardId,
                        showLabel: true,
                        showVoters: true,
                        startDate: startDate
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('hr', { className: 'comments-modal__hr' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_comments, {
                    boardId: boardId,
                    endDate: endDate,
                    listingId: listingId,
                    startDate: startDate
                })
            )
        )
    );
}

CommentsModal.defaultProps = {
    onClose: function onClose() {}
};

var comments_modal_mapStateToProps = function mapStateToProps(state) {
    return getCommentsModalState(state);
};

var comments_modal_mapDispatchToProps = {
    onClose: comments_actions.close
};

/* harmony default export */ var components_comments_modal = (Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(comments_modal_mapStateToProps, comments_modal_mapDispatchToProps)(CommentsModal));
// CONCATENATED MODULE: ./src/universal/tripboard/comments/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function reducer__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var reducer_actionHandlers = {};

var reducer_initialState = {
    boardId: null,
    endDate: null,
    images: [],
    isOpen: false,
    listingId: null,
    startDate: null,
    timezone: new Date().toTimeString()
};

reducer_actionHandlers[comments_actions.MODAL_OPEN] = function (state, _ref) {
    var payload = _ref.payload;

    var isOpen = true;

    var boardId = payload.boardId,
        listingId = payload.listingId,
        startDate = payload.startDate,
        endDate = payload.endDate,
        rest = reducer__objectWithoutProperties(payload, ['boardId', 'listingId', 'startDate', 'endDate']);

    return reducer__extends({}, state, {
        boardId: boardId,
        endDate: endDate,
        isOpen: isOpen,
        listingId: listingId,
        startDate: startDate
    }, rest);
};

reducer_actionHandlers[comments_actions.MODAL_CLOSE] = function () {
    return reducer_initialState;
};

/* harmony default export */ var reducer = (utils_createReducer(reducer_actionHandlers, reducer_initialState));
// CONCATENATED MODULE: ./src/universal/tripboard/comments/index.js




// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitAccommodations/HitAccommodations.js



function HitAccommodations(props) {
    var accomodations = [];

    if (props.bedrooms) {
        accomodations.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'li',
            { key: 'bedrooms', className: 'hit-accommodation hit-bedrooms hidden-mini' },
            props.bedrooms
        ));
    }

    if (props.bathrooms) {
        accomodations.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'li',
            { key: 'bathrooms', className: 'hit-accommodation hit-bathrooms hidden-mini' },
            props.bathrooms
        ));
    }

    if (props.sleeps) {
        accomodations.push(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'li',
            { key: 'sleeps', className: 'hit-accommodation hit-sleeps hidden-mini' },
            props.sleeps
        ));
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'ul',
        { className: 'hit-accommodations list-unstyled' },
        accomodations
    );
}

HitAccommodations.propTypes = {
    bathrooms: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    bedrooms: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    sleeps: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitAccommodations_HitAccommodations = (HitAccommodations);
// CONCATENATED MODULE: ./src/universal/abacus/test-exposure-once/index.js
function test_exposure_once__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Ensures the test exposure is fired only once.
 * @example
 * const testExposure = new TestExposureOnce('ha_pulse_test_name');
 * testExposure.trigger();
 */

var test_exposure_once_TestExposureOnce = function TestExposureOnce(experimentName) {
    var _this = this;

    test_exposure_once__classCallCheck(this, TestExposureOnce);

    this.trigger = function () {
        // only log test exposure once
        if (!_this.isLogged) {
            Object(abacus_client_utils_lib_transpiled["evaluateExperimentAndLog"])(_this.name);
            _this.isLogged = true;
        }
    };

    this.isLogged = false;
    this.name = experimentName;
};


// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitRating/HitRating.js




function HitRating(_ref) {
    var averageRating = _ref.averageRating,
        reviewCount = _ref.reviewCount;

    var rating = null;

    if (averageRating && reviewCount > 0) {
        rating = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'ratings-wrapper' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_star_rating_lib_transpiled_default.a, { rating: averageRating }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'span',
                { className: 'review-count' },
                reviewCount
            )
        );
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'hit-ratings hidden-mini' },
        rating
    );
}

HitRating.propTypes = {
    averageRatingClass: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    reviewCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number
};

/* harmony default export */ var HitRating_HitRating = (HitRating);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitPrice/HitPrice.js



// Component to use for error states
var HitPrice_NoPriceLabel = function NoPriceLabel(_ref) {
    var noPrice = _ref.noPrice;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'small',
            { className: 'rate' },
            noPrice
        )
    );
};

// helper function for mapping our legacy prop names to props for <PriceSummary />
var mapHitPricePropsToPriceSummary = function mapHitPricePropsToPriceSummary(_ref2) {
    var rate = _ref2.rate,
        ratesUnitOfMeasure = _ref2.ratesUnitOfMeasure,
        _ref2$edapEventJson = _ref2.edapEventJson,
        edapEventJson = _ref2$edapEventJson === undefined ? '' : _ref2$edapEventJson;
    return {
        formattedAmount: rate,
        pricePeriodDescription: ratesUnitOfMeasure,
        edapEventJson: edapEventJson
    };
};

var isRateless = function isRateless(_ref3) {
    var rate = _ref3.rate,
        ratesUnitOfMeasure = _ref3.ratesUnitOfMeasure;
    return !rate || !ratesUnitOfMeasure;
};

// main component that determines which pricing component to display
var HitPrice_HitPrice = function HitPrice(props) {
    if (isRateless(props)) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitPrice_NoPriceLabel, { noPrice: props.noPrice });
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_price_summary_lib_transpiled_default.a, { priceSummary: mapHitPricePropsToPriceSummary(props) });
};

/* harmony default export */ var HitSubComponents_HitPrice_HitPrice = (HitPrice_HitPrice);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitFooter/HitFooter.js







function HitFooter(props) {
    var arrivalDate = props.arrivalDate,
        _props$averageRating = props.averageRating,
        averageRating = _props$averageRating === undefined ? 0 : _props$averageRating,
        changeSummary = props.changeSummary,
        currencyUnits = props.currencyUnits,
        departureDate = props.departureDate,
        instantBookable = props.instantBookable,
        instantBookableTooltip = props.instantBookableTooltip,
        noPrice = props.noPrice,
        notifyChange = props.notifyChange,
        rate = props.rate,
        ratesUnitOfMeasure = props.ratesUnitOfMeasure,
        edapEventJson = props.edapEventJson,
        reviewCount = props.reviewCount,
        status = props.status,
        unit = props.unit;


    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'card__footer scratchpad-hit-footer' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'price-wrapper' },
            instantBookable && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'price-wrapper__instantBook', title: instantBookableTooltip },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: esm["INSTANT_BOOK__16"] })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitSubComponents_HitPrice_HitPrice, {
                arrivalDate: arrivalDate,
                departureDate: departureDate,
                changeSummary: changeSummary,
                currency: currencyUnits,
                noPrice: noPrice,
                notifyChange: notifyChange,
                rate: rate,
                ratesUnitOfMeasure: ratesUnitOfMeasure,
                edapEventJson: edapEventJson,
                status: status,
                unit: unit
            })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitRating_HitRating, {
            averageRating: averageRating,
            reviewCount: reviewCount
        })
    );
}

HitFooter.propTypes = {
    averageRating: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    changeSummary: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object, /* eslint react/forbid-prop-types: 0 */
    instantBookable: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    instantBookableTooltip: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    noPrice: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    notifyChange: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    rate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    ratesUnitOfMeasure: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    edapEventJson: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    reviewCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    status: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitFooter_HitFooter = (HitFooter);
// CONCATENATED MODULE: ./src/universal/utils/abacus.js



var tests =  true ? window.__ABACUS__ : {};

var abacus_initialize = function initialize() {
    if (window !== 'undefined') {
        // set up abacus experiment cache
        abacus_client_utils_lib_transpiled_default.a.initialize(tests);
        abacus_client_utils_lib_transpiled_default.a.evaluateExperimentAndLog(experiments["HA_PULSE_AA_TEST"]);
    }
};

var isTestOn = function isTestOn() {
    var abacus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var testName = arguments[1];

    return abacus[testName] && abacus[testName].value > 0 || false;
};

/* harmony default export */ var utils_abacus = ({ initialize: abacus_initialize });
// EXTERNAL MODULE: ./src/universal/abacus/swap-reviews-price/hit-footer.less
var hit_footer = __webpack_require__("jJn2");
var hit_footer_default = /*#__PURE__*/__webpack_require__.n(hit_footer);

// CONCATENATED MODULE: ./src/universal/abacus/swap-reviews-price/hit-footer.js








function hit_footer_HitFooter(props) {
    var arrivalDate = props.arrivalDate,
        averageRating = props.averageRating,
        changeSummary = props.changeSummary,
        currencyUnits = props.currencyUnits,
        departureDate = props.departureDate,
        instantBookable = props.instantBookable,
        instantBookableTooltip = props.instantBookableTooltip,
        noPrice = props.noPrice,
        notifyChange = props.notifyChange,
        rate = props.rate,
        ratesUnitOfMeasure = props.ratesUnitOfMeasure,
        edapEventJson = props.edapEventJson,
        reviewCount = props.reviewCount,
        status = props.status,
        unit = props.unit;


    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'card__footer scratchpad-hit-footer card__swap-reviews-price' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitRating_HitRating, {
            averageRating: averageRating,
            reviewCount: reviewCount
        }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'price-wrapper' },
            instantBookable && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'price-wrapper__instantBook', title: instantBookableTooltip },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: esm["INSTANT_BOOK__16"] })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitSubComponents_HitPrice_HitPrice, {
                arrivalDate: arrivalDate,
                departureDate: departureDate,
                changeSummary: changeSummary,
                currency: currencyUnits,
                noPrice: noPrice,
                notifyChange: notifyChange,
                rate: rate,
                ratesUnitOfMeasure: ratesUnitOfMeasure,
                edapEventJson: edapEventJson,
                status: status,
                unit: unit
            })
        )
    );
}

hit_footer_HitFooter.propTypes = {
    averageRating: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    changeSummary: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object, /* eslint react/forbid-prop-types: 0 */
    noPrice: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    notifyChange: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    rate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    ratesUnitOfMeasure: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    edapEventJson: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    reviewCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    status: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var swap_reviews_price_hit_footer = (hit_footer_HitFooter);
// CONCATENATED MODULE: ./src/universal/abacus/abacus-context.js


var AbacusContext = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createContext({});

/* harmony default export */ var abacus_context = (AbacusContext);
// CONCATENATED MODULE: ./src/universal/abacus/with-abacus/with-abacus.js
var with_abacus__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function withAbacus(Component) {
    return function (props) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            abacus_context.Consumer,
            null,
            function (abacus) {
                var newProps = with_abacus__extends({}, props, {
                    abacus: abacus
                });
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Component, newProps);
            }
        );
    };
}
// CONCATENATED MODULE: ./src/universal/abacus/swap-reviews-price/index.js
function swap_reviews_price__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function swap_reviews_price__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function swap_reviews_price__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var testExposure = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_SWAP_REVIEWS_PRICE"]);

var swap_reviews_price_HitFooterContainer = function (_Component) {
    swap_reviews_price__inherits(HitFooterContainer, _Component);

    function HitFooterContainer(props) {
        swap_reviews_price__classCallCheck(this, HitFooterContainer);

        return swap_reviews_price__possibleConstructorReturn(this, _Component.call(this, props));
    }

    HitFooterContainer.prototype.componentDidMount = function componentDidMount() {
        var reviewCount = this.props.reviewCount;

        if (reviewCount > 0) {
            testExposure.trigger(experiments["HA_PULSE_SWAP_REVIEWS_PRICE"]);
        }
    };

    // only update if price changed


    HitFooterContainer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        var props = this.props;
        var rate = nextProps.rate;

        return rate !== props.rate;
    };

    HitFooterContainer.prototype.render = function render() {
        var abacus = this.props.abacus;

        if (isTestOn(abacus, experiments["HA_PULSE_SWAP_REVIEWS_PRICE"])) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(swap_reviews_price_hit_footer, this.props);
        }
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitFooter_HitFooter, this.props);
    };

    return HitFooterContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

swap_reviews_price_HitFooterContainer.defaultProps = {
    abacus: {},
    reviewCount: 0
};
/* harmony default export */ var swap_reviews_price = (withAbacus(swap_reviews_price_HitFooterContainer));
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitHeadline/HitHeadline.js



function HitHeadline(_ref) {
    var headline = _ref.headline;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'h4',
        { className: 'hit-headline hidden-sm hidden-xs hidden-mini hidden-gallery' },
        headline
    );
}

HitHeadline.propTypes = {
    headline: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitHeadline_HitHeadline = (HitHeadline);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitFadedHeadline/HitFadedHeadline.js



function HitFadedHeadline_HitHeadline(_ref) {
    var headline = _ref.headline;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'h4',
        { className: 'hit-faded-headline' },
        headline
    );
}

HitFadedHeadline_HitHeadline.propTypes = {
    headline: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitFadedHeadline = (HitFadedHeadline_HitHeadline);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitDelisted/HitDelisted.js








function HitDelisted(props) {
    var delistedMessage = props.delistedMessage,
        delistedRemove = props.delistedRemove,
        delistedTitle = props.delistedTitle,
        onDelete = props.onDelete,
        siteDisplayName = props.siteDisplayName,
        listingId = props.listingId;


    function handleRemoveClick(event) {
        event.preventDefault();
        onDelete(event, listingId);
        event.stopPropagation();
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'scratchpad-hit-delisted' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'scratchpad-hit-delisted__title' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedMessage"], {
                id: 'greeting.welcome_message',
                defaultMessage: delistedTitle,
                values: { Brand: siteDisplayName }
            })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'scratchpad-hit-delisted__message' },
            delistedMessage
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
            className: 'scratchpad-hit-delisted__remove-button',
            label: delistedRemove,
            onClick: handleRemoveClick,
            size: 'sm'
        })
    );
}

HitDelisted.propTypes = {
    delistedMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    delistedRemove: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    delistedTitle: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    onDelete: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    siteDisplayName: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    listingId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitDelisted_HitDelisted = (withTranslationsAsProps({
    'tripboards.error.delisted.message': 'delistedMessage',
    'tripboards.error.delisted.remove': 'delistedRemove',
    'tripboards.error.delisted.title': 'delistedTitle'
})(HitDelisted));
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitBody/HitBody.js



 // ha_pulse_swap_reviews_price





function HitBody(props) {
    var arrivalDate = props.arrivalDate,
        averageRating = props.averageRating,
        baseLocation = props.baseLocation,
        bathrooms = props.bathrooms,
        bedrooms = props.bedrooms,
        changeSummary = props.changeSummary,
        currencyUnits = props.currencyUnits,
        departureDate = props.departureDate,
        gallery = props.gallery,
        headline = props.headline,
        instantBookable = props.instantBookable,
        instantBookableTooltip = props.instantBookableTooltip,
        onDelete = props.onDelete,
        noPrice = props.noPrice,
        notifyChange = props.notifyChange,
        propertyId = props.propertyId,
        rate = props.rate,
        ratesUnitOfMeasure = props.ratesUnitOfMeasure,
        edapEventJson = props.edapEventJson,
        reviewCount = props.reviewCount,
        reviews = props.reviews,
        sleeps = props.sleeps,
        siteDisplayName = props.siteDisplayName,
        superlative = props.superlative,
        status = props.status,
        showHeadline = props.showHeadline,
        unit = props.unit;

    if (status === 'DELISTED') {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'card__body sp-child-grid-tst2 scratchpad-body component--translucent', style: { 'order': 2 } },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'card__content scratchpad-hit-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitDelisted_HitDelisted, {
                    siteDisplayName: siteDisplayName,
                    onDelete: onDelete
                })
            )
        );
    }
    if (showHeadline && gallery) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'card__body sp-child-grid-tst2 scratchpad-body component--translucent', style: { 'order': 2 } },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'card__content scratchpad-hit-content reduced-padding' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_location, { baseLocation: baseLocation }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitFadedHeadline, { headline: headline })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'card__content scratchpad-hit-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitAccommodations_HitAccommodations, {
                    bathrooms: bathrooms,
                    bedrooms: bedrooms,
                    sleeps: sleeps
                })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(swap_reviews_price, {
                arrivalDate: arrivalDate,
                averageRating: averageRating,
                changeSummary: changeSummary,
                currencyUnits: currencyUnits,
                departureDate: departureDate,
                instantBookable: instantBookable,
                instantBookableTooltip: instantBookableTooltip,
                noPrice: noPrice,
                notifyChange: notifyChange,
                rate: rate,
                ratesUnitOfMeasure: ratesUnitOfMeasure,
                edapEventJson: edapEventJson,
                reviewCount: reviewCount,
                status: status,
                unit: unit
            })
        );
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'card__body scratchpad-body component--translucent' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'card__content scratchpad-hit-content' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitHeadline_HitHeadline, { headline: headline }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitAccommodations_HitAccommodations, {
                bathrooms: bathrooms,
                bedrooms: bedrooms,
                sleeps: sleeps
            })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(swap_reviews_price, {
            averageRating: averageRating,
            changeSummary: changeSummary,
            noPrice: noPrice,
            notifyChange: notifyChange,
            propertyId: propertyId,
            rate: rate,
            ratesUnitOfMeasure: ratesUnitOfMeasure,
            instantBookable: instantBookable,
            instantBookableTooltip: instantBookableTooltip,
            edapEventJson: edapEventJson,
            reviewCount: reviewCount,
            reviews: reviews,
            superlative: superlative,
            status: status
        })
    );
}

HitBody.propTypes = {
    averageRating: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    bathrooms: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    changeSummary: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object, /* eslint react/forbid-prop-types: 0 */
    bedrooms: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    headline: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    instantBookable: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    instantBookableMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    instantBookableTooltip: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    miniHit: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    multiUnitProperty: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    multiUnitPropertyMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    noPrice: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    notifyChange: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    popularBadge: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    popularText: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    rate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    ratesUnitOfMeasure: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    edapEventJson: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    reviewCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    sleeps: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    status: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired
};

/* harmony default export */ var HitBody_HitBody = (HitBody);
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitDeleteButton/HitDeleteButton.js



function HitDeleteButton(_ref) {
    var onDelete = _ref.onDelete,
        scratchpadId = _ref.scratchpadId,
        deleteText = _ref.deleteText;

    if (!onDelete) {
        return null;
    }

    function onClick(event) {
        event.preventDefault();
        onDelete(event, scratchpadId);
        event.stopPropagation();
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'button',
        {
            'aria-label': deleteText,
            className: 'scratchpad-hit-close card__close hidden-mini',
            onClick: onClick,
            'data-wdio': 'tripboard-details__listing--delete'
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'svg',
            { className: 'inline-svg', viewBox: '-28 -14 50 50' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { d: 'M-3 35.4c-13.4 0-24.4-11-24.4-24.4 0-13.4 11-24.4 24.4-24.4 13.4 0 24.4 11 24.4 24.4 0 13.4-11 24.4-24.4 24.4zM-3-11c-12.2 0-22 9.8-22 22s9.8 22 22 22 22-9.8 22-22S9.3-11-3-11z' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { d: 'M-11.2 1.2l18 18L5.4 21l-18-18.2z' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'g',
                null,
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { d: 'M5.2 1.2l1.6 1.6-18 18-1.7-1.5z' })
            )
        )
    );
}

HitDeleteButton.propTypes = {
    onDelete: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    scratchpadId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var HitDeleteButton_HitDeleteButton = (HitDeleteButton);
// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/HEART_SELECTED__16.js
var HEART_SELECTED__16 = __webpack_require__("OFFT");
var HEART_SELECTED__16_default = /*#__PURE__*/__webpack_require__.n(HEART_SELECTED__16);

// CONCATENATED MODULE: ./src/universal/tripboard/listing-delete-modal/actions.js
var listing_delete_modal_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var actions_NAMESPACE = 'DELETE_LISTING';
var listing_delete_modal_actions_ACTIONS = {
    MODAL_CLOSE: actions_NAMESPACE + '_MODAL_CLOSE',
    MODAL_OPEN: actions_NAMESPACE + '_MODAL_OPEN'
};

/* istanbul ignore next */
var listing_delete_modal_actions_ACTION_CREATORS = {
    close: function close() {
        return { type: listing_delete_modal_actions_ACTIONS.MODAL_CLOSE };
    },
    open: function open(_ref) {
        var boardId = _ref.boardId,
            hitTotal = _ref.hitTotal,
            idx = _ref.idx,
            listingId = _ref.listingId;
        return {
            type: listing_delete_modal_actions_ACTIONS.MODAL_OPEN,
            payload: { boardId: boardId, hitTotal: hitTotal, idx: idx, listingId: listingId }
        };
    }
};

/* harmony default export */ var listing_delete_modal_actions = (listing_delete_modal_actions__extends({}, listing_delete_modal_actions_ACTIONS, listing_delete_modal_actions_ACTION_CREATORS));
// EXTERNAL MODULE: ./src/universal/components/Hit/HitSubComponents/HeartDeleteButton/HeartDeleteButton.less
var HeartDeleteButton = __webpack_require__("9Zlg");
var HeartDeleteButton_default = /*#__PURE__*/__webpack_require__.n(HeartDeleteButton);

// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HeartDeleteButton/HeartDeleteButton.js








function HeartDeleteButton_HeartDeleteButton(_ref) {
    var idx = _ref.idx,
        hitTotal = _ref.hitTotal,
        listingId = _ref.listingId,
        boardId = _ref.boardId,
        open = _ref.open,
        deleteText = _ref.deleteText;

    function handleModalOpen(event) {
        event.preventDefault();
        tripboard_edap.listingDeleteModalOpen(boardId, listingId);
        tripboard_edap.heartClicked(boardId, 'off');
        open({ boardId: boardId, hitTotal: hitTotal, idx: idx, listingId: listingId });
        event.stopPropagation();
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        {
            'aria-label': deleteText,
            role: 'button',
            className: 'heart-delete-button card__close hidden-mini',
            onClick: handleModalOpen,
            onKeyPress: handleModalOpen,
            'data-wdio': 'tripboard-details__listing--delete',
            tabIndex: '0'
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'heart-delete-button__circle' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-danger', inlineFlex: true, markup: HEART_SELECTED__16["HEART_SELECTED__16"] })
        )
    );
}

HeartDeleteButton_HeartDeleteButton.defaultProps = {
    open: function open() {}
};

var HeartDeleteButton_mapDispatchToProps = {
    open: listing_delete_modal_actions.open
};

/* harmony default export */ var HitSubComponents_HeartDeleteButton_HeartDeleteButton = (Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(null, HeartDeleteButton_mapDispatchToProps)(HeartDeleteButton_HeartDeleteButton));
// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/HitSpecialOffer/HitSpecialOffer.js



function HitSpecialOffer(_ref) {
    var specialOffer = _ref.specialOffer;

    if (!specialOffer) {
        return null;
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'special-offer hidden-mini hidden-gallery component--translucent' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('i', { 'aria-hidden': true, className: 'icon-tag icon-white' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'label-special-offer text-uppercase' },
            specialOffer.message
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'content-special-offer' },
            specialOffer.title
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'special-offer-dates' },
            specialOffer.formattedDate
        )
    );
}

HitSpecialOffer.propTypes = {
    specialOffer: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
        formattedDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
        message: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
        title: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired
    })
};

/* harmony default export */ var HitSpecialOffer_HitSpecialOffer = (HitSpecialOffer);
// CONCATENATED MODULE: ./src/universal/components/permissions/permissions.js



/**
 * Show/hide components based on role permissions. Default
 * behavior is to show an element if the role matches. There
 * is also an `inverse` option, which does the opposite. Do not
 * show an element if the role matches.
 *
 * @example
 * // Show edit button for owners and collaborators
 * <Permissions role={ROLES.OWNER} owner collaborator/>
 *  <button>{'edit'}</button>
 * </Permissions>
 *
 * // Do NOT show edit button for viewers
 * <Permissions role={ROLES.VIEWER} inverse viewer/>
 *  <button>{'edit'}</button>
 * </Permissions>
 */
function Permissions(_ref) {
    var children = _ref.children,
        collaborator = _ref.collaborator,
        owner = _ref.owner,
        role = _ref.role,
        viewer = _ref.viewer,
        inverse = _ref.inverse;

    if (collaborator && role === ROLES.COLLABORATOR || owner && role === ROLES.OWNER || viewer && role === ROLES.VIEWER) {
        if (inverse) {
            return null;
        }
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            children
        );
    }
    if (inverse) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            children
        );
    }
    return null;
}

Permissions.defaultProps = {
    collaborator: false,
    owner: false,
    viewer: false,
    inverse: false
};

/* harmony default export */ var permissions = (Permissions);
// CONCATENATED MODULE: ./src/universal/components/permissions/index.js

/* harmony default export */ var components_permissions = (permissions);
// EXTERNAL MODULE: ./src/universal/components/Hit/HitSubComponents/TripboardButtonContainer/TripboardButtonContainer.less
var TripboardButtonContainer = __webpack_require__("SSMt");
var TripboardButtonContainer_default = /*#__PURE__*/__webpack_require__.n(TripboardButtonContainer);

// CONCATENATED MODULE: ./src/universal/components/Hit/HitSubComponents/TripboardButtonContainer/TripboardButtonContainer.js
function TripboardButtonContainer__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










function TripboardButtonContainer_mapStateToProps(state) {
    return {
        position: 'right-auto',
        siteName: getSiteName(state)
    };
}

function TripboardButtonContainer_TripboardButtonContainer(_ref) {
    var onClick = _ref.onClick,
        rest = TripboardButtonContainer__objectWithoutProperties(_ref, ['onClick']);

    /* eslint-disable jsx-a11y/interactive-supports-focus */
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'tripboard-button-wrapper', onClick: onClick, onKeyPress: onClick, role: 'button' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(transpiled_default.a, rest)
    );
}

TripboardButtonContainer_TripboardButtonContainer.defaultProps = {
    onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
    }
};

/* harmony default export */ var HitSubComponents_TripboardButtonContainer_TripboardButtonContainer = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withAbacus, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(TripboardButtonContainer_mapStateToProps))(TripboardButtonContainer_TripboardButtonContainer));
// EXTERNAL MODULE: ./src/universal/components/Hit/Hit.less
var Hit = __webpack_require__("kR2y");
var Hit_default = /*#__PURE__*/__webpack_require__.n(Hit);

// CONCATENATED MODULE: ./src/universal/components/Hit/Hit.js














var HitThumbnails = __webpack_require__("72mj").default;









var logDelisted = lodash_debounce_default()(log, 500, {
    leading: false,
    trailing: true
});

function Hit_Hit(props) {
    var addedTime = props.addedTime,
        arrivalDate = props.arrivalDate,
        availableForDates = props.availableForDates,
        averagePrice = props.averagePrice,
        averageRating = props.averageRating,
        baseLocation = props.baseLocation,
        bathrooms = props.bathrooms,
        bedrooms = props.bedrooms,
        boardId = props.boardId,
        changeSummary = props.changeSummary,
        detailPageUrl = props.detailPageUrl,
        departureDate = props.departureDate,
        gallery = props.gallery,
        galleryUrl = props.galleryUrl,
        hasCarousel = props.hasCarousel,
        headline = props.headline,
        hitTotal = props.hitTotal,
        idx = props.idx,
        images = props.images,
        instantBookable = props.instantBookable,
        instantBookableMessage = props.instantBookableMessage,
        instantBookableTooltip = props.instantBookableTooltip,
        isDated = props.isDated,
        isMobile = props.isMobile,
        listingId = props.listingId,
        miniHit = props.miniHit,
        minStay = props.minStay,
        multiUnitProperty = props.multiUnitProperty,
        multiUnitPropertyMessage = props.multiUnitPropertyMessage,
        noPrice = props.noPrice,
        notifyChange = props.notifyChange,
        onClick = props.onClick,
        onDelete = props.onDelete,
        popularBadge = props.popularBadge,
        popularText = props.popularText,
        propertyId = props.propertyId,
        rate = props.rate,
        rateUnits = props.rateUnits,
        recoHit = props.recoHit,
        edapEventJson = props.edapEventJson,
        reviewCount = props.reviewCount,
        reviews = props.reviews,
        role = props.role,
        priceSummary = props.priceSummary,
        scratchpadId = props.scratchpadId,
        siteDisplayName = props.siteDisplayName,
        sleeps = props.sleeps,
        specialOffer = props.specialOffer,
        spu = props.spu,
        status = props.status,
        superlative = props.superlative,
        showHeadline = props.showHeadline,
        stay = props.stay,
        thumbnailUrl1 = props.thumbnailUrl1,
        thumbnailUrl2 = props.thumbnailUrl2,
        thumbnailUrl3 = props.thumbnailUrl3,
        translations = props.translations,
        hasDeleteButton = props.hasDeleteButton,
        hasTripboardButton = props.hasTripboardButton,
        isHeartRemoveTestOn = props.isHeartRemoveTestOn,
        unit = props.unit,
        tripBoardUuid = props.tripBoardUuid;


    var ratesUnitOfMeasure = isDated ? translations.perNight : translations.avgNight;

    if (recoHit) {
        ratesUnitOfMeasure = rateUnits;
    }

    var delisted = status === 'DELISTED';
    var unavailable = status === 'UNAVAILABLE';

    if (delisted) {
        logDelisted({ message: 'Delisted hit shown. ListingId: ' + scratchpadId });
    }

    var wrapperClassName = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('scratchpad-hit-wrapper', {
        'has-special': !!specialOffer && !miniHit && !gallery,
        'scratchpad-hit-wrapper-gallery': gallery,
        'scratchpad-hit-wrapper-mini': miniHit,
        'scratchpad-hit-wrapper-reco': recoHit,
        'dates-unavailable': unavailable,
        'is-delisted': delisted
    });

    var mainClassName = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('card', 'hit-scratchpad', 'hit-child-grid', 'listing-spu-' + spu, 'preview-listing-' + spu, 'hit-has-collaborate', 'hit-scratchpad__collaborate', {
        'hit-scratchpad-gallery card--xs': gallery,
        'hit-scratchpad-mini card--xxs': miniHit,
        'hit-scratchpad-reco card--xxs': recoHit,
        'card--no-scale': true
    });

    var target = isMobile ? '_self' : '_blank';

    function onHitClick() {
        if (onClick && !delisted) {
            // if price summary edapEventJson is available then log a "price.summary.display"
            if (edapEventJson) {
                var options = { delayProcessing: true };
                Object(react_price_summary_lib_transpiled["edapTriggerPriceSummaryDisplay"])({ edapEventJson: edapEventJson }, options);
            }

            onClick(isMobile);
        }
    }

    function onCarouselArrowClick(direction) {
        tripboard_edap.carouselHitArrowClick(direction);
    }

    function onCarouselHitClick(position, total) {
        tripboard_edap.carouselHitClick(position, total);
        onHitClick();
        if (!delisted) {
            window.open(detailPageUrl, target);
        }
    }

    var showCarousel = hasCarousel && images.length > 1;

    var body = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitBody_HitBody, {
        arrivalDate: arrivalDate,
        averageRating: averageRating,
        baseLocation: baseLocation,
        bathrooms: bathrooms,
        bedrooms: bedrooms,
        changeSummary: changeSummary,
        currencyUnits: averagePrice && averagePrice.currencyUnits,
        departureDate: departureDate,
        detailPageUrl: detailPageUrl,
        gallery: gallery,
        headline: headline,
        instantBookable: instantBookable,
        instantBookableMessage: instantBookableMessage,
        instantBookableTooltip: instantBookableTooltip,
        miniHit: miniHit,
        minStay: minStay,
        multiUnitProperty: multiUnitProperty,
        multiUnitPropertyMessage: multiUnitPropertyMessage,
        noPrice: noPrice,
        notifyChange: notifyChange,
        onDelete: onDelete,
        popularBadge: popularBadge,
        popularText: popularText,
        propertyId: propertyId,
        rate: rate,
        recoHit: recoHit,
        ratesUnitOfMeasure: ratesUnitOfMeasure,
        edapEventJson: edapEventJson,
        reviewCount: reviewCount,
        reviews: reviews,
        scratchpadId: scratchpadId,
        sleeps: sleeps,
        siteDisplayName: siteDisplayName,
        specialOffer: specialOffer,
        status: status,
        superlative: superlative,
        showHeadline: showHeadline,
        unit: unit
    });
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: wrapperClassName },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: mainClassName },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'a',
                {
                    className: 'hit-wrapper-link',
                    'data-spu': spu,
                    target: target,
                    href: delisted ? null : detailPageUrl,
                    onClick: onHitClick,
                    'data-wdio': 'tripboard-details__listing'
                },
                unavailable && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_unavailable_label, null),
                hasDeleteButton && !isHeartRemoveTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitDeleteButton_HitDeleteButton, {
                    onDelete: onDelete,
                    scratchpadId: scratchpadId,
                    deleteText: translations.deleteText
                }),
                hasDeleteButton && isHeartRemoveTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitSubComponents_HeartDeleteButton_HeartDeleteButton, {
                    deleteText: translations.deleteText,
                    idx: idx,
                    hitTotal: hitTotal,
                    listingId: scratchpadId,
                    boardId: boardId
                }),
                hasTripboardButton && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitSubComponents_TripboardButtonContainer_TripboardButtonContainer, {
                    headline: headline,
                    listingId: scratchpadId,
                    rating: averageRating,
                    reviewCount: reviewCount,
                    thumbnailUrl: thumbnailUrl1
                }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'scratchpad-hit-inner-wrapper' },
                    (!showCarousel || delisted) && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitThumbnails, {
                        addedTime: addedTime,
                        gallery: gallery,
                        galleryUrl: galleryUrl,
                        miniHit: miniHit,
                        recoHit: recoHit,
                        spu: spu,
                        thumbnailUrl1: thumbnailUrl1,
                        thumbnailUrl2: thumbnailUrl2 || thumbnailUrl1,
                        thumbnailUrl3: thumbnailUrl3 || thumbnailUrl1
                    }),
                    showCarousel && !delisted && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(image_carousel_image_carousel, {
                        images: images,
                        isMobile: isMobile,
                        onCarouselArrowClick: onCarouselArrowClick,
                        onCarouselHitClick: onCarouselHitClick,
                        slideSize: 'cover'
                    }),
                    body
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                logged_in,
                null,
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    components_permissions,
                    { role: role, owner: true, collaborator: true },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'flex flex-space-between hit-collaborate' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tripboard_votes_votes, {
                            className: 'hit-votes',
                            endDate: departureDate,
                            listingId: listingId,
                            startDate: arrivalDate,
                            tripBoardUuid: tripBoardUuid,
                            sm: true
                        }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_comments_icon, {
                            availableForDates: availableForDates,
                            averagePrice: averagePrice,
                            averageRating: averageRating,
                            baseLocation: baseLocation,
                            bathrooms: bathrooms,
                            bedrooms: bedrooms,
                            boardId: boardId,
                            className: 'hit-comments-icon',
                            detailPageUrl: detailPageUrl,
                            endDate: departureDate,
                            hasCarousel: hasCarousel,
                            headline: headline,
                            images: images,
                            instantBookable: instantBookable,
                            listingId: listingId,
                            priceSummary: priceSummary,
                            reviewCount: reviewCount,
                            sleeps: sleeps,
                            startDate: arrivalDate,
                            status: status,
                            stay: stay
                        })
                    )
                )
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitSpecialOffer_HitSpecialOffer, { specialOffer: specialOffer })
    );
}

Hit_Hit.propTypes = {
    addedTime: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    averageRating: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    bathrooms: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    bedrooms: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    changeSummary: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object /* eslint react/forbid-prop-types: 0 */
    , dateNotAvailable: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    detailPageUrl: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    gallery: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    galleryUrl: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    hasCarousel: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    headline: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    images: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
        c6_uri: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        c10_uri: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
    })),
    instantBookable: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    instantBookableMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    instantBookableTooltip: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    isDated: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    miniHit: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    minStay: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    multiUnitProperty: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    multiUnitPropertyMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    noPrice: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    notifyChange: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    onClick: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    onDelete: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    popularBadge: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    popularText: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    propertyId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    rate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    ratesUnitOfMeasure: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    recoHit: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    edapEventJson: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    reviewCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    reviews: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    role: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    scratchpadId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    sleeps: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    specialOffer: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
        formattedDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
        message: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
        title: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired
    }),
    spu: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    status: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    superlative: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    showHeadline: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    thumbnailUrl1: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    thumbnailUrl2: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    thumbnailUrl3: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    translations: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object,
    votes: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
        voteCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
        voteUuid: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        isMine: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool
    }),
    hasDeleteButton: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    hasTripboardButton: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool
};

Hit_Hit.defaultProps = {
    gallery: false,
    galleryUrl: 'https://csvcus.homeaway.com/rsrcs/cdn-logos/2.6.1/bce/brand/misc/property-image-placeholder.svg',
    hasCarousel: false,
    headline: '',
    images: [],
    isDated: false,
    onClick: function onClick() {},
    miniHit: false,
    recoHit: false,
    role: ROLES.VIEWER,
    showHeadline: false,
    smallImageTestValue: 0,
    spu: '',
    translations: {},
    hasDeleteButton: true,
    hasTripboardButton: false
};

/* harmony default export */ var components_Hit_Hit = (react_determine_if_mobile_lib_transpiled_default()(Hit_Hit));
// CONCATENATED MODULE: ./src/universal/selectors/translations.js


var getTranslations = function getTranslations(state) {
    return state.translations;
};

/** @todo Put remaining hit translations here so that they are no longer pulled from the API response */
var getHitTranslations = Object(reselect_lib["createSelector"])(getTranslations, function (translations) {
    return {
        avgNight: translations['header.scratchpadSummary.listingsSummary.presentation.ratesUnitOfMeasure.averagePerNight'],
        perNight: translations['header.scratchpadSummary.listingsSummary.presentation.ratesUnitOfMeasure.perNight'],
        deleteText: translations['th.button.delete']
    };
});


// CONCATENATED MODULE: ./src/universal/selectors/index.js




// CONCATENATED MODULE: ./src/universal/components/Hit/hit-container.js




function hit_container_mapStateToProps(state) {
    return {
        translations: getHitTranslations(state)
    };
}

/* harmony default export */ var hit_container = (Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(hit_container_mapStateToProps)(components_Hit_Hit));
// CONCATENATED MODULE: ./src/universal/components/Hit/index.js



/* harmony default export */ var components_Hit = (hit_container);

// CONCATENATED MODULE: ./src/universal/recent-activity/components/recent-activity-hit.js
var recent_activity_hit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function recent_activity_hit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function recent_activity_hit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function recent_activity_hit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var recent_activity_hit_RecentActivityHit = function (_Component) {
    recent_activity_hit__inherits(RecentActivityHit, _Component);

    function RecentActivityHit(props) {
        recent_activity_hit__classCallCheck(this, RecentActivityHit);

        // set an artificially high initial state so that edap event doesn't fire until resize handler is done calculating
        var _this = recent_activity_hit__possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {
            if (true) {
                window.addEventListener('resize', _this.debounceWindowResize);
                _this.handleWindowResize();
            }
        };

        _this.componentWillUnmount = function () {
            if (true) {
                window.removeEventListener('resize', _this.debounceWindowResize);
            }
        };

        _this.handleWindowResize = function () {
            var hitHeight = -_this.waypointContainer.clientHeight;
            _this.setState({ hitHeight: hitHeight });
        };

        _this.setContainer = function (container) {
            _this.waypointContainer = container;
        };

        _this.handleDelete = function (event) {
            var _this$props = _this.props,
                handleDeletePropertyClick = _this$props.handleDeletePropertyClick,
                hit = _this$props.hit,
                scratchpadId = _this$props.scratchpadId;

            event.stopPropagation();
            handleDeletePropertyClick(hit.listingId, scratchpadId);
        };

        _this.handleEnter = function () {
            var _this$props2 = _this.props,
                onWaypointEnter = _this$props2.onWaypointEnter,
                scratchpadId = _this$props2.scratchpadId,
                index = _this$props2.index,
                hits = _this$props2.hits;


            onWaypointEnter(scratchpadId, index, hits);
        };

        _this.state = {
            hitHeight: -5000
        };

        _this.debounceWindowResize = lodash_throttle_default()(_this.handleWindowResize.bind(_this), 100, {
            leading: true,
            trailing: true
        });
        return _this;
    }

    RecentActivityHit.prototype.render = function render() {
        var _props = this.props,
            addedTime = _props.addedTime,
            changeSummary = _props.changeSummary,
            hit = _props.hit,
            isDated = _props.isDated,
            notifyChange = _props.notifyChange,
            presentation = _props.presentation,
            scratchpadId = _props.scratchpadId,
            recentActivityDetails = _props.recentActivityDetails;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'scratchpad-app-hit-wrapper', ref: this.setContainer },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                lib_transpiled["Waypoint"],
                {
                    key: scratchpadId,
                    label: scratchpadId,
                    onEnter: notifyChange ? this.handleEnter : function () {},
                    threshold: this.state.hitHeight
                },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'text-muted small scratchpad-child-grid-hit-time' },
                    addedTime
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_Hit, recent_activity_hit__extends({}, hit, presentation, {
                    unit: hit && hit.unitUuid,
                    arrivalDate: recentActivityDetails && recentActivityDetails.startDate,
                    departureDate: recentActivityDetails && recentActivityDetails.endDate,
                    changeSummary: changeSummary,
                    notifyChange: notifyChange,
                    isDated: isDated,
                    gallery: true,
                    showHeadline: true,
                    onDelete: this.handleDelete
                }))
            )
        );
    };

    return RecentActivityHit;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

recent_activity_hit_RecentActivityHit.propTypes = {
    addedTime: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    endDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    hits: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({})),
    index: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    notifyChange: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    scratchpadId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    startDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};

/* harmony default export */ var recent_activity_hit = (recent_activity_hit_RecentActivityHit);
// CONCATENATED MODULE: ./src/universal/utils/images.js
var C1 = 'c1';
var C2 = 'c2';
var C3 = 'c3';
var C4 = 'c4';
var C5 = 'c5';
var C6 = 'c6'; // mobile
var C7 = 'c7';
var C8 = 'c8';
var C9 = 'c9'; // desktop
var C10 = 'c10';

var SIZES = [C1, C2, C3, C4, C5, C6, C7, C8, C9, C10];

var isValidSize = function isValidSize(suffix) {
    return SIZES.indexOf(suffix) !== -1;
};

var _getImageUrl = function _getImageUrl(imgUrl, size) {
    var parts = imgUrl.split('.');
    var suffix = parts[parts.length - 2];

    if (isValidSize(suffix) && isValidSize(size)) {
        suffix = size;
        parts[parts.length - 2] = suffix;
        imgUrl = parts.join('.');
    }

    return imgUrl;
};

/**
 * @param {string} imgUrl - image url from odis
 * @param {string} size
 * @returns {string} new image url for specified size
 */
var getImageUrl = function getImageUrl(imgUrl) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : C6;

    if (!imgUrl || !imgUrl.length) {
        return null;
    }

    return _getImageUrl(imgUrl, size);
};
// CONCATENATED MODULE: ./src/universal/recent-activity/selectors.js



var getRecentActivityDetails = function getRecentActivityDetails(state, linkId) {
    var scratchpad = state.recentActivity && state.recentActivity.summaries && state.recentActivity.summaries.find(function (summary) {
        return summary.linkId === linkId;
    });

    if (scratchpad) {
        scratchpad.isDated = !!(scratchpad.arrivalDate && scratchpad.departureDate);
    }

    return scratchpad || null;
};

var getSummaries = function getSummaries(state) {
    return state.recentActivity && state.recentActivity.summaries || [];
};

var selectors_getFetchState = function getFetchState(state) {
    var fetch = state.recentActivity && state.recentActivity.fetch;
    return {
        isFetched: fetch === API_STATUS.SUCCESS || fetch === API_STATUS.ERROR,
        fetch: fetch
    };
};

// RecentActivityCarousel
var selectors_getRecentActivityCarousel = function getRecentActivityCarousel(state) {
    var summaries = getSummaries(state);
    return summaries.map(function (summary) {
        var arrivalDate = summary.arrivalDate,
            endDate = summary.endDate,
            departureDate = summary.departureDate,
            lbsGroupName = summary.lbsGroupName,
            lbsUuid = summary.lbsUuid,
            _summary$propertiesSu = summary.propertiesSummary,
            propertiesSummary = _summary$propertiesSu === undefined ? {} : _summary$propertiesSu,
            scratchpadId = summary.scratchpadId,
            startDate = summary.startDate,
            imageUrl = summary.imageUrl;
        var _propertiesSummary$pr = propertiesSummary.properties,
            properties = _propertiesSummary$pr === undefined ? [] : _propertiesSummary$pr;

        var firstImageUrl = properties[0] && properties[0].hit && properties[0].hit.thumbnailUrl1;
        var count = properties.length;
        var imageUri = imageUrl || firstImageUrl;
        return {
            startDate: arrivalDate,
            count: count,
            endDate: departureDate,
            searchEndDate: endDate,
            searchStartDate: startDate,
            title: lbsGroupName,
            lbsUuid: lbsUuid,
            key: scratchpadId,
            id: scratchpadId,
            imageUri: getImageUrl(imageUri)
        };
    });
};

// RecentActivityCarousel
var getCardIndex = function getCardIndex(state) {
    return state.recentActivity && state.recentActivity.cardIndex;
};

/* harmony default export */ var selectors = ({
    getFetchState: selectors_getFetchState,
    getRecentActivityDetails: getRecentActivityDetails,
    getCardIndex: getCardIndex,
    getRecentActivityCarousel: selectors_getRecentActivityCarousel,
    getSummaries: getSummaries
});
// CONCATENATED MODULE: ./src/universal/recent-activity/edap.js
var recent_activity_edap__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var edap_CATEGORY = 'scratchpad';

// generic events
var edap_generic = {
    RECENT_ACTIVITY_SEARCH: 'fullpage:recentactivitysearch',
    SUMMARY_CLICK: 'fullpage:parentclick',
    SUMMARY_INITIAL_LOAD: 'fullpage:load',
    SEE_MORE_CLICK: 'fullpage:continuesearchclick',
    REMOVE_SEARCH_CLICK: 'fullpage:searchremove_parent',
    REMOVE_PROPERTY_CLICK: 'fullpage:listingremove_child',
    BEST_MATCH_CLICK: 'fullpage:recpropclick',
    BEST_MATCH_ARROW_CLICK: 'fullpage:recoarrowclick',
    CHANGE_SEEN: 'changeSeen'
};

// generic event utility methods
var recent_activity_edap_trigger = function trigger(data) {
    edap.trigger(GENERIC_EVENT, recent_activity_edap__extends({
        eventcategory: edap_CATEGORY
    }, data));
};

var edap_triggerDelay = function triggerDelay(data) {
    edap.trigger(GENERIC_EVENT, recent_activity_edap__extends({
        eventcategory: edap_CATEGORY
    }, data), {
        delayProcessing: true
    });
};

// generic event methods
edap_generic.seeMoreClick = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    edap_triggerDelay({
        eventaction: edap_generic.SEE_MORE_CLICK,
        eventlabel: label
    });
};

edap_generic.removeSearchClick = function () {
    recent_activity_edap_trigger({
        eventaction: edap_generic.REMOVE_SEARCH_CLICK
    });
};

edap_generic.removePropertyClick = function () {
    recent_activity_edap_trigger({
        eventaction: edap_generic.REMOVE_PROPERTY_CLICK
    });
};

edap_generic.bestMatchClick = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    recent_activity_edap_trigger({
        eventaction: edap_generic.BEST_MATCH_CLICK,
        eventlabel: label
    });
};

edap_generic.bestMatchNextArrowClick = function () {
    recent_activity_edap_trigger({
        eventaction: edap_generic.BEST_MATCH_ARROW_CLICK,
        eventlabel: 'right'
    });
};

edap_generic.bestMatchPreviousArrowClick = function () {
    recent_activity_edap_trigger({
        eventaction: edap_generic.BEST_MATCH_ARROW_CLICK,
        eventlabel: 'left'
    });
};

edap_generic.changeSeenEvent = function () {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var scratchpadId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    recent_activity_edap_trigger({
        eventaction: edap_generic.CHANGE_SEEN,
        eventlabel: edap.getPositionLabel(position, total) + ';spid=' + scratchpadId
    });
};

edap_generic.recentActivitySearch = function () {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var lbsUuid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    recent_activity_edap_trigger({
        eventaction: edap_generic.RECENT_ACTIVITY_SEARCH,
        eventlabel: edap.getPositionLabel(position, total) + ';lbsUuid=' + lbsUuid
    });
};

// named events (edap-integrations@8.6.0)
var recent_activity_edap_named = {
    RECENT_ACTIVITY_MORE_CLICK: 'recentactivity.seemore.click',
    RECENT_ACTIVITY_DELETE: 'recentactivity.search.delete',
    RECENT_ACTIVITY_REMOVE: 'recentactivity.individual.delete',
    RECENT_ACTIVITY_VIEW: 'recentactivity.view'
};

var MORE_LOCATION = {
    BOTTOM: 'bottom',
    TOP: 'top'
};

var getSearchTerm = function getSearchTerm(searchTerm) {
    return searchTerm && searchTerm.toLowerCase() || '';
};

var MORE_TYPE = {
    top: 'see more',
    bottom: 'see more in x'
};

recent_activity_edap_named.delete = function (eventsearchterm) {
    var searchterm = getSearchTerm(eventsearchterm);
    edap.trigger(recent_activity_edap_named.RECENT_ACTIVITY_DELETE, { eventsearchterm: searchterm });
};

recent_activity_edap_named.remove = function (eventsearchterm) {
    var listingIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var eventlistingids = listingIds.join(',');
    var searchterm = getSearchTerm(eventsearchterm);
    edap.trigger(recent_activity_edap_named.RECENT_ACTIVITY_REMOVE, {
        eventsearchterm: searchterm,
        eventlistingids: eventlistingids
    });
};

recent_activity_edap_named.seeMoreClick = function (location) {
    edap.trigger(recent_activity_edap_named.RECENT_ACTIVITY_MORE_CLICK, {
        seemoretype: MORE_TYPE[location]
    });
};

recent_activity_edap_named.view = function (eventsearchterm) {
    var searchterm = getSearchTerm(eventsearchterm);
    edap.trigger(recent_activity_edap_named.RECENT_ACTIVITY_VIEW, { eventsearchterm: searchterm });
};

var methods = {
    bestMatchClick: edap_generic.bestMatchClick,
    bestMatchNextArrowClick: edap_generic.bestMatchNextArrowClick,
    bestMatchPreviousArrowClick: edap_generic.bestMatchPreviousArrowClick,
    changeSeenEvent: edap_generic.changeSeenEvent,
    recentActivitySearch: edap_generic.recentActivitySearch,
    removePropertyClick: function removePropertyClick(searchTerm, listingIds) {
        listingIds = !Array.isArray(listingIds) ? [listingIds] : listingIds;
        edap_generic.removePropertyClick();
        recent_activity_edap_named.remove(searchTerm, listingIds);
    },
    removeSearchClick: function removeSearchClick(searchTerm) {
        edap_generic.removeSearchClick();
        recent_activity_edap_named.delete(searchTerm);
    },
    seeMoreClick: function seeMoreClick(location) {
        edap_generic.seeMoreClick(location);
        recent_activity_edap_named.seeMoreClick(location);
    },


    viewRecentActivityDetails: recent_activity_edap_named.view
};

/* harmony default export */ var recent_activity_edap = (recent_activity_edap__extends({
    generic: edap_generic,
    named: recent_activity_edap_named
}, methods));
// EXTERNAL MODULE: ./src/universal/recent-activity/components/back-to-scratchpad-button.less
var back_to_scratchpad_button = __webpack_require__("d0RQ");
var back_to_scratchpad_button_default = /*#__PURE__*/__webpack_require__.n(back_to_scratchpad_button);

// CONCATENATED MODULE: ./src/universal/recent-activity/components/back-to-scratchpad-button.js









function BackToScratchpadButton(_ref) {
    var buttonText = _ref.buttonText;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        es["Link"],
        { className: 'recent-activity-back-button', to: universal_routes.TRIPBOARD },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
            'aria-label': buttonText,
            className: 'recent-activity-back-button',
            label: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                null,
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    null,
                    buttonText
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inlineFlex: true, markup: CHEVRON_LEFT__16["CHEVRON_LEFT__16"] })
            )
        })
    );
}

/* harmony default export */ var components_back_to_scratchpad_button = (BackToScratchpadButton);
// EXTERNAL MODULE: ./src/universal/components/grid-layout/grid-layout.less
var grid_layout = __webpack_require__("hlwG");
var grid_layout_default = /*#__PURE__*/__webpack_require__.n(grid_layout);

// CONCATENATED MODULE: ./src/universal/components/grid-layout/grid-layout.js




function GridLayout(props) {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'grid-layout' },
        props.children
    );
}

/* harmony default export */ var grid_layout_grid_layout = (GridLayout);
// CONCATENATED MODULE: ./src/universal/components/grid-layout/index.js


/* harmony default export */ var components_grid_layout = (grid_layout_grid_layout);
// EXTERNAL MODULE: ./src/universal/recent-activity/components/recent-activity-details-container.less
var recent_activity_details_container = __webpack_require__("fNN3");
var recent_activity_details_container_default = /*#__PURE__*/__webpack_require__.n(recent_activity_details_container);

// EXTERNAL MODULE: ./node_modules/url-search-params/build/url-search-params.node.js
var url_search_params_node = __webpack_require__("5mUy");
var url_search_params_node_default = /*#__PURE__*/__webpack_require__.n(url_search_params_node);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-horizontal-scroll/lib/transpiled/index.js
var react_horizontal_scroll_lib_transpiled = __webpack_require__("bfTJ");
var react_horizontal_scroll_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_horizontal_scroll_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/utils/api.js
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    var error = new Error(response.statusText);
    error.response = response;
    throw error;
}


// CONCATENATED MODULE: ./src/universal/recent-activity/components/best-match-hit.js
var best_match_hit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function best_match_hit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function best_match_hit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function best_match_hit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var best_match_hit_BestMatchHit = function (_Component) {
    best_match_hit__inherits(BestMatchHit, _Component);

    function BestMatchHit() {
        var _temp, _this, _ret;

        best_match_hit__classCallCheck(this, BestMatchHit);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = best_match_hit__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function () {
            _this.props.onClick(_this.props.index);
        }, _temp), best_match_hit__possibleConstructorReturn(_this, _ret);
    }

    BestMatchHit.prototype.render = function render() {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            {
                className: 'hit-container',
                onClick: this.onClick,
                onKeyPress: this.onClick,
                role: 'button',
                tabIndex: '0'
            },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_Hit, best_match_hit__extends({ miniHit: true }, this.props.hit))
        );
    };

    return BestMatchHit;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var best_match_hit = (best_match_hit_BestMatchHit);
// EXTERNAL MODULE: ./src/universal/recent-activity/components/best-match.less
var best_match = __webpack_require__("FXRR");
var best_match_default = /*#__PURE__*/__webpack_require__.n(best_match);

// CONCATENATED MODULE: ./src/universal/recent-activity/components/best-match.js
function best_match__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function best_match__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function best_match__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var best_match_BestMatch = function (_Component) {
    best_match__inherits(BestMatch, _Component);

    function BestMatch(props) {
        best_match__classCallCheck(this, BestMatch);

        /* Define state for the best match */
        var _this = best_match__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            hits: []
        };

        _this.validListingIdPattern = /^\d+\.\d+\.\d+$/;
        return _this;
    }

    /**
     *  componentDidMount()
     *  Add a listener for a resize event
     */


    BestMatch.prototype.componentDidMount = function componentDidMount() {
        if (true) {
            this.fetchApiHeart();
        }
    };

    BestMatch.prototype.componentDidCatch = function componentDidCatch() {
        this.setState({ hasError: true });
    };

    BestMatch.prototype.fetchApiHeart = function fetchApiHeart() {
        var _this2 = this;

        var _props = this.props,
            listingIds = _props.listingIds,
            searchTerm = _props.searchTerm,
            startDate = _props.startDate,
            endDate = _props.endDate,
            useNewRecommendationService = _props.useNewRecommendationService,
            logHaPulseRecoAbTestExposure = _props.logHaPulseRecoAbTestExposure,
            locale = _props.locale;


        var urlQueryParams = new url_search_params_node_default.a();

        // start [SCRATCHPAD-1344] ha_pulse_reco_ab_test
        if (useNewRecommendationService) {
            urlQueryParams.set('recommendationModel', 'LISTING');
        }
        // end [SCRATCHPAD-1344] ha_pulse_reco_ab_test

        var listingId = listingIds[0];
        var isDated = !!(startDate && endDate);
        var recoDateRange = '';
        // [SCRATCHPAD-598] Sanity check listingId to avoid malformed requests
        if (!this.validListingIdPattern.test(listingId)) {
            return;
        }
        var exclusions = listingIds.slice(1);
        var numberOfRecos = 10;
        urlQueryParams.set('size', numberOfRecos);
        urlQueryParams.set('fallBack', numberOfRecos - 1);
        urlQueryParams.set('searchSort', 'mostPopular');
        urlQueryParams.set('listingId', listingId);
        urlQueryParams.set('locale', locale);
        if (exclusions.length > 0) {
            exclusions.forEach(function (exclusion) {
                urlQueryParams.append('exclusions', exclusion);
            });
        }
        urlQueryParams.set('searchTerm', searchTerm);

        if (isDated) {
            urlQueryParams.set('startDate', startDate);
            urlQueryParams.set('endDate', endDate);

            var formattedStart = startDate.split('-');
            formattedStart.push(formattedStart.shift());
            formattedStart = formattedStart.join('%2f');

            var formattedEnd = endDate.split('-');
            formattedEnd.push(formattedEnd.shift());
            formattedEnd = formattedEnd.join('%2f');

            recoDateRange = '?arrivalDate=' + formattedStart + '&departureDate=' + formattedEnd;
        }

        fetch('/traveler/scratchpad/api/recent-activity/findByListing?' + urlQueryParams.toString()).then(checkStatus).then(function (r) {
            return r.json();
        }).then(function (response) {
            var responseHits = response.recommendedHits;
            var hits = responseHits ? responseHits.map(function (hit) {
                return {
                    averageRatingClass: hit.averageRatingClass,
                    bathrooms: hit.presentationModel.bathroomsMessage,
                    bedrooms: hit.presentationModel.bedroomsMessage,
                    detailPageUrl: '' + hit.propertyHref + recoDateRange,
                    isDated: isDated,
                    noPrice: hit.presentationModel.noPriceMessage,
                    rate: hit.rate,
                    ratesUnitOfMeasure: hit.rateUnitOfMeasure,
                    reviewCount: hit.reviewCount,
                    sleeps: hit.presentationModel.sleepsMessage,
                    thumbnailUrl1: hit.imageHref,
                    // don't gray out gallery
                    status: 'AVAILABLE'
                };
            }) : [];

            _this2.setState({ hits: hits.splice(0, numberOfRecos), message: response.bestMatchSearchText });

            // start [SCRATCHPAD-1344] ha_pulse_reco_ab_test
            if (hits.length > 1) {
                // only fire exposure when user is shown recommendations
                logHaPulseRecoAbTestExposure();
            }
            // end [SCRATCHPAD-1344] ha_pulse_reco_ab_test
        });
    };

    BestMatch.prototype.render = function render() {
        var _this3 = this;

        var message = null;

        if (this.state.hasError || this.state.hits.length === 0) {
            return null;
        }

        /* if there is a default message passed in as a prop, render it otherwise use the
        message retrieved from the fetch request */
        if (this.props.defaultMessage) {
            message = this.props.defaultMessage;
        } else {
            message = this.state.message;
        }

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'best-match-headline' },
                message
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'best-match-container' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    react_horizontal_scroll_lib_transpiled_default.a,
                    this.props,
                    this.state.hits.map(function (hit, index) {
                        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(best_match_hit, { key: 'slide' + index, hit: hit, index: index + 1, onClick: _this3.props.onClick });
                    })
                )
            )
        );
    };

    return BestMatch;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

best_match_BestMatch.propTypes = {
    defaultMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    listingIds: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string),
    onClick: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    scratchpadId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    searchTerm: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    startDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    endDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    useNewRecommendationService: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    logHaPulseRecoAbTestExposure: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func
};

best_match_BestMatch.defaultProps = {
    useNewRecommendationService: false,
    logHaPulseRecoAbTestExposure: function logHaPulseRecoAbTestExposure() {}
};

/* harmony default export */ var components_best_match = (best_match_BestMatch);
// CONCATENATED MODULE: ./src/universal/utils/dom.js
var scrollToTop = function scrollToTop() {
    if (window && window.scroll) {
        window.scroll(0, 0);
    }
};

/* harmony default export */ var dom = ({ scrollToTop: scrollToTop });
// CONCATENATED MODULE: ./src/universal/components/PageView/PageView.js
function PageView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PageView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PageView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line no-unused-vars




var PageView_Page = function (_Component) {
    PageView__inherits(Page, _Component);

    function Page(props) {
        PageView__classCallCheck(this, Page);

        return PageView__possibleConstructorReturn(this, _Component.call(this, props));
    }

    Page.prototype.componentDidMount = function componentDidMount() {
        var pagename = this.props.pagename;

        edap.pageview(pagename);
        dom.scrollToTop();
    };

    Page.prototype.componentWillUnmount = function componentWillUnmount() {
        // Since we log PAR on multiple pages, we need to mark
        // this to reset our zero-point mark after client-side
        // routing takes over.
        ha_wrapper.userTiming.mark('page.unload');
    };

    Page.prototype.render = function render() {
        var children = this.props.children;
        // Support <PageView /> and <PageView>...</PageView>

        return children || null;
    };

    return Page;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);


// CONCATENATED MODULE: ./src/universal/components/Timing/withPAR.js
var withPAR__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function withPAR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withPAR__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withPAR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var withPAR_withPAR = function withPAR(WrappedComponent) {
    var namedWrappedComponent = function (_Component) {
        withPAR__inherits(namedWrappedComponent, _Component);

        function namedWrappedComponent(props) {
            withPAR__classCallCheck(this, namedWrappedComponent);

            var _this = withPAR__possibleConstructorReturn(this, _Component.call(this, props));

            _this.markPAR = function () {
                if (!_this.isMarked) {
                    _this.isMarked = true;
                    edap.markPAR();
                }
            };

            _this.isMarked = false;
            return _this;
        }

        namedWrappedComponent.prototype.componentWillMount = function componentWillMount() {
            this.isMarked = false;
        };

        namedWrappedComponent.prototype.render = function render() {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(WrappedComponent, withPAR__extends({}, this.props, { markPAR: this.markPAR }));
        };

        return namedWrappedComponent;
    }(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

    /* istanbul ignore next */
    namedWrappedComponent.displayName = 'withPAR(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')';
    return namedWrappedComponent;
};

/* harmony default export */ var Timing_withPAR = (withPAR_withPAR);
// CONCATENATED MODULE: ./src/universal/components/Timing/index.js



// CONCATENATED MODULE: ./src/universal/abacus/with-abacus-test-values-as-props/with-abacus-test-values-as-props.js
var with_abacus_test_values_as_props__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// helper that is exported only for testing!
// abacusTestsToProps is a map of abacus test names to desired prop names
// abacus is the abacus slice from redux
function mapTestValuesToProps(abacusTestsToProps, abacus) {
    var props = {};
    for (var test in abacusTestsToProps) {
        if (abacusTestsToProps.hasOwnProperty(test)) {
            var prop = abacusTestsToProps[test];
            // default missing test values to 0
            props[prop] = abacus[test] && abacus[test].value ? abacus[test].value : 0;
        }
    }
    return props;
}

// Main HOC
// function => function => Component
function withAbacusTestValuesAsProps(abacusTestsToProps) {
    return function (Component) {
        return function (props) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                abacus_context.Consumer,
                null,
                function (abacus) {
                    var abacusProps = mapTestValuesToProps(abacusTestsToProps, abacus);
                    var mergedProps = with_abacus_test_values_as_props__extends({}, props, abacusProps);
                    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Component, mergedProps);
                }
            );
        };
    };
}
/* harmony default export */ var with_abacus_test_values_as_props = (withAbacusTestValuesAsProps);
// CONCATENATED MODULE: ./src/universal/recent-activity/components/recent-activity-details-container.js
var _withAbacusTestValues;

var recent_activity_details_container__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function recent_activity_details_container__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function recent_activity_details_container__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function recent_activity_details_container__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























// start [SCRATCHPAD-1344] ha_pulse_reco_ab_test
var isLogged = false;

var recent_activity_details_container_logHaPulseRecoAbTestExposure = function logHaPulseRecoAbTestExposure() {
    if (isLogged) {
        return;
    }
    isLogged = true;
    abacus_client_utils_lib_transpiled_default.a.evaluateExperimentAndLog(experiments["HA_PULSE_RECO_AB_TEST"]);
};
// end [SCRATCHPAD-1344] ha_pulse_reco_ab_test

var recent_activity_details_container_RecentActivityDetailsContainer = function (_Component) {
    recent_activity_details_container__inherits(RecentActivityDetailsContainer, _Component);

    function RecentActivityDetailsContainer(props) {
        recent_activity_details_container__classCallCheck(this, RecentActivityDetailsContainer);

        var _this = recent_activity_details_container__possibleConstructorReturn(this, _Component.call(this, props));

        recent_activity_details_container__initialiseProps.call(_this);

        _this.seenHits = [];
        return _this;
    }

    RecentActivityDetailsContainer.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            fetchRecentActivity = _props.fetchRecentActivity,
            recentActivityDetails = _props.recentActivityDetails;

        if (!recentActivityDetails) {
            fetchRecentActivity();
        } else {
            recent_activity_edap.viewRecentActivityDetails(recentActivityDetails.searchTerm);
        }
        this.par(this.props);
    };

    RecentActivityDetailsContainer.prototype.render = function render() {
        var _this2 = this;

        var _props2 = this.props,
            backMessage = _props2.backMessage,
            deleteMessage = _props2.deleteMessage,
            errorTitle = _props2.errorTitle,
            errorMessage = _props2.errorMessage,
            seeMoreInMessage = _props2.seeMoreInMessage,
            seeMoreMessage = _props2.seeMoreMessage,
            recentActivityDetails = _props2.recentActivityDetails,
            locale = _props2.locale,
            recoTestValue = _props2.recoTestValue;


        if (!recentActivityDetails) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Redirect"], { to: universal_routes.TRIPBOARD });
        }

        // [SCRATCHPAD-1344] ha_pulse_reco_ab_test
        var useNewRecommendationService = recoTestValue > 0;

        var arrivalDate = recentActivityDetails.arrivalDate,
            departureDate = recentActivityDetails.departureDate,
            endDate = recentActivityDetails.endDate,
            guests = recentActivityDetails.guests,
            isDated = recentActivityDetails.isDated,
            propertiesSummary = recentActivityDetails.propertiesSummary,
            scratchpadId = recentActivityDetails.scratchpadId,
            searchTerm = recentActivityDetails.searchTerm,
            searchTime = recentActivityDetails.searchTime,
            seeMoreLikeThis = recentActivityDetails.seeMoreLikeThis,
            startDate = recentActivityDetails.startDate;


        var listingIds = propertiesSummary && propertiesSummary.properties ? propertiesSummary.properties.map(function (property) {
            return property.hit.listingId;
        }) : [];

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(PageView_Page, { pagename: PAGE_RECENT_ACTIVITY_DETAILS }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { key: 'recent-activity-details-header', className: 'row remove-container-padding scratchpad-header' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'col-md-10 col-md-offset-1 remove-col-padding' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'main-header margin-bottom' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_back_to_scratchpad_button, { buttonText: backMessage })
                    )
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { key: 'recent-activity-details-body', className: 'row remove-container-padding' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    error_boundary,
                    { errorTitle: errorTitle, errorMessage: errorMessage },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'scratchpad-search-container col-md-10 col-md-offset-1 remove-col-padding' },
                        searchTime && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'scratchpad-search-time text-left text-muted' },
                            searchTime
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'col-xs-12 scratchpad-search-text hidden-xs' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                { className: 'scratchpad-search-header' },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'svg',
                                    { className: 'inline-svg scratchpad-search-icon' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xmlnsXlink: 'http://www.w3.org/2000/xlink', xlinkHref: '#svg-magnifying-glass' })
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'h2',
                                    { className: 'scratchpad-search-term' },
                                    searchTerm
                                ),
                                arrivalDate && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'span',
                                    { className: 'scratchpad-dates-container' },
                                    arrivalDate,
                                    ' ',
                                    departureDate && String.fromCharCode(0x2192) + ' ' + departureDate
                                ),
                                guests &&
                                /* eslint-disable react/jsx-no-literals */
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'span',
                                    { className: 'scratchpad-guests-container hidden-xs' },
                                    arrivalDate && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'span',
                                        { className: 'hidden-xs' },
                                        '\xA0 \u2022 \xA0'
                                    ),
                                    guests
                                )
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                null,
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'a',
                                    { href: seeMoreLikeThis.href, onClick: this.handleContinueSearchTopClick, className: 'btn btn-primary btn-icon-circle visible-xs-block', 'data-effect': 'ripple', title: seeMoreMessage },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('i', { className: 'icon-search' })
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'a',
                                    { href: seeMoreLikeThis.href, onClick: this.handleContinueSearchTopClick, className: 'btn btn-primary scratchpad-button btn-sm hidden-xs scratchpad-btn-see-more', 'data-effect': 'ripple' },
                                    seeMoreMessage
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'svg',
                                    { onClick: this.handleRemoveSearchClick, className: 'inline-svg scratchpad-btn-remove-search hidden-xs', 'aria-label': deleteMessage },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'title',
                                        null,
                                        deleteMessage
                                    ),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xmlnsXlink: 'http://www.w3.org/2000/xlink', xlinkHref: '#svg-remove' })
                                )
                            )
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'span',
                            { className: 'visible-xs-block' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                {
                                    className: 'col-xs-12 scratchpad-search-text',
                                    onClick: this.handleContinueSearchTopClick,
                                    onKeyPress: this.handleContinueSearchTopClick,
                                    role: 'button',
                                    tabIndex: '0'
                                },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'a',
                                    { className: 'scratchpad-search-header-xs', href: seeMoreLikeThis.href },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'svg',
                                        { className: 'inline-svg scratchpad-search-icon' },
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xmlnsXlink: 'http://www.w3.org/2000/xlink', xlinkHref: '#svg-magnifying-glass' })
                                    ),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'h4',
                                        { className: 'scratchpad-search-heading-xs' },
                                        searchTerm
                                    ),
                                    arrivalDate && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'div',
                                        { className: 'scratchpad-dates-container' },
                                        arrivalDate,
                                        ' ',
                                        departureDate && String.fromCharCode(0x2192) + ' ' + departureDate
                                    ),
                                    guests && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'div',
                                        { className: 'scratchpad-guests-container' },
                                        guests
                                    )
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'svg',
                                    { className: 'inline-svg scratchpad-btn-remove-search pull-right', onClick: this.handleRemoveSearchClick },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xmlnsXlink: 'http://www.w3.org/2000/xlink', xlinkHref: '#svg-remove' })
                                )
                            )
                        ),
                        propertiesSummary && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'scratchpad-search-hits-wrapper col-xs-12' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                { className: 'scratchpad-search-hits' },
                                propertiesSummary.headerSummary.text && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'text-muted scratchpad-search-number' },
                                    propertiesSummary.headerSummary.text
                                ),
                                propertiesSummary.properties && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'scratchpad-hit-container' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        components_grid_layout,
                                        null,
                                        propertiesSummary.properties.map(function (property, index, hits) {
                                            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(recent_activity_hit, recent_activity_details_container__extends({}, property, _this2.props, {
                                                key: index,
                                                hits: hits,
                                                index: index,
                                                isDated: isDated,
                                                seenHits: _this2.seenHits,
                                                handleDeletePropertyClick: _this2.handleDeletePropertyClick,
                                                onWaypointEnter: _this2.onWaypointEnter
                                            }));
                                        })
                                    )
                                ),
                                propertiesSummary.footerSummary && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'scratchpad-search-related text-center' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'a',
                                        { href: seeMoreLikeThis.href,
                                            onClick: this.handleContinueSearchBottomClick,
                                            className: 'btn btn-primary continue-search-button scratchpad-button hidden-xs',
                                            'data-bypass': 'true',
                                            'data-effect': 'ripple'
                                        },
                                        seeMoreInMessage && seeMoreInMessage.replace('{0}', searchTerm)
                                    ),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'a',
                                        { href: seeMoreLikeThis.href, onClick: this.handleContinueSearchBottomClick, className: 'btn btn-primary continue-search-button scratchpad-button visible-xs-block', 'data-bypass': 'true', 'data-effect': 'ripple' },
                                        seeMoreMessage
                                    )
                                )
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                { className: 'scratchpad-hit-gallery' },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_best_match, {
                                    arrowBackgroundColor: {
                                        red: 247,
                                        green: 247,
                                        blue: 248
                                    },
                                    listingIds: listingIds,
                                    onNextClick: this.handleBestMatchNextArrowClick,
                                    onPreviousClick: this.handleBestMatchPreviousArrowClick,
                                    scratchpadId: scratchpadId,
                                    searchTerm: searchTerm,
                                    onClick: this.handleBestMatchClick,
                                    startDate: startDate,
                                    endDate: endDate,
                                    useNewRecommendationService: useNewRecommendationService,
                                    logHaPulseRecoAbTestExposure: recent_activity_details_container_logHaPulseRecoAbTestExposure,
                                    locale: locale
                                })
                            )
                        )
                    )
                )
            )
        );
    };

    return RecentActivityDetailsContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

recent_activity_details_container_RecentActivityDetailsContainer.defaultProps = {
    markPAR: function markPAR() {},
    recoTestValue: 0
};

var recent_activity_details_container__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.componentWillReceiveProps = function (nextProps) {
        var recentActivityDetails = _this3.props.recentActivityDetails;

        if (nextProps.recentActivityDetails && (!recentActivityDetails || recentActivityDetails.searchTerm !== nextProps.recentActivityDetails.searchTerm)) {
            recent_activity_edap.viewRecentActivityDetails(nextProps.recentActivityDetails.searchTerm);
        }
        _this3.par(nextProps);
    };

    this.handleContinueSearchTopClick = function () {
        recent_activity_edap.seeMoreClick(MORE_LOCATION.TOP);
    };

    this.handleContinueSearchBottomClick = function () {
        recent_activity_edap.seeMoreClick(MORE_LOCATION.BOTTOM);
    };

    this.handleRemoveSearchClick = function () {
        var removeRecentActivitySearch = _this3.props.removeRecentActivitySearch;
        var _props$recentActivity = _this3.props.recentActivityDetails,
            propertiesSummary = _props$recentActivity.propertiesSummary,
            scratchpadId = _props$recentActivity.scratchpadId,
            searchTerm = _props$recentActivity.searchTerm;


        var propertyIds = propertiesSummary && propertiesSummary.properties ? propertiesSummary.properties.map(function (property) {
            return property.scratchpadId;
        }) : [];

        recent_activity_edap.removeSearchClick(searchTerm);
        removeRecentActivitySearch({ scratchpadId: scratchpadId, propertyIds: propertyIds });
    };

    this.handleDeletePropertyClick = function (listingId, scratchpadId) {
        var recentActivityDetails = _this3.props.recentActivityDetails;
        var searchTerm = recentActivityDetails.searchTerm;

        var searchId = recentActivityDetails.scratchpadId;
        recent_activity_edap.removePropertyClick(searchTerm, listingId);
        _this3.props.removeRecentActivityProperty({ scratchpadId: scratchpadId, searchId: searchId });
    };

    this.handleBestMatchClick = function (index) {
        recent_activity_edap.bestMatchClick(index);
    };

    this.handleBestMatchNextArrowClick = function () {
        recent_activity_edap.bestMatchNextArrowClick();
    };

    this.handleBestMatchPreviousArrowClick = function () {
        recent_activity_edap.bestMatchPreviousArrowClick();
    };

    this.onWaypointEnter = function (scratchpadId, index, hits) {
        // avoid sending the event on scroll if we have already notified the back-end
        var alreadySeen = _this3.seenHits.indexOf(scratchpadId) !== -1;
        if (!alreadySeen) {
            _this3.seenHits.push(scratchpadId);
            recent_activity_edap.changeSeenEvent(index, hits.length, scratchpadId);
        }
    };

    this.par = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var recentActivityDetails = props.recentActivityDetails;
        // PAR definition: When recent activity details are fully loaded.

        if (recentActivityDetails) {
            _this3.props.markPAR();
        }
    };
};

recent_activity_details_container_RecentActivityDetailsContainer.propTypes = {
    backMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    deleteMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    recentActivityDetails: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
        arrivalDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        departureDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        endDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        guests: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        propertiesSummary: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
            headerSummary: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({ text: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string }),
            properties: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({}))
        }),
        scratchpadId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        searchTerm: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        searchTime: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
        seeMoreLikeThis: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
            href: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
            text: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
        }),
        startDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
    }),
    seeMoreInMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    seeMoreMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    useNewRecommendationService: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool
};

function recent_activity_details_container_mapStateToProps(state, ownProps) {
    var linkId = ownProps.match.params.linkId;
    var recentActivityDetails = selectors.getRecentActivityDetails(state, linkId);
    var translations = getTranslations(state);
    return {
        backMessage: translations['scratchpad.button.back'],
        deleteMessage: translations['scratchpad.button.delete'],
        errorTitle: translations['th.inbox.error.title'],
        errorMessage: translations['th.inbox.error.message'],
        pagename: PAGE_RECENT_ACTIVITY_DETAILS,
        recentActivityDetails: recentActivityDetails,
        locale: state.system.fullLocale,
        seeMoreInMessage: translations['scratchpadFullSummary.searchesSummary.propertiesSummary.footer.seeMoreIn'],
        seeMoreMessage: translations['scratchpadFullSummary.searchesSummary.seeMore']
    };
}

var recent_activity_details_container_mapDispatchToProps = {
    fetchRecentActivity: recent_activity_actions.fetchRecentActivity,
    removeRecentActivitySearch: recent_activity_actions.removeRecentActivitySearch,
    removeRecentActivityProperty: recent_activity_actions.removeRecentActivityProperty
};

/* harmony default export */ var components_recent_activity_details_container = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(Timing_withPAR, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(recent_activity_details_container_mapStateToProps, recent_activity_details_container_mapDispatchToProps), with_abacus_test_values_as_props((_withAbacusTestValues = {}, _withAbacusTestValues[experiments["HA_PULSE_RECO_AB_TEST"]] = 'recoTestValue', _withAbacusTestValues)))(recent_activity_details_container_RecentActivityDetailsContainer));
// EXTERNAL MODULE: ./node_modules/md5/md5.js
var md5 = __webpack_require__("L6bb");
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-recent-activity-carousel/lib/transpiled/index.js
var react_recent_activity_carousel_lib_transpiled = __webpack_require__("tRR0");
var react_recent_activity_carousel_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_recent_activity_carousel_lib_transpiled);

// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/models/RangeParam.js
var RangeParam =
/*#__PURE__*/
function () {
  function RangeParam() {}

  var _proto = RangeParam.prototype;

  _proto.setFrom = function setFrom(from) {
    this.from = from;
  };

  _proto.setTo = function setTo(to) {
    this.to = to;
  };

  _proto.getFrom = function getFrom() {
    return this.from;
  };

  _proto.getTo = function getTo() {
    return this.to;
  };

  return RangeParam;
}();


//# sourceMappingURL=RangeParam.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/models/SearchUrlParameters.js
var ADULTS_COUNT = 'adultsCount';
var ARRIVAL = 'arrival';
var ASCENDING = 'ascending';
var BATHROOMS = 'bathrooms';
var BATHROOMS_REFINEMENT = 'Bathrooms'; // legacy bathroom slot refinement

var BEDROOMS = 'bedrooms';
var BEDROOMS_REFINEMENT = 'Bedrooms'; // legacy bedrooms slot refinement

var CHILDREN_COUNT = 'childrenCount';
var DEPARTURE = 'departure';
var FILTER = 'filter';
var FROM_DATE = 'from-date';
var KEYWORDS = 'keywords';
var MAX_BATHROOMS = 'maxBathrooms';
var MAX_BEDROOMS = 'maxBedrooms';
var MAX_NIGHTLY_PRICE = 'maxNightlyPrice';
var MAX_PRICE = 'maxprice';
var MAX_SLEEPS = 'maxSleeps';
var MIN_BATHROOMS = 'minBathrooms';
var MIN_BEDROOMS = 'minBedrooms';
var MIN_NIGHTLY_PRICE = 'minNightlyPrice';
var MIN_PRICE = 'minprice';
var MIN_SLEEPS = 'minSleeps';
var NE_LAT = 'neLat';
var NE_LONG = 'neLong';
var ORDER_BY = 'orderBy';
var PAGE = 'page';
var PET_INCLUDED = 'petIncluded';
var QUERY = 'q';
var REGION = 'region';
var SEARCH_TERM_UUID = 'searchTermUuid';
var SLEEPS = 'sleeps';
var SW_LAT = 'swLat';
var SW_LONG = 'swLong';
var TO_DATE = 'to-date';
var VIEW = 'view';
var ZOOM = 'zoom';
//# sourceMappingURL=SearchUrlParameters.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/models/SearchUrl.js

 // Region Parameter can be brand-specific.
// Though we are greedy in determining regionId value and do not consider site name.
// See https://github.homeawaycorp.com/geo/gbs/blob/752486c57169c43721a633321591e93d3d419423/gbs-url/src/main/java/com/homeaway/geo/gbs/url/GbsUrlUtils.java#L31
// and https://github.homeawaycorp.com/geo/gbs/blob/752486c57169c43721a633321591e93d3d419423/gbs-url/src/main/java/com/homeaway/geo/gbs/url/GbsUrlService.java#L98

var REGION_COLON_PARAMETER_VARIANTS = [
/* default */
'region',
/* vrbo? */
'regions',
/* homeaway_de */
'regionen',
/* BR */
'regiao',
/* IT */
'regione',
/* NL */
'regio',
/* FI */
'Matkakohteesi'];
var LEGACY_PATH_PARAM_PROPERTY_TYPES = ['property type', 'unterkunftsart'];
var LEGACY_PATH_PARAM_LOCATION_TYPES = ['location type', 'ortstyp'];
var LEGACY_PATH_PARAM_FEATURE_TYPES = ['features', 'ausstattung'];
var BOUNDING_BOX_REGEX = /@(-?\d+\.?\d+,){4}(\d{1,2})z/g;
var LANDING_PAGE_URL_PATTERN = /\/(.+)\/r(\d+)/;
var LANDING_PAGE_URL_PREFIXES = [
/* abritel, canada french, expedia fr */
'/vacances',
/* alugueTemporada */
'/ferias',
/* australia */
'/holiday-rentals',
/* canada english*/
'/cottage-rentals',
/* denmark */
'/ferie-bolig-lejlighed',
/* FewoDirekt, expedia de */
'/urlaub-ferienwohnung-ferienhaus',
/* finland */
'/loma-asunto',
/* new zealand */
'/holiday-accommodation',
/* united kingdom */
'/lettings',
/* homelidays com (fr) */
'/location-vacances',
/* homelidays es */
'/alquiler-vacacional',
/* homelidays it */
'/case-vacanze',
/* italy, expedia it */
'/case-vacanze-appartamenti',
/* mexico */
'/alquileres-vacaciones',
/* netherlands */
'/vakantie-vakantiehuis-vakantiewoning',
/* norway */
'/ferie-leilighet-feriehus',
/* odhr */
'/rentals',
/* poland */
'/apartamenty-wakacyjne',
/* portugal */
'/casas-apartamentos-ferias',
/* spain */
'/alquiler-vacaciones',
/* sweden */
'/semester-stugor-laegenhet',
/* luxury */
'/vacation-rentals',
/* vr */
'/browse',
/* homeaway-gr */
'/ενοικίαση-για-διακοπές',
/* homeaway-at */
'/ferienwohnung-ferienhaus-urlaub',
/* abritel legacy */
'/annonces',
/* stayz */
'/accommodation',
/* bookabach */
'/baches-and-holiday-homes'];
var SEARCH_URL_PARAMETERS = Object.keys(SearchUrlParameters_namespaceObject).filter(function (k) {
  return k !== '__esModule';
}).map(function (k) {
  return SearchUrlParameters_namespaceObject[k];
});
var SLASH_PARAMETERS = [MIN_NIGHTLY_PRICE, MAX_NIGHTLY_PRICE, MIN_BEDROOMS, MAX_BEDROOMS, MIN_SLEEPS, MAX_SLEEPS, MIN_BATHROOMS, MAX_BATHROOMS, FILTER];
var COLON_PARAMETERS = [PAGE, KEYWORDS, ARRIVAL, DEPARTURE];
//# sourceMappingURL=SearchUrl.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/filterRefinementUtils.js
var filterRefinementUtils = __webpack_require__("yTOT");
var filterRefinementUtils_default = /*#__PURE__*/__webpack_require__.n(filterRefinementUtils);

// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/models/SearchUrlBuilder.js



var SearchUrlBuilder_Builder =
/*#__PURE__*/
function () {
  function Builder() {
    this.ROOT = ROOT_PATH;
    this.PATHS = '';
    this.COLON_PARAMETERS = new Map();
    this.SLASH_PARAMETERS = new Map();
    this.QUERY_PARAMETERS = new Map();
    this.BOUNDING_BOX_PARAMETERS = null;
  }

  var _proto = Builder.prototype;

  _proto.addColonParameter = function addColonParameter(key, value) {
    if (value || typeof value === 'number' || typeof value === 'boolean') {
      this.COLON_PARAMETERS.set(key, value);
    }

    return this;
  };

  _proto.buildFilterForUrl = function buildFilterForUrl(filter) {
    // split <fieldName>:<refinementLink> into parts, defaulting to
    // filter:<filter> if fieldName is not specified
    var tokens = filter.split(':');
    var fieldName = Object(filterRefinementUtils["encodeFilterValue"])(tokens.length > 1 ? tokens[0] : FILTER);
    var value = Object(filterRefinementUtils["encodeFilterValue"])(tokens.length > 1 ? tokens[1] : filter);
    return {
      fieldName: fieldName,
      value: value
    };
  } // group filters by their field name (legacy) or under 'filter' for consolidated
  // filters
  ;

  _proto.groupFilters = function groupFilters(filters, map) {
    var _this = this;

    [].concat(filters || []).sort().forEach(function (f) {
      var _this$buildFilterForU = _this.buildFilterForUrl(f),
          fieldName = _this$buildFilterForU.fieldName,
          value = _this$buildFilterForU.value; // group the filters by fieldName


      var filtersForGroup = [].concat(map.get(fieldName) || []);
      filtersForGroup.push(value);
      map.set(fieldName, filtersForGroup);
    });
  };

  _proto.addFilterQueryParams = function addFilterQueryParams(filters) {
    this.groupFilters(filters, this.QUERY_PARAMETERS);
    return this;
  };

  _proto.addFilterPathSegments = function addFilterPathSegments(filters) {
    this.groupFilters(filters, this.COLON_PARAMETERS);
    return this;
  };

  _proto.addSlashParameter = function addSlashParameter(key, value) {
    if (value || typeof value === 'number' || typeof value === 'boolean') {
      this.SLASH_PARAMETERS.set(key, value);
    }

    return this;
  };

  _proto.addQueryParameter = function addQueryParameter(key, value) {
    if (value || typeof value === 'number' || typeof value === 'boolean') {
      this.QUERY_PARAMETERS.set(key, this.cleanedValues(key, value));
    }

    return this;
  };

  _proto.addQueryParameters = function addQueryParameters(values) {
    var _this2 = this;

    Object.keys(values).forEach(function (key) {
      return _this2.addQueryParameter(key, values[key]);
    });
    return this;
  };

  _proto.addBedroomParameters = function addBedroomParameters(minKey, maxKey, minValue, maxValue) {
    // exact studio match
    if (typeof minValue === 'number') {
      this.SLASH_PARAMETERS.set(minKey, minValue);
    }

    if (typeof maxValue === 'number') {
      this.SLASH_PARAMETERS.set(maxKey, maxValue);
    }

    return this;
  };

  _proto.addMapBoundingBoxParameters = function addMapBoundingBoxParameters(boundingBoxParameters) {
    this.BOUNDING_BOX_PARAMETERS = boundingBoxParameters;
    return this;
  };

  _proto.cleanedValue = function cleanedValue(key, value) {
    // filter ids can have 'filter:id' in them due to historical reasons, remove the extraneous 'filter'
    return key.toLowerCase() === FILTER ? value.split(':').pop() : value;
  };

  _proto.cleanedValues = function cleanedValues(key, value) {
    var _this3 = this;

    if (Array.isArray(value)) {
      return value.map(function (v) {
        return _this3.cleanedValue(key, v);
      });
    }

    return this.cleanedValue(key, value);
  };

  _proto.colonPathSegment = function colonPathSegment(key, value) {
    return key + ":" + this.cleanedValue(key, value);
  };

  _proto.build = function build() {
    var _this4 = this;

    var url = [this.ROOT, this.PATHS];
    this.COLON_PARAMETERS.forEach(function (value, key) {
      if (Array.isArray(value) && value.length > 0) {
        url.push('/');
        url.push(value.map(function (v) {
          return _this4.colonPathSegment(key, v);
        }).join('/'));
      } else if (!Array.isArray(value)) {
        url.push('/');
        url.push(_this4.colonPathSegment(key, value));
      }
    });

    if (this.BOUNDING_BOX_PARAMETERS) {
      var _this$BOUNDING_BOX_PA = this.BOUNDING_BOX_PARAMETERS,
          neLat = _this$BOUNDING_BOX_PA.neLat,
          neLong = _this$BOUNDING_BOX_PA.neLong,
          swLat = _this$BOUNDING_BOX_PA.swLat,
          swLong = _this$BOUNDING_BOX_PA.swLong,
          zoom = _this$BOUNDING_BOX_PA.zoom;
      url.push("/@" + swLat + "," + swLong + "," + neLat + "," + neLong + "," + zoom + "z");
    }

    this.SLASH_PARAMETERS.forEach(function (value, key) {
      url.push('/');
      url.push(key + "/" + value);
    });

    if (this.QUERY_PARAMETERS.size > 0) {
      var queryParams = [];
      this.QUERY_PARAMETERS.forEach(function (value, key) {
        var stringValue = value.toString();
        var arrayParam = stringValue && stringValue.split(',') || [];
        arrayParam.forEach(function (arrayValue) {
          queryParams.push(key + "=" + arrayValue);
        });
      });
      url.push("?" + queryParams.join('&'));
    }

    return url.join('');
  };

  return Builder;
}();

var SearchUrlBuilder =
/*#__PURE__*/
function () {
  function SearchUrlBuilder() {
    throw new Error('You can not construct builder');
  }

  SearchUrlBuilder.builder = function builder() {
    return new SearchUrlBuilder_Builder();
  };

  return SearchUrlBuilder;
}();


//# sourceMappingURL=SearchUrlBuilder.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/formatters/SearchUrlFormatter.js
function SearchUrlFormatter__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var SearchUrlFormatter_SearchUrlFormatter =
/*#__PURE__*/
function () {
  function SearchUrlFormatter() {
    this.root = ROOT_PATH;
  }

  var _proto = SearchUrlFormatter.prototype;

  _proto.format = function format(searchRequest) {
    var boundingBoxParameters;

    var neLat = searchRequest.neLat,
        neLong = searchRequest.neLong,
        swLat = searchRequest.swLat,
        swLong = searchRequest.swLong,
        zoom = searchRequest.zoom,
        q = searchRequest.q,
        page = searchRequest.page,
        arrival = searchRequest.arrival,
        departure = searchRequest.departure,
        regionId = searchRequest.regionId,
        minPrice = searchRequest.minPrice,
        maxPrice = searchRequest.maxPrice,
        minBedrooms = searchRequest.minBedrooms,
        maxBedrooms = searchRequest.maxBedrooms,
        minBathrooms = searchRequest.minBathrooms,
        maxBathrooms = searchRequest.maxBathrooms,
        minSleeps = searchRequest.minSleeps,
        maxSleeps = searchRequest.maxSleeps,
        filter = searchRequest.filter,
        rest = SearchUrlFormatter__objectWithoutProperties(searchRequest, ["neLat", "neLong", "swLat", "swLong", "zoom", "q", "page", "arrival", "departure", "regionId", "minPrice", "maxPrice", "minBedrooms", "maxBedrooms", "minBathrooms", "maxBathrooms", "minSleeps", "maxSleeps", "filter"]);

    if (neLat && neLong && swLat && swLong && zoom) {
      boundingBoxParameters = {
        neLat: neLat,
        neLong: neLong,
        swLat: swLat,
        swLong: swLong,
        zoom: zoom
      };
    }

    return SearchUrlBuilder.builder().addQueryParameters(rest) // this needs to be called first, order is important
    .addColonParameter(KEYWORDS, encodeURIComponentString(q)).addColonParameter(PAGE, page).addColonParameter(ARRIVAL, arrival).addColonParameter(DEPARTURE, departure).addColonParameter(REGION, regionId).addFilterPathSegments(filter).addSlashParameter(MIN_NIGHTLY_PRICE, minPrice).addSlashParameter(MAX_NIGHTLY_PRICE, maxPrice).addBedroomParameters(MIN_BEDROOMS, MAX_BEDROOMS, minBedrooms, maxBedrooms).addSlashParameter(MIN_BATHROOMS, minBathrooms).addSlashParameter(MAX_BATHROOMS, maxBathrooms).addSlashParameter(MIN_SLEEPS, minSleeps).addSlashParameter(MAX_SLEEPS, maxSleeps).addMapBoundingBoxParameters(boundingBoxParameters).build();
  };

  return SearchUrlFormatter;
}();


//# sourceMappingURL=SearchUrlFormatter.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/utils/petSyncer.js
var PETS_INCLUDED_LEGACY_KEY = {
  abritel: 'SpecialOptions:suitability_pets_considered',
  homeaway_us: 'amenities_title:suitability_pets_considered',
  homeaway_uk: 'amenities_title_old:suitability_pets_considered',
  homelidays_es: 'suitability_title:suitability_pets_considered',
  homelidays_fr: 'suitability_title:suitability_pets_considered',
  homelidays_it: 'suitability_title:suitability_pets_considered',
  vrbo: 'amenities_title:suitability_pet_friendly'
};
var PETS_INCLUDED_LEGACY_LINK = {
  abritel: 'Options spéciales:animaux acceptes',
  homeaway_at: 'Ausstattung:Haustiere erlaubt',
  homeaway_de: 'Ausstattung:Haustiere erlaubt',
  homeaway_es: 'Servicios:se admiten mascotas',
  homeaway_gr: 'Χαρακτηριστικά:δέχεται κατοικίδια',
  homeaway_pl: 'Cechy:Przyjazne dla zwierząt',
  homeaway_uk: 'Property Details:pets considered',
  homeaway_us: 'Features:pets considered',
  homelidays_es: 'Opciones especiales:admiten-animales',
  homelidays_fr: 'Options spéciales:animaux-acceptes',
  homelidays_it: 'Caratteristiche speciali:animali-ammessi',
  vrbo: 'Features:pet_friendly'
};
var PETS_INCLUDED_ID = 'filter:27';
var PETS_INCLUDED_IDS = [].concat(Object.keys(PETS_INCLUDED_LEGACY_KEY).map(function (key) {
  return PETS_INCLUDED_LEGACY_KEY[key];
}), Object.keys(PETS_INCLUDED_LEGACY_LINK).map(function (key) {
  return PETS_INCLUDED_LEGACY_LINK[key];
}), [PETS_INCLUDED_ID]);
/**
 * Returns true if filter is a pet refinement
 * @param {string} filter filter refinement
 */

var isPetFilter = function isPetFilter(filter) {
  return PETS_INCLUDED_IDS.map(function (id) {
    return id.toLowerCase();
  }).includes(decodeURIComponent(filter).toLowerCase());
};
/**
 * Returns true if filters contain a pet refinement
 * @param {?string[]} filters refinement filters
 */

var petsInFilters = function petsInFilters(filters) {
  if (filters === void 0) {
    filters = [];
  }

  return !![].concat(filters).find(isPetFilter);
};

var withoutPetsFilter = function withoutPetsFilter(filter) {
  return [].concat(filter || []).filter(function (f) {
    return !isPetFilter(f);
  });
};

var SYNC_STRATEGY_BOTH = 'both';
var SYNC_STRATEGY_PET_INCLUDED = 'petIncluded';
var SYNC_STRATEGY_FILTER = 'filter';
/**
 * Takes a search request object and syncs the petIncluded and pet refinement filters
 * @param {T: SyncPetsInput} searchRequest object containing fields from SyncPetsInput
 */

function syncPets(searchRequest, syncWith) {
  if (syncWith === void 0) {
    syncWith = 'both';
  }

  var filter = [].concat(searchRequest.filter || []);
  var withoutPets = withoutPetsFilter(filter);
  var petsInFilter = withoutPets.length !== filter.length;

  if (syncWith === 'both') {
    if (petsInFilter !== !!searchRequest.petIncluded) {
      if (!petsInFilter) {
        searchRequest.filter = [].concat(withoutPets, [PETS_INCLUDED_ID]).sort();
      }

      searchRequest.petIncluded = true;
    }
  } else if (syncWith === 'filter') {
    // use filter as source of true
    searchRequest.petIncluded = petsInFilter;
  } else if (syncWith === 'petIncluded') {
    // use petIncluded as source of true
    if (searchRequest.petIncluded) {
      searchRequest.filter = [].concat(withoutPets, [PETS_INCLUDED_ID]).sort();
    } else if (petsInFilter) {
      // petIncluded flag not set, but there's pets in the filter field
      searchRequest.filter = withoutPets;
    }
  }

  return searchRequest;
}

/* harmony default export */ var petSyncer = (syncPets);
//# sourceMappingURL=petSyncer.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/utils/generateUrl.js
/* harmony default export */ var generateUrl = (function (hostname, formattedSearchUrl) {
  if (hostname) {
    var sanitizedHostname = hostname.replace(/(^\w+:|^)\/\/|\//g, '');
    return "https://" + sanitizedHostname + formattedSearchUrl;
  }

  return formattedSearchUrl;
});
//# sourceMappingURL=generateUrl.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/toURL.js



var ROOT_PATH = '/search';

/**
 * Generates a search URL for the given Search Request model
 *
 * @param searchRequest - Search Request model
 * @param options
 * @returns {string} - relative url
 */
function toURL(searchRequest, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      hostname = _options.hostname; // sync pets

  searchRequest = petSyncer(searchRequest, options.petSyncStrategy);
  var formattedSearchUrl = new SearchUrlFormatter_SearchUrlFormatter().format(searchRequest);
  return generateUrl(hostname, formattedSearchUrl);
}
//# sourceMappingURL=toURL.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/utils/index.js

 // This keeps wanting to replace \/ with just / which is not the same regex
// eslint-disable-next-line

var localeRegex = RegExp('\/[a-zA-Z]{2}-[a-zA-Z]{2}\/');
var normalizeString = function normalizeString(value) {
  if (!value) {
    return '';
  }

  return decodeURIComponent(value).replace(/\+/g, ' ');
};
var encodeURIComponentString = function encodeURIComponentString(value) {
  if (!value) {
    return '';
  }

  return encodeURIComponent(value);
};
var intParser = function intParser(value) {
  value = normalizeString(value);
  var result = parseInt(value, 10);
  return isNaN(result) ? -1 : result;
};
var floatParser = function floatParser(value) {
  value = normalizeString(value);
  var result = parseFloat(value);
  return isNaN(result) ? -1 : result;
};
var stringParser = function stringParser(value) {
  return normalizeString(value);
};
var booleanParser = function booleanParser(value) {
  if (!value) {
    return false;
  }

  return value === 'true' || value === '1';
};
/**
 * Returns the root path of a given url
 * http://www.homeaway.com/results/fo/bar/land -> /results
 * @param {url} value url
 */

var utils_stripToRoot = function stripToRoot(value) {
  if (!value) {
    return ROOT_PATH;
  } // remove protocol


  var strippedValue = value.replace(/http(s)?:\/\//i, ''); // strip off query string

  strippedValue = strippedValue.split('?', 1).join(''); // strip off hash

  strippedValue = strippedValue.split('#', 1).join(''); // strip off domain

  if (!strippedValue.startsWith('/')) {
    var tokens = strippedValue.split('/');
    strippedValue = "/" + tokens.slice(1).join('/');
  }

  strippedValue = strippedValue.replace(localeRegex, '/'); // grab root path

  return strippedValue.split('/', 2).join('/');
};
/**
 * Checks whether root path is valid
 *
 * @param root
 * @returns {boolean}
 */

var utils_isValidRoot = function isValidRoot(root) {
  return [].concat(LANDING_PAGE_URL_PREFIXES, ['/search', '/results']).join('|').includes(root);
};
/**
 * Converts a date string to YYYY-mm-dd format
 *
 * Be careful when changing this function. This way of parsing dates should be revisited to be TZ independent.
 * @param {value} date as a string
 */

var formatDateToISO = function formatDateToISO(value) {
  try {
    return new Date(decodeURIComponent(value)).toISOString().split('T')[0];
  } catch (e) {
    // swallow
    return null;
  }
};
var parseNullOrString = function parseNullOrString(rawValue) {
  var value = stringParser(rawValue);

  if (value === 'undefined' || value === 'null') {
    return null;
  }

  if (value.match(/^\-?\d+\.\d+$/)) {
    return floatParser(value);
  }

  if (value.match(/^\-?\d+$/)) {
    return intParser(value);
  }

  if (value.toLowerCase() === 'true') {
    return true;
  }

  if (value.toLowerCase() === 'false') {
    return false;
  }

  return value;
};
/**
 * Parses a string value and attempts the type cast it to an int, float, or boolean, falling back to
 * a string.
 */

var multiPrimitiveParser = function multiPrimitiveParser(rawValue) {
  if (Array.isArray(rawValue)) {
    return rawValue.map(function (v) {
      return parseNullOrString(v);
    });
  }

  return parseNullOrString(rawValue);
};
var toTitleCase = function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
var canonicalizeKeywords = function canonicalizeKeywords(str) {
  return str.toLowerCase().replace(/[%,?.@#$^&*_\\/~!<>\[\]='"|;]/g, '').replace(/\s\s*/g, '-');
};
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/SearchUrlParser.js





var VRBO_REFINEMENT_FIELD_TITLES = ['Even More Filters', 'Features', 'Amenities', 'AddOn', 'Suitabilitites', 'Booking Options', 'Online Booking', 'Location Type', 'LocationType', 'Managed By', 'New Properties', 'Other', 'Pay Per Booking', 'Payment', 'Property Type', 'PropertyType', 'Properties good for', 'Suitability'];

var SearchUrlParser_SearchUrlParser =
/*#__PURE__*/
function () {
  function SearchUrlParser() {
    this.DATE_FORMATS = [new RegExp(/([0-9]{4})-([0-9]{2})-([0-9]{2})/), new RegExp(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})/)];
  }

  var _proto = SearchUrlParser.prototype;

  _proto.getUrlParts = function getUrlParts(url) {
    var root = utils_stripToRoot(url);

    if (!utils_isValidRoot(root)) {
      throw new Error("Invalid root for url = {" + url + "}");
    }

    var parts = this.stripSegment(url).split(root);

    if (parts.length !== 2) {
      throw new Error("Malformed URL = {" + url + "}");
    }

    return parts;
  };

  _proto.parseQueryParams = function parseQueryParams(searchRequestModel, options, queryParameters) {
    if (Object.keys(queryParameters).length) {
      this.setKeywords(searchRequestModel, queryParameters);
      this.setPrice(searchRequestModel, queryParameters);
      this.setBedrooms(searchRequestModel, queryParameters);
      this.setBathrooms(searchRequestModel, queryParameters);
      this.setSleeps(searchRequestModel, queryParameters);
      this.setRegion(searchRequestModel, queryParameters);
      this.setDates(searchRequestModel, options, queryParameters);
      this.setGuests(searchRequestModel, queryParameters);
      this.setPage(searchRequestModel, queryParameters);
      this.setView(searchRequestModel, queryParameters);
      this.setOrderBy(searchRequestModel, queryParameters);
      this.setFilters(searchRequestModel, queryParameters);
      this.setBoundingBoxParams(searchRequestModel, queryParameters);
      this.setSearchTermUuid(searchRequestModel, queryParameters);
    } // for params not handled above, parse them, guessing the primitive type


    var handledParams = SEARCH_URL_PARAMETERS.concat(VRBO_REFINEMENT_FIELD_TITLES).map(function (k) {
      return k.toLowerCase();
    });
    Object.keys(queryParameters).forEach(function (key) {
      var value = queryParameters[key];

      if (!handledParams.includes(key.toLowerCase())) {
        searchRequestModel[key] = multiPrimitiveParser(value);
      }
    });
  };

  _proto.isValidPathname = function isValidPathname(pathname) {
    return !!pathname && pathname.includes('/');
  };

  _proto.parsePathnameSegments = function parsePathnameSegments(pathname) {
    return pathname.split('/').filter(function (segment) {
      return segment !== '' && !segment.includes(':');
    }).map(encodeURIComponent);
  };

  _proto.setLegacyRegionPath = function setLegacyRegionPath(searchRequestModel, segments) {
    if (segments && segments.length) {
      searchRequestModel.legacyRegionPath = segments.join(',');
    }
  };

  _proto.isRegionPathParam = function isRegionPathParam(paramName) {
    return REGION_COLON_PARAMETER_VARIANTS.some(function (regionParamName) {
      // $FlowFixMe options string[] incorrect type checking
      var matcher = new RegExp(regionParamName, ['i']);
      return paramName.match(matcher) !== null;
    });
  };

  _proto.setGuests = function setGuests(searchRequest, queryParameters) {
    if (queryParameters[ADULTS_COUNT]) {
      searchRequest.adultsCount = intParser(queryParameters[ADULTS_COUNT]);
    }

    if (queryParameters[CHILDREN_COUNT]) {
      searchRequest.childrenCount = intParser(queryParameters[CHILDREN_COUNT]);
    }

    if (queryParameters[PET_INCLUDED]) {
      searchRequest.petIncluded = booleanParser(queryParameters[PET_INCLUDED]);
    }
  };

  _proto.setDates = function setDates(searchRequest, options, queryParameters) {
    var _this = this;

    if (queryParameters[FROM_DATE] && queryParameters[TO_DATE] || queryParameters[ARRIVAL] && queryParameters[DEPARTURE]) {
      var arrival = decodeURIComponent(stringParser(queryParameters[FROM_DATE] || queryParameters[ARRIVAL]));
      var departure = decodeURIComponent(stringParser(queryParameters[TO_DATE] || queryParameters[DEPARTURE]));
      this.DATE_FORMATS.filter(function (pattern) {
        return pattern.test(arrival) && pattern.test(departure);
      }).forEach(function () {
        var parsedArrival = _this.safeDateParse(searchRequest, arrival, 'arrival', options);

        var parsedDeparture = _this.safeDateParse(searchRequest, departure, 'departure', options);

        if (parsedArrival && parsedDeparture) {
          searchRequest.arrival = parsedArrival;
          searchRequest.departure = parsedDeparture;
        }
      });
    }
  };

  _proto.safeDateParse = function safeDateParse(searchRequest, value, key, options) {
    var dateValue = formatDateToISO(value);

    if (dateValue) {
      return dateValue;
    }

    if (options.onWarning) {
      options.onWarning("Invalid " + key + " date value=" + value, key);
    }

    return false;
  };

  _proto.setRegion = function setRegion(searchRequest, queryParameters) {
    if (queryParameters[REGION]) {
      searchRequest.regionId = intParser(queryParameters[REGION]);
    }
  };

  _proto.setSleeps = function setSleeps(searchRequest, queryParameters) {
    if (queryParameters[SLEEPS]) {
      var values = this.parseRangeParam(queryParameters[SLEEPS]);

      if (values.getFrom()) {
        searchRequest.minSleeps = values.getFrom();
      }

      if (values.getTo()) {
        searchRequest.maxSleeps = values.getTo();
      }
    }
  };

  _proto.setBathrooms = function setBathrooms(searchRequest, queryParameters) {
    if (queryParameters[BATHROOMS] || queryParameters[BATHROOMS_REFINEMENT]) {
      var values = this.parseRangeParam(queryParameters[BATHROOMS] || queryParameters[BATHROOMS_REFINEMENT]);

      if (values.getFrom()) {
        searchRequest.minBathrooms = values.getFrom();
      }

      if (values.getTo()) {
        searchRequest.maxBathrooms = values.getTo();
      }
    }
  };

  _proto.setBedrooms = function setBedrooms(searchRequest, queryParameters) {
    if (queryParameters[BEDROOMS] || queryParameters[BEDROOMS_REFINEMENT]) {
      var values = this.parseRangeParam(queryParameters[BEDROOMS] || queryParameters[BEDROOMS_REFINEMENT]);

      if (typeof values.getFrom() === 'number') {
        searchRequest.minBedrooms = values.getFrom();
      }

      if (typeof values.getTo() === 'number') {
        searchRequest.maxBedrooms = values.getTo();
      }
    }
  };

  _proto.setFilters = function setFilters(searchRequest, queryParameters) {
    var _this2 = this;

    if (queryParameters[FILTER]) {
      var stringValue = stringParser(queryParameters[FILTER]);
      var arrayParam = stringValue && stringValue.split(',') || []; // prepend 'filter:' if just the integer is passed in

      searchRequest.filter = [].concat(searchRequest.filter || [], arrayParam.map(function (filter) {
        return filter.match(/^\d+$/) ? FILTER + ":" + filter : filter;
      }));
    }

    VRBO_REFINEMENT_FIELD_TITLES.forEach(function (propertyKey) {
      _this2.setQueryParamFilters(searchRequest, queryParameters, propertyKey);
    });
  };

  _proto.setQueryParamFilters = function setQueryParamFilters(searchRequest, queryParameters, key) {
    var filters = searchRequest.filter ? searchRequest.filter : []; // query param key check

    Object.keys(queryParameters).forEach(function (k) {
      var value = queryParameters[k];

      if (k === key) {
        var stringValue = stringParser(value);
        var tempFilters = stringValue && stringValue.split(',') || [];
        searchRequest.filter = filters.concat(tempFilters.map(function (filter) {
          return Object(filterRefinementUtils["decodeFilterValue"])(key) + ":" + Object(filterRefinementUtils["decodeFilterValue"])(filter);
        }));
      }
    });
  };

  _proto.setPrice = function setPrice(searchRequest, queryParameters) {
    var price = this.parsePriceParams(queryParameters);

    if (typeof price.getFrom() !== 'undefined') {
      searchRequest.minPrice = price.getFrom();
    }

    if (typeof price.getTo() !== 'undefined') {
      searchRequest.maxPrice = price.getTo();
    }
  };

  _proto.setKeywords = function setKeywords(searchRequest, queryParameters) {
    if (queryParameters[QUERY] || queryParameters[KEYWORDS]) {
      var keywords = queryParameters[QUERY] || queryParameters[KEYWORDS];
      var result = stringParser(keywords);

      if (result !== '-1') {
        searchRequest.q = result;
      }
    }
  };

  _proto.setPage = function setPage(searchRequest, queryParameters) {
    if (queryParameters[PAGE]) {
      searchRequest.page = intParser(queryParameters[PAGE]);
    }
  };

  _proto.setView = function setView(searchRequest, queryParameters) {
    if (queryParameters[VIEW]) {
      searchRequest.view = stringParser(queryParameters[VIEW]);
    }
  };

  _proto.setOrderBy = function setOrderBy(searchRequest, queryParameters) {
    if (queryParameters[ORDER_BY]) {
      searchRequest.orderBy = stringParser(queryParameters[ORDER_BY]);
      searchRequest.ascending = booleanParser(queryParameters[ASCENDING]);
    }
  };

  _proto.setBoundingBoxParams = function setBoundingBoxParams(searchRequest, queryParameters) {
    if (queryParameters[NE_LAT] && queryParameters[NE_LONG] && queryParameters[SW_LAT] && queryParameters[SW_LONG]) {
      searchRequest.neLat = floatParser(queryParameters[NE_LAT]);
      searchRequest.neLong = floatParser(queryParameters[NE_LONG]);
      searchRequest.swLat = floatParser(queryParameters[SW_LAT]);
      searchRequest.swLong = floatParser(queryParameters[SW_LONG]);
    }

    if (queryParameters[ZOOM]) {
      searchRequest.zoom = intParser(queryParameters[ZOOM]);
    }
  };

  _proto.setSearchTermUuid = function setSearchTermUuid(searchRequest, queryParameters) {
    if (queryParameters[SEARCH_TERM_UUID]) {
      searchRequest.searchTermUuid = stringParser(queryParameters[SEARCH_TERM_UUID]);
    }
  };

  _proto.parsePriceParams = function parsePriceParams(queryParams) {
    var result = new RangeParam();

    if (queryParams[MIN_PRICE]) {
      var minPrice = intParser(queryParams[MIN_PRICE]);

      if (minPrice >= 0) {
        result.setFrom(minPrice);
      }
    }

    if (queryParams[MAX_PRICE]) {
      var maxPrice = intParser(queryParams[MAX_PRICE]);

      if (maxPrice >= 0) {
        result.setTo(maxPrice);
      }
    }

    return result;
  };

  _proto.parseRangeParam = function parseRangeParam(value) {
    var result = new RangeParam();

    if (value && !this.isEmpty(value)) {
      var parts = value.split('-');

      if (parts.length > 0) {
        var from = intParser(parts[0]);

        if (from >= 0) {
          result.setFrom(from);
        }
      }

      if (parts.length === 1) {
        result.setTo(result.getFrom());
      } else if (parts.length > 1) {
        var to = intParser(parts[1]);

        if (to >= 0) {
          result.setTo(to);
        }
      }
    }

    return result;
  };

  _proto.stripSegment = function stripSegment(uri) {
    if (this.isEmpty(uri)) {
      return uri;
    }

    return uri.split('#')[0];
  };

  _proto.isEmpty = function isEmpty(uri) {
    return !uri || uri.trim() === '';
  };

  return SearchUrlParser;
}();


//# sourceMappingURL=SearchUrlParser.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/search-url-parser/node_modules/query-string/index.js
var query_string = __webpack_require__("ir1l");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/SERPSearchUrlParser.js
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




/*
* Query params that require special parsing and validation, the rest we will just be handled individually as primitives
*/

var SPECIAL_PARAMS = ['arrival', 'departure', 'neLat', 'neLong', 'swLat', 'swLong', 'orderBy', 'ascending', 'filter'];

var SERPSearchUrlParser_SERPSearchUrlParser =
/*#__PURE__*/
function (_SearchUrlParser) {
  _inheritsLoose(SERPSearchUrlParser, _SearchUrlParser);

  function SERPSearchUrlParser() {
    return _SearchUrlParser.apply(this, arguments) || this;
  }

  var _proto = SERPSearchUrlParser.prototype;

  _proto.parse = function parse(url, options) {
    var path = this.stripSegment(url);

    if (!path) {
      return {};
    }

    var searchRequestModel = {};
    var tokens = path.split('?');

    if (tokens.length > 1) {
      var queryParams = query_string_default.a.parse(tokens[1]);
      Object.keys(queryParams).forEach(function (key) {
        var value = queryParams[key];

        if (!SPECIAL_PARAMS.includes(key)) {
          var parsedValue = multiPrimitiveParser(value);

          if (parsedValue !== null) {
            searchRequestModel[key] = parsedValue;
          }
        }
      });
      this.setFilters(searchRequestModel, queryParams);
      this.setDates(searchRequestModel, options, queryParams);
      this.setBoundingBoxParams(searchRequestModel, queryParams);
      this.setOrderBy(searchRequestModel, queryParams);
    }

    return searchRequestModel;
  };

  return SERPSearchUrlParser;
}(SearchUrlParser_SearchUrlParser);


//# sourceMappingURL=SERPSearchUrlParser.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/GTSearchUrlParser.js
function GTSearchUrlParser__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var GTSearchUrlParser_isLandingPageUrl = function isLandingPageUrl(path) {
  return path.match(LANDING_PAGE_URL_PATTERN) !== null;
};

var GTSearchUrlParser_GTSearchUrlParser =
/*#__PURE__*/
function (_SearchUrlParser) {
  GTSearchUrlParser__inheritsLoose(GTSearchUrlParser, _SearchUrlParser);

  function GTSearchUrlParser() {
    return _SearchUrlParser.apply(this, arguments) || this;
  }

  var _proto = GTSearchUrlParser.prototype;

  _proto.parse = function parse(url, options) {
    if (options === void 0) {
      options = {};
    }

    var parts = this.getUrlParts(url);
    var searchRequest = {};

    if (!this.isEmpty(parts[1])) {
      if (GTSearchUrlParser_isLandingPageUrl(parts[1])) {
        this.parseLandingUrl(parts[1], searchRequest);
      }

      if (parts[1].includes('?')) {
        var pair = parts[1].split('?');
        this.parseQueryParams(searchRequest, options, // adds filter refinements to searchRequest.filter
        this.getPathParams(pair[0], searchRequest, options));
        this.parseQueryParams(searchRequest, options, query_string_default.a.parseUrl(parts[1]).query);
      } else {
        this.parseQueryParams(searchRequest, options, this.getPathParams(parts[1], searchRequest, options));
      }
    }

    return searchRequest;
  };

  _proto.getPathParams = function getPathParams(path, searchRequest, options) {
    var _this = this;

    var segments = path.split('/');
    return segments.reduce(function (parameters, segment, key) {
      var tokens = segment.split(':');
      var parameterKey = tokens[0];
      var parameterValue = tokens[1];
      var colonOrSlashParameterKey = [].concat(COLON_PARAMETERS, SLASH_PARAMETERS).filter(function (p) {
        return p === parameterKey || p.toLowerCase() === parameterKey.trim().toLowerCase();
      })[0];

      if (tokens.length === 2 && COLON_PARAMETERS.includes(colonOrSlashParameterKey)) {
        parameters[colonOrSlashParameterKey] = parameterValue;
      } else if (tokens.length === 1 && SLASH_PARAMETERS.includes(colonOrSlashParameterKey)) {
        var value = segments.length >= key + 1 ? segments[key + 1] : null;

        if (value) {
          parameters[colonOrSlashParameterKey] = value;
        }
      } else if (segment.match(BOUNDING_BOX_REGEX)) {
        _this.parseBoundingBoxPath(parameters, segment, options);
      }

      _this.addFilterParamsToSearchRequest(parameters, tokens);

      if (_this.isRegionPathParam(parameterKey)) {
        parameters[REGION] = parameterValue;
      }

      return parameters;
    }, {});
  };

  _proto.parseBoundingBoxPath = function parseBoundingBoxPath(parameters, segment, options) {
    var strippedSegment = segment.replace('@', '').replace('z', '');
    var mapTokens = strippedSegment.split(',');

    if (!(mapTokens.length === 4 || mapTokens.length === 5)) {
      if (options.onWarning) {
        options.onWarning("Malformed URL Map Segment = \"" + segment + "\"");
      }
    } else {
      parameters.swLat = mapTokens[0];
      parameters.swLong = mapTokens[1];
      parameters.neLat = mapTokens[2];
      parameters.neLong = mapTokens[3];

      if (mapTokens[4]) {
        parameters.zoom = mapTokens[4];
      }
    }
  };

  _proto.parseLandingUrl = function parseLandingUrl(path, searchRequest) {
    var matches = LANDING_PAGE_URL_PATTERN.exec(path);

    if (matches !== null) {
      if (matches[1] && this.isValidPathname(matches[1])) {
        this.setLegacyRegionPath(searchRequest, this.parsePathnameSegments(matches[1]));
      }

      searchRequest.regionId = matches[2];
    }
  };

  _proto.addFilterParamsToSearchRequest = function addFilterParamsToSearchRequest(params, tokens) {
    var filters = params.filter || [];
    var validToken = tokens.length === 2;
    var handledParams = SEARCH_URL_PARAMETERS.concat(REGION_COLON_PARAMETER_VARIANTS).map(function (k) {
      return k.toLowerCase();
    });
    var legacyFilter = !handledParams.includes(tokens[0].toLowerCase());
    var consolidatedFilter = tokens[0].toLowerCase() === FILTER;

    if (validToken && (legacyFilter || consolidatedFilter)) {
      filters.push(Object(filterRefinementUtils["decodeFilterValue"])(tokens[0]) + ":" + Object(filterRefinementUtils["decodeFilterValue"])(tokens[1]));
    } // add to filters to searchRequest


    if (filters.length) {
      params.filter = filters;
    }
  };

  _proto.setSleeps = function setSleeps(searchRequest, queryParameters) {
    if (queryParameters[MIN_SLEEPS]) {
      var min = intParser(queryParameters[MIN_SLEEPS]);

      if (min) {
        searchRequest.minSleeps = min;
      }
    }

    if (queryParameters[MAX_SLEEPS]) {
      var max = intParser(queryParameters[MAX_SLEEPS]);

      if (max) {
        searchRequest.maxSleeps = max;
      }
    }
  };

  _proto.setBathrooms = function setBathrooms(searchRequest, queryParameters) {
    if (queryParameters[MIN_BATHROOMS]) {
      var min = intParser(queryParameters[MIN_BATHROOMS]);

      if (min) {
        searchRequest.minBathrooms = min;
      }
    }

    if (queryParameters[MAX_BATHROOMS]) {
      var max = intParser(queryParameters[MAX_BATHROOMS]);

      if (max) {
        searchRequest.maxBathrooms = max;
      }
    }
  };

  _proto.setBedrooms = function setBedrooms(searchRequest, queryParameters) {
    if (queryParameters[MIN_BEDROOMS]) {
      var min = intParser(queryParameters[MIN_BEDROOMS]);

      if (typeof min === 'number') {
        searchRequest.minBedrooms = min;
      }
    }

    if (queryParameters[MAX_BEDROOMS]) {
      var max = intParser(queryParameters[MAX_BEDROOMS]);

      if (typeof max === 'number') {
        searchRequest.maxBedrooms = max;
      }
    }
  };

  _proto.setPrice = function setPrice(searchRequest, queryParameters) {
    if (queryParameters[MIN_NIGHTLY_PRICE]) {
      var min = intParser(queryParameters[MIN_NIGHTLY_PRICE]);

      if (min > -1) {
        searchRequest.minPrice = min;
      }
    }

    if (queryParameters[MAX_NIGHTLY_PRICE]) {
      var max = intParser(queryParameters[MAX_NIGHTLY_PRICE]);

      if (max > -1) {
        searchRequest.maxPrice = max;
      }
    }
  };

  return GTSearchUrlParser;
}(SearchUrlParser_SearchUrlParser);


//# sourceMappingURL=GTSearchUrlParser.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/VRBOSearchUrlParser.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function VRBOSearchUrlParser__extends() { VRBOSearchUrlParser__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return VRBOSearchUrlParser__extends.apply(this, arguments); }

function VRBOSearchUrlParser__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var VRBOSearchUrlParser_VRBOSearchUrlParser =
/*#__PURE__*/
function (_SearchUrlParser) {
  VRBOSearchUrlParser__inheritsLoose(VRBOSearchUrlParser, _SearchUrlParser);

  function VRBOSearchUrlParser() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _SearchUrlParser.call.apply(_SearchUrlParser, [this].concat(args)) || this;

    _this.parseParams = function (pathname, query, options) {
      var searchRequestModel = {};

      if (query) {
        var queryObject = _this.normalizeSleeps(query_string_default.a.parse(query));

        _this.parseQueryParams(searchRequestModel, options, queryObject);
      }

      if (pathname && _this.isValidPathname(pathname)) {
        var segments = _this.parsePathnameSegments(pathname);

        var clearedSegments = _this.clearHAPathParameters(segments);

        if (!searchRequestModel.q && !searchRequestModel.regionId) {
          _this.setQFromPathname(searchRequestModel, clearedSegments);
        }

        _this.setLegacyRegionPath(searchRequestModel, clearedSegments);
      }

      return searchRequestModel;
    };

    _this.clearHAPathParameters = function (segments) {
      return segments.reduce(function (cleared, segment, i) {
        if (!(_this.isRegionPathParam(segment) || segment.match(BOUNDING_BOX_REGEX) || SLASH_PARAMETERS.includes(segment) || SLASH_PARAMETERS.includes(segments[i - 1]) || COLON_PARAMETERS.includes(segment.split(':')))) {
          cleared.push(segment);
        }

        return cleared;
      }, []);
    };

    _this.setQFromPathname = function (searchRequestModel, segments) {
      if (segments && segments.length) {
        searchRequestModel.q = toTitleCase(segments[segments.length - 1].replace(/-/g, ' '));
      }
    };

    _this.normalizeSleeps = function (query) {
      var sleepsKey = 'sleeps-';
      var sleepsKeys = Object.keys(query).filter(function (key) {
        return key.indexOf(sleepsKey) === 0;
      });
      sleepsKeys.forEach(function (key) {
        return delete query[key];
      });

      if (sleepsKeys.length > 0) {
        var sleeps = sleepsKeys[sleepsKeys.length - 1].split(sleepsKey)[1];
        return VRBOSearchUrlParser__extends({}, query, {
          sleeps: sleeps
        });
      }

      return query;
    };

    return _this;
  }

  var _proto = VRBOSearchUrlParser.prototype;

  _proto.parse = function parse(url, options) {
    var parts = this.getUrlParts(url);
    var pathname;
    var query;

    if (!this.isEmpty(parts[1])) {
      if (parts[1].includes('?')) {
        var _parts$1$split = parts[1].split('?');

        var _parts$1$split2 = _slicedToArray(_parts$1$split, 2);

        pathname = _parts$1$split2[0];
        query = _parts$1$split2[1];
      } else {
        pathname = parts[1];
      }
    }

    return this.parseParams(pathname, query, options);
  };

  return VRBOSearchUrlParser;
}(SearchUrlParser_SearchUrlParser);


//# sourceMappingURL=VRBOSearchUrlParser.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/AbritelSearchUrlParser.js
function AbritelSearchUrlParser__extends() { AbritelSearchUrlParser__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AbritelSearchUrlParser__extends.apply(this, arguments); }

function AbritelSearchUrlParser__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }



var AbritelSearchUrlParser =
/*#__PURE__*/
function (_GTSearchUrlParser) {
  AbritelSearchUrlParser__inheritsLoose(AbritelSearchUrlParser, _GTSearchUrlParser);

  function AbritelSearchUrlParser() {
    return _GTSearchUrlParser.apply(this, arguments) || this;
  }

  var _proto = AbritelSearchUrlParser.prototype;

  _proto.parse = function parse(url, options) {
    if (options === void 0) {
      options = {};
    }

    // check if it's a legacy URL. We don't do this client side due to the ginormous data file required to do this.
    if (false) {
      var urlStore = require('../data/abritel_legacy_urls.json');

      var urlParser = require('url');

      var parsedUrl = urlParser.parse(url);
      var pathname = parsedUrl.pathname && parsedUrl.pathname.replace(/_dt\d+.php/, '_dt0.php').replace('%27', "'"); // replace _dt* to support SEO bot requests with non 0 page number

      var queryParams = require('query-string').parse(parsedUrl.query || '');

      var searchTermUuid = urlStore[pathname];

      if (searchTermUuid) {
        return AbritelSearchUrlParser__extends({
          searchTermUuid: searchTermUuid
        }, queryParams);
      } else if (pathname === '/annonces/location-vacances/monde_dt0.php') {
        // world search case
        return AbritelSearchUrlParser__extends({
          regionId: 1
        }, queryParams);
      }
    } // default to normal GT logic


    return _GTSearchUrlParser.prototype.parse.call(this, url, options);
  };

  return AbritelSearchUrlParser;
}(GTSearchUrlParser_GTSearchUrlParser);


//# sourceMappingURL=AbritelSearchUrlParser.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parsers/BrazilSearchUrlParser.js
function BrazilSearchUrlParser__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }



var BrazilSearchUrlParser =
/*#__PURE__*/
function (_GTSearchUrlParser) {
  BrazilSearchUrlParser__inheritsLoose(BrazilSearchUrlParser, _GTSearchUrlParser);

  function BrazilSearchUrlParser() {
    return _GTSearchUrlParser.apply(this, arguments) || this;
  }

  var _proto = BrazilSearchUrlParser.prototype;

  _proto.parse = function parse(url, options) {
    if (options === void 0) {
      options = {};
    }

    if (false) {
      var districtRegion = require('../data/brazil_bairronav_regionAndTerm.json');

      var cityRegion = require('../data/brazil_cidade_regionAndTerm.json');

      var stateRegion = require('../data/brazil_estado_regionAndTerm.json');

      var urlParser = require('url');

      var parsedUrl = urlParser.parse(url);

      var queryParams = require('query-string').parse(parsedUrl.query || ''); // Order matters. Maps are presented here in precision order
      // starting from the most precise one


      var regionMaps = [{
        name: 'BairroNav',
        valueMap: districtRegion
      }, {
        name: 'Cidade',
        valueMap: cityRegion
      }, {
        name: 'Estado',
        valueMap: stateRegion
      }];

      for (var _i = 0; _i < regionMaps.length; _i++) {
        var regionMapObj = regionMaps[_i];
        var regionMapName = regionMapObj.name;

        if (queryParams[regionMapName] && !Array.isArray(queryParams[regionMapName])) {
          var ids = regionMapObj.valueMap[decodeURI(queryParams[regionMapName])];

          if (ids) {
            if (Array.isArray(ids)) {
              return {
                regionId: ids[0],
                searchTermUuid: ids[1]
              };
            }

            return {
              regionId: ids
            };
          }
        }
      }
    } // default to normal GT logic


    return _GTSearchUrlParser.prototype.parse.call(this, url, options);
  };

  return BrazilSearchUrlParser;
}(GTSearchUrlParser_GTSearchUrlParser);


//# sourceMappingURL=BrazilSearchUrlParser.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/parseURL.js







/**
 * Determines whether path matches SERP url pattern
 * SERP path prefix always followed by query parameter
 * Valid SERP urls: '/s?q=Keyword', '/serp?q=Keyword'
 * Not valid: '/search|semester-stugor-laegenhet'
 *
 * @param pathname
 * @returns {boolean}
 */

function isSERPUrl(pathname) {
  return !!pathname.match(/\/(s(?!\w)|serp)/); //
}

var HA_DEFAULT_PARSER = new GTSearchUrlParser_GTSearchUrlParser();
/**
 * Brand specific parsers
 */

var BRAND_PARSERS = {
  vrbo: new VRBOSearchUrlParser_VRBOSearchUrlParser(),
  abritel: new AbritelSearchUrlParser(),
  homeaway_br: new BrazilSearchUrlParser()
};
/**
 * Parses search URLs into Search Request model
 *
 * @param url - search url
 * @param brand - Brand object
 * @param options - {Options}
 * @returns {SearchRequest}
 */

function parseURL(url, brand, options) {
  if (options === void 0) {
    options = {
      onWarning: function onWarning() {}
    };
  }

  var parser;
  var searchRequest = {};
  var brandName = brand.name.toLowerCase();

  if (isSERPUrl(url)) {
    // new URLs
    parser = new SERPSearchUrlParser_SERPSearchUrlParser();
  } else {
    parser = BRAND_PARSERS[brandName] || HA_DEFAULT_PARSER;
  }

  try {
    var decodedUrl = decodeURI(url);
    searchRequest = parser.parse(decodedUrl, options);

    if (brandName === 'vrbo') {
      try {
        var haSearchRequest = HA_DEFAULT_PARSER.parse(decodedUrl, options);

        if (Object.keys(haSearchRequest).length > Object.keys(searchRequest).length) {
          searchRequest = haSearchRequest;
        }
      } catch (e) {} // eslint-disable-line no-empty

    }
  } catch (e) {
    if (options.onWarning) {
      if (e instanceof URIError) {
        options.onWarning("Malformed URL = {" + url + "}");
      } else {
        options.onWarning(e.message);
      }
    }
  } // sync pets


  return petSyncer(searchRequest);
}
//# sourceMappingURL=parseURL.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/toCanonicalURL.js
function toCanonicalURL__extends() { toCanonicalURL__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toCanonicalURL__extends.apply(this, arguments); }






var makeMinValueEnforcer = function makeMinValueEnforcer(searchRequest) {
  return function (key, minValue) {
    var _ref;

    if (minValue === void 0) {
      minValue = 0;
    }

    return toCanonicalURL__extends({}, searchRequest[key] && parseInt(searchRequest[key], 10) > minValue ? (_ref = {}, _ref[key] = searchRequest[key], _ref) : {});
  };
};

var toCanonicalURL_pickCanonicalParams = function pickCanonicalParams(searchRequest) {
  var _extends2;

  var enforceMinValue = makeMinValueEnforcer(searchRequest);
  return toCanonicalURL__extends((_extends2 = {}, _extends2[QUERY] = canonicalizeKeywords(searchRequest[QUERY] || ''), _extends2[FILTER] = searchRequest[FILTER], _extends2), enforceMinValue(MIN_BEDROOMS), enforceMinValue(MIN_BATHROOMS), enforceMinValue(PAGE, 1));
};

function toCanonicalURL(searchRequest, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      hostname = _options.hostname;
  var formatter = new SearchUrlFormatter_SearchUrlFormatter();
  var canonicalSearchRequest = toCanonicalURL_pickCanonicalParams(searchRequest);
  return generateUrl(hostname, formatter.format(canonicalSearchRequest));
}
//# sourceMappingURL=toCanonicalURL.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/search-url-parser/dist/esm/index.js








//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./src/universal/abacus/with-abacus-test-values-as-props/index.js


/* harmony default export */ var abacus_with_abacus_test_values_as_props = (with_abacus_test_values_as_props);
// EXTERNAL MODULE: ./src/universal/recent-activity/components/recent-activity-carousel-container.less
var recent_activity_carousel_container = __webpack_require__("Rw6c");
var recent_activity_carousel_container_default = /*#__PURE__*/__webpack_require__.n(recent_activity_carousel_container);

// CONCATENATED MODULE: ./src/universal/recent-activity/components/recent-activity-carousel-container.js
var _class, recent_activity_carousel_container__withAbacusTestValues;

function recent_activity_carousel_container__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function recent_activity_carousel_container__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function recent_activity_carousel_container__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var testExposureCarousel = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_RECENT_ACTIVITY_TEST"]);

function recent_activity_carousel_container_mapStateToProps(state) {
    var fetchState = selectors.getFetchState(state);
    var cardIndex = selectors.getCardIndex(state);
    var summaries = selectors.getRecentActivityCarousel(state);
    var siteName = getSiteName(state);

    return {
        isEmpty: !summaries.length,
        isLoading: !fetchState.isFetched,
        siteName: siteName,
        summaries: summaries,
        cardIndex: cardIndex
    };
}

var recent_activity_carousel_container_mapDispatchToProps = {
    fetchRecentActivity: recent_activity_actions.fetchRecentActivity,
    changeRecentActivityCardIndex: recent_activity_actions.changeRecentActivityCardIndex
};

var recent_activity_carousel_container_RecentActivityCarouselContainer = Object(es["withRouter"])(_class = function (_Component) {
    recent_activity_carousel_container__inherits(RecentActivityCarouselContainer, _Component);

    function RecentActivityCarouselContainer(props) {
        recent_activity_carousel_container__classCallCheck(this, RecentActivityCarouselContainer);

        var _this = recent_activity_carousel_container__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleArrowClick = function (event, cardIndex) {
            _this.props.changeRecentActivityCardIndex({ cardIndex: cardIndex });
        };

        _this.handleCarouselClick = function (e, scratchpadId, position, startDate, endDate, lbsUuid) {
            if (_this.props.recentActivityTestValue !== 1) {
                _this.props.history.push(universal_routes.RECENT_DETAILS.replace(':linkId', md5_default()(scratchpadId)));
            } else {
                _this.launchSearch(position, startDate, endDate, lbsUuid);
            }
        };

        _this.launchSearch = function (position, startDate, endDate, lbsUuid) {
            var placeUrl = toURL({
                arrival: startDate,
                departure: endDate,
                searchTermUuid: encodeURIComponent(lbsUuid)
            });
            recent_activity_edap.recentActivitySearch(position, _this.props.summaries.length, lbsUuid);
            window.open(placeUrl, _this.props.isMobile ? '_self' : '_blank');
        };

        _this.carouselExposure = function () {
            testExposureCarousel.trigger(experiments["HA_PULSE_RECENT_ACTIVITY_TEST"]);
        };

        _this.getTitle = function () {
            var _this$props = _this.props,
                recentActivityTestValue = _this$props.recentActivityTestValue,
                title = _this$props.title,
                altTitle = _this$props.altTitle;

            return recentActivityTestValue !== 1 ? title : altTitle;
        };

        return _this;
    }

    RecentActivityCarouselContainer.prototype.componentDidMount = function componentDidMount() {
        this.props.fetchRecentActivity();
    };

    RecentActivityCarouselContainer.prototype.render = function render() {
        var _props = this.props,
            cardIndex = _props.cardIndex,
            isLoading = _props.isLoading,
            isEmpty = _props.isEmpty,
            isMobile = _props.isMobile,
            summaries = _props.summaries,
            recentActivityTestValue = _props.recentActivityTestValue;


        if (isLoading || isEmpty) {
            return null;
        }

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'recent-activity-summary__carousel' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                lib_transpiled["Waypoint"],
                {
                    label: 'waypoint-recent-activity-test-exposure',
                    onEnter: this.carouselExposure
                },
                recentActivityTestValue !== 2 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_recent_activity_carousel_lib_transpiled["RecentActivityStateless"], {
                    cardIndex: cardIndex,
                    isMobile: isMobile,
                    onArrowClick: this.handleArrowClick,
                    onClick: this.handleCarouselClick,
                    title: this.getTitle(),
                    summaries: summaries
                })
            )
        );
    };

    return RecentActivityCarouselContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"])) || _class;

recent_activity_carousel_container_RecentActivityCarouselContainer.defaultProps = {
    summaries: []
};
/* harmony default export */ var components_recent_activity_carousel_container = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(abacus_with_abacus_test_values_as_props((recent_activity_carousel_container__withAbacusTestValues = {}, recent_activity_carousel_container__withAbacusTestValues[experiments["HA_PULSE_RECENT_ACTIVITY_TEST"]] = 'recentActivityTestValue', recent_activity_carousel_container__withAbacusTestValues)), withTranslationsAsProps({
    'header.scratchpadSummary.messages.scratchpadActivity': 'title',
    'scratchpad.recentActivity.recentSearches': 'altTitle'
}), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(recent_activity_carousel_container_mapStateToProps, recent_activity_carousel_container_mapDispatchToProps))(react_determine_if_mobile_lib_transpiled_default()(recent_activity_carousel_container_RecentActivityCarouselContainer, 767)));
// CONCATENATED MODULE: ./src/universal/recent-activity/components/index.js



// EXTERNAL MODULE: ./node_modules/@homeaway/redux-middleware-adapter/lib/index.js
var redux_middleware_adapter_lib = __webpack_require__("UNM8");
var redux_middleware_adapter_lib_default = /*#__PURE__*/__webpack_require__.n(redux_middleware_adapter_lib);

// CONCATENATED MODULE: ./src/universal/recent-activity/middleware.js






function doRecentActivityFetch(store) {
    store.dispatch(recent_activity_actions.fetchRecentActivityStart());

    fetch(API + '/recent-activity/fullV1', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'GET',
        credentials: 'include'
    }).then(checkStatus).then(function (r) {
        return r.json();
    }).then(function (recentActivity) {
        store.dispatch(recent_activity_actions.fetchRecentActivitySuccess(recentActivity));
    }).catch(function (error) {
        store.dispatch(recent_activity_actions.fetchRecentActivityError(error));
    });
}

function registerAllMiddleware() {
    Object(redux_middleware_adapter_lib["registerMiddleware"])(recent_activity_actions.FETCH_RECENT_ACTIVITY, doRecentActivityFetch);
}

/* harmony default export */ var middleware = (registerAllMiddleware);
// CONCATENATED MODULE: ./src/universal/recent-activity/index.js






// CONCATENATED MODULE: ./src/universal/tripboard/actions.js
var tripboard_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* istanbul ignore next */
var tripboard_actions_ACTIONS = {
    FETCH_PREVIEWS: 'FETCH_PREVIEWS',
    FETCH_PREVIEWS_START: 'FETCH_PREVIEWS_START',
    FETCH_PREVIEWS_SUCCESS: 'FETCH_PREVIEWS_SUCCESS',
    FETCH_PREVIEWS_ERROR: 'FETCH_PREVIEWS_ERROR',
    FETCH_DETAILS: 'FETCH_DETAILS',
    FETCH_DETAILS_START: 'FETCH_DETAILS_START',
    FETCH_DETAILS_SUCCESS: 'FETCH_DETAILS_SUCCESS',
    FETCH_DETAILS_ERROR: 'FETCH_DETAILS_ERROR',
    FETCH_COLLABORATOR_COUNT: 'FETCH_COLLABORATOR_COUNT',
    FETCH_COLLABORATOR_COUNT_START: 'FETCH_COLLABORATOR_COUNT_START',
    FETCH_COLLABORATOR_COUNT_SUCCESS: 'FETCH_COLLABORATOR_COUNT_SUCCESS',
    FETCH_COLLABORATOR_COUNT_ERROR: 'FETCH_COLLABORATOR_COUNT_ERROR',
    DELETE_TRIPBOARD: 'DELETE_TRIPBOARD',
    DELETE_TRIPBOARD_START: 'DELETE_TRIPBOARD_START',
    DELETE_TRIPBOARD_SUCCESS: 'DELETE_TRIPBOARD_SUCCESS',
    DELETE_TRIPBOARD_ERROR: 'DELETE_TRIPBOARD_ERROR',
    DELETE_TRIPBOARD_LISTING: 'DELETE_TRIPBOARD_LISTING',
    DELETE_TRIPBOARD_LISTING_START: 'DELETE_TRIPBOARD_LISTING_START',
    DELETE_TRIPBOARD_LISTING_SUCCESS: 'DELETE_TRIPBOARD_LISTING_SUCCESS',
    DELETE_TRIPBOARD_LISTING_ERROR: 'DELETE_TRIPBOARD_LISTING_ERROR',
    RENAME_TRIPBOARD: 'RENAME_TRIPBOARD',
    RENAME_TRIPBOARD_START: 'RENAME_TRIPBOARD_START',
    RENAME_TRIPBOARD_SUCCESS: 'RENAME_TRIPBOARD_SUCCESS',
    RENAME_TRIPBOARD_ERROR: 'RENAME_TRIPBOARD_ERROR',
    DELETE_TRIPBOARD_DATES: 'DELETE_TRIPBOARD_DATES',
    DELETE_TRIPBOARD_DATES_START: 'DELETE_TRIPBOARD_DATES_START',
    DELETE_TRIPBOARD_DATES_SUCCESS: 'DELETE_TRIPBOARD_DATES_SUCCESS',
    DELETE_TRIPBOARD_DATES_ERROR: 'DELETE_TRIPBOARD_DATES_ERROR',
    UPDATE_TRIPBAORD_DATES: 'UPDATE_TRIPBAORD_DATES',
    UPDATE_TRIPBAORD_DATES_START: 'UPDATE_TRIPBAORD_DATES_START',
    UPDATE_TRIPBAORD_DATES_SUCCESS: 'UPDATE_TRIPBAORD_DATES_SUCCESS',
    UPDATE_TRIPBAORD_DATES_ERROR: 'UPDATE_TRIPBAORD_DATES_ERROR',
    SET_CURRENT_TRIPBOARD: 'SET_CURRENT_TRIPBOARD',
    CREATE_TRIPBOARD_INVITATION: 'CREATE_TRIPBOARD_INVITATION',
    CREATE_TRIPBOARD_INVITATION_START: 'CREATE_TRIPBOARD_INVITATION_START',
    CREATE_TRIPBOARD_INVITATION_SUCCESS: 'CREATE_TRIPBOARD_INVITATION_SUCCESS',
    CREATE_TRIPBOARD_INVITATION_ERROR: 'CREATE_TRIPBOARD_INVITATION_ERROR',
    COMPLETED_TRIPBOARD_ONBOARDING: 'COMPLETED_TRIPBOARD_ONBOARDING'
};

/* istanbul ignore next */
var tripboard_actions_ACTION_CREATORS = {
    fetchCollaboratorCount: function fetchCollaboratorCount(boardId) {
        return { type: tripboard_actions_ACTIONS.FETCH_COLLABORATOR_COUNT, payload: { boardId: boardId } };
    },
    deleteTripboardListing: function deleteTripboardListing(boardId, listingId) {
        return { type: tripboard_actions_ACTIONS.DELETE_TRIPBOARD_LISTING, payload: { boardId: boardId, listingId: listingId } };
    },
    renameTripboard: function renameTripboard(boardId, name) {
        return { type: tripboard_actions_ACTIONS.RENAME_TRIPBOARD, payload: { boardId: boardId, name: name } };
    },
    deleteTripboardDates: function deleteTripboardDates(boardId) {
        return { type: tripboard_actions_ACTIONS.DELETE_TRIPBOARD_DATES, payload: { boardId: boardId } };
    },
    updateTripboardDates: function updateTripboardDates(boardId, startDate, endDate) {
        return {
            type: tripboard_actions_ACTIONS.UPDATE_TRIPBAORD_DATES,
            payload: { boardId: boardId, startDate: startDate, endDate: endDate }
        };
    },
    setCurrentTripboard: function setCurrentTripboard(boardId) {
        return { type: tripboard_actions_ACTIONS.SET_CURRENT_TRIPBOARD, payload: { boardId: boardId } };
    },
    createInvitation: function createInvitation(boardId) {
        return { type: tripboard_actions_ACTIONS.CREATE_TRIPBOARD_INVITATION, payload: { boardId: boardId } };
    },
    completeOnboarding: function completeOnboarding() {
        return { type: tripboard_actions_ACTIONS.COMPLETED_TRIPBOARD_ONBOARDING };
    }
};

/* harmony default export */ var tripboard_actions = (tripboard_actions__extends({}, tripboard_actions_ACTIONS, tripboard_actions_ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/actions.js
var collaborate_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var collaborate_actions_NAMESPACE = 'COLLABORATE';
var collaborate_actions_ACTIONS = {
    COLLABORATE: collaborate_actions_NAMESPACE + '_COLLABORATE',
    FETCH_COUNT: collaborate_actions_NAMESPACE + '_FETCH_COUNT',
    FETCH_COUNT_START: collaborate_actions_NAMESPACE + '_FETCH_COUNT_START',
    FETCH_COUNT_SUCCESS: collaborate_actions_NAMESPACE + '_FETCH_COUNT_SUCCESS',
    FETCH_COUNT_ERROR: collaborate_actions_NAMESPACE + '_FETCH_COUNT_ERROR',
    FETCH_INVITE: collaborate_actions_NAMESPACE + '_FETCH_INVITE',
    FETCH_INVITE_ERROR: collaborate_actions_NAMESPACE + '_FETCH_INVITE_ERROR',
    FETCH_INVITE_START: collaborate_actions_NAMESPACE + '_FETCH_INVITE_START',
    FETCH_INVITE_SUCCESS: collaborate_actions_NAMESPACE + '_FETCH_INVITE_SUCCESS',
    FETCH_LOGIN: collaborate_actions_NAMESPACE + '_FETCH_LOGIN',
    FETCH_LOGIN_ERROR: collaborate_actions_NAMESPACE + '_FETCH_LOGIN_ERROR',
    FETCH_LOGIN_START: collaborate_actions_NAMESPACE + '_FETCH_LOGIN_START',
    FETCH_LOGIN_SUCCESS: collaborate_actions_NAMESPACE + '_FETCH_LOGIN_SUCCESS',
    RESET: collaborate_actions_NAMESPACE + '_RESET'
};

/* istanbul ignore next */
var collaborate_actions_ACTION_CREATORS = {
    collaborate: function collaborate() {
        return { type: collaborate_actions_ACTIONS.COLLABORATE };
    },
    fetchCount: function fetchCount(boardId) {
        return { type: collaborate_actions_ACTIONS.FETCH_COUNT, payload: { boardId: boardId } };
    },
    invite: function invite(boardId) {
        return { type: collaborate_actions_ACTIONS.FETCH_INVITE, payload: { boardId: boardId } };
    },
    login: function login(fullLocale, siteName) {
        return { type: collaborate_actions_ACTIONS.FETCH_LOGIN, payload: { fullLocale: fullLocale, siteName: siteName } };
    },
    reset: function reset() {
        return { type: collaborate_actions_ACTIONS.RESET };
    }
};

/* harmony default export */ var collaborate_actions = (collaborate_actions__extends({}, collaborate_actions_ACTIONS, collaborate_actions_ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/selectors.js


var getCollaborateState = function getCollaborateState(state) {
    return state.tripboard.collaborate;
};

var getCountState = Object(reselect_lib["createSelector"])(getCollaborateState, function (state) {
    return state.count;
});

var getModalState = Object(reselect_lib["createSelector"])(getCollaborateState, function (state) {
    return state.modal;
});
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/state.js





function state_mapStateToProps(state) {
    var _getModalState = getModalState(state),
        error = _getModalState.error,
        inviteUrl = _getModalState.inviteUrl,
        isModalOpen = _getModalState.isModalOpen,
        loading = _getModalState.loading,
        loginUrl = _getModalState.loginUrl;

    return {
        error: error,
        fullLocale: getFullLocale(state),
        inviteUrl: inviteUrl,
        isMobile: getIsMobile(state),
        isOpen: isModalOpen,
        loading: loading,
        loginUrl: loginUrl,
        siteName: getSiteName(state)
    };
}

var state_mapDispatchToProps = {
    collaborate: collaborate_actions.collaborate,
    invite: collaborate_actions.invite,
    login: collaborate_actions.login,
    reset: collaborate_actions.reset
};

function withCollaborateState(Component) {
    return Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(state_mapStateToProps, state_mapDispatchToProps)(Component);
}
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invite-share-button.js
function invite_share_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function invite_share_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function invite_share_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CollaborateIcon = {
    INVITE: COLLABORATE__24,
    SHARE: esm["SHARE__16"]
};

var CollaborateType = {
    INVITE: 'invite',
    SHARE: 'share'
};

var invite_share_button_CollaborateButton = function (_Component) {
    invite_share_button__inherits(CollaborateButton, _Component);

    function CollaborateButton(props) {
        invite_share_button__classCallCheck(this, CollaborateButton);

        var _this = invite_share_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onClick = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                collaborate = _this$props.collaborate,
                endDate = _this$props.endDate,
                startDate = _this$props.startDate;

            collaborate();
            collaborate_edap.buttonClick(boardId, endDate, startDate);
        };

        return _this;
    }

    CollaborateButton.prototype.componentDidMount = function componentDidMount() {
        this.props.reset();
    };

    CollaborateButton.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return false;
    };

    CollaborateButton.prototype.componentWillUnmount = function componentWillUnmount() {
        this.props.reset();
    };

    CollaborateButton.prototype.render = function render() {
        var _props = this.props,
            label = _props.label,
            type = _props.type;

        var svgMarkup = type === CollaborateType.INVITE ? CollaborateIcon.INVITE : CollaborateIcon.SHARE;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIcon"], {
            circle: true,
            className: 'btn-icon-responsive',
            label: label,
            onClick: this.onClick,
            svgMarkup: svgMarkup,
            size: 'sm'
        });
    };

    return CollaborateButton;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

invite_share_button_CollaborateButton.defaultProps = {
    boardId: null,
    collaborate: function collaborate() {},
    reset: function reset() {},
    label: '',
    type: '' // CollaborateType
};
/* harmony default export */ var invite_share_button = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withCollaborateState, withTranslationsAsProps({
    'tripboards.share.text': 'label'
}))(invite_share_button_CollaborateButton));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/collaborator-count.js
var collaborator_count__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function collaborator_count__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collaborator_count__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collaborator_count__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CollaboratorCountState = function (_Component) {
    collaborator_count__inherits(CollaboratorCountState, _Component);

    function CollaboratorCountState() {
        collaborator_count__classCallCheck(this, CollaboratorCountState);

        return collaborator_count__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    CollaboratorCountState.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            boardId = _props.boardId,
            fetch = _props.fetch;

        fetch(boardId);
    };

    CollaboratorCountState.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        var loading = nextProps.loading;
        var props = this.props;

        return loading !== props.loading;
    };

    CollaboratorCountState.prototype.render = function render() {
        var children = this.props.children;

        return children(collaborator_count__extends({}, this.props));
    };

    return CollaboratorCountState;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

CollaboratorCountState.defaultProps = {
    boardId: null,
    count: 0,
    error: false,
    fetch: function fetch() {},
    loading: true,
    text: ''
};
function collaborator_count_mapStateToProps(state) {
    var _getCountState = getCountState(state),
        count = _getCountState.count,
        loading = _getCountState.loading,
        text = _getCountState.text;

    return {
        count: count,
        loading: loading,
        text: text
    };
}

var collaborator_count_mapDispatchToProps = {
    fetch: collaborate_actions.fetchCount
};

var CollaboratorCountProvider = Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(collaborator_count_mapStateToProps, collaborator_count_mapDispatchToProps)(CollaboratorCountState);

function CollaboratorCount(_ref) {
    var error = _ref.error,
        count = _ref.count,
        loading = _ref.loading,
        text = _ref.text;

    if (error || loading) {
        return null;
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        { className: 'padding-right-2x collaborator-count' },
        count > 1 && text
    );
}

/* harmony default export */ var collaborator_count = (function (_ref2) {
    var boardId = _ref2.boardId;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        CollaboratorCountProvider,
        { boardId: boardId },
        function (props) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(CollaboratorCount, props);
        }
    );
});
// EXTERNAL MODULE: ./src/universal/tripboard/collaborate/components/collaborator-display.less
var collaborator_display = __webpack_require__("4ZAL");
var collaborator_display_default = /*#__PURE__*/__webpack_require__.n(collaborator_display);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/collaborator-display.js
function collaborator_display__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collaborator_display__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collaborator_display__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var collaboratorFilter = function collaboratorFilter(collaborator) {
    return collaborator && collaborator.profile;
};

var collaborator_display_CollaboratorDisplay = function (_Component) {
    collaborator_display__inherits(CollaboratorDisplay, _Component);

    function CollaboratorDisplay() {
        var _temp, _this, _ret;

        collaborator_display__classCallCheck(this, CollaboratorDisplay);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = collaborator_display__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.capitalizeInitial = function (name) {
            return name && name.length > 0 && name.charAt(0).toUpperCase() || '';
        }, _this.capitalizeName = function (name) {
            return '' + _this.capitalizeInitial(name) + name.slice(1);
        }, _this.generateInitials = function (profile) {
            return profile && '' + _this.capitalizeInitial(profile.firstName) + _this.capitalizeInitial(profile.lastName) || '';
        }, _this.generateRemainderInitials = function (remainder) {
            return remainder.filter(collaboratorFilter).map(function (collaborator) {
                return _this.capitalizeName(collaborator.profile && collaborator.profile.firstName || '') + ' ' + _this.capitalizeInitial(collaborator.profile && collaborator.profile.lastName || '') + '.';
            }).join(', ');
        }, _this.hasImage = function (profile) {
            return !!profile && profile.publicImageUrl && profile.publicImageUrl !== '' && profile.publicImageUrl.indexOf('default-profile-pic.png') === -1;
        }, _temp), collaborator_display__possibleConstructorReturn(_this, _ret);
    }

    CollaboratorDisplay.prototype.render = function render() {
        var _this2 = this;

        var _props$users = this.props.users,
            collaborators = _props$users === undefined ? [] : _props$users;


        var remainder = [];
        var collaboratorDisplayLimit = 7;
        var collaboratorAnimationDelay = 50;
        if (collaborators.length > collaboratorDisplayLimit) {
            remainder = collaborators.slice(collaboratorDisplayLimit, collaborators.length);
            collaborators = collaborators.slice(0, collaboratorDisplayLimit);
        }
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'tripboard-details-collaborators' },
            remainder.length > 0 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                react_tooltip_lib_transpiled_default.a,
                {
                    content: this.generateRemainderInitials(remainder),
                    wrapperStyle: { zIndex: collaborators.length }
                },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    {
                        style: { animationDelay: collaboratorAnimationDelay + 'ms' },
                        className: 'tripboard-details-collaborators__collaborator'
                    },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'tripboard-details-collaborators__collaborator-display' },
                        '+' + remainder.length
                    )
                )
            ),
            collaborators.filter(collaboratorFilter).map(function (_ref, index) {
                var profile = _ref.profile;

                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    react_tooltip_lib_transpiled_default.a,
                    {
                        content: _this2.capitalizeName(profile && profile.firstName || '') + ' ' + _this2.capitalizeName(profile && profile.lastName || ''),
                        wrapperStyle: { zIndex: '' + (collaborators.length - 1 - index) },
                        key: index
                    },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        {
                            style: { animationDelay: (index + 1) * collaboratorAnimationDelay + 'ms' },
                            className: 'tripboard-details-collaborators__collaborator'
                        },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'tripboard-details-collaborators__collaborator-display',
                                style: _this2.hasImage(profile) ? { backgroundImage: 'url(' + profile.publicImageUrl + ')' } : {}
                            },
                            _this2.hasImage(profile) ? '' : _this2.generateInitials(profile)
                        )
                    )
                );
            })
        );
    };

    return CollaboratorDisplay;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

collaborator_display_CollaboratorDisplay.propTypes = {
    users: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape({
        profile: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.object
    }))
};
collaborator_display_CollaboratorDisplay.defaultProps = {
    users: []
};


/* harmony default export */ var components_collaborator_display = (collaborator_display_CollaboratorDisplay);
// EXTERNAL MODULE: ./src/universal/tripboard/components/three-pack.less
var three_pack = __webpack_require__("vIb5");
var three_pack_default = /*#__PURE__*/__webpack_require__.n(three_pack);

// EXTERNAL MODULE: ./src/universal/abacus/skeleton-abc/skeleton-loading.less
var skeleton_loading = __webpack_require__("k//m");
var skeleton_loading_default = /*#__PURE__*/__webpack_require__.n(skeleton_loading);

// CONCATENATED MODULE: ./src/universal/abacus/skeleton-abc/skeleton-hidden.js



function SkeletonHidden(_ref) {
    var loading = _ref.loading,
        children = _ref.children;

    if (!loading) {
        return children;
    }

    var SKELETON_CLASS = 'skeleton-hidden';
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Children.map(children, function (child) {
        var className = child.props.className || '';
        className = className.length ? className + ' ' + SKELETON_CLASS : SKELETON_CLASS;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.cloneElement(child, { className: className });
    });
}

/* harmony default export */ var skeleton_hidden = (SkeletonHidden);
// CONCATENATED MODULE: ./src/universal/abacus/skeleton-abc/skeleton-loading.js



function SkeletonLoading(_ref) {
    var loading = _ref.loading,
        children = _ref.children;

    if (!loading) {
        return children;
    }

    var SKELETON_CLASS = 'skeleton-loading';
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Children.map(children, function (child) {
        var className = child.props.className || '';
        className = className.length ? className + ' ' + SKELETON_CLASS : SKELETON_CLASS;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.cloneElement(child, { className: className });
    });
}

/* harmony default export */ var skeleton_abc_skeleton_loading = (SkeletonLoading);
// CONCATENATED MODULE: ./src/universal/abacus/skeleton-abc/index.js





var skeleton_abc_testExposure = new test_exposure_once_TestExposureOnce(experiments["SKELETON_ABC"]);

// CONCATENATED MODULE: ./src/universal/tripboard/components/three-pack.js
function three_pack__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function three_pack__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function three_pack__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Abacus: HA_PULSE_SKELETON_ABC


var three_pack_ThreePack = function (_Component) {
    three_pack__inherits(ThreePack, _Component);

    function ThreePack() {
        three_pack__classCallCheck(this, ThreePack);

        return three_pack__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ThreePack.prototype.render = function render() {
        var _props = this.props,
            image1 = _props.image1,
            image2 = _props.image2,
            image3 = _props.image3,
            isLoading = _props.isLoading;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'three-pack' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'three-pack__grid' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'three-pack__column' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        skeleton_abc_skeleton_loading,
                        { loading: isLoading },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__image three-pack__image--rounded-top-and-bottom-left three-pack__image--left-panel', style: image1 ? { backgroundImage: 'url(' + image1 + ')' } : {} })
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__separator' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'three-pack__column' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        skeleton_abc_skeleton_loading,
                        { loading: isLoading },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__image three-pack__image--rounded-top-right', style: image2 ? { backgroundImage: 'url(' + image2 + ')' } : {} })
                    ),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__separator' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        skeleton_abc_skeleton_loading,
                        { loading: isLoading },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__image three-pack__image--rounded-bottom-right', style: image3 ? { backgroundImage: 'url(' + image3 + ')' } : {} })
                    )
                )
            )
        );
    };

    return ThreePack;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

three_pack_ThreePack.propTypes = {
    image1: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    image2: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    image3: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};


/* harmony default export */ var components_three_pack = (three_pack_ThreePack);
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/preview-card.js
var preview_card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function preview_card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function preview_card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function preview_card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function getListingImages() {
    var listings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var images = [];
    var ids = Object.keys(listings);
    for (var index = 0; index < ids.length; index++) {
        var listing = listings[ids[index]];
        if (images.length === 3) {
            break;
        }
        if (listing && listing.galleryUrl) {
            var image = getImageUrl(listing.galleryUrl, C1);
            images.push(image);
        }
    }
    return {
        image1: images[0],
        image2: images[1],
        image3: images[2]
    };
}

var preview_card_ModalCard = function (_Component) {
    preview_card__inherits(ModalCard, _Component);

    function ModalCard(props) {
        preview_card__classCallCheck(this, ModalCard);

        var _this = preview_card__possibleConstructorReturn(this, _Component.call(this, props));

        _this.getPreviewImages = function () {
            var listings = _this.props.listings;

            var imageProps = getListingImages(listings);
            _this.setState(preview_card__extends({}, imageProps));
        };

        _this.state = {
            image1: null,
            image2: null,
            image3: null
        };
        return _this;
    }

    ModalCard.prototype.componentDidMount = function componentDidMount() {
        this.getPreviewImages();
    };

    ModalCard.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var image1 = nextState.image1;
        var state = this.state;

        return image1 !== state.image1;
    };

    ModalCard.prototype.render = function render() {
        var _state = this.state,
            image1 = _state.image1,
            image2 = _state.image2,
            image3 = _state.image3;
        var name = this.props.name;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'card collab-modal__card' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'h6',
                { className: 'collab-modal__card-name' },
                name
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_three_pack, {
                image1: image1,
                image2: image2,
                image3: image3
            })
        );
    };

    return ModalCard;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

preview_card_ModalCard.defaultProps = {
    listings: []
};
/* harmony default export */ var preview_card = (preview_card_ModalCard);
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invite-login.js
function invite_login__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function invite_login__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function invite_login__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var invite_login_InviteLogin = function (_Component) {
    invite_login__inherits(InviteLogin, _Component);

    function InviteLogin(props) {
        invite_login__classCallCheck(this, InviteLogin);

        return invite_login__possibleConstructorReturn(this, _Component.call(this, props));
    }

    InviteLogin.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            fetch = _props.fetch,
            fullLocale = _props.fullLocale,
            siteName = _props.siteName;

        fetch(fullLocale, siteName);
    };

    InviteLogin.prototype.render = function render() {
        var _props2 = this.props,
            desc = _props2.desc,
            error = _props2.error,
            errorLogin = _props2.errorLogin,
            labelLogin = _props2.labelLogin,
            loginUrl = _props2.loginUrl,
            title = _props2.title;

        var errorMsg = error ? errorLogin : null;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'h5',
                { className: 'flex-row' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'margin-right-1x', markup: COLLABORATE__24 }),
                title
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'p',
                null,
                desc
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'flex flex-align-items-center' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], {
                    href: loginUrl,
                    label: labelLogin,
                    disabled: error
                }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    { className: 'login-fetch-error' },
                    errorMsg
                )
            )
        );
    };

    return InviteLogin;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

invite_login_InviteLogin.defaultProps = {
    error: null,
    errorLogin: '',
    fetch: function fetch() {},
    fullLocale: '',
    labelLogin: '',
    labelSignUp: '',
    loading: false,
    loginUrl: '',
    siteName: '',
    translations: {}
};
/* harmony default export */ var invite_login = (withTranslationsAsProps({
    'tripboards.invite.desc.logged.out': 'desc',
    'tripboards.invite.collaborators': 'title',
    'tripboards.invite.login': 'labelLogin',
    'tripboards.invite.signup': 'labelSignUp',
    'th.inbox.error.title': 'errorLogin'
})(invite_login_InviteLogin));
// EXTERNAL MODULE: ./src/universal/components/copy-input/copy-input.less
var copy_input = __webpack_require__("aUQ4");
var copy_input_default = /*#__PURE__*/__webpack_require__.n(copy_input);

// CONCATENATED MODULE: ./src/universal/components/copy-input/copy-input.js
var copy_input__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function copy_input__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function copy_input__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function copy_input__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function copy_input__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function selectRange($input) {
    if (!$input.setSelectionRange || !window.getSelection || !document.createRange) {
        return null;
    }

    var range = document.createRange();
    var selection = window.getSelection();

    range.selectNodeContents($input);
    selection.removeAllRanges();
    selection.addRange(range);
    $input.setSelectionRange(0, $input.value.length);
    return selection;
}

function removeRange(selection) {
    if (!selection || !selection.removeAllRanges) {
        return;
    }
    selection.removeAllRanges();
}

var copy_input_CopyInput = function (_Component) {
    copy_input__inherits(CopyInput, _Component);

    function CopyInput(props) {
        copy_input__classCallCheck(this, CopyInput);

        var _this = copy_input__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleCopyClick = function () {
            var input = _this.formInput.input;
            var _this$props = _this.props,
                isMobile = _this$props.isMobile,
                onCopyClick = _this$props.onCopyClick;

            onCopyClick();
            if (!input) {
                return;
            }
            input.select();

            // SCRATCHPAD-2028 iOS needs range selectors for execCommand, this breaks in IE 11 so we only call them if isMobile
            var selection = isMobile ? selectRange(input) : null;

            try {
                var isCopied = document.execCommand('copy');
                _this.setState({ isCopied: isCopied });
            } catch (e) {
                client_logger.captureException(e);
            }

            if (selection) {
                removeRange(selection);
            }
        };

        _this.formInput = {}; // <FormInput/> ref
        _this.state = {
            isCopied: false
        };
        return _this;
    }

    CopyInput.prototype.render = function render() {
        var _this2 = this;

        var isCopied = this.state.isCopied;

        var _props = this.props,
            copiedText = _props.copiedText,
            copyText = _props.copyText,
            errorMsg = _props.errorMsg,
            onCopyUrl = _props.onCopyUrl,
            onCutUrl = _props.onCutUrl,
            value = _props.value,
            rest = copy_input__objectWithoutProperties(_props, ['copiedText', 'copyText', 'errorMsg', 'onCopyUrl', 'onCutUrl', 'value']);

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'copy-input__container' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'input-group' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'input-group-wrapper' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_form_components_lib_transpiled["FormInput"], copy_input__extends({
                        className: 'copy-input__form-group',
                        errorMsg: errorMsg,
                        inputClassName: 'copy-input__input',
                        label: copyText,
                        onCopy: onCopyUrl,
                        onCut: onCutUrl,
                        ref: function ref(formInput) {
                            return _this2.formInput = formInput;
                        },
                        srOnlyLabel: true,
                        value: value
                    }, rest))
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    { className: 'input-group-btn' },
                    isCopied && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        react_buttons_lib_transpiled["ButtonPrimary"],
                        {
                            block: true,
                            className: 'copy-input__btn',
                            label: copiedText,
                            onClick: this.handleCopyClick
                        },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'copy-input__svg', markup: esm["CHECK__16"] })
                    ),
                    !isCopied && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
                        block: true,
                        className: 'copy-input__btn grey ' + (errorMsg ? 'has-error' : ''),
                        disabled: !!errorMsg,
                        label: copyText,
                        onClick: this.handleCopyClick
                    })
                )
            )
        );
    };

    return CopyInput;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

copy_input_CopyInput.defaultProps = {
    errorMsg: null,
    isMobile: false,
    onCopyClick: function onCopyClick() {},
    onCopyUrl: function onCopyUrl() {},
    onCutUrl: function onCutUrl() {},
    value: ''
};
/* harmony default export */ var copy_input_copy_input = (withTranslationsAsProps({
    'tripboards.copied': 'copiedText',
    'tripboards.copy': 'copyText'
})(copy_input_CopyInput));
// CONCATENATED MODULE: ./src/universal/components/copy-input/index.js




// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invite-url.js
function invite_url__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function invite_url__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function invite_url__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var invite_url_InviteUrl = function (_Component) {
    invite_url__inherits(InviteUrl, _Component);

    function InviteUrl(props) {
        invite_url__classCallCheck(this, InviteUrl);

        var _this = invite_url__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onCopyClick = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                endDate = _this$props.endDate,
                startDate = _this$props.startDate;

            collaborate_edap.copyClick(boardId, endDate, startDate, TYPES.INVITE);
        };

        _this.onCopyUrl = function () {
            var _this$props2 = _this.props,
                boardId = _this$props2.boardId,
                endDate = _this$props2.endDate,
                startDate = _this$props2.startDate;

            collaborate_edap.copyUrl(boardId, endDate, startDate, TYPES.INVITE);
        };

        _this.onCutUrl = function () {
            var _this$props3 = _this.props,
                boardId = _this$props3.boardId,
                endDate = _this$props3.endDate,
                startDate = _this$props3.startDate;

            collaborate_edap.cutUrl(boardId, endDate, startDate, TYPES.INVITE);
        };

        return _this;
    }

    InviteUrl.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            boardId = _props.boardId,
            fetch = _props.fetch;

        fetch(boardId);
    };

    InviteUrl.prototype.render = function render() {
        var _props2 = this.props,
            desc = _props2.desc,
            error = _props2.error,
            isMobile = _props2.isMobile,
            langError = _props2.langError,
            title = _props2.title,
            url = _props2.url;

        var errorMsg = error ? langError : null;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'position-relative' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'h5',
                { className: 'flex-row' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'margin-right-2x', markup: COLLABORATE__24 }),
                title
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(copy_input_copy_input, {
                errorMsg: errorMsg,
                isMobile: isMobile,
                id: 'trip-board-invite-url',
                onCopyClick: this.onCopyClick,
                onCopyUrl: this.onCopyUrl,
                onCutUrl: this.onCutUrl,
                value: url || ''
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'span',
                { className: 'help-block' },
                desc
            )
        );
    };

    return InviteUrl;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

invite_url_InviteUrl.defaultProps = {
    boardId: null,
    desc: '',
    endDate: null,
    error: null,
    fetch: function fetch() {},
    langError: '',
    startDate: null,
    title: '',
    url: ''
};
/* harmony default export */ var invite_url = (withTranslationsAsProps({
    'tripboards.invite.desc': 'desc',
    'th.inbox.error.title': 'langError',
    'tripboards.invite.collaborators': 'title'
})(invite_url_InviteUrl));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/share-url.js
function share_url__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function share_url__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function share_url__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var share_url_ShareUrl = function (_Component) {
    share_url__inherits(ShareUrl, _Component);

    function ShareUrl() {
        var _temp, _this, _ret;

        share_url__classCallCheck(this, ShareUrl);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = share_url__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onCopyClick = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                endDate = _this$props.endDate,
                startDate = _this$props.startDate;

            collaborate_edap.copyClick(boardId, endDate, startDate, TYPES.SHARE);
        }, _this.onCopyUrl = function () {
            var _this$props2 = _this.props,
                boardId = _this$props2.boardId,
                endDate = _this$props2.endDate,
                startDate = _this$props2.startDate;

            collaborate_edap.copyUrl(boardId, endDate, startDate, TYPES.SHARE);
        }, _this.onCutUrl = function () {
            var _this$props3 = _this.props,
                boardId = _this$props3.boardId,
                endDate = _this$props3.endDate,
                startDate = _this$props3.startDate;

            collaborate_edap.cutUrl(boardId, endDate, startDate, TYPES.SHARE);
        }, _temp), share_url__possibleConstructorReturn(_this, _ret);
    }

    // withRouter causes unnecessary renders
    ShareUrl.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return false;
    };

    ShareUrl.prototype.render = function render() {
        var _props = this.props,
            desc = _props.desc,
            isMobile = _props.isMobile,
            location = _props.location,
            title = _props.title;

        var url = window.location.protocol + '//' + window.location.host + location.pathname;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'h5',
                { className: 'flex-row' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'margin-right-2x', markup: esm["SHARE__24"] }),
                title
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(copy_input_copy_input, {
                id: 'trip-board-share-url',
                isMobile: isMobile,
                onCopyClick: this.onCopyClick,
                onCopyUrl: this.onCopyUrl,
                onCutUrl: this.onCutUrl,
                value: url
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'span',
                { className: 'help-block' },
                desc
            )
        );
    };

    return ShareUrl;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

share_url_ShareUrl.defaultProps = {
    boardId: null,
    endDate: null,
    desc: '',
    location: {},
    startDate: null,
    title: '' };
/* harmony default export */ var share_url = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(es["withRouter"], withTranslationsAsProps({
    'tripboards.share.desc': 'desc',
    'tripboards.share.link': 'title'
}))(share_url_ShareUrl));
// EXTERNAL MODULE: ./src/universal/tripboard/collaborate/components/collaborate.less
var components_collaborate = __webpack_require__("iEo0");
var collaborate_default = /*#__PURE__*/__webpack_require__.n(components_collaborate);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invite-share-modal.js














function Divider(_ref) {
    var text = _ref.text;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'collab-modal__divider' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('hr', { className: 'collab-modal__divider-hr' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'collab-modal__divider-text' },
            text
        )
    );
}

function CollaborateModal(_ref2) {
    var boardId = _ref2.boardId,
        collaborate = _ref2.collaborate,
        endDate = _ref2.endDate,
        error = _ref2.error,
        fullLocale = _ref2.fullLocale,
        invite = _ref2.invite,
        inviteUrl = _ref2.inviteUrl,
        isMobile = _ref2.isMobile,
        isOpen = _ref2.isOpen,
        langOr = _ref2.langOr,
        listings = _ref2.listings,
        loading = _ref2.loading,
        login = _ref2.login,
        loginUrl = _ref2.loginUrl,
        name = _ref2.name,
        role = _ref2.role,
        siteName = _ref2.siteName,
        startDate = _ref2.startDate,
        title = _ref2.title;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        lib_esm["default"],
        {
            className: 'collab-modal',
            id: 'collaborate-modal',
            isOpen: isOpen,
            onClose: collaborate,
            title: title
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_card, {
            listings: listings,
            name: name
        }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loading }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            logged_in,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                components_permissions,
                { role: role, owner: true },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'margin-bottom-5x' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_url, {
                        boardId: boardId,
                        error: error,
                        endDate: endDate,
                        fetch: invite,
                        isMobile: isMobile,
                        startDate: startDate,
                        url: inviteUrl
                    }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Divider, { text: langOr })
                )
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'margin-bottom-5x' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(share_url, {
                boardId: boardId,
                endDate: endDate,
                isMobile: isMobile,
                startDate: startDate
            })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            logged_in,
            { inverse: true },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                components_permissions,
                { role: role, owner: true },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Divider, { text: langOr }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'margin-bottom-5x' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_login, {
                        boardId: boardId,
                        endDate: endDate,
                        error: error,
                        fetch: login,
                        fullLocale: fullLocale,
                        loginUrl: loginUrl,
                        siteName: siteName,
                        startDate: startDate
                    })
                )
            )
        )
    );
}

/* harmony default export */ var invite_share_modal = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withCollaborateState, withTranslationsAsProps({
    'tripboards.or': 'langOr',
    'tripboards.share': 'title'
}))(CollaborateModal));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/reducer-count.js



var reducer_count_initialState = {
    boardId: null,
    count: 0,
    error: false,
    loading: true, // init with loading true even though no fetches have been made to provider component logic
    text: ''
};

var reducer_count_actionHandlers = {};

reducer_count_actionHandlers[collaborate_actions.FETCH_COUNT_START] = function (state, _ref) {
    var payload = _ref.payload;
    var boardId = payload.boardId;

    return {
        loading: true,
        boardId: boardId
    };
};

reducer_count_actionHandlers[collaborate_actions.FETCH_COUNT_SUCCESS] = function (state, _ref2) {
    var payload = _ref2.payload;
    var _payload$apiData = payload.apiData,
        collaboratorCount = _payload$apiData.collaboratorCount,
        collaboratorText = _payload$apiData.collaboratorText,
        tripBoardUuid = _payload$apiData.tripBoardUuid;

    return {
        boardId: tripBoardUuid,
        count: collaboratorCount,
        error: false,
        loading: false,
        text: collaboratorText
    };
};

reducer_count_actionHandlers[collaborate_actions.FETCH_COUNT_ERROR] = function (state) {
    return {
        boardId: state.boardId,
        error: true,
        loading: false
    };
};

/* harmony default export */ var reducer_count = (utils_createReducer(reducer_count_actionHandlers, reducer_count_initialState));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/reducer-collaborate.js
var reducer_collaborate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var reducer_collaborate_actionHandlers = {};
var reducer_collaborate_initialState = {
    error: null,
    isModalOpen: false,
    inviteUrl: '',
    loginUrl: '',
    signupUrl: '',
    loading: false
};

reducer_collaborate_actionHandlers[collaborate_actions.COLLABORATE] = function (state) {
    var isModalOpen = !state.isModalOpen;
    return reducer_collaborate__extends({}, state, {
        isModalOpen: isModalOpen
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.FETCH_INVITE] = function (state) {
    return reducer_collaborate__extends({}, state, {
        loading: true
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.FETCH_INVITE_ERROR] = function (state) {
    /** @todo Pass through error codes... */
    return reducer_collaborate__extends({}, state, {
        error: true,
        loading: false
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.FETCH_INVITE_SUCCESS] = function (state, _ref) {
    var payload = _ref.payload;
    var apiData = payload.apiData;

    return reducer_collaborate__extends({}, state, apiData, {
        loading: false
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.FETCH_LOGIN] = function (state) {
    return reducer_collaborate__extends({}, state, {
        loading: true
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.FETCH_LOGIN_ERROR] = function (state) {
    /** @todo Pass through error codes... */
    return reducer_collaborate__extends({}, state, {
        error: true,
        loading: false
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.FETCH_LOGIN_SUCCESS] = function (state, _ref2) {
    var payload = _ref2.payload;
    var apiData = payload.apiData;

    var loginUrl = apiData.header.login.items[0].link;
    return reducer_collaborate__extends({}, state, {
        loginUrl: loginUrl,
        loading: false
    });
};

reducer_collaborate_actionHandlers[collaborate_actions.RESET] = function () {
    return reducer_collaborate_initialState;
};

/* harmony default export */ var reducer_collaborate = (utils_createReducer(reducer_collaborate_actionHandlers, reducer_collaborate_initialState));
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/reducer.js




/* harmony default export */ var collaborate_reducer = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["combineReducers"])({
    count: reducer_count,
    modal: reducer_collaborate
}));
// EXTERNAL MODULE: ./src/universal/tripboard/collaborate/components/accept-invite-modal.less
var accept_invite_modal = __webpack_require__("TkuE");
var accept_invite_modal_default = /*#__PURE__*/__webpack_require__.n(accept_invite_modal);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/preview-invite-modal.js




var preview_invite_modal_MockHeadline = function MockHeadline(_ref) {
    var noPropertiesText = _ref.noPropertiesText,
        propertiesText = _ref.propertiesText,
        unitsCount = _ref.unitsCount,
        stay = _ref.stay;

    if (stay && stay.dateRange && stay.dateRange.arrival && stay.dateRange.departure) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedDate"], { value: stay.dateRange.arrival, month: 'long', day: '2-digit', timeZone: 'UTC' }),
            ' - ',
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedDate"], { value: stay.dateRange.departure, month: 'long', day: '2-digit', timeZone: 'UTC' })
        );
    }
    if (unitsCount && unitsCount > 0) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'TB headline', defaultMessage: propertiesText, values: { COUNT: unitsCount } });
    }
    return noPropertiesText;
};

var preview_invite_modal_BgImage = function BgImage(_ref2) {
    var tripBoard = _ref2.tripBoard,
        imageIndex = _ref2.imageIndex,
        className = _ref2.className;

    var thisUrl = tripBoard && tripBoard.listings && tripBoard.listings[imageIndex] && tripBoard.listings[imageIndex].mobileThumbnailUrl || '';

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: className, style: { backgroundImage: 'url(' + thisUrl + ')' } });
};

var preview_invite_modal_PreviewInviteModal = function PreviewInviteModal(_ref3) {
    var noPropertiesText = _ref3.noPropertiesText,
        propertiesText = _ref3.propertiesText,
        unitsCount = _ref3.unitsCount,
        stay = _ref3.stay,
        tripBoard = _ref3.tripBoard;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'accept-invite-modal__preview' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'accept-invite-modal__modal-bg' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'accept-invite-modal__listing-preview' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'header text-emphasis' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_invite_modal_MockHeadline, { noPropertiesText: noPropertiesText, propertiesText: propertiesText, unitsCount: unitsCount, stay: stay })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_invite_modal_BgImage, { className: 'left-content', imageIndex: 0, tripBoard: tripBoard }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'right-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_invite_modal_BgImage, { className: 'right-content__top', imageIndex: 1, tripBoard: tripBoard }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_invite_modal_BgImage, { className: 'right-content__bottom', imageIndex: 2, tripBoard: tripBoard })
            )
        )
    );
};

/* harmony default export */ var preview_invite_modal = (preview_invite_modal_PreviewInviteModal);
// EXTERNAL MODULE: ./src/universal/tripboard/collaborate/components/error-invite-modal.less
var error_invite_modal = __webpack_require__("Vs5E");
var error_invite_modal_default = /*#__PURE__*/__webpack_require__.n(error_invite_modal);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/error-invite-modal.js
function error_invite_modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function error_invite_modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function error_invite_modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var testExposureInviteModal = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_INVITE_ACCEPT_MODAL_TEST"]);


var closeTypes = {
    skip: 'skip',
    close: 'close'
};

var error_invite_modal_ErrorInviteModal = function (_Component) {
    error_invite_modal__inherits(ErrorInviteModal, _Component);

    function ErrorInviteModal(props) {
        error_invite_modal__classCallCheck(this, ErrorInviteModal);

        var _this = error_invite_modal__possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {
            var _this$props = _this.props,
                invitationId = _this$props.invitationId,
                boardId = _this$props.boardId;


            collaborate_edap.expiredInviteModalPop(invitationId, boardId);
        };

        _this.handleClose = _this.handleClose.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.state = {
            isOpen: true
        };
        return _this;
    }

    ErrorInviteModal.prototype.closeModal = function closeModal() {
        testExposureInviteModal.trigger(experiments["HA_PULSE_INVITE_ACCEPT_MODAL_TEST"]);
        this.setState({
            isOpen: false
        });
    };

    ErrorInviteModal.prototype.handleClose = function handleClose(closeType) {
        var _this2 = this;

        var _props = this.props,
            invitationId = _props.invitationId,
            boardId = _props.boardId;

        if (closeType === closeTypes.close) {
            return function () {
                collaborate_edap.expiredInviteModalClose(invitationId, boardId);
                _this2.closeModal();
            };
        }

        return function () {
            collaborate_edap.expiredInvitePublicTripboardViewClick(invitationId, boardId);
            _this2.closeModal();
        };
    };

    ErrorInviteModal.prototype.render = function render() {
        var _props2 = this.props,
            titleText = _props2.titleText,
            bodyText = _props2.bodyText,
            skipText = _props2.skipText,
            noPropertiesText = _props2.noPropertiesText,
            propertiesText = _props2.propertiesText,
            unitsCount = _props2.unitsCount,
            stay = _props2.stay,
            tripBoard = _props2.tripBoard;

        var isOpen = this.state.isOpen;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            lib_esm["default"],
            { id: 'accept-invite-modal', isOpen: isOpen, onClose: this.handleClose(closeTypes.close) },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'error-invite-modal' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'error-invite-modal__header header--columLayout' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        null,
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'h2',
                            null,
                            titleText
                        )
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_invite_modal, { noPropertiesText: noPropertiesText, propertiesText: propertiesText, unitsCount: unitsCount, stay: stay, tripBoard: tripBoard }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'error-invite-modal__content' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'error-invite-modal__header header--rowLayout' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            null,
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'h2',
                                null,
                                titleText
                            )
                        )
                    ),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'error-invite-modal__body' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'error-invite-modal__body-copy' },
                            bodyText
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'error-invite-modal__exit' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
                                className: 'error-invite-modal__btn',
                                onClick: this.handleClose(closeTypes.skip),
                                label: skipText
                            })
                        )
                    )
                )
            )
        );
    };

    return ErrorInviteModal;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var components_error_invite_modal = (error_invite_modal_ErrorInviteModal);
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/accept-invite-modal.js
function accept_invite_modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function accept_invite_modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function accept_invite_modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var accept_invite_modal_testExposureInviteModal = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_INVITE_ACCEPT_MODAL_TEST"]);

var accept_invite_modal_AcceptInviteModal = function (_Component) {
    accept_invite_modal__inherits(AcceptInviteModal, _Component);

    function AcceptInviteModal(props) {
        accept_invite_modal__classCallCheck(this, AcceptInviteModal);

        var _this = accept_invite_modal__possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {
            var byPass = _this.props.byPass;


            if (!byPass) {
                collaborate_edap.validInviteModalPop(_this.props.invitationId, _this.props.boardId);
                _this.getLoginUrl();
            }
        };

        _this.handleClose = function (closeType) {
            return function () {
                collaborate_edap.validInviteModalClose(_this.props.invitationId, _this.props.boardId, closeType);
                accept_invite_modal_testExposureInviteModal.trigger(experiments["HA_PULSE_INVITE_ACCEPT_MODAL_TEST"]);
                _this.setState({
                    isOpen: false
                });
            };
        };

        _this.getLoginUrl = function () {
            var _this$props = _this.props,
                loginFetchError = _this$props.loginFetchError,
                loginFetchLoading = _this$props.loginFetchLoading,
                fetchLogin = _this$props.fetchLogin,
                loginUrl = _this$props.loginUrl,
                fullLocale = _this$props.fullLocale,
                siteName = _this$props.siteName;

            if (fullLocale && siteName && !loginFetchError && !loginFetchLoading && !loginUrl) {
                fetchLogin(fullLocale, siteName);
            }
        };

        _this.handleLoginEdap = function () {
            collaborate_edap.validInviteModalLogin(_this.props.invitationId, _this.props.boardId);
        };

        _this.handleLogin = function () {
            // replace the redirect URL from cas with the original /i/ URL
            if (_this.props.loginUrl) {
                var regex = /tripboard(.*?)&kmsi=true/g;
                return _this.props.loginUrl.replace(regex, 'tripboard%252Fi%252F' + _this.props.invitationId + '&kmsi=true');
            }
            return '';
        };

        _this.state = {
            isOpen: true // pop on creation
        };
        return _this;
    }

    AcceptInviteModal.prototype.render = function render() {
        var _props = this.props,
            addText = _props.addText,
            loginToText = _props.loginToText,
            loginFetchLoading = _props.loginFetchLoading,
            skipText = _props.skipText,
            titleText = _props.titleText,
            voteText = _props.voteText,
            loginText = _props.loginText,
            tripBoardName = _props.tripBoardName,
            noPropertiesText = _props.noPropertiesText,
            propertiesText = _props.propertiesText,
            unitsCount = _props.unitsCount,
            stay = _props.stay,
            tripBoard = _props.tripBoard,
            byPass = _props.byPass;


        if (byPass) {
            return null;
        }

        var loginUrl = this.handleLogin();

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            lib_esm["default"],
            { id: 'accept-invite-modal', isOpen: this.state.isOpen, onClose: this.handleClose('close') },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'accept-invite-modal' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(preview_invite_modal, { noPropertiesText: noPropertiesText, propertiesText: propertiesText, unitsCount: unitsCount, stay: stay, tripBoard: tripBoard }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'accept-invite-modal__header' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        null,
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            null,
                            titleText
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'h2',
                            null,
                            tripBoardName
                        )
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'accept-invite-modal__body' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'accept-invite-modal__body-copy' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'accept-invite-modal__login' },
                            loginToText
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'accept-invite-modal__bullets' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inline: true, className: 'text-white', markup: esm["SUCCESS__16"] }),
                            addText
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'accept-invite-modal__bullets' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inline: true, className: 'text-white', markup: esm["SUCCESS__16"] }),
                            voteText
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            react_buttons_lib_transpiled["ButtonPrimary"],
                            {
                                className: 'accept-invite-modal__btn',
                                label: loginText,
                                href: loginUrl,
                                onClick: this.handleLoginEdap
                            },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loginFetchLoading })
                        )
                    ),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'accept-invite-modal__exit' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'button',
                            {
                                className: 'accept-invite-modal__exit-button',
                                onClick: this.handleClose('skip'),
                                label: skipText + ' >'
                            },
                            skipText + ' >'
                        )
                    )
                )
            )
        );
    };

    return AcceptInviteModal;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var components_accept_invite_modal = (accept_invite_modal_AcceptInviteModal);
// EXTERNAL MODULE: ./src/server/plugins/tripboard-invitations/constants.js
var tripboard_invitations_constants = __webpack_require__("v1/r");
var constants_default = /*#__PURE__*/__webpack_require__.n(tripboard_invitations_constants);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invite-modal-provider.js
var invite_modal_provider__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var invite_modal_provider__templateObject = invite_modal_provider__taggedTemplateLiteralLoose(['\n    query invitationPreview($hav: String!, $invitationId: String!, $listingPageSize: Int!) {\n        invitationPreview(hav: $hav, invitationId: $invitationId) {\n            unitsCount\n            code\n            tripBoardUuid\n            tripBoardName\n            stay {\n                dateRange {\n                    arrival\n                    departure\n                }\n            }\n            tripBoard {\n                listings(pageSize: $listingPageSize) {\n                    mobileThumbnailUrl\n                }\n                users {\n                    isMe\n                    role {\n                        type\n                    }\n                }\n            }\n        }\n    }\n'], ['\n    query invitationPreview($hav: String!, $invitationId: String!, $listingPageSize: Int!) {\n        invitationPreview(hav: $hav, invitationId: $invitationId) {\n            unitsCount\n            code\n            tripBoardUuid\n            tripBoardName\n            stay {\n                dateRange {\n                    arrival\n                    departure\n                }\n            }\n            tripBoard {\n                listings(pageSize: $listingPageSize) {\n                    mobileThumbnailUrl\n                }\n                users {\n                    isMe\n                    role {\n                        type\n                    }\n                }\n            }\n        }\n    }\n']);

function invite_modal_provider__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }














var invite_modal_provider_query = src_default()(invite_modal_provider__templateObject);

var defaultNumberOfListings = 3;
var invite_modal_provider_InviteModalProvider = function InviteModalProvider(ownProps) {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        react_apollo_browser_umd["Query"],
        {
            query: invite_modal_provider_query,
            errorPolicy: 'all',
            skip: !ownProps.hav || !ownProps.invitationId,
            variables: {
                hav: ownProps.hav,
                invitationId: ownProps.invitationId,
                listingPageSize: ownProps.numListingsInPreview || defaultNumberOfListings
            }
        },
        function (_ref) {
            var data = _ref.data,
                error = _ref.error,
                loading = _ref.loading;

            if (loading) {
                return null;
            }

            var _ref2 = data && data.invitationPreview,
                boardId = _ref2.tripBoardUuid,
                unitsCount = _ref2.unitsCount,
                tripBoardName = _ref2.tripBoardName,
                stay = _ref2.stay,
                tripBoard = _ref2.tripBoard,
                code = _ref2.code;

            var invitationId = ownProps.invitationId,
                noPropertiesText = ownProps.noPropertiesText,
                propertiesText = ownProps.propertiesText,
                expiredTitleText = ownProps.expiredTitleText,
                expiredBodyText = ownProps.expiredBodyText,
                expiredCTAText = ownProps.expiredCTAText,
                isLoggedIn = ownProps.isLoggedIn;

            var isMe = false;
            var myRole = ROLES.VIEWER;
            var users = tripBoard && tripBoard.users || [];
            users.filter(function (user) {
                return user;
            }).forEach(function (user) {
                if (user.isMe) {
                    isMe = true;
                    myRole = user.role && user.role.type || ROLES.VIEWER;
                }
            });
            var byPass = isMe && isLoggedIn && myRole !== ROLES.VIEWER;
            if (!byPass && (error || tripboard_invitations_constants["BOARD_ERROR_CODES"].includes(code))) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_error_invite_modal, {
                    invitationId: invitationId,
                    titleText: expiredTitleText,
                    bodyText: expiredBodyText,
                    skipText: expiredCTAText,
                    noPropertiesText: noPropertiesText,
                    propertiesText: propertiesText,
                    boardId: boardId,
                    unitsCount: unitsCount,
                    tripBoardName: tripBoardName,
                    stay: stay,
                    tripBoard: tripBoard
                });
            }

            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_accept_invite_modal, invite_modal_provider__extends({}, ownProps, { boardId: boardId, unitsCount: unitsCount, tripBoardName: tripBoardName, stay: stay, tripBoard: tripBoard, byPass: byPass }));
        }
    );
};

var invite_modal_provider_mapDispatchToProps = {
    fetchLogin: collaborate_actions.login
};

var invite_modal_provider_mapStateToProps = function mapStateToProps(state) {
    var collaborateState = state && state.tripboard && state.tripboard.collaborate && state.tripboard.collaborate.modal || {};
    var systemState = state && state.system || {};
    return {
        loginUrl: collaborateState.loginUrl || '',
        loginFetchError: collaborateState.error,
        loginFetchLoading: collaborateState.loading,
        fullLocale: systemState.fullLocale,
        siteName: systemState.siteName
    };
};

/* harmony default export */ var invite_modal_provider = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'tripboards.modal.invite.add': 'addText',
    'tripboards.modal.invite.loginto': 'loginToText',
    'tripboards.modal.invite.noproperties': 'noPropertiesText',
    'tripboards.modal.invite.properties': 'propertiesText',
    'tripboards.modal.invite.skip': 'skipText',
    'tripboards.modal.invite.title': 'titleText',
    'tripboards.modal.invite.vote': 'voteText',
    'tripboards.modal.invite.accept': 'loginText',
    'tripboards.modal.invite.expired.title': 'expiredTitleText',
    'tripboards.modal.invite.expired.body': 'expiredBodyText',
    'tripboards.modal.invite.expired.cta': 'expiredCTAText',
    'tripboards.invite.signup': 'signupText'
}), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(invite_modal_provider_mapStateToProps, invite_modal_provider_mapDispatchToProps), with_auth)(invite_modal_provider_InviteModalProvider));
// EXTERNAL MODULE: ./src/universal/tripboard/collaborate/components/invalid-invite-modal.less
var invalid_invite_modal = __webpack_require__("StqW");
var invalid_invite_modal_default = /*#__PURE__*/__webpack_require__.n(invalid_invite_modal);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invalid-invite-modal.js
function invalid_invite_modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function invalid_invite_modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function invalid_invite_modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Modal will pop and fire edap on mount -- conditionally render in containing component!
var invalid_invite_modal_InvalidInviteModal = function (_Component) {
    invalid_invite_modal__inherits(InvalidInviteModal, _Component);

    function InvalidInviteModal(props) {
        invalid_invite_modal__classCallCheck(this, InvalidInviteModal);

        var _this = invalid_invite_modal__possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {
            collaborate_edap.invalidInviteModalPop(_this.props.inviteId);
        };

        _this.handleClose = function () {
            collaborate_edap.invalidInviteModalClose(_this.props.inviteId);
            _this.setState({
                isOpen: false
            });
        };

        _this.state = {
            isOpen: true // pop on creation
        };
        return _this;
    }

    InvalidInviteModal.prototype.render = function render() {
        var _props = this.props,
            buttonText = _props.buttonText,
            messageText = _props.messageText,
            titleText = _props.titleText;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            lib_esm["default"],
            { id: 'invalid-invite-modal', isOpen: this.state.isOpen, onClose: this.handleClose, title: titleText },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'p',
                null,
                messageText
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'invalid-invite-modal__button' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], { label: buttonText, onClick: this.handleClose })
            )
        );
    };

    return InvalidInviteModal;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var components_invalid_invite_modal = (withTranslationsAsProps({
    'tripboards.main.expired.ok': 'buttonText',
    'tripboards.main.expired': 'messageText',
    'tripboards.main.expired.title': 'titleText'
})(invalid_invite_modal_InvalidInviteModal));
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var node_modules_query_string = __webpack_require__("OAwv");
var node_modules_query_string_default = /*#__PURE__*/__webpack_require__.n(node_modules_query_string);

// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/components/invite-accept.js
function invite_accept__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function invite_accept__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function invite_accept__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var invite_accept_testExposureInviteModal = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_INVITE_ACCEPT_MODAL_TEST"]);

function getInviteId() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return params.invalid || null;
}

function getParams() {
    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var search = location.search;

    return search ? node_modules_query_string_default.a.parse(search) : {};
}

function isNewModal() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return !!params.modal;
}

function getModalInviteId() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return params.modal || null;
}

function isInviteAccept() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return !!params.invite;
}

function isInviteInvalid() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return !!params.invalid;
}

var invite_accept_InviteAccept = function (_Component) {
    invite_accept__inherits(InviteAccept, _Component);

    function InviteAccept(props) {
        invite_accept__classCallCheck(this, InviteAccept);

        var _this = invite_accept__possibleConstructorReturn(this, _Component.call(this, props));

        _this.validateInvite = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                endDate = _this$props.endDate,
                location = _this$props.location,
                startDate = _this$props.startDate;

            var params = getParams(location);
            var isAccept = isInviteAccept(params);
            var isInvalid = isInviteInvalid(params);
            var isNewInviteModal = isNewModal(params);
            var inviteId = isInvalid ? getInviteId(params) : null;
            var modalInviteId = getModalInviteId(params);
            _this.setState({ inviteId: inviteId, isAccept: isAccept, isInvalid: isInvalid, isNewInviteModal: isNewInviteModal, modalInviteId: modalInviteId });

            if (isAccept) {
                collaborate_edap.acceptInvite(boardId, endDate, startDate);
            }

            if (isInvalid) {
                collaborate_edap.invalidInvite(inviteId);
            }

            if (isInvalid || isAccept) {
                invite_accept_testExposureInviteModal.trigger(experiments["HA_PULSE_INVITE_ACCEPT_MODAL_TEST"]);
            }
        };

        _this.state = {
            inviteId: null,
            isAccept: false,
            isInvalid: false,
            isNewInviteModal: false,
            modalInviteId: null
        };
        return _this;
    }

    InviteAccept.prototype.componentDidMount = function componentDidMount() {
        this.validateInvite();
    };

    InviteAccept.prototype.shouldComponentUpdate = function shouldComponentUpdate(_, nextState) {
        var isAccept = nextState.isAccept,
            isInvalid = nextState.isInvalid,
            isNewInviteModal = nextState.isNewInviteModal;

        var state = this.state;
        return isAccept !== state.isAccept || isInvalid !== state.isInvalid || isNewInviteModal !== state.isNewInviteModal;
    };

    InviteAccept.prototype.render = function render() {
        var location = this.props.location;
        var _state = this.state,
            inviteId = _state.inviteId,
            isAccept = _state.isAccept,
            isInvalid = _state.isInvalid,
            isNewInviteModal = _state.isNewInviteModal,
            modalInviteId = _state.modalInviteId;


        if (isAccept) {
            // we've run through the gauntlet of checks and the user is going to the newly invited tripboard
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Redirect"], { to: location.pathname });
        }
        if (isInvalid) {
            // we are not in the invite modal test, and the invite is invalid for some reason
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_invalid_invite_modal, { inviteId: inviteId });
        }
        if (isNewInviteModal) {
            // we are in the new modal test and we are starting the process of checking for expired tripboards and unlogged in users
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_modal_provider, { invitationId: modalInviteId });
        }
        return null;
    };

    return InviteAccept;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

invite_accept_InviteAccept.defaultProps = {
    boardId: null,
    location: {}
};
/* harmony default export */ var invite_accept = (Object(es["withRouter"])(invite_accept_InviteAccept));
// CONCATENATED MODULE: ./src/universal/tripboard/middleware.js
var middleware__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function createApiMiddleware(_ref) {
    var start = _ref.start,
        success = _ref.success,
        error = _ref.error,
        apiHandler = _ref.apiHandler;

    return function (store, _ref2) {
        var payload = _ref2.payload;

        store.dispatch({
            type: start,
            payload: payload
        });
        apiHandler(payload).then(checkStatus).then(function (response) {
            return response.json();
        }).then(function (apiData) {
            store.dispatch({
                type: success,
                payload: middleware__extends({}, payload, {
                    apiData: apiData
                })
            });
        }).catch(function (apiData) {
            store.dispatch({
                type: error,
                payload: middleware__extends({}, payload, {
                    apiData: apiData
                })
            });
        });
    };
}

var apiRoot = API + '/tripboard';

var defaultFetchOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

if ("object" !== 'undefined' && window.ha) {
    defaultFetchOptions.headers['x-csrf-token'] = window.ha.crumb;
}

function middleware_registerAllMiddleware() {
    collaborate_middleware();
}

/* harmony default export */ var tripboard_middleware = (middleware_registerAllMiddleware);
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/middleware.js
var collaborate_middleware__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var fetchCount = createApiMiddleware({
    start: collaborate_actions.FETCH_COUNT_START,
    success: collaborate_actions.FETCH_COUNT_SUCCESS,
    error: collaborate_actions.FETCH_COUNT_ERROR,
    apiHandler: function apiHandler(_ref) {
        var boardId = _ref.boardId;

        return fetch(apiRoot + '/' + boardId + '/collaboratorCount');
    }
});

var fetchInvite = createApiMiddleware({
    start: collaborate_actions.FETCH_INVITE_START,
    success: collaborate_actions.FETCH_INVITE_SUCCESS,
    error: collaborate_actions.FETCH_INVITE_ERROR,
    apiHandler: function apiHandler(_ref2) {
        var boardId = _ref2.boardId;

        var options = collaborate_middleware__extends({}, defaultFetchOptions, {
            method: 'POST',
            body: JSON.stringify({
                tripBoardUuid: boardId
            })
        });
        return fetch(universal_routes.TRIPBOARD + '/api/tripBoardInvitations', options);
    }
});

var fetchLogin = createApiMiddleware({
    start: collaborate_actions.FETCH_LOGIN_START,
    success: collaborate_actions.FETCH_LOGIN_SUCCESS,
    error: collaborate_actions.FETCH_LOGIN_ERROR,
    apiHandler: function apiHandler(_ref3) {
        var fullLocale = _ref3.fullLocale,
            siteName = _ref3.siteName;

        return fetch(API + '/header/bceHeader?site=' + siteName + '&locale=' + fullLocale, defaultFetchOptions);
    }
});

function collaborate_middleware_registerAllMiddleware() {
    Object(redux_middleware_adapter_lib["registerMiddleware"])(collaborate_actions.FETCH_COUNT, fetchCount);
    Object(redux_middleware_adapter_lib["registerMiddleware"])(collaborate_actions.FETCH_INVITE, fetchInvite);
    Object(redux_middleware_adapter_lib["registerMiddleware"])(collaborate_actions.FETCH_LOGIN, fetchLogin);
}

/* harmony default export */ var collaborate_middleware = (collaborate_middleware_registerAllMiddleware);
// CONCATENATED MODULE: ./src/universal/tripboard/collaborate/index.js








// CONCATENATED MODULE: ./src/universal/tripboard/current-tripboard-reducer.js
var current_tripboard_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var current_tripboard_reducer_initialState = {};

var current_tripboard_reducer_actionHandlers = {};

current_tripboard_reducer_actionHandlers[tripboard_actions.SET_CURRENT_TRIPBOARD] = function (state, _ref) {
    var payload = _ref.payload;

    var newState = current_tripboard_reducer__extends({}, state, {
        currentBoardId: payload.boardId
    });
    return newState;
};

/* harmony default export */ var current_tripboard_reducer = (utils_createReducer(current_tripboard_reducer_actionHandlers, current_tripboard_reducer_initialState));
// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/actions.js
var create_tripboard_controls_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* istanbul ignore next */
var create_tripboard_controls_actions_ACTIONS = {
    CREATE_TRIPBOARD_OPEN_MODAL: 'CREATE_TRIPBOARD_OPEN_MODAL',
    CREATE_TRIPBOARD_CLOSE_MODAL: 'CREATE_TRIPBOARD_CLOSE_MODAL',
    CREATE_TRIPBOARD_SHOW_BUTTON: 'CREATE_TRIPBOARD_SHOW_BUTTON'
};

/* istanbul ignore next */
var create_tripboard_controls_actions_ACTION_CREATORS = {
    openModal: function openModal() {
        return { type: create_tripboard_controls_actions_ACTIONS.CREATE_TRIPBOARD_OPEN_MODAL };
    },
    closeModal: function closeModal() {
        return { type: create_tripboard_controls_actions_ACTIONS.CREATE_TRIPBOARD_CLOSE_MODAL };
    },
    showButton: function showButton(tripboardButtonVisible) {
        return { type: create_tripboard_controls_actions_ACTIONS.CREATE_TRIPBOARD_SHOW_BUTTON, payload: { tripboardButtonVisible: tripboardButtonVisible } };
    }
};

/* harmony default export */ var create_tripboard_controls_actions = (create_tripboard_controls_actions__extends({}, create_tripboard_controls_actions_ACTIONS, create_tripboard_controls_actions_ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/create-tripboard-reducer.js
var create_tripboard_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var create_tripboard_reducer_initialState = {
    modalOpen: false,
    tripboardButtonVisible: false
};

var create_tripboard_reducer_actionHandlers = {};

create_tripboard_reducer_actionHandlers[create_tripboard_controls_actions.CREATE_TRIPBOARD_OPEN_MODAL] = function (state) {
    var newState = create_tripboard_reducer__extends({}, state, {
        modalOpen: true
    });
    return newState;
};

create_tripboard_reducer_actionHandlers[create_tripboard_controls_actions.CREATE_TRIPBOARD_CLOSE_MODAL] = function (state) {
    var newState = create_tripboard_reducer__extends({}, state, {
        modalOpen: false
    });
    return newState;
};

create_tripboard_reducer_actionHandlers[create_tripboard_controls_actions.CREATE_TRIPBOARD_SHOW_BUTTON] = function (state, _ref) {
    var payload = _ref.payload;

    var newState = create_tripboard_reducer__extends({}, state, {
        tripboardButtonVisible: payload.tripboardButtonVisible
    });
    return newState;
};

/* harmony default export */ var create_tripboard_reducer = (utils_createReducer(create_tripboard_reducer_actionHandlers, create_tripboard_reducer_initialState));
// EXTERNAL MODULE: ./node_modules/lodash.merge/index.js
var lodash_merge = __webpack_require__("mB6w");
var lodash_merge_default = /*#__PURE__*/__webpack_require__.n(lodash_merge);

// CONCATENATED MODULE: ./src/universal/tripboard/tripboard-reducer.js
var tripboard_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var tripboard_reducer_initialState = {};

function indexByListingId(listings) {
    return listings.reduce(function (obj, listing) {
        obj[listing.listingId] = listing;
        return obj;
    }, {});
}

function indexByBoardId(boards) {
    return boards.reduce(function (obj, board) {
        obj[board.boardId] = board;
        return obj;
    }, {});
}

function flattenPreview(_ref) {
    var tripBoard = _ref.tripBoard,
        previews = _ref.previews;

    var listingsById = indexByListingId(tripBoard.listings);
    var previewsById = indexByListingId(previews);
    var listings = lodash_merge_default()({}, previewsById, listingsById);
    return tripboard_reducer__extends({}, tripBoard, {
        listings: listings
    });
}

function flattenDetail(_ref2) {
    var tripBoard = _ref2.tripBoard,
        views = _ref2.views;

    var listingsById = indexByListingId(tripBoard.listings);
    var flattenedViews = views.map(function (_ref3) {
        var hit = _ref3.hit,
            presentation = _ref3.presentation,
            listingId = _ref3.listingId;

        return tripboard_reducer__extends({}, hit, presentation, {
            listingId: listingId
        });
    });
    var viewsById = indexByListingId(flattenedViews);
    var listings = lodash_merge_default()({}, viewsById, listingsById);
    tripBoard.endDate = tripBoard.endDate || null;
    tripBoard.startDate = tripBoard.startDate || null;
    return tripboard_reducer__extends({}, tripBoard, {
        listings: listings
    });
}

var tripboard_reducer_actionHandlers = {};

tripboard_reducer_actionHandlers[tripboard_actions.FETCH_PREVIEWS_SUCCESS] = function (state, _ref4) {
    var payload = _ref4.payload;

    var flattened = payload.apiData.map(flattenPreview);
    return lodash_merge_default()({}, state, indexByBoardId(flattened));
};

tripboard_reducer_actionHandlers[tripboard_actions.FETCH_DETAILS_SUCCESS] = function (state, _ref5) {
    var payload = _ref5.payload;

    var boardToMerge = indexByBoardId([flattenDetail(payload.apiData)]);
    return lodash_merge_default()({}, state, boardToMerge);
};

tripboard_reducer_actionHandlers[tripboard_actions.DELETE_TRIPBOARD_START] = function (state, _ref6) {
    var payload = _ref6.payload;

    var newState = tripboard_reducer__extends({}, state);
    delete newState[payload.boardId];
    return newState;
};

tripboard_reducer_actionHandlers[tripboard_actions.DELETE_TRIPBOARD_LISTING_START] = function (state, _ref7) {
    var payload = _ref7.payload;
    var boardId = payload.boardId,
        listingId = payload.listingId;

    var board = state[boardId];
    if (!board) {
        return state;
    }
    var newListings = tripboard_reducer__extends({}, board.listings);
    delete newListings[listingId];
    var newBoard = tripboard_reducer__extends({}, board, {
        listings: newListings
    });
    var newState = tripboard_reducer__extends({}, state);
    newState[boardId] = newBoard;
    return newState;
};

tripboard_reducer_actionHandlers[tripboard_actions.RENAME_TRIPBOARD_START] = function (state, _ref8) {
    var payload = _ref8.payload;
    var boardId = payload.boardId,
        name = payload.name;

    var board = state[boardId];
    if (!board) {
        return state;
    }
    var newBoard = tripboard_reducer__extends({}, board, {
        name: name
    });
    var newState = tripboard_reducer__extends({}, state);
    newState[boardId] = newBoard;
    return newState;
};

/* harmony default export */ var tripboard_reducer = (utils_createReducer(tripboard_reducer_actionHandlers, tripboard_reducer_initialState));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-aspect-ratio-card/lib/transpiled/index.js
var react_aspect_ratio_card_lib_transpiled = __webpack_require__("4pRd");
var react_aspect_ratio_card_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_aspect_ratio_card_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-card-carousel/lib/transpiled/index.js
var react_card_carousel_lib_transpiled = __webpack_require__("F8cY");
var react_card_carousel_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_card_carousel_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/tripboard/loading-state.js
var initial = Object.freeze({
    isInitial: true,
    isStart: false,
    isSuccess: false,
    isError: false,
    isNotFound: false
});

var loading_state_start = Object.freeze({
    isInitial: false,
    isStart: true,
    isSuccess: false,
    isError: false,
    isNotFound: false
});

var loading_state_success = Object.freeze({
    isInitial: false,
    isStart: false,
    isSuccess: true,
    isError: false,
    isNotFound: false
});

var loading_state_error = Object.freeze({
    isInitial: false,
    isStart: false,
    isSuccess: false,
    isError: true,
    isNotFound: false

});

var notFound = Object.freeze({
    isInitial: false,
    isStart: false,
    isSuccess: false,
    isError: true,
    isNotFound: true
});


// CONCATENATED MODULE: ./src/universal/tripboard/details/components/with-tripboard-query.js
var with_tripboard_query__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var with_tripboard_query__templateObject = with_tripboard_query__taggedTemplateLiteralLoose(['\nquery tripBoard($hav: String!, $tripBoardUuid: String!, $currency: String!) {\n    tripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid) {\n        uuid\n        name\n        sharedFavorite\n        stay {\n          adultCount\n          childrenCount\n          petsIncluded\n          dateRange {\n            arrival\n            departure\n          }\n        }\n        user {\n            role {\n                type\n            }\n        }\n        listings {\n            status\n            multiUnitProperty\n            availableForDates\n            averagePrice {\n                achievableEndDate\n                achievableStartDate\n                currencySymbol\n                currencyUnits\n                localized\n                periodType\n                value\n            }\n            geoCode {\n                latitude\n                longitude\n            }\n            priceSummary(currency: $currency) {\n                formattedAmount\n                pricePeriodDescription\n                edapEventJson\n            }\n            preferredPlace {\n                name {\n                    full\n                    simple\n                }\n                uuid\n            }\n            baseLocation {\n                name {\n                    full\n                }\n            }\n            bathrooms {\n                full\n                half\n                toiletOnly\n            }\n            instantBookable\n            bedrooms\n            sleeps\n            headline\n            listingId\n            unitApiUrl\n            detailPageUrl\n            reviewCount\n            averageRating\n            images {\n                c6_uri,\n                c10_uri,\n                height,\n                width\n            }\n        }\n        users {\n            isMe\n            role {\n                type\n            }\n            profile {\n                firstName\n                lastName\n                publicImageUrl\n            }\n        }\n    }\n}'], ['\nquery tripBoard($hav: String!, $tripBoardUuid: String!, $currency: String!) {\n    tripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid) {\n        uuid\n        name\n        sharedFavorite\n        stay {\n          adultCount\n          childrenCount\n          petsIncluded\n          dateRange {\n            arrival\n            departure\n          }\n        }\n        user {\n            role {\n                type\n            }\n        }\n        listings {\n            status\n            multiUnitProperty\n            availableForDates\n            averagePrice {\n                achievableEndDate\n                achievableStartDate\n                currencySymbol\n                currencyUnits\n                localized\n                periodType\n                value\n            }\n            geoCode {\n                latitude\n                longitude\n            }\n            priceSummary(currency: $currency) {\n                formattedAmount\n                pricePeriodDescription\n                edapEventJson\n            }\n            preferredPlace {\n                name {\n                    full\n                    simple\n                }\n                uuid\n            }\n            baseLocation {\n                name {\n                    full\n                }\n            }\n            bathrooms {\n                full\n                half\n                toiletOnly\n            }\n            instantBookable\n            bedrooms\n            sleeps\n            headline\n            listingId\n            unitApiUrl\n            detailPageUrl\n            reviewCount\n            averageRating\n            images {\n                c6_uri,\n                c10_uri,\n                height,\n                width\n            }\n        }\n        users {\n            isMe\n            role {\n                type\n            }\n            profile {\n                firstName\n                lastName\n                publicImageUrl\n            }\n        }\n    }\n}']);

function with_tripboard_query__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function with_tripboard_query__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }









/**
 * @todo deprecate once partial returns tripBoard.user.profile
 * https://jira.homeawaycorp.com/browse/SCRATCHPAD-2495
 */
var getUser = function getUser() {
    var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (!Array.isArray(users)) {
        return {};
    }
    return users.find(function (user) {
        return !!user.isMe;
    });
};

var with_tripboard_query_query = src_default()(with_tripboard_query__templateObject);

var with_tripboard_query_options = function options(props) {
    // eslint-disable-line
    return {
        variables: {
            tripBoardUuid: props.match.params.boardId,
            hav: props.hav,
            currency: props.currency
        },
        notifyOnNetworkStatusChange: true,
        errorPolicy: 'all'
    };
};

// ported from ListingScratchpadConverter.getBedroomsPresentationModel (api-scratchpad-v2)
var createGetBedrooms = function createGetBedrooms(formatMessage) {
    var studioMessageDescriptor = {
        id: 'header.scratchpadSummary.listingsSummary.hit.label.studio',
        defaultMessage: 'Studio',
        description: 'studio label'
    };
    var bedroomsMessageDescriptor = {
        id: 'header.scratchpadSummary.listingsSummary.hit.label.bedrooms',
        defaultMessage: '',
        description: 'bedrooms label'
    };

    return function (listing) {
        if (listing.bedrooms === 0) {
            return formatMessage(studioMessageDescriptor);
        }

        if (listing.bedrooms > 1) {
            return formatMessage(bedroomsMessageDescriptor, { 0: listing.bedrooms });
        }
        return '';
    };
};

var createGetBathrooms = function createGetBathrooms(formatMessage) {
    var fullBathroomsDescriptor = {
        id: 'header.scratchpadSummary.listingsSummary.hit.label.fullBathrooms',
        defaultMessage: 'Bathrooms',
        description: 'Bathrooms label'
    };

    var halfBathsroomsDescriptor = {
        id: 'header.scratchpadSummary.listingsSummary.hit.label.halfBathrooms',
        defaultMessage: 'Half baths',
        description: 'half baths label'
    };

    return function (listing) {
        if (!listing.bathrooms) {
            return '';
        }
        var bathroomMessages = [];
        if (listing.bathrooms.full >= 1) {
            bathroomMessages.push(formatMessage(fullBathroomsDescriptor, { 0: listing.bathrooms.full }));
        }
        if (listing.bathrooms.half >= 1) {
            bathroomMessages.push(formatMessage(halfBathsroomsDescriptor, { 0: listing.bathrooms.half }));
        }
        // Gross but scratchpad hard-coded this too
        return bathroomMessages.join(', ');
    };
};

// ported from ListingScratchpadConverter.getSleepsPresentationModel (api-scratchpad-v2)
var createGetSleeps = function createGetSleeps(formatMessage) {
    var sleepsDescriptor = {
        id: 'header.scratchpadSummary.listingsSummary.hit.label.sleepsPlural',
        defaultMessage: 'sleeps',
        description: 'sleeps label'
    };

    return function (listing) {
        if (listing.sleeps >= 1) {
            return formatMessage(sleepsDescriptor, { 0: listing.sleeps });
        }
        return '';
    };
};

// gross helper function that maps listings from graphql to ugly scratchpad-style hit props
function mapListingsToLegacyHitProps(intl, tripBoard) {
    var listings = tripBoard.listings,
        user = tripBoard.user;
    var formatMessage = intl.formatMessage;
    // create format functions from translation object (for reuse within loop)

    var getBathrooms = createGetBathrooms(formatMessage);
    var getBedrooms = createGetBedrooms(formatMessage);
    var getSleeps = createGetSleeps(formatMessage);

    var listingIds = [];
    var places = {};
    var mappedListings = listings.filter(function (listing) {
        return listing && (user && user.role && user.role.type !== 'VIEWER' || listing.status && listing.status !== 'DELISTED');
    }).map(function (listing) {
        var unitUuid = listing.unitApiUrl && listing.unitApiUrl.split('/').pop() || '';
        listingIds.push(listing.listingId);
        var images = listing.images && listing.images.map(function (_ref) {
            var src = _ref.c10_uri,
                lowResSrc = _ref.c6_uri,
                rest = with_tripboard_query__objectWithoutProperties(_ref, ['c10_uri', 'c6_uri']);

            return with_tripboard_query__extends({ src: src, lowResSrc: lowResSrc }, rest);
        }) || [];
        if (listing.preferredPlace && listing.preferredPlace.name) {
            var thisPlaceKey = listing.preferredPlace.name.full;
            if (!places[thisPlaceKey]) {
                places[thisPlaceKey] = with_tripboard_query__extends({}, listing.preferredPlace.name, {
                    count: 0,
                    uuid: listing.preferredPlace.uuid
                });
            }
            places[thisPlaceKey].count++;
        }

        var hitProps = {
            availableForDates: listing.availableForDates,
            averageRating: listing.averageRating,
            baseLocation: listing.baseLocation,
            boardId: tripBoard.uuid,
            headline: listing.headline,
            listingId: listing.listingId,
            detailPageUrl: listing.detailPageUrl,
            geoCode: listing.geoCode,
            unitUuid: unitUuid,
            reviewCount: listing.reviewCount,
            averagePrice: with_tripboard_query__extends({}, listing.averagePrice, {
                currencyUnits: listing.averagePrice && listing.averagePrice.currencyUnits || 'USD'
            }),
            bedrooms: getBedrooms(listing),
            bathrooms: getBathrooms(listing),
            sleeps: getSleeps(listing),
            images: images,
            instantBookable: listing.instantBookable,
            instantBookableMessage: formatMessage({ id: 'shared.stabHit.instant.flag' }),
            instantBookableTooltip: formatMessage({ id: 'shared.stabHit.instant.tooltip' }),
            multiUnitProperty: listing.multiUnitProperty,
            multiUnitPropertyMessage: formatMessage({ id: 'shared.stabHit.multi.unit' }),
            noPrice: formatMessage({ id: 'shared.stabHit.rate.none' }),
            priceSummary: listing.priceSummary,
            dateNotAvailable: formatMessage({ id: 'shared.stabHit.dates.not.available' }),
            galleryUrl: images[0] && images[0].src,
            thumbnailUrl1: images[0] && images[0].src,
            thumbnailUrl2: images[1] && images[1].src,
            thumbnailUrl3: images[2] && images[2].src,
            role: user && user.role && user.role.type || ROLES.VIEWER,
            stay: tripBoard.stay,
            tripBoardUuid: tripBoard.uuid
        };
        if (tripBoard.stay && tripBoard.stay.dateRange && listing.status !== 'DELISTED') {
            // board has dates so set legacy status flag based on availability
            hitProps.status = listing.availableForDates ? 'AVAILABLE' : 'UNAVAILABLE';
            if (listing.priceSummary) {
                hitProps.rate = listing.priceSummary.formattedAmount;
                hitProps.ratesUnitOfMeasure = listing.priceSummary.pricePeriodDescription;
                hitProps.edapEventJson = listing.priceSummary.edapEventJson;
            }
        } else {
            // board is dateless or delisted
            hitProps.status = listing.status;
            hitProps.rate = listing.averagePrice && listing.averagePrice.localized || '';
            hitProps.ratesUnitOfMeasure = formatMessage({ id: 'shared.stabHit.rate.average.night.short' });
        }
        return hitProps;
    });
    var sortedPlaces = Object.values(places || {});
    sortedPlaces.sort(function (a, b) {
        return b.count - a.count;
    });

    return { mappedListings: mappedListings, listingIds: listingIds, sortedPlaces: sortedPlaces };
}

// maps the graphql query response to the props that TripboardDetails expects
// we'll likely want to refactor TripboardDetails to use better names
function mapQueryResponseToLegacyProps(_ref2) {
    var data = _ref2.data,
        ownProps = _ref2.ownProps;
    var intl = ownProps.intl;

    if (data.loading) {
        return {
            loadingState: loading_state_start
        };
    }
    // TODO: more robust error-handling
    // assuming that a graphql error with tripBoard === null is a 404
    if (!data.tripBoard) {
        return {
            loadingState: notFound
        };
    }
    var tripBoard = data.tripBoard;
    // if pds calls fail it is possible to have null listings, for now we'll use existing error-state
    // this should be consistent with existing behavior without graphql
    if (!tripBoard.listings) {
        return {
            loadingState: loading_state_error
        };
    }
    var listingsMaps = intl ? mapListingsToLegacyHitProps(intl, tripBoard) : {};
    var listings = listingsMaps.mappedListings || [];
    var listingIds = listingsMaps.listingIds || [];
    var places = listingsMaps.sortedPlaces || [];
    var props = {
        boardId: tripBoard.uuid,
        name: tripBoard.name,
        isFavorite: !!tripBoard.sharedFavorite,
        isShared: !!tripBoard.sharedFavorite,
        loadingState: loading_state_success,
        role: tripBoard.user.role.type,
        listings: listings,
        listingIds: listingIds,
        places: places,
        refetchTripboard: data.refetch,
        users: tripBoard.users,
        /**
         * @todo deprecate once partial returns tripBoard.user.profile
         * https://jira.homeawaycorp.com/browse/SCRATCHPAD-2495
         */
        user: getUser(tripBoard.users)
    };
    // stay can be null for dateless boards and legacy endpoint omits dates if the user is a VIEWER
    if (tripBoard.stay && tripBoard.stay.dateRange && tripBoard.user.role.type !== 'VIEWER') {
        props.startDate = tripBoard.stay.dateRange.arrival;
        props.endDate = tripBoard.stay.dateRange.departure;
    }

    if (tripBoard.stay && tripBoard.user.role.type !== 'VIEWER') {
        props.adultsCount = tripBoard.stay.adultCount;
        props.childrenCount = tripBoard.stay.childrenCount;
        props.petsIncluded = tripBoard.stay.petsIncluded;
    }

    return props;
}

var withTripboardQuery = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, // hav is extracted from auth context for use in query
index_es["injectIntl"], Object(react_apollo_browser_umd["graphql"])(with_tripboard_query_query, { options: with_tripboard_query_options, props: mapQueryResponseToLegacyProps }));

/* harmony default export */ var with_tripboard_query = (withTripboardQuery);
// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-url.js
var listing_url__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function listing_url__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function listing_url__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function listing_url__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function listing_url__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function getFormattedDate(date) {
    if (!date) {
        return null;
    }
    var formattedDate = date.split('-');
    formattedDate.push(formattedDate.shift());
    return formattedDate.join('/');
}

function getListingUrl(detailPageUrl, startDate, endDate) {
    if (!detailPageUrl) {
        return '';
    }

    var isDated = !!(startDate && endDate);
    var arrival = getFormattedDate(startDate);
    var departure = getFormattedDate(endDate);
    var urlParts = (detailPageUrl || '').split('?');
    var rawURL = urlParts[0];
    var rawParams = urlParts[1] || '';
    var searchParams = node_modules_query_string_default.a.parse(rawParams);

    if (isDated) {
        searchParams.arrivalDate = arrival;
        searchParams.departureDate = departure;
    } else {
        searchParams.noDates = true;
    }

    return rawURL + '?' + node_modules_query_string_default.a.stringify(searchParams);
}

var listing_url_ListingUrl = function (_Component) {
    listing_url__inherits(ListingUrl, _Component);

    function ListingUrl(props) {
        listing_url__classCallCheck(this, ListingUrl);

        var _this = listing_url__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onClick = function () {
            // istanbul ignore next
            _this.props.onClick();
        };

        _this.linkRef = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createRef();
        return _this;
    }

    ListingUrl.prototype.componentDidMount = function componentDidMount() {
        // onClick via React does not work when rendered inside a google overlay
        // istanbul ignore next
        if (this.linkRef.current) {
            this.linkRef.current.addEventListener('click', this.onClick);
        }
    };

    ListingUrl.prototype.componentWillUnmount = function componentWillUnmount() {
        // istanbul ignore next
        if (this.linkRef.current) {
            this.linkRef.current.removeEventListener('click', this.onClick);
        }
    };

    ListingUrl.prototype.render = function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            detailPageUrl = _props.detailPageUrl,
            onClick = _props.onClick,
            stay = _props.stay,
            rest = listing_url__objectWithoutProperties(_props, ['children', 'className', 'detailPageUrl', 'onClick', 'stay']);

        var _ref = stay || {},
            dateRange = _ref.dateRange;

        var _ref2 = dateRange || {},
            arrival = _ref2.arrival,
            departure = _ref2.departure;

        var url = getListingUrl(detailPageUrl, arrival, departure);
        var classNames = 'listing-url ' + (className || '');
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'a',
            listing_url__extends({
                className: classNames,
                href: url,
                ref: this.linkRef
            }, rest),
            children
        );
    };

    return ListingUrl;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

listing_url_ListingUrl.defaultProps = {
    onClick: function onClick() {}
};
/* harmony default export */ var listing_url = (listing_url_ListingUrl);
// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-mini-hit.less
var listing_mini_hit = __webpack_require__("CBH9");
var listing_mini_hit_default = /*#__PURE__*/__webpack_require__.n(listing_mini_hit);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-mini-hit.js
/* istanbul ignore file */








var ASPECT_RATIO_4X3 = '4x3';

function ListingMiniHit(_ref) {
    var _ref$aspectRatio = _ref.aspectRatio,
        aspectRatio = _ref$aspectRatio === undefined ? ASPECT_RATIO_4X3 : _ref$aspectRatio,
        averagePrice = _ref.averagePrice,
        bathrooms = _ref.bathrooms,
        bedrooms = _ref.bedrooms,
        className = _ref.className,
        detailPageUrl = _ref.detailPageUrl,
        edapEventJson = _ref.edapEventJson,
        images = _ref.images,
        imageUri = _ref.imageUri,
        isMobile = _ref.isMobile,
        onClick = _ref.onClick,
        priceSummary = _ref.priceSummary,
        sleeps = _ref.sleeps,
        status = _ref.status,
        stay = _ref.stay,
        langAvgNight = _ref.langAvgNight,
        langDatesNotAvailable = _ref.langDatesNotAvailable,
        langNoPrice = _ref.langNoPrice;

    if (!imageUri) {
        imageUri = Array.isArray(images) ? images[0] && images[0].lowResSrc || '' : '';
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        listing_url,
        {
            className: 'listing-mini-hit ' + (className || ''),
            detailPageUrl: detailPageUrl,
            onClick: onClick,
            stay: stay,
            target: isMobile ? '_self' : '_blank'
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_aspect_ratio_card_lib_transpiled["AspectRatioCard"],
            { aspectRatio: aspectRatio },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_aspect_ratio_card_lib_transpiled["AspectRatioCardImage"], {
                'data-slot': 'figure',
                imageUri: imageUri
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_rooms, {
                bathrooms: bathrooms,
                bedrooms: bedrooms,
                className: 'AspectRatioCardTitle h4 text-bold text-ha-gray-dark',
                'data-slot': 'caption',
                sleeps: sleeps
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_price, {
                averagePrice: averagePrice,
                'data-slot': 'content',
                edapEventJson: edapEventJson,
                langAvgNight: langAvgNight,
                langDatesNotAvailable: langDatesNotAvailable,
                langNoPrice: langNoPrice,
                priceSummary: priceSummary,
                stay: stay,
                status: status
            })
        )
    );
}

/* harmony default export */ var listing_listing_mini_hit = (react_determine_if_mobile_lib_transpiled_default()(ListingMiniHit));
// CONCATENATED MODULE: ./src/universal/tripboard/recommended-properties/actions/index.js
var recommended_properties_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var recommended_properties_actions_ACTIONS = {
    CHANGE_CARD_INDEX: 'CHANGE_CHARD_INDEX',
    CHANGE_NUM_CARDS_VISIBLE: 'CHANGE_NUM_CARDS_VISIBLE',
    SCROLLED_INTO_VIEW: 'SCROLLED_INTO_VIEW'
};

var recommended_properties_actions_ACTION_CREATORS = {
    changeCardIndex: function changeCardIndex(newCardIndex) {
        return { type: recommended_properties_actions_ACTIONS.CHANGE_CARD_INDEX, payload: { cardIndex: newCardIndex } };
    },
    changeNumCardsVisible: function changeNumCardsVisible(numCardsVisible) {
        return { type: recommended_properties_actions_ACTIONS.CHANGE_NUM_CARDS_VISIBLE, payload: { numCardsVisible: numCardsVisible } };
    },
    scrolledIntoView: function scrolledIntoView() {
        return { type: recommended_properties_actions_ACTIONS.SCROLLED_INTO_VIEW };
    }
};

/* harmony default export */ var recommended_properties_actions = (recommended_properties_actions__extends({}, recommended_properties_actions_ACTIONS, recommended_properties_actions_ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/tripboard/recommended-properties/edap.js



// generic events
var recommended_properties_edap_generic = {
    TRIP_BOARDS_RECOMMENDED_PROPERTY_VIEW: 'board.recommended.property.view',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_LISTING_CLICK: 'board.recommended.property.click',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_NEXT_CLICK: 'board.recommended.property.next.click',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_PREV_CLICK: 'board.recommended.property.prev.click',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_RECOMMENDED: 'board.recommended.property.recommended'
};

// events
var edap_propertyViewed = function propertyViewed(boardId, listingId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: recommended_properties_edap_generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_VIEW,
        eventlabel: edap.getPositionLabel(position, total) + ';' + edap_getBoardIdListingId(boardId, listingId),
        highfrequency: 'true'
    });
};

var edap_propertiesRecommended = function propertiesRecommended(boardId, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: recommended_properties_edap_generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_RECOMMENDED,
        eventlabel: edap_getBoardIdListingId(boardId) + ';total=' + total
    });
};

var edap_recommendedListingClick = function recommendedListingClick(boardId, listingId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: recommended_properties_edap_generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_LISTING_CLICK,
        eventlabel: edap.getPositionLabel(position, total) + ';' + edap_getBoardIdListingId(boardId, listingId)
    }, { delayProcessing: true });
};

var edap_carouselNext = function carouselNext(boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: recommended_properties_edap_generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_NEXT_CLICK,
        eventlabel: '' + edap_getBoardIdListingId(boardId),
        highfrequency: 'true'
    });
};

var edap_carouselPrev = function carouselPrev(boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: recommended_properties_edap_generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_PREV_CLICK,
        eventlabel: '' + edap_getBoardIdListingId(boardId),
        highfrequency: 'true'
    });
};
// EXTERNAL MODULE: ./src/universal/tripboard/recommended-properties/components/recommended-properties-carousel.less
var recommended_properties_carousel = __webpack_require__("2+dq");
var recommended_properties_carousel_default = /*#__PURE__*/__webpack_require__.n(recommended_properties_carousel);

// CONCATENATED MODULE: ./src/universal/tripboard/recommended-properties/components/recommended-properties-carousel.js
var recommended_properties_carousel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function recommended_properties_carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function recommended_properties_carousel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function recommended_properties_carousel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var breakpoints = {
    '2340': 8,
    '2040': 7,
    '1740': 6,
    '1440': 5,
    '1140': 4,
    '840': 3,
    '769': 2,
    '680': 3,
    '490': 3,
    '0': 2
};

var recommended_properties_carousel_getAmenities = function getAmenities(cardProps, formatMessage) {
    var getBathrooms = createGetBathrooms(formatMessage);
    var getBedrooms = createGetBedrooms(formatMessage);
    var getSleeps = createGetSleeps(formatMessage);
    return {
        bathrooms: getBathrooms(cardProps),
        bedrooms: getBedrooms(cardProps),
        sleeps: getSleeps(cardProps)
    };
};

var placeHolderImage = 'https://csvcus.homeaway.com/rsrcs/cdn-logos/2.6.1/bce/brand/misc/property-image-placeholder.svg';

var getImage = function getImage(cardProps) {
    return cardProps.images && cardProps.images[0] && cardProps.images[0].c6_uri ? cardProps.images[0].c6_uri : placeHolderImage;
};

var recommended_properties_carousel_getControlOffset = function getControlOffset() {
    return function (width, controlHeight) {
        return react_aspect_ratio_card_lib_transpiled["AspectRatioCard"].getControlOffset(width, controlHeight, ASPECT_RATIO_4X3);
    };
};

var recommended_properties_carousel_RecommendedPropertyCarousel = function RecommendedPropertyCarousel(props) {
    var recommendations = props.recommendations,
        _props$cardIndex = props.cardIndex,
        cardIndex = _props$cardIndex === undefined ? 0 : _props$cardIndex,
        isMobile = props.isMobile,
        title = props.title,
        handleNextArrowClick = props.handleNextArrowClick,
        handlePrevArrowClick = props.handlePrevArrowClick,
        handleResize = props.handleResize,
        handleHitClick = props.handleHitClick,
        formatMessage = props.intl.formatMessage,
        stay = props.stay;


    if (!formatMessage || recommendations.length < 1) {
        return null;
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'recommended-properties-carousel' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_card_carousel_lib_transpiled["CardCarousel"],
            {
                breakpoints: breakpoints,
                cardIndex: cardIndex,
                onNextClick: handleNextArrowClick,
                onPreviousClick: handlePrevArrowClick,
                onResize: handleResize,
                title: title,
                paging: true,
                scrolling: isMobile,
                scrollingPeekPct: isMobile ? 0.5 : 0.2,
                getControlOffset: recommended_properties_carousel_getControlOffset()
            },
            recommendations.map(function (listing, index) {
                var amenities = recommended_properties_carousel_getAmenities(listing, formatMessage);
                var imageUrl = getImage(listing);
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
                    { key: listing.listingId },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(HitSubComponents_TripboardButtonContainer_TripboardButtonContainer, {
                        headline: listing.headline,
                        listingId: listing.listingId,
                        rating: listing.averageRating,
                        reviewCount: listing.reviewCount,
                        thumbnailUrl: imageUrl,
                        adultsCount: stay && stay.adultsCount,
                        childrenCount: stay && stay.childrenCount,
                        petIncluded: stay && stay.petsIncluded,
                        startDate: stay && stay.dateRange && stay.dateRange.arrival,
                        endDate: stay && stay.dateRange && stay.dateRange.departure
                    }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_mini_hit, recommended_properties_carousel__extends({}, listing, amenities, {
                        aspectRatio: ASPECT_RATIO_4X3,
                        imageUri: imageUrl,
                        onClick: handleHitClick(listing.listingId, index),
                        stay: !!listing.priceSummary
                    }))
                );
            })
        )
    );
};

var recommended_properties_carousel_RecommendedPropertyCarouselWrapper = function (_Component) {
    recommended_properties_carousel__inherits(RecommendedPropertyCarouselWrapper, _Component);

    function RecommendedPropertyCarouselWrapper(props) {
        recommended_properties_carousel__classCallCheck(this, RecommendedPropertyCarouselWrapper);

        var _this = recommended_properties_carousel__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleNextArrowClick = _this.handleNextArrowClick.bind(_this);
        _this.handlePrevArrowClick = _this.handlePrevArrowClick.bind(_this);
        _this.handleHitClick = _this.handleHitClick.bind(_this);
        _this.onEnter = _this.onEnter.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.lastCardSeen = 0;
        return _this;
    }

    RecommendedPropertyCarouselWrapper.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            boardId = _props.boardId,
            recommendations = _props.recommendations;

        edap_propertiesRecommended(boardId, recommendations && recommendations.length || 0);
    };

    RecommendedPropertyCarouselWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props2 = this.props,
            isInView = _props2.isInView,
            numCardsVisible = _props2.numCardsVisible,
            cardIndex = _props2.cardIndex;
        var prevIsInView = prevProps.isInView,
            prevNumCardsVisible = prevProps.numCardsVisible,
            prevCardIndex = prevProps.cardIndex;

        if (isInView && (!prevIsInView || numCardsVisible > prevNumCardsVisible || cardIndex > prevCardIndex)) {
            this.firePropertiesViewed();
        }
    };

    RecommendedPropertyCarouselWrapper.prototype.firePropertiesViewed = function firePropertiesViewed() {
        var _props3 = this.props,
            boardId = _props3.boardId,
            recommendations = _props3.recommendations,
            numCardsVisible = _props3.numCardsVisible,
            cardIndex = _props3.cardIndex;

        var total = recommendations.length;
        var finalIndex = Math.min(total, cardIndex + numCardsVisible);
        var firstIndex = this.lastCardSeen;
        this.lastCardSeen = finalIndex;

        for (var index = firstIndex; index < finalIndex; index++) {
            var listing = recommendations[index];
            if (listing) {
                edap_propertyViewed(boardId, listing.listingId, index, total);
            }
        }
    };

    RecommendedPropertyCarouselWrapper.prototype.onEnter = function onEnter() {
        var scrolledIntoView = this.props.scrolledIntoView;

        scrolledIntoView();
    };

    RecommendedPropertyCarouselWrapper.prototype.handleResize = function handleResize(_ref) {
        var numberCardsVisible = _ref.numberCardsVisible;
        var _props4 = this.props,
            changeNumCardsVisible = _props4.changeNumCardsVisible,
            numCardsVisible = _props4.numCardsVisible;


        if (numberCardsVisible > numCardsVisible) {
            changeNumCardsVisible(numberCardsVisible);
        }
    };

    RecommendedPropertyCarouselWrapper.prototype.handleNextArrowClick = function handleNextArrowClick(_, cardIndex) {
        var _props5 = this.props,
            changeCardIndex = _props5.changeCardIndex,
            boardId = _props5.boardId;

        changeCardIndex(cardIndex);
        edap_carouselNext(boardId);
    };

    RecommendedPropertyCarouselWrapper.prototype.handlePrevArrowClick = function handlePrevArrowClick(_, cardIndex) {
        var _props6 = this.props,
            changeCardIndex = _props6.changeCardIndex,
            boardId = _props6.boardId;

        changeCardIndex(cardIndex);
        edap_carouselPrev(boardId);
    };

    RecommendedPropertyCarouselWrapper.prototype.handleHitClick = function handleHitClick(listingId, position) {
        var _props7 = this.props,
            boardId = _props7.boardId,
            recommendations = _props7.recommendations;

        var total = recommendations.length;
        return function () {
            edap_recommendedListingClick(boardId, listingId, position, total);
        };
    };

    RecommendedPropertyCarouselWrapper.prototype.render = function render() {
        var formatMessage = this.props.intl.formatMessage;

        var carouselProps = recommended_properties_carousel__extends({}, this.props, {
            title: formatMessage({ id: 'tripboards.recommendedProperties.recommendationMessage' }),
            handleHitClick: this.handleHitClick,
            handleNextArrowClick: this.handleNextArrowClick,
            handlePrevArrowClick: this.handlePrevArrowClick,
            handleResize: this.handleResize
        });
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            lib_transpiled["Waypoint"],
            { onEnter: this.onEnter },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(recommended_properties_carousel_RecommendedPropertyCarousel, carouselProps)
        );
    };

    return RecommendedPropertyCarouselWrapper;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
var recommended_properties_carousel_mapStateToProps = function mapStateToProps(_ref2, _ref3) {
    var isMobile = _ref2.system.isMobile,
        _ref2$tripboard = _ref2.tripboard;
    _ref2$tripboard = _ref2$tripboard === undefined ? {} : _ref2$tripboard;
    var _ref2$tripboard$recom = _ref2$tripboard.recommendations;
    _ref2$tripboard$recom = _ref2$tripboard$recom === undefined ? {} : _ref2$tripboard$recom;
    var _ref2$tripboard$recom2 = _ref2$tripboard$recom.cardIndex,
        cardIndex = _ref2$tripboard$recom2 === undefined ? 0 : _ref2$tripboard$recom2,
        _ref2$tripboard$recom3 = _ref2$tripboard$recom.numCardsVisible,
        numCardsVisible = _ref2$tripboard$recom3 === undefined ? 0 : _ref2$tripboard$recom3,
        _ref2$tripboard$recom4 = _ref2$tripboard$recom.isInView,
        isInView = _ref2$tripboard$recom4 === undefined ? false : _ref2$tripboard$recom4;
    var recommendations = _ref3.recommendations;
    return {
        cardIndex: Math.min(cardIndex, Math.max(0, recommendations.length - 1)),
        numCardsVisible: numCardsVisible,
        isInView: isInView,
        isMobile: isMobile
    };
};

var recommended_properties_carousel_mapDispatchToProps = {
    changeCardIndex: recommended_properties_actions.changeCardIndex,
    changeNumCardsVisible: recommended_properties_actions.changeNumCardsVisible,
    scrolledIntoView: recommended_properties_actions.scrolledIntoView
};

/* harmony default export */ var components_recommended_properties_carousel = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(recommended_properties_carousel_mapStateToProps, recommended_properties_carousel_mapDispatchToProps), index_es["injectIntl"], react_determine_if_mobile_lib_transpiled_default.a)(recommended_properties_carousel_RecommendedPropertyCarouselWrapper));
// CONCATENATED MODULE: ./src/universal/tripboard/recommended-properties/components/recommended-properties-provider.js
var recommended_properties_provider__templateObject = recommended_properties_provider__taggedTemplateLiteralLoose(['\n    query recommendations($listingIds: [String]!, $currency: String!, $withDates: Boolean!, $stay: StayDates, $maxProperties: Int) {\n        recommendations(listingIds: $listingIds, stay: $stay, maxProperties: $maxProperties) {\n            status\n            availableForDates\n            averagePrice {\n                currencySymbol\n                currencyUnits\n                localized\n                periodType\n                value\n            }\n            priceSummary(currency: $currency) @include(if: $withDates) {\n                formattedAmount\n                pricePeriodDescription\n                edapEventJson\n            }\n            bathrooms {\n                full\n                half\n                toiletOnly\n            }\n            instantBookable\n            bedrooms\n            sleeps\n            headline\n            listingId\n            unitApiUrl\n            detailPageUrl\n            reviewCount\n            averageRating\n            images {\n                c6_uri\n            }\n        }\n    } '], ['\n    query recommendations($listingIds: [String]!, $currency: String!, $withDates: Boolean!, $stay: StayDates, $maxProperties: Int) {\n        recommendations(listingIds: $listingIds, stay: $stay, maxProperties: $maxProperties) {\n            status\n            availableForDates\n            averagePrice {\n                currencySymbol\n                currencyUnits\n                localized\n                periodType\n                value\n            }\n            priceSummary(currency: $currency) @include(if: $withDates) {\n                formattedAmount\n                pricePeriodDescription\n                edapEventJson\n            }\n            bathrooms {\n                full\n                half\n                toiletOnly\n            }\n            instantBookable\n            bedrooms\n            sleeps\n            headline\n            listingId\n            unitApiUrl\n            detailPageUrl\n            reviewCount\n            averageRating\n            images {\n                c6_uri\n            }\n        }\n    } ']);

function recommended_properties_provider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function recommended_properties_provider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function recommended_properties_provider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function recommended_properties_provider__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }








var recommendedProperties = src_default()(recommended_properties_provider__templateObject);

var recommended_properties_provider_mapStateToProps = function mapStateToProps(_ref) {
    var _ref$system$currency = _ref.system.currency,
        currency = _ref$system$currency === undefined ? '' : _ref$system$currency;
    return {
        currency: currency
    };
};

var recommended_properties_provider_RecommendedPropertyProvider = function (_Component) {
    recommended_properties_provider__inherits(RecommendedPropertyProvider, _Component);

    function RecommendedPropertyProvider() {
        recommended_properties_provider__classCallCheck(this, RecommendedPropertyProvider);

        return recommended_properties_provider__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    RecommendedPropertyProvider.prototype.render = function render() {
        var _props = this.props,
            listingIds = _props.listingIds,
            stay = _props.stay,
            currency = _props.currency,
            boardId = _props.boardId,
            maxProperties = _props.maxProperties;

        if (!listingIds || listingIds.length === 0) {
            return null;
        }
        var hasDates = !!(stay && stay.dateRange && stay.dateRange.arrival && stay.dateRange.departure);

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_apollo_browser_umd["Query"],
            { query: recommendedProperties, errorPolicy: 'all', variables: { listingIds: listingIds, currency: currency, stay: stay.dateRange, withDates: hasDates, maxProperties: maxProperties } },
            function (_ref2) {
                var data = _ref2.data,
                    loading = _ref2.loading;

                if (loading) {
                    return null;
                }
                var filteredData = data && data.recommendations && data.recommendations.filter(function (listing) {
                    return listing && listing.status !== 'DELISTED' && listing.listingId;
                }) || [];
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_recommended_properties_carousel, { boardId: boardId, recommendations: filteredData, stay: stay });
            }
        );
    };

    return RecommendedPropertyProvider;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);
/* harmony default export */ var recommended_properties_provider = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(recommended_properties_provider_mapStateToProps))(recommended_properties_provider_RecommendedPropertyProvider));
// CONCATENATED MODULE: ./src/universal/tripboard/recommended-properties/reducer-recommended-properties.js
var reducer_recommended_properties__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var reducer_recommended_properties_actionHandlers = {};
var reducer_recommended_properties_initialState = {
    cardIndex: 0,
    numCardsVisible: 0,
    isInView: false
};

reducer_recommended_properties_actionHandlers[recommended_properties_actions.CHANGE_CARD_INDEX] = function (state, _ref) {
    var cardIndex = _ref.payload.cardIndex;

    return reducer_recommended_properties__extends({}, state, {
        cardIndex: cardIndex
    });
};

reducer_recommended_properties_actionHandlers[recommended_properties_actions.CHANGE_NUM_CARDS_VISIBLE] = function (state, _ref2) {
    var numCardsVisible = _ref2.payload.numCardsVisible;

    return reducer_recommended_properties__extends({}, state, {
        numCardsVisible: numCardsVisible
    });
};

reducer_recommended_properties_actionHandlers[recommended_properties_actions.SCROLLED_INTO_VIEW] = function (state) {
    return reducer_recommended_properties__extends({}, state, {
        isInView: true
    });
};

/* harmony default export */ var reducer_recommended_properties = (utils_createReducer(reducer_recommended_properties_actionHandlers, reducer_recommended_properties_initialState));
// CONCATENATED MODULE: ./src/universal/tripboard/recommended-properties/index.js




// CONCATENATED MODULE: ./src/universal/tripboard/listing-delete-modal/reducer.js
var listing_delete_modal_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var listing_delete_modal_reducer_actionHandlers = {};

var listing_delete_modal_reducer_initialState = {
    isOpen: false,
    boardId: null,
    hitTotal: null,
    idx: null,
    listingId: null
};

listing_delete_modal_reducer_actionHandlers[listing_delete_modal_actions.MODAL_OPEN] = function (state, _ref) {
    var payload = _ref.payload;

    var isOpen = true;
    var boardId = payload.boardId,
        listingId = payload.listingId,
        hitTotal = payload.hitTotal,
        idx = payload.idx;

    return listing_delete_modal_reducer__extends({}, state, {
        boardId: boardId,
        isOpen: isOpen,
        listingId: listingId,
        hitTotal: hitTotal,
        idx: idx
    });
};

listing_delete_modal_reducer_actionHandlers[listing_delete_modal_actions.MODAL_CLOSE] = function () {
    return listing_delete_modal_reducer_initialState;
};

/* harmony default export */ var listing_delete_modal_reducer = (utils_createReducer(listing_delete_modal_reducer_actionHandlers, listing_delete_modal_reducer_initialState));
// CONCATENATED MODULE: ./src/universal/tripboard/reducer.js









var combined = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["combineReducers"])({
    collaborate: collaborate_reducer,
    comments: reducer,
    currentTripboard: current_tripboard_reducer,
    recommendations: reducer_recommended_properties,
    tripboards: tripboard_reducer,
    createControls: create_tripboard_reducer,
    listingDeleteModal: listing_delete_modal_reducer
});

/* harmony default export */ var universal_tripboard_reducer = (combined);
// CONCATENATED MODULE: ./src/universal/abacus/abacus-classes/abacus-classes.js



function AbacusClasses(_ref) {
    var _ref$abacus = _ref.abacus,
        abacus = _ref$abacus === undefined ? {} : _ref$abacus,
        children = _ref.children,
        _ref$testNames = _ref.testNames,
        testNames = _ref$testNames === undefined ? [] : _ref$testNames;

    var classNames = testNames.reduce(function (className, testName) {
        var test = abacus[testName] || { value: 0 };
        return className + ' ' + testName + '-' + test.value;
    }, '');

    if (classNames === '') {
        return children;
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Children.map(children, function (child) {
        var className = child.props.className || '';
        className = className.length ? className + ' ' + classNames : classNames;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.cloneElement(child, { className: className });
    });
}

/* harmony default export */ var abacus_classes = (withAbacus(AbacusClasses));
// CONCATENATED MODULE: ./src/universal/tripboard/activity-indicator/activity-indicator-graphql.js
var activity_indicator_graphql__templateObject = activity_indicator_graphql__taggedTemplateLiteralLoose(['\nquery indicators($hav: String!) {\n    indicators(hav: $hav)\n}'], ['\nquery indicators($hav: String!) {\n    indicators(hav: $hav)\n}']);

function activity_indicator_graphql__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }



var GET_INDICATORS = src_default()(activity_indicator_graphql__templateObject);

/* istanbul ignore next */
var activity_indicator_graphql_queryOptions = function queryOptions(_ref) {
    var hav = _ref.hav;
    return {
        variables: { hav: hav },
        notifyOnNetworkStatusChange: false,
        errorPolicy: 'all'
    };
};

/**
 * Remove indicator from the cache
 * @param {ApolloClient} client
 */
var removeIndicator = function removeIndicator(_ref2) {
    var boardId = _ref2.boardId,
        client = _ref2.client,
        hav = _ref2.hav;

    var variables = { hav: hav };
    var cache = client.readQuery({ query: GET_INDICATORS, variables: variables });
    if (cache && Array.isArray(cache.indicators)) {
        cache.indicators = cache.indicators.filter(function (board) {
            return board !== boardId;
        });
        client.writeQuery({ query: GET_INDICATORS, variables: variables, data: cache });
    }
};
// EXTERNAL MODULE: ./src/universal/tripboard/activity-indicator/activity-indicator.less
var activity_indicator = __webpack_require__("rpn+");
var activity_indicator_default = /*#__PURE__*/__webpack_require__.n(activity_indicator);

// CONCATENATED MODULE: ./src/universal/tripboard/activity-indicator/activity-indicator.js
var activity_indicator__withAbacusTestValues;

function activity_indicator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function activity_indicator__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function activity_indicator__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @abacus 28106 - ha_pulse_activity_indicators */














/* istanbul ignore next */
var activity_indicator_onClick = function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
};

var HA_PULSE_ACTIVITY_INDICATORS = experiments_default.a.HA_PULSE_ACTIVITY_INDICATORS;
var activity_indicator_testExposure = new test_exposure_once_TestExposureOnce(HA_PULSE_ACTIVITY_INDICATORS);

var getClassIndex = function getClassIndex() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var idx = index + 1;
    if (idx > 3) {
        if (idx % 5 === 0) {
            return 5;
        }
        if (idx % 3 === 0) {
            return 3;
        }
        if (idx % 2 === 0) {
            return 2;
        }
        return 1;
    }
    return idx;
};

var hasNewActivity = function hasNewActivity(boardId) {
    var uuids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!Array.isArray(uuids)) {
        return false;
    }
    return uuids.indexOf(boardId) !== -1;
};

function ActivityIndicatorIcon(_ref) {
    var boardId = _ref.boardId,
        langTooltip = _ref.langTooltip;

    // Tooltip fires the onOpen callback multiple times
    /* istanbul ignore next */
    var onOpen = lodash_debounce_default()(function () {
        tripboard_edap.activityIndicatorTooltip(boardId);
    }, 250);

    /** @edap */
    tripboard_edap.activityIndicator(boardId);

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_tooltip_lib_transpiled_default.a, {
        centered: true,
        content: langTooltip,
        onOpen: onOpen,
        placement: 'top',
        tooltipType: 'tooltip',
        trigger: 'click hover',
        wrapperClassName: 'activity-indicator--tooltip'
    });
}

var activity_indicator_ActivityIndicator = function (_Component) {
    activity_indicator__inherits(ActivityIndicator, _Component);

    function ActivityIndicator(props) {
        activity_indicator__classCallCheck(this, ActivityIndicator);

        var _this = activity_indicator__possibleConstructorReturn(this, _Component.call(this, props));

        activity_indicator__initialiseProps.call(_this);

        _this.state = _this.getActivityState(props);
        return _this;
    }

    ActivityIndicator.prototype.componentDidMount = function componentDidMount() {
        this.setActivityState(this.state);
    };

    ActivityIndicator.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref2, _ref3) {
        var loading = _ref2.data.loading;
        var hasActivity = _ref3.hasActivity;
        var data = this.props.data;

        return loading !== data.loading || hasActivity !== this.state.hasActivity;
    };

    ActivityIndicator.prototype.componentDidUpdate = function componentDidUpdate() {
        var state = this.getActivityState(this.props);
        this.setActivityState(state);
    };

    ActivityIndicator.prototype.render = function render() {
        var _state = this.state,
            hasActivity = _state.hasActivity,
            index = _state.index;
        var _props = this.props,
            boardId = _props.boardId,
            langTooltip = _props.langTooltip,
            testValue = _props.testValue;


        if (testValue > 0) {
            if (hasActivity) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    {
                        className: 'activity-indicator activity-indicator--active activity-indicator--' + getClassIndex(index),
                        onClick: activity_indicator_onClick,
                        onKeyPress: activity_indicator_onClick,
                        role: 'none'
                    },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(ActivityIndicatorIcon, {
                        boardId: boardId,
                        langTooltip: langTooltip
                    })
                );
            }

            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('span', {
                className: 'activity-indicator activity-indicator--none',
                role: 'none'
            });
        }

        return null;
    };

    return ActivityIndicator;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

activity_indicator_ActivityIndicator.defaultProps = {
    data: {},
    testValue: 0
};
activity_indicator_ActivityIndicator.initialState = {
    index: -1,
    hasActivity: false
};

var activity_indicator__initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.getActivityState = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var boardId = props.boardId,
            data = props.data;

        var _ref4 = data || [],
            indicators = _ref4.indicators;

        var hasActivity = hasNewActivity(boardId, indicators);

        if (hasActivity) {
            return {
                hasActivity: hasActivity,
                index: indicators.indexOf(boardId)
            };
        }
        return activity_indicator_ActivityIndicator.initialState;
    };

    this.setActivityState = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var isAlreadyActive = _this2.state.hasActivity;
        if (!state.hasActivity || isAlreadyActive) {
            return;
        }

        /** @edap */
        activity_indicator_testExposure.trigger(HA_PULSE_ACTIVITY_INDICATORS);

        /* istanbul ignore next */
        setTimeout(function () {
            _this2.setState(state);
        }, 0);
    };
};

/* harmony default export */ var activity_indicator_activity_indicator = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, Object(react_apollo_browser_umd["graphql"])(GET_INDICATORS, { options: activity_indicator_graphql_queryOptions }), with_abacus_test_values_as_props((activity_indicator__withAbacusTestValues = {}, activity_indicator__withAbacusTestValues[HA_PULSE_ACTIVITY_INDICATORS] = 'testValue', activity_indicator__withAbacusTestValues)), withTranslationsAsProps({
    'tripboards.new.activity': 'langTooltip'
}))(activity_indicator_ActivityIndicator));
// EXTERNAL MODULE: ./node_modules/react-router/es/index.js
var react_router_es = __webpack_require__("CIox");

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/TRASHCAN__16.js
var TRASHCAN__16 = __webpack_require__("BRq8");
var TRASHCAN__16_default = /*#__PURE__*/__webpack_require__.n(TRASHCAN__16);

// EXTERNAL MODULE: ./src/universal/tripboard/components/tripboard-card.less
var tripboard_card = __webpack_require__("FYws");
var tripboard_card_default = /*#__PURE__*/__webpack_require__.n(tripboard_card);

// CONCATENATED MODULE: ./src/universal/abacus/waterfall/util.js

function isWaterFallOn() {
    var abacus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var evalData = abacus[experiments["WATERFALL_AB"]] || { value: 0 };
    return evalData.value > 0;
}
// EXTERNAL MODULE: ./node_modules/react-async-component/commonjs/index.js
var commonjs = __webpack_require__("jtXF");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-site-header/lib/transpiled/index.js
var react_site_header_lib_transpiled = __webpack_require__("qGti");
var react_site_header_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_site_header_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/abacus/waterfall/async-header.js
var async_header__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* istanbul ignore next */
var AsyncSiteHeader = Object(commonjs["asyncComponent"])({
    name: 'AsyncSiteHeader',
    resolve: function resolve() {
        return Promise.resolve(react_site_header_lib_transpiled_default.a);
    },
    serverMode: 'defer'
});

function AsyncHeader(_ref) {
    var header = _ref.header,
        isMobile = _ref.isMobile,
        siteName = _ref.siteName,
        fullLocale = _ref.fullLocale,
        currency = _ref.currency;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'site-header-container' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(AsyncSiteHeader, async_header__extends({}, header, {
            dataUrl: '/traveler/scratchpad/api/header',
            isMobile: isMobile,
            siteName: siteName,
            fullLocale: fullLocale,
            currencyCode: currency,
            withoutCountryLanguageSelector: false,
            withoutCurrencySelector: false
        }))
    );
}
// CONCATENATED MODULE: ./src/universal/abacus/waterfall/svgs.js
/**
 * @todo If test wins, we should cache these in the common
 * bundle if we are rarely changing them.
 */

function Svgs() {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        "svg",
        { display: "none", width: "0", height: "0", xmlns: "http://www.w3.org/2000/svg" },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            "defs",
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-magnifying-glass", viewBox: "0 0 26 27" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    "g",
                    { id: "UX-LAB-FLOW", fill: "none", fillRule: "evenodd" },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        "g",
                        { id: "Artboard", fill: "#353E44" },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            "g",
                            { id: "Search", transform: "matrix(-1 0 0 1 26 0)" },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M17.06021,20.1815303 L22.9393398,26.0606602 C23.5251263,26.6464466 24.4748737,26.6464466 25.0606602,26.0606602 C25.6464466,25.4748737 25.6464466,24.5251263 25.0606602,23.9393398 L19.3187263,18.197406 C20.9892607,16.2683043 22,13.7521876 22,11 C22,4.92486775 17.0751322,0 11,0 C4.92486775,0 0,4.92486775 0,11 C0,17.0751322 4.92486775,22 11,22 C13.2393827,22 15.3224711,21.330825 17.06021,20.1815303 Z M2,11 C2,6.02943725 6.02943725,2 11,2 C15.9705627,2 20,6.02943725 20,11 C20,15.9705627 15.9705627,20 11,20 C6.02943725,20 2,15.9705627 2,11 Z",
                                id: "Combined-Shape"
                            })
                        )
                    )
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-alert", viewBox: "0 0 50 50" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M48.9 45.8C47.3 48.5 44 50 40 50H10c-4.1 0-7.3-1.5-9-4.2-1.5-2.6-1.4-5.9.3-9.3L17.8 5.4C19.6 1.9 22.2 0 25 0s5.4 1.9 7.3 5.4l16.3 31.1c1.8 3.4 1.9 6.7.3 9.3zM45.8 38L29.5 6.9c-1.2-2.4-2.9-3.8-4.5-3.8s-3.2 1.4-4.5 3.8L4.2 38c-1.3 2.4-1.4 4.6-.4 6.2 1 1.7 3.3 2.7 6.3 2.7H40c3 0 5.2-1 6.3-2.7.9-1.6.8-3.8-.5-6.2zm-16.1 1.1c0 2.6-2.1 4.7-4.7 4.7s-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7 4.7 2.1 4.7 4.7zm-8-11L20.5 14c-.1-1.7 1.2-3.1 2.9-3.1h3.1c1.7 0 3 1.4 2.9 3.1l-1.1 14.1c-.1 1.7-1.6 3.1-3.3 3.1s-3.2-1.3-3.3-3.1zm6.4 11c0-1.7-1.4-3.1-3.1-3.1-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1c1.7 0 3.1-1.4 3.1-3.1zm-6-25.2L23.2 28c0 .9.9 1.7 1.8 1.7s1.7-.8 1.8-1.7l1.1-14.1c0-.4-.1-.8-.3-1s-.6-.4-1-.4h-3.1c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-remove", viewBox: "-28 -14 50 50" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M-3 35.4c-13.4 0-24.4-11-24.4-24.4 0-13.4 11-24.4 24.4-24.4 13.4 0 24.4 11 24.4 24.4 0 13.4-11 24.4-24.4 24.4zM-3-11c-12.2 0-22 9.8-22 22s9.8 22 22 22 22-9.8 22-22S9.3-11-3-11z" }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M-11.2 1.2l18 18L5.4 21l-18-18.2z" }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M5.2 1.2l1.6 1.6-18 18-1.7-1.5z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-mansion", viewBox: "0 0 60 44" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    "g",
                    { fillRule: "evenodd" },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M40.445619 28.0942809L40.445619 21.5457702C40.445619 21.1001532 40.0789524 20.7397277 39.625619 20.7397277L34.1760952 20.7397277C33.7237143 20.7397277 33.3570476 21.1001532 33.3570476 21.5457702L33.3570476 28.0942809C33.3570476 28.5389617 33.7237143 28.8993872 34.1760952 28.8993872L39.625619 28.8993872C40.0789524 28.8993872 40.445619 28.5389617 40.445619 28.0942809M14.651619 27.8888851L9.20304762 27.8888851C8.75066667 27.8888851 8.384 28.2493106 8.384 28.6939915L8.384 35.2434383C8.384 35.6881191 8.75066667 36.0485447 9.20304762 36.0485447L14.651619 36.0485447C15.104 36.0485447 15.471619 35.6881191 15.471619 35.2434383L15.471619 28.6939915C15.471619 28.2493106 15.104 27.8888851 14.651619 27.8888851M24.578 27.8888851L19.1275238 27.8888851C18.6751429 27.8888851 18.3084762 28.2493106 18.3084762 28.6939915L18.3084762 35.2434383C18.3084762 35.6881191 18.6751429 36.0485447 19.1275238 36.0485447L24.578 36.0485447C25.030381 36.0485447 25.3970476 35.6881191 25.3970476 35.2434383L25.3970476 28.6939915C25.3970476 28.2493106 25.030381 27.8888851 24.578 27.8888851M45.9828571 28.8996681L51.4314286 28.8996681C51.8847619 28.8996681 52.2514286 28.5392426 52.2514286 28.0945617L52.2514286 21.5451149C52.2514286 21.100434 51.8847619 20.7400085 51.4314286 20.7400085L45.9828571 20.7400085C45.5304762 20.7400085 45.1638095 21.100434 45.1638095 21.5451149L45.1638095 28.0945617C45.1638095 28.5392426 45.5304762 28.8996681 45.9828571 28.8996681" }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M39.7764762,43.1922723 L39.7764762,43.1922723 C39.8898095,43.1922723 39.9974286,43.1698043 40.0955238,43.1286128 C39.9974286,43.1698043 39.8898095,43.1922723 39.7764762,43.1922723 L39.7764762,43.1922723 Z M0.860285714,22.9822298 L5.4012381,9.88801702 L0.860285714,22.9822298 C0.839333333,23.044017 0.826,23.1067404 0.820285714,23.1704 C0.826,23.1067404 0.839333333,23.044017 0.860285714,22.9822298 L0.860285714,22.9822298 Z M19.8231429,4.78120851 C19.8240952,4.67074043 19.8479048,4.56588936 19.8898095,4.4704 C19.8479048,4.56588936 19.8240952,4.67074043 19.8231429,4.78120851 L19.8231429,4.78120851 Z M26.8469524,4.47695319 C26.7640952,4.28410213 26.6069524,4.12963404 26.4107619,4.04818723 C26.6069524,4.12963404 26.7640952,4.28410213 26.8469524,4.47695319 L26.8469524,4.47695319 Z M29.618381,16.4842723 L42.8050476,3.25993191 L55.9907619,16.4842723 L29.618381,16.4842723 Z M38.9574286,33.4542298 L38.9574286,41.5811234 L30.0012381,41.5811234 L30.0012381,18.0954213 L55.6079048,18.0954213 L55.6079048,41.5811234 L46.6517143,41.5811234 L46.6517143,33.4542298 C46.6517143,33.0086128 46.2850476,32.6481872 45.8317143,32.6481872 L39.7764762,32.6481872 C39.3240952,32.6481872 38.9574286,33.0086128 38.9574286,33.4542298 L38.9574286,33.4542298 Z M5.78504762,41.5811234 L28.3621905,41.5811234 L28.3621905,24.0475915 L5.78504762,24.0475915 L5.78504762,41.5811234 Z M21.4526667,9.34316596 L25.2726667,9.34316596 L25.2726667,5.5956766 L21.4526667,5.5956766 L21.4526667,9.34316596 Z M2.7812381,22.4364426 L6.76314286,10.9543149 L32.838381,10.9543149 L27.0821905,16.7267404 C26.8507619,16.9579745 26.7840952,17.3024851 26.9117143,17.6020596 C27.0393333,17.901634 27.3374286,18.0954213 27.6669524,18.0954213 L28.3621905,18.0954213 L28.3621905,22.4364426 L2.7812381,22.4364426 Z M43.3898095,1.54580426 L58.5269524,16.7267404 L43.3898095,1.54580426 C43.313619,1.46810213 43.2221905,1.40818723 43.1221905,1.36699574 C43.2221905,1.40818723 43.313619,1.46810213 43.3898095,1.54580426 L43.3898095,1.54580426 Z M59.0564762,16.2165277 L43.9193333,1.03559149 C43.6269524,0.742570213 43.2212381,0.574995745 42.8050476,0.574995745 C42.3879048,0.574995745 41.9821905,0.743506383 41.6907619,1.03559149 L34.1326667,8.61482553 L27.6526667,8.61482553 L27.6526667,4.78963404 C27.6526667,3.94427234 26.9526667,3.25618723 26.0917143,3.25618723 L20.6421905,3.25618723 C19.7917143,3.25618723 19.0917143,3.93584681 19.0812381,4.77278298 L19.0812381,8.61482553 L6.17742857,8.61482553 C5.50790476,8.61482553 4.91457143,9.03235745 4.69933333,9.65397447 L0.159333333,22.7472511 C-0.00352380952,23.2144 0.0745714286,23.7339745 0.366952381,24.1355915 C0.659333333,24.5372085 1.13361905,24.7768681 1.63647619,24.7768681 L3.40504762,24.7768681 L3.40504762,42.3862298 C3.40504762,43.2325277 4.10504762,43.9206128 4.966,43.9206128 L39.7764762,43.9206128 C40.6374286,43.9206128 41.3374286,43.2325277 41.3374286,42.3862298 L41.3374286,34.9876766 L44.2707619,34.9876766 L44.2707619,42.3862298 C44.2707619,43.2325277 44.9717143,43.9206128 45.8317143,43.9206128 L56.4279048,43.9206128 C57.2879048,43.9206128 57.9888571,43.2325277 57.9888571,42.3862298 L57.9888571,18.8237617 C58.5993333,18.8059745 59.1421905,18.4408681 59.3802857,17.8838468 C59.6240952,17.312783 59.4974286,16.6584 59.0564762,16.2165277 L59.0564762,16.2165277 Z" })
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-check", viewBox: "0 0 1024 1024" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { className: "path1", d: "M113.582 531.374c17.449 0 33.423 5.407 47.944 16.2l252.867 189.338 430.981-610.345c12.022-17.019 29.266-27.505 51.651-31.457 22.467-3.953 42.373 0.102 59.781 12.145 17.9 12.861 28.652 30.106 32.42 51.712 3.727 21.586-0.819 41.533-13.701 59.781l-477.696 677.581c-12.861 17.859-30.495 28.836-52.92 33.014-22.446 3.338-42.537-1.638-60.396-14.93l-318.874-239.165c-17.469-13.681-27.832-31.334-31.15-52.9-3.318-21.606 1.884-41.329 15.565-59.187 15.79-21.176 36.966-31.785 63.529-31.785z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-close", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M1.5 50a1.5 1.5 0 0 1-1-2.6l47-47a1.5 1.5 0 0 1 2 2.2l-47 46.8a1.5 1.5 0 0 1-1 .5z" }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M48.4 50a1.5 1.5 0 0 1-1-.4l-47-47A1.5 1.5 0 0 1 2.8.3l46.7 47a1.5 1.5 0 0 1-1 2.6z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-clock", viewBox: "0 0 50 50" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M25 47.1c-11.3 0-20.7-9.2-20.7-20.5C4.3 15 13.6 5.8 25 5.8S45.7 15 45.7 26.5c0 11.3-9.4 20.6-20.7 20.6zm0-38.6c-9.9 0-18 8-18 18s8 18 18 18 18-8.1 18-18-8.1-18-18-18z" }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M27.4 27.8H15.9v-2.6h8.8v-13h2.7M36.03 42.56l1.9-1.9 6.73 6.7-1.9 1.9zM5.32 47.3l6.72-6.73 1.9 1.9-6.7 6.73zM3.5 15.2l-.9-.9C1.1 12.8.3 10.8.3 8.7S1.1 4.5 2.6 3 6 .8 8.2.8s4.1.8 5.6 2.3l.9.9L3.5 15.2zM8.2 3.4c-1.4 0-2.7.6-3.8 1.5S3 7.3 3 8.6c0 .9.3 1.9.7 2.7l7.1-7.1c-.8-.5-1.7-.8-2.6-.8zM46.5 15.2L35.4 4.1l.9-.9C37.6 1.6 39.6.8 41.8.8s4.1.8 5.6 2.3c3.1 3.1 3.1 8 0 11.1l-.9 1zM39.1 4.1l7.1 7.1c1.2-2 .9-4.5-.8-6.3-1.6-1.6-4.3-1.9-6.3-.8z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-heart", viewBox: "-1 -1 18 15" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-navigate-left", viewBox: "0 0 1024 1024" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { className: "path1", d: "M730.583 40.366c17.94 0 33.014 6.144 45.302 18.412 12.288 11.592 18.432 25.825 18.432 42.66 0 17.203-6.164 31.416-18.432 42.66l-379.228 368.169 379.228 368.169c12.288 11.223 18.432 25.457 18.432 42.639 0 16.855-6.164 31.109-18.432 42.68-12.288 11.94-27.546 17.9-45.814 17.9s-33.382-5.96-45.302-17.9l-446.136-432.968c-5.98-5.96-8.95-12.82-8.95-20.521 0-7.721 2.99-14.561 8.95-20.541l446.136-432.947c12.268-12.268 27.525-18.412 45.814-18.412z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-plus", viewBox: "0 0 50 50" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M50 22H28V0h-6v22H0v6h22v22h6V28h22" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-facebook", viewBox: "0 0 373 512" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M139.637 395.637v-170.667h-46.546v-62.060h46.546v-54.303q0-36.202 23.488-60.767t69.603-24.566q11.637 0 23.273 0.862t17.239 1.724l6.034 0.862-2.586 58.613h-40.081q-16.377 0-21.764 7.758t-5.387 23.273v46.546h69.818l-4.74 62.060h-65.077v170.667h-69.818z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-twitter", viewBox: "0 0 373 512" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M372.363 90.074q-15.515 23.272-37.926 39.65v9.912q0 30.6-8.835 61.198t-27.151 58.829-43.744 49.778-60.983 34.478-76.499 12.93q-68.956 0-117.225-31.031 9.050 1.293 18.101 1.293 49.563 0 94.815-36.202-24.566-0.431-44.175-15.3t-26.936-37.71q7.327 1.293 14.222 1.293 10.344 0 20.256-2.586-26.29-5.172-43.744-26.29t-17.454-48.701v-0.862q16.377 9.050 34.478 9.482-34.047-22.842-34.047-63.353 0-18.963 10.343-37.064 28.875 34.909 69.603 55.38t87.703 23.057q-1.724-7.327-1.724-17.67 0-31.462 22.196-53.872t54.088-22.411q32.754 0 56.027 24.135 25.428-5.171 48.269-18.532-8.62 27.582-33.616 42.236 21.98-2.586 43.959-12.067z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-pinterest", viewBox: "0 0 373 512" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M194.802 23.273q59.475 0 97.4 36.417t37.926 85.98q0 63.785-32.108 105.158t-82.963 41.373q-16.808 0-31.677-7.757t-20.903-18.532q-12.067 49.132-15.084 58.613-3.879 15.084-13.791 32.754t-15.299 25.212-9.266 11.852q-1.293 1.724-3.017 1.293t-2.155-2.155q-5.603-54.734 0.862-81.454l27.151-116.363q-6.465-13.791-6.465-34.047 0-23.703 11.852-39.434t29.091-15.73q13.791 0 21.334 9.050t7.542 22.842q0 8.619-3.232 20.903t-8.404 28.66-7.327 26.29q-3.879 16.808 6.464 29.091t27.583 12.283q29.738 0 48.701-33.185t18.963-80.593q0-36.202-23.488-59.044t-65.293-22.842q-47.407 0-76.499 29.953t-29.091 72.189q0 24.996 14.222 42.236 4.74 5.602 3.017 11.637l-1.293 5.172t-1.724 7.327-1.293 4.74q-2.155 8.619-10.775 5.602-21.549-9.050-32.538-31.030t-10.99-50.855q0-23.273 9.913-46.546t28.013-42.882 48.054-31.892 66.586-12.283z" })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                "symbol",
                { id: "svg-share", viewBox: "0 0 16 16" },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    "g",
                    { fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.333" },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M12 10.667v4.666H1.333V6h3.334" }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M6.667 10.667A6.667 6.667 0 0 1 13.333 4h2" }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement("path", { d: "M12.667 6.667L15.333 4l-2.666-2.667" })
                )
            )
        )
    );
}
// CONCATENATED MODULE: ./src/universal/abacus/waterfall/async-svgs.js



/* istanbul ignore next */
var AsyncSvgs = Object(commonjs["asyncComponent"])({
    name: 'AsyncSvgs',
    resolve: function resolve() {
        return Promise.resolve(Svgs);
    },
    serverMode: 'defer'
});

/* harmony default export */ var async_svgs = (AsyncSvgs);
// CONCATENATED MODULE: ./src/universal/abacus/waterfall/lazy-four-pack.js


// Abacus: HA_PULSE_SKELETON_ABC


function LazyFourPack(_ref) {
    var image1 = _ref.image1,
        image2 = _ref.image2,
        image3 = _ref.image3,
        image4 = _ref.image4,
        isLoading = _ref.isLoading;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'four-pack' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'four-pack__grid' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'four-pack__column' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'four-pack__image four-pack__image--rounded-top-left',
                        style: image1 ? { backgroundImage: 'url(' + image1 + ')' } : {}
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'four-pack__separator' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'four-pack__image four-pack__image--rounded-bottom-left',
                        style: image3 ? { backgroundImage: 'url(' + image3 + ')' } : {}
                    })
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'four-pack__separator' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'four-pack__column' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'four-pack__image four-pack__image--rounded-top-right',
                        style: image2 ? { backgroundImage: 'url(' + image2 + ')' } : {}
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'four-pack__separator' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'four-pack__image four-pack__image--rounded-bottom-right',
                        style: image4 ? { backgroundImage: 'url(' + image4 + ')' } : {}
                    })
                )
            )
        )
    );
}
// CONCATENATED MODULE: ./src/universal/abacus/waterfall/lazy-three-pack.js


// Abacus: HA_PULSE_SKELETON_ABC


function LazyThreePack(_ref) {
    var image1 = _ref.image1,
        image2 = _ref.image2,
        image3 = _ref.image3,
        isLoading = _ref.isLoading;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'three-pack' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'three-pack__grid' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'three-pack__column' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'three-pack__image three-pack__image--rounded-top-and-bottom-left three-pack__image--left-panel',
                        style: image1 ? { backgroundImage: 'url(' + image1 + ')' } : {}
                    })
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__separator' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'three-pack__column' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'three-pack__image three-pack__image--rounded-top-right',
                        style: image2 ? { backgroundImage: 'url(' + image2 + ')' } : {}
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'three-pack__separator' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    skeleton_abc_skeleton_loading,
                    { loading: isLoading },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', {
                        className: 'three-pack__image three-pack__image--rounded-bottom-right',
                        style: image3 ? { backgroundImage: 'url(' + image3 + ')' } : {}
                    })
                )
            )
        )
    );
}
// CONCATENATED MODULE: ./src/universal/abacus/waterfall/lazy-image-pack.js
var lazy_image_pack__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function lazy_image_pack__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function lazy_image_pack__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lazy_image_pack__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lazy_image_pack__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LAZYLOAD_DELAY = 250;

/**
 * Lazy load images for ThreePack or FourPack.
 * Populate images from state vs props. If we are supposed
 * to lazy load, then init state to null and update state
 * from props after the component has mounted.
 */

var lazy_image_pack_LazyImagePack = function (_Component) {
    lazy_image_pack__inherits(LazyImagePack, _Component);

    function LazyImagePack(props) {
        lazy_image_pack__classCallCheck(this, LazyImagePack);

        var _this = lazy_image_pack__possibleConstructorReturn(this, _Component.call(this, props));

        lazy_image_pack__initialiseProps.call(_this);

        var isLazyLoaded = true;
        var isLazyLoad = props.isLazyLoad,
            image1 = props.image1,
            image2 = props.image2,
            image3 = props.image3,
            image4 = props.image4;


        var lazyLoadState = {
            isLazyLoaded: false,
            image1: null,
            image2: null,
            image3: null,
            image4: null
        };

        _this.state = isLazyLoad ? lazyLoadState : { isLazyLoaded: isLazyLoaded, image1: image1, image2: image2, image3: image3, image4: image4 };
        return _this;
    }

    LazyImagePack.prototype.componentDidMount = function componentDidMount() {
        var isLazyLoad = this.props.isLazyLoad;


        if (isLazyLoad) {
            this.lazyLoadImages();
        }
    };

    // Fixes component rendering 3x (render 2x max depending on isLazyLoad)


    LazyImagePack.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var isImageChange = this.didImagesChange(nextProps);
        var isLazyLoadChange = this.didLazyLoadChange(nextState);
        return isImageChange || isLazyLoadChange;
    };

    LazyImagePack.prototype.render = function render() {
        var _props = this.props,
            isLoading = _props.isLoading,
            isThreePack = _props.isThreePack;

        var rest = lazy_image_pack__objectWithoutProperties(this.state, []);

        if (isThreePack) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(LazyThreePack, lazy_image_pack__extends({ isLoading: isLoading }, rest));
        }
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(LazyFourPack, lazy_image_pack__extends({ isLoading: isLoading }, rest));
    };

    return LazyImagePack;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

lazy_image_pack_LazyImagePack.defaultProps = {
    image1: null,
    image2: null,
    image3: null,
    image4: null,
    isThreePack: false,
    isLazyLoad: false, // Abacus: waterfall
    isLoading: false // Abacus: skeleton_abc
};

var lazy_image_pack__initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.didImagesChange = function (nextProps) {
        var _props2 = _this2.props,
            image1 = _props2.image1,
            image2 = _props2.image2,
            image3 = _props2.image3,
            image4 = _props2.image4;

        return image1 !== nextProps.image1 || image2 !== nextProps.image2 || image3 !== nextProps.image3 || image4 !== nextProps.image4;
    };

    this.didLazyLoadChange = function (nextState) {
        var isLazyLoaded = _this2.state.isLazyLoaded;

        return isLazyLoaded !== nextState.isLazyLoaded;
    };

    this.lazyLoadImages = function () {
        setTimeout(function () {
            _this2.updateImageState();
        }, LAZYLOAD_DELAY);
    };

    this.updateImageState = function () {
        var isLazyLoaded = true;
        var _props3 = _this2.props,
            image1 = _props3.image1,
            image2 = _props3.image2,
            image3 = _props3.image3,
            image4 = _props3.image4;

        _this2.setState({ isLazyLoaded: isLazyLoaded, image1: image1, image2: image2, image3: image3, image4: image4 });
    };
};


// CONCATENATED MODULE: ./src/universal/abacus/waterfall/index.js
 // 25978







// CONCATENATED MODULE: ./src/universal/tripboard/components/tripboard-card.js
var tripboard_card__withAbacusTestValues;

function tripboard_card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tripboard_card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tripboard_card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















// Abacus: HA_PULSE_SKELETON_ABC


// Abacus: waterfall


// export base presentational Component
var tripboard_card_TripboardCard = function (_Component) {
    tripboard_card__inherits(TripboardCard, _Component);

    function TripboardCard(props) {
        tripboard_card__classCallCheck(this, TripboardCard);

        var _this = tripboard_card__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleClick = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                index = _this$props.index,
                total = _this$props.total;

            if (_this.isDisabled() || _this.state.isPendingDeletion) {
                return;
            }
            tripboard_edap.boardClick(boardId, index, total);
            _this.setState({ shouldRedirect: true });
        };

        _this.markDelete = function (e) {
            var boardId = _this.props.boardId;

            e.stopPropagation();
            if (!_this.isDisabled()) {
                _this.setState({ isPendingDeletion: true });
                tripboard_edap.deleteStart(boardId);
            }
        };

        _this.confirmDelete = function () {
            var _this$props2 = _this.props,
                onDelete = _this$props2.onDelete,
                boardId = _this$props2.boardId;

            onDelete(boardId);
            tripboard_edap.deleteAttempt(_this.props.boardId);
        };

        _this.cancelDelete = function () {
            _this.setState({ isPendingDeletion: false });
            tripboard_edap.deleteCancel(_this.props.boardId);
        };

        _this.isDisabled = function () {
            var _this$props3 = _this.props,
                boardId = _this$props3.boardId,
                isLoading = _this$props3.isLoading;

            return !boardId || isLoading || false;
        };

        _this.renderCardPack = function () {
            var _this$props4 = _this.props,
                image1 = _this$props4.image1,
                image2 = _this$props4.image2,
                image3 = _this$props4.image3,
                isLoading = _this$props4.isLoading,
                isLazyLoad = _this$props4.isLazyLoad,
                waterfallTestValue = _this$props4.waterfallTestValue;


            var isWaterFallTestOn = waterfallTestValue > 0;

            // Abacus: waterfall
            if (isWaterFallTestOn) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(lazy_image_pack_LazyImagePack, {
                    image1: image1,
                    image2: image2,
                    image3: image3,
                    isLazyLoad: isLazyLoad,
                    isThreePack: true
                });
            }

            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_three_pack, {
                image1: image1,
                image2: image2,
                image3: image3,
                isLoading: isLoading // Abacus: skeleton abc
            });
        };

        _this.state = {
            isPendingDeletion: false,
            shouldRedirect: false
        };
        return _this;
    }

    // Abacus: skeleton test


    TripboardCard.prototype.render = function render() {
        var _state = this.state,
            isPendingDeletion = _state.isPendingDeletion,
            shouldRedirect = _state.shouldRedirect;
        var _props = this.props,
            boardId = _props.boardId,
            count = _props.count,
            isLoading = _props.isLoading,
            langCancel = _props.langCancel,
            langDeleteConfirmation = _props.langDeleteConfirmation,
            langYesDelete = _props.langYesDelete,
            langDeleteNoUndo = _props.langDeleteNoUndo,
            langRemoveConfirmation = _props.langRemoveConfirmation,
            langRemoveNoUndo = _props.langRemoveNoUndo,
            langYesRemove = _props.langYesRemove,
            name = _props.name,
            role = _props.role;


        if (shouldRedirect) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_router_es["Redirect"], {
                push: true,
                to: {
                    pathname: universal_routes.TRIPBOARD_DETAILS.replace(':boardId', boardId),
                    state: { referrer: universal_routes.TRIPBOARD }
                }
            });
        }

        var tripboardSummaryHitClass = isPendingDeletion ? 'tripboard-summary-hit__inner is-blurred' : 'tripboard-summary-hit__inner';

        var cardClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
            'tripboard-summary-hit': true,
            'card': true,
            'is-disabled': this.isDisabled()
        });

        var cardPack = this.renderCardPack();

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            abacus_classes,
            { testNames: [HA_PULSE_ACTIVITY_INDICATORS] },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'tripboard-summary-container__hit-wrapper' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    {
                        className: cardClass,
                        'data-wdio': 'tripboard-summary__hit-button',
                        onClick: this.handleClick,
                        onKeyPress: this.handleClick,
                        role: 'button',
                        tabIndex: '0'
                    },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: tripboardSummaryHitClass },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'tripboard-summary-hit__top-bar' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                skeleton_abc_skeleton_loading,
                                { loading: isLoading },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'h3',
                                    {
                                        className: 'tripboard-summary-hit__name',
                                        'data-wdio': 'tripboard-summary__hit-name'
                                    },
                                    name
                                )
                            ),
                            boardId && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(activity_indicator_activity_indicator, { boardId: boardId }),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                skeleton_hidden,
                                { loading: isLoading },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'span',
                                    { className: 'tripboard-summary-hit__listings' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'svg',
                                        { className: 'tripboard-summary-hit__heart svg-black inline-svg' },
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { d: 'M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z' })
                                    ),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'small',
                                        { className: 'tripboard-summary-hit__count', 'data-wdio': 'tripboard-summary__hit-count' },
                                        count
                                    )
                                )
                            )
                        ),
                        cardPack,
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'tripboard-summary-hit__bottom-bar' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                skeleton_abc_skeleton_loading,
                                { loading: isLoading },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
                                    'aria-label': role === ROLES.COLLABORATOR ? langRemoveConfirmation : langDeleteConfirmation,
                                    className: 'btn btn-link tripboard-summary-hit__btn-trashcan',
                                    onClick: this.markDelete,
                                    label: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                                        null,
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                            skeleton_hidden,
                                            { loading: isLoading },
                                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inlineFlex: true, markup: TRASHCAN__16["TRASHCAN__16"] })
                                        )
                                    )
                                })
                            )
                        )
                    ),
                    isPendingDeletion && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'tripboard-summary-prompt' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'tripboard-summary-prompt__content' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, inverse: true, collaborator: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'p',
                                    { className: 'tripboard-summary-prompt__copy' },
                                    langDeleteConfirmation + ' ' + langDeleteNoUndo + '.'
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'button',
                                    { className: 'tripboard-summary-prompt__delete-btn btn btn-sm btn-overlay', onClick: this.confirmDelete, 'data-wdio': 'tripboard-summary__hit-delete--confirm' },
                                    langYesDelete
                                )
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, collaborator: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'p',
                                    { className: 'tripboard-summary-prompt__copy' },
                                    langRemoveConfirmation + ' ' + langRemoveNoUndo + '.'
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'button',
                                    { className: 'tripboard-summary-prompt__delete-btn btn btn-sm btn-overlay', onClick: this.confirmDelete, 'data-wdio': 'tripboard-summary__hit-delete--confirm' },
                                    langYesRemove
                                )
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'button',
                                { className: 'tripboard-summary-prompt__cancel-btn btn btn-sm btn-overlay', onClick: this.cancelDelete, 'data-wdio': 'tripboard-summary__hit-delete--cancel' },
                                langCancel
                            )
                        )
                    )
                )
            )
        );
    };

    return TripboardCard;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

// export wired component as default
tripboard_card_TripboardCard.propTypes = {
    boardId: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    count: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    index: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    name: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    role: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    total: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    onDelete: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    image1: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    image2: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    image3: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};
tripboard_card_TripboardCard.defaultProps = {
    count: 0,
    index: 0,
    role: ROLES.OWNER,
    total: 0,
    waterfallTestValue: 0
};
/* harmony default export */ var components_tripboard_card = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(abacus_with_abacus_test_values_as_props((tripboard_card__withAbacusTestValues = {}, tripboard_card__withAbacusTestValues[experiments["WATERFALL_AB"]] = 'waterfallTestValue', tripboard_card__withAbacusTestValues)), withTranslationsAsProps({
    'tripboards.cancel': 'langCancel',
    'tripboards.main.delete.confirmation': 'langDeleteConfirmation',
    'tripboards.main.yes.delete': 'langYesDelete',
    'tripboards.main.delete.cant.undo': 'langDeleteNoUndo',
    'tripboards.main.remove.confirmation': 'langRemoveConfirmation',
    'tripboards.main.remove.cant.undo': 'langRemoveNoUndo',
    'tripboards.main.yes.remove': 'langYesRemove'
}))(tripboard_card_TripboardCard));
// EXTERNAL MODULE: ./src/universal/tripboard/components/empty-tripboard-label.less
var empty_tripboard_label = __webpack_require__("WpB1");
var empty_tripboard_label_default = /*#__PURE__*/__webpack_require__.n(empty_tripboard_label);

// CONCATENATED MODULE: ./src/universal/tripboard/components/empty-tripboard-label.js
var empty_tripboard_label__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var empty_tripboard_label_React = __webpack_require__("GiK3");








var empty_tripboard_label_EmptyTripboardLabel = function EmptyTripboardLabel(_ref) {
    var large = _ref.large,
        translations = _ref.translations;

    var emptyText = translations['tripboards.main.empty.state'].split('{heart}'); // no message reader...
    var labelClassName = large ? 'h3 text-300' : 'text-muted';
    var iconClassName = large ? 'create-trip-board__cta_heart create-trip-board__cta_heart--large' : 'create-trip-board__cta_heart';
    return empty_tripboard_label_React.createElement(
        'p',
        { className: labelClassName, 'data-wdio': 'tripboard-summary__empty-message' },
        emptyText[0],
        empty_tripboard_label_React.createElement(react_svg_lib_transpiled["SVGIcon"], { inlineFlex: true, markup: HEART_SELECTED__16["HEART_SELECTED__16"], className: iconClassName }),
        emptyText[1]
    );
};

empty_tripboard_label_EmptyTripboardLabel.propTypes = {
    large: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool
};

var empty_tripboard_label_mapStateToProps = function mapStateToProps(state, ownProps) {
    return empty_tripboard_label__extends({
        translations: getTranslations(state)
    }, ownProps);
};

/* harmony default export */ var components_empty_tripboard_label = (Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(empty_tripboard_label_mapStateToProps)(empty_tripboard_label_EmptyTripboardLabel));
// CONCATENATED MODULE: ./src/universal/components/onboarding/actions.js
var onboarding_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* istanbul ignore next */
var onboarding_actions_ACTIONS = {
    COMPLETED_TRIPBOARD_ONBOARDING: 'COMPLETED_TRIPBOARD_ONBOARDING',
    STARTED_TRIPBOARD_CREATION: 'STARTED_TRIPBOARD_CREATION',
    COMPLETED_TRIPBOARD_CREATION: 'COMPLETED_TRIPBOARD_CREATION',
    INIT_ONBOARDING_FLAGS: 'INIT_ONBOARDING_FLAGS',
    RESET_ONBOARDING_FLAGS: 'RESET_ONBOARDING_FLAGS'
};

/* istanbul ignore next */
var onboarding_actions_ACTION_CREATORS = {
    completeOnboarding: function completeOnboarding() {
        return { type: onboarding_actions_ACTIONS.COMPLETED_TRIPBOARD_ONBOARDING };
    },
    startTripboardCreation: function startTripboardCreation() {
        return { type: onboarding_actions_ACTIONS.STARTED_TRIPBOARD_CREATION };
    },
    completeTripboardCreation: function completeTripboardCreation() {
        return { type: onboarding_actions_ACTIONS.COMPLETED_TRIPBOARD_CREATION };
    },
    resetOnBoardingFlags: function resetOnBoardingFlags() {
        return { type: onboarding_actions_ACTIONS.RESET_ONBOARDING_FLAGS };
    },
    initOnboardingFlags: function initOnboardingFlags(tripboardCreationStarted, tripboardCreationNotComplete, onboardingCompleted) {
        return {
            type: onboarding_actions_ACTIONS.INIT_ONBOARDING_FLAGS,
            payload: { tripboardCreationStarted: tripboardCreationStarted, tripboardCreationNotComplete: tripboardCreationNotComplete, onboardingCompleted: onboardingCompleted }
        };
    }
};

/* harmony default export */ var onboarding_actions = (onboarding_actions__extends({}, onboarding_actions_ACTIONS, onboarding_actions_ACTION_CREATORS));
// EXTERNAL MODULE: ./src/universal/tripboard/improved-empty-state/improved-empty-state.less
var improved_empty_state = __webpack_require__("fM2g");
var improved_empty_state_default = /*#__PURE__*/__webpack_require__.n(improved_empty_state);

// CONCATENATED MODULE: ./src/universal/tripboard/improved-empty-state/improved-empty-state.js
function improved_empty_state__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function improved_empty_state__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function improved_empty_state__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var improved_empty_state_ImprovedEmptyState = function ImprovedEmptyState(_ref) {
    var loginButtonLabel = _ref.loginButtonLabel,
        signupButtonLabel = _ref.signupButtonLabel,
        learnMoreLabel = _ref.learnMoreLabel,
        loginUrl = _ref.loginUrl,
        loading = _ref.loading,
        handleLoginClick = _ref.handleLoginClick,
        handleSignupClick = _ref.handleSignupClick,
        handleLearnMoreClick = _ref.handleLearnMoreClick;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'improved-empty-state__wrapper' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'improved-empty-state__controls' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loading }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'improved-empty-state__title' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'h2',
                    null,
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.startplan' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.login.prompt' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'improved-empty-state__controlRow' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], { onClick: handleLoginClick, href: loginUrl, label: loginButtonLabel, size: 'sm' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], { onClick: handleSignupClick, href: loginUrl, label: signupButtonLabel, size: 'sm' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'improved-empty-state__learnMoreRow' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    es["Link"],
                    {
                        to: universal_routes.TRIPBOARD,
                        onClick: handleLearnMoreClick,
                        className: 'improved-empty-state__learnMoreLabel'
                    },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
                        null,
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: esm["REPLY__16"] }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'span',
                            { className: 'improved-empty-state__learnMoreText' },
                            learnMoreLabel
                        )
                    )
                )
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'improved-empty-state-splash' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'improved-empty-state-splash__gray-circle' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'improved-empty-state-splash__property-card-1 improved-empty-state-splash__board' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'header text-emphasis' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], {
                        id: 'tripboards.main.empty.board4',
                        defaultMessage: '',
                        description: 'Trip Board title 1'
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'left-content' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'right-content' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__top' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__bottom' })
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'improved-empty-state-splash__property-card-2 improved-empty-state-splash__board' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'header text-emphasis' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], {
                        id: 'tripboards.main.empty.board3',
                        defaultMessage: '',
                        description: 'Trip Board title 2'
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'left-content' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'right-content' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__top' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__bottom' })
                )
            )
        )
    );
};

var improved_empty_state_mapDispatchToProps = {
    fetchLogin: collaborate_actions.login,
    resetOnboarding: onboarding_actions.resetOnBoardingFlags
};

var improved_empty_state_mapStateToProps = function mapStateToProps(state) {
    var collaborateState = state && state.tripboard && state.tripboard.collaborate && state.tripboard.collaborate.modal || {};
    var systemState = state && state.system || {};
    return {
        loginUrl: collaborateState.loginUrl || '',
        loginFetchError: collaborateState.error,
        loginFetchLoading: collaborateState.loading,
        fullLocale: systemState.fullLocale,
        siteName: systemState.siteName
    };
};

var improved_empty_state_ImprovedEmptyStateWrapper = function (_PureComponent) {
    improved_empty_state__inherits(ImprovedEmptyStateWrapper, _PureComponent);

    function ImprovedEmptyStateWrapper(props) {
        improved_empty_state__classCallCheck(this, ImprovedEmptyStateWrapper);

        var _this = improved_empty_state__possibleConstructorReturn(this, _PureComponent.call(this, props));

        _this.getLoginUrl = _this.getLoginUrl.bind(_this);
        _this.handleLoginClick = _this.handleLoginClick.bind(_this);
        _this.handleSignupClick = _this.handleSignupClick.bind(_this);
        _this.handleLearnMoreClick = _this.handleLearnMoreClick.bind(_this);
        _this.getLoginUrl();
        return _this;
    }

    ImprovedEmptyStateWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
        this.getLoginUrl();
    };

    ImprovedEmptyStateWrapper.prototype.getLoginUrl = function getLoginUrl() {
        var _props = this.props,
            loginFetchError = _props.loginFetchError,
            loginFetchLoading = _props.loginFetchLoading,
            fetchLogin = _props.fetchLogin,
            loginUrl = _props.loginUrl,
            fullLocale = _props.fullLocale,
            siteName = _props.siteName;

        if (fullLocale && siteName && !loginFetchError && !loginFetchLoading && !loginUrl) {
            fetchLogin(fullLocale, siteName);
        }
    };

    ImprovedEmptyStateWrapper.prototype.handleLoginClick = function handleLoginClick() {
        tripboard_edap.tripboardLogin();
    };

    ImprovedEmptyStateWrapper.prototype.handleSignupClick = function handleSignupClick() {
        tripboard_edap.tripboardSignup(); // lots of dupe with login click, but keeping it separate for future work
    };

    ImprovedEmptyStateWrapper.prototype.handleLearnMoreClick = function handleLearnMoreClick() {
        tripboard_edap.learnMoreClick();
        this.props.resetOnboarding();
    };

    ImprovedEmptyStateWrapper.prototype.render = function render() {
        var _props2 = this.props,
            title = _props2.title,
            description = _props2.description,
            loginButtonLabel = _props2.loginButtonLabel,
            signupButtonLabel = _props2.signupButtonLabel,
            loginUrl = _props2.loginUrl,
            loginFetchLoading = _props2.loginFetchLoading,
            learnMoreLabel = _props2.learnMoreLabel;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(improved_empty_state_ImprovedEmptyState, {
            title: title,
            description: description,
            signupButtonLabel: signupButtonLabel,
            loginButtonLabel: loginButtonLabel,
            learnMoreLabel: learnMoreLabel,
            loginUrl: loginUrl,
            loading: loginFetchLoading,
            handleLoginClick: this.handleLoginClick,
            handleSignupClick: this.handleSignupClick,
            handleLearnMoreClick: this.handleLearnMoreClick
        });
    };

    return ImprovedEmptyStateWrapper;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["PureComponent"]);

/* harmony default export */ var improved_empty_state_improved_empty_state = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'tripboards.invite.login': 'loginButtonLabel',
    'tripboards.invite.signup': 'signupButtonLabel',
    'sort.legal.linkText': 'learnMoreLabel'
}), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(improved_empty_state_mapStateToProps, improved_empty_state_mapDispatchToProps))(improved_empty_state_ImprovedEmptyStateWrapper));
// EXTERNAL MODULE: ./src/universal/components/onboarding/content/static/slide-1/slide-1.less
var slide_1 = __webpack_require__("avdD");
var slide_1_default = /*#__PURE__*/__webpack_require__.n(slide_1);

// CONCATENATED MODULE: ./src/universal/components/onboarding/content/static/slide-1/slide-1.js
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }






var slide_1_Slide1 = function Slide1(_ref) {
    _objectDestructuringEmpty(_ref);

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-onboarding-slide1' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide1__gray-circle' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide1__listings-circle' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide1__check-circle' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-info', markup: esm["CHECK__24"] })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide1__person1' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide1__person2' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide1__person3' })
    );
};

/* harmony default export */ var slide_1_slide_1 = (slide_1_Slide1);
// EXTERNAL MODULE: ./src/universal/components/onboarding/content/static/slide-2/slide-2.less
var slide_2 = __webpack_require__("8Wdq");
var slide_2_default = /*#__PURE__*/__webpack_require__.n(slide_2);

// CONCATENATED MODULE: ./src/universal/components/onboarding/content/static/slide-2/slide-2.js
function slide_2__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }







var slide_2_Slide2 = function Slide2(_ref) {
    slide_2__objectDestructuringEmpty(_ref);

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-onboarding-slide2' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide2__gray-circle' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide2__house1' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'trip-board-onboarding-slide2__white-circle' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-danger', markup: esm["HEART_SELECTED__24"] })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide2__house2' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'trip-board-onboarding-slide2__white-circle' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-danger', markup: esm["HEART_SELECTED__24"] })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide2__house3' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'trip-board-onboarding-slide2__white-circle' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-danger', markup: esm["HEART_SELECTED__24"] })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide2__family-getaway' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'header text-emphasis' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.board1', defaultMessage: '', description: 'Trip Board title' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'left-content' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'right-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__top' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__bottom' })
            )
        )
    );
};

/* harmony default export */ var slide_2_slide_2 = (slide_2_Slide2);
// EXTERNAL MODULE: ./src/universal/components/onboarding/content/static/slide-3/slide-3.less
var slide_3 = __webpack_require__("mc59");
var slide_3_default = /*#__PURE__*/__webpack_require__.n(slide_3);

// CONCATENATED MODULE: ./src/universal/components/onboarding/content/static/slide-3/slide-3.js
function slide_3__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }







var slide_3_Slide3 = function Slide3(_ref) {
    slide_3__objectDestructuringEmpty(_ref);

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-onboarding-slide3' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide3__gray-circle' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide3__family-getaway' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'header text-emphasis' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.board1', defaultMessage: '', description: 'Trip Board title' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'left-content' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'right-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__top' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__bottom' })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide3__invite-circle' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'text-info', markup: COLLABORATE__24 })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide3__person1' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide3__person2' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide3__person3' })
    );
};

/* harmony default export */ var slide_3_slide_3 = (slide_3_Slide3);
// EXTERNAL MODULE: ./src/universal/components/onboarding/content/static/slide-4/slide-4.less
var slide_4 = __webpack_require__("IVYJ");
var slide_4_default = /*#__PURE__*/__webpack_require__.n(slide_4);

// CONCATENATED MODULE: ./src/universal/components/onboarding/content/static/slide-4/slide-4.js
function slide_4__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }





var slide_4_Slide4 = function Slide4(_ref) {
    slide_4__objectDestructuringEmpty(_ref);

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-onboarding-slide4' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide4__gray-circle' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide4__house1' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide4__white-pill1' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide4__person1' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'trip-board-onboarding-slide4__commnent1' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.comment1', defaultMessage: '', description: 'Trip Board comment 1' }),
                ' 😃'
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide4__white-pill2' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide4__person2' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'trip-board-onboarding-slide4__commnent2' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.comment2', defaultMessage: '', description: 'Trip Board comment 2' })
            )
        )
    );
};

/* harmony default export */ var slide_4_slide_4 = (slide_4_Slide4);
// EXTERNAL MODULE: ./src/universal/components/onboarding/content/static/slide-5/slide-5.less
var slide_5 = __webpack_require__("6nsg");
var slide_5_default = /*#__PURE__*/__webpack_require__.n(slide_5);

// CONCATENATED MODULE: ./src/universal/components/onboarding/content/static/slide-5/slide-5.js
function slide_5__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }





var slide_5_Slide5 = function Slide5(_ref) {
    slide_5__objectDestructuringEmpty(_ref);

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-onboarding-slide5' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'trip-board-onboarding-slide5__gray-circle' }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide5__property-card-1 trip-board-onboarding-slide5__board' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'header text-emphasis' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.board4', defaultMessage: '', description: 'Trip Board title 1' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'left-content' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'right-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__top' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__bottom' })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-onboarding-slide5__property-card-2 trip-board-onboarding-slide5__board' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'header text-emphasis' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: 'tripboards.main.empty.board3', defaultMessage: '', description: 'Trip Board title 2' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'left-content' }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'right-content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__top' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'right-content__bottom' })
            )
        )
    );
};

/* harmony default export */ var slide_5_slide_5 = (slide_5_Slide5);
// CONCATENATED MODULE: ./src/universal/components/onboarding/content/index.js







var carouselSlides = [{
    slide: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(slide_1_slide_1, null),
    title: 'tripboards.main.empty.startplan'
}, {
    slide: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(slide_2_slide_2, null),
    mobileTitle: 'tripboards.main.empty.heart',
    title: 'tripboards.main.empty.heart.desktop'
}, {
    slide: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(slide_3_slide_3, null),
    title: 'tripboards.main.empty.invite'
}, {
    slide: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(slide_4_slide_4, null),
    title: 'tripboards.main.empty.comment'
}, {
    slide: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(slide_5_slide_5, null),
    title: 'tripboards.main.empty.planning'
}];

/* harmony default export */ var onboarding_content = (carouselSlides);
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/edit-name.js
function edit_name__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function edit_name__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function edit_name__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var edit_name_EditName = function (_Component) {
    edit_name__inherits(EditName, _Component);

    function EditName(props) {
        edit_name__classCallCheck(this, EditName);

        var _this = edit_name__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleInputKeyPress = function (e) {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                onDone = _this$props.onDone;
            var name = _this.state.name;

            if (e.charCode === ENTER_CHAR_CODE) {
                onDone(boardId, name);
            }
        };

        _this.handleNameChange = function (e) {
            var name = e.target.value;
            var isChanged = _this.isNamedChanged(name);
            var isValid = _this.isValidName(name);
            var onNameChange = _this.props.onNameChange;

            _this.setState({ name: name });
            onNameChange({
                isNameChanged: isValid && isChanged,
                name: name.trim()
            });
        };

        _this.isValidName = function (name) {
            name = name || _this.state.name;
            var trimmed = name.trim();
            return trimmed.length > 0 && trimmed.length <= MAX_TRIPBOARD_NAME_LENGTH;
        };

        _this.isNamedChanged = function (name) {
            return name.trim() !== _this.props.name;
        };

        _this.moveCursorToEnd = function (e) {
            var value = e.target.value;
            e.target.value = '';
            e.target.value = value;
        };

        _this.state = {
            name: props.name
        };
        return _this;
    }

    EditName.prototype.render = function render() {
        var _props = this.props,
            altLabel = _props.altLabel,
            isMobile = _props.isMobile,
            label = _props.label;
        var name = this.state.name;

        return (
            /* eslint-disable jsx-a11y/no-autofocus */
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_form_components_lib_transpiled["FormInput"], {
                autoFocus: !isMobile,
                id: 'edit-name__id',
                onFocus: this.moveCursorToEnd,
                onKeyPress: this.handleInputKeyPress,
                className: 'trip-board-details__header-form-input',
                name: 'title',
                label: altLabel ? altLabel : label,
                value: name,
                maxLength: MAX_TRIPBOARD_NAME_LENGTH,
                onChange: this.handleNameChange,
                'data-wdio': 'tripboard-details__edit-input'
            })
        );
    };

    return EditName;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

edit_name_EditName.defaultProps = {
    boardId: null,
    altLabel: null,
    isMobile: false,
    label: '',
    name: '',
    onDone: function onDone() {},
    onNameChange: function onNameChange() {}
};
/* harmony default export */ var edit_name = (withTranslationsAsProps({
    'tripboards.modal.create.name': 'label'
})(edit_name_EditName));
// EXTERNAL MODULE: ./src/universal/components/onboarding/landing-page/landing-page.less
var landing_page = __webpack_require__("wVAM");
var landing_page_default = /*#__PURE__*/__webpack_require__.n(landing_page);

// CONCATENATED MODULE: ./src/universal/components/onboarding/landing-page/landing-page.js
var landing_page__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var landing_page__templateObject = landing_page__taggedTemplateLiteralLoose(['\n    mutation createTripBoard($tripBoard: TripBoardInput!, $hav: String!) {\n        createTripBoard(tripBoard: $tripBoard, hav: $hav) {\n            uuid\n            name\n            createTime\n            updateTime\n            stay {\n                dateRange {\n                  arrival\n                  departure\n                }\n            }\n            user  {\n                role {\n                    type\n                }\n            }\n            users {\n                isMe\n                role {\n                    type\n                }\n                profile {\n                    firstName\n                    lastName\n                    publicImageUrl\n                }\n            }\n        }\n    }\n'], ['\n    mutation createTripBoard($tripBoard: TripBoardInput!, $hav: String!) {\n        createTripBoard(tripBoard: $tripBoard, hav: $hav) {\n            uuid\n            name\n            createTime\n            updateTime\n            stay {\n                dateRange {\n                  arrival\n                  departure\n                }\n            }\n            user  {\n                role {\n                    type\n                }\n            }\n            users {\n                isMe\n                role {\n                    type\n                }\n                profile {\n                    firstName\n                    lastName\n                    publicImageUrl\n                }\n            }\n        }\n    }\n']);

function landing_page__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function landing_page__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function landing_page__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function landing_page__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }














var CREATE_TRIPBOARD = src_default()(landing_page__templateObject);

var landing_page_updateTripBoards = function updateTripBoards(hav) {
    var onDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return function (proxy, _ref) {
        var data = _ref.data;

        var variables = tripboards_queryParams(hav);
        var cache = proxy.readQuery({ query: PAGINATED_TRIPBOARDS_QUERY, variables: variables }) || {};
        if (data && data.createTripBoard && cache.paginatedTripBoards) {
            var uuid = data.createTripBoard.uuid;

            tripboard_edap.tripboardCreate(uuid, 'empty');
            tripboard_edap.boardSaved(uuid, 'empty');
            cache.paginatedTripBoards.tripBoards = [landing_page__extends({}, data.createTripBoard, { listings: [], listingRefs: [] })].concat(cache.paginatedTripBoards.tripBoards);
        } else {
            tripboard_edap.boardCreateError('empty');
        }

        proxy.writeQuery({ query: PAGINATED_TRIPBOARDS_QUERY, variables: variables, data: cache });
        onDone();
    };
};

var landing_page_LandingPage = function (_Component) {
    landing_page__inherits(LandingPage, _Component);

    function LandingPage(props) {
        landing_page__classCallCheck(this, LandingPage);

        var _this = landing_page__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleDone = function () {
            var _this$props = _this.props,
                createTripBoard = _this$props.createTripBoard,
                hav = _this$props.hav;
            var name = _this.state.name;

            var tripBoard = { name: name };
            tripboard_edap.boardCreate(name, 'empty');
            createTripBoard({ variables: { tripBoard: tripBoard, hav: hav } });
        };

        _this.handleNameChange = function (_ref2) {
            var isNameChanged = _ref2.isNameChanged,
                name = _ref2.name;

            _this.setState({ name: name, isNameChanged: isNameChanged });
        };

        _this.state = { name: '', isNameChanged: false };
        return _this;
    }

    LandingPage.prototype.componentDidMount = function componentDidMount() {
        var startTripboardCreation = this.props.startTripboardCreation;

        startTripboardCreation(); // callback; example usage: sets the redux flag to handle the routing to the newly created tripboard in onboarding
    };

    LandingPage.prototype.render = function render() {
        var _state = this.state,
            isNameChanged = _state.isNameChanged,
            name = _state.name;
        var _props = this.props,
            _props$loading = _props.loading,
            loading = _props$loading === undefined ? false : _props$loading,
            modalLayout = _props.modalLayout,
            _props$onCancel = _props.onCancel,
            onCancel = _props$onCancel === undefined ? function () {} : _props$onCancel,
            formLabel = _props.formLabel,
            cancelLabel = _props.cancelLabel,
            createLabel = _props.createLabel,
            isMobile = _props.isMobile;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'span',
                { className: 'landing-page__input' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(edit_name, {
                    onDone: this.handleDone,
                    altLabel: formLabel,
                    onNameChange: this.handleNameChange,
                    isMobile: isMobile
                })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('landing-page__button-container', { 'button-container--modal': modalLayout }) },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loading }),
                modalLayout && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
                    label: cancelLabel,
                    className: 'landing-page__cancelbutton',
                    onClick: onCancel,
                    size: 'sm'
                }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], {
                    label: createLabel,
                    className: 'landing-page__button',
                    onClick: this.handleDone,
                    disabled: !isNameChanged || name === '',
                    size: 'sm'
                })
            )
        );
    };

    return LandingPage;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

var landing_page_handleMutationError = function handleMutationError() {
    var onError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    return function () {
        tripboard_edap.boardCreateError('empty');
        onError();
    };
};

var landing_page_LandingPageProvider = function LandingPageProvider(_ref3) {
    var hav = _ref3.hav,
        _ref3$startTripboardC = _ref3.startTripboardCreation,
        startTripboardCreation = _ref3$startTripboardC === undefined ? function () {} : _ref3$startTripboardC,
        onDone = _ref3.onDone,
        onError = _ref3.onError,
        formLabel = _ref3.formLabel,
        cancelLabel = _ref3.cancelLabel,
        createLabel = _ref3.createLabel,
        modalLayout = _ref3.modalLayout;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        react_apollo_browser_umd["Mutation"],
        { mutation: CREATE_TRIPBOARD, update: landing_page_updateTripBoards(hav, onDone), onError: landing_page_handleMutationError(onError) },
        function (createTripBoard, _ref4) {
            var loading = _ref4.loading;

            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(landing_page_LandingPage, { formLabel: formLabel, cancelLabel: cancelLabel, createLabel: createLabel, createTripBoard: createTripBoard, hav: hav, startTripboardCreation: startTripboardCreation, loading: loading, onCancel: onDone, modalLayout: modalLayout });
        }
    );
};

/* harmony default export */ var landing_page_landing_page = (withTranslationsAsProps({ 'tripboards.main.empty.board.prefill': 'formLabel', 'tripboards.cancel': 'cancelLabel', 'tripboards.main.empty.create': 'createLabel' })(landing_page_LandingPageProvider));
// EXTERNAL MODULE: ./src/universal/components/onboarding/onboarding-carousel/onboarding-carousel.less
var onboarding_carousel = __webpack_require__("LtA8");
var onboarding_carousel_default = /*#__PURE__*/__webpack_require__.n(onboarding_carousel);

// CONCATENATED MODULE: ./src/universal/components/onboarding/onboarding-carousel/onboarding-carousel.js
function onboarding_carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function onboarding_carousel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function onboarding_carousel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var onboarding_carousel_SlideBars = function SlideBars(_ref) {
    var slides = _ref.slides,
        imageIndex = _ref.imageIndex;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'slide-nav__bars' },
        slides.map(function (_, index) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { key: 'slide_nav_bar_' + index, className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('slide-nav__bar', { 'bar--current': index === imageIndex }) });
        })
    );
};

var onboarding_carousel_CTAButton = function CTAButton(_ref2) {
    var clickHandler = _ref2.clickHandler,
        icon = _ref2.icon,
        label = _ref2.label;

    var buttonlabel = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            null,
            label
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inline: true, markup: icon })
    );
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'slide-nav__button' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], { onClick: clickHandler, label: buttonlabel, className: 'btn-primary', size: 'sm' })
    );
};

var onboarding_carousel_SlideNavButton = function SlideNavButton(_ref3) {
    var disabled = _ref3.disabled,
        clickHandler = _ref3.clickHandler,
        pressHandler = _ref3.pressHandler,
        icon = _ref3.icon,
        type = _ref3.type;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'slide-nav__button' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIcon"], { label: '', circle: true, svgMarkup: icon, size: 'sm', className: type === 'next' ? 'btn-primary' : '', onMouseDown: pressHandler, onClick: clickHandler, disabled: disabled })
    );
};

var onboarding_carousel_OnboardingCarousel = function (_PureComponent) {
    onboarding_carousel__inherits(OnboardingCarousel, _PureComponent);

    function OnboardingCarousel(props) {
        onboarding_carousel__classCallCheck(this, OnboardingCarousel);

        var _this = onboarding_carousel__possibleConstructorReturn(this, _PureComponent.call(this, props));

        _this.handleNext = function () {
            _this.setState({ imageIndex: _this.state.imageIndex + 1, animation: true });
        };

        _this.cancelAnimation = function () {
            _this.setState({ animation: false });
        };

        _this.handlePrev = function () {
            _this.setState({ imageIndex: _this.state.imageIndex - 1, animation: true });
        };

        _this.handleSkip = function () {
            tripboard_edap.boardCreateSkip();
            _this.props.completeOnboarding();
        };

        _this.handleCreate = function () {
            tripboard_edap.boardCreateClick('empty');
            _this.handleComplete();
        };

        _this.handleComplete = function () {
            _this.setState({ imageIndex: _this.state.imageIndex + 1, animation: true });
        };

        _this.state = {
            imageIndex: 0,
            animation: true
        };
        return _this;
    }

    OnboardingCarousel.prototype.render = function render() {
        var _props = this.props,
            skipLabel = _props.skipLabel,
            ctaLabel = _props.ctaLabel,
            startTripboardCreation = _props.startTripboardCreation,
            hav = _props.hav,
            isMobile = _props.isMobile;
        var _state = this.state,
            imageIndex = _state.imageIndex,
            animation = _state.animation;

        var showPrevButton = imageIndex > 0;
        var showNextButton = imageIndex + 1 < onboarding_content.length;
        var showLandingPage = imageIndex >= onboarding_content.length;
        var carouselIndex = Math.min(imageIndex, onboarding_content.length - 1);
        var carouselTitle = carouselIndex === 1 && isMobile ? onboarding_content[carouselIndex].mobileTitle : onboarding_content[carouselIndex].title;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'onboarding-carousel__wrapper' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'onboarding-carousel__row' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'onboarding-carousel__nav' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('slide-title', { 'title-animation': animation }) },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: carouselTitle, defaultMessage: '', description: 'Trip Board slide title' })
                    ),
                    !showLandingPage && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'slide-nav' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_SlideNavButton, { disabled: !showPrevButton, clickHandler: this.handlePrev, pressHandler: this.cancelAnimation, type: 'back', icon: esm["CHEVRON_LEFT__16"] }),
                        showNextButton && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_SlideBars, { imageIndex: carouselIndex, slides: onboarding_content }),
                        !showNextButton && isMobile && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_SlideBars, { imageIndex: carouselIndex, slides: onboarding_content }),
                        showNextButton && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_SlideNavButton, { clickHandler: this.handleNext, pressHandler: this.cancelAnimation, type: 'next', icon: esm["CHEVRON_RIGHT__16"] }),
                        !showNextButton && !isMobile && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_CTAButton, { label: ctaLabel, clickHandler: this.handleCreate, icon: esm["CHEVRON_RIGHT__16"] }),
                        !showNextButton && isMobile && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_SlideNavButton, { clickHandler: this.handleCreate, type: 'next', icon: esm["CHEVRON_RIGHT__16"] })
                    ),
                    showLandingPage && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'slide-create' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(landing_page_landing_page, { startTripboardCreation: startTripboardCreation, hav: hav, isMobile: isMobile })
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'onboarding-carousel__slides' },
                    onboarding_content[carouselIndex].slide
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'onboarding-carousel__row' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'onboarding-carousel__skip' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonLink"], { label: skipLabel, onClick: this.handleSkip })
                )
            )
        );
    };

    return OnboardingCarousel;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["PureComponent"]);

var onboarding_carousel_mapDispatchToProps = {
    completeOnboarding: onboarding_actions.completeOnboarding,
    startTripboardCreation: onboarding_actions.startTripboardCreation
};

var onboarding_carousel_mapStateToProps = function mapStateToProps(state) {
    return {
        onboardingCompleted: state && state.onboarding && state.onboarding.onboardingCompleted
    };
};

/* harmony default export */ var onboarding_carousel_onboarding_carousel = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'tripboards.skip': 'skipLabel',
    'tripboards.main.empty.action': 'ctaLabel'
}), with_auth, react_determine_if_mobile_lib_transpiled_default.a, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(onboarding_carousel_mapStateToProps, onboarding_carousel_mapDispatchToProps))(onboarding_carousel_OnboardingCarousel));
// CONCATENATED MODULE: ./src/universal/components/onboarding/onboarding-carousel/onboarding-carousel-router.js






var onboarding_carousel_router_OnboardingCarouselRouter = function OnboardingCarouselRouter(props) {
    var tripboardCreationStarted = props.tripboardCreationStarted,
        tripboards = props.tripboards;

    var uuid = tripboards && tripboards[0] && tripboards[0].uuid;
    if (uuid && tripboardCreationStarted) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_router_es["Redirect"], { to: universal_routes.TRIPBOARD + '/' + uuid, push: true });
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_carousel_onboarding_carousel, props);
};

var onboarding_carousel_router_mapStateToProps = function mapStateToProps(state) {
    return {
        tripboardCreationStarted: state && state.onboarding && state.onboarding.tripboardCreationStarted
    };
};

/* harmony default export */ var onboarding_carousel_router = (Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(onboarding_carousel_router_mapStateToProps)(onboarding_carousel_router_OnboardingCarouselRouter));
// CONCATENATED MODULE: ./src/universal/components/onboarding/onboarding-carousel/index.js

/* harmony default export */ var onboarding_onboarding_carousel = (onboarding_carousel_router);
// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/edap.js



var edap_clickedControl = function clickedControl(label) {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_CONTROL_CLICK,
        eventcategory: CATEGORY,
        eventlabel: label
    });
};

var edap_modalSeen = function modalSeen() {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_MODAL_SEEN,
        eventcategory: CATEGORY
    });
};

var edap_modalClosed = function modalClosed() {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_MODAL_CLOSED,
        eventcategory: CATEGORY
    });
};

var edap_modalError = function modalError() {
    edap_trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_MODAL_ERRORED,
        eventcategory: CATEGORY
    });
};

/* harmony default export */ var create_tripboard_controls_edap = ({
    clickedControl: edap_clickedControl,
    modalClosed: edap_modalClosed,
    modalSeen: edap_modalSeen,
    modalError: edap_modalError
});
// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-button.js










var EDAP_LABEL = 'tripboard.create.control.button';

var create_tripboard_button_handleClick = function handleClick(callback) {
    return function () {
        /* dispatch edap */
        edap_clickedControl(EDAP_LABEL);
        callback();
    };
};

var create_tripboard_button_CreateTripboardButton = function CreateTripboardButton(_ref) {
    var title = _ref.title,
        openModal = _ref.openModal,
        _ref$isMobile = _ref.isMobile,
        isMobile = _ref$isMobile === undefined ? false : _ref$isMobile;

    var onClick = create_tripboard_button_handleClick(openModal);
    var buttonLabel = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inline: true, markup: esm["PLUS__16"] }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            null,
            title
        )
    );
    if (isMobile) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonIconPrimary"], { label: buttonLabel, onClick: onClick, svgMarkup: esm["PLUS__16"], circle: true, size: 'xs' });
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], { onClick: onClick, label: buttonLabel });
};

var create_tripboard_button_mapDispatchToProps = {
    openModal: create_tripboard_controls_actions.openModal
};

/* harmony default export */ var create_tripboard_button = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({ 'tripboards.main.empty.create': 'title' }), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(null, create_tripboard_button_mapDispatchToProps))(create_tripboard_button_CreateTripboardButton));
// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-modal.js
function create_tripboard_modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function create_tripboard_modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function create_tripboard_modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var create_tripboard_modal_CreateTripboardModal = function (_Component) {
    create_tripboard_modal__inherits(CreateTripboardModal, _Component);

    function CreateTripboardModal(props) {
        create_tripboard_modal__classCallCheck(this, CreateTripboardModal);

        var _this = create_tripboard_modal__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }

    CreateTripboardModal.prototype.componentDidMount = function componentDidMount() {
        if (this.props.isOpen) {
            edap_modalSeen();
        }
    };

    CreateTripboardModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var isOpen = this.props.isOpen;
        var wasOpen = prevProps.isOpen;

        if (isOpen && !wasOpen) {
            edap_modalSeen();
        }
    };

    CreateTripboardModal.prototype.handleClose = function handleClose() {
        edap_modalClosed();
        var handleModalClose = this.props.handleModalClose;

        handleModalClose();
    };

    CreateTripboardModal.prototype.handleError = function handleError() {
        edap_modalError();
        var handleModalClose = this.props.handleModalClose;

        handleModalClose();
    };

    CreateTripboardModal.prototype.render = function render() {
        var _props = this.props,
            hav = _props.hav,
            isOpen = _props.isOpen,
            title = _props.title;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            lib_esm["default"],
            { id: 'create-tripboard__modal', onClose: this.handleClose, isOpen: isOpen, isWorkflow: true, title: title },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(landing_page_landing_page, { hav: hav, onError: this.handleError, onDone: this.handleClose, modalLayout: true })
        );
    };

    return CreateTripboardModal;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var create_tripboard_modal = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, withTranslationsAsProps({ 'tripboards.modal.create.new.list.copy': 'title' }))(create_tripboard_modal_CreateTripboardModal));
// EXTERNAL MODULE: ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-card.less
var create_tripboard_card = __webpack_require__("pJz2");
var create_tripboard_card_default = /*#__PURE__*/__webpack_require__.n(create_tripboard_card);

// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-card.js











var create_tripboard_card_EDAP_LABEL = 'tripboard.create.control.card';

var create_tripboard_card_handleClick = function handleClick(callback) {
    return function () {
        /* dispatch edap */
        edap_clickedControl(create_tripboard_card_EDAP_LABEL);
        callback();
    };
};

var create_tripboard_card_CreateTripboardCard = function CreateTripboardCard(_ref) {
    var title = _ref.title,
        openModal = _ref.openModal;

    var onClick = create_tripboard_card_handleClick(openModal);
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'tripboard-summary-container__hit-wrapper', role: 'button', 'aria-label': title, onKeyDown: onClick, tabIndex: 0, onClick: onClick },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'create-tripboard-card card' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'create-tripboard-card__title' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'h3',
                    null,
                    title
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'create-tripboard-card__content' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'create-tripboard-card__cta' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'create-tripboard-card__icon' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { strokeWidth: 1, markup: esm["ADD_CIRCLE__24"] })
                    )
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'create-tripboard-card__bottom' })
        )
    );
};

var create_tripboard_card_mapDispatchToProps = {
    openModal: create_tripboard_controls_actions.openModal
};

/* harmony default export */ var components_create_tripboard_card = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({ 'tripboards.modal.create.new.list.copy': 'title' }), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(null, create_tripboard_card_mapDispatchToProps))(create_tripboard_card_CreateTripboardCard));
// CONCATENATED MODULE: ./src/universal/tripboard/create-tripboard-controls/index.js





// EXTERNAL MODULE: ./src/universal/tripboard/components/tripboards.less
var components_tripboards = __webpack_require__("WB1p");
var tripboards_default = /*#__PURE__*/__webpack_require__.n(components_tripboards);

// CONCATENATED MODULE: ./src/universal/tripboard/components/tripboards.js
var tripboards__withAbacusTestValues;

var tripboards__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var tripboards__templateObject = tripboards__taggedTemplateLiteralLoose(['\n    query paginatedTripBoards($hav: String!, $pageSize: Int!, $listingPageSize: Int) {\n        paginatedTripBoards(hav: $hav, pageSize: $pageSize) {\n            tripBoards {\n                uuid\n                name\n                listingRefs\n                listings(pageSize: $listingPageSize) {\n                    images {\n                        c6_uri\n                        height\n                        width\n                    }\n                }\n                user {\n                    role {\n                        type\n                    }\n                }\n            }\n        }\n    }\n'], ['\n    query paginatedTripBoards($hav: String!, $pageSize: Int!, $listingPageSize: Int) {\n        paginatedTripBoards(hav: $hav, pageSize: $pageSize) {\n            tripBoards {\n                uuid\n                name\n                listingRefs\n                listings(pageSize: $listingPageSize) {\n                    images {\n                        c6_uri\n                        height\n                        width\n                    }\n                }\n                user {\n                    role {\n                        type\n                    }\n                }\n            }\n        }\n    }\n']),
    tripboards__templateObject2 = tripboards__taggedTemplateLiteralLoose(['\n    mutation deleteTripBoard($hav: String!, $tripBoardUuid: String!) {\n        deleteTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid)\n    }\n'], ['\n    mutation deleteTripBoard($hav: String!, $tripBoardUuid: String!) {\n        deleteTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid)\n    }\n']);

function tripboards__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tripboards__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tripboards__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function tripboards__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }






















// Abacus: HA_PULSE_SKELETON_ABC

var testExposureCreateTripboard = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_CREATE_BOARD"]);
var fireImprovedEmptyStateExposure = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_IMPROVED_EMPTY_STATE"]);

var tripboards_getImageUrl = function getImageUrl(image) {
    if (!image || !image.c6_uri) {
        return '';
    }
    return image.c6_uri;
};

var PAGE_SIZE = 200;
var LISTING_PAGE_SIZE = 3;

var PAGINATED_TRIPBOARDS_QUERY = src_default()(tripboards__templateObject);

var TRIPBOARDS_DELETE = src_default()(tripboards__templateObject2);
var tripboards_queryParams = function queryParams(hav) {
    return {
        hav: hav,
        pageSize: PAGE_SIZE,
        listingPageSize: LISTING_PAGE_SIZE
    };
};

var tripboards_Tripboards = function (_Component) {
    tripboards__inherits(Tripboards, _Component);

    function Tripboards() {
        var _temp, _this, _ret;

        tripboards__classCallCheck(this, Tripboards);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = tripboards__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidMount = function () {
            var loading = _this.props.loading;

            if (!loading) {
                _this.loadEvents();
            }
        }, _this.cardProps = function (board, index, boards) {
            var _this$props = _this.props,
                onDelete = _this$props.onDelete,
                translations = _this$props.translations,
                waterfallTestValue = _this$props.waterfallTestValue;

            var thumbnails = board.listings.map(function (listing) {
                return listing.images && listing.images[0];
            });
            var name = board.name,
                boardId = board.uuid,
                listingRefs = board.listingRefs;

            var isWaterFallTestOn = waterfallTestValue > 0;
            return {
                count: listingRefs ? listingRefs.length : 0,
                boardId: boardId,
                image1: tripboards_getImageUrl(thumbnails[0]),
                image2: tripboards_getImageUrl(thumbnails[1]),
                image3: tripboards_getImageUrl(thumbnails[2]),
                name: name,
                onDelete: onDelete,
                role: board.role,
                translations: translations,
                index: index,
                total: boards.length,
                isWaterFallTestOn: isWaterFallTestOn, // Abacus: waterfall
                isLazyLoad: isWaterFallTestOn && index > 2 // Abacus: waterfall
            };
        }, _this.isEmpty = function () {
            var _this$props2 = _this.props,
                loading = _this$props2.loading,
                previews = _this$props2.previews;
            /** @todo error handling: failing silently in the UI */

            return !loading && !previews.length;
        }, _this.showImprovedEmptyState = function (isLoggedIn, improvedEmptyStateTestValue) {
            return improvedEmptyStateTestValue > 0 && !isLoggedIn;
        }, _this.showOnboarding = function () {
            /* we want to show carousel when:
               1. no tripboards AND user has NOT seen landing page
               2. tripboard BUT they have not seen the details page for the tripboard
               3. User completed onboarding but have not completed new tripboard creation */
            var _this$props3 = _this.props,
                tripboardCreationNotComplete = _this$props3.tripboardCreationNotComplete,
                tripboardCreationStarted = _this$props3.tripboardCreationStarted,
                onboardingCompleted = _this$props3.onboardingCompleted;


            return !onboardingCompleted && (_this.isEmpty() || tripboardCreationNotComplete && tripboardCreationStarted);
        }, _this.par = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var loading = props.loading;
            // PAR definition: When tripboards are fully loaded (clickable).

            if (!loading) {
                _this.props.markPAR();
            }
        }, _this.handleBoardDelete = function (mutation, hav) {
            return function (boardId) {
                mutation({
                    variables: {
                        hav: hav,
                        tripBoardUuid: boardId
                    }
                });
            };
        }, _this.updateCache = function (boardId, hav) {
            return function (cache) {
                var data = cache.readQuery({
                    query: PAGINATED_TRIPBOARDS_QUERY,
                    variables: tripboards_queryParams(hav, PAGE_SIZE, LISTING_PAGE_SIZE)
                }) || {};

                var _ref = data.paginatedTripBoards || {},
                    _ref$tripBoards = _ref.tripBoards,
                    tripBoards = _ref$tripBoards === undefined ? [] : _ref$tripBoards;

                tripBoards.splice(tripBoards.findIndex(function (tripboard) {
                    return tripboard.uuid === boardId;
                }), 1);
                data.paginatedTripBoards.tripBoards = tripBoards;
                cache.writeQuery({
                    query: PAGINATED_TRIPBOARDS_QUERY,
                    variables: tripboards_queryParams(hav, PAGE_SIZE, LISTING_PAGE_SIZE),
                    data: data
                });
            };
        }, _temp), tripboards__possibleConstructorReturn(_this, _ret);
    }

    Tripboards.prototype.componentDidUpdate = function componentDidUpdate() {
        if (!this.props.loading) {
            this.loadEvents();
        }
    };

    Tripboards.prototype.loadEvents = function loadEvents() {
        this.par(this.props);
        var _props = this.props,
            showCreateTripboardButton = _props.showCreateTripboardButton,
            previews = _props.previews,
            createTripboardTestValue = _props.createTripboardTestValue,
            improvedEmptyStateTestValue = _props.improvedEmptyStateTestValue,
            isLoggedIn = _props.isLoggedIn,
            isMobile = _props.isMobile;

        tripboard_edap.summariesLoad(previews.length);
        var hasTripboards = !!previews.length;
        var showImprovedEmptyState = this.showImprovedEmptyState(isLoggedIn, improvedEmptyStateTestValue);
        var showCreateButton = hasTripboards && (createTripboardTestValue === 1 || createTripboardTestValue === 2 && isMobile);

        if (!hasTripboards && !this.showOnboarding() && !isLoggedIn) {
            showCreateButton = showImprovedEmptyState;
            fireImprovedEmptyStateExposure.trigger(experiments["HA_PULSE_IMPROVED_EMPTY_STATE"]);
        } else if (hasTripboards) {
            testExposureCreateTripboard.trigger(experiments["HA_PULSE_CREATE_BOARD"]);
        }

        showCreateTripboardButton(showCreateButton);
    };

    Tripboards.prototype.render = function render() {
        var _this2 = this;

        var _props2 = this.props,
            loading = _props2.loading,
            previews = _props2.previews,
            hav = _props2.hav,
            createTripboardModalOpen = _props2.createTripboardModalOpen,
            handleCreateModalClose = _props2.handleCreateModalClose,
            createTripboardTestValue = _props2.createTripboardTestValue,
            isMobile = _props2.isMobile,
            improvedEmptyStateTestValue = _props2.improvedEmptyStateTestValue,
            isLoggedIn = _props2.isLoggedIn;

        var isEmpty = this.isEmpty();
        var showOnboarding = this.showOnboarding();
        var showTripboadCard = !isMobile && !isEmpty && createTripboardTestValue === 2;
        var showImprovedEmptyState = this.showImprovedEmptyState(isLoggedIn, improvedEmptyStateTestValue);
        var containerClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()({
            'tripboard-summary-container': true,
            'tripboard-summary-empty': isEmpty,
            'is-empty': isEmpty
        });

        if (loading) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: containerClass + ' is-skeleton', 'data-wdio': 'tripboard-summary__container' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_tripboard_card, {
                    onDelete: function onDelete() {} // eslint-disable-line
                    , translations: this.props.translations,
                    isLoading: true
                })
            );
        }

        if (showOnboarding) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(onboarding_onboarding_carousel, { tripboards: previews });
        }

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: containerClass },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loading }),
            isEmpty && !showOnboarding && !showImprovedEmptyState && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_empty_tripboard_label, { translations: this.props.translations, large: true }),
            isEmpty && !showOnboarding && showImprovedEmptyState && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(improved_empty_state_improved_empty_state, null),
            showTripboadCard && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_create_tripboard_card, null),
            !isEmpty && previews.map(this.cardProps).map(function (props) {
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    react_apollo_browser_umd["Mutation"],
                    {
                        key: props.boardId,
                        mutation: TRIPBOARDS_DELETE,
                        update: _this2.updateCache(props.boardId, hav)
                    },
                    function (deleteTripBoard) {
                        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_tripboard_card, tripboards__extends({}, props, { onDelete: _this2.handleBoardDelete(deleteTripBoard, hav) }));
                    }
                );
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(create_tripboard_modal, { handleModalClose: handleCreateModalClose, isOpen: createTripboardModalOpen })
        );
    };

    return Tripboards;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

tripboards_Tripboards.propTypes = {
    listings: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape),
    translations: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.objectOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string).isRequired
};
tripboards_Tripboards.defaultProps = {
    listings: [],
    markPAR: function markPAR() {},
    waterfallTestValue: 0,
    smallerImageTestValue: 0
};
var tripboards_TripboardsProvider = function TripboardsProvider(ownProps) {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        react_apollo_browser_umd["Query"],
        {
            query: PAGINATED_TRIPBOARDS_QUERY,
            errorPolicy: 'all',
            skip: !ownProps.hav,
            ssr: false,
            variables: tripboards_queryParams(ownProps.hav, PAGE_SIZE, LISTING_PAGE_SIZE)
        },
        function (_ref2) {
            var data = _ref2.data,
                loading = _ref2.loading;

            var previews = data && data.paginatedTripBoards && data.paginatedTripBoards.tripBoards || [];

            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tripboards_Tripboards, tripboards__extends({}, ownProps, { previews: previews, loading: loading }));
        }
    );
};

var tripboards_mapStateToProps = function mapStateToProps(state) {
    return {
        tripboardCreationNotComplete: state && state.onboarding && state.onboarding.tripboardCreationNotComplete,
        tripboardCreationStarted: state && state.onboarding && state.onboarding.tripboardCreationStarted,
        onboardingCompleted: state && state.onboarding && state.onboarding.onboardingCompleted,
        createTripboardModalOpen: state && state.tripboard && state.tripboard.createControls && state.tripboard.createControls.modalOpen,
        isMobile: getIsMobile(state)
    };
};

var tripboards_mapDispatchToProps = {
    showCreateTripboardButton: create_tripboard_controls_actions.showButton,
    handleCreateModalClose: create_tripboard_controls_actions.closeModal
};

// export wired component as default
/* harmony default export */ var tripboard_components_tripboards = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(abacus_with_abacus_test_values_as_props((tripboards__withAbacusTestValues = {}, tripboards__withAbacusTestValues[experiments["WATERFALL_AB"]] = 'waterfallTestValue', tripboards__withAbacusTestValues[experiments["HA_PULSE_CREATE_BOARD"]] = 'createTripboardTestValue', tripboards__withAbacusTestValues[experiments["HA_PULSE_IMPROVED_EMPTY_STATE"]] = 'improvedEmptyStateTestValue', tripboards__withAbacusTestValues)), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(tripboards_mapStateToProps, tripboards_mapDispatchToProps), react_determine_if_mobile_lib_transpiled_default.a, with_auth)(tripboards_TripboardsProvider));
// CONCATENATED MODULE: ./src/universal/tripboard/components/tripboards-container.js






function tripboards_container_mapStateToProps(state) {
    return {
        translations: getTranslations(state)
    };
}

var tripboards_container_mapDispatchToProps = {
    onDelete: tripboard_actions.deleteTripboard
};

var TripboardsContainer = Timing_withPAR(Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(tripboards_container_mapStateToProps, tripboards_container_mapDispatchToProps)(tripboard_components_tripboards));

/* harmony default export */ var tripboards_container = (TripboardsContainer);
// CONCATENATED MODULE: ./src/universal/tripboard/details/marketing-tripboards.js
/**
 * TEMP: This is a hard-coded list of marketing trip boards. This will be a simple,
 * static list in source control until we understand usage patterns and the
 * need for a more developed system.
 *
 * GENERATION
 * To generate pieces of this list, obtain a text file containing trip board URLs for which they want to promote
 * and run the following bash script:
 *
 * grep tripboard marketing-trip-boards.txt | awk -F/ '{print "'\''" $NF "'\'': true,"}' | sort -n | uniq
 *
 * Copy the results in to the bottom of the list and release this project into production
 *
 * @todo deprecate once graphql returns marketing flag
 */
/* harmony default export */ var marketing_tripboards = ({
    '92cfae78-5e06-11e8-9c2d-fa7ae01bbebc': true,
    '125171c8-d7e1-4f3d-89e9-42707a6751d8': true,
    '614b83f4-2647-4d48-a1c9-3e9acc8826a4': true,
    '69a364a5-d4df-46b7-a238-f6e76c26e60a': true,
    '8f4c9f58-8623-4105-b91b-16fc7007cd7c': true,
    '9804d28a-d8b9-4e95-83a0-349b93a1ad86': true,
    'e3c04f49-d508-41c7-8208-958c48fd35eb': true,
    '659755e4-52e8-4bd0-848f-b8792b03cf70': true,
    '733a42c5-8b7b-4f3c-b1ff-0482c2d754d3': true,
    '5a8cb4b9-b834-48eb-a17f-a051f1f647b7': true,
    'fcbe4db2-b7e8-45cd-ac4f-8b804d259969': true,
    '9f2e1b85-7035-4843-bd1a-b11cdd0a242b': true,
    '65d6d52d-1c7f-4972-9e02-5ae8bf175452': true,
    '56b00749-e2f0-44b8-a3e6-47f8dfbc8c94': true,
    '9fe7bef9-52ee-4b50-9a1e-8affec321698': true,
    'f4d86139-0d82-458e-b3ab-a88e0a72da82': true,
    'ab779a91-264e-4e46-af05-5b201aa3a0ac': true,
    '98198f94-dcbb-4708-9f49-9ba31514a5e0': true,
    'b7c3c3da-6e3b-422c-8773-9babe17c98fe': true,
    'fd4b2d3f-0a38-4cd0-a8ef-ae8fb6608a21': true,
    'c12ca6c7-d8bc-40fb-b9ec-5503df8dd7c5': true,
    'a59d14cc-927d-4a2a-ad44-1d248630594b': true,
    'e935153c-92a0-4b9d-b9ee-41476520cd87': true,
    '6fff96a4-c138-47c0-8e17-fafcce8d5de9': true,
    'd94958f7-7607-4b50-937b-6486c11df94b': true,
    'c2ee7802-cd38-412a-b1fc-222abc814a27': true,
    '2ff83b08-892a-40c5-8c7f-ba3c1ae80b86': true,
    'b6012ea9-85ed-41f1-a983-5d64c7e6a89a': true,
    'ee038b13-f448-41cd-b85b-7ea277ed01f2': true,
    '695edd8f-88a7-422f-ac5d-fa46bb9bf81d': true,
    'a2938dab-2055-4d82-a802-dae9f984d73b': true,
    '426d185e-8f70-4e40-988f-4ebdfbac18d8': true,
    '2321d3be-1e5d-4064-8382-fda2ba768967': true,
    'babcfb00-f5be-4d66-9749-33e39e5a42ca': true,
    '28e58165-8194-4e7c-ba0c-e13d5236e390': true,
    '0b320e01-c9e5-4933-a96e-9d262d23670d': true,
    '1b03c7d8-985d-4c1c-8739-6f479615b162': true,
    '725709fd-5404-4784-9031-13ecfebfad72': true,
    'ac740145-0be2-4a6a-9eec-fb309ba6c7b6': true,
    '1724d366-fbba-4640-a28a-ed844072732a': true,
    'ac0b4ee2-9106-4a9b-bf39-fd5d3d0956d6': true,
    'ddcfaded-ab5e-4916-a5c6-3e0628382467': true,
    '6f7a187f-5dfb-4ff7-894f-09e0e886203a': true,
    'c81f110d-6070-4f4b-8262-d068c9bb35d8': true,
    '0bf88e83-31eb-4852-b948-f54bd38c299a': true,
    '0b077483-776a-4000-a728-a14b83562cd6': true,
    '4a76e119-8186-41c1-9285-3bd8c181ae9c': true,
    '030d6dd8-4933-4e49-acb0-267dae95ea21': true,
    'c5f63525-0606-4f2c-91a4-f1aec650c3a5': true,
    '8504fb2a-935e-48c4-83e1-1a6696c49f4d': true,
    '5792cd5e-f453-439c-8d4c-aa5b33ee52de': true,
    '29362f18-ec56-4ab1-854b-51eeae313731': true,
    '76c3337d-4ddf-476f-83c5-47533c9dd05d': true,
    '3860fab1-93f9-4b34-a2f0-a2c5dbfc08dd': true,
    '7d82f525-10e3-43a9-a601-774028fe6cc5': true,
    'd93a30fc-6ab1-4329-aa6e-44351463bbc3': true,
    '382e78bc-bc28-4b66-8d8a-b787e4b32fa3': true,
    '4a7adccd-0a7a-4e40-a235-00557c5ac9ca': true,
    '22ef9560-d21d-49b0-b2da-2530f3f48feb': true,
    '665c23cf-0b9e-4581-bc34-6e8b42d782f9': true,
    '280ecb13-040d-4ac2-9d9a-be78c0acaf55': true,
    '4554c855-6eec-4c88-90c4-4b9d8b5d51df': true,
    '152ae21c-7453-449f-b6df-a812de4bed45': true,
    '6295cacb-bd39-4ad5-b0b4-5f3b4c650f04': true,
    'c9709f7a-b7c7-4e5c-a9f6-abe78e68fae3': true,
    '92d2a7f0-4c38-42c1-898e-09ab6acfbf6e': true,
    'afbe6aeb-cb86-446f-9d37-820de0bf0fc0': true,
    'ab066ca5-aed3-4fc2-88d1-40cd16bd5d0c': true,
    '1198f29d-bd39-46af-b729-88e481d4999d': true
});
// CONCATENATED MODULE: ./src/universal/tripboard/details/utils.js


/** @todo deprecate once graphql returns marketing flag */
function isMarketingBoard(boardId) {
    return marketing_tripboards[boardId] === true;
}
// CONCATENATED MODULE: ./src/universal/tripboard/activity-indicator/activity-indicator-seen.js
var activity_indicator_seen__withAbacusTestValues;

function activity_indicator_seen__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function activity_indicator_seen__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function activity_indicator_seen__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Could potentially use when we get more granular as well.
 * We could wrap this in unveil and pass down props on what
 * "seen types" to pass to the backend. Would likely be
 * wrapped in a mutation. Should also think about removing
 * the logic for the "activity seen" EDAP event, so that we
 * we do not need to execute logic or an additional API
 * call. Might make sense to remove during test clean up.
 */











var activity_indicator_seen_ActivityIndicatorSeen = function (_Component) {
    activity_indicator_seen__inherits(ActivityIndicatorSeen, _Component);

    function ActivityIndicatorSeen(props) {
        activity_indicator_seen__classCallCheck(this, ActivityIndicatorSeen);

        var _this = activity_indicator_seen__possibleConstructorReturn(this, _Component.call(this, props));

        _this.triggerActivitySeen = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                client = _this$props.client,
                indicators = _this$props.data.indicators,
                hav = _this$props.hav,
                state = _this$props.location.state,
                testValue = _this$props.testValue;


            if (testValue > 0) {
                var hasActivity = hasNewActivity(boardId, indicators);
                var hasSeenIndicator = !!(state && state.referrer && state.referrer === universal_routes.TRIPBOARD);

                /** @edap */
                if (hasActivity && hasSeenIndicator) {
                    tripboard_edap.activitySeen(boardId);
                    removeIndicator({ boardId: boardId, client: client, hav: hav });
                }
            }
        };

        return _this;
    }

    ActivityIndicatorSeen.prototype.componentDidMount = function componentDidMount() {
        this.triggerActivitySeen();
    };

    ActivityIndicatorSeen.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
        var loading = _ref.data.loading;
        var data = this.props.data;

        return loading !== data.loading;
    };

    ActivityIndicatorSeen.prototype.componentDidUpdate = function componentDidUpdate() {
        this.triggerActivitySeen();
    };

    ActivityIndicatorSeen.prototype.render = function render() {
        return null;
    };

    return ActivityIndicatorSeen;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

activity_indicator_seen_ActivityIndicatorSeen.defaultProps = {
    data: {},
    location: {},
    testValue: 0
};
/* harmony default export */ var activity_indicator_seen = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, Object(react_apollo_browser_umd["graphql"])(GET_INDICATORS, { options: activity_indicator_graphql_queryOptions }), with_abacus_test_values_as_props((activity_indicator_seen__withAbacusTestValues = {}, activity_indicator_seen__withAbacusTestValues[HA_PULSE_ACTIVITY_INDICATORS] = 'testValue', activity_indicator_seen__withAbacusTestValues)), react_apollo_browser_umd["withApollo"], es["withRouter"])(activity_indicator_seen_ActivityIndicatorSeen));
// EXTERNAL MODULE: ./src/universal/tripboard/tripboard-banner/components/tripboard-banner.less
var tripboard_banner = __webpack_require__("lu7F");
var tripboard_banner_default = /*#__PURE__*/__webpack_require__.n(tripboard_banner);

// CONCATENATED MODULE: ./src/universal/tripboard/tripboard-banner/components/tripboard-banner.js





var tripboard_banner_TripboardBanner = function TripboardBanner(_ref) {
    var welcomeMessage = _ref.welcomeMessage,
        welcomeTitle = _ref.welcomeTitle;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'tripboard-banner' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'tripboard-banner__text' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'tripboard-banner__title' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'h2',
                    null,
                    welcomeTitle
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'tripboard-banner__message text-muted' },
                welcomeMessage
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'tripboard-banner__image' })
    );
};

/* harmony default export */ var components_tripboard_banner = (withTranslationsAsProps({
    'tripboards.main.welcome': 'welcomeMessage',
    'tripboards.main.welcome.title': 'welcomeTitle'
})(tripboard_banner_TripboardBanner));
// CONCATENATED MODULE: ./src/universal/tripboard/tripboard-banner/index.js


// CONCATENATED MODULE: ./src/universal/tripboard/details/components/error-boundary.js




function TranslatedErrorBoundary(_ref) {
    var children = _ref.children,
        message = _ref.message,
        title = _ref.title;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            error_boundary,
            {
                errorMessage: message,
                errorTitle: title
            },
            children
        )
    );
}

/* harmony default export */ var components_error_boundary = (withTranslationsAsProps({
    'th.inbox.error.message': 'message',
    'th.inbox.error.title': 'title'
})(TranslatedErrorBoundary));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/favorites-message.js





function FavoritesMessage(_ref) {
    var isShared = _ref.isShared,
        langList = _ref.langList,
        langListShared = _ref.langListShared,
        location = _ref.location;

    var isFavoritesRedirect = location && location.search && location.search.indexOf('redirect=favorites') !== -1;
    if (!isFavoritesRedirect) {
        return null;
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'fade in alert alert--verbose alert-info', role: 'alert' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'svg',
                { className: 'inline-svg', 'aria-hidden': 'true' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '#svg-clock' })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'scratchpad-alert-message-text' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'p',
                    null,
                    isShared ? langListShared : langList
                )
            )
        )
    );
}

/* harmony default export */ var favorites_message = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'tripboards.favorites.list': 'langList',
    'tripboards.favorites.shared_list': 'langListShared'
}), es["withRouter"])(FavoritesMessage));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-searchbox/lib/esm/index.js
var react_searchbox_lib_esm = __webpack_require__("ymrj");
var esm_default = /*#__PURE__*/__webpack_require__.n(react_searchbox_lib_esm);

// CONCATENATED MODULE: ./src/universal/tripboard/details/components/search-box-wrapper.js












var isDateRangeAfterToday = function isDateRangeAfterToday(startDate, endDate) {
    if (!startDate || !endDate) {
        return false;
    }
    var q = new Date();
    var m = q.getMonth();
    var d = q.getDate();
    var y = q.getFullYear();

    var currentDate = new Date(y, m, d);
    currentDate.setHours(0, 0, 0, 0);
    currentDate = currentDate.getTime();

    var dateCheckIn = new Date(startDate);
    var dateCheckOut = new Date(endDate);

    if (currentDate >= dateCheckIn.getTime() || currentDate >= dateCheckOut.getTime()) {
        return false;
    }
    return true;
};

var search_box_wrapper_submitSearch = function submitSearch(role, siteName, boardId, updateTripData, edapActionLocation) {
    return function (search) {
        var checkIn = search.checkIn,
            checkOut = search.checkOut,
            _search$destination = search.destination,
            destination = _search$destination === undefined ? '' : _search$destination,
            subDestination = search.subDestination,
            _search$guests = search.guests,
            adultsCount = _search$guests.adultsCount,
            _search$guests$childr = _search$guests.childrenCount,
            childrenCount = _search$guests$childr === undefined ? 0 : _search$guests$childr,
            _search$guests$petInc = _search$guests.petIncluded,
            petIncluded = _search$guests$petInc === undefined ? false : _search$guests$petInc;


        var dated = checkIn && checkOut;

        tripboard_edap.tripboardSearch(boardId, role, dated, edapActionLocation);

        var filterId = subDestination && subDestination.filter && subDestination.filter.id;

        var url = toURL({
            arrival: checkIn,
            departure: checkOut,
            q: destination,
            adultsCount: adultsCount,
            childrenCount: childrenCount,
            petIncluded: petIncluded,
            filter: filterId ? ['filter:' + filterId] : []
        });
        var tripData = {
            searchUrl: url,
            location: destination,
            adultsCount: adultsCount,
            childrenCount: childrenCount,
            petIncluded: petIncluded,
            arrival: checkIn,
            departure: checkOut
        };
        updateTripData(tripData);

        window.open(url, '_blank');
    };
};

var search_box_wrapper_SearchBoxWrapper = function SearchBoxWrapper(props) {
    var adultLabel = props.adultLabel,
        adultsLabel = props.adultsLabel,
        applyLabel = props.applyLabel,
        arriveLabel = props.arriveLabel,
        dateCheckIn = props.dateCheckIn,
        dateCheckOut = props.dateCheckOut,
        boardId = props.boardId,
        childLabel = props.childLabel,
        childrenLabel = props.childrenLabel,
        clearLabel = props.clearLabel,
        departLabel = props.departLabel,
        destination = props.destination,
        doneLabel = props.doneLabel,
        edapActionLocation = props.edapActionLocation,
        guestLabel = props.guestLabel,
        guestContinueLabel = props.guestContinueLabel,
        guestTitle = props.guestTitle,
        guestsLabel = props.guestsLabel,
        helpLabel = props.helpLabel,
        isMobile = props.isMobile,
        locale = props.locale,
        noLabel = props.noLabel,
        petsLabel = props.petsLabel,
        petMessage = props.petMessage,
        role = props.role,
        searchTitle = props.searchTitle,
        searchTextTitle = props.searchTextTitle,
        searchTextDesktop = props.searchTextDesktop,
        searchTextMobile = props.searchTextMobile,
        siteName = props.siteName,
        stayGuests = props.stayGuests,
        trip = props.trip,
        typeaheadLabel = props.typeaheadLabel,
        updateTripData = props.updateTripData,
        yesLabel = props.yesLabel;


    var labels = {
        buttonTitle: searchTitle,
        mobileTitle: searchTitle,
        datePicker: {
            clear: clearLabel,
            label: arriveLabel,
            label2: departLabel,
            done: doneLabel,
            help: helpLabel
        },
        guests: {
            label: guestTitle,
            adult: adultLabel,
            adults: adultsLabel,
            child: childLabel,
            children: childrenLabel,
            pets: petsLabel,
            guest: guestLabel,
            guests: guestsLabel,
            yesBtn: yesLabel,
            noBtn: noLabel,
            clearBtn: clearLabel,
            applyBtn: applyLabel,
            modalTitle: guestTitle,
            mobileBtn: guestContinueLabel,
            petMessage: petMessage
        },
        typeahead: {
            destinationplaceholdermsg: typeaheadLabel
        }
    };
    var headerTextId = isMobile ? searchTextMobile : searchTextDesktop;
    var buttonComponent = function buttonComponent() {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], { type: 'submit', label: searchTitle, size: 'lg' });
    };

    var resolvedDestination = destination || trip && trip.location || '';
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-details__search-box' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'search-box__copy' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'search-box__title' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: searchTextTitle, description: 'search box title', defaultMessage: '' })
            ),
            headerTextId && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'search-box__text' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: headerTextId, description: 'search box text', defaultMessage: '' })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(esm_default.a, {
            actionLocation: edapActionLocation,
            checkIn: dateCheckIn,
            checkOut: dateCheckOut,
            consolidateDateInputs: false,
            destination: resolvedDestination,
            guests: stayGuests,
            geoType: 'point_of_interest',
            isMobile: isMobile,
            labels: labels,
            locale: locale,
            buttonComponent: buttonComponent(),
            onSubmit: search_box_wrapper_submitSearch(role, siteName, boardId, updateTripData, edapActionLocation),
            splitDatePicker: true,
            useMobileExpanded: true,
            typeaheadProps: { isTypeaheadInputFocus: false }
        })
    );
};

var search_box_wrapper_mapStateToProps = function mapStateToProps(_ref, _ref2) {
    var trip = _ref.trip;
    var arrival = _ref2.arrival,
        departure = _ref2.departure,
        guests = _ref2.guests,
        preferStayProps = _ref2.preferStayProps;

    var cookieTrip = trip || {};
    var dateCheckIn = cookieTrip.arrival;
    var dateCheckOut = cookieTrip.departure;
    var stayGuests = {
        adultsCount: cookieTrip.adultsCount,
        childrenCount: cookieTrip.childrenCount,
        petIncluded: cookieTrip.petIncluded
    };
    var usePropDates = preferStayProps || !dateCheckIn || !dateCheckOut;
    var usePropGuests = preferStayProps || !cookieTrip.adultsCount && cookieTrip.adultsCount !== 0;
    if (usePropDates && arrival && departure) {
        // we want to use the passed in props in preference over cookies
        dateCheckIn = arrival;
        dateCheckOut = departure;
    }

    if (usePropGuests) {
        stayGuests = guests;
    }

    if (!isDateRangeAfterToday(dateCheckIn, dateCheckOut)) {
        dateCheckIn = null;
        dateCheckOut = null;
    }

    return {
        trip: trip,
        dateCheckIn: dateCheckIn,
        dateCheckOut: dateCheckOut,
        stayGuests: stayGuests
    };
};

var search_box_wrapper_mapDispatchToProps = {
    updateTripData: actions.updateTripData
};

/* harmony default export */ var search_box_wrapper = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'datepicker.dates.label': 'dateLabel',
    'datepicker.clear': 'clearLabel',
    'datepicker.done': 'doneLabel',
    'datepicker.help': 'helpLabel',
    'guest.selector.title': 'guestTitle',
    'guest.selector.adult': 'adultLabel',
    'guest.selector.adults': 'adultsLabel',
    'guest.selector.child': 'childLabel',
    'guest.selector.children': 'childrenLabel',
    'guest.selector.pets': 'petsLabel',
    'guest.selector.guest': 'guestLabel',
    'guest.selector.guests': 'guestsLabel',
    'guest.selector.pets.yes': 'yesLabel',
    'guest.selector.pets.no': 'noLabel',
    'guest.selector.clear': 'clearLabel',
    'guest.selector.apply': 'applyLabel',
    'guest.modal.title': 'modalTitle',
    'guest.modal.continue': 'guestContinueLabel',
    'guest.modal.petmessage': 'petMessage',
    'typeahead.error': 'errorMessage',
    'typeahead.label': 'typeaheadLabel',
    'typeahead.message': 'typeaheadMessage',
    'search.button': 'buttonLabel',
    'search.modal.title': 'searchTitle',
    arrive: 'arriveLabel',
    depart: 'departLabel'
}), react_determine_if_mobile_lib_transpiled_default.a, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(search_box_wrapper_mapStateToProps, search_box_wrapper_mapDispatchToProps))(search_box_wrapper_SearchBoxWrapper));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/public-search.js



var public_search_PublicSearch = function PublicSearch(_ref) {
    var boardCheckIn = _ref.boardCheckIn,
        boardCheckOut = _ref.boardCheckOut,
        _ref$adultsCount = _ref.adultsCount,
        adultsCount = _ref$adultsCount === undefined ? 2 : _ref$adultsCount,
        _ref$childrenCount = _ref.childrenCount,
        childrenCount = _ref$childrenCount === undefined ? 0 : _ref$childrenCount,
        _ref$petIncluded = _ref.petIncluded,
        petIncluded = _ref$petIncluded === undefined ? false : _ref$petIncluded,
        boardId = _ref.boardId,
        locale = _ref.locale,
        role = _ref.role,
        siteName = _ref.siteName,
        edapSearchType = _ref.edapSearchType;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-details__public-search' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(search_box_wrapper, {
            boardId: boardId,
            arrival: boardCheckIn,
            departure: boardCheckOut,
            edapActionLocation: edapSearchType,
            guests: { adultsCount: adultsCount, childrenCount: childrenCount, petIncluded: petIncluded },
            locale: locale,
            role: role,
            siteName: siteName,
            searchTextTitle: 'tripboards.main.empty.planning'
        })
    );
};

public_search_PublicSearch.defaultProps = {
    isMobile: false,
    boardId: null,
    role: null,
    boardCheckIn: null,
    boardCheckOut: null
};

/* harmony default export */ var public_search = (public_search_PublicSearch);
// EXTERNAL MODULE: ./node_modules/@homeaway/react-date-pickers/lib/transpiled/index.js
var react_date_pickers_lib_transpiled = __webpack_require__("lLC2");
var react_date_pickers_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_date_pickers_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/CALENDAR__16.js
var CALENDAR__16 = __webpack_require__("N1tr");
var CALENDAR__16_default = /*#__PURE__*/__webpack_require__.n(CALENDAR__16);

// CONCATENATED MODULE: ./src/universal/tripboard/details/components/date-range-picker.js
function date_range_picker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function date_range_picker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function date_range_picker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var date_range_picker_DateRangePickerContainer = function (_Component) {
    date_range_picker__inherits(DateRangePickerContainer, _Component);

    function DateRangePickerContainer(props) {
        date_range_picker__classCallCheck(this, DateRangePickerContainer);

        var _this = date_range_picker__possibleConstructorReturn(this, _Component.call(this, props));

        date_range_picker__initialiseProps.call(_this);

        var startDate = props.startDate,
            endDate = props.endDate;


        _this.state = {
            startDate: startDate,
            endDate: endDate
        };
        return _this;
    }

    DateRangePickerContainer.prototype.render = function render() {
        var dateFormatOptions = { month: 'short', day: 'numeric' };
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'form',
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_date_pickers_lib_transpiled["DateRangePicker"], {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                onDateRangeChange: this.handleDateRangeChange,
                onOpen: this.props.onDatesClick,
                onClose: this.handleDateRangeClose,
                id: 'trip-board-date-range-picker',
                inputLabel1: this.props.datesText,
                inputName1: 'dates',
                clearButtonLabel: this.props.clearDatesText,
                consolidateInputs: true,
                dateFormatOptions: dateFormatOptions,
                locale: this.props.locale,
                inputIcon1: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: CALENDAR__16["CALENDAR__16"] }),
                showContinueButton: true
            })
        );
    };

    return DateRangePickerContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

date_range_picker_DateRangePickerContainer.propTypes = {
    locale: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    datesText: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    clearDatesText: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    startDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    endDate: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    onDatesClick: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    onNewDates: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func
};
date_range_picker_DateRangePickerContainer.defaultProps = {
    onDatesClick: function onDatesClick() {},
    onNewDates: function onNewDates() {}
};

var date_range_picker__initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleDateRangeChange = function (startDate, endDate) {
        _this2.setState({
            startDate: startDate,
            endDate: endDate
        });
    };

    this.handleDateRangeClose = function () {
        if (_this2.isDateChange()) {
            _this2.props.onNewDates(_this2.state.startDate, _this2.state.endDate);
        }
    };

    this.isDateChange = function () {
        return _this2.state.startDate !== _this2.props.startDate || _this2.state.endDate !== _this2.props.endDate;
    };
};

/* harmony default export */ var date_range_picker = (withTranslationsAsProps({
    'tripboards.date_picker.clear_dates': 'clearDatesText',
    'tripboards.date_picker.dates': 'datesText'
})(date_range_picker_DateRangePickerContainer));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-guest-picker/lib/transpiled/index.js
var react_guest_picker_lib_transpiled = __webpack_require__("U7UD");
var react_guest_picker_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_guest_picker_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/GROUP__16.js
var GROUP__16 = __webpack_require__("SMcY");
var GROUP__16_default = /*#__PURE__*/__webpack_require__.n(GROUP__16);

// CONCATENATED MODULE: ./src/universal/tripboard/details/components/guest-picker.js
function guest_picker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function guest_picker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function guest_picker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var guest_picker_GuestPickerContainer = function (_Component) {
    guest_picker__inherits(GuestPickerContainer, _Component);

    function GuestPickerContainer(props) {
        guest_picker__classCallCheck(this, GuestPickerContainer);

        var _this = guest_picker__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleGuestSelectorChanged = function (key, value) {
            var _this$setState;

            _this.setState((_this$setState = {}, _this$setState[key] = value, _this$setState));
        };

        _this.handleGuestSelectorExited = function (undoState) {
            _this.setState(undoState);
            return;
        };

        _this.handleGuestSelectorClose = function () {
            if (_this.isGuestChange()) {
                _this.props.onNewGuests(_this.state.adultsCount, _this.state.childrenCount, _this.state.petIncluded, _this.props.startDate, _this.props.endDate);
            }
        };

        _this.isGuestChange = function () {
            return _this.state.adultsCount !== _this.props.adultsCount || _this.state.childrenCount !== _this.props.childrenCount || _this.state.petIncluded !== _this.props.petIncluded;
        };

        _this.guestLabel = function (numGuests, pet) {
            var petString = pet ? ', ' + _this.props.petsLabel : '';
            return numGuests ? numGuests + ' ' + _this.props.guestsLabel + petString : '';
        };

        _this.state = {
            adultsCount: props.adultsCount || 2,
            childrenCount: props.childrenCount || 0,
            petIncluded: props.petsIncluded || false
        };
        return _this;
    }

    GuestPickerContainer.prototype.render = function render() {
        var _props = this.props,
            guestTitle = _props.guestTitle,
            adultLabel = _props.adultLabel,
            adultsLabel = _props.adultsLabel,
            childLabel = _props.childLabel,
            childrenLabel = _props.childrenLabel,
            petsLabel = _props.petsLabel,
            yesLabel = _props.yesLabel,
            noLabel = _props.noLabel,
            clearLabel = _props.clearLabel,
            applyLabel = _props.applyLabel,
            modalTitle = _props.modalTitle,
            guestContinueLabel = _props.guestContinueLabel,
            petMessage = _props.petMessage,
            onGuestsClick = _props.onGuestsClick;
        var _state = this.state,
            adultsCount = _state.adultsCount,
            childrenCount = _state.childrenCount,
            petIncluded = _state.petIncluded;

        var adultsLabelFormatted = adultsCount === 1 ? adultsCount + ' ' + adultLabel : adultsCount + ' ' + adultsLabel;
        var childrenLabelFormatted = childrenCount === 1 ? childrenCount + ' ' + childLabel : childrenCount + ' ' + childrenLabel;
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'form',
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_guest_picker_lib_transpiled["GuestPicker"], {
                adultsMin: 1,
                applyButtonLabel: applyLabel,
                label: guestTitle,
                name: guestTitle,
                guestLabel: this.guestLabel(adultsCount + childrenCount, petIncluded),
                adultsLabel: adultsLabelFormatted,
                adultsCount: adultsCount,
                childrenLabel: childrenLabelFormatted,
                childrenCount: childrenCount,
                clearButtonLabel: clearLabel,
                continueButtonLabel: guestContinueLabel,
                inputIcon: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: GROUP__16["GROUP__16"] }),
                modalTitle: modalTitle,
                petIncluded: petIncluded,
                petLabel: petsLabel,
                petMessage: petMessage,
                petNoLabel: noLabel,
                petYesLabel: yesLabel,
                showPetOption: true,
                onChange: this.handleGuestSelectorChanged,
                onClose: this.handleGuestSelectorClose,
                onExit: this.handleGuestSelectorExited,
                onOpen: onGuestsClick,
                showClearButton: false
            })
        );
    };

    return GuestPickerContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

guest_picker_GuestPickerContainer.propTypes = {
    petIncluded: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    childrenCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    adultsCount: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.number,
    onGuestsClick: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    onNewGuests: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func
};
guest_picker_GuestPickerContainer.defaultProps = {
    onGuestsClick: function onGuestsClick() {},
    onNewGuests: function onNewGuests() {}
};


/* harmony default export */ var guest_picker = (withTranslationsAsProps({
    'guest.selector.title': 'guestTitle',
    'guest.selector.adult': 'adultLabel',
    'guest.selector.adults': 'adultsLabel',
    'guest.selector.child': 'childLabel',
    'guest.selector.children': 'childrenLabel',
    'guest.selector.pets': 'petsLabel',
    'guest.selector.guest': 'guestLabel',
    'guest.selector.guests': 'guestsLabel',
    'guest.selector.pets.yes': 'yesLabel',
    'guest.selector.pets.no': 'noLabel',
    'guest.selector.clear': 'clearLabel',
    'guest.selector.apply': 'applyLabel',
    'guest.modal.title': 'modalTitle',
    'guest.modal.continue': 'guestContinueLabel',
    'guest.modal.petmessage': 'petMessage'
})(guest_picker_GuestPickerContainer));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/stay-context-container.js
var stay_context_container__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var stay_context_container__templateObject = stay_context_container__taggedTemplateLiteralLoose(['\nmutation updateStayOnTripBoard($hav: String!, $tripBoardUuid: String!, $stay: StayInput!) {\n    updateStayOnTripBoard(\n        hav: $hav\n        tripBoardUuid: $tripBoardUuid\n        stay: $stay\n    )\n}'], ['\nmutation updateStayOnTripBoard($hav: String!, $tripBoardUuid: String!, $stay: StayInput!) {\n    updateStayOnTripBoard(\n        hav: $hav\n        tripBoardUuid: $tripBoardUuid\n        stay: $stay\n    )\n}']),
    stay_context_container__templateObject2 = stay_context_container__taggedTemplateLiteralLoose(['\nmutation resetTripBoardDates($hav: String!, $tripBoardUuid: String!) {\n    resetTripBoardDates(hav: $hav, tripBoardUuid: $tripBoardUuid)\n}'], ['\nmutation resetTripBoardDates($hav: String!, $tripBoardUuid: String!) {\n    resetTripBoardDates(hav: $hav, tripBoardUuid: $tripBoardUuid)\n}']);

function stay_context_container__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stay_context_container__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function stay_context_container__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function stay_context_container__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }









var updateStayOnTripBoard = src_default()(stay_context_container__templateObject);

var resetTripBoardDates = src_default()(stay_context_container__templateObject2);

var stay_context_container_StayContextContainer = function (_Component) {
    stay_context_container__inherits(StayContextContainer, _Component);

    function StayContextContainer(props) {
        stay_context_container__classCallCheck(this, StayContextContainer);

        var _this = stay_context_container__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleNewDates = function (startDate, endDate) {
            if (startDate && endDate) {
                _this.handleUpdateStay(null, null, null, startDate, endDate);
            } else {
                var noDates = {
                    variables: {
                        hav: _this.props.hav,
                        tripBoardUuid: _this.props.boardId
                    }
                };
                _this.props.deleteDates(noDates);
            }
            tripboard_edap.datesChange(_this.props.boardId, startDate, endDate);
        };

        _this.handleNewGuests = function (adultsCount, childrenCount, petsIncluded) {
            tripboard_edap.guestsChange(_this.props.boardId, adultsCount, childrenCount, petsIncluded);
            _this.handleUpdateStay(adultsCount, childrenCount, petsIncluded, null, null);
        };

        _this.handleUpdateStay = function () {
            var adultsCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
            var childrenCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var petsIncluded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var startDate = arguments[3];
            var endDate = arguments[4];

            var tripBoardUuid = _this.props.boardId;
            var hav = _this.props.hav;
            var updatedStay = {
                variables: {
                    hav: hav,
                    tripBoardUuid: tripBoardUuid,
                    stay: stay_context_container__extends({
                        adultCount: adultsCount !== null ? adultsCount : _this.props.adultsCount,
                        childrenCount: childrenCount !== null ? childrenCount : _this.props.childrenCount,
                        petsIncluded: petsIncluded !== null ? petsIncluded : _this.props.petsIncluded
                    }, (startDate || _this.props.startDate) && (endDate || _this.props.endDate) && {
                        dateRange: {
                            arrival: startDate || _this.props.startDate,
                            departure: endDate || _this.props.endDate
                        }
                    })
                }
            };

            _this.props.updateStay(updatedStay);
        };

        _this.onGuestsClick = function () {
            tripboard_edap.guestsClick(_this.props.boardId);
        };

        _this.onDatesClick = function () {
            tripboard_edap.datesClick(_this.props.boardId);
        };

        return _this;
    }

    StayContextContainer.prototype.render = function render() {
        var _props = this.props,
            boardId = _props.boardId,
            endDate = _props.endDate,
            locale = _props.locale,
            startDate = _props.startDate,
            _props$adultsCount = _props.adultsCount,
            adultsCount = _props$adultsCount === undefined ? 2 : _props$adultsCount,
            _props$childrenCount = _props.childrenCount,
            childrenCount = _props$childrenCount === undefined ? 0 : _props$childrenCount,
            _props$petsIncluded = _props.petsIncluded,
            petsIncluded = _props$petsIncluded === undefined ? false : _props$petsIncluded,
            isGuestContextTestOn = _props.isGuestContextTestOn;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xlg-2 trip-board-details__date-picker' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(date_range_picker, {
                    boardId: boardId,
                    endDate: endDate,
                    locale: locale,
                    onNewDates: this.handleNewDates,
                    onDatesClick: this.onDatesClick,
                    startDate: startDate
                })
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xlg-2 trip-board-details__guest-picker' },
                isGuestContextTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(guest_picker, {
                    adultsCount: adultsCount,
                    boardId: boardId,
                    childrenCount: childrenCount,
                    endDate: endDate,
                    onGuestsClick: this.onGuestsClick,
                    onNewGuests: this.handleNewGuests,
                    petsIncluded: petsIncluded,
                    startDate: startDate
                })
            )
        );
    };

    return StayContextContainer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

var stay_context_container_handleMutationError = function handleMutationError() {
    var onError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    return function () {
        onError();
    };
};

var stay_context_container_StayContextContainerProvider = function StayContextContainerProvider(_ref) {
    var hav = _ref.hav,
        onError = _ref.onError,
        adultsCount = _ref.adultsCount,
        boardId = _ref.boardId,
        childrenCount = _ref.childrenCount,
        endDate = _ref.endDate,
        locale = _ref.locale,
        petsIncluded = _ref.petsIncluded,
        startDate = _ref.startDate,
        isGuestContextTestOn = _ref.isGuestContextTestOn,
        refetchTripboard = _ref.refetchTripboard;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        react_apollo_browser_umd["Mutation"],
        {
            mutation: updateStayOnTripBoard,
            onError: stay_context_container_handleMutationError(onError),
            onCompleted: refetchTripboard
        },
        function (updateStay) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                react_apollo_browser_umd["Mutation"],
                {
                    mutation: resetTripBoardDates,
                    onError: stay_context_container_handleMutationError(onError),
                    onCompleted: refetchTripboard
                },
                function (deleteDates) {
                    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(stay_context_container_StayContextContainer, {
                        updateStay: updateStay,
                        deleteDates: deleteDates,
                        hav: hav,
                        adultsCount: adultsCount,
                        boardId: boardId,
                        childrenCount: childrenCount,
                        endDate: endDate,
                        locale: locale,
                        petsIncluded: petsIncluded,
                        startDate: startDate,
                        isGuestContextTestOn: isGuestContextTestOn
                    });
                }
            );
        }
    );
};

/* harmony default export */ var stay_context_container = (with_auth(stay_context_container_StayContextContainerProvider));
// CONCATENATED MODULE: ./src/universal/utils/translations.js
/**
 * Translations do not need state. Sticking them here, so we can require them anywhere
 * we want vs passing translation props down all of the time.
 * @todo Need to deprecate dependencies on translations from store throughout app if
 * this POJO proves to be the better approach.
 */
var translations_translations =  true ? window.__TRANSLATIONS__ : {};
/* harmony default export */ var utils_translations = (translations_translations);
// CONCATENATED MODULE: ./src/universal/components/generic-error/generic-error.js



var generic_error_GenericError = function GenericError() {
    var title = utils_translations['th.inbox.error.title'];
    var message = utils_translations['th.inbox.error.message'];
    var errorStyle = {
        paddingTop: '40px',
        paddingBottom: '40px'
    };

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'row text-center', style: errorStyle },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'svg',
            { className: 'inline-svg svg-xl svg-warning ' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xlinkHref: '#svg-alert' })
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'h3',
            null,
            title
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'p',
            null,
            message
        )
    );
};

/* harmony default export */ var generic_error = (generic_error_GenericError);
// CONCATENATED MODULE: ./src/universal/components/generic-error/index.js

/* harmony default export */ var components_generic_error = (generic_error);
// CONCATENATED MODULE: ./src/universal/tripboard/listing-delete-modal/selectors.js
/* istanbul ignore file */
var getListingDeleteModalState = function getListingDeleteModalState(state) {
  return state.tripboard.listingDeleteModal;
};
// EXTERNAL MODULE: ./src/universal/tripboard/listing-delete-modal/ListingDeleteModal.less
var ListingDeleteModal = __webpack_require__("uywk");
var ListingDeleteModal_default = /*#__PURE__*/__webpack_require__.n(ListingDeleteModal);

// CONCATENATED MODULE: ./src/universal/tripboard/listing-delete-modal/ListingDeleteModal.js
/* istanbul ignore file */











function ListingDeleteModal_ListingDeleteModal(_ref) {
    var confirmText = _ref.confirmText,
        confirmRemove = _ref.confirmRemove,
        confirmCancel = _ref.confirmCancel,
        isOpen = _ref.isOpen,
        onClose = _ref.onClose,
        onDelete = _ref.onDelete,
        boardId = _ref.boardId,
        listingId = _ref.listingId,
        idx = _ref.idx,
        hitTotal = _ref.hitTotal,
        userRole = _ref.userRole;

    function handleModalClose() {
        tripboard_edap.listingDeleteModalClose(boardId, listingId);
        onClose();
    }

    function handleDeleteClick() {
        onDelete(boardId, listingId);
        tripboard_edap.listingDelete(boardId, listingId, idx, hitTotal, userRole);
        handleModalClose();
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        lib_esm["default"],
        {
            id: 'listing-remove-modal',
            isOpen: isOpen,
            onClose: handleModalClose
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'p',
            null,
            confirmText
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'listing-delete-modal__button' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], { label: confirmCancel, onClick: handleModalClose }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], { label: confirmRemove, onClick: handleDeleteClick })
        )
    );
}

ListingDeleteModal_ListingDeleteModal.defaultProps = {
    onClose: function onClose() {}
};

var ListingDeleteModal_mapStateToProps = function mapStateToProps(state) {
    return getListingDeleteModalState(state);
};

var ListingDeleteModal_mapDispatchToProps = {
    onClose: listing_delete_modal_actions.close
};

/* harmony default export */ var listing_delete_modal_ListingDeleteModal = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslationsAsProps({
    'tripboards.main.remove.property': 'confirmText',
    'tripboards.main.yes.remove': 'confirmRemove',
    'tripboards.cancel': 'confirmCancel'
}), Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(ListingDeleteModal_mapStateToProps, ListingDeleteModal_mapDispatchToProps))(ListingDeleteModal_ListingDeleteModal));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/back-button.js







function BackButton(_ref) {
    var label = _ref.label;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        es["Link"],
        {
            'aria-label': label,
            className: 'btn btn-default btn-icon-responsive',
            'data-wdio': 'tripboard-details__back-to-sctratchpad-button',
            to: universal_routes.TRIPBOARD
        },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { className: 'visible-xs', markup: CHEVRON_LEFT__16["CHEVRON_LEFT__16"] }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'span',
            { className: 'hidden-xs' },
            label
        )
    );
}

/* harmony default export */ var back_button = (withTranslationsAsProps({
    'tripboards.button.back': 'label'
})(BackButton));
// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/defs/EDIT__16.js
var EDIT__16 = __webpack_require__("dUKy");
var EDIT__16_default = /*#__PURE__*/__webpack_require__.n(EDIT__16);

// CONCATENATED MODULE: ./src/universal/tripboard/details/components/edit-button.js






function EditButton(_ref) {
    var isEditing = _ref.isEditing,
        isSaveable = _ref.isSaveable,
        labelCancel = _ref.labelCancel,
        labelDone = _ref.labelDone,
        labelEdit = _ref.labelEdit,
        onCancel = _ref.onCancel,
        onDone = _ref.onDone,
        onEdit = _ref.onEdit;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
        null,
        isEditing && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonLink"], {
                'data-wdio': 'tripboard-details__edit-button--cancel',
                label: labelCancel,
                onClick: onCancel
            }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["ButtonPrimary"], {
                'data-wdio': 'tripboard-details__edit-button--done',
                disabled: !isSaveable,
                label: labelDone,
                onClick: onDone
            })
        ),
        !isEditing && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
            'aria-label': labelEdit,
            className: 'btn-icon-responsive edit-button',
            'data-wdio': 'tripboard-details__edit-button',
            label: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                null,
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'span',
                    { className: 'hidden-xs' },
                    labelEdit
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { inlineFlex: true, markup: EDIT__16["EDIT__16"], className: 'visible-xs' })
            ),
            onClick: onEdit
        })
    );
}

/* harmony default export */ var edit_button = (withTranslationsAsProps({
    'tripboards.cancel': 'labelCancel',
    'tripboards.done': 'labelDone',
    'tripboards.main.edit': 'labelEdit'
})(EditButton));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/with-rename-tripboard.js
var with_rename_tripboard__templateObject = with_rename_tripboard__taggedTemplateLiteralLoose(['\nmutation updateTripBoardName($hav: String!, $tripBoardUuid: String!, $name: String!) {\n    updateTripBoardName(hav: $hav, tripBoardUuid: $tripBoardUuid, name: $name)\n}'], ['\nmutation updateTripBoardName($hav: String!, $tripBoardUuid: String!, $name: String!) {\n    updateTripBoardName(hav: $hav, tripBoardUuid: $tripBoardUuid, name: $name)\n}']);

function with_rename_tripboard__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }








var updateTripBoardName = src_default()(with_rename_tripboard__templateObject);

var with_rename_tripboard_props = function props(_ref) {
    var mutate = _ref.mutate,
        _ref$ownProps = _ref.ownProps;
    _ref$ownProps = _ref$ownProps === undefined ? {} : _ref$ownProps;
    var client = _ref$ownProps.client,
        hav = _ref$ownProps.hav,
        boardId = _ref$ownProps.boardId,
        currency = _ref$ownProps.currency;
    return {
        rename: function rename(tripBoardUuid, name) {
            return mutate({
                variables: {
                    hav: hav,
                    tripBoardUuid: tripBoardUuid,
                    name: name
                },
                update: function update(proxy) {
                    var variables = {
                        hav: hav,
                        tripBoardUuid: boardId,
                        currency: currency
                    };
                    try {
                        var data = proxy.readQuery({ query: with_tripboard_query_query, variables: variables });
                        // remove listing from cache
                        if (data.tripBoard) {
                            data.tripBoard.name = name;
                        }
                        proxy.writeQuery({ query: with_tripboard_query_query, variables: variables, data: data });
                    } catch (err) {
                        /* we can't read or write the cache for some reason, silently swallow
                        and try to refetch the query from network in the refetchQueries function */
                    }
                },
                refetchQueries: [{
                    query: with_tripboard_query_query,
                    variables: {
                        hav: hav,
                        tripBoardUuid: tripBoardUuid,
                        currency: currency
                    }
                }],
                optimisticResponse: {
                    updateTripBoardName: true
                }
            }).catch(function () {
                // VERY HACKY manually set the cache in case something blows up bad server side.
                // TODO: remove when rename query does not error because of v1 issues
                var variables = {
                    hav: hav,
                    tripBoardUuid: boardId,
                    currency: currency
                };
                var data = client.readQuery({ query: with_tripboard_query_query, variables: variables });

                // rename tripboard
                if (data.tripBoard) {
                    data.tripBoard.name = name;
                }
                client.writeQuery({ query: with_tripboard_query_query, variables: variables, data: data });
            });
        }
    };
};
var with_rename_tripboard_mapStateToProps = function mapStateToProps(state) {
    return {
        currency: state && state.system && state.system.currency || 'USD'
    };
};

var withRenameTripboard = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, // hav is extracted from auth context for use in query
react_apollo_browser_umd["withApollo"], Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(with_rename_tripboard_mapStateToProps), Object(react_apollo_browser_umd["graphql"])(updateTripBoardName, { props: with_rename_tripboard_props }));

/* harmony default export */ var with_rename_tripboard = (withRenameTripboard);
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/header-with-edit-state.js
var header_with_edit_state__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function header_with_edit_state__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function header_with_edit_state__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function header_with_edit_state__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var header_with_edit_state_initialState = {
    isEditing: false,
    isNameChanged: false,
    isSaveable: false
};

var header_with_edit_state_EditHeader = function (_Component) {
    header_with_edit_state__inherits(EditHeader, _Component);

    function EditHeader(props) {
        header_with_edit_state__classCallCheck(this, EditHeader);

        var _this = header_with_edit_state__possibleConstructorReturn(this, _Component.call(this, props));

        _this.isSaveable = function (state) {
            return state.isNameChanged;
        };

        _this.onCancel = function () {
            var boardId = _this.props.boardId;

            tripboard_edap.editCancel(boardId);
            _this.reset();
        };

        _this.onDone = function () {
            var _this$state = _this.state,
                isSaveable = _this$state.isSaveable,
                nameEdit = _this$state.nameEdit;
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                name = _this$props.name,
                rename = _this$props.rename,
                role = _this$props.role;

            var newName = nameEdit.trim();

            if (!isSaveable) {
                return;
            }

            rename(boardId, newName);
            tripboard_edap.editAttempt(boardId, name, newName, role);
            tripboard_edap.editDone(boardId);
            _this.reset();
        };

        _this.onEdit = function () {
            var boardId = _this.props.boardId;
            var isEditing = _this.state.isEditing;

            tripboard_edap.editStart(boardId);
            _this.setState({
                isEditing: !isEditing
            });
        };

        _this.onNameChange = function (state) {
            var isNameChanged = state.isNameChanged,
                name = state.name;

            var newState = header_with_edit_state__extends({}, _this.state, {
                isNameChanged: isNameChanged,
                nameEdit: name
            });
            _this.setState({
                isNameChanged: isNameChanged,
                isSaveable: _this.isSaveable(newState),
                nameEdit: name
            });
        };

        _this.reset = function () {
            var name = _this.props.name;

            _this.setState(header_with_edit_state__extends({}, header_with_edit_state_initialState, {
                nameEdit: name
            }));
        };

        _this.state = header_with_edit_state__extends({}, header_with_edit_state_initialState, {
            nameEdit: props.name
        });
        return _this;
    }

    // Currently, we are only enabling Save (Done button) if the name
    // has changed. In the future, if the user can edit additional information
    // that is tied to the Save (or Done button), then we can include that
    // logic here.


    EditHeader.prototype.render = function render() {
        var _props = this.props,
            boardId = _props.boardId,
            collaboratorType = _props.collaboratorType,
            name = _props.name,
            role = _props.role,
            startDate = _props.startDate,
            endDate = _props.endDate,
            users = _props.users,
            showEmptyStateSearch = _props.showEmptyStateSearch;
        var _state = this.state,
            isEditing = _state.isEditing,
            isSaveable = _state.isSaveable;
        var onCancel = this.onCancel,
            onDone = this.onDone,
            onEdit = this.onEdit,
            onNameChange = this.onNameChange;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'flex-row flex-space-between padding-bottom-3x' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    null,
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        components_permissions,
                        { role: role, collaborator: true, owner: true },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(back_button, null)
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    null,
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        components_permissions,
                        { role: role, collaborator: true, owner: true },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(edit_button, {
                            boardId: boardId,
                            isEditing: isEditing,
                            isSaveable: isSaveable,
                            onCancel: onCancel,
                            onDone: onDone,
                            onEdit: onEdit
                        })
                    )
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'row' },
                isEditing && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-4 col-xlg-3' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(edit_name, {
                        boardId: boardId,
                        name: name,
                        onDone: onDone,
                        onNameChange: onNameChange
                    })
                ),
                !isEditing && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    null,
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'flex-row flex-space-between flex-align-items-center flex-wrap margin-bottom-2x ' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'h2',
                                {
                                    className: 'trip-board-details__header-title',
                                    'data-wdio': 'tripboard-details__title'
                                },
                                name
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, viewer: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'flex-align-center flex-align-items-center flex-end flex-row padding-top-1x' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'div',
                                        { className: 'view-button' },
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_share_button, { boardId: boardId })
                                    )
                                )
                            ),
                            showEmptyStateSearch && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, collaborator: true, owner: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'flex-align-center flex-align-items-center flex-end flex-row' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_collaborator_display, { users: users }),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_share_button, {
                                        boardId: boardId,
                                        endDate: endDate,
                                        startDate: startDate,
                                        type: collaboratorType
                                    })
                                )
                            )
                        )
                    )
                )
            )
        );
    };

    return EditHeader;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

// Redux wrapper
header_with_edit_state_EditHeader.defaultProps = {
    boardId: null,
    collaboratorType: '',
    name: '',
    rename: function rename() {},
    role: ROLES.VIEWER
};
var header_with_edit_state_mapDispatchToProps = {
    rename: tripboard_actions.renameTripboard
};

// Graphql wrapper
var EditHeaderWithGraphql = with_rename_tripboard(header_with_edit_state_EditHeader);

// toggle will switch between redux / graphql as our source of truth
/* harmony default export */ var header_with_edit_state = (EditHeaderWithGraphql);
// EXTERNAL MODULE: ./node_modules/@homeaway/react-google-maps/lib/transpiled/index.js
var react_google_maps_lib_transpiled = __webpack_require__("lVWM");
var react_google_maps_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_google_maps_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-simple-image-carousel/lib/transpiled/index.js
var react_simple_image_carousel_lib_transpiled = __webpack_require__("IAED");
var react_simple_image_carousel_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_simple_image_carousel_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-map-carousel.js
var listing_map_carousel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function listing_map_carousel__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function listing_map_carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function listing_map_carousel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function listing_map_carousel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var listing_map_carousel_ListingMapCarousel = function (_Component) {
    listing_map_carousel__inherits(ListingMapCarousel, _Component);

    function ListingMapCarousel(props) {
        listing_map_carousel__classCallCheck(this, ListingMapCarousel);

        var _this = listing_map_carousel__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onCarouselHitClick = function () {
            var _this$props = _this.props,
                detailPageUrl = _this$props.detailPageUrl,
                target = _this$props.target,
                onClick = _this$props.onClick,
                stay = _this$props.stay;

            var _ref = stay || {},
                dateRange = _ref.dateRange;

            var _ref2 = dateRange || {},
                arrival = _ref2.arrival,
                departure = _ref2.departure;

            var url = getListingUrl(detailPageUrl, arrival, departure);
            onClick();
            window.open(url, target);
        };

        _this.onImageNavigateNext = function (index) {
            tripboard_edap.carouselHitArrowClick('next');
            _this.setState({ imageIndex: index });
            _this.props.updateCarouselState(_this.state.imageIndex, _this.state.imageTotal);
        };

        _this.onImageNavigateBack = function (index) {
            tripboard_edap.carouselHitArrowClick('back');
            _this.setState({ imageIndex: index });
            _this.props.updateCarouselState(_this.state.imageIndex, _this.state.imageTotal);
        };

        _this.state = {
            imageIndex: 0,
            imageTotal: 0
        };
        return _this;
    }

    ListingMapCarousel.prototype.render = function render() {
        var lowResImages = this.props.images.map(function (_ref3) {
            var lowResSrc = _ref3.src,
                src = _ref3.lowResSrc,
                rest = listing_map_carousel__objectWithoutProperties(_ref3, ['src', 'lowResSrc']);

            return listing_map_carousel__extends({ src: src, lowResSrc: lowResSrc }, rest);
        });

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_simple_image_carousel_lib_transpiled_default.a, {
            images: lowResImages,
            index: this.state.imageIndex,
            transitionStyle: 'slide',
            transitionDuration: 250,
            onNextClick: this.onImageNavigateNext,
            onPrevClick: this.onImageNavigateBack,
            onClick: this.onCarouselHitClick
        });
    };

    return ListingMapCarousel;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var listing_map_carousel = (listing_map_carousel_ListingMapCarousel);
// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-collaboration.less
var listing_collaboration = __webpack_require__("t5lc");
var listing_collaboration_default = /*#__PURE__*/__webpack_require__.n(listing_collaboration);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-collaboration.js
var listing_collaboration__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function listing_collaboration__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var listing_collaboration_ListingCollaboration = function ListingCollaboration(props) {
    var stay = props.stay,
        listingId = props.listingId,
        tripBoardUuid = props.tripBoardUuid,
        rest = listing_collaboration__objectWithoutProperties(props, ['stay', 'listingId', 'tripBoardUuid']);

    var _ref = stay || {},
        dateRange = _ref.dateRange;

    var _ref2 = dateRange || {},
        arrival = _ref2.arrival,
        departure = _ref2.departure;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'listing-collaboration' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tripboard_votes_votes, {
            className: 'listing-collaboration__votes',
            endDate: departure,
            listingId: listingId,
            tripBoardUuid: tripBoardUuid,
            startDate: arrival,
            useSmallButton: true,
            sm: true
        }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_comments_icon, listing_collaboration__extends({
            boardId: tripBoardUuid,
            listingId: listingId,
            isSmall: true
        }, rest))
    );
};

/* harmony default export */ var listing_listing_collaboration = (listing_collaboration_ListingCollaboration);
// EXTERNAL MODULE: ./src/universal/tripboard/listing/listing-hit.less
var listing_hit = __webpack_require__("lIME");
var listing_hit_default = /*#__PURE__*/__webpack_require__.n(listing_hit);

// CONCATENATED MODULE: ./src/universal/tripboard/listing/listing-hit.js
function listing_hit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function listing_hit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function listing_hit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* istanbul ignore file */











var listing_hit_ASPECT_RATIO_4X3 = '4x3';

var listing_hit_ListingHit = function (_Component) {
    listing_hit__inherits(ListingHit, _Component);

    function ListingHit(props) {
        listing_hit__classCallCheck(this, ListingHit);

        var _this = listing_hit__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleHitClick = function () {
            var _this$props = _this.props,
                boardId = _this$props.boardId,
                unitUuid = _this$props.unitUuid,
                images = _this$props.images;

            var imageCount = images.length;
            tripboard_edap.mapPropertyClicked(boardId, _this.state.carouselIndex, imageCount, unitUuid);
        };

        _this.updateCarouselState = function (index) {
            _this.setState({ carouselIndex: index });
        };

        _this.state = {
            carouselIndex: 0
        };
        return _this;
    }

    ListingHit.prototype.render = function render() {
        var _props = this.props,
            _props$aspectRatio = _props.aspectRatio,
            aspectRatio = _props$aspectRatio === undefined ? listing_hit_ASPECT_RATIO_4X3 : _props$aspectRatio,
            averagePrice = _props.averagePrice,
            bathrooms = _props.bathrooms,
            bedrooms = _props.bedrooms,
            className = _props.className,
            _props$showCollaborat = _props.showCollaborationToolbar,
            showCollaborationToolbar = _props$showCollaborat === undefined ? false : _props$showCollaborat,
            detailPageUrl = _props.detailPageUrl,
            edapEventJson = _props.edapEventJson,
            images = _props.images,
            isMobile = _props.isMobile,
            priceSummary = _props.priceSummary,
            sleeps = _props.sleeps,
            status = _props.status,
            stay = _props.stay;


        var target = isMobile ? '_self' : '_blank';

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'listing-hit ' + (className || '') },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                react_aspect_ratio_card_lib_transpiled["AspectRatioCard"],
                { aspectRatio: aspectRatio, hasHover: false, hasHoverOverlay: false },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_map_carousel, {
                    'data-slot': 'figure',
                    detailPageUrl: detailPageUrl,
                    images: images,
                    onClick: this.handleHitClick,
                    stay: stay,
                    target: target,
                    isMobile: isMobile,
                    updateCarouselState: this.updateCarouselState
                }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    listing_url,
                    {
                        'data-slot': 'caption',
                        detailPageUrl: detailPageUrl,
                        onClick: this.handleHitClick,
                        stay: stay,
                        target: target
                    },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_rooms, {
                        bathrooms: bathrooms,
                        bedrooms: bedrooms,
                        className: 'AspectRatioCardTitle h4 text-bold text-ha-gray-dark',
                        sleeps: sleeps
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { 'data-slot': 'content' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        listing_url,
                        {
                            detailPageUrl: detailPageUrl,
                            onClick: this.handleHitClick,
                            stay: stay,
                            target: target
                        },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_price, {
                            averagePrice: averagePrice,
                            edapEventJson: edapEventJson,
                            priceSummary: priceSummary,
                            stay: stay,
                            status: status
                        })
                    ),
                    showCollaborationToolbar && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_collaboration, this.props)
                )
            )
        );
    };

    return ListingHit;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var listing_listing_hit = (react_determine_if_mobile_lib_transpiled_default()(listing_hit_ListingHit));
// CONCATENATED MODULE: ./src/universal/tripboard/listings-map/map-marker.js
var map_marker__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function map_marker__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable no-undef */






var HA_CORE_BLUE = '#0067db';

function mapPin() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    /* istanbul ignore next */
    var fillColor = props && props.fillColor || HA_CORE_BLUE;
    /* istanbul ignore next */
    var strokeColor = props && props.strokeColor || '#FFF';
    /* istanbul ignore next */
    return {
        anchor: new google.maps.Point(27, 32),
        path: 'M 26.93,32.18 C 26.37,31.37 25.82,30.54 25.29,29.72 24.03,27.79 22.82,25.82 21.68,23.83 21.01,22.67 20.37,21.49 19.77,20.30 17.68,16.26 16.50,13.07 16.50,11.10 16.50,5.24 21.24,0.50 27.10,0.50 32.95,0.50 37.69,5.24 37.69,11.10 37.69,13.07 36.51,16.26 34.43,20.33 33.81,21.52 33.16,22.70 32.49,23.82 31.35,25.82 30.12,27.81 28.89,29.71 28.46,30.37 28.06,30.97 27.70,31.51 27.70,31.51 27.25,32.17 27.25,32.17 27.13,32.34 27.06,32.34 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.93,32.18 26.93,32.18 Z M 26.93,32.18 C 26.37,31.37 25.82,30.54 25.29,29.72 24.03,27.79 22.82,25.82 21.68,23.83 21.01,22.67 20.37,21.49 19.77,20.30 17.68,16.26 16.50,13.07 16.50,11.10 16.50,5.24 21.24,0.50 27.10,0.50 32.95,0.50 37.69,5.24 37.69,11.10 37.69,13.07 36.51,16.26 34.43,20.33 33.81,21.52 33.16,22.70 32.49,23.82 31.35,25.82 30.12,27.81 28.89,29.71 28.46,30.37 28.06,30.97 27.70,31.51 27.70,31.51 27.25,32.17 27.25,32.17 27.13,32.34 27.06,32.34 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.93,32.18 26.93,32.18 Z',
        fillColor: fillColor,
        fillOpacity: 1,
        strokeColor: strokeColor
    };
}

function MapMarker(_ref) {
    var icon = _ref.icon,
        listing = _ref.listing,
        map = _ref.map,
        onClick = _ref.onClick,
        showOverlay = _ref.showOverlay,
        user = _ref.user,
        rest = map_marker__objectWithoutProperties(_ref, ['icon', 'listing', 'map', 'onClick', 'showOverlay', 'user']);

    var _ref2 = listing || {},
        geoCode = _ref2.geoCode,
        unitUuid = _ref2.unitUuid;

    var _ref3 = geoCode || {},
        latitude = _ref3.latitude,
        longitude = _ref3.longitude;

    var _ref4 = user || {},
        _ref4$role = _ref4.role;

    _ref4$role = _ref4$role === undefined ? {} : _ref4$role;
    var _ref4$role$type = _ref4$role.type,
        roleType = _ref4$role$type === undefined ? '' : _ref4$role$type;

    var showCollaborationToolbar = roleType === ROLES.COLLABORATOR || roleType === ROLES.OWNER;
    var pixelOffset = new google.maps.Size(-130, showCollaborationToolbar ? -352 : -315);
    var handleClick = function handleClick(e) {
        if (onClick) {
            onClick(e, { unitUuid: unitUuid });
        }
    };
    if (!latitude) {
        return null;
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        react_google_maps_lib_transpiled["Marker"],
        map_marker__extends({}, rest, {
            icon: icon,
            id: unitUuid,
            map: map,
            onClick: handleClick // eslint-disable-line react/jsx-no-bind
            , position: {
                lat: latitude,
                lng: longitude
            }
        }),
        showOverlay && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_google_maps_lib_transpiled["Overlay"],
            { map: map, pixelOffset: pixelOffset },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_listing_hit, map_marker__extends({
                showCollaborationToolbar: showCollaborationToolbar
            }, listing))
        )
    );
}

/* harmony default export */ var map_marker = (withUser(MapMarker));
// CONCATENATED MODULE: ./src/universal/tripboard/listings-map/listings-map.js
function listings_map__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function listings_map__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function listings_map__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global google */
/* eslint-disable no-undef */






// world search
var DEFAULT_BOUNDS = {
    neLat: 82.12492067499629,
    neLong: 58.172218749999956,
    swLat: -78.48103194080132,
    swLong: -124.99184375000004
};

var getDefaultBounds = function getDefaultBounds() {
    var neLat = DEFAULT_BOUNDS.neLat,
        neLong = DEFAULT_BOUNDS.neLong,
        swLat = DEFAULT_BOUNDS.swLat,
        swLong = DEFAULT_BOUNDS.swLong;

    return new google.maps.LatLngBounds(new google.maps.LatLng(swLat, swLong), new google.maps.LatLng(neLat, neLong));
};

/** @returns {LatLngBounds} */
var getBounds = function getBounds() {
    var listings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (!Array.isArray(listings)) {
        return getDefaultBounds();
    }
    var bounds = null;
    listings.forEach(function (listing) {
        var _ref = listing || {},
            geoCode = _ref.geoCode;

        var _ref2 = geoCode || {},
            latitude = _ref2.latitude,
            longitude = _ref2.longitude;

        if (latitude && longitude) {
            bounds = bounds || new google.maps.LatLngBounds();
            bounds.extend({ lat: latitude, lng: longitude });
        }
    });

    return bounds || getDefaultBounds();
};

var getListings = function getListings(listings) {
    if (!Array.isArray(listings)) {
        return [];
    }
    return listings.filter(function (listing) {
        return listing;
    });
};

/**
 * transform bounds for component
 * @returns {neLat, neLong, swLat, swLong}
 * @todo bounds prop isn't working; having to manually call fitBounds
 * Need to figure out why
 * */
var getTransformedBounds = function getTransformedBounds(bounds) {
    if (!(bounds instanceof google.maps.LatLngBounds)) {
        // world search
        return DEFAULT_BOUNDS;
    }
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();
    return {
        neLat: ne.lat(),
        neLong: ne.lng(),
        swLat: sw.lat(),
        swLong: sw.lng()
    };
};

var listings_map_ListingsMap = function (_Component) {
    listings_map__inherits(ListingsMap, _Component);

    function ListingsMap(props) {
        listings_map__classCallCheck(this, ListingsMap);

        var _this = listings_map__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleMarkerClick = function (e, listing) {
            var boardId = _this.props.boardId;

            var _ref3 = listing || {},
                unitUuid = _ref3.unitUuid;

            _this.setState({ overlay: unitUuid || null });
            tripboard_edap.mapMarkerClicked(boardId, unitUuid);
        };

        _this.onClick = function () {
            var boardId = _this.props.boardId;

            _this.resetOverlay();
            tripboard_edap.mapInteraction(boardId, 'map.click');
        };

        _this.onDragEnd = function () {
            var boardId = _this.props.boardId;

            tripboard_edap.mapInteraction(boardId, 'dragged');
        };

        _this.onZoomChanged = function () {
            var boardId = _this.props.boardId;

            _this.resetOverlay();
            tripboard_edap.mapInteraction(boardId, 'zoom');
        };

        _this.resetOverlay = function () {
            _this.setState({ overlay: null });
        };

        _this.googleMapRef = null;
        _this.googleMap = null;
        _this.state = {
            bounds: null,
            icon: null,
            listings: getListings(props.listings),
            overlay: null,
            transformedBounds: null,
            zoom: null
        };
        return _this;
    }

    ListingsMap.prototype.componentWillMount = function componentWillMount() {
        var listings = this.state.listings;

        var bounds = getBounds(listings);
        var transformedBounds = getTransformedBounds(bounds);
        var icon = mapPin();
        // must set zoom to null so the component doesn't override our bounds calculations
        var zoom = listings && listings.length === 1 ? 13 : null;
        this.setState({ bounds: bounds, icon: icon, transformedBounds: transformedBounds, zoom: zoom });
    };

    ListingsMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var listings = getListings(nextProps.listings);
        this.setState({ listings: listings });
    };

    ListingsMap.prototype.render = function render() {
        var _this2 = this;

        var _state = this.state,
            icon = _state.icon,
            listings = _state.listings,
            overlay = _state.overlay,
            transformedBounds = _state.transformedBounds,
            zoom = _state.zoom;
        var boardId = this.props.boardId;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_google_maps_lib_transpiled["GoogleMap"],
            {
                bounds: transformedBounds,
                containerElement: reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('div', { className: 'listing-map', style: { height: '100%' } }),
                onClick: this.onClick,
                onDragEnd: this.onDragEnd,
                onMapLoad: this.onMapLoad,
                onZoomChanged: this.onZoomChanged,
                options: {
                    backgroundColor: '#f1f3f5',
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    styles: [{
                        featureType: 'poi',
                        elementType: 'all',
                        stylers: [{
                            visibility: 'on'
                        }]
                    }]
                },
                ref: function ref(map) {
                    return _this2.googleMapRef = map;
                },
                zoom: zoom
            },
            listings && listings.map(function (listing) {
                /* istanbul ignore next */
                if (!listing) {
                    return null;
                }
                var unitUuid = listing.unitUuid;

                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(map_marker, {
                    boardId: boardId,
                    icon: icon,
                    key: unitUuid,
                    listing: listing,
                    onClick: _this2.handleMarkerClick,
                    showOverlay: unitUuid === overlay
                });
            })
        );
    };

    return ListingsMap;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

/* harmony default export */ var listings_map = (with_auth(Object(react_google_maps_lib_transpiled["injectMap"])(listings_map_ListingsMap)));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/no-listings-search.js



var no_listings_search_NoListingsSearch = function NoListingsSearch(_ref) {
    var boardCheckIn = _ref.boardCheckIn,
        boardCheckOut = _ref.boardCheckOut,
        _ref$adultsCount = _ref.adultsCount,
        adultsCount = _ref$adultsCount === undefined ? 2 : _ref$adultsCount,
        _ref$childrenCount = _ref.childrenCount,
        childrenCount = _ref$childrenCount === undefined ? 0 : _ref$childrenCount,
        _ref$petIncluded = _ref.petIncluded,
        petIncluded = _ref$petIncluded === undefined ? false : _ref$petIncluded,
        boardId = _ref.boardId,
        isMobile = _ref.isMobile,
        locale = _ref.locale,
        role = _ref.role,
        siteName = _ref.siteName,
        edapSearchType = _ref.edapSearchType;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-details__empty-search' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(search_box_wrapper, {
            boardId: boardId,
            arrival: boardCheckIn,
            departure: boardCheckOut,
            edapActionLocation: edapSearchType,
            guests: { adultsCount: adultsCount, childrenCount: childrenCount, petIncluded: petIncluded },
            isMobile: isMobile,
            locale: locale,
            role: role,
            siteName: siteName,
            searchTextTitle: 'tripboards.details.empty.search.title',
            searchTextDesktop: 'tripboards.details.empty.search.desktop',
            searchTextMobile: 'tripboards.details.empty.search.mobile'
        })
    );
};

no_listings_search_NoListingsSearch.defaultProps = {
    isMobile: false,
    boardId: null,
    role: null,
    boardCheckIn: null,
    boardCheckOut: null
};

/* harmony default export */ var no_listings_search = (no_listings_search_NoListingsSearch);
// EXTERNAL MODULE: ./src/universal/tripboard/details/components/details.less
var details = __webpack_require__("T5L2");
var details_default = /*#__PURE__*/__webpack_require__.n(details);

// CONCATENATED MODULE: ./src/universal/tripboard/details/components/private-search.js










var private_search_onClick = function onClick(boardId, role, dated, edapActionLocation) {
    return function () {
        tripboard_edap.tripboardSearch(boardId, role, dated, edapActionLocation);
    };
};

var private_search_PrivateSearch = function PrivateSearch(_ref) {
    var boardCheckIn = _ref.boardCheckIn,
        boardCheckOut = _ref.boardCheckOut,
        _ref$adultsCount = _ref.adultsCount,
        adultsCount = _ref$adultsCount === undefined ? 2 : _ref$adultsCount,
        _ref$childrenCount = _ref.childrenCount,
        childrenCount = _ref$childrenCount === undefined ? 0 : _ref$childrenCount,
        _ref$petIncluded = _ref.petIncluded,
        petIncluded = _ref$petIncluded === undefined ? false : _ref$petIncluded,
        boardId = _ref.boardId,
        locale = _ref.locale,
        role = _ref.role,
        siteName = _ref.siteName,
        edapSearchType = _ref.edapSearchType,
        places = _ref.places,
        numPlaces = _ref.numPlaces,
        searchBoxVariant = _ref.searchBoxVariant;

    if (searchBoxVariant === 0 || places.length <= 0) {
        return null;
    }
    var searchTextTitle = 'tripboards.search.prompt';
    var topPlace = places && places[0] && places[0].full;
    if (searchBoxVariant === 2) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-details__private-search' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(search_box_wrapper, {
                boardId: boardId,
                arrival: boardCheckIn,
                departure: boardCheckOut,
                destination: topPlace,
                edapActionLocation: edapSearchType,
                guests: { adultsCount: adultsCount, childrenCount: childrenCount, petIncluded: petIncluded },
                locale: locale,
                role: role,
                siteName: siteName,
                searchTextTitle: searchTextTitle,
                preferStayProps: true
            })
        );
    }
    var numberPlaces = Math.min(numPlaces, places.length);
    var topNPlaces = places.slice(0, numberPlaces);
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-details__private-search-badges' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'search-box__copy' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                { className: 'search-box__title' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(index_es["FormattedHTMLMessage"], { id: searchTextTitle, defaultMessage: '', description: 'search title text' })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'private-search-badges__button-row' },
            topNPlaces.map(function (place) {
                var placeUrl = toURL({
                    arrival: boardCheckIn,
                    departure: boardCheckOut,
                    searchTermUuid: encodeURIComponent(place.uuid),
                    adultsCount: adultsCount,
                    childrenCount: childrenCount,
                    petIncluded: petIncluded
                });
                var label = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
                    null,
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], { markup: esm["SEARCH__16"] }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'span',
                        null,
                        place.simple
                    )
                );
                return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_buttons_lib_transpiled["Button"], {
                    onClick: private_search_onClick(boardId, role, boardCheckIn && boardCheckOut, edapSearchType),
                    key: place.full,
                    href: placeUrl,
                    size: 'xs',
                    target: '_blank',
                    label: label
                });
            })
        )
    );
};

private_search_PrivateSearch.defaultProps = {
    isMobile: false,
    boardId: null,
    role: null,
    boardCheckIn: null,
    boardCheckOut: null,
    abacus: {},
    places: [],
    numPlaces: 0,
    searchBoxVariant: 0
};

/* harmony default export */ var private_search = (private_search_PrivateSearch);
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/no-listings-graphic.js



function NoListingsGraphic() {
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'trip-board-details__is-empty' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'svg',
            { className: 'trip-board-details__svg__is-empty', viewBox: '0 0 447 298' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'title',
                null,
                'cabin-blue'
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'defs',
                null,
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'a', x1: '50.002%', x2: '50.002%', y1: '-57.649%', y2: '193.354%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#7400FF', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#7400FF', stopOpacity: '0', offset: '47%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'b', x1: '49.955%', x2: '49.955%', y1: '114.685%', y2: '-94.298%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', stopOpacity: '0', offset: '59%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'c', x1: '49.996%', x2: '49.996%', y1: '-57.723%', y2: '193.321%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#7400FF', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#7400FF', stopOpacity: '0', offset: '47%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'd', x1: '49.984%', x2: '49.984%', y1: '114.719%', y2: '-94.108%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', stopOpacity: '0', offset: '59%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'e', x1: '.034%', x2: '99.966%', y1: '49.992%', y2: '49.992%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#3385E2', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CC2FF', offset: '100%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'f', x1: '-.021%', x2: '99.974%', y1: '50.006%', y2: '50.006%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#00A0FF', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#FFF', offset: '100%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'g', x1: '50.121%', x2: '50.121%', y1: '114.703%', y2: '-94.057%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', stopOpacity: '0', offset: '59%' })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'linearGradient',
                    { id: 'h', x1: '50.143%', x2: '50.143%', y1: '114.682%', y2: '-94.083%' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', offset: '0%' }),
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('stop', { stopColor: '#5CDEAB', stopOpacity: '0', offset: '59%' })
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', transform: 'translate(-2)' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#a)', fillRule: 'nonzero', d: 'M289 245L247.1 88.9c-4.7-17.5-22.7-27.9-40.3-23.2-5.7 1.5-11 4.6-15.1 8.9l-34.5 35.7c-4.5 4.6-11.9 4.8-16.5.3-.2-.2-.4-.4-.6-.7L88.7 51.6c-6.3-7.1-17.1-7.8-24.2-1.5-2.6 2.3-4.4 5.2-5.2 8.5L10.5 245H289z', opacity: '.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M101.3 243.7h-4.5l2.3-144.4' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#b)', fillRule: 'nonzero', d: 'M106.2 221.2c-14.5 9.6-38-18.1-27.4-34.1 12.3-18.7-13.3-24.4-13.1-44.3 0-12.7 13.3-9.8 19.7-16.8 6.4-7-8.1-37.9 11.4-37 12.7.6 19.9 33.5 27.1 39.4 25.6 21.1-13.8 23.2-13.8 41.2 0 9.3 24.7 32.5-3.9 51.6z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#c)', fillRule: 'nonzero', d: 'M164.8 162.6l30.4-42.9c13.8-19.5 40.1-25.6 61.1-14.2l2.2 1.2c20.7 11.3 46.7 5.5 60.6-13.5l33.6-45.7c6.9-9.3 20-11.3 29.4-4.5 3.5 2.6 6.1 6.2 7.5 10.4L440 207.8s-209.1 8.8-220.6 9.1c-11.5.3-54.6-54.3-54.6-54.3z', opacity: '.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('circle', { cx: '149', cy: '58.9', r: '58.9', fill: '#FFE399', fillRule: 'nonzero', opacity: '.1' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('circle', { cx: '149', cy: '58.9', r: '27', fill: '#FFE399', fillRule: 'nonzero', opacity: '.6' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M360.3 286.1h-4.5l2.3-144.3' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#d)', fillRule: 'nonzero', d: 'M365.1 263.6c-14.5 9.6-38-18.1-27.4-34.1 12.3-18.7-13.3-24.4-13.1-44.3.1-12.7 13.4-9.8 19.8-16.9 6.4-7.1-8.1-37.9 11.4-37 12.7.6 19.9 33.5 27.1 39.4 25.6 21.1-13.9 23.2-13.9 41.2 0 9.5 24.7 32.7-3.9 51.7z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { stroke: '#5CC2FF', d: 'M363.7 213.6h41.2m-41.2-5h41.2m-41.2-5h41.2m-41.2-5h41.2m-41.2-5h41.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M393.5 220.2l-44.1 44.2 3.5 3.5 47.9-48' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M408.2 218.4h-42.9v5h42.9' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M403.2 191.8v31.4h5v-31.4' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#e)', fillRule: 'nonzero', d: 'M172.6 272.6H56.1V161.8l116.5-22.5' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#f)', fillRule: 'nonzero', d: 'M365.3 292.1H172.6V149.3l192.8-37.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M103.5 162.3h21.8v40.4h-21.8z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M123.2 164.3v36.4h-17.8v-36.4h17.8zm4-4h-25.8v44.4h25.8v-44.4zm65.4 46.2h21.8v55.1h-21.8z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M212.4 208.5v51.1h-17.8v-51.1h17.8zm4-4h-25.8v59.1h25.8v-59.1z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M246.4 148.1v-1l19.3-3.8v4.8' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M263.7 145.7v.4h-2l2-.4zm4-4.9l-23.3 4.6v4.7h23.3v-9.3z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M305.9 148.1v-12.6l19.3-3.7v16.3' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M323.2 134.2v11.9h-15.3v-8.9l15.3-3zm4-4.8l-23.3 4.5v16.2h23.3v-20.7z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M334.1 148.1v-18l19.3-3.7v21.7' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M351.4 128.9v17.2h-15.3v-14.4l15.3-2.8zm4-4.9l-23.3 4.4v21.7h23.3V124z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M274.7 148.1V141l19.2-3.2v10.3' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M291.9 140.1v6h-15.3v-3.4l15.3-2.6zm4-4.7l-23.3 4v10.7h23.3v-14.7z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M174.6 162.1h57.9v30.4h-57.9z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M230.4 164.1v26.4h-53.9v-26.4h53.9zm4-4h-61.9v34.4h61.9v-34.4z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M246.4 162.1h47.5v54.2h-47.5z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M291.9 164.1v50.2h-43.5v-50.2h43.5zm4-4h-51.5v58.2h51.5v-58.2z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M305.9 162.1h47.5v54.2h-47.5z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FAFAFA', fillRule: 'nonzero', d: 'M351.4 164.1v50.2h-43.5v-50.2h43.5zm4-4h-51.5v58.2h51.5v-58.2z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M365.2 107.2l-192.6 37.1v10l192.8-37.2', opacity: '.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M172.3 255.9h62.4v36.2h-62.4zm208-156.6l-207.7 40v10l207.7-40.1' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M172.6 132v141.7c.5-.1 10 0 10 0V132h-10zm71.8 106.2h111c-.1-.5 0-10 0-10h-111v10z', opacity: '.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M56.1 166.7l134.2-25.8-.3-9.9-133.9 25.8', opacity: '.2' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M190 126L37.4 155.4v10l152.9-29.5' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M35.6 242h4.9L38 82.1' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#g)', fillRule: 'nonzero', d: 'M30.2 217c16 10.7 42-20.1 30.3-37.8-13.7-20.7 14.7-27 14.5-49-.1-14.1-14.8-10.8-21.9-18.7-7.1-7.9 9-41.9-12.7-41-14 .6-22 37.1-30 43.7-28.2 23.4 15.5 25.8 15.5 45.8 0 10.3-27.3 36 4.3 57z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { stroke: '#5CC2FF', strokeWidth: '2', d: 'M246.9 213.6h106m-106-5h106m-106-5h106m-106-5h106m-106-5h106' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M355.4 218.2h-111c.1.5 0 10 0 10h111v-10z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M321.3 223.2v32.7h5v-32.7m6.6 0v32.7h5v-32.7m-76 0v32.7h5v-32.7m6.6 0v32.7h5v-32.7m-34.1-35v40h5v-40m100.9 0v40h5v-40m-120.6 72.7h45.8v31.2h-45.8zm45.8 5h45.8v26.2h-45.8zm45.8 4.9h45.8V292h-45.8zm45.8 5h45.8V292h-45.8z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#FFF', fillRule: 'nonzero', d: 'M5.6 238.2c90.6-12.6 169.4 23.3 236.3 37.6 51.6 11 111.3-8.2 206.3 14.9v6.8l-433-3-9.6-56.3z' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { stroke: '#3385E2', strokeWidth: '4', d: 'M5.6 238.2c90.6-12.6 169.4 23.3 236.3 37.6 51.6 11 111.3-8.2 206.3 14.9' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: '#3385E2', fillRule: 'nonzero', d: 'M390.5 282.8h5L393 123' }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('path', { fill: 'url(#h)', fillRule: 'nonzero', d: 'M385.2 257.9c16 10.7 42-20.1 30.3-37.8-13.7-20.7 14.7-27 14.5-49-.1-14.1-14.8-10.8-21.9-18.7-7.1-7.9 9-41.9-12.7-41-14 .6-22 37.1-30 43.7-28.3 23.3 15.3 25.7 15.3 45.7.2 10.3-27.2 36 4.5 57.1z' })
            )
        ),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_empty_tripboard_label, null)
    );
}

/* harmony default export */ var no_listings_graphic = (NoListingsGraphic);
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/tab-navigation.js





function Tab(_ref) {
    var icon = _ref.icon,
        langText = _ref.langText;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'span',
        null,
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_svg_lib_transpiled["SVGIcon"], {
            className: 'map-navigation__icon',
            markup: icon
        }),
        langText
    );
}

var tab_navigation_ListTab = function ListTab(_ref2) {
    var langText = _ref2.langText;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Tab, { icon: LISTICON, langText: langText });
};
var tab_navigation_MapTab = function MapTab(_ref3) {
    var langText = _ref3.langText;
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Tab, { icon: MAPICON, langText: langText });
};

function TabNavigation(props) {
    var mapTestValue = props.mapTestValue,
        displayIndex = props.displayIndex,
        translations = props.translations,
        onTabClick = props.onTabClick;


    var navTabClass0 = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('map-navigation__a', {
        'map-navigation__a--active': displayIndex === 0
    });

    var navTabClass1 = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('map-navigation__a', {
        'map-navigation__a--active': displayIndex === 1
    });

    // default variant 1
    var firstButtonText = translations.listText;
    var secondButtonText = translations.mapText;
    var FirstTab = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tab_navigation_ListTab, { langText: firstButtonText });
    var SecondTab = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tab_navigation_MapTab, { langText: secondButtonText });

    // reverse tab order for variant 2
    if (mapTestValue === 2) {
        firstButtonText = translations.mapText;
        secondButtonText = translations.listText;
        FirstTab = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tab_navigation_MapTab, { langText: firstButtonText });
        SecondTab = reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tab_navigation_ListTab, { langText: secondButtonText });
    }

    function handleTabClick(idx) {
        return function () {
            onTabClick(idx);
        };
    }

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        'div',
        { className: 'row' },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'ul',
            { className: 'map-navigation__ul' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'li',
                { className: 'map-navigation__li' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'button',
                    {
                        'aria-label': firstButtonText,
                        onClick: handleTabClick(0),
                        className: navTabClass0
                    },
                    FirstTab
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'li',
                { className: 'map-navigation__li' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'button',
                    {
                        'aria-label': secondButtonText,
                        onClick: handleTabClick(1),
                        className: navTabClass1
                    },
                    SecondTab
                )
            )
        )
    );
}

TabNavigation.defaultProps = {
    mapTestValue: 0,
    displayIndex: 0,
    translations: {}
};

/* harmony default export */ var tab_navigation = (TabNavigation);
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/details.js
var details__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var details__withAbacusTestValues;

function details__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function details__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function details__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










































var details_testExposureCarousel = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_TRIPBOARDS_CAROUSEL_TEST"]);
var testExposureGoogleMap = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_GOOGLE_MAP"]);
var testExposureSimilarProperties = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_SIMILAR_PROPERTIES"]);
var testExposureEmptySearch = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_EMPTY_SEARCH_TEST"]);
var testExposurePublicSearch = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_PUBLIC_SEARCH_TEST"]);
var testExposurePrivateSearch = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_PRIVATE_SEARCH_TEST"]);
var testExposureHeartRemove = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_HEART_REMOVE_TEST"]);
var testExposureGuestContext = new test_exposure_once_TestExposureOnce(experiments["HA_PULSE_GUEST_CONTEXT_TEST"]);
var details_TripboardDetails = function (_Component) {
    details__inherits(TripboardDetails, _Component);

    TripboardDetails.formatTripboardDate = function formatTripboardDate(date) {
        if (!date) {
            return null;
        }
        var formattedDate = date.split('-');
        formattedDate.push(formattedDate.shift());
        return formattedDate.join('/');
    };

    function TripboardDetails(props) {
        details__classCallCheck(this, TripboardDetails);

        var _this = details__possibleConstructorReturn(this, _Component.call(this, props));

        details__initialiseProps.call(_this);

        _this.translations = {
            editText: props.translations['tripboards.main.edit'],
            nameText: props.translations['tripboards.modal.create.name'],
            doneText: props.translations['tripboards.done'],
            cancelText: props.translations['tripboards.cancel'],
            clearDatesText: props.translations['tripboards.date_picker.clear_dates'],
            datesText: props.translations['tripboards.date_picker.dates'],
            favoritesList: props.translations['tripboards.favorites.list'],
            favoritesListShared: props.translations['tripboards.favorites.shared_list'],
            errorTitle: props.translations['th.inbox.error.title'],
            errorMessage: props.translations['th.inbox.error.message'],
            copyText: props.translations['tripboards.copy'],
            copiedText: props.translations['tripboards.copied'],
            shareTitle: props.translations['tripboards.share'],
            shareText: props.translations['tripboards.share.text'],
            mapText: props.translations.mapButton,
            listText: props.translations.backToListButton
        };

        _this.state = {
            displayIndex: 0
        };
        return _this;
    }

    TripboardDetails.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.loadingState.isSuccess && !prevProps.loadingState.isSuccess) {
            var _props = this.props,
                setCurrentTripboard = _props.setCurrentTripboard,
                completeTripboardCreation = _props.completeTripboardCreation,
                boardId = _props.boardId,
                endDate = _props.endDate,
                listings = _props.listings,
                startDate = _props.startDate,
                role = _props.role,
                places = _props.places;
            // Fire edap event as we have successfully completed data fetch

            tripboard_edap.detailsLoad(boardId, endDate, listings.length, startDate);
            tripboard_edap.tripboardsView(boardId, role);
            var roleLowerCase = role.toLowerCase();
            setCurrentTripboard(boardId);
            completeTripboardCreation();
            if (listings && listings.length > 0) {
                if (!places || places.length === 0) {
                    tripboard_edap.placesError(boardId, places);
                }
                details_testExposureCarousel.trigger(experiments["HA_PULSE_TRIPBOARDS_CAROUSEL_TEST"]);
                testExposureGoogleMap.trigger(experiments["HA_PULSE_GOOGLE_MAP"]);
                testExposureSimilarProperties.trigger(experiments["HA_PULSE_SIMILAR_PROPERTIES"]);
                if (roleLowerCase === constants.VIEWER) {
                    testExposurePublicSearch.trigger(experiments["HA_PULSE_PUBLIC_SEARCH_TEST"]);
                } else if (roleLowerCase === constants.OWNER || roleLowerCase === constants.COLLABORATOR) {
                    testExposurePrivateSearch.trigger(experiments["HA_PULSE_PRIVATE_SEARCH_TEST"]);
                    testExposureHeartRemove.trigger(experiments["HA_PULSE_HEART_REMOVE_TEST"]);
                    testExposureGuestContext.trigger(experiments["HA_PULSE_GUEST_CONTEXT_TEST"]);
                }
            } else {
                testExposureEmptySearch.trigger(experiments["HA_PULSE_EMPTY_SEARCH_TEST"]);
            }
        }
        this.par(this.props);
    };

    // Start Abacus: ha_pulse_shared_tripboard_ab_test

    // End Abacus: ha_pulse_shared_tripboard_ab_test

    // Start Abacus: ha_pulse_tripboards_carousel_test

    // End Abacus: ha_pulse_tripboards_carousel_test

    // Start Abacus: ha_pulse_remove_heart_test

    // End Abacus: ha_pulse_remove_heart_test

    // Using ha_pulse_remove_back_button_test as a toggle for this feature


    // Start Abacus: ha_pulse_shared_tripboard_ab_test

    // End Abacus: ha_pulse_shared_tripboard_ab_test

    TripboardDetails.prototype.render = function render() {
        var _props2 = this.props,
            adultsCount = _props2.adultsCount,
            boardId = _props2.boardId,
            childrenCount = _props2.childrenCount,
            currency = _props2.currency,
            emptySearchTestValue = _props2.emptySearchTestValue,
            endDate = _props2.endDate,
            guestContextTestValue = _props2.guestContextTestValue,
            listings = _props2.listings,
            listingIds = _props2.listingIds,
            isShared = _props2.isShared,
            loadingState = _props2.loadingState,
            locale = _props2.locale,
            name = _props2.name,
            petsIncluded = _props2.petsIncluded,
            publicSearchTestValue = _props2.publicSearchTestValue,
            privateSearchTestValue = _props2.privateSearchTestValue,
            places = _props2.places,
            role = _props2.role,
            refetchTripboard = _props2.refetchTripboard,
            siteName = _props2.siteName,
            startDate = _props2.startDate,
            sharedTestValue = _props2.sharedTestValue,
            similarPropertiesTestValue = _props2.similarPropertiesTestValue,
            mapTestValue = _props2.mapTestValue,
            user = _props2.user,
            users = _props2.users;


        var isSimilarPropertytestOn = similarPropertiesTestValue > 0;
        var isEmptySearchTestOn = emptySearchTestValue > 0;
        var isPublicSearchTestOn = publicSearchTestValue > 0;
        var isPrivateSearchTestOn = privateSearchTestValue > 0;
        var isGuestContextTestOn = guestContextTestValue > 0;

        if (loadingState.isNotFound) {
            return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Redirect"], { to: universal_routes.TRIPBOARD });
        }

        var collaboratorType = user && user.isViewer ? CollaborateType.SHARE : CollaborateType.INVITE;

        // Start Abacus: ha_pulse_shared_tripboard_ab_test
        var contentRowClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('row', {
            'remove-container-padding grey-background': sharedTestValue === 2
        });

        var contentRowClassPlusPadding = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()(contentRowClass, 'row--padded');

        var contentColClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('col-lg-10 col-lg-offset-1', {
            'trip-board-details__content': sharedTestValue === 2,
            'with-loading-overlay': true
        });

        var headerRowClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('row header-container', {
            'share-var-2 remove-container-padding': sharedTestValue === 2
        });

        // End Abacus: ha_pulse_shared_tripboard_ab_test
        var showEmptyStateSearch = loadingState.isSuccess && listings.length === 0 && isEmptySearchTestOn;
        var translations = this.translations;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-details__container' },
            boardId && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(activity_indicator_seen, { boardId: boardId }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                components_error_boundary,
                null,
                boardId && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_accept, { boardId: boardId, endDate: endDate, startDate: startDate }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: headerRowClass },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'col-lg-10 col-lg-offset-1' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            components_permissions,
                            { role: role, viewer: true },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_tripboard_banner, null)
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'trip-board-details__header' },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                { className: 'row' },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(favorites_message, { isShared: isShared })
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(header_with_edit_state, {
                                boardId: boardId,
                                collaboratorType: collaboratorType,
                                endDate: endDate,
                                listings: listings,
                                name: name,
                                role: role,
                                startDate: startDate,
                                users: users,
                                showEmptyStateSearch: showEmptyStateSearch
                            }),
                            !showEmptyStateSearch && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, collaborator: true, owner: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(stay_context_container, {
                                        adultsCount: adultsCount,
                                        boardId: boardId,
                                        childrenCount: childrenCount,
                                        endDate: endDate,
                                        locale: locale,
                                        petsIncluded: petsIncluded,
                                        startDate: startDate,
                                        isGuestContextTestOn: isGuestContextTestOn,
                                        currency: currency,
                                        refetchTripboard: refetchTripboard
                                    }),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'div',
                                        { className: 'col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xlg-8 text-right' },
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                            'div',
                                            { className: 'flex-align-center flex-align-items-center flex-end flex-row padding-top-1x' },
                                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_collaborator_display, { users: users }),
                                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_share_button, {
                                                boardId: boardId,
                                                endDate: endDate,
                                                startDate: startDate,
                                                type: collaboratorType
                                            })
                                        )
                                    )
                                )
                            ),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                                null,
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_share_modal, {
                                    boardId: boardId,
                                    endDate: endDate,
                                    listings: listings,
                                    name: name,
                                    role: role,
                                    startDate: startDate
                                })
                            )
                        ),
                        mapTestValue > 0 && loadingState.isSuccess && listings.length > 0 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tab_navigation, {
                            mapTestValue: mapTestValue,
                            translations: translations,
                            onTabClick: this.onTabClick,
                            displayIndex: this.state.displayIndex
                        })
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: contentRowClass },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: contentColClass },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_loading_overlay_lib_transpiled["LoadingOverlay"], { loading: loadingState.isStart }),
                        loadingState.isError && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_generic_error, null),
                        loadingState.isSuccess && listings.length === 0 && !showEmptyStateSearch && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                            null,
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(PageView_Page, { pagename: PAGE_TRIPBOARD_DETAILS }),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(no_listings_graphic, null)
                        ),
                        showEmptyStateSearch && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                            null,
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(PageView_Page, { pagename: PAGE_TRIPBOARD_DETAILS }),
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, owner: true, collaborator: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(no_listings_search, {
                                    boardCheckIn: startDate,
                                    boardCheckOut: endDate,
                                    boardId: boardId,
                                    locale: locale,
                                    siteName: siteName,
                                    role: role,
                                    translations: translations,
                                    edapSearchType: 'tripboard empty search bar'
                                })
                            )
                        ),
                        loadingState.isSuccess && listings.length > 0 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'trip-board-details__hits' },
                            this.showDetails() && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                                null,
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(PageView_Page, { pagename: PAGE_TRIPBOARD_DETAILS }),
                                listings.map(this.renderHit)
                            ),
                            !this.showDetails() && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                { className: 'trip-board-details__map' },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(PageView_Page, { pagename: PAGE_TRIPBOARD_DETAILS_MAP }),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listings_map, {
                                    boardId: boardId,
                                    channel: GOOGLE_MAPS_CHANNEL_ID,
                                    listings: listings
                                })
                            )
                        )
                    )
                ),
                (isPublicSearchTestOn || isPrivateSearchTestOn) && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'row' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'col-lg-10 col-lg-offset-1' },
                        listings.length !== 0 && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
                            null,
                            isPublicSearchTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, viewer: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(public_search, {
                                    boardCheckIn: startDate,
                                    boardCheckOut: endDate,
                                    boardId: boardId,
                                    locale: locale,
                                    siteName: siteName,
                                    role: role,
                                    translations: translations,
                                    edapSearchType: 'tripboard public search bar'
                                })
                            ),
                            isPrivateSearchTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                components_permissions,
                                { role: role, owner: true, collaborator: true },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(private_search, {
                                    adultsCount: adultsCount,
                                    childrenCount: childrenCount,
                                    petIncluded: petsIncluded,
                                    boardCheckIn: startDate,
                                    boardCheckOut: endDate,
                                    boardId: boardId,
                                    locale: locale,
                                    siteName: siteName,
                                    role: role,
                                    searchBoxVariant: privateSearchTestValue,
                                    numPlaces: 5,
                                    places: places,
                                    edapSearchType: 'tripboard private search bar'
                                })
                            )
                        ),
                        listings.length === 0 && isPublicSearchTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            components_permissions,
                            { role: role, viewer: true },
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(no_listings_search, {
                                boardCheckIn: startDate,
                                boardCheckOut: endDate,
                                boardId: boardId,
                                locale: locale,
                                siteName: siteName,
                                role: role,
                                translations: translations,
                                edapSearchType: 'tripboard public search bar'
                            })
                        )
                    )
                ),
                isSimilarPropertytestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: contentRowClassPlusPadding },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(recommended_properties_provider, {
                        stay: {
                            dateRange: { arrival: startDate, departure: endDate },
                            adultsCount: adultsCount,
                            childrenCount: childrenCount,
                            petsIncluded: petsIncluded
                        },
                        boardId: boardId,
                        listingIds: listingIds,
                        maxProperties: 12
                    })
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_comments_modal, null),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(listing_delete_modal_ListingDeleteModal, { userRole: role, onDelete: this.props.onDelete })
            )
        );
    };

    return TripboardDetails;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

details_TripboardDetails.propTypes = {
    listings: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.shape),
    locale: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string.isRequired,
    renameTripboard: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    onDelete: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func,
    setCurrentTripboard: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.func
};
details_TripboardDetails.defaultProps = {
    listings: [],
    name: '',
    renameTripboard: function renameTripboard() {},
    role: constants.OWNER,
    onDelete: function onDelete() {},
    fetchDetails: function fetchDetails() {},
    setCurrentTripboard: function setCurrentTripboard() {},
    completeTripboardCreation: function completeTripboardCreation() {},
    markPAR: function markPAR() {},
    sharedTestValue: 0,
    mapTestValue: 0,
    removeBackButtonTestValue: 0,
    similarPropertiesTestValue: 0
};

var details__initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.componentDidMount = function () {
        var _props3 = _this2.props,
            setCurrentTripboard = _props3.setCurrentTripboard,
            endDate = _props3.endDate,
            listings = _props3.listings,
            loadingState = _props3.loadingState,
            boardId = _props3.boardId,
            startDate = _props3.startDate;

        if (loadingState.isSuccess && boardId) {
            // Fire edap event as data is already loaded
            tripboard_edap.detailsLoad(boardId, endDate, listings.length, startDate);
            tripboard_edap.tripboardsView(boardId, _this2.props.role);
            setCurrentTripboard(boardId);
        }
        _this2.par(_this2.props);
    };

    this.par = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var loadingState = props.loadingState;
        // PAR definition: When the listings of a tripboard are fully loaded.

        if (!loadingState.isInitial && !loadingState.isStart) {
            _this2.props.markPAR();
        }
    };

    this.isOwner = function () {
        return _this2.props.role.toLowerCase() === constants.OWNER;
    };

    this.isCollaborator = function () {
        return _this2.props.role.toLowerCase() === constants.COLLABORATOR;
    };

    this.isViewer = function () {
        return _this2.props.role.toLowerCase() === constants.VIEWER;
    };

    this.showDetails = function () {
        return _this2.props.mapTestValue < 2 && _this2.state.displayIndex === 0 || _this2.props.mapTestValue === 2 && _this2.state.displayIndex === 1;
    };

    this.onTabClick = function (index) {
        tripboard_edap.mapTabClicked(_this2.props.boardId, _this2.props.mapTestValue, index);
        _this2.setState({ displayIndex: index });
    };

    this.isSharedTestOn = function () {
        var shareButtonToggleValue = _this2.props.shareButtonToggleValue;

        return shareButtonToggleValue > 0;
    };

    this.isCarouselTestOn = function () {
        var carouselTestValue = _this2.props.carouselTestValue;

        return carouselTestValue > 0;
    };

    this.isRemoveHeartTestOn = function () {
        var heartRemoveTestValue = _this2.props.heartRemoveTestValue;

        return heartRemoveTestValue > 0;
    };

    this.hasBackButton = function () {
        var removeBackButtonTestValue = _this2.props.removeBackButtonTestValue;
        // only hide the back button if a VIEWER is looking at the board

        return !_this2.isViewer() || removeBackButtonTestValue === 0;
    };

    this.hasDates = function () {
        var loadingState = _this2.props.loadingState;


        return !loadingState.isError && !_this2.isViewer();
    };

    this.hasDatesInHeader = function () {
        return !_this2.isSharedTestOn() && _this2.hasDates();
    };

    this.hasDatesInBody = function () {
        return _this2.isSharedTestOn() && _this2.hasDates();
    };

    this.hasNameEdit = function () {
        var loadingState = _this2.props.loadingState;


        return !loadingState.isError && !_this2.isViewer();
    };

    this.hasDeleteButton = function () {
        return !_this2.isViewer();
    };

    this.hasTripboardButton = function () {
        return _this2.isViewer();
    };

    this.hasShareModal = function () {
        return _this2.isSharedTestOn();
    };

    this.getHitProps = function (hit, idx, hits) {
        var _props4 = _this2.props,
            boardId = _props4.boardId,
            endDate = _props4.endDate,
            startDate = _props4.startDate,
            heartRemoveTestValue = _props4.heartRemoveTestValue,
            role = _props4.role,
            adultsCount = _props4.adultsCount,
            childrenCount = _props4.childrenCount,
            petsIncluded = _props4.petsIncluded;

        var isDated = !!(startDate && endDate);
        var isHeartRemoveTestOn = heartRemoveTestValue > 0;
        var handleHitClick = function handleHitClick() {
            tripboard_edap.listingClick(boardId, hit.listingId, idx, hits.length);
        };
        var handleDeleteClick = function handleDeleteClick() {
            _this2.props.onDelete(boardId, hit.listingId);
            tripboard_edap.listingDelete(boardId, hit.listingId, idx, hits.length, role);
        };
        var formattedStartDate = details_TripboardDetails.formatTripboardDate(startDate);
        var formattedEndDate = details_TripboardDetails.formatTripboardDate(endDate);
        var urlParts = (hit.detailPageUrl || '').split('?');
        var rawURL = urlParts[0];
        var rawParams = urlParts[1] || '';

        var searchParams = node_modules_query_string_default.a.parse(rawParams);
        if (isDated) {
            searchParams.arrivalDate = formattedStartDate;
            searchParams.departureDate = formattedEndDate;
        } else {
            searchParams.noDates = true;
        }

        if (adultsCount) {
            searchParams.adultsCount = adultsCount;
        }
        if (childrenCount) {
            searchParams.childrenCount = childrenCount;
        }
        if (petsIncluded) {
            searchParams.petsIncluded = petsIncluded;
        }

        var detailPageUrl = rawURL + '?' + node_modules_query_string_default.a.stringify(searchParams);

        // [SCRATCHPAD-1467] temp logging to further debug
        if (!hit.detailPageUrl) {
            logNoListingUrl(boardId, hit.listingId);
        }

        return details__extends({}, hit, {
            galleryUrl: getImageUrl(hit.galleryUrl), // this reconstructs this URL to request c6 (smaller images)
            thumbnailUrl1: getImageUrl(hit.thumbnailUrl1),
            thumbnailUrl2: getImageUrl(hit.thumbnailUrl2),
            thumbnailUrl3: getImageUrl(hit.thumbnailUrl3),
            arrivalDate: _this2.props.startDate,
            departureDate: _this2.props.endDate,
            unit: hit.unitUuid,
            detailPageUrl: detailPageUrl,
            scratchpadId: hit.listingId, // react-hit-scratchpad invokes onClick callback with event + this ID
            gallery: true,
            isDated: isDated,
            showHeadline: true,
            siteDisplayName: _this2.props.siteDisplayName,
            onClick: handleHitClick,
            onDelete: _this2.hasDeleteButton() ? handleDeleteClick : null,
            hasDeleteButton: _this2.hasDeleteButton(),
            hasTripboardButton: _this2.hasTripboardButton(),
            hasCarousel: _this2.isCarouselTestOn(),
            isHeartRemoveTestOn: isHeartRemoveTestOn,
            idx: idx,
            hitTotal: hits.length
        });
    };

    this.renderHit = function (hit, idx, hits) {
        var hitProps = _this2.getHitProps(hit, idx, hits);

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { className: 'trip-board-details__hit', key: hit.listingId },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_Hit, hitProps)
        );
    };
};

/* harmony default export */ var components_details = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(Timing_withPAR, abacus_with_abacus_test_values_as_props((details__withAbacusTestValues = {}, details__withAbacusTestValues[experiments["HA_PULSE_EMPTY_SEARCH_TEST"]] = 'emptySearchTestValue', details__withAbacusTestValues[experiments["HA_PULSE_PUBLIC_SEARCH_TEST"]] = 'publicSearchTestValue', details__withAbacusTestValues[experiments["HA_PULSE_PRIVATE_SEARCH_TEST"]] = 'privateSearchTestValue', details__withAbacusTestValues[experiments["HA_PULSE_GOOGLE_MAP"]] = 'mapTestValue', details__withAbacusTestValues[experiments["HA_PULSE_SHARED_TRIPBOARD_AB_TEST"]] = 'sharedTestValue', details__withAbacusTestValues[experiments["HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE"]] = 'shareButtonToggleValue', details__withAbacusTestValues[experiments["HA_PULSE_TRIPBOARDS_CAROUSEL_TEST"]] = 'carouselTestValue', details__withAbacusTestValues[experiments["HA_PULSE_REMOVE_BACK_BUTTON_TEST"]] = 'removeBackButtonTestValue', details__withAbacusTestValues[experiments["HA_PULSE_SIMILAR_PROPERTIES"]] = 'similarPropertiesTestValue', details__withAbacusTestValues[experiments["HA_PULSE_HEART_REMOVE_TEST"]] = 'heartRemoveTestValue', details__withAbacusTestValues[experiments["HA_PULSE_GUEST_CONTEXT_TEST"]] = 'guestContextTestValue', details__withAbacusTestValues)))(details_TripboardDetails));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/marketing-redirect.js
var marketing_redirect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function getUrl() {
    var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var boardId = arguments[1];

    return route.replace(':boardId', boardId);
}

function isRouteMatch(pathname, path) {
    var isMatch = Object(react_router_es["matchPath"])(pathname, { path: path }) || { isExact: false };
    return isMatch.isExact;
}

/**
 * Redirect container for <TripboardDetails/>.
 * Handles updating the URL for analytics purposes.
 */
function MarketingRedirect(props) {
    var boardId = props.boardId,
        location = props.location,
        match = props.match;

    var pathboardId = match && match.params && match.params.boardId;
    var resolvedBoardId = boardId ? boardId : pathboardId; // if we don't already have the boardId in props from the server-side render for some reason
    var isMarketing = isMarketingBoard(resolvedBoardId); /** @todo deprecate once graphql returns marketing flag */
    var isDefaultRoute = isRouteMatch(location.pathname, TRIPBOARD_DETAILS);
    var isMarketingRoute = isRouteMatch(location.pathname, TRIPBOARD_MARKETING);
    var usr = props.user || {};

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.Fragment,
        null,
        isMarketing && isDefaultRoute && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Redirect"], { to: getUrl(TRIPBOARD_MARKETING, resolvedBoardId) }),
        !isMarketing && isMarketingRoute && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Redirect"], { to: getUrl(TRIPBOARD_DETAILS, resolvedBoardId) }),
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            user_UserProvider,
            usr,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                UserContext.Consumer,
                null,
                function (user) {
                    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_details, marketing_redirect__extends({}, marketing_redirect__extends({}, props, { boardId: resolvedBoardId }), { user: user }));
                }
            )
        )
    );
}

MarketingRedirect.defaultProps = {
    location: {}
};

/* harmony default export */ var marketing_redirect = (Object(es["withRouter"])(MarketingRedirect));
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/with-tripboard-listing-delete.js
var with_tripboard_listing_delete__templateObject = with_tripboard_listing_delete__taggedTemplateLiteralLoose(['\nmutation removeUnitFromTripBoard($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n    removeUnitFromTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad)\n}'], ['\nmutation removeUnitFromTripBoard($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {\n    removeUnitFromTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad)\n}']);

function with_tripboard_listing_delete__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var removeUnitFromTripBoard = src_default()(with_tripboard_listing_delete__templateObject);

var with_tripboard_listing_delete_props = function props(_ref) {
    var mutate = _ref.mutate,
        ownProps = _ref.ownProps;
    return {
        // just using onDelete as that is the expected legacy prop name, it would be nice to change this later
        onDelete: function onDelete(tripBoardUuid, unitTriad) {
            mutate({
                variables: {
                    hav: ownProps.hav,
                    tripBoardUuid: tripBoardUuid,
                    unitTriad: unitTriad
                },
                optimisticResponse: {
                    removeUnitFromTripBoard: true
                },
                update: function update(proxy) {
                    try {
                        var variables = {
                            hav: ownProps.hav,
                            tripBoardUuid: ownProps.boardId,
                            currency: ownProps.currency
                        };
                        var data = proxy.readQuery({ query: with_tripboard_query_query, variables: variables });
                        // remove listing from cache
                        data.tripBoard.listings = data.tripBoard.listings && data.tripBoard.listings.filter(function (_ref2) {
                            var listingId = _ref2.listingId;
                            return listingId !== unitTriad;
                        }) || [];
                        data.tripBoard.listingRefs = data.tripBoard.listingRefs && data.tripBoard.listingRefs.filter(function (listingId) {
                            return listingId !== unitTriad;
                        }) || [];
                        proxy.writeQuery({ query: with_tripboard_query_query, variables: variables, data: data });
                    } catch (err) {
                        /* we can't read or write the cache for some reason, silently swallow
                        and try to refetch the tripboard query from network in the refetchQueries function */
                    }
                },
                refetchQueries: [{
                    query: with_tripboard_query_query,
                    variables: {
                        hav: ownProps.hav,
                        tripBoardUuid: tripBoardUuid,
                        currency: ownProps.currency
                    }
                }]
            });
        }
    };
};

var withTripboardListingDelete = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(with_auth, // hav is extracted from auth context for use in query
Object(react_apollo_browser_umd["graphql"])(removeUnitFromTripBoard, { props: with_tripboard_listing_delete_props }));

/* harmony default export */ var with_tripboard_listing_delete = (withTripboardListingDelete);
// CONCATENATED MODULE: ./src/universal/tripboard/details/components/details-container.js











function details_container_mapStateToProps(state) {
    return {
        locale: state.system.locale,
        currency: state.system.currency,
        siteName: state.system.siteName,
        siteDisplayName: state.system.siteDisplayName,
        translations: getTranslations(state)
    };
}
var details_container_mapDispatchToProps = {
    setCurrentTripboard: tripboard_actions.setCurrentTripboard,
    completeTripboardCreation: onboarding_actions.completeTripboardCreation
};
var DetailsGraphqlContainer = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(Timing_withPAR, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(details_container_mapStateToProps, details_container_mapDispatchToProps), with_tripboard_query, // must come before withChangeTripboardDateRange and withDeleteTripboardDateRange
with_tripboard_listing_delete)(marketing_redirect);

/* harmony default export */ var details_container = (Object(commonjs["asyncComponent"])({
    name: 'DetailsGraphqlContainer',
    resolve: function resolve() {
        return Promise.resolve(DetailsGraphqlContainer);
    }, // connect HitPrice to abacus
    serverMode: 'defer'
}));
// CONCATENATED MODULE: ./src/universal/tripboard/selectors.js
var selectors__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var sortByUpdateTime = function sortByUpdateTime(a, b) {
    var aDate = new Date(a.updateTime);
    var bDate = new Date(b.updateTime);
    return (aDate < bDate) - (aDate > bDate); // trick for turning booleans into 1, 0, -1 range
};

// returns boards sorted by updateTime with listings sorted by updateTime
function getTripboardsByUpdateTime(state) {
    return Object.values(state.tripboard.tripboards).sort(sortByUpdateTime).reduce(function (boards, board) {
        if (board.role.toLowerCase() !== constants.VIEWER) {
            var listings = Object.values(board.listings).sort(sortByUpdateTime);
            return boards.concat(selectors__extends({}, board, {
                listings: listings
            }));
        }
        return boards;
    }, []);
}

function getTripboard(state, props) {
    var board = state.tripboard.tripboards[props.match.params.boardId];
    if (!board) {
        return board;
    }
    return selectors__extends({}, board, {
        isFavorite: board.sourceFavorite,
        isShared: board.shared,
        listings: Object.values(board.listings).sort(sortByUpdateTime)
    });
}

function getCurrentBoardId(state) {
    var boardId = state.tripboard.currentTripboard.currentBoardId;
    if (!boardId) {
        return '';
    }
    return boardId;
}

function getPreviewsLoadingState(state) {
    return state.tripboard.previewsLoadingState;
}

function getDetailsLoadingState(state, props) {
    var loadingState = state.tripboard.detailsLoadingState[props.match.params.boardId];
    return !loadingState ? initial : loadingState;
}

function getInvitation(state) {
    return state.tripboard.invitation;
}


// CONCATENATED MODULE: ./src/universal/tripboard/index.js









// CONCATENATED MODULE: ./src/universal/reducers/trip.js
var trip__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var trip_initialState = {
    adultsCount: 2,
    childrenCount: 0,
    petIncluded: false,
    arrival: null,
    departure: null,
    location: '',
    searchUrl: ''
};

var trip_actionHandlers = {};

var mergeStates = function mergeStates(newState) {
    return {
        adultsCount: newState.adultsCount || trip_initialState.adultsCount,
        childrenCount: newState.childrenCount || trip_initialState.childrenCount,
        petIncluded: newState.petIncluded || trip_initialState.petIncluded,
        arrival: newState.arrival || trip_initialState.arrival,
        departure: newState.departure || trip_initialState.departure,
        location: newState.location || trip_initialState.location,
        searchUrl: newState.searchUrl || trip_initialState.searchUrl
    };
};

trip_actionHandlers[actions.UPDATE_TRIP_DATA] = function (_, _ref) {
    var payload = _ref.payload;

    var newState = trip__extends({}, mergeStates(payload));
    return newState;
};

trip_actionHandlers[actions.INIT_TRIP_DATA] = function (_, _ref2) {
    var payload = _ref2.payload;

    var newState = trip__extends({}, mergeStates(payload));
    return newState;
};

/* harmony default export */ var reducers_trip = (utils_createReducer(trip_actionHandlers, trip_initialState));
// EXTERNAL MODULE: ./node_modules/@homeaway/react-toaster/lib/transpiled/index.js
var react_toaster_lib_transpiled = __webpack_require__("jAkQ");
var react_toaster_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_toaster_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/components/onboarding/onboarding-reducer.js
var onboarding_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var onboarding_reducer_initialState = {
    onboardingCompleted: false, // skip to landing page (create tripboard) of onboarding
    tripboardCreationStarted: false, // onboarding done, tripboard created. Route to the tripboard
    tripboardCreationNotComplete: false // user has seen their newly created tripboard, route normally.
};

var onboarding_reducer_actionHandlers = {};

onboarding_reducer_actionHandlers[onboarding_actions.COMPLETED_TRIPBOARD_ONBOARDING] = function (state) {
    var newState = onboarding_reducer__extends({}, state, {
        onboardingCompleted: true
    });
    return newState;
};

onboarding_reducer_actionHandlers[onboarding_actions.STARTED_TRIPBOARD_CREATION] = function (state) {
    var newState = onboarding_reducer__extends({}, state, {
        tripboardCreationStarted: true,
        tripboardCreationNotComplete: true
    });
    return newState;
};

onboarding_reducer_actionHandlers[onboarding_actions.COMPLETED_TRIPBOARD_CREATION] = function (state) {
    var newState = onboarding_reducer__extends({}, state, {
        onboardingCompleted: true,
        tripboardCreationNotComplete: false
    });
    return newState;
};

onboarding_reducer_actionHandlers[onboarding_actions.INIT_ONBOARDING_FLAGS] = function (state, _ref) {
    var payload = _ref.payload;

    var newState = onboarding_reducer__extends({}, state, payload);
    return newState;
};

onboarding_reducer_actionHandlers[onboarding_actions.RESET_ONBOARDING_FLAGS] = function () {
    return onboarding_reducer_initialState;
};

/* harmony default export */ var onboarding_reducer = (utils_createReducer(onboarding_reducer_actionHandlers, onboarding_reducer_initialState));
// CONCATENATED MODULE: ./src/universal/reducers/all.js











/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
var all_reducers = {
    footer: reducers_footer,
    header: reducers_header,
    recentActivity: recent_activity_reducer,
    system: reducers_system,
    onboarding: onboarding_reducer,
    translations: reducers_translations,
    tripboard: universal_tripboard_reducer,
    tripboardButton: transpiled["tripboardButtonReducer"],
    trip: reducers_trip,
    toasts: react_toaster_lib_transpiled["toasterReducers"]
};

/* harmony default export */ var reducers_all = (all_reducers);
// CONCATENATED MODULE: ./src/universal/middleware/edap.js
var middleware_edap__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Responds to TRIGGER_EDAP_EVENT action
function triggerEdapEvent(store) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { payload: { eventName: '', eventData: {}, options: {} } };

    if (false) {
        return;
    }

    var payload = action.payload;

    var newEventData = middleware_edap__extends({
        eventcategory: 'Scratchpad'
    }, payload.eventData);

    window.edap.push(function (edapInstance) {
        edapInstance.trigger(payload.eventName, newEventData, payload.options);
    });
}

// responds to TRIGGER_EDAP_PAGEVIEW action
function triggerEdapPageView() {
    if (false) {
        return;
    }

    window.edap.push(function (edapInstance) {
        edapInstance.trigger('pageview');
    });
}


// CONCATENATED MODULE: ./src/universal/utils/local-storage.js
var myStorage = "object" !== 'undefined' && window.localStorage || {};

var writeToStorage = function writeToStorage(key, value) {
    try {
        myStorage.setItem(key, value);
        return true;
    } catch (err) {
        return false;
    }
};

var readFromStorage = function readFromStorage(key) {
    try {
        return JSON.parse(myStorage.getItem(key));
    } catch (err) {
        return null;
    }
};
// CONCATENATED MODULE: ./src/universal/components/onboarding/middleware.js




var STARTED_KEY = 'tripboards.onboardingstarted';
var COMPLETED_KEY = 'tripboards.onboardingnotcompleted';
var ONBOARDED_KEY = 'tripboards.onboardingcompleted';

var middleware_writeStarted = function writeStarted() {
    writeToStorage(STARTED_KEY, 'true');
    writeToStorage(COMPLETED_KEY, 'true');
};

var middleware_writeCompleted = function writeCompleted() {
    writeToStorage(STARTED_KEY, 'true');
    writeToStorage(COMPLETED_KEY, 'false');
    writeToStorage(ONBOARDED_KEY, 'true');
};

var middleware_writeOnboarded = function writeOnboarded() {
    writeToStorage(ONBOARDED_KEY, 'true');
};

var middleware_reset = function reset() {
    writeToStorage(STARTED_KEY, 'false');
    writeToStorage(COMPLETED_KEY, 'false');
    writeToStorage(ONBOARDED_KEY, 'false');
};

function onboarding_middleware_registerAllMiddleware() {
    Object(redux_middleware_adapter_lib["registerMiddleware"])(onboarding_actions.STARTED_TRIPBOARD_CREATION, middleware_writeStarted);
    Object(redux_middleware_adapter_lib["registerMiddleware"])(onboarding_actions.COMPLETED_TRIPBOARD_CREATION, middleware_writeCompleted);
    Object(redux_middleware_adapter_lib["registerMiddleware"])(onboarding_actions.COMPLETED_TRIPBOARD_ONBOARDING, middleware_writeOnboarded);
    Object(redux_middleware_adapter_lib["registerMiddleware"])(onboarding_actions.RESET_ONBOARDING_FLAGS, middleware_reset);
}

/* harmony default export */ var onboarding_middleware = (onboarding_middleware_registerAllMiddleware);
// CONCATENATED MODULE: ./src/universal/utils/cookieUtils.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var TRIP_COOKIE = 'ha-trip-prst';
var STATE_COOKIE = 'ha-state-prst';

var HAS_DOCUMENT_COOKIE = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';

var writeCookie = function writeCookie(name, value) {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    var expireTime = new Date();
    expireTime.setTime(expireTime.getTime() + 30 * 24 * 60 * 60 * 1000);
    var cookie = [name, '=', encodeURIComponent(JSON.stringify(value)), ';expires=', expireTime.toUTCString(), '; path=/;'].join('');

    document.cookie = cookie;
};

var readCookie = function readCookie(cookieValue) {
    var result = {};
    if (!cookieValue) {
        return result;
    }
    try {
        result = decodeURIComponent(cookieValue);
        result = JSON.parse(result);
    } catch (err) {/* silently swallow error */}
    return result;
};

var deleteCookie = function deleteCookie(name) {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    document.cookie = [name, '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/'].join('');
};

var tripDataFromCookie = function tripDataFromCookie(state) {
    var tripCookie = readCookie(state[TRIP_COOKIE]);
    var locationCookie = readCookie(state[STATE_COOKIE]);
    var arrival = tripCookie.arrival,
        departure = tripCookie.departure,
        adultsCount = tripCookie.numberOfAdults,
        childrenCount = tripCookie.numberOfChildren,
        petIncluded = tripCookie.petIncluded;
    var searchUrl = locationCookie.lastSearchUrl,
        location = locationCookie.lbsKeywords;

    var tripData = { searchUrl: searchUrl, location: location, arrival: arrival, departure: departure, adultsCount: adultsCount, childrenCount: childrenCount, petIncluded: petIncluded };
    return tripData;
};

var writeCookiesFromTripData = function writeCookiesFromTripData(data) {
    var _ref = data || {},
        searchUrl = _ref.searchUrl,
        location = _ref.location,
        arrival = _ref.arrival,
        departure = _ref.departure,
        adultsCount = _ref.adultsCount,
        childrenCount = _ref.childrenCount,
        petIncluded = _ref.petIncluded;

    var tripCookieValue = {
        arrival: arrival,
        departure: departure,
        numberOfAdults: adultsCount,
        numberOfChildren: childrenCount,
        petIncluded: petIncluded
    };

    var stateCookieValue = {
        lbsKeywords: location,
        lastSearchUrl: searchUrl

    };
    writeCookie(TRIP_COOKIE, tripCookieValue);
    writeCookie(STATE_COOKIE, stateCookieValue);
};

/* harmony default export */ var cookieUtils = ({ writeCookie: writeCookie, deleteCookie: deleteCookie, readCookie: readCookie, tripDataFromCookie: tripDataFromCookie, writeCookiesFromTripData: writeCookiesFromTripData });
// CONCATENATED MODULE: ./src/universal/middleware/trip.js

// Responds to UPDATE_TRIP action
var trip_updateTrip = function updateTrip(_, action) {
    if (false) {
        return;
    }
    cookieUtils.writeCookiesFromTripData(action && action.payload || {});
};


// CONCATENATED MODULE: ./src/universal/middleware/all.js









/**
 * The middleware directory holds functions that are meant to be called
 * when certain redux actions are dispatched. This is a pattern for consolidating
 * business logic and simplifying side effects handling, such as async api calls.
 *
 * It is a simpler alternative to redux-sagas, but accomplishes the same thing.
 * This is a cleaner pattern than redux-thunk or redux-promises.
 *
 * There is one true redux middleware, called the middlewareAdapter that allows us to
 * register middleware functions that hold our business logic. Each function is paired with
 * one action. When that action is dispatched, the function is called. The registrations
 * below are pairing up action-to-function.
 *
 * The functions, themselves, are passed the store and the action. They can dispatch
 * additional actions, as needed.
 *
 * Example:
 *  function doFetchData(store, action) {
 *      request('/api/getData').then((resp) => {
 *          store.dispatch(fetchSuccess(resp));
 *      });
 *  }
 *
 * registerMiddleware(FETCH_DATA, doFetchData);
 *
 * Once the above is setup, a component could dispatch the FETCH_DATA action creator,
 * our doFetchData function would therefore be called and when it succeeded in fetching
 * the data, dispatches the fetchSuccess action creator with the payload, presumably to
 * populate a reducer. More details here:
 * https://github.homeawaycorp.com/Catalyst/node-redux-middleware-adapter
 */

/* istanbul ignore next */
function all_registerAllMiddleware() {
  // List out all middleware functions and the action that they respond to
  Object(redux_middleware_adapter_lib["registerMiddleware"])(actions.TRIGGER_EDAP_PAGEVIEW, triggerEdapPageView);
  Object(redux_middleware_adapter_lib["registerMiddleware"])(actions.TRIGGER_EDAP_EVENT, triggerEdapEvent);
  Object(redux_middleware_adapter_lib["registerMiddleware"])(actions.UPDATE_TRIP_DATA, trip_updateTrip);
  tripboard_middleware();
  middleware();
  onboarding_middleware();
}

/* harmony default export */ var middleware_all = (all_registerAllMiddleware);
// CONCATENATED MODULE: ./src/universal/store.js





/**
 * Initialize the redux store.
 *   - connects middleware and reducers
 *   - configures the chrome extension for redux
 */

/* istanbul ignore next */
function createStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Each middleware function is registered with the middlewareAdapter and
    // is assigned an action to respond to. See './middleware/all'
    middleware_all();

    var composeEnhancers = esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"];

    // Setup redux devtools chrome extension, if available and correct env
    if ("object" !== 'undefined' && initialState.system.environment === 'development') {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"];
    }

    var createStoreWithMiddleware = composeEnhancers(Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["applyMiddleware"])(redux_middleware_adapter_lib["middlewareAdapter"]))(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["createStore"]);
    var reducers = Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["combineReducers"])(Object.assign({}, reducers_all));
    return createStoreWithMiddleware(reducers, initialState);
}


// EXTERNAL MODULE: ./node_modules/react-hot-loader/lib/AppContainer.js
var lib_AppContainer = __webpack_require__("lx7a");
var AppContainer_default = /*#__PURE__*/__webpack_require__.n(lib_AppContainer);

// CONCATENATED MODULE: ./src/universal/utils/tab-sync.js
var tabSync = {
    visibilityChange: null,

    setVisibilityListener: function setVisibilityListener(callBack) {
        if (typeof document.hidden !== 'undefined') {
            // Opera 12.10 and Firefox 18 and later support
            this.visibilityChange = 'visibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
            this.visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
            this.visibilityChange = 'webkitvisibilitychange';
        }

        document.removeEventListener(this.visibilityChange, callBack, false); // most likely not neccesary
        document.addEventListener(this.visibilityChange, callBack, false);
    },
    removeVisibilityListener: function removeVisibilityListener(callBack) {
        document.removeEventListener(this.visibilityChange, callBack, false);
    }
};

/* harmony default export */ var tab_sync = (tabSync);
// CONCATENATED MODULE: ./src/universal/components/error-page/error-page.js
function error_page__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function error_page__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function error_page__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/* istanbul ignore next */
var AsyncGenericError = Object(commonjs["asyncComponent"])({
    name: 'AsyncGenericError',
    resolve: function resolve() {
        return Promise.resolve(components_generic_error);
    },
    serverMode: 'defer'
});

/**
 * This may have more logic in the future
 * to display different types of error UIs and messages.
 */

var error_page_ErrorPage = function (_Component) {
    error_page__inherits(ErrorPage, _Component);

    function ErrorPage(props) {
        error_page__classCallCheck(this, ErrorPage);

        return error_page__possibleConstructorReturn(this, _Component.call(this, props));
    }

    ErrorPage.prototype.componentDidMount = function componentDidMount() {
        /** @todo [SCRATCHPAD-1640] log edap event(s) */
    };

    ErrorPage.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return false;
    };

    ErrorPage.prototype.render = function render() {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(AsyncGenericError, null);
    };

    return ErrorPage;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);


// CONCATENATED MODULE: ./src/universal/components/error-page/index.js

/* harmony default export */ var error_page = (error_page_ErrorPage);
// EXTERNAL MODULE: ./node_modules/@homeaway/react-feedback/lib/transpiled/index.js
var react_feedback_lib_transpiled = __webpack_require__("ScPh");
var react_feedback_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_feedback_lib_transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-site-footer/lib/transpiled/index.js
var react_site_footer_lib_transpiled = __webpack_require__("JPvU");
var react_site_footer_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_site_footer_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/components/Footer/Footer.js
var Footer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Footer__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/* istanbul ignore next */
var AsyncSiteFooter = Object(commonjs["asyncComponent"])({
    name: 'AsyncSiteFooter',
    resolve: function resolve() {
        return Promise.resolve(react_site_footer_lib_transpiled_default.a);
    },
    serverMode: 'defer'
});

var Footer_Footer = function (_Component) {
    Footer__inherits(Footer, _Component);

    function Footer() {
        Footer__classCallCheck(this, Footer);

        return Footer__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Footer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        // Prevent multiple API calls
        return nextProps.site !== this.props.site && nextProps.locale !== this.props.locale;
    };

    Footer.prototype.render = function render() {
        var _props = this.props,
            site = _props.site,
            locale = _props.locale,
            rest = Footer__objectWithoutProperties(_props, ['site', 'locale']);

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(AsyncSiteFooter, Footer__extends({
            dataUrl: '/traveler/scratchpad/api/footer',
            site: site,
            locale: locale
        }, rest));
    };

    return Footer;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

Footer_Footer.propTypes = {
    site: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    locale: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};
Footer_Footer.defaultProps = {
    site: 'homeaway_us',
    locale: 'en_US_HA'
};


/* harmony default export */ var components_Footer_Footer = (Footer_Footer);
// CONCATENATED MODULE: ./src/universal/components/Header/Header.js
var Header__withAbacusTestValues;

var Header__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Header__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







// Abacus: waterfall



function Header_mapStateToProps(state) {
    return {
        siteName: getSiteName(state),
        fullLocale: state.system.fullLocale,
        isMobile: getIsMobile(state),
        header: state.header,
        currency: state.system.currency
    };
}

function Header(_ref) {
    var header = _ref.header,
        isMobile = _ref.isMobile,
        siteName = _ref.siteName,
        fullLocale = _ref.fullLocale,
        currency = _ref.currency;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_site_header_lib_transpiled_default.a, Header__extends({}, header, {
        dataUrl: '/traveler/scratchpad/api/header',
        isMobile: isMobile,
        siteName: siteName,
        fullLocale: fullLocale,
        currencyCode: currency,
        withoutCountryLanguageSelector: false,
        withoutCurrencySelector: false
    }));
}

// Abacus: waterfall
function HeaderContainer(_ref2) {
    var waterfallTestValue = _ref2.waterfallTestValue,
        rest = Header__objectWithoutProperties(_ref2, ['waterfallTestValue']);

    if (waterfallTestValue > 0) {
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(AsyncHeader, rest);
    }
    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Header, rest);
}

/* harmony default export */ var Header_Header = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(Header_mapStateToProps), with_abacus_test_values_as_props((Header__withAbacusTestValues = {}, Header__withAbacusTestValues[experiments["WATERFALL_AB"]] = 'waterfallTestValue', Header__withAbacusTestValues)))(HeaderContainer));
// EXTERNAL MODULE: ./src/universal/components/MainPage/MainPageContainer.less
var MainPageContainer = __webpack_require__("SuiU");
var MainPageContainer_default = /*#__PURE__*/__webpack_require__.n(MainPageContainer);

// CONCATENATED MODULE: ./src/universal/components/MainPage/MainPageContainer.js
function MainPageContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MainPageContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MainPageContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















function MainPageContainer_mapStateToProps(state, _ref) {
    var location = _ref.location;

    var translations = getTranslations(state);
    var queryParams = node_modules_query_string_default.a.parse(location.search);
    var favoritesMessage = translations['tripboards.favorites.message'];
    var errorTitle = translations['th.inbox.error.title'];
    var errorMessage = translations['th.inbox.error.message'];
    var showTripboardButton = state && state.tripboard && state.tripboard.createControls && state.tripboard.createControls.tripboardButtonVisible;
    return {
        errorTitle: errorTitle,
        errorMessage: errorMessage,
        title: translations['shared.bce.header.scratchpad.label'] || 'Scratchpad',
        favoritesMessage: favoritesMessage,
        fromFavorites: queryParams.redirect === 'favorites',
        pagename: PAGE_TRIPBOARD_MAIN,
        showTripboardButton: showTripboardButton,
        isMobile: getIsMobile(state),
        location: location
    };
}

var MainPageContainer_MainPage = function (_Component) {
    MainPageContainer__inherits(MainPage, _Component);

    function MainPage(props) {
        MainPageContainer__classCallCheck(this, MainPage);

        return MainPageContainer__possibleConstructorReturn(this, _Component.call(this, props));
    }

    MainPage.prototype.render = function render() {
        var _props = this.props,
            errorTitle = _props.errorTitle,
            errorMessage = _props.errorMessage,
            fromFavorites = _props.fromFavorites,
            favoritesMessage = _props.favoritesMessage,
            showTripboardButton = _props.showTripboardButton,
            isMobile = _props.isMobile;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            'div',
            { id: 'main-page-container', className: 'main-page-container' },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(PageView_Page, { pagename: PAGE_TRIPBOARD_MAIN }),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                error_boundary,
                { errorTitle: errorTitle, errorMessage: errorMessage },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(invite_accept, null),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'row' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        'div',
                        { className: 'col-sm-10 col-sm-offset-1' },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            'div',
                            { className: 'main-page-container__header' },
                            fromFavorites && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                null,
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'fade in alert alert--verbose alert-info', role: 'alert' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'svg',
                                        { className: 'inline-svg', 'aria-hidden': 'true' },
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement('use', { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '#svg-clock' })
                                    ),
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                        'div',
                                        { className: 'scratchpad-alert-message-text' },
                                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                            'p',
                                            null,
                                            favoritesMessage
                                        )
                                    )
                                )
                            ),
                            showTripboardButton && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'div',
                                { className: 'tripboard-summary__row' },
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'h2',
                                    { 'data-wdio': 'tripboard-summary__header' },
                                    this.props.title
                                ),
                                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                    'div',
                                    { className: 'tripboard-summary__createButton' },
                                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(create_tripboard_button, { isMobile: isMobile })
                                )
                            ),
                            !showTripboardButton && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                                'h2',
                                { 'data-wdio': 'tripboard-summary__header' },
                                this.props.title
                            )
                        ),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(tripboards_container, null)
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'row' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_recent_activity_carousel_container, null)
                )
            )
        );
    };

    return MainPage;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

MainPageContainer_MainPage.propTypes = {
    errorTitle: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    errorMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    fromFavorites: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.bool,
    favoritesMessage: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string,
    title: prop_typesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.string
};
MainPageContainer_MainPage.defaultProps = {
    fromFavorites: false,
    location: { search: '' }
};
/* harmony default export */ var MainPage_MainPageContainer = (Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(MainPageContainer_mapStateToProps)(MainPageContainer_MainPage));
// EXTERNAL MODULE: ./node_modules/load-script/index.js
var load_script = __webpack_require__("PirY");
var load_script_default = /*#__PURE__*/__webpack_require__.n(load_script);

// CONCATENATED MODULE: ./src/universal/utils/loadLocale.js




var LANGUAGE_FALLBACKS = {
    'no-NO': 'nb-NO',
    no: 'nb'
};

// react-intl and google maps expect a different locale format from the standard
// ex. "en-US" or "en"
// "no" locale is not valid language, we have to use "nb" instead
var formatLocale = function formatLocale(locale) {
    var langCountryPair = locale.match(/^.{2}_.{2}/);
    var formattedLocale = locale.slice(0, 2);

    if (langCountryPair) {
        formattedLocale = langCountryPair[0].replace('_', '-');
    }

    return LANGUAGE_FALLBACKS[formattedLocale] || formattedLocale;
};

// returns correct language from locale
var getLanguageFromLocale = function getLanguageFromLocale(locale) {
    return formatLocale(locale).split(/_|-/)[0];
};

var loadLocale_loadLocaleData = function loadLocaleData(locale) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var language = getLanguageFromLocale(locale);
    if (false) {
        // server side case
        addLocaleData(require('react-intl/locale-data/' + language));
        return cb();
    } else if (window.ReactIntlLocaleData[language]) {
        // In the browser, we cheat and use a global. Yay globals!
        Object(index_es["addLocaleData"])(window.ReactIntlLocaleData[language]);
        return cb();
    }

    return load_script_default()(window.reactIntlLocaleDataPath + '/' + language + '.js', function (err) {
        if (err) {
            client_logger.captureMessage('loadLocaleData dynamic load failed err=' + err, LOG_ERROR);
            return cb(err);
        }
        Object(index_es["addLocaleData"])(window.ReactIntlLocaleData[language]);
        return cb();
    });
};

/* harmony default export */ var loadLocale = (loadLocale_loadLocaleData);
// CONCATENATED MODULE: ./src/universal/components/intl/intl-wrapper.js
function intl_wrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function intl_wrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function intl_wrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var intl_wrapper_IntlWrapper = function (_Component) {
    intl_wrapper__inherits(IntlWrapper, _Component);

    function IntlWrapper(props) {
        intl_wrapper__classCallCheck(this, IntlWrapper);

        var _this = intl_wrapper__possibleConstructorReturn(this, _Component.call(this, props));

        loadLocale(props.locale);
        return _this;
    }

    IntlWrapper.prototype.render = function render() {
        var _props = this.props,
            children = _props.children,
            translations = _props.translations,
            locale = _props.locale;

        var intlLocale = getLanguageFromLocale(locale);
        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            index_es["IntlProvider"],
            {
                locale: intlLocale,
                key: intlLocale,
                messages: translations
            },
            children
        );
    };

    return IntlWrapper;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

var intl_wrapper_mapStateToProps = function mapStateToProps() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$system = _ref.system;

    _ref$system = _ref$system === undefined ? {} : _ref$system;
    var _ref$system$locale = _ref$system.locale,
        locale = _ref$system$locale === undefined ? 'en_US' : _ref$system$locale;
    return { locale: locale };
};
/* harmony default export */ var intl_wrapper = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(withTranslations, Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(intl_wrapper_mapStateToProps))(intl_wrapper_IntlWrapper));
// EXTERNAL MODULE: ./src/universal/components/not-found/not-found.less
var not_found = __webpack_require__("iTOu");
var not_found_default = /*#__PURE__*/__webpack_require__.n(not_found);

// CONCATENATED MODULE: ./src/universal/components/not-found/not-found.js
var _dec, not_found__class;

function not_found__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function not_found__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function not_found__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function not_found_mapStateToProps(state) {
    var translations = getTranslations(state);

    return {
        content: translations['shared.generic404.content'],
        title: translations['shared.generic404.title']
    };
}

var not_found_NotFound = (_dec = Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(not_found_mapStateToProps), _dec(not_found__class = function (_Component) {
    not_found__inherits(NotFound, _Component);

    function NotFound() {
        not_found__classCallCheck(this, NotFound);

        return not_found__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    NotFound.prototype.render = function render() {
        var _props = this.props,
            content = _props.content,
            title = _props.title;


        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Fragment"],
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'section',
                { className: 'col-sm-6 col-xs-12 error-code' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'h1',
                    null,
                    '404'
                )
            ),
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'section',
                { className: 'col-sm-6 col-xs-12 not-found' },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'h3',
                    { className: 'not-found__title' },
                    title
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'p',
                    { className: 'lead' },
                    content
                )
            )
        );
    };

    return NotFound;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"])) || not_found__class);


/* harmony default export */ var not_found_not_found = (not_found_NotFound);
// CONCATENATED MODULE: ./src/universal/components/not-found/index.js


/* harmony default export */ var components_not_found = (not_found_not_found);
// EXTERNAL MODULE: ./src/universal/components/App/App.less
var App_App = __webpack_require__("b753");
var App_default = /*#__PURE__*/__webpack_require__.n(App_App);

// EXTERNAL MODULE: ./src/universal/less/index.less
var less = __webpack_require__("pDqy");
var less_default = /*#__PURE__*/__webpack_require__.n(less);

// CONCATENATED MODULE: ./src/universal/components/App/App.js
var App__withAbacusTestValues;

function App__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function App__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function App__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @prettier
 */






























// Abacus: waterfall





function App_mapStateToProps(state) {
    var footer = state.footer,
        system = state.system;

    var boardId = getCurrentBoardId(state);
    var translations = getTranslations(state);

    var lingua = {
        tabText: translations['shared.stabFeedback.tabText'],
        title: translations['shared.stabFeedback.title'],
        reviewLink: translations['shared.stabFeedback.reviewLink'],
        reviewLinkText: translations['shared.stabFeedback.lookingToWriteReview'],
        helpLink: translations['shared.stabFeedback.helpLink'],
        helpLinkText: translations['shared.stabFeedback.lookingForSupport'],
        supportLinkText: translations['shared.stabFeedback.leaveComment']
    };

    return {
        boardId: boardId,
        footer: footer,
        siteName: system.siteName,
        currency: system.currency,
        fullLocale: system.fullLocale,
        lingua: lingua
    };
}
var App_mapDispatchToProps = {
    fetchRecentActivity: recent_activity_actions.fetchRecentActivity,
    initOnboardingFlags: onboarding_actions.initOnboardingFlags
};

var App_App_App = function (_Component) {
    App__inherits(App, _Component);

    function App(props) {
        App__classCallCheck(this, App);

        var _this = App__possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {
            var initOnboardingFlags = _this.props.initOnboardingFlags;
            // Initialize abacus client utils and experiment cache

            utils_abacus.initialize();
            tab_sync.setVisibilityListener(_this.handleVisibilityChange);
            var startedTripboardCreation = readFromStorage(STARTED_KEY) || false;
            var completedTripboardCreation = readFromStorage(COMPLETED_KEY) || false;
            var onboardingCompleted = readFromStorage(ONBOARDED_KEY) || false;
            initOnboardingFlags(startedTripboardCreation, completedTripboardCreation, onboardingCompleted);
        };

        _this.componentWillUnmount = function () {
            tab_sync.removeVisibilityListener(_this.handleVisibilityChange);
        };

        _this.handleVisibilityChange = function () {
            if (!document.hidden) {
                // the handler fires twice for hidden = false and hidden = true.  We only need one.
                var _this$props = _this.props,
                    fetchRecentActivity = _this$props.fetchRecentActivity,
                    client = _this$props.client,
                    boardId = _this$props.boardId,
                    hav = _this$props.hav,
                    currency = _this$props.currency,
                    pathname = _this$props.location.pathname;


                if (pathname === ROOT || pathname === ROOT2) {
                    fetchRecentActivity();
                    client.query({
                        query: PAGINATED_TRIPBOARDS_QUERY,
                        fetchPolicy: 'network-only',
                        errorPolicy: 'all',
                        variables: tripboards_queryParams(hav)
                    }).catch();
                } else if (pathname.indexOf(TRIPBOARD) !== -1) {
                    client.query({
                        query: with_tripboard_query_query,
                        fetchPolicy: 'network-only',
                        errorPolicy: 'all',
                        variables: {
                            hav: hav,
                            tripBoardUuid: boardId,
                            currency: currency
                        }
                    }).catch();
                } else if (pathname.indexOf(RECENT_DETAILS) !== -1) {
                    fetchRecentActivity();
                }
            }
        };

        return _this;
    }

    App.prototype.render = function render() {
        var _props = this.props,
            footer = _props.footer,
            lingua = _props.lingua,
            siteName = _props.siteName,
            fullLocale = _props.fullLocale,
            sharedTestValue = _props.sharedTestValue,
            waterfallTestValue = _props.waterfallTestValue;

        // Start Abacus: ha_pulse_shared_tripboard_ab_test

        var appContainerClass = classnamesfrom_dll_reference_vendor_d3276433b58c8a2853f4_default()('app-page-container container-fluid', {
            'padding-bottom': sharedTestValue === 0
        });

        // Abacus: waterfall
        var isWaterFallTestOn = waterfallTestValue > 0;

        return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            intl_wrapper,
            null,
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                'div',
                null,
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(Header_Header, null),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: appContainerClass, id: 'app-page-container' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        es["Switch"],
                        null,
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Route"], {
                            exact: true,
                            path: universal_routes.TRIPBOARD,
                            component: MainPage_MainPageContainer
                        }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Route"], {
                            exact: true,
                            path: universal_routes.TRIPBOARD_ERROR,
                            component: error_page
                        }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Route"], {
                            exact: true,
                            path: universal_routes.TRIPBOARD_DETAILS,
                            component: details_container
                        }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Route"], {
                            exact: true,
                            path: universal_routes.TRIPBOARD_MARKETING,
                            component: details_container
                        }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Route"], {
                            exact: true,
                            path: universal_routes.RECENT_DETAILS,
                            component: components_recent_activity_details_container
                        }),
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(es["Route"], { component: components_not_found })
                    )
                ),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_toaster_lib_transpiled["Toaster"], null),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_Footer_Footer, { data: footer, site: siteName, locale: fullLocale }),
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    'div',
                    { className: 'app-page-container__hide-feedback-mobile' },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(react_feedback_lib_transpiled_default.a, { tabPosition: 'right', lingua: lingua })
                ),
                isWaterFallTestOn && reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(async_svgs, null)
            )
        );
    };

    return App;
}(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4["Component"]);

App_App_App.defaultProps = {
    sharedTestValue: 0,
    waterfallTestValue: 0
};


/* harmony default export */ var components_App_App = (Object(esfrom_dll_reference_vendor_d3276433b58c8a2853f4["compose"])(es["withRouter"], with_auth, abacus_with_abacus_test_values_as_props((App__withAbacusTestValues = {}, App__withAbacusTestValues[experiments["HA_PULSE_SHARED_TRIPBOARD_AB_TEST"]] = 'sharedTestValue', App__withAbacusTestValues[experiments["WATERFALL_AB"]] = 'waterfallTestValue', App__withAbacusTestValues)), react_apollo_browser_umd["withApollo"], Object(react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["connect"])(App_mapStateToProps, App_mapDispatchToProps))(App_App_App));
// CONCATENATED MODULE: ./src/universal/Root.js









/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root(_ref) {
    var store = _ref.store,
        client = _ref.client;

    return reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
        react_apollo_browser_umd["ApolloProvider"],
        { client: client },
        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
            react_redux_esfrom_dll_reference_vendor_d3276433b58c8a2853f4["Provider"],
            { store: store },
            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                auth_context.Provider,
                { value: window.__AUTH__ },
                reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                    translations_context.Provider,
                    { value: window.__TRANSLATIONS__ },
                    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                        abacus_context.Provider,
                        { value: window.__ABACUS__ },
                        reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
                            es["BrowserRouter"],
                            null,
                            reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(components_App_App, null)
                        )
                    )
                )
            )
        )
    );
}

/* harmony default export */ var universal_Root = (Root);
// CONCATENATED MODULE: ./src/universal/index.js







/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

// Initial state as set by the server-side render
var universal_initialState = window.__INITIAL_STATE__;
var universal_store = createStore(universal_initialState);

react_domfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.hydrate(reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(
    AppContainer_default.a,
    { store: universal_store },
    reactfrom_dll_reference_vendor_d3276433b58c8a2853f4_default.a.createElement(universal_Root, { store: universal_store, client: client_side_apollo_client })
), document.getElementById('root'));

// Hot module replacement in development env only
if (false) {
    module.hot.accept('./Root', function () {
        var RootRequired = require('./Root').default;
        ReactDOM.unmountComponentAtNode(document.getElementById('root'));
        ReactDOM.hydrate(React.createElement(
            AppContainer,
            { store: universal_store },
            React.createElement(RootRequired, { store: universal_store, client: client })
        ), document.getElementById('root'));
        console.log('[HMR] Rendered at ' + new Date().toLocaleTimeString()); // eslint-disable-line
    });
}

/***/ }),

/***/ "zXiQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zZmH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatError = formatError;

var _invariant = _interopRequireDefault(__webpack_require__("JiIc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? (0, _invariant.default)(0, 'Received null or undefined error.') : void 0;
  var message = error.message || 'An unknown error occurred.';
  var locations = error.locations;
  var path = error.path;
  var extensions = error.extensions;
  return extensions ? {
    message: message,
    locations: locations,
    path: path,
    extensions: extensions
  } : {
    message: message,
    locations: locations,
    path: path
  };
}

/***/ }),

/***/ "zaqd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _rcHammerjs = __webpack_require__("rwgm");

var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);

var _rafOptimized = __webpack_require__("pick");

var _CarouselSlide = __webpack_require__("x08l");

var _CarouselSlide2 = _interopRequireDefault(_CarouselSlide);

var _CarouselUtil = __webpack_require__("ZTHW");

var _CarouselButtons = __webpack_require__("/xbn");

var _CarouselButtons2 = _interopRequireDefault(_CarouselButtons);

__webpack_require__("UVMF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Third Party Imports


// Artifactory Imports


// Primary Imports


// styles


var Carousel = function (_Component) {
    _inherits(Carousel, _Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _initialiseProps.call(_this);

        var width = _this.props.width || 0;
        var height = _this.props.height || 0;
        var _this$props = _this.props,
            index = _this$props.index,
            renderedIndices = _this$props.renderedIndices;

        var slidesData = _this.getSlidesData({
            carouselWidth: width,
            carouselHeight: height
        });
        var x = _this.getX({
            slidesData: slidesData,
            width: width,
            index: index,
            renderedIndices: renderedIndices
        });

        _this.state = {
            width: width,
            height: height,
            touchEnabled: false,
            hasPlaceholders: _CarouselUtil.utils.hasPlaceholders(_this.props.images),
            slidesData: slidesData,
            sliding: false,
            panning: false,
            rotating: false,
            slidingToClose: false,
            panAxis: '',
            x: x,
            xBeforePan: x,
            y: 0,
            bgOpacity: 1,
            canPan: true
        };

        // get a setStateIfChanged method that uses this component's setState method
        _this.setStateIfChanged = _CarouselUtil.utils.getSetStateIfChanged(function (changes) {
            return _this.setState(function () {
                return changes;
            });
        });
        // hash of timeout ids
        _this.timeouts = {};

        // data for the last pan event
        _this.lastPan = {
            deltaX: 0,
            deltaY: 0
        };
        // rgb color array for slide overlay, carousel bg, and caption gradient bg
        _this.overlayColorRGB = _CarouselUtil.utils.hexToRGB(_this.props.overlayColor);
        // keyup flag for keyboard enabled navigation.
        _this.keyUp = true;
        return _this;
    }

    _createClass(Carousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _state = this.state,
                height = _state.height,
                width = _state.width,
                slidingToClose = _state.slidingToClose;
            // once component has mounted, get carousel DOM ref height and width

            var carouselWidth = this.getWidth();
            var carouselHeight = this.getHeight();
            // array of possible state changes, including making sure slidingToClose is false
            var possibleChanges = [{
                key: 'touchEnabled',
                value: _CarouselUtil.utils.isTouchEnabled(),
                oldValue: this.state.touchEnabled
            }, {
                key: 'slidingToClose',
                value: false,
                oldValue: slidingToClose
            }];
            // get known changes
            var knownChanges = _CarouselUtil.utils.getChanges({
                possibleChanges: [{
                    key: 'width',
                    value: carouselWidth,
                    oldValue: width
                }, {
                    key: 'height',
                    value: carouselHeight,
                    oldValue: height
                }]
            });

            // if size changed, compute new slidesData and listbox x position
            if (knownChanges.changed) {
                var _props = this.props,
                    index = _props.index,
                    renderedIndices = _props.renderedIndices;

                var slidesData = this.updateSlidesData({
                    slidesData: this.state.slidesData,
                    carouselWidth: carouselWidth,
                    carouselHeight: carouselHeight
                });
                var x = this.getX({
                    slidesData: slidesData,
                    width: carouselWidth,
                    index: index,
                    renderedIndices: renderedIndices
                });
                knownChanges.changes = _extends({}, knownChanges.changes, {
                    x: x,
                    xBeforePan: x,
                    slidesData: slidesData
                });
            }

            // once window is available and carousel has mounted
            // update touch enabled, width/height, slidesData, and x in state
            this.setStateIfChanged({
                possibleChanges: possibleChanges,
                knownChanges: knownChanges.changes
            });
            // toggle window handles
            this.toggleWindowHandlers(true);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // eslint-disable-line complexity
            var _state2 = this.state,
                width = _state2.width,
                height = _state2.height,
                hasPlaceholders = _state2.hasPlaceholders,
                slidesData = _state2.slidesData;
            var index = this.props.index;

            var newHasPlaceholders = hasPlaceholders && _CarouselUtil.utils.hasPlaceholders(nextProps.images);
            var newWidth = this.getWidth(nextProps.width);
            var newHeight = this.getHeight(nextProps.height);
            var knownChanges = _CarouselUtil.utils.getChanges({
                possibleChanges: [{
                    key: 'width',
                    value: newWidth,
                    oldValue: width
                }, {
                    key: 'height',
                    value: newHeight,
                    oldValue: height
                }, {
                    key: 'hasPlaceholders',
                    value: newHasPlaceholders,
                    oldValue: hasPlaceholders
                }]
            });

            if (knownChanges.changed || nextProps.index !== index) {
                var tempSlidesData = slidesData;
                if (knownChanges.changed) {
                    tempSlidesData = this.updateSlidesData({
                        slidesData: slidesData,
                        carouselWidth: newWidth,
                        carouselHeight: newHeight
                    });
                }
                var x = this.getX({
                    slidesData: tempSlidesData,
                    width: newWidth,
                    index: nextProps.index,
                    renderedIndices: nextProps.renderedIndices
                });

                this.setStateIfChanged({
                    knownChanges: _extends({}, knownChanges.changes, {
                        x: x,
                        xBeforePan: x,
                        slidesData: tempSlidesData,
                        sliding: false
                    })
                });
            }

            // if keyboardNavigationEnabled changed, add/remove event handlers as appropriate
            // this is necessary because the key handlers are added to the window and will need to
            // be turned off for all but the active carousel when multiple carousel instance exists
            if (nextProps.handlesKeyboardNavigation !== this.props.handlesKeyboardNavigation && "object" !== 'undefined') {
                if (nextProps.handlesKeyboardNavigation) {
                    window.addEventListener('keydown', this.onKeyDown);
                    window.addEventListener('keyup', this.onKeyUp);
                } else {
                    window.removeEventListener('keydown', this.onKeyDown);
                    window.removeEventListener('keyup', this.onKeyUp);
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            for (var key in this.timeouts) {
                if (this.timeouts.hasOwnProperty(key)) {
                    clearTimeout(this.timeouts[key]);
                }
            }
            this.timeouts = {};
            this.toggleWindowHandlers(false);
        }
    }, {
        key: 'getX',
        value: function getX(_ref) {
            var slidesData = _ref.slidesData,
                width = _ref.width,
                index = _ref.index,
                renderedIndices = _ref.renderedIndices;
            var slideMargin = this.props.slideMargin;

            var indexOfIndex = renderedIndices.indexOf(index);
            var posIndices = renderedIndices.slice(0, indexOfIndex);
            var dist = posIndices.reduce(function (accum, curVal) {
                var d = slidesData[curVal].slideWidth + slideMargin;
                return d + accum;
            }, 0);
            var margin = _CarouselUtil.utils.getSlideMargin(width, slidesData[index].slideWidth);
            var x = dist - margin;
            return x;
        }
    }, {
        key: 'getSlidesData',
        value: function getSlidesData(_ref2) {
            var carouselWidth = _ref2.carouselWidth,
                carouselHeight = _ref2.carouselHeight;
            var _props2 = this.props,
                slideSize = _props2.slideSize,
                images = _props2.images;

            var carouselAspectRatio = carouselHeight && carouselWidth && carouselWidth / carouselHeight || 0;
            var slidesData = images.map(function (image, index) {
                var src = image.src,
                    mediaType = image.mediaType;

                var type = _CarouselUtil.utils.getMediaType({ src: src, mediaType: mediaType });
                var size = _CarouselUtil.utils.computeSlideData({
                    index: index,
                    image: image,
                    carouselWidth: carouselWidth,
                    carouselHeight: carouselHeight,
                    carouselAspectRatio: carouselAspectRatio,
                    slideSize: slideSize,
                    mediaType: type
                });
                return size;
            });

            return slidesData;
        }

        // called when carousel resizes. updates hash of slide sizes using carousel and
        // slide image aspect ratio. this data is used to size and position the slides

    }, {
        key: 'updateSlidesData',
        value: function updateSlidesData(_ref3) {
            var slidesData = _ref3.slidesData,
                carouselWidth = _ref3.carouselWidth,
                carouselHeight = _ref3.carouselHeight;
            var _props3 = this.props,
                slideSize = _props3.slideSize,
                images = _props3.images;

            var carouselAspectRatio = _CarouselUtil.utils.getAspectRatio(carouselWidth, carouselHeight);
            return slidesData.map(function (slideData, index) {
                var _ref4 = images[index] || {},
                    src = _ref4.src,
                    width = _ref4.width,
                    height = _ref4.height,
                    mediaType = _ref4.mediaType;

                var type = _CarouselUtil.utils.getMediaType({ src: src, mediaType: mediaType });
                // always prefer to use slideData image width and height (if present)
                // over image metadata width and height, because this allows to persist
                // image size if set from image load callbacks. and if that isn't the case
                // the width and height values should be the same anyway
                return _CarouselUtil.utils.computeSlideData({
                    index: index,
                    image: {
                        width: slideData.imageWidth || width,
                        height: slideData.imageHeight || height,
                        src: src
                    },
                    carouselWidth: carouselWidth,
                    carouselHeight: carouselHeight,
                    carouselAspectRatio: carouselAspectRatio,
                    slideSize: slideSize,
                    mediaType: type
                });
            });
        }
    }, {
        key: 'toggleWindowHandlers',
        value: function toggleWindowHandlers(enable) {
            if (true) {
                var func = enable ? 'addEventListener' : 'removeEventListener';

                if (this.props.handlesOrientationChange && typeof window.orientation !== 'undefined') {
                    window[func]('orientationchange', this.onOrientationChange);
                }

                if (this.props.handlesKeyboardNavigation) {
                    window[func]('keydown', this.onKeyDown);
                    window[func]('keyup', this.onKeyUp);
                }

                this.toggleResizeHandlers(enable);
            }
        }
    }, {
        key: 'toggleResizeHandlers',
        value: function toggleResizeHandlers(enable) {
            if (this.props.handlesWindowResize) {
                if (enable) {
                    if (this.clearResize && typeof this.clearResize === 'function') {
                        this.clearResize();
                    }
                    this.clearResize = (0, _rafOptimized.resize)(this.onResize);
                } else if (this.clearResize) {
                    this.clearResize();
                    this.clearResize = null;
                }
            }
        }
    }, {
        key: 'ignoreKeyDown',
        value: function ignoreKeyDown(e) {
            return e.metaKey || e.ctrlKey || ['input', 'textarea'].some(function (elem) {
                return e.target.matches(elem);
            });
        }
    }, {
        key: 'onSizeChange',
        value: function onSizeChange(newWidth, newHeight) {
            var knownChanges = _CarouselUtil.utils.getChanges({
                possibleChanges: [{
                    key: 'width',
                    value: newWidth,
                    oldValue: this.state.width
                }, {
                    key: 'height',
                    value: newHeight,
                    oldValue: this.state.height
                }]
            });

            if (knownChanges.changed) {
                var _props4 = this.props,
                    index = _props4.index,
                    renderedIndices = _props4.renderedIndices;

                var slidesData = this.updateSlidesData({
                    slidesData: this.state.slidesData,
                    carouselWidth: newWidth,
                    carouselHeight: newHeight
                });
                var x = this.getX({
                    slidesData: slidesData,
                    width: newWidth,
                    index: index,
                    renderedIndices: renderedIndices
                });

                knownChanges.changes = _extends({}, knownChanges.changes, {
                    x: x,
                    xBeforePan: x,
                    slidesData: slidesData
                });

                this.setStateIfChanged({
                    knownChanges: knownChanges.changes
                });
            }
        }
    }, {
        key: 'slideAffectsLeftOffset',
        value: function slideAffectsLeftOffset(slideIndex) {
            var _props5 = this.props,
                index = _props5.index,
                renderedIndices = _props5.renderedIndices,
                slideSize = _props5.slideSize;


            var indexOfSlideIndex = renderedIndices.indexOf(slideIndex);
            var indexOfIndex = renderedIndices.indexOf(index);

            return slideSize === 'height' && indexOfSlideIndex > -1 && indexOfIndex > -1 && indexOfSlideIndex <= indexOfIndex;
        }

        // gets the width and height (size) of a slide from the slidesData array

    }, {
        key: 'getSlideSize',
        value: function getSlideSize(index) {
            var slideData = this.state.slidesData[index];
            if (slideData) {
                return {
                    width: slideData.slideWidth || 0,
                    height: slideData.slideHeight || 0
                };
            }
            return { width: 0, height: 0 };
        }
    }, {
        key: 'getImageDataFromSlideData',
        value: function getImageDataFromSlideData(idx) {
            var slideData = this.state.slidesData[idx];

            if (slideData) {
                var cloneSlideData = _extends({}, slideData);
                if (cloneSlideData.slideAspectRatio > 0) {
                    delete cloneSlideData.index;
                    return cloneSlideData;
                }
            }
            return {};
        }
    }, {
        key: 'updateOverlayOpacity',
        value: function updateOverlayOpacity(_ref5) {
            var isNext = _ref5.isNext,
                reset = _ref5.reset,
                _ref5$clearAll = _ref5.clearAll,
                clearAll = _ref5$clearAll === undefined ? false : _ref5$clearAll;

            if (this.props.maxOverlayOpacity > 0) {
                if (clearAll) {
                    this.setElemsStyles([{ elem: this['slide-overlay-current'], prop: 'opacity', value: '' }, { elem: this['slide-overlay-prev'], prop: 'opacity', value: '' }, { elem: this['slide-overlay-next'], prop: 'opacity', value: '' }]);
                } else if (reset) {
                    this.setElemsStyles([{ elem: this['slide-overlay-current'], prop: 'opacity', value: 0 }, { elem: this['slide-overlay-prev'], prop: 'opacity', value: 1 }, { elem: this['slide-overlay-next'], prop: 'opacity', value: 1 }]);
                } else if (isNext) {
                    this.setElemsStyles([{ elem: this['slide-overlay-current'], prop: 'opacity', value: 1 }, { elem: this['slide-overlay-prev'], prop: 'opacity', value: 1 }, { elem: this['slide-overlay-next'], prop: 'opacity', value: 0 }]);
                } else {
                    this.setElemsStyles([{ elem: this['slide-overlay-current'], prop: 'opacity', value: 1 }, { elem: this['slide-overlay-prev'], prop: 'opacity', value: 0 }, { elem: this['slide-overlay-next'], prop: 'opacity', value: 1 }]);
                }
            }
        }
    }, {
        key: 'setElemsStyles',
        value: function setElemsStyles() {
            var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            // list item: {elem, prop, value}
            var filteredList = list.filter(function (item) {
                var elem = item.elem,
                    prop = item.prop;

                return elem && elem.style && prop;
            });
            requestAnimationFrame(function () {
                filteredList.map(function (item) {
                    var elem = item.elem,
                        prop = item.prop,
                        value = item.value;

                    elem.style[prop] = value;
                });
            });
        }
    }, {
        key: 'updateOverlayOpacityOnPan',
        value: function updateOverlayOpacityOnPan(deltaX) {
            var _props6 = this.props,
                index = _props6.index,
                images = _props6.images,
                overlayAccelerationMultiplier = _props6.overlayAccelerationMultiplier;
            var _state3 = this.state,
                slidesData = _state3.slidesData,
                width = _state3.width;

            var mult = 1 / overlayAccelerationMultiplier;
            var panPct = _CarouselUtil.utils.getPanPercent({
                carouselWidth: width,
                slidesData: slidesData,
                index: index,
                length: images.length,
                deltaX: deltaX
            }) * mult;
            var goingPct = _CarouselUtil.utils.normalize({ value: panPct });
            var comingPct = _CarouselUtil.utils.normalize({ value: 1 - panPct });
            if (deltaX < 0) {
                this.setElemsStyles([{ elem: this['slide-overlay-current'], prop: 'opacity', value: goingPct }, { elem: this['slide-overlay-next'], prop: 'opacity', value: comingPct }]);
            } else {
                this.setElemsStyles([{ elem: this['slide-overlay-current'], prop: 'opacity', value: goingPct }, { elem: this['slide-overlay-prev'], prop: 'opacity', value: comingPct }]);
            }
        }
    }, {
        key: 'getImageDismissY',
        value: function getImageDismissY(index, toTheTop) {
            var _state4 = this.state,
                slidesData = _state4.slidesData,
                width = _state4.width,
                height = _state4.height;

            var slideData = slidesData[index];
            if (slideData && slideData.imageAspectRatio > 0) {
                var imageHeight = _CarouselUtil.utils.getImageSize(width, height, slideData.imageAspectRatio, this.props.slideSize).height;
                var margin = Math.max(0, (height - imageHeight) / 2);
                return toTheTop ? -(imageHeight + margin) : imageHeight + margin;
            }
            return toTheTop ? -height : height;
        }
    }, {
        key: 'slide',
        value: function slide(_ref6) {
            var _this2 = this;

            var isNext = _ref6.isNext,
                callback = _ref6.callback,
                reset = _ref6.reset,
                interactionType = _ref6.interactionType;

            if (!this.state.sliding) {
                var x = this.state.xBeforePan;
                if (!reset) {
                    var _props7 = this.props,
                        index = _props7.index,
                        renderedIndices = _props7.renderedIndices,
                        images = _props7.images;
                    var _state5 = this.state,
                        slidesData = _state5.slidesData,
                        width = _state5.width;

                    var newIndex = _CarouselUtil.utils.getIndex(index, images.length, isNext);
                    x = this.getX({ slidesData: slidesData, width: width, index: newIndex, renderedIndices: renderedIndices });
                }

                this.updateOverlayOpacity({ isNext: isNext, reset: reset });

                this.setStateIfChanged({
                    knownChanges: {
                        x: x,
                        xBeforePan: x,
                        y: 0,
                        sliding: true,
                        panning: false,
                        panAxis: '',
                        bgOpacity: 1
                    }
                });

                clearTimeout(this.timeouts.sliding);
                this.timeouts.sliding = setTimeout(function () {
                    delete _this2.timeouts.sliding;
                    // remove inline styles for slide overlay opacity. classNamees should handle correct opacity.
                    _this2.updateOverlayOpacity({ clearAll: true });
                    if (reset) {
                        _this2.setStateIfChanged({ knownChanges: { sliding: false } });
                        _this2.props.onPanY(false);
                    } else if (typeof callback === 'function') {
                        callback(_this2.props.index, _this2.props.images.length, interactionType);
                    }
                }, _CarouselUtil.SETTINGS.SLIDE_TRANSITION_DURATION);
            }
        }
    }, {
        key: 'resetCurrentSlide',
        value: function resetCurrentSlide() {
            var interactionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click';

            this.slide({ isNext: null, callback: null, reset: true, interactionType: interactionType });
        }
    }, {
        key: 'getSlideMargin',
        value: function getSlideMargin(index) {
            return _CarouselUtil.utils.getSlideMargin(this.state.width, this.getSlideSize(index).width);
        }

        // ----------------------- GESTURE CODE (start) -----------------------

    }, {
        key: 'resetPanEndTimeout',
        value: function resetPanEndTimeout(justCancel) {
            var _this3 = this;

            this.lastPan = { deltaX: 0, deltaY: 0 };
            clearTimeout(this.timeouts.panEnd);
            if (!justCancel) {
                this.timeouts.panEnd = setTimeout(function () {
                    delete _this3.timeouts.panEnd;
                    _this3.onPanCancel({});
                }, _CarouselUtil.SETTINGS.PAN_END_TIMEOUT);
            }
        }
    }, {
        key: 'verticalPanEnd',
        value: function verticalPanEnd(deltaY) {
            var _this4 = this;

            var index = this.props.index;

            if (Math.abs(deltaY) > _CarouselUtil.SETTINGS.DISMISS_THRESHOLD) {
                this.setStateIfChanged({
                    knownChanges: {
                        y: this.getImageDismissY(index, deltaY < 0),
                        slidingToClose: true,
                        panning: false,
                        panAxis: '',
                        bgOpacity: 0
                    }
                });
                clearTimeout(this.timeouts.panningVertical);
                this.timeouts.panningVertical = setTimeout(function () {
                    delete _this4.timeouts.panningVertical;
                    _this4.props.closeModal(true);
                }, _CarouselUtil.SETTINGS.TRANSITION_DURATION);
            } else {
                this.resetCurrentSlide('touch');
            }
        }
    }, {
        key: 'horizontalPanEnd',
        value: function horizontalPanEnd(deltaX) {
            if (deltaX > _CarouselUtil.SETTINGS.NEXT_PREV_THRESHOLD) {
                this.handlePrev('touch');
            } else if (deltaX < -_CarouselUtil.SETTINGS.NEXT_PREV_THRESHOLD) {
                this.handleNext('touch');
            } else {
                this.resetCurrentSlide('touch');
            }
        }
        // ----------------------- GESTURE CODE (end) -----------------------

    }, {
        key: 'getCarouselStyle',
        value: function getCarouselStyle() {
            return this.props.hideBackground ? {} : { backgroundColor: this.props.overlayColor };
        }
    }, {
        key: 'getImageSrc',
        value: function getImageSrc(i, shouldRender) {
            var _props8 = this.props,
                images = _props8.images,
                renderedIndices = _props8.renderedIndices,
                renderedLowResCountPerSide = _props8.renderedLowResCountPerSide;

            if (shouldRender) {
                if (renderedLowResCountPerSide === 0) {
                    return images[i].src;
                }
                var highResIndices = renderedIndices.slice(renderedLowResCountPerSide, renderedIndices.length - renderedLowResCountPerSide);
                return highResIndices.indexOf(i) > -1 ? images[i].src : images[i].lowResSrc;
            }
            return images[i].lowResSrc;
        }
    }, {
        key: 'getPositionFlags',
        value: function getPositionFlags(shouldRender, i, index, prevIndex, nextIndex) {
            if (shouldRender) {
                var isCurrent = i === index;
                var isPrev = i === prevIndex;
                var isNext = i === nextIndex;
                var label = (0, _classnames2.default)('', {
                    'current': isCurrent,
                    'prev': isPrev,
                    'next': isNext
                });
                return { isCurrent: isCurrent, isPrev: isPrev, isNext: isNext, label: label };
            }
            return { isCurrent: false, isNext: false, isPrev: false, label: '' };
        }
    }, {
        key: 'getSlideStyle',
        value: function getSlideStyle(slideIndex) {
            var _props9 = this.props,
                index = _props9.index,
                images = _props9.images,
                renderedIndices = _props9.renderedIndices;
            var slidesData = this.state.slidesData;

            var sideCount = Math.floor(renderedIndices.length / 2);
            var order = renderedIndices.indexOf(slideIndex);
            if (order < 0) {
                order = slideIndex - index + sideCount;
                if (order < renderedIndices.length) {
                    order = images.length + order;
                }
            }

            return {
                order: order,
                width: slidesData[slideIndex].slideWidth + 'px',
                height: slidesData[slideIndex].slideHeight + 'px',
                marginRight: this.props.slideMargin + 'px'
            };
        }
    }, {
        key: 'gestureEnabled',
        value: function gestureEnabled() {
            return this.state.touchEnabled && this.props.renderedIndices.length > 1 && !this.props.touchProhibited;
        }
    }, {
        key: 'renderCarouselSlides',
        value: function renderCarouselSlides() {
            var _this5 = this;

            var _props10 = this.props,
                index = _props10.index,
                images = _props10.images,
                renderedIndices = _props10.renderedIndices,
                detailsHidden = _props10.detailsHidden,
                displayCaptions = _props10.displayCaptions,
                truncateCaptions = _props10.truncateCaptions,
                slideSize = _props10.slideSize,
                overlayColor = _props10.overlayColor,
                renderPlaceholder = _props10.renderPlaceholder,
                captionsAlignment = _props10.captionsAlignment,
                maxOverlayOpacity = _props10.maxOverlayOpacity,
                updateSlideDataOnImageLoad = _props10.updateSlideDataOnImageLoad,
                persistVideoIframe = _props10.persistVideoIframe,
                carouselType = _props10.carouselType,
                pinchZoom = _props10.pinchZoom,
                maxZoom = _props10.maxZoom;
            var _state6 = this.state,
                width = _state6.width,
                height = _state6.height,
                panning = _state6.panning,
                sliding = _state6.sliding;


            var imagesLength = images.length;
            var nextIndex = _CarouselUtil.utils.getNextIndex(index, imagesLength);
            var prevIndex = _CarouselUtil.utils.getPrevIndexForRender({ index: index, prevIndex: this.props.prevIndex, images: images });
            var carouselAspectRatio = _CarouselUtil.utils.getAspectRatio(width, height);
            var gestureEnabled = this.gestureEnabled();
            var maxVideoHeight = height;
            if (carouselType === _CarouselUtil.CAROUSEL_TYPE.FULLSCREEN) {
                maxVideoHeight = height - _CarouselUtil.SETTINGS.VIDEO_BAR_HEIGHT * 2;
            }

            return images.map(function (image, i) {
                var shouldRender = renderedIndices.indexOf(i) !== -1;

                if (shouldRender) {
                    var positionFlags = _this5.getPositionFlags(shouldRender, i, index, prevIndex, nextIndex);
                    var imageData = _this5.getImageDataFromSlideData(i);
                    var imageSrc = _this5.getImageSrc(i, shouldRender);
                    var slideStyle = _this5.getSlideStyle(i, imageData);

                    var overlayStyle = {
                        backgroundColor: maxOverlayOpacity > 0 ? _CarouselUtil.utils.getRGBString(_this5.overlayColorRGB, maxOverlayOpacity) : ''
                    };

                    return _react2.default.createElement(_CarouselSlide2.default, _extends({
                        index: i,
                        key: 'slide' + i,
                        setSlideRef: maxOverlayOpacity > 0 ? _this5.getSetSlideRef(positionFlags) : undefined // eslint-disable-line no-undefined
                        , imageSrc: imageSrc
                    }, positionFlags, imageData, {
                        carouselWidth: width,
                        carouselHeight: height,
                        carouselAspectRatio: carouselAspectRatio,
                        detailsHidden: detailsHidden,
                        displayCaptions: displayCaptions,
                        truncateCaptions: truncateCaptions,
                        imageLowResSrc: image.lowResSrc,
                        imageAltText: image.altText,
                        shouldRender: shouldRender,
                        slideSize: slideSize,
                        slideStyle: slideStyle,
                        overlayColor: overlayColor,
                        overlayStyle: overlayStyle,
                        imageLoadedCallback: _this5.onSlideImageLoaded,
                        renderPlaceholder: renderPlaceholder,
                        onVideoPlay: _this5.onVideoPlay,
                        captionsAlignment: captionsAlignment,
                        updateSlideDataOnImageLoad: updateSlideDataOnImageLoad,
                        updateChildScale: _this5.handleChildScale,
                        persistVideoIframe: persistVideoIframe,
                        maxVideoHeight: maxVideoHeight,
                        gestureEnabled: gestureEnabled,
                        panning: panning,
                        sliding: sliding,
                        onSlideClick: _this5.onSlideClick,
                        pinchZoom: pinchZoom,
                        maxZoom: maxZoom
                    }));
                }
                return null;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            // eslint-disable-line complexity
            var _props11 = this.props,
                index = _props11.index,
                panDirection = _props11.panDirection,
                renderedIndices = _props11.renderedIndices,
                renderButtons = _props11.renderButtons,
                showArrows = _props11.showArrows,
                hideBackground = _props11.hideBackground;
            var _state7 = this.state,
                width = _state7.width,
                height = _state7.height,
                x = _state7.x,
                y = _state7.y,
                sliding = _state7.sliding,
                panning = _state7.panning,
                rotating = _state7.rotating,
                slidingToClose = _state7.slidingToClose,
                slidesData = _state7.slidesData,
                bgOpacity = _state7.bgOpacity,
                panAxis = _state7.panAxis,
                canPan = _state7.canPan;

            var useGestureViewbox = this.gestureEnabled();
            var isVideo = slidesData[index].mediaType === _CarouselUtil.MEDIA_TYPE.VIDEO; // isVideo;
            var hideButtonsBecausePanY = slidingToClose || panning && panAxis === 'vert' && canPan;
            var transX = Math.abs(x);
            if (x > 0) {
                transX = 0 - x;
            }
            var listboxStyle = {
                transform: 'translate(' + transX + 'px, ' + y + 'px)'
            };
            var carouselClasses = (0, _classnames2.default)('carousel', {
                'carousel--animating': sliding || slidingToClose,
                'carousel--panning': panning,
                'carousel--rotating': rotating
                // 'carousel--closing-from-pan': closingFromPan
            });
            var carouselStyles = {
                backgroundColor: !hideBackground ? _CarouselUtil.utils.getRGBString(this.overlayColorRGB, bgOpacity) : ''
            };

            var hammerOptions = {
                recognizers: {
                    pan: { threshold: 1 }
                }
            };
            if (panDirection === 'horizontal') {
                hammerOptions.touchAction = 'pan-y';
            }

            return _react2.default.createElement(
                'div',
                {
                    className: carouselClasses,
                    ref: this.setCarouselRef,
                    style: carouselStyles
                },
                useGestureViewbox && _react2.default.createElement(
                    _rcHammerjs2.default,
                    {
                        onPan: this.onPan,
                        onPanStart: this.onPanStart,
                        onPanEnd: this.onPanEnd,
                        onPanCancel: this.onPanCancel,
                        direction: 'DIRECTION_ALL',
                        options: hammerOptions
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'carousel__listbox-gesture-wrapper',
                            style: {
                                width: '100%', height: '100%'
                            }
                        },
                        _react2.default.createElement(
                            'ol',
                            {
                                className: 'carousel__listbox',
                                ref: this.setListboxRef,
                                style: listboxStyle
                            },
                            width > 0 && height > 0 && this.renderCarouselSlides()
                        )
                    )
                ),
                !useGestureViewbox && _react2.default.createElement(
                    'ol',
                    {
                        className: 'carousel__listbox',
                        ref: this.setListboxRef,
                        style: listboxStyle
                    },
                    width > 0 && height > 0 && this.renderCarouselSlides()
                ),
                !hideButtonsBecausePanY && showArrows && renderedIndices.length > 1 && renderButtons && renderButtons({ handlePrev: this.handlePrev, handleNext: this.handleNext, reduceButtonHitTarget: isVideo })
            );
        }
    }]);

    return Carousel;
}(_react.Component);

Carousel.propTypes = {
    /** Updates image index to next image. Takes current index and images length as params. */
    onNextImage: _propTypes2.default.func,
    /** Updates image index to previous image. Takes current index and images length as params. */
    onPrevImage: _propTypes2.default.func,
    /** Closes modal container. Used to execute close from full screen modal click and pan-y gesture. */
    closeModal: _propTypes2.default.func,
    /** Action to take when an image / slide is clicked. */
    onImageClick: _propTypes2.default.func,
    /** Action to take when a slide is panned-y. In fulls creen modal used to hide image count, close x, and comments. */
    onPanY: _propTypes2.default.func,
    /** Callback to container when image is loaded. Used to store map of image sizes (from aspect ratio). Takes index and image aspect ratio as params. */
    onCurrentImageLoaded: _propTypes2.default.func,
    /** Action to take when a YouTube video starts playing. */
    onVideoPlay: _propTypes2.default.func,
    /** Image data objects. Contains properties: src, lowResSrc, and altText. */
    images: _propTypes2.default.instanceOf(Array),
    /** Current image index. */
    index: _propTypes2.default.number.isRequired,
    /** Indices from images array to render. */
    renderIndices: _propTypes2.default.instanceOf(Array),
    /** Indicates if captions, image count and close 'x' hidden. */
    detailsHidden: _propTypes2.default.bool,
    /** Indicates if captions should be shown. */
    displayCaptions: _propTypes2.default.bool,
    /** Indicates if captions should be truncated to one line. */
    truncateCaptions: _propTypes2.default.bool,
    /** Type of carousel. 'inline' - appears inline, 'fullscreen' - appears as fullscreen modal. 'custom' - not default inline or default modal. */
    carouselType: _propTypes2.default.oneOf([_CarouselUtil.CAROUSEL_TYPE.INLINE, _CarouselUtil.CAROUSEL_TYPE.FULLSCREEN, _CarouselUtil.CAROUSEL_TYPE.CUSTOM]),
    /** Indicates whether carousel pans horizantally or horizontally and vertically. Possible vales are: 'horizontal' or 'all'.*/
    panDirection: _propTypes2.default.string,
    /** Number of pixels in spacing between slides.*/
    slideMargin: _propTypes2.default.number,
    /** How images size to slide and how slides flow within carousel. 'height' - images size to set height and flow horizantally, 'contain' - images size to be contained in full height/width slide and flow horizontally, 'cover' - images size to cover full height/width slide and flow horizontally. */
    slideSize: _propTypes2.default.oneOf(['height', 'cover', 'contain']),
    /** Overlay color for non-current slide.*/
    overlayColor: _propTypes2.default.string,
    /** Maximum opacity for the non-current slide overlay.*/
    maxOverlayOpacity: _propTypes2.default.number,
    /** Multiplier which controls the rate at which the overlay opacity changes. 1 means the opacity will go from maximum to 0 when slide to be current slide is in current slide x-position. 0.5 means the opacity will go from maximum to 0 when slide to be current slide is half-way to the current slide x-position.*/
    overlayAccelerationMultiplier: _propTypes2.default.number,
    /** How many images at the front and tail of the renderedIndices should be rendered as low res.*/
    renderedLowResCountPerSide: _propTypes2.default.number,
    /** renders previous and next buttons. Takes {handlePrev, handleNext} as argument */
    renderButtons: _propTypes2.default.func,
    /** renders placeholder card content for card without image src */
    renderPlaceholder: _propTypes2.default.func,
    /** does not set a color style for the carousel background */
    hideBackground: _propTypes2.default.bool,
    /** id for debugging */
    id: _propTypes2.default.string,
    /** width to set the carousel*/
    width: _propTypes2.default.number,
    /** height to set the carousel*/
    height: _propTypes2.default.number,
    /** caption alignment */
    captionsAlignment: _propTypes2.default.oneOf(['slideBottom', 'imageBottom']),
    /** do we handle the image load callback to update the slide size */
    updateSlideDataOnImageLoad: _propTypes2.default.bool,
    /** do we persist the iframe DOM elements for a video slide when it is not the current slide */
    persistVideoIframe: _propTypes2.default.bool,
    /** Indicates if, on devices that support orientation change event, carousel handles orientation change event.*/
    handlesOrientationChange: _propTypes2.default.bool,
    /** Indicates if carousel handles window resize event.*/
    handlesWindowResize: _propTypes2.default.bool,
    /** Indicates if carousel handles keyboard events, i.e. do arrow keys navigate images */
    handlesKeyboardNavigation: _propTypes2.default.bool,
    /** Enables pinch to zoom */
    pinchZoom: _propTypes2.default.bool
};
Carousel.defaultProps = {
    onNextImage: function onNextImage() {},
    onPrevImage: function onPrevImage() {},
    closeModal: function closeModal() {},
    onImageClick: function onImageClick() {},
    onVideoPlay: function onVideoPlay() {},
    onPanY: function onPanY() {},
    onCurrentImageLoaded: function onCurrentImageLoaded() {},
    images: [],
    renderIndices: [],
    index: 0,
    detailsHidden: false,
    displayCaptions: false,
    truncateCaptions: false,
    type: 'inline',
    panDirection: 'horizontal',
    slideMargin: 0,
    slideSize: 'height',
    overlayColor: '#000',
    maxOverlayOpacity: 0.6,
    overlayAccelerationMultiplier: 0.75,
    renderedLowResCountPerSide: 0,
    renderButtons: _CarouselButtons2.default,
    hideBackground: false,
    id: '',
    captionsAlignment: 'slideBottom',
    updateSlideDataOnImageLoad: false,
    persistVideoIframe: false,
    handlesOrientationChange: false,
    handlesWindowResize: true,
    handlesKeyboardNavigation: false,
    pinchZoom: false
};

var _initialiseProps = function _initialiseProps() {
    var _this6 = this;

    this.getWidth = function () {
        var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (width) {
            return width;
        }
        return _this6.carousel ? _this6.carousel.clientWidth || _this6.carousel.getBoundingClientRect().width : _this6.state.width;
    };

    this.getHeight = function () {
        var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (height) {
            return height;
        }
        return _this6.carousel ? _this6.carousel.clientHeight || _this6.carousel.getBoundingClientRect().height : _this6.state.height;
    };

    this.onOrientationChange = function () {
        if (_this6.props.handlesOrientationChange) {
            _this6.setStateIfChanged({
                possibleChanges: [{
                    key: 'rotating',
                    value: true,
                    oldValue: _this6.state.rotating
                }]
            });

            clearTimeout(_this6.timeouts.rotating);
            _this6.timeouts.rotating = setTimeout(function () {
                delete _this6.timeouts.rotating;
                _this6.setStateIfChanged({
                    knownChanges: { rotating: false }
                });
            }, _CarouselUtil.SETTINGS.ROTATION_TRANSITION_DURATION);
        }
    };

    this.onKeyDown = function (e) {
        // eslint-disable-line complexity
        if (_this6.keyUp && !_this6.sliding) {
            _this6.keyUp = false;
            if (_this6.ignoreKeyDown(e)) {
                return;
            } else if (e.keyCode === 37) {
                // left arrow key
                _this6.slide({
                    isNext: false,
                    callback: _this6.props.onPrevImage,
                    interactionType: 'keyboard'
                });
            } else if (e.keyCode === 39) {
                // right arrow key
                _this6.slide({
                    isNext: true,
                    callback: _this6.props.onNextImage,
                    interactionType: 'keyboard'
                });
            } else if (e.keyCode === 27 && _this6.props.carouselType === _CarouselUtil.CAROUSEL_TYPE.FULLSCREEN) {
                // esc key
                _this6.props.closeModal();
            }
        }
    };

    this.onKeyUp = function () {
        _this6.keyUp = true;
    };

    this.onResize = function () {
        _this6.onSizeChange(_this6.getWidth(), _this6.getHeight());
    };

    this.onSlideImageLoaded = function (_ref7) {
        var slideData = _ref7.slideData,
            dataHasChanged = _ref7.dataHasChanged,
            isCurrentSlide = _ref7.isCurrentSlide;
        var _props12 = _this6.props,
            updateSlideDataOnImageLoad = _props12.updateSlideDataOnImageLoad,
            onCurrentImageLoaded = _props12.onCurrentImageLoaded,
            renderedIndices = _props12.renderedIndices;


        if (updateSlideDataOnImageLoad && dataHasChanged && slideData) {
            var knownChanges = {};
            var slidesData = _this6.state.slidesData;
            var index = slideData.index,
                slideAspectRatio = slideData.slideAspectRatio,
                slideWidth = slideData.slideWidth,
                slideHeight = slideData.slideHeight;


            if (typeof index !== 'undefined' && slideWidth > 0 && slideHeight > 0 && slideAspectRatio > 0) {
                slidesData = _this6.state.slidesData.slice();
                slidesData.splice(index, 1, _extends({}, slideData));
                knownChanges.slidesData = slidesData;
            }

            if (_this6.slideAffectsLeftOffset(index)) {
                var x = _this6.getX({
                    slidesData: slidesData,
                    width: _this6.state.width,
                    index: _this6.props.index,
                    renderedIndices: renderedIndices
                });
                knownChanges.x = x;
                knownChanges.xBeforePan = x;
            }

            _this6.setStateIfChanged({
                knownChanges: knownChanges
            });
        }

        if (isCurrentSlide) {
            onCurrentImageLoaded();
        }
    };

    this.handleNext = function () {
        var interactionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click';

        _this6.slide({ isNext: true, callback: _this6.props.onNextImage, interactionType: interactionType });
    };

    this.handlePrev = function () {
        var interactionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click';

        _this6.slide({ isNext: false, callback: _this6.props.onPrevImage, interactionType: interactionType });
    };

    this.onVideoPlay = function (e) {
        _this6.props.onVideoPlay(e);
    };

    this.onPanStart = function (e) {
        var direction = e.direction,
            deltaX = e.deltaX,
            deltaY = e.deltaY;
        var _state8 = _this6.state,
            panning = _state8.panning,
            x = _state8.x,
            y = _state8.y,
            sliding = _state8.sliding,
            canPan = _state8.canPan;

        var horzDirections = [2, 4];
        var vertDirections = [8, 16];

        if (!sliding && !panning && canPan) {
            if (horzDirections.indexOf(direction) > -1 && Math.abs(deltaY) < 60) {
                var xBeforePan = x;
                _this6.resetPanEndTimeout();
                _this6.setStateIfChanged({
                    knownChanges: {
                        panning: true,
                        panAxis: 'horz',
                        xBeforePan: xBeforePan,
                        x: xBeforePan - deltaX
                    }
                });
            } else if (_this6.props.panDirection === 'all' && vertDirections.indexOf(direction) > -1) {
                var yBeforePan = y;
                _this6.resetPanEndTimeout();
                _this6.props.onPanY(true);
                _this6.setStateIfChanged({
                    knownChanges: {
                        panning: true,
                        panAxis: 'vert',
                        yBeforePan: yBeforePan,
                        y: deltaY
                    }
                });
            }
        }
    };

    this.onPan = function (e) {
        // eslint-disable-line complexity
        var additionalEvent = e.additionalEvent,
            deltaX = e.deltaX,
            deltaY = e.deltaY;
        var _state9 = _this6.state,
            panAxis = _state9.panAxis,
            xBeforePan = _state9.xBeforePan,
            sliding = _state9.sliding,
            height = _state9.height,
            canPan = _state9.canPan;

        if (!sliding && canPan) {
            _this6.resetPanEndTimeout();
            if (panAxis === 'horz' && (additionalEvent === 'panright' || additionalEvent === 'panleft')) {
                // horizontal pan
                _this6.lastPan.deltaX = deltaX;
                _this6.updateOverlayOpacityOnPan(deltaX);
                _this6.setStateIfChanged({
                    knownChanges: {
                        panning: true,
                        panAxis: 'horz',
                        x: xBeforePan - deltaX
                    }
                });
            } else if (panAxis === 'vert' && (additionalEvent === 'pandown' || additionalEvent === 'panup')) {
                // vertical pan
                _this6.lastPan.deltaY = deltaY;
                _this6.setStateIfChanged({
                    knownChanges: {
                        panning: true,
                        panAxis: 'vert',
                        y: deltaY,
                        bgOpacity: _CarouselUtil.utils.getBgOpacityPctOnPanY(height, e.deltaY)
                    }
                });
            }
        }
    };

    this.onPanEnd = function (e) {
        _this6.panStopped(e);
    };

    this.onPanCancel = function () {
        _this6.panStopped(_this6.lastPan);
    };

    this.panStopped = function (data) {
        var _state10 = _this6.state,
            sliding = _state10.sliding,
            panning = _state10.panning,
            panAxis = _state10.panAxis,
            canPan = _state10.canPan;

        if (!sliding && panning && canPan) {
            var deltaX = data.deltaX,
                deltaY = data.deltaY;
            // this.panning = false;

            _this6.resetPanEndTimeout(true);
            if (panAxis === 'horz') {
                _this6.horizontalPanEnd(deltaX);
            } else if (panAxis === 'vert') {
                _this6.verticalPanEnd(deltaY);
            } else {
                _this6.setStateIfChanged({
                    knownChanges: {
                        panning: false,
                        panAxis: ''
                    }
                });
            }
        }
    };

    this.setListboxRef = function (ref) {
        _this6.listbox = ref;
    };

    this.setCarouselRef = function (ref) {
        _this6.carousel = ref;
    };

    this.getSetSlideRef = function (_ref8) {
        var label = _ref8.label;
        return function (ref) {
            if (label) {
                if (ref) {
                    _this6['slide-overlay-' + label] = ref.querySelector('.carousel-slide__overlay');
                } else {
                    _this6['slide-overlay-' + label] = null;
                }
            }
        };
    };

    this.onSlideClick = function (_ref9) {
        var index = _ref9.index,
            isCurrent = _ref9.isCurrent;

        var slideData = _this6.state.slidesData[index];
        if (slideData) {
            var _props13 = _this6.props,
                onImageClick = _props13.onImageClick,
                renderedIndices = _props13.renderedIndices;

            if (isCurrent) {
                onImageClick();
            } else if (_CarouselUtil.utils.isPrev({ index: index, renderedIndices: renderedIndices })) {
                _this6.handlePrev();
            } else if (_CarouselUtil.utils.isNext({ index: index, renderedIndices: renderedIndices })) {
                _this6.handleNext();
            }
        }
    };

    this.handleChildScale = function (scale) {
        if (scale === 1) {
            _this6.setState({
                canPan: true
            });
        } else {
            _this6.setState({
                canPan: false
            });
        }
    };
};

exports.default = Carousel;
//# sourceMappingURL=Carousel.js.map

/***/ }),

/***/ "zq7B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__("RH2O");

var _redux = __webpack_require__("2KeS");

var _reactToaster = __webpack_require__("jAkQ");

var _constants = __webpack_require__("hXMO");

var _TripBoard = __webpack_require__("Dtfn");

var _TripBoard2 = _interopRequireDefault(_TripBoard);

__webpack_require__("u8nl");

var _index = __webpack_require__("xGNz");

var _HeartIcon = __webpack_require__("rSCM");

var _HeartIcon2 = _interopRequireDefault(_HeartIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TripBoardButton = function (_Component) {
    _inherits(TripBoardButton, _Component);

    function TripBoardButton(props) {
        _classCallCheck(this, TripBoardButton);

        var _this = _possibleConstructorReturn(this, (TripBoardButton.__proto__ || Object.getPrototypeOf(TripBoardButton)).call(this, props));

        _this.toggle = function () {
            if (_this.props.isHearted) {
                _TripBoard2.default.remove(_this.props.removeFromBoard, _this.props.listingId, _this.props.tripboards.boards);
            } else {
                _TripBoard2.default.open(_this);
            }
        };

        var abacus = props.abacus;

        _this.refButton = null;
        _this.stabHit = null;

        // heart loading animations test
        _this.loadingAnimTestValue = abacus[_constants.LOADING_ANIMATION] ? abacus[_constants.LOADING_ANIMATION].value : 0;
        _this.isAbacusLoadingTestOn = _this.loadingAnimTestValue > 0;
        return _this;
    }

    _createClass(TripBoardButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var props = this.props;
            var siteName = props.siteName,
                createToast = props.createToast,
                getTripboards = props.getTripboards;


            this.setUpTripBoard(siteName, createToast, getTripboards);
            if ("object" !== 'undefined' && Object.keys(this.props.translations).length === 0 && window.tripboardConfig && window.tripboardConfig.translations) {
                this.props.setTripboardTranslations({ translations: window.tripboardConfig.translations });
            }
            if ("object" !== 'undefined' && typeof window.__ABACUS__ !== 'undefined') {
                _TripBoard2.default.testExposure.loadingAnimation.trigger();
            }

            if (this.props.useNativeEventListener && this.refButton) {
                this.refButton.addEventListener('click', this.toggle);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.useNativeEventListener && this.refButton) {
                this.refButton.removeEventListener('click', this.toggle);
            }
        }
    }, {
        key: 'setUpTripBoard',
        value: function setUpTripBoard(siteName, createToast, getTripboards) {
            _TripBoard2.default.setSitename(siteName);
            _TripBoard2.default.setCreateToast(createToast);
            _TripBoard2.default.setGetTripboards(getTripboards);
            _TripBoard2.default.setVisibilityListener();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isDisabled = _props.isDisabled,
                position = _props.position,
                type = _props.type,
                tripboards = _props.tripboards,
                translations = _props.translations,
                loading = _props.loading;

            var boards = tripboards && tripboards.boards || [];
            var translationKey = !loading && boards.length > 0 ? 'tripboards.modal.add.to' : 'tripboards.modal.create.new.list.copy';
            var ariaLabel = translations[translationKey];

            var buttonClasses = (0, _classnames2.default)({
                'react-trip-board-button': true,
                'react-trip-board-button__position-bottom': position === 'bottom',
                'react-trip-board-button__position-right': position === 'right',
                'react-trip-board-button__outline': type === 'outline'
            });

            var iconClass = (0, _classnames2.default)('react-trip-board-button__heart-core__heart-icon', {
                unhearted: !this.props.isHearted,
                isDisabled: isDisabled,
                'loading-anim-1': loading && this.loadingAnimTestValue === 1,
                'loading-anim-2': loading && this.loadingAnimTestValue === 2
            });

            var iconClassBg = (0, _classnames2.default)('react-trip-board-button__heart-core__heart-icon', {
                unhearted: !this.props.isHearted,
                'loading-anim-bg-1': loading && this.loadingAnimTestValue === 1,
                'loading-anim-bg-2': loading && this.loadingAnimTestValue === 2
            });

            return _react2.default.createElement(
                'button',
                {
                    'aria-label': ariaLabel,
                    className: buttonClasses,
                    disabled: isDisabled,
                    onClick: this.toggle,
                    tabIndex: '-1',
                    ref: function ref(c) {
                        return _this2.refButton = c;
                    }
                },
                _react2.default.createElement(_HeartIcon2.default, {
                    iconClass: iconClass,
                    iconClassBg: iconClassBg,
                    isAbacusLoadingTestOn: this.isAbacusLoadingTestOn
                })
            );
        }
    }]);

    return TripBoardButton;
}(_react.Component);

TripBoardButton.propTypes = {
    adultsCount: _propTypes2.default.number,
    childrenCount: _propTypes2.default.number,
    endDate: _propTypes2.default.string,
    isDisabled: _propTypes2.default.bool,
    isHearted: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    listingId: _propTypes2.default.string.isRequired,
    tripBoards: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    getTripboards: _propTypes2.default.func,
    onHeart: _propTypes2.default.func,
    onUnheart: _propTypes2.default.func,
    petIncluded: _propTypes2.default.bool,
    position: _propTypes2.default.oneOf(['bottom', 'left', 'right', 'right-auto']),
    siteName: _propTypes2.default.string,
    startDate: _propTypes2.default.string,
    thumbnailUrl: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['default', 'outline']),
    rating: _propTypes2.default.number,
    headline: _propTypes2.default.string,
    reviewCount: _propTypes2.default.number,
    abacus: _propTypes2.default.object, // eslint-disable-line
    useNativeEventListener: _propTypes2.default.bool
};
TripBoardButton.defaultProps = {
    adultsCount: null,
    childrenCount: null,
    isDisabled: false,
    isHearted: false,
    isLoading: true,
    onHeart: function onHeart() {},
    onUnheart: function onUnheart() {},
    tripBoards: { boards: [] },
    getTripboards: function getTripboards() {},
    petIncluded: null,
    position: 'right',
    siteName: null,
    thumbnailUrl: null,
    type: 'default',
    rating: 0,
    headline: '',
    reviewCount: 0,
    abacus: {},
    useNativeEventListener: false
};


var mapStateToProps = function mapStateToProps(state, props) {
    var translations = state.tripboardButton.translations;

    var boards = props.tripboards && props.tripboards.boards || [];
    var isHearted = false;
    for (var index = 0; index < boards.length; index++) {
        var tripboard = boards[index];
        var listingRefs = tripboard.listingRefs || [];
        if (listingRefs.includes(props.listingId)) {
            isHearted = true;
            break;
        }
    }

    return {
        isHearted: isHearted,
        translations: translations
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        createToast: _reactToaster.toasterActions.createToast,
        setTripboardTranslations: _index.setTripboardTranslations
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TripBoardButton);
//# sourceMappingURL=TripBoardButton.js.map

/***/ }),

/***/ "zwoO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "zyKz":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ })

},["zW/i"]);


// WEBPACK FOOTER //
// bundle.55e240dcf5b38dbe983c.js